
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var parcelRequire = $parcel$global["parcelRequire8565"];
var parcelRegister = parcelRequire.register;
parcelRegister("11q0R", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1bebd8346ff9255f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AppRoutes", () => $1bebd8346ff9255f$export$37d3279522fbf5e2);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $57CDS = parcelRequire("57CDS");
var $5YTEB = parcelRequire("5YTEB");
var $5YTEB = parcelRequire("5YTEB");

var $7WKzO = parcelRequire("7WKzO");

var $bteot = parcelRequire("bteot");

var $5Fl8O = parcelRequire("5Fl8O");

var $lavfF = parcelRequire("lavfF");

var $gga7I = parcelRequire("gga7I");

var $ekG0d = parcelRequire("ekG0d");

var $1M3WI = parcelRequire("1M3WI");

var $6KwHv = parcelRequire("6KwHv");

var $8yT7q = parcelRequire("8yT7q");

var $PLN39 = parcelRequire("PLN39");

var $7SDUa = parcelRequire("7SDUa");

var $lU03w = parcelRequire("lU03w");

var $4vrHF = parcelRequire("4vrHF");

var $37RpH = parcelRequire("37RpH");

var $eYBPp = parcelRequire("eYBPp");

var $eTQRA = parcelRequire("eTQRA");

var $4In7L = parcelRequire("4In7L");

var $8iH6y = parcelRequire("8iH6y");

var $6xMPx = parcelRequire("6xMPx");

var $cigwJ = parcelRequire("cigwJ");

var $fzMi1 = parcelRequire("fzMi1");

var $yaNWN = parcelRequire("yaNWN");

var $29fm1 = parcelRequire("29fm1");

var $5BnXn = parcelRequire("5BnXn");

var $29pjJ = parcelRequire("29pjJ");

var $iYUUD = parcelRequire("iYUUD");

var $sdOpr = parcelRequire("sdOpr");

const $1bebd8346ff9255f$var$LazyAccountScopedRoutes = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("i4RsZ")));

const $1bebd8346ff9255f$var$LazyExperimentsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>Promise.resolve((parcelRequire("yaNWN"))));

const $1bebd8346ff9255f$var$LazyInviteCallbackPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("hDwdE")));

const $1bebd8346ff9255f$var$LazyCliAuthCallbackPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("gBucm")));

const $1bebd8346ff9255f$var$LazyAccountScreen = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("8dshk")));

const $1bebd8346ff9255f$var$LazyHomePage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("43HUV")));
function $1bebd8346ff9255f$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $iYUUD.AgentProvider), {
        children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $29pjJ.AppEventsProvider), {
            children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $1M3WI.AuthProvider), {
                children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $bteot.LinkProvider), {
                    value: (0, $6xMPx.RouterLinkAdapter),
                    children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5Fl8O.ThemeProvider), {
                        children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $4In7L.default), {
                            children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $6KwHv.AppQueryClientProvider), {
                                children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $gga7I.AccountsProvider), {
                                    children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $yaNWN.ExperimentsProvider), {
                                        children: /*#__PURE__*/ (0, $2T9xh.jsx)($1bebd8346ff9255f$var$RootRouter, {})
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}
function $1bebd8346ff9255f$var$RootRouter() {
    const { user: user, isLoading: isLoading } = (0, $1M3WI.useAuth)();
    const agent = (0, $iYUUD.useAgent)();
    (0, $aOzEm.useEffect)(()=>{
        if (user && agent) agent.setUser({
            id: user.sub,
            email: user.email
        });
    }, [
        user,
        agent
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $sdOpr.LazyLoadingFallback), {});
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $7WKzO.ErrorBoundary), {
        FallbackComponent: (0, $cigwJ.ErrorBoundaryFallback),
        children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $57CDS.BrowserRouter), {
            children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $lU03w.CommandPaletteProvider), {
                children: /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $37RpH.default), {
                    children: [
                        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $37RpH.GTagUserTracker), {}),
                        /*#__PURE__*/ (0, $2T9xh.jsx)($1bebd8346ff9255f$export$37d3279522fbf5e2, {})
                    ]
                })
            })
        })
    });
}
function $1bebd8346ff9255f$export$37d3279522fbf5e2() {
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $5YTEB.Routes), {
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                path: "/",
                element: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Navigate), {
                    to: "/-/accounts",
                    replace: true
                })
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                path: "/callback/cli/auth",
                element: /*#__PURE__*/ (0, $2T9xh.jsx)($1bebd8346ff9255f$var$LazyCliAuthCallbackPage, {})
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                path: "/callback/invite",
                element: /*#__PURE__*/ (0, $2T9xh.jsx)($1bebd8346ff9255f$var$LazyInviteCallbackPage, {})
            }),
            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $5YTEB.Route), {
                path: "/-/",
                children: [
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                        path: "experiments",
                        element: /*#__PURE__*/ (0, $2T9xh.jsx)($1bebd8346ff9255f$var$LazyExperimentsPage, {})
                    }),
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                        path: "login",
                        element: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $eTQRA.default), {})
                    }),
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                        path: "callback/auth",
                        element: /*#__PURE__*/ (0, $2T9xh.jsx)($1bebd8346ff9255f$var$AuthCallback, {})
                    }),
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                        path: "accounts/*",
                        element: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $29fm1.default), {})
                    }),
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                        path: "auth-error",
                        element: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $fzMi1.default), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $5YTEB.Route), {
                path: ":accountName",
                element: /*#__PURE__*/ (0, $2T9xh.jsx)($1bebd8346ff9255f$var$LazyAccountScopedRoutes, {}),
                children: [
                    /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $5YTEB.Route), {
                        element: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5BnXn.default), {}),
                        children: [
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                                index: true,
                                element: /*#__PURE__*/ (0, $2T9xh.jsx)($1bebd8346ff9255f$var$LazyHomePage, {})
                            }),
                            (0, $lavfF.route),
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                                path: "account",
                                element: /*#__PURE__*/ (0, $2T9xh.jsx)($1bebd8346ff9255f$var$LazyAccountScreen, {})
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                                path: "connections",
                                children: (0, $ekG0d.routes)
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                                path: "streams",
                                children: (0, $7SDUa.routes)
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                                path: "pipelines",
                                children: (0, $8yT7q.routes)
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                                path: "secrets",
                                children: (0, $PLN39.routes)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                        path: "pipelines",
                        children: (0, $8yT7q.flinkUiRoute)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, $2T9xh.jsx)($1bebd8346ff9255f$var$NotFound, {})
            })
        ]
    });
}
function $1bebd8346ff9255f$var$AuthCallback() {
    const { isLoading: isLoading, error: error } = (0, $1M3WI.useAuth)();
    const navigate = (0, $5YTEB.useNavigate)();
    (0, $aOzEm.useEffect)(()=>{
        if (!isLoading && error) {
            const auth0ErrorParams = new URLSearchParams(window.location.search);
            navigate(`/-/auth-error/?${auth0ErrorParams.toString()}`, {
                replace: true
            });
        }
    }, [
        isLoading,
        error
    ]);
    return null;
}
function $1bebd8346ff9255f$var$NotFound() {
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $2T9xh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8iH6y.default), {}),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $4vrHF.default), {
                title: "404",
                message: "You look lost. Let's get you back home.",
                actions: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $eYBPp.default), {})
            })
        ]
    });
}

});
parcelRegister("57CDS", function(module, exports) {

$parcel$export(module.exports, "createSearchParams", () => $3bab94bb18dee09c$export$a2e4e2dcc7b1f22f);
$parcel$export(module.exports, "BrowserRouter", () => $3bab94bb18dee09c$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $3bab94bb18dee09c$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "NavLink", () => $3bab94bb18dee09c$export$b0d92dbee9b5b60d);
$parcel$export(module.exports, "useSearchParams", () => $3bab94bb18dee09c$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("5YTEB")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("5YTEB")).useNavigate);
/**
 * React Router DOM v6.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aOzEm = parcelRequire("aOzEm");

var $bs9Us = parcelRequire("bs9Us");
var $5YTEB = parcelRequire("5YTEB");

var $bs9Us = parcelRequire("bs9Us");
function $3bab94bb18dee09c$var$_extends() {
    $3bab94bb18dee09c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3bab94bb18dee09c$var$_extends.apply(this, arguments);
}
function $3bab94bb18dee09c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $3bab94bb18dee09c$var$defaultMethod = "get";
const $3bab94bb18dee09c$var$defaultEncType = "application/x-www-form-urlencoded";
function $3bab94bb18dee09c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $3bab94bb18dee09c$var$isButtonElement(object) {
    return $3bab94bb18dee09c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $3bab94bb18dee09c$var$isFormElement(object) {
    return $3bab94bb18dee09c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $3bab94bb18dee09c$var$isInputElement(object) {
    return $3bab94bb18dee09c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $3bab94bb18dee09c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $3bab94bb18dee09c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$3bab94bb18dee09c$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $3bab94bb18dee09c$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $3bab94bb18dee09c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $3bab94bb18dee09c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $3bab94bb18dee09c$var$_formDataSupportsSubmitter = null;
function $3bab94bb18dee09c$var$isFormDataSubmitterSupported() {
    if ($3bab94bb18dee09c$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $3bab94bb18dee09c$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $3bab94bb18dee09c$var$_formDataSupportsSubmitter = true;
    }
    return $3bab94bb18dee09c$var$_formDataSupportsSubmitter;
}
const $3bab94bb18dee09c$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $3bab94bb18dee09c$var$getFormEncType(encType) {
    if (encType != null && !$3bab94bb18dee09c$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $3bab94bb18dee09c$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($3bab94bb18dee09c$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $bs9Us.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $3bab94bb18dee09c$var$defaultMethod;
        encType = $3bab94bb18dee09c$var$getFormEncType(target.getAttribute("enctype")) || $3bab94bb18dee09c$var$defaultEncType;
        formData = new FormData(target);
    } else if ($3bab94bb18dee09c$var$isButtonElement(target) || $3bab94bb18dee09c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $bs9Us.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $3bab94bb18dee09c$var$defaultMethod;
        encType = $3bab94bb18dee09c$var$getFormEncType(target.getAttribute("formenctype")) || $3bab94bb18dee09c$var$getFormEncType(form.getAttribute("enctype")) || $3bab94bb18dee09c$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$3bab94bb18dee09c$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($3bab94bb18dee09c$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $3bab94bb18dee09c$var$defaultMethod;
        action = null;
        encType = $3bab94bb18dee09c$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $3bab94bb18dee09c$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $3bab94bb18dee09c$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $3bab94bb18dee09c$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $3bab94bb18dee09c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $bs9Us.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $3bab94bb18dee09c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bs9Us.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $3bab94bb18dee09c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5YTEB.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $3bab94bb18dee09c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $bs9Us.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $3bab94bb18dee09c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bs9Us.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $3bab94bb18dee09c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5YTEB.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $3bab94bb18dee09c$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $3bab94bb18dee09c$var$_extends({}, state, {
        errors: $3bab94bb18dee09c$var$deserializeErrors(state.errors)
    });
    return state;
}
function $3bab94bb18dee09c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $bs9Us.ErrorResponse)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $3bab94bb18dee09c$var$START_TRANSITION = "startTransition";
const $3bab94bb18dee09c$var$startTransitionImpl = $aOzEm[$3bab94bb18dee09c$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $3bab94bb18dee09c$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $aOzEm.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bs9Us.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aOzEm.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOzEm.useCallback((newState)=>{
        v7_startTransition && $3bab94bb18dee09c$var$startTransitionImpl ? $3bab94bb18dee09c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aOzEm.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aOzEm.createElement((0, $5YTEB.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $3bab94bb18dee09c$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $aOzEm.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bs9Us.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aOzEm.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOzEm.useCallback((newState)=>{
        v7_startTransition && $3bab94bb18dee09c$var$startTransitionImpl ? $3bab94bb18dee09c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aOzEm.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aOzEm.createElement((0, $5YTEB.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $3bab94bb18dee09c$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $aOzEm.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOzEm.useCallback((newState)=>{
        v7_startTransition && $3bab94bb18dee09c$var$startTransitionImpl ? $3bab94bb18dee09c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aOzEm.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aOzEm.createElement((0, $5YTEB.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $3bab94bb18dee09c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $3bab94bb18dee09c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $3bab94bb18dee09c$export$a6c7ac8248d6e38a = /*#__PURE__*/ $aOzEm.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $3bab94bb18dee09c$var$_objectWithoutPropertiesLoose(_ref4, $3bab94bb18dee09c$var$_excluded);
    let { basename: basename } = $aOzEm.useContext((0, $5YTEB.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $3bab94bb18dee09c$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($3bab94bb18dee09c$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $bs9Us.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $5YTEB.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $3bab94bb18dee09c$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $aOzEm.createElement("a", $3bab94bb18dee09c$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $3bab94bb18dee09c$export$b0d92dbee9b5b60d = /*#__PURE__*/ $aOzEm.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $3bab94bb18dee09c$var$_objectWithoutPropertiesLoose(_ref5, $3bab94bb18dee09c$var$_excluded2);
    let path = (0, $5YTEB.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $5YTEB.useLocation)();
    let routerState = $aOzEm.useContext((0, $5YTEB.UNSAFE_DataRouterStateContext));
    let { navigator: navigator } = $aOzEm.useContext((0, $5YTEB.UNSAFE_NavigationContext));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $aOzEm.createElement($3bab94bb18dee09c$export$a6c7ac8248d6e38a, $3bab94bb18dee09c$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $3bab94bb18dee09c$export$a7fed597f4b8afd8 = /*#__PURE__*/ $aOzEm.forwardRef((props, ref)=>{
    let submit = $3bab94bb18dee09c$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $aOzEm.createElement($3bab94bb18dee09c$var$FormImpl, $3bab94bb18dee09c$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $3bab94bb18dee09c$var$FormImpl = /*#__PURE__*/ $aOzEm.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $3bab94bb18dee09c$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $3bab94bb18dee09c$var$_objectWithoutPropertiesLoose(_ref6, $3bab94bb18dee09c$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $3bab94bb18dee09c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $aOzEm.createElement("form", $3bab94bb18dee09c$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $3bab94bb18dee09c$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $3bab94bb18dee09c$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $3bab94bb18dee09c$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($3bab94bb18dee09c$var$DataRouterHook || ($3bab94bb18dee09c$var$DataRouterHook = {}));
var $3bab94bb18dee09c$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($3bab94bb18dee09c$var$DataRouterStateHook || ($3bab94bb18dee09c$var$DataRouterStateHook = {}));
function $3bab94bb18dee09c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $3bab94bb18dee09c$var$useDataRouterContext(hookName) {
    let ctx = $aOzEm.useContext((0, $5YTEB.UNSAFE_DataRouterContext));
    !ctx && (0, $bs9Us.UNSAFE_invariant)(false);
    return ctx;
}
function $3bab94bb18dee09c$var$useDataRouterState(hookName) {
    let state = $aOzEm.useContext((0, $5YTEB.UNSAFE_DataRouterStateContext));
    !state && (0, $bs9Us.UNSAFE_invariant)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $3bab94bb18dee09c$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $5YTEB.useNavigate)();
    let location = (0, $5YTEB.useLocation)();
    let path = (0, $5YTEB.useResolvedPath)(to, {
        relative: relative
    });
    return $aOzEm.useCallback((event)=>{
        if ($3bab94bb18dee09c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $bs9Us.createPath)(location) === (0, $bs9Us.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $3bab94bb18dee09c$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $aOzEm.useRef($3bab94bb18dee09c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $aOzEm.useRef(false);
    let location = (0, $5YTEB.useLocation)();
    let searchParams = $aOzEm.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $3bab94bb18dee09c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $5YTEB.useNavigate)();
    let setSearchParams = $aOzEm.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $3bab94bb18dee09c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $3bab94bb18dee09c$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $3bab94bb18dee09c$export$47c85c6e3a081d3() {
    let { router: router } = $3bab94bb18dee09c$var$useDataRouterContext($3bab94bb18dee09c$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $aOzEm.useContext((0, $5YTEB.UNSAFE_NavigationContext));
    let currentRouteId = (0, $5YTEB.UNSAFE_useRouteId)();
    return $aOzEm.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $3bab94bb18dee09c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $3bab94bb18dee09c$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $3bab94bb18dee09c$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $3bab94bb18dee09c$var$useDataRouterContext($3bab94bb18dee09c$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $aOzEm.useContext((0, $5YTEB.UNSAFE_NavigationContext));
    return $aOzEm.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $3bab94bb18dee09c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $3bab94bb18dee09c$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $bs9Us.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $3bab94bb18dee09c$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $aOzEm.useContext((0, $5YTEB.UNSAFE_NavigationContext));
    let routeContext = $aOzEm.useContext((0, $5YTEB.UNSAFE_RouteContext));
    !routeContext && (0, $bs9Us.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $3bab94bb18dee09c$var$_extends({}, (0, $5YTEB.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $5YTEB.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $bs9Us.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $bs9Us.createPath)(path);
}
function $3bab94bb18dee09c$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $aOzEm.forwardRef((props, ref)=>{
        let submit = $3bab94bb18dee09c$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $aOzEm.createElement($3bab94bb18dee09c$var$FormImpl, $3bab94bb18dee09c$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $3bab94bb18dee09c$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $3bab94bb18dee09c$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $3bab94bb18dee09c$var$useDataRouterContext($3bab94bb18dee09c$var$DataRouterHook.UseFetcher);
    let route = $aOzEm.useContext((0, $5YTEB.UNSAFE_RouteContext));
    !route && (0, $bs9Us.UNSAFE_invariant)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $bs9Us.UNSAFE_invariant)(false);
    let [fetcherKey] = $aOzEm.useState(()=>String(++$3bab94bb18dee09c$var$fetcherId));
    let [Form] = $aOzEm.useState(()=>{
        !routeId && (0, $bs9Us.UNSAFE_invariant)(false);
        return $3bab94bb18dee09c$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $aOzEm.useState(()=>(href)=>{
            !router && (0, $bs9Us.UNSAFE_invariant)(false);
            !routeId && (0, $bs9Us.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $3bab94bb18dee09c$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $aOzEm.useMemo(()=>$3bab94bb18dee09c$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $aOzEm.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $3bab94bb18dee09c$export$fa996778a3a31087() {
    let state = $3bab94bb18dee09c$var$useDataRouterState($3bab94bb18dee09c$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $3bab94bb18dee09c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $3bab94bb18dee09c$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $3bab94bb18dee09c$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $3bab94bb18dee09c$var$useDataRouterContext($3bab94bb18dee09c$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $3bab94bb18dee09c$var$useDataRouterState($3bab94bb18dee09c$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $aOzEm.useContext((0, $5YTEB.UNSAFE_NavigationContext));
    let location = (0, $5YTEB.useLocation)();
    let matches = (0, $5YTEB.useMatches)();
    let navigation = (0, $5YTEB.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $aOzEm.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $3bab94bb18dee09c$var$usePageHide($aOzEm.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $3bab94bb18dee09c$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $3bab94bb18dee09c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($3bab94bb18dee09c$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aOzEm.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $3bab94bb18dee09c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $3bab94bb18dee09c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aOzEm.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($3bab94bb18dee09c$var$_extends({}, location, {
                    pathname: (0, $bs9Us.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($3bab94bb18dee09c$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aOzEm.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $3bab94bb18dee09c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $aOzEm.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $3bab94bb18dee09c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $aOzEm.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $3bab94bb18dee09c$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $5YTEB.unstable_useBlocker)(when);
    $aOzEm.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $aOzEm.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}

});
parcelRegister("bs9Us", function(module, exports) {

$parcel$export(module.exports, "Action", () => $8569ff0ee3132eee$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $8569ff0ee3132eee$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $8569ff0ee3132eee$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $8569ff0ee3132eee$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $8569ff0ee3132eee$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $8569ff0ee3132eee$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $8569ff0ee3132eee$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $8569ff0ee3132eee$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $8569ff0ee3132eee$export$b69e3301ce081aa3);
$parcel$export(module.exports, "joinPaths", () => $8569ff0ee3132eee$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $8569ff0ee3132eee$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getPathContributingMatches", () => $8569ff0ee3132eee$export$90ba53ce1c7fdff2);
$parcel$export(module.exports, "resolveTo", () => $8569ff0ee3132eee$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $8569ff0ee3132eee$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "ErrorResponse", () => $8569ff0ee3132eee$export$acf1a680051f5031);
$parcel$export(module.exports, "isRouteErrorResponse", () => $8569ff0ee3132eee$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $8569ff0ee3132eee$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $8569ff0ee3132eee$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.8.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $8569ff0ee3132eee$var$_extends() {
    $8569ff0ee3132eee$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8569ff0ee3132eee$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $8569ff0ee3132eee$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($8569ff0ee3132eee$export$e19cd5f9376f8cee || ($8569ff0ee3132eee$export$e19cd5f9376f8cee = {}));
const $8569ff0ee3132eee$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $8569ff0ee3132eee$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $8569ff0ee3132eee$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $8569ff0ee3132eee$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $8569ff0ee3132eee$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $8569ff0ee3132eee$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $8569ff0ee3132eee$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $8569ff0ee3132eee$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $8569ff0ee3132eee$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $8569ff0ee3132eee$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $8569ff0ee3132eee$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $8569ff0ee3132eee$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $8569ff0ee3132eee$export$fe53371bee54353d(to);
    }
    return $8569ff0ee3132eee$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $8569ff0ee3132eee$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $8569ff0ee3132eee$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $8569ff0ee3132eee$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $8569ff0ee3132eee$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $8569ff0ee3132eee$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $8569ff0ee3132eee$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $8569ff0ee3132eee$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $8569ff0ee3132eee$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $8569ff0ee3132eee$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $8569ff0ee3132eee$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $8569ff0ee3132eee$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $8569ff0ee3132eee$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $8569ff0ee3132eee$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $8569ff0ee3132eee$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $8569ff0ee3132eee$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $8569ff0ee3132eee$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $8569ff0ee3132eee$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $8569ff0ee3132eee$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($8569ff0ee3132eee$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $8569ff0ee3132eee$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $8569ff0ee3132eee$export$e19cd5f9376f8cee.Push;
        let location = $8569ff0ee3132eee$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $8569ff0ee3132eee$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $8569ff0ee3132eee$export$e19cd5f9376f8cee.Replace;
        let location = $8569ff0ee3132eee$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $8569ff0ee3132eee$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $8569ff0ee3132eee$export$fe53371bee54353d(to);
        $8569ff0ee3132eee$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($8569ff0ee3132eee$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($8569ff0ee3132eee$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $8569ff0ee3132eee$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($8569ff0ee3132eee$var$ResultType || ($8569ff0ee3132eee$var$ResultType = {}));
const $8569ff0ee3132eee$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $8569ff0ee3132eee$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $8569ff0ee3132eee$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $8569ff0ee3132eee$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $8569ff0ee3132eee$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($8569ff0ee3132eee$var$isIndexRoute(route)) {
            let indexRoute = $8569ff0ee3132eee$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $8569ff0ee3132eee$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $8569ff0ee3132eee$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $8569ff0ee3132eee$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $8569ff0ee3132eee$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $8569ff0ee3132eee$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $8569ff0ee3132eee$var$flattenRoutes(routes);
    $8569ff0ee3132eee$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $8569ff0ee3132eee$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $8569ff0ee3132eee$var$safelyDecodeURI(pathname));
    return matches;
}
function $8569ff0ee3132eee$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $8569ff0ee3132eee$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $8569ff0ee3132eee$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $8569ff0ee3132eee$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $8569ff0ee3132eee$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $8569ff0ee3132eee$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $8569ff0ee3132eee$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $8569ff0ee3132eee$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $8569ff0ee3132eee$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $8569ff0ee3132eee$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $8569ff0ee3132eee$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $8569ff0ee3132eee$var$paramRe = /^:\w+$/;
const $8569ff0ee3132eee$var$dynamicSegmentValue = 3;
const $8569ff0ee3132eee$var$indexRouteValue = 2;
const $8569ff0ee3132eee$var$emptySegmentValue = 1;
const $8569ff0ee3132eee$var$staticSegmentValue = 10;
const $8569ff0ee3132eee$var$splatPenalty = -2;
const $8569ff0ee3132eee$var$isSplat = (s)=>s === "*";
function $8569ff0ee3132eee$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($8569ff0ee3132eee$var$isSplat)) initialScore += $8569ff0ee3132eee$var$splatPenalty;
    if (index) initialScore += $8569ff0ee3132eee$var$indexRouteValue;
    return segments.filter((s)=>!$8569ff0ee3132eee$var$isSplat(s)).reduce((score, segment)=>score + ($8569ff0ee3132eee$var$paramRe.test(segment) ? $8569ff0ee3132eee$var$dynamicSegmentValue : segment === "" ? $8569ff0ee3132eee$var$emptySegmentValue : $8569ff0ee3132eee$var$staticSegmentValue), initialScore);
}
function $8569ff0ee3132eee$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $8569ff0ee3132eee$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $8569ff0ee3132eee$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $8569ff0ee3132eee$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $8569ff0ee3132eee$export$a5c6d149b50c1d86($8569ff0ee3132eee$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $8569ff0ee3132eee$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $8569ff0ee3132eee$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $8569ff0ee3132eee$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $8569ff0ee3132eee$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $8569ff0ee3132eee$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $8569ff0ee3132eee$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $8569ff0ee3132eee$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $8569ff0ee3132eee$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $8569ff0ee3132eee$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $8569ff0ee3132eee$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $8569ff0ee3132eee$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $8569ff0ee3132eee$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $8569ff0ee3132eee$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $8569ff0ee3132eee$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $8569ff0ee3132eee$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $8569ff0ee3132eee$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $8569ff0ee3132eee$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $8569ff0ee3132eee$var$normalizeSearch(search),
        hash: $8569ff0ee3132eee$var$normalizeHash(hash)
    };
}
function $8569ff0ee3132eee$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $8569ff0ee3132eee$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $8569ff0ee3132eee$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $8569ff0ee3132eee$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $8569ff0ee3132eee$export$8ccf933b0513f8d0(toArg);
    else {
        to = $8569ff0ee3132eee$var$_extends({}, toArg);
        $8569ff0ee3132eee$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $8569ff0ee3132eee$var$getInvalidPathError("?", "pathname", "search", to));
        $8569ff0ee3132eee$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $8569ff0ee3132eee$var$getInvalidPathError("#", "pathname", "hash", to));
        $8569ff0ee3132eee$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $8569ff0ee3132eee$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $8569ff0ee3132eee$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $8569ff0ee3132eee$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $8569ff0ee3132eee$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $8569ff0ee3132eee$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $8569ff0ee3132eee$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $8569ff0ee3132eee$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $8569ff0ee3132eee$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $8569ff0ee3132eee$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $8569ff0ee3132eee$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $8569ff0ee3132eee$export$42a99a7a4bc0e76a extends Error {
}
class $8569ff0ee3132eee$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $8569ff0ee3132eee$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $8569ff0ee3132eee$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $8569ff0ee3132eee$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $8569ff0ee3132eee$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $8569ff0ee3132eee$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $8569ff0ee3132eee$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $8569ff0ee3132eee$var$unwrapTrackedPromise(value) {
    if (!$8569ff0ee3132eee$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $8569ff0ee3132eee$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $8569ff0ee3132eee$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $8569ff0ee3132eee$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $8569ff0ee3132eee$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $8569ff0ee3132eee$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $8569ff0ee3132eee$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $8569ff0ee3132eee$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $8569ff0ee3132eee$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $8569ff0ee3132eee$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $8569ff0ee3132eee$var$validMutationMethods = new Set($8569ff0ee3132eee$var$validMutationMethodsArr);
const $8569ff0ee3132eee$var$validRequestMethodsArr = [
    "get",
    ...$8569ff0ee3132eee$var$validMutationMethodsArr
];
const $8569ff0ee3132eee$var$validRequestMethods = new Set($8569ff0ee3132eee$var$validRequestMethodsArr);
const $8569ff0ee3132eee$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $8569ff0ee3132eee$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $8569ff0ee3132eee$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $8569ff0ee3132eee$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $8569ff0ee3132eee$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $8569ff0ee3132eee$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $8569ff0ee3132eee$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $8569ff0ee3132eee$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $8569ff0ee3132eee$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $8569ff0ee3132eee$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $8569ff0ee3132eee$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $8569ff0ee3132eee$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $8569ff0ee3132eee$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $8569ff0ee3132eee$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $8569ff0ee3132eee$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $8569ff0ee3132eee$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $8569ff0ee3132eee$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $8569ff0ee3132eee$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $8569ff0ee3132eee$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($8569ff0ee3132eee$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $8569ff0ee3132eee$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $8569ff0ee3132eee$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $8569ff0ee3132eee$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $8569ff0ee3132eee$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $8569ff0ee3132eee$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $8569ff0ee3132eee$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $8569ff0ee3132eee$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $8569ff0ee3132eee$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($8569ff0ee3132eee$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $8569ff0ee3132eee$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $8569ff0ee3132eee$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $8569ff0ee3132eee$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $8569ff0ee3132eee$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $8569ff0ee3132eee$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $8569ff0ee3132eee$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $8569ff0ee3132eee$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $8569ff0ee3132eee$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $8569ff0ee3132eee$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $8569ff0ee3132eee$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $8569ff0ee3132eee$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $8569ff0ee3132eee$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $8569ff0ee3132eee$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $8569ff0ee3132eee$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $8569ff0ee3132eee$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $8569ff0ee3132eee$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $8569ff0ee3132eee$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$8569ff0ee3132eee$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $8569ff0ee3132eee$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $8569ff0ee3132eee$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $8569ff0ee3132eee$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $8569ff0ee3132eee$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $8569ff0ee3132eee$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $8569ff0ee3132eee$var$ResultType.error,
            error: $8569ff0ee3132eee$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $8569ff0ee3132eee$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($8569ff0ee3132eee$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($8569ff0ee3132eee$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $8569ff0ee3132eee$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $8569ff0ee3132eee$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($8569ff0ee3132eee$var$isDeferredResult(result)) throw $8569ff0ee3132eee$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $8569ff0ee3132eee$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $8569ff0ee3132eee$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $8569ff0ee3132eee$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $8569ff0ee3132eee$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $8569ff0ee3132eee$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($8569ff0ee3132eee$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $8569ff0ee3132eee$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $8569ff0ee3132eee$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $8569ff0ee3132eee$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $8569ff0ee3132eee$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $8569ff0ee3132eee$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $8569ff0ee3132eee$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $8569ff0ee3132eee$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $8569ff0ee3132eee$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $8569ff0ee3132eee$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $8569ff0ee3132eee$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $8569ff0ee3132eee$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $8569ff0ee3132eee$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $8569ff0ee3132eee$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $8569ff0ee3132eee$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($8569ff0ee3132eee$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $8569ff0ee3132eee$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $8569ff0ee3132eee$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    submission: submission,
                    isFetchActionRedirect: true
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($8569ff0ee3132eee$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($8569ff0ee3132eee$var$isDeferredResult(actionResult)) throw $8569ff0ee3132eee$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $8569ff0ee3132eee$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $8569ff0ee3132eee$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $8569ff0ee3132eee$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $8569ff0ee3132eee$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $8569ff0ee3132eee$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $8569ff0ee3132eee$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $8569ff0ee3132eee$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $8569ff0ee3132eee$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $8569ff0ee3132eee$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $8569ff0ee3132eee$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($8569ff0ee3132eee$var$_extends({
                errors: errors,
                loaderData: $8569ff0ee3132eee$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $8569ff0ee3132eee$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $8569ff0ee3132eee$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $8569ff0ee3132eee$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($8569ff0ee3132eee$var$isDeferredResult(result)) result = await $8569ff0ee3132eee$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($8569ff0ee3132eee$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $8569ff0ee3132eee$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($8569ff0ee3132eee$var$isErrorResult(result)) {
            let boundaryMatch = $8569ff0ee3132eee$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $8569ff0ee3132eee$export$3e9cee6b33872309(!$8569ff0ee3132eee$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $8569ff0ee3132eee$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $8569ff0ee3132eee$var$createLocation(state.location, redirect.location, $8569ff0ee3132eee$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $8569ff0ee3132eee$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($8569ff0ee3132eee$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $8569ff0ee3132eee$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $8569ff0ee3132eee$export$e19cd5f9376f8cee.Replace : $8569ff0ee3132eee$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let activeSubmission = submission || $8569ff0ee3132eee$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($8569ff0ee3132eee$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $8569ff0ee3132eee$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $8569ff0ee3132eee$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: $8569ff0ee3132eee$var$getLoadingNavigation(redirectLocation),
            fetcherSubmission: activeSubmission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a submission, we will preserve it through the redirect navigation
            let overrideNavigation = $8569ff0ee3132eee$var$getLoadingNavigation(redirectLocation, activeSubmission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$8569ff0ee3132eee$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $8569ff0ee3132eee$var$callLoaderOrAction("loader", $8569ff0ee3132eee$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $8569ff0ee3132eee$var$ResultType.error,
                        error: $8569ff0ee3132eee$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $8569ff0ee3132eee$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $8569ff0ee3132eee$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $8569ff0ee3132eee$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $8569ff0ee3132eee$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $8569ff0ee3132eee$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $8569ff0ee3132eee$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $8569ff0ee3132eee$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $8569ff0ee3132eee$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $8569ff0ee3132eee$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $8569ff0ee3132eee$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $8569ff0ee3132eee$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $8569ff0ee3132eee$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$8569ff0ee3132eee$var$createUseMatchesMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $8569ff0ee3132eee$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $8569ff0ee3132eee$export$4d0306f8f6a4585b = Symbol("deferred");
function $8569ff0ee3132eee$export$3336b097a6fbc59a(routes, opts) {
    $8569ff0ee3132eee$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $8569ff0ee3132eee$var$defaultMapRouteProperties;
    let dataRoutes = $8569ff0ee3132eee$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $8569ff0ee3132eee$var$createLocation("", $8569ff0ee3132eee$export$fe53371bee54353d(url), null, "default");
        let matches = $8569ff0ee3132eee$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$8569ff0ee3132eee$var$isValidMethod(method) && method !== "HEAD") {
            let error = $8569ff0ee3132eee$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $8569ff0ee3132eee$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $8569ff0ee3132eee$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $8569ff0ee3132eee$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($8569ff0ee3132eee$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $8569ff0ee3132eee$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $8569ff0ee3132eee$var$createLocation("", $8569ff0ee3132eee$export$fe53371bee54353d(url), null, "default");
        let matches = $8569ff0ee3132eee$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$8569ff0ee3132eee$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $8569ff0ee3132eee$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $8569ff0ee3132eee$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $8569ff0ee3132eee$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $8569ff0ee3132eee$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $8569ff0ee3132eee$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($8569ff0ee3132eee$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$8569ff0ee3132eee$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $8569ff0ee3132eee$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($8569ff0ee3132eee$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $8569ff0ee3132eee$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $8569ff0ee3132eee$var$isResponse(result) ? result : $8569ff0ee3132eee$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($8569ff0ee3132eee$var$isQueryRouteResponse(e)) {
                if (e.type === $8569ff0ee3132eee$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($8569ff0ee3132eee$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $8569ff0ee3132eee$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $8569ff0ee3132eee$var$ResultType.error,
                error: error
            };
        } else {
            result = await $8569ff0ee3132eee$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($8569ff0ee3132eee$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($8569ff0ee3132eee$var$isDeferredResult(result)) {
            let error = $8569ff0ee3132eee$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $8569ff0ee3132eee$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($8569ff0ee3132eee$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($8569ff0ee3132eee$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $8569ff0ee3132eee$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $8569ff0ee3132eee$var$_extends({}, context, {
                statusCode: $8569ff0ee3132eee$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $8569ff0ee3132eee$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $8569ff0ee3132eee$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $8569ff0ee3132eee$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $8569ff0ee3132eee$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $8569ff0ee3132eee$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$8569ff0ee3132eee$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $8569ff0ee3132eee$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $8569ff0ee3132eee$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $8569ff0ee3132eee$export$fec11da027c70692(routes, context, error) {
    let newContext = $8569ff0ee3132eee$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $8569ff0ee3132eee$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $8569ff0ee3132eee$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $8569ff0ee3132eee$export$cae722b0cc860f13(to ? to : ".", $8569ff0ee3132eee$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $8569ff0ee3132eee$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$8569ff0ee3132eee$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $8569ff0ee3132eee$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $8569ff0ee3132eee$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $8569ff0ee3132eee$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$8569ff0ee3132eee$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$8569ff0ee3132eee$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $8569ff0ee3132eee$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $8569ff0ee3132eee$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $8569ff0ee3132eee$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$8569ff0ee3132eee$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$8569ff0ee3132eee$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $8569ff0ee3132eee$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $8569ff0ee3132eee$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $8569ff0ee3132eee$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $8569ff0ee3132eee$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $8569ff0ee3132eee$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($8569ff0ee3132eee$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $8569ff0ee3132eee$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $8569ff0ee3132eee$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $8569ff0ee3132eee$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $8569ff0ee3132eee$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $8569ff0ee3132eee$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $8569ff0ee3132eee$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($8569ff0ee3132eee$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $8569ff0ee3132eee$var$shouldRevalidateLoader(match, $8569ff0ee3132eee$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $8569ff0ee3132eee$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $8569ff0ee3132eee$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $8569ff0ee3132eee$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $8569ff0ee3132eee$var$shouldRevalidateLoader(fetcherMatch, $8569ff0ee3132eee$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $8569ff0ee3132eee$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $8569ff0ee3132eee$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $8569ff0ee3132eee$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $8569ff0ee3132eee$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $8569ff0ee3132eee$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $8569ff0ee3132eee$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$8569ff0ee3132eee$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $8569ff0ee3132eee$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $8569ff0ee3132eee$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $8569ff0ee3132eee$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $8569ff0ee3132eee$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $8569ff0ee3132eee$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $8569ff0ee3132eee$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $8569ff0ee3132eee$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $8569ff0ee3132eee$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $8569ff0ee3132eee$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($8569ff0ee3132eee$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($8569ff0ee3132eee$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $8569ff0ee3132eee$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$8569ff0ee3132eee$var$ABSOLUTE_URL_REGEX.test(location)) location = $8569ff0ee3132eee$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $8569ff0ee3132eee$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $8569ff0ee3132eee$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $8569ff0ee3132eee$var$ResultType.error ? $8569ff0ee3132eee$var$ResultType.error : $8569ff0ee3132eee$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $8569ff0ee3132eee$var$ResultType.error) return {
            type: resultType,
            error: new $8569ff0ee3132eee$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $8569ff0ee3132eee$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $8569ff0ee3132eee$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($8569ff0ee3132eee$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $8569ff0ee3132eee$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $8569ff0ee3132eee$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $8569ff0ee3132eee$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($8569ff0ee3132eee$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $8569ff0ee3132eee$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $8569ff0ee3132eee$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $8569ff0ee3132eee$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $8569ff0ee3132eee$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $8569ff0ee3132eee$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $8569ff0ee3132eee$export$3e9cee6b33872309(!$8569ff0ee3132eee$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($8569ff0ee3132eee$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $8569ff0ee3132eee$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $8569ff0ee3132eee$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($8569ff0ee3132eee$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $8569ff0ee3132eee$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $8569ff0ee3132eee$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $8569ff0ee3132eee$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($8569ff0ee3132eee$var$isErrorResult(result)) {
            let boundaryMatch = $8569ff0ee3132eee$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $8569ff0ee3132eee$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($8569ff0ee3132eee$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $8569ff0ee3132eee$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($8569ff0ee3132eee$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $8569ff0ee3132eee$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $8569ff0ee3132eee$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $8569ff0ee3132eee$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $8569ff0ee3132eee$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $8569ff0ee3132eee$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $8569ff0ee3132eee$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $8569ff0ee3132eee$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $8569ff0ee3132eee$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $8569ff0ee3132eee$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($8569ff0ee3132eee$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $8569ff0ee3132eee$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $8569ff0ee3132eee$export$8ccf933b0513f8d0(path) : path;
    return $8569ff0ee3132eee$export$fe53371bee54353d($8569ff0ee3132eee$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $8569ff0ee3132eee$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $8569ff0ee3132eee$var$isDeferredResult(result) {
    return result.type === $8569ff0ee3132eee$var$ResultType.deferred;
}
function $8569ff0ee3132eee$var$isErrorResult(result) {
    return result.type === $8569ff0ee3132eee$var$ResultType.error;
}
function $8569ff0ee3132eee$var$isRedirectResult(result) {
    return (result && result.type) === $8569ff0ee3132eee$var$ResultType.redirect;
}
function $8569ff0ee3132eee$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $8569ff0ee3132eee$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $8569ff0ee3132eee$var$isRedirectResponse(result) {
    if (!$8569ff0ee3132eee$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $8569ff0ee3132eee$var$isQueryRouteResponse(obj) {
    return obj && $8569ff0ee3132eee$var$isResponse(obj.response) && (obj.type === $8569ff0ee3132eee$var$ResultType.data || obj.type === $8569ff0ee3132eee$var$ResultType.error);
}
function $8569ff0ee3132eee$var$isValidMethod(method) {
    return $8569ff0ee3132eee$var$validRequestMethods.has(method.toLowerCase());
}
function $8569ff0ee3132eee$var$isMutationMethod(method) {
    return $8569ff0ee3132eee$var$validMutationMethods.has(method.toLowerCase());
}
async function $8569ff0ee3132eee$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$8569ff0ee3132eee$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($8569ff0ee3132eee$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $8569ff0ee3132eee$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $8569ff0ee3132eee$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $8569ff0ee3132eee$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $8569ff0ee3132eee$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $8569ff0ee3132eee$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $8569ff0ee3132eee$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $8569ff0ee3132eee$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $8569ff0ee3132eee$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $8569ff0ee3132eee$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $8569ff0ee3132eee$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $8569ff0ee3132eee$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $8569ff0ee3132eee$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $8569ff0ee3132eee$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $8569ff0ee3132eee$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $8569ff0ee3132eee$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $8569ff0ee3132eee$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    }
}
function $8569ff0ee3132eee$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}
function $8569ff0ee3132eee$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}

});

parcelRegister("5YTEB", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $45adba0f1b6fcc11$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $45adba0f1b6fcc11$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $45adba0f1b6fcc11$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $45adba0f1b6fcc11$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $45adba0f1b6fcc11$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $45adba0f1b6fcc11$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $45adba0f1b6fcc11$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $45adba0f1b6fcc11$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $45adba0f1b6fcc11$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $45adba0f1b6fcc11$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $45adba0f1b6fcc11$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $45adba0f1b6fcc11$export$2378eb7f5ff86053);
$parcel$export(module.exports, "unstable_useBlocker", () => $45adba0f1b6fcc11$export$2af03a1de5c0910);
$parcel$export(module.exports, "Router", () => $45adba0f1b6fcc11$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $45adba0f1b6fcc11$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Outlet", () => $45adba0f1b6fcc11$export$910ae8079b2c2852);
$parcel$export(module.exports, "Route", () => $45adba0f1b6fcc11$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $45adba0f1b6fcc11$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $45adba0f1b6fcc11$export$52b333d321859367);
/**
 * React Router v6.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aOzEm = parcelRequire("aOzEm");

var $bs9Us = parcelRequire("bs9Us");
function $45adba0f1b6fcc11$var$_extends() {
    $45adba0f1b6fcc11$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $45adba0f1b6fcc11$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $45adba0f1b6fcc11$export$3add0d5dce533e2e = /*#__PURE__*/ $aOzEm.createContext(null);
const $45adba0f1b6fcc11$export$145dfa71566a64dc = /*#__PURE__*/ $aOzEm.createContext(null);
const $45adba0f1b6fcc11$var$AwaitContext = /*#__PURE__*/ $aOzEm.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $45adba0f1b6fcc11$export$26749e8557646306 = /*#__PURE__*/ $aOzEm.createContext(null);
const $45adba0f1b6fcc11$export$c7914228fb69b0f5 = /*#__PURE__*/ $aOzEm.createContext(null);
const $45adba0f1b6fcc11$export$9072aa6dd1f93057 = /*#__PURE__*/ $aOzEm.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $45adba0f1b6fcc11$var$RouteErrorContext = /*#__PURE__*/ $aOzEm.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $45adba0f1b6fcc11$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$45adba0f1b6fcc11$export$9c954a9d03d32f4a() && (0, $bs9Us.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $aOzEm.useContext($45adba0f1b6fcc11$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $45adba0f1b6fcc11$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $bs9Us.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $45adba0f1b6fcc11$export$9c954a9d03d32f4a() {
    return $aOzEm.useContext($45adba0f1b6fcc11$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $45adba0f1b6fcc11$export$45d76561a5302f2b() {
    !$45adba0f1b6fcc11$export$9c954a9d03d32f4a() && (0, $bs9Us.UNSAFE_invariant)(false);
    return $aOzEm.useContext($45adba0f1b6fcc11$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $45adba0f1b6fcc11$export$1b3f31771c5d07c() {
    return $aOzEm.useContext($45adba0f1b6fcc11$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $45adba0f1b6fcc11$export$6c330e8992e8a295(pattern) {
    !$45adba0f1b6fcc11$export$9c954a9d03d32f4a() && (0, $bs9Us.UNSAFE_invariant)(false);
    let { pathname: pathname } = $45adba0f1b6fcc11$export$45d76561a5302f2b();
    return $aOzEm.useMemo(()=>(0, $bs9Us.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $45adba0f1b6fcc11$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $45adba0f1b6fcc11$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $aOzEm.useContext($45adba0f1b6fcc11$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $aOzEm.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $45adba0f1b6fcc11$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $aOzEm.useContext($45adba0f1b6fcc11$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $45adba0f1b6fcc11$var$useNavigateStable() : $45adba0f1b6fcc11$var$useNavigateUnstable();
}
function $45adba0f1b6fcc11$var$useNavigateUnstable() {
    !$45adba0f1b6fcc11$export$9c954a9d03d32f4a() && (0, $bs9Us.UNSAFE_invariant)(false);
    let dataRouterContext = $aOzEm.useContext($45adba0f1b6fcc11$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $aOzEm.useContext($45adba0f1b6fcc11$export$26749e8557646306);
    let { matches: matches } = $aOzEm.useContext($45adba0f1b6fcc11$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $45adba0f1b6fcc11$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $bs9Us.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    let activeRef = $aOzEm.useRef(false);
    $45adba0f1b6fcc11$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aOzEm.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $bs9Us.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $bs9Us.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $45adba0f1b6fcc11$var$OutletContext = /*#__PURE__*/ $aOzEm.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $45adba0f1b6fcc11$export$4138103a3ae699cc() {
    return $aOzEm.useContext($45adba0f1b6fcc11$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $45adba0f1b6fcc11$export$a3be3530d8e40d0b(context) {
    let outlet = $aOzEm.useContext($45adba0f1b6fcc11$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $45adba0f1b6fcc11$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $aOzEm.useContext($45adba0f1b6fcc11$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $45adba0f1b6fcc11$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $aOzEm.useContext($45adba0f1b6fcc11$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $45adba0f1b6fcc11$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $bs9Us.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    return $aOzEm.useMemo(()=>(0, $bs9Us.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $45adba0f1b6fcc11$export$5d3fca4a98652595(routes, locationArg) {
    return $45adba0f1b6fcc11$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $45adba0f1b6fcc11$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$45adba0f1b6fcc11$export$9c954a9d03d32f4a() && (0, $bs9Us.UNSAFE_invariant)(false);
    let { navigator: navigator } = $aOzEm.useContext($45adba0f1b6fcc11$export$26749e8557646306);
    let { matches: parentMatches } = $aOzEm.useContext($45adba0f1b6fcc11$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $45adba0f1b6fcc11$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $bs9Us.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $bs9Us.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $bs9Us.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $45adba0f1b6fcc11$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $bs9Us.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $bs9Us.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $45adba0f1b6fcc11$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $bs9Us.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $45adba0f1b6fcc11$var$DefaultErrorComponent() {
    let error = $45adba0f1b6fcc11$export$ed527bf60f6e05f2();
    let message = (0, $bs9Us.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $aOzEm.createElement($aOzEm.Fragment, null, /*#__PURE__*/ $aOzEm.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $aOzEm.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $aOzEm.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $45adba0f1b6fcc11$var$defaultErrorElement = /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$var$DefaultErrorComponent, null);
class $45adba0f1b6fcc11$var$RenderErrorBoundary extends $aOzEm.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $45adba0f1b6fcc11$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $aOzEm.useContext($45adba0f1b6fcc11$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $45adba0f1b6fcc11$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $bs9Us.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $45adba0f1b6fcc11$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $aOzEm.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $45adba0f1b6fcc11$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($45adba0f1b6fcc11$var$DataRouterHook || {});
var $45adba0f1b6fcc11$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($45adba0f1b6fcc11$var$DataRouterStateHook || {});
function $45adba0f1b6fcc11$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $45adba0f1b6fcc11$var$useDataRouterContext(hookName) {
    let ctx = $aOzEm.useContext($45adba0f1b6fcc11$export$3add0d5dce533e2e);
    !ctx && (0, $bs9Us.UNSAFE_invariant)(false);
    return ctx;
}
function $45adba0f1b6fcc11$var$useDataRouterState(hookName) {
    let state = $aOzEm.useContext($45adba0f1b6fcc11$export$145dfa71566a64dc);
    !state && (0, $bs9Us.UNSAFE_invariant)(false);
    return state;
}
function $45adba0f1b6fcc11$var$useRouteContext(hookName) {
    let route = $aOzEm.useContext($45adba0f1b6fcc11$export$9072aa6dd1f93057);
    !route && (0, $bs9Us.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $45adba0f1b6fcc11$var$useCurrentRouteId(hookName) {
    let route = $45adba0f1b6fcc11$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $bs9Us.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $45adba0f1b6fcc11$export$5fc8298006ad9e58() {
    return $45adba0f1b6fcc11$var$useCurrentRouteId($45adba0f1b6fcc11$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $45adba0f1b6fcc11$export$d0fd4b7106de2769() {
    let state = $45adba0f1b6fcc11$var$useDataRouterState($45adba0f1b6fcc11$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $45adba0f1b6fcc11$export$600dc272ed516c15() {
    let dataRouterContext = $45adba0f1b6fcc11$var$useDataRouterContext($45adba0f1b6fcc11$var$DataRouterHook.UseRevalidator);
    let state = $45adba0f1b6fcc11$var$useDataRouterState($45adba0f1b6fcc11$var$DataRouterStateHook.UseRevalidator);
    return $aOzEm.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $45adba0f1b6fcc11$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $45adba0f1b6fcc11$var$useDataRouterState($45adba0f1b6fcc11$var$DataRouterStateHook.UseMatches);
    return $aOzEm.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $45adba0f1b6fcc11$export$1448a5050d252c4d() {
    let state = $45adba0f1b6fcc11$var$useDataRouterState($45adba0f1b6fcc11$var$DataRouterStateHook.UseLoaderData);
    let routeId = $45adba0f1b6fcc11$var$useCurrentRouteId($45adba0f1b6fcc11$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $45adba0f1b6fcc11$export$fd5d37484eab868d(routeId) {
    let state = $45adba0f1b6fcc11$var$useDataRouterState($45adba0f1b6fcc11$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $45adba0f1b6fcc11$export$fdc00f3f26066d5e() {
    let state = $45adba0f1b6fcc11$var$useDataRouterState($45adba0f1b6fcc11$var$DataRouterStateHook.UseActionData);
    let route = $aOzEm.useContext($45adba0f1b6fcc11$export$9072aa6dd1f93057);
    !route && (0, $bs9Us.UNSAFE_invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $45adba0f1b6fcc11$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $aOzEm.useContext($45adba0f1b6fcc11$var$RouteErrorContext);
    let state = $45adba0f1b6fcc11$var$useDataRouterState($45adba0f1b6fcc11$var$DataRouterStateHook.UseRouteError);
    let routeId = $45adba0f1b6fcc11$var$useCurrentRouteId($45adba0f1b6fcc11$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $45adba0f1b6fcc11$export$78a72ddb39bdd145() {
    let value = $aOzEm.useContext($45adba0f1b6fcc11$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $45adba0f1b6fcc11$export$17f53340677d5831() {
    let value = $aOzEm.useContext($45adba0f1b6fcc11$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $45adba0f1b6fcc11$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $45adba0f1b6fcc11$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $45adba0f1b6fcc11$var$useDataRouterContext($45adba0f1b6fcc11$var$DataRouterHook.UseBlocker);
    let state = $45adba0f1b6fcc11$var$useDataRouterState($45adba0f1b6fcc11$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $aOzEm.useState("");
    let blockerFunction = $aOzEm.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $45adba0f1b6fcc11$var$_extends({}, currentLocation, {
                pathname: (0, $bs9Us.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $45adba0f1b6fcc11$var$_extends({}, nextLocation, {
                pathname: (0, $bs9Us.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $aOzEm.useEffect(()=>{
        let key = String(++$45adba0f1b6fcc11$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $aOzEm.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $bs9Us.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $45adba0f1b6fcc11$var$useNavigateStable() {
    let { router: router } = $45adba0f1b6fcc11$var$useDataRouterContext($45adba0f1b6fcc11$var$DataRouterHook.UseNavigateStable);
    let id = $45adba0f1b6fcc11$var$useCurrentRouteId($45adba0f1b6fcc11$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $aOzEm.useRef(false);
    $45adba0f1b6fcc11$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aOzEm.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $45adba0f1b6fcc11$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $45adba0f1b6fcc11$var$alreadyWarned = {};
function $45adba0f1b6fcc11$var$warningOnce(key, cond, message) {
    if (!cond && !$45adba0f1b6fcc11$var$alreadyWarned[key]) $45adba0f1b6fcc11$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $45adba0f1b6fcc11$var$START_TRANSITION = "startTransition";
const $45adba0f1b6fcc11$var$startTransitionImpl = $aOzEm[$45adba0f1b6fcc11$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $45adba0f1b6fcc11$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $aOzEm.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOzEm.useCallback((newState)=>{
        v7_startTransition && $45adba0f1b6fcc11$var$startTransitionImpl ? $45adba0f1b6fcc11$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aOzEm.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $aOzEm.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $aOzEm.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $aOzEm.createElement($aOzEm.Fragment, null, /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $45adba0f1b6fcc11$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $45adba0f1b6fcc11$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $45adba0f1b6fcc11$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $aOzEm.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bs9Us.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aOzEm.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOzEm.useCallback((newState)=>{
        v7_startTransition && $45adba0f1b6fcc11$var$startTransitionImpl ? $45adba0f1b6fcc11$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aOzEm.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $45adba0f1b6fcc11$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$45adba0f1b6fcc11$export$9c954a9d03d32f4a() && (0, $bs9Us.UNSAFE_invariant)(false);
    let { matches: matches } = $aOzEm.useContext($45adba0f1b6fcc11$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $45adba0f1b6fcc11$export$45d76561a5302f2b();
    let navigate = $45adba0f1b6fcc11$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $bs9Us.resolveTo)(to, (0, $bs9Us.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $aOzEm.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $45adba0f1b6fcc11$export$910ae8079b2c2852(props) {
    return $45adba0f1b6fcc11$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $45adba0f1b6fcc11$export$e7b0ac011bb776c6(_props) {
    (0, $bs9Us.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $45adba0f1b6fcc11$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $bs9Us.Action).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$45adba0f1b6fcc11$export$9c954a9d03d32f4a() && (0, $bs9Us.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $aOzEm.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $bs9Us.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $aOzEm.useMemo(()=>{
        let trailingPathname = (0, $bs9Us.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $45adba0f1b6fcc11$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $45adba0f1b6fcc11$export$5d3fca4a98652595($45adba0f1b6fcc11$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $45adba0f1b6fcc11$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$var$ResolveAwait, null, children));
}
var $45adba0f1b6fcc11$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($45adba0f1b6fcc11$var$AwaitRenderStatus || {});
const $45adba0f1b6fcc11$var$neverSettledPromise = new Promise(()=>{});
class $45adba0f1b6fcc11$var$AwaitErrorBoundary extends $aOzEm.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $45adba0f1b6fcc11$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $45adba0f1b6fcc11$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $45adba0f1b6fcc11$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $45adba0f1b6fcc11$var$AwaitRenderStatus.error : promise._data !== undefined ? $45adba0f1b6fcc11$var$AwaitRenderStatus.success : $45adba0f1b6fcc11$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $45adba0f1b6fcc11$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $45adba0f1b6fcc11$var$AwaitRenderStatus.error && promise._error instanceof (0, $bs9Us.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $45adba0f1b6fcc11$var$neverSettledPromise;
        if (status === $45adba0f1b6fcc11$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $45adba0f1b6fcc11$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $45adba0f1b6fcc11$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $aOzEm.createElement($45adba0f1b6fcc11$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $45adba0f1b6fcc11$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $45adba0f1b6fcc11$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $aOzEm.createElement($aOzEm.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $45adba0f1b6fcc11$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $aOzEm.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $aOzEm.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $aOzEm.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $45adba0f1b6fcc11$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $45adba0f1b6fcc11$export$e7b0ac011bb776c6) && (0, $bs9Us.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $bs9Us.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $45adba0f1b6fcc11$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $45adba0f1b6fcc11$export$daf73786167a7f72(matches) {
    return $45adba0f1b6fcc11$var$_renderMatches(matches);
}
function $45adba0f1b6fcc11$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $aOzEm.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $aOzEm.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $45adba0f1b6fcc11$export$f30f7e456d254e83(routes, opts) {
    return (0, $bs9Us.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $45adba0f1b6fcc11$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bs9Us.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $45adba0f1b6fcc11$export$52b333d321859367
    }).initialize();
}

});


parcelRegister("7WKzO", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("aOzEm")));
})(module.exports, function(exports1, React) {
    "use strict";
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === "function") return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});

parcelRegister("bteot", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLink = module.exports.LinkProvider = void 0;

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");
// LinkContext allows a consuming application to inject a
// custom component to be used for nav links & buttons into
// decodable-ui. In this way, the consumer can connection
// decodable-ui into their routing solution of choice -
// typically react-router. The provided component must handle
// adapting the MUI Button/Link props API to the external
// router's components.
//
// See: https://mui.com/guides/routing/
const $859d916ce3269b33$var$LinkContext = (0, $aOzEm.createContext)(null);
function $859d916ce3269b33$var$LinkProvider({ value: value, children: children }) {
    return (0, $2T9xh.jsx)($859d916ce3269b33$var$LinkContext.Provider, Object.assign({
        value: value
    }, {
        children: children
    }));
}
module.exports.LinkProvider = $859d916ce3269b33$var$LinkProvider;
function $859d916ce3269b33$var$useLink() {
    const value = (0, $aOzEm.useContext)($859d916ce3269b33$var$LinkContext);
    return value;
}
module.exports.useLink = $859d916ce3269b33$var$useLink;

});

parcelRegister("5Fl8O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ThemeProvider = module.exports.brandColors = void 0;

var $aW4Rp = parcelRequire("aW4Rp");
Object.defineProperty(module.exports, "brandColors", {
    enumerable: true,
    get: function() {
        return $aW4Rp.brandColors;
    }
});

var $dJTQM = parcelRequire("dJTQM");
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $dJTQM.ThemeProvider;
    }
});

});
parcelRegister("aW4Rp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.brandColors = void 0;
// From "Decodable - Brand Guidline.pdf" in GDrive
module.exports.brandColors = {
    primary: {
        main: "#0E0F18",
        blue: "#2F74F9"
    },
    blue: {
        light: "#45CDFF",
        main: "#2F74F9",
        contrastText: "white"
    },
    red: {
        main: "#F44C4C"
    },
    plum: {
        main: "#FF70F1"
    },
    green: {
        main: "#44E1BC",
        contrastText: "black"
    },
    yellow: {
        main: "#FFE182"
    }
};

});

parcelRegister("dJTQM", function(module, exports) {
"use strict";
var $a00acd0f5aae05f5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDecodableTheme = module.exports.ThemeProvider = void 0;

var $2T9xh = parcelRequire("2T9xh");

var $dsx7b = parcelRequire("dsx7b");
var $hIOMs = parcelRequire("hIOMs");

var $iyoP2 = parcelRequire("iyoP2");
var $57YGU = parcelRequire("57YGU");

const $a00acd0f5aae05f5$var$light_1 = $a00acd0f5aae05f5$var$__importDefault((parcelRequire("3ppai")));
function $a00acd0f5aae05f5$var$ThemeProvider({ scoped: scoped, children: children }) {
    // todo: add a theme switching function to context once dark mode is defined
    return (0, $2T9xh.jsxs)($iyoP2.default, Object.assign({
        theme: $a00acd0f5aae05f5$var$light_1.default
    }, {
        children: [
            scoped ? (0, $2T9xh.jsx)($hIOMs.default, {}) : (0, $2T9xh.jsx)($dsx7b.default, {}),
            children
        ]
    }));
}
module.exports.ThemeProvider = $a00acd0f5aae05f5$var$ThemeProvider;
// The name is a bit verbose, but avoids collisions with the
// dozen `useTheme` imports you can find in various MUI and
// related packages (so your editor can auto-import easily).
function $a00acd0f5aae05f5$var$useDecodableTheme() {
    return (0, $57YGU.default)();
}
module.exports.useDecodableTheme = $a00acd0f5aae05f5$var$useDecodableTheme;

});
parcelRegister("dsx7b", function(module, exports) {

$parcel$export(module.exports, "html", () => $9cc793cf9fb08779$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "body", () => $9cc793cf9fb08779$export$32180ef41b15b513);
$parcel$export(module.exports, "default", () => $9cc793cf9fb08779$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $gEb5G = parcelRequire("gEb5G");

var $103xJ = parcelRequire("103xJ");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $9cc793cf9fb08779$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $g6Hsb.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $9cc793cf9fb08779$export$32180ef41b15b513 = (theme)=>(0, $g6Hsb.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $9cc793cf9fb08779$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $g6Hsb.default)({
        html: $9cc793cf9fb08779$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $g6Hsb.default)({
            margin: 0
        }, $9cc793cf9fb08779$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $9cc793cf9fb08779$var$CssBaseline(inProps) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($aOzEm.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $103xJ.default), {
                styles: (theme)=>$9cc793cf9fb08779$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $9cc793cf9fb08779$export$2e2bcd8739ae039 = $9cc793cf9fb08779$var$CssBaseline;

});
parcelRegister("103xJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ba88a17c1e9eb88$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");
parcelRequire("aOzEm");


var $acjHQ = parcelRequire("acjHQ");

var $i1vlj = parcelRequire("i1vlj");

var $iaZx2 = parcelRequire("iaZx2");

var $2T9xh = parcelRequire("2T9xh");
"use client";
function $0ba88a17c1e9eb88$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $acjHQ.default), (0, $g6Hsb.default)({}, props, {
        defaultTheme: (0, $i1vlj.default),
        themeId: (0, $iaZx2.default)
    }));
}
var $0ba88a17c1e9eb88$export$2e2bcd8739ae039 = $0ba88a17c1e9eb88$var$GlobalStyles;

});
parcelRegister("acjHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $76ca4f9b14365e0e$export$2e2bcd8739ae039);
parcelRequire("aOzEm");


var $aC91m = parcelRequire("aC91m");

var $bUm4i = parcelRequire("bUm4i");

var $2T9xh = parcelRequire("2T9xh");
"use client";
function $76ca4f9b14365e0e$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $bUm4i.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $aC91m.default), {
        styles: globalStyles
    });
}
var $76ca4f9b14365e0e$export$2e2bcd8739ae039 = $76ca4f9b14365e0e$var$GlobalStyles;

});



parcelRegister("hIOMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce6defb133fdc76f$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $gEb5G = parcelRequire("gEb5G");

var $25zst = parcelRequire("25zst");

var $dsx7b = parcelRequire("dsx7b");

var $bGxqV = parcelRequire("bGxqV");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $ce6defb133fdc76f$var$_excluded = [
    "className",
    "component",
    "enableColorScheme"
];
const $ce6defb133fdc76f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $bGxqV.getScopedCssBaselineUtilityClass), classes);
};
const $ce6defb133fdc76f$var$ScopedCssBaselineRoot = (0, $25zst.default)("div", {
    name: "MuiScopedCssBaseline",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    const colorSchemeStyles = {};
    if (ownerState.enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[`&${theme.getColorSchemeSelector(key).replace(/\s*&/, "")}`] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    return (0, $g6Hsb.default)({}, (0, $dsx7b.html)(theme, ownerState.enableColorScheme), (0, $dsx7b.body)(theme), {
        "& *, & *::before, & *::after": {
            boxSizing: "inherit"
        },
        "& strong, & b": {
            fontWeight: theme.typography.fontWeightBold
        }
    }, colorSchemeStyles);
});
const $ce6defb133fdc76f$var$ScopedCssBaseline = /*#__PURE__*/ $aOzEm.forwardRef(function ScopedCssBaseline(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiScopedCssBaseline"
    });
    const { className: className, component: component = "div" } = props, other = (0, $cAqXo.default)(props, $ce6defb133fdc76f$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        component: component
    });
    const classes = $ce6defb133fdc76f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($ce6defb133fdc76f$var$ScopedCssBaselineRoot, (0, $g6Hsb.default)({
        as: component,
        className: (0, $g45Wv.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $ce6defb133fdc76f$export$2e2bcd8739ae039 = $ce6defb133fdc76f$var$ScopedCssBaseline;

});
parcelRegister("bGxqV", function(module, exports) {

$parcel$export(module.exports, "getScopedCssBaselineUtilityClass", () => $881d8d17271479d8$export$a3f1a6e59bdd9d27);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $881d8d17271479d8$export$a3f1a6e59bdd9d27(slot) {
    return (0, $6vnyE.default)("MuiScopedCssBaseline", slot);
}
const $881d8d17271479d8$var$scopedCssBaselineClasses = (0, $cyhE3.default)("MuiScopedCssBaseline", [
    "root"
]);
var $881d8d17271479d8$export$2e2bcd8739ae039 = $881d8d17271479d8$var$scopedCssBaselineClasses;

});


parcelRegister("iyoP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d81ea827ee705516$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");
parcelRequire("aOzEm");


var $66Nwt = parcelRequire("66Nwt");

var $iaZx2 = parcelRequire("iaZx2");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $d81ea827ee705516$var$_excluded = [
    "theme"
];
function $d81ea827ee705516$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $cAqXo.default)(_ref, $d81ea827ee705516$var$_excluded);
    const scopedTheme = themeInput[0, $iaZx2.default];
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $66Nwt.default), (0, $g6Hsb.default)({}, props, {
        themeId: scopedTheme ? (0, $iaZx2.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}

});
parcelRegister("66Nwt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4729b7d15b51019f$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $88RrJ = parcelRequire("88RrJ");
var $gC0Gz = parcelRequire("gC0Gz");


var $e2SFW = parcelRequire("e2SFW");

var $8BSy0 = parcelRequire("8BSy0");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $4729b7d15b51019f$var$EMPTY_THEME = {};
function $4729b7d15b51019f$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $aOzEm.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $g6Hsb.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $g6Hsb.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $g6Hsb.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $4729b7d15b51019f$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $8BSy0.default)($4729b7d15b51019f$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $gC0Gz.default)() || $4729b7d15b51019f$var$EMPTY_THEME;
    const engineTheme = $4729b7d15b51019f$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $4729b7d15b51019f$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $88RrJ.default), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $e2SFW.ThemeContext).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
var $4729b7d15b51019f$export$2e2bcd8739ae039 = $4729b7d15b51019f$var$ThemeProvider;

});
parcelRegister("88RrJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ed88769c4b8b5ec$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");



var $fiH23 = parcelRequire("fiH23");

var $gC0Gz = parcelRequire("gC0Gz");

var $kvmeh = parcelRequire("kvmeh");

var $2T9xh = parcelRequire("2T9xh");
function $5ed88769c4b8b5ec$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $g6Hsb.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $5ed88769c4b8b5ec$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $gC0Gz.default)();
    const theme = $aOzEm.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $5ed88769c4b8b5ec$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $kvmeh.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $fiH23.default).Provider, {
        value: theme,
        children: children
    });
}
var $5ed88769c4b8b5ec$export$2e2bcd8739ae039 = $5ed88769c4b8b5ec$var$ThemeProvider;

});
parcelRegister("fiH23", function(module, exports) {

$parcel$export(module.exports, "default", () => $b239eac0113fafb4$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");
const $b239eac0113fafb4$var$ThemeContext = /*#__PURE__*/ $aOzEm.createContext(null);
var $b239eac0113fafb4$export$2e2bcd8739ae039 = $b239eac0113fafb4$var$ThemeContext;

});

parcelRegister("gC0Gz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c180ba1b40000ce3$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");

var $fiH23 = parcelRequire("fiH23");
function $c180ba1b40000ce3$export$2e2bcd8739ae039() {
    const theme = $aOzEm.useContext((0, $fiH23.default));
    return theme;
}

});

parcelRegister("kvmeh", function(module, exports) {

$parcel$export(module.exports, "default", () => $eed7f2288f009a72$export$2e2bcd8739ae039);
const $eed7f2288f009a72$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $eed7f2288f009a72$export$2e2bcd8739ae039 = $eed7f2288f009a72$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});




parcelRegister("57YGU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bbcaf28df9712fa$export$2e2bcd8739ae039);
parcelRequire("aOzEm");

var $bUm4i = parcelRequire("bUm4i");

var $i1vlj = parcelRequire("i1vlj");

var $iaZx2 = parcelRequire("iaZx2");
"use client";
function $3bbcaf28df9712fa$export$2e2bcd8739ae039() {
    const theme = (0, $bUm4i.default)((0, $i1vlj.default));
    return theme[0, $iaZx2.default] || theme;
}

});

parcelRegister("3ppai", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $k7Clf = parcelRequire("k7Clf");

var $aW4Rp = parcelRequire("aW4Rp");
// Colors in this palette _not_ derived from brandColors are pulled from figma.
// Note: this palette is merged with the default MUI palette via createTheme.
const $27b73a2549e93235$var$palette = {
    brand: $aW4Rp.brandColors,
    common: {
        white: "white",
        black: "black",
        grey: "grey"
    },
    primary: {
        main: $aW4Rp.brandColors.primary.main
    },
    secondary: {
        main: "rgba(14, 15, 24, 0.04)"
    },
    error: {
        main: $aW4Rp.brandColors.red.main
    },
    warning: {
        main: $aW4Rp.brandColors.yellow.main
    },
    info: {
        light: "#A8AFCE",
        main: "#79809D",
        dark: "#4C546F"
    },
    success: {
        main: $aW4Rp.brandColors.green.main
    },
    background: {
        paper: "#ffffff",
        default: "rgba(245, 247, 250, 1)"
    },
    text: {
        primary: "rgba(14, 15, 24, 1)",
        secondary: "rgba(14, 15, 24, 0.64)",
        disabled: "rgba(14, 15, 24, 0.32)"
    }
};
const $27b73a2549e93235$var$decodableBits = {
    contentArea: {
        maxWidth: "1024px"
    },
    sheetWidth: {
        small: "600px",
        medium: "800px",
        large: "1024px"
    },
    layoutParameters: {
        // Gives enough clearance for the "main" component to coexist with
        // the app bar & subheader, if present, and have some bottom padding
        // (to avoid collisions with horizontal scroll bars) on a 1080 screen.
        //
        // TODO: Sure can't wait to get all of the pages switched over to a grid
        // layout / on the new page templates to better manage vertical space
        // and get rid of this horrible magic number. Please forgive me for making
        // you look at this.
        primaryComponentMaxHeight: "calc(100vh - 264px)"
    },
    tags: {
        chip: {
            fontSize: "0.8215rem"
        }
    }
};
// todo: https://mui.com/customization/theme-components/#adding-new-component-variants
// We're using the variants API which is deprecated. We should switch to styleOverrides functions.
// todo: extract "base" theme object & mixin to light & dark modes
const $27b73a2549e93235$var$decodableThemeOptions = {
    palette: $27b73a2549e93235$var$palette,
    decodable: $27b73a2549e93235$var$decodableBits,
    // Note: Inter & "IBM Plex Mono" must be loaded by the application!
    // We should be self-hosting these, but for convenience they can be loaded from Google's CDN:
    //
    //   <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Inter">
    //   <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=IBM+Plex+Mono">
    typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        code: {
            fontFamily: '"IBM Plex Mono", monospace'
        }
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: $27b73a2549e93235$var$palette.common.white,
                    color: $27b73a2549e93235$var$palette.primary.main,
                    "& .MuiToolbar-root": {
                        minHeight: 0,
                        height: "4.2rem",
                        padding: 0,
                        overflow: "hidden"
                    },
                    "& .MuiTabs-root": {
                        height: "100%"
                    },
                    "& .MuiTab-root": {
                        fontSize: ".9rem",
                        padding: "0 1.5ch"
                    },
                    "& .MuiTabs-flexContainer": {
                        height: "100%"
                    },
                    "& .MuiTabs-indicator": {
                        height: "2px"
                    }
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: $27b73a2549e93235$var$palette.common.white
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                autoComplete: "off",
                InputLabelProps: {
                    shrink: true
                }
            }
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true
            },
            styleOverrides: {
                root: {
                    textTransform: "none",
                    fontSize: "0.9rem",
                    fontWeight: "400"
                }
            },
            variants: [
                {
                    props: {
                        color: "secondary"
                    },
                    style: {
                        color: $27b73a2549e93235$var$palette.primary.main
                    }
                }
            ]
        },
        MuiButtonGroup: {
            defaultProps: {
                disableElevation: true
            },
            styleOverrides: {
                root ({ ownerState: ownerState }) {
                    const overrides = {};
                    if (ownerState.color == "primary") overrides["& .MuiButtonGroup-grouped:not(:last-of-type)"] = {
                        borderColor: $27b73a2549e93235$var$palette.common.grey
                    };
                    return overrides;
                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    "&.Mui-checked.MuiCheckbox-colorPrimary": {
                        color: $27b73a2549e93235$var$palette.brand.blue.main
                    },
                    "&.Mui-checked.MuiCheckbox-colorSecondary": {
                        // We're just increasing the opacity from the default
                        color: "rgba(14, 15, 24, 0.4)"
                    }
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    "& .MuiListItemIcon-root": {
                        minWidth: "3ch"
                    }
                }
            }
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    textTransform: "none"
                }
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    "& .MuiButtonBase-root": {
                        textTransform: "none"
                    },
                    "& .Mui-selected": {
                        fontWeight: "500"
                    }
                }
            }
        },
        MuiTypography: {
            variants: [
                {
                    props: {
                        variant: "body2"
                    },
                    style: {
                        color: $27b73a2549e93235$var$palette.text.secondary
                    }
                }
            ]
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 600,
                    backgroundColor: $27b73a2549e93235$var$palette.background.paper,
                    py: 0
                },
                root: {
                    fontSize: "1rem",
                    height: "3.5em"
                }
            }
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: $aW4Rp.brandColors.blue.main,
                    textDecoration: "none"
                }
            }
        },
        MuiAlert: {
            styleOverrides: {
                root: ({ ownerState: ownerState, theme: theme })=>{
                    if (ownerState.color == "grey") {
                        const color = theme.palette.primary.main;
                        return {
                            color: color,
                            "& .MuiAlert-icon": {
                                color: color
                            },
                            backgroundColor: theme.palette.secondary.main
                        };
                    }
                    const color = theme.palette[ownerState.severity || "info"].contrastText;
                    return {
                        color: color,
                        "& .MuiAlert-icon": {
                            color: color
                        },
                        backgroundColor: theme.palette[ownerState.severity || "info"].main,
                        fontWeight: ownerState.severity == "error" ? "500" : undefined
                    };
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    "& .MuiLink-root": {
                        color: $27b73a2549e93235$var$palette.common.white
                    }
                }
            },
            defaultProps: {
                arrow: true
            }
        },
        MuiBadge: {
            styleOverrides: {
                badge: ({ ownerState: ownerState })=>{
                    const base = {
                        fontWeight: "500"
                    };
                    if (ownerState.color == "primary") return Object.assign(Object.assign({}, base), {
                        backgroundColor: $27b73a2549e93235$var$palette.brand.blue.main,
                        color: $27b73a2549e93235$var$palette.brand.blue.contrastText
                    });
                    if (ownerState.color == "secondary") return Object.assign(Object.assign({}, base), {
                        // Default secondary color is transparent, which doesn't work for badges
                        // (you can barely see it). Use an opaque grey instead.
                        backgroundColor: "grey",
                        color: "white"
                    });
                    return base;
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: "4px",
                    fontWeight: 400,
                    fontSize: $27b73a2549e93235$var$decodableBits.tags.chip.fontSize
                },
                colorSecondary: ({ theme: theme })=>({
                        backgroundColor: theme.palette.grey[200],
                        color: theme.palette.grey[900]
                    }),
                deleteIcon: (props)=>{
                    if (props.ownerState.color === "secondary") return {
                        color: props.theme.palette.grey[400],
                        ":hover": {
                            color: $27b73a2549e93235$var$palette.common.black
                        }
                    };
                }
            }
        },
        MuiSlider: {
            styleOverrides: {
                track: {
                    color: "var(--de-color-blue)"
                },
                thumb: {
                    color: "var(--de-color-blue)"
                },
                mark: {
                    color: "white"
                }
            }
        }
    }
};
const $27b73a2549e93235$var$lightTheme = (0, $k7Clf.default)($27b73a2549e93235$var$decodableThemeOptions);
module.exports.default = $27b73a2549e93235$var$lightTheme;

});



parcelRegister("lavfF", function(module, exports) {

$parcel$export(module.exports, "route", () => $3887e33fd22198a1$export$4cb887bfde2d34ca);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $5YTEB = parcelRequire("5YTEB");

var $5BnXn = parcelRequire("5BnXn");

var $fmfg5 = parcelRequire("fmfg5");

const $3887e33fd22198a1$var$LazyAccessNav = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("k3nD8")));

const $3887e33fd22198a1$var$LazyGroupDetailsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("ZfB0f")));

const $3887e33fd22198a1$var$LazyGroupListingPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("eOFP5")));

const $3887e33fd22198a1$var$LazyRoleDetailsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("9MUcM")));

const $3887e33fd22198a1$var$LazyRoleListingPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("dnhWp")));

const $3887e33fd22198a1$var$LazyUserDetailsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("87ZI0")));

const $3887e33fd22198a1$var$LazyUserListingPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("4Jhys")));
function $3887e33fd22198a1$export$e84a48020d970d05({ useMocks: useMocks }) {
    let ApiProvider;
    ApiProvider = (0, $fmfg5.AccessApiProvider);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)(ApiProvider, {
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5BnXn.TopNav), {
                component: $3887e33fd22198a1$var$LazyAccessNav
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Outlet), {})
        ]
    });
}
function $3887e33fd22198a1$export$9267e3c26c007dbc({ useMocks: useMocks = false } = {}) {
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $5YTEB.Route), {
        path: "access",
        element: /*#__PURE__*/ (0, $2T9xh.jsx)($3887e33fd22198a1$export$e84a48020d970d05, {
            useMocks: useMocks
        }),
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                path: "groups",
                element: /*#__PURE__*/ (0, $2T9xh.jsx)($3887e33fd22198a1$var$LazyGroupListingPage, {})
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                path: "groups/:id",
                element: /*#__PURE__*/ (0, $2T9xh.jsx)($3887e33fd22198a1$var$LazyGroupDetailsPage, {})
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                path: "users",
                element: /*#__PURE__*/ (0, $2T9xh.jsx)($3887e33fd22198a1$var$LazyUserListingPage, {})
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                path: "users/:id",
                element: /*#__PURE__*/ (0, $2T9xh.jsx)($3887e33fd22198a1$var$LazyUserDetailsPage, {})
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                path: "roles",
                element: /*#__PURE__*/ (0, $2T9xh.jsx)($3887e33fd22198a1$var$LazyRoleListingPage, {})
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                path: "roles/:id",
                element: /*#__PURE__*/ (0, $2T9xh.jsx)($3887e33fd22198a1$var$LazyRoleDetailsPage, {})
            })
        ]
    });
}
const $3887e33fd22198a1$export$4cb887bfde2d34ca = $3887e33fd22198a1$export$9267e3c26c007dbc();

});
parcelRegister("5BnXn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9495a7d2d6a7ded$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useShell", () => $c9495a7d2d6a7ded$export$cf1c14293b2fca1b);
$parcel$export(module.exports, "TopNav", () => $c9495a7d2d6a7ded$export$41d0d88a6b0e456f);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $7WKzO = parcelRequire("7WKzO");
parcelRequire("4UEYn");
var $4t5s9 = parcelRequire("4t5s9");

var $5YTEB = parcelRequire("5YTEB");

var $jyGS9 = parcelRequire("jyGS9");

var $3ax2v = parcelRequire("3ax2v");

var $iviOa = parcelRequire("iviOa");

var $cigwJ = parcelRequire("cigwJ");

var $sdOpr = parcelRequire("sdOpr");

var $iuWnt = parcelRequire("iuWnt");

var $bMDHv = parcelRequire("bMDHv");

var $8iH6y = parcelRequire("8iH6y");
var $c9495a7d2d6a7ded$export$2e2bcd8739ae039 = $c9495a7d2d6a7ded$export$794614fa392eb573;
function $c9495a7d2d6a7ded$export$794614fa392eb573() {
    const isFetching = (0, $4t5s9.useIsFetching)();
    const [state, dispatch] = $c9495a7d2d6a7ded$var$useShellReducer();
    const { state: shellState } = (0, $iviOa.useGuide)() ?? {};
    return /*#__PURE__*/ (0, $2T9xh.jsx)($c9495a7d2d6a7ded$var$ShellContextProvider, {
        state: state,
        dispatch: dispatch,
        children: /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
            sx: {
                display: "grid",
                height: "100vh",
                gridTemplateAreas: `
          "alert alert  alert"
          "left  topbar guide"
          "left  body   guide"
        `,
                gridTemplateColumns: "auto 1fr auto",
                gridTemplateRows: "auto auto 1fr"
            },
            children: [
                /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                    ref: state.modalContainer,
                    sx: {
                        position: "relative",
                        gridRowStart: "topbar",
                        gridRowEnd: "body",
                        gridColumnStart: "body",
                        gridColumnEnd: "body",
                        overflow: "hidden",
                        pointerEvents: "none"
                    }
                }),
                /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                    sx: {
                        gridArea: "alert"
                    },
                    children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $iuWnt.ScheduledAlerts), {})
                }),
                /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                    sx: {
                        gridArea: "topbar"
                    },
                    children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8iH6y.default), {
                        disableLogo: true,
                        isLoading: isFetching > 0,
                        renderNav: state.TopNav ? ()=>/*#__PURE__*/ (0, $2T9xh.jsx)(state.TopNav, {}) : null
                    })
                }),
                /*#__PURE__*/ (0, $2T9xh.jsx)((0, $bMDHv.SideNav), {
                    sx: {
                        gridArea: "left",
                        placeSelf: "stretch"
                    }
                }),
                /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                    sx: {
                        gridArea: "body",
                        overflow: "auto"
                    },
                    children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $7WKzO.ErrorBoundary), {
                        FallbackComponent: (0, $cigwJ.ErrorBoundaryFallback),
                        children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).Suspense, {
                            fallback: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $sdOpr.LazyLoadingFallback), {}),
                            children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Outlet), {})
                        })
                    })
                }),
                shellState?.activeGuide && /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                    sx: {
                        gridArea: "guide",
                        position: "sticky",
                        top: 0,
                        overflowY: "auto",
                        overflowX: "hidden",
                        bgcolor: "background.paper",
                        borderLeft: "solid 1px rgb(90% 90% 90%)"
                    },
                    children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $3ax2v.Guide), {
                        useCase: shellState?.activeGuide,
                        sx: {
                            width: "clamp(58ch, 28vw, 120ch)"
                        }
                    })
                })
            ]
        })
    });
}
const $c9495a7d2d6a7ded$export$168f9136804a4de9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createContext({
    state: {
        modalContainer: {
            current: document?.body
        }
    },
    dispatch () {
        console.warn("No provider setup for ShellContext");
    }
});
function $c9495a7d2d6a7ded$var$ShellContextProvider(props) {
    return /*#__PURE__*/ (0, $2T9xh.jsx)($c9495a7d2d6a7ded$export$168f9136804a4de9.Provider, {
        value: {
            state: props.state,
            dispatch: props.dispatch
        },
        children: props.children
    });
}
function $c9495a7d2d6a7ded$var$useShellReducer() {
    const modalContainer = (0, $aOzEm.useRef)(null);
    return (0, $aOzEm.useReducer)((state, action)=>{
        const type = action.type;
        switch(type){
            case "set_top_nav":
                if (state.TopNav) console.warn(// In practice, one simply clobbers the other.
                "Multiple top nav elements set. This is unsupported, and the behavior is undefined.");
                return {
                    ...state,
                    TopNav: action.component
                };
            case "clear_top_nav":
                return {
                    ...state,
                    TopNav: null
                };
            default:
                let unhandled = type;
                throw new Error(`Unhandled action: ${unhandled}`);
        }
    }, {
        TopNav: null,
        modalContainer: modalContainer
    });
}
function $c9495a7d2d6a7ded$export$cf1c14293b2fca1b() {
    return (0, $aOzEm.useContext)($c9495a7d2d6a7ded$export$168f9136804a4de9);
}
function $c9495a7d2d6a7ded$export$41d0d88a6b0e456f({ component: component }) {
    const shell = $c9495a7d2d6a7ded$export$cf1c14293b2fca1b();
    (0, $aOzEm.useEffect)(()=>{
        shell.dispatch({
            type: "set_top_nav",
            component: component
        });
        return ()=>shell.dispatch({
                type: "clear_top_nav"
            });
    }, [
        component
    ]);
    return null;
}

});
parcelRegister("4UEYn", function(module, exports) {
$parcel$export(module.exports, "MutationCache", () => (parcelRequire("l1slT")).MutationCache);
$parcel$export(module.exports, "QueryClient", () => (parcelRequire("k71hw")).QueryClient);
$parcel$export(module.exports, "QueryClientProvider", () => (parcelRequire("dRtsf")).QueryClientProvider);
$parcel$export(module.exports, "useIsFetching", () => (parcelRequire("4t5s9")).useIsFetching);
$parcel$export(module.exports, "useMutation", () => (parcelRequire("lKmTf")).useMutation);
$parcel$export(module.exports, "useQuery", () => (parcelRequire("ipyAV")).useQuery);
$parcel$export(module.exports, "useQueryClient", () => (parcelRequire("dRtsf")).useQueryClient);
parcelRequire("l1slT");parcelRequire("k71hw");
parcelRequire("aR1zK");

});
parcelRegister("l1slT", function(module, exports) {

$parcel$export(module.exports, "MutationCache", () => $f4dfaf1f3935c12b$export$1fcfd9a244434844);

var $7rgHR = parcelRequire("7rgHR");

var $iISSM = parcelRequire("iISSM");

var $g6Wac = parcelRequire("g6Wac");

var $9pMTd = parcelRequire("9pMTd");

var $76ORa = parcelRequire("76ORa");
var $f4dfaf1f3935c12b$export$1fcfd9a244434844 = /*#__PURE__*/ function(_Subscribable) {
    (0, $7rgHR.default)(MutationCache, _Subscribable);
    function MutationCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.mutations = [];
        _this.mutationId = 0;
        return _this;
    }
    var _proto = MutationCache.prototype;
    _proto.build = function build(client, options, state) {
        var mutation = new (0, $g6Wac.Mutation)({
            mutationCache: this,
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    };
    _proto.add = function add(mutation) {
        this.mutations.push(mutation);
        this.notify(mutation);
    };
    _proto.remove = function remove(mutation) {
        this.mutations = this.mutations.filter(function(x) {
            return x !== mutation;
        });
        mutation.cancel();
        this.notify(mutation);
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $iISSM.notifyManager).batch(function() {
            _this2.mutations.forEach(function(mutation) {
                _this2.remove(mutation);
            });
        });
    };
    _proto.getAll = function getAll() {
        return this.mutations;
    };
    _proto.find = function find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find(function(mutation) {
            return (0, $9pMTd.matchMutation)(filters, mutation);
        });
    };
    _proto.findAll = function findAll(filters) {
        return this.mutations.filter(function(mutation) {
            return (0, $9pMTd.matchMutation)(filters, mutation);
        });
    };
    _proto.notify = function notify(mutation) {
        var _this3 = this;
        (0, $iISSM.notifyManager).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(mutation);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        this.resumePausedMutations();
    };
    _proto.onOnline = function onOnline() {
        this.resumePausedMutations();
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        var pausedMutations = this.mutations.filter(function(x) {
            return x.state.isPaused;
        });
        return (0, $iISSM.notifyManager).batch(function() {
            return pausedMutations.reduce(function(promise, mutation) {
                return promise.then(function() {
                    return mutation.continue().catch((0, $9pMTd.noop));
                });
            }, Promise.resolve());
        });
    };
    return MutationCache;
}((0, $76ORa.Subscribable));

});
parcelRegister("7rgHR", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a8038fb918e538$export$2e2bcd8739ae039);

var $3jXGt = parcelRequire("3jXGt");
function $56a8038fb918e538$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $3jXGt.default)(subClass, superClass);
}

});
parcelRegister("3jXGt", function(module, exports) {

$parcel$export(module.exports, "default", () => $26b17179657ba510$export$2e2bcd8739ae039);
function $26b17179657ba510$export$2e2bcd8739ae039(o, p) {
    $26b17179657ba510$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $26b17179657ba510$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("iISSM", function(module, exports) {

$parcel$export(module.exports, "notifyManager", () => $da16e89a10fac8d9$export$520687f44db6e1ab);

var $9pMTd = parcelRequire("9pMTd");
var $da16e89a10fac8d9$export$c3ab47f7c70c8aa4 = /*#__PURE__*/ function() {
    function NotifyManager() {
        this.queue = [];
        this.transactions = 0;
        this.notifyFn = function(callback) {
            callback();
        };
        this.batchNotifyFn = function(callback) {
            callback();
        };
    }
    var _proto = NotifyManager.prototype;
    _proto.batch = function batch(callback) {
        var result;
        this.transactions++;
        try {
            result = callback();
        } finally{
            this.transactions--;
            if (!this.transactions) this.flush();
        }
        return result;
    };
    _proto.schedule = function schedule(callback) {
        var _this = this;
        if (this.transactions) this.queue.push(callback);
        else (0, $9pMTd.scheduleMicrotask)(function() {
            _this.notifyFn(callback);
        });
    } /**
   * All calls to the wrapped function will be batched.
   */ ;
    _proto.batchCalls = function batchCalls(callback) {
        var _this2 = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this2.schedule(function() {
                callback.apply(void 0, args);
            });
        };
    };
    _proto.flush = function flush() {
        var _this3 = this;
        var queue = this.queue;
        this.queue = [];
        if (queue.length) (0, $9pMTd.scheduleMicrotask)(function() {
            _this3.batchNotifyFn(function() {
                queue.forEach(function(callback) {
                    _this3.notifyFn(callback);
                });
            });
        });
    } /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ ;
    _proto.setNotifyFunction = function setNotifyFunction(fn) {
        this.notifyFn = fn;
    } /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ ;
    _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
        this.batchNotifyFn = fn;
    };
    return NotifyManager;
}(); // SINGLETON
var $da16e89a10fac8d9$export$520687f44db6e1ab = new $da16e89a10fac8d9$export$c3ab47f7c70c8aa4();

});
parcelRegister("9pMTd", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $6dac5f4b4c77b5b8$export$6acf61af03e62db);
$parcel$export(module.exports, "noop", () => $6dac5f4b4c77b5b8$export$8793edee2d425525);
$parcel$export(module.exports, "functionalUpdate", () => $6dac5f4b4c77b5b8$export$7f095f455ad5af3f);
$parcel$export(module.exports, "isValidTimeout", () => $6dac5f4b4c77b5b8$export$e539f754e934e270);
$parcel$export(module.exports, "ensureQueryKeyArray", () => $6dac5f4b4c77b5b8$export$4d32d63f64b825b9);
$parcel$export(module.exports, "timeUntilStale", () => $6dac5f4b4c77b5b8$export$811b83d62bcf47f0);
$parcel$export(module.exports, "parseQueryArgs", () => $6dac5f4b4c77b5b8$export$8a11fbc2c8ea08fd);
$parcel$export(module.exports, "parseMutationArgs", () => $6dac5f4b4c77b5b8$export$b646c531ea475334);
$parcel$export(module.exports, "parseFilterArgs", () => $6dac5f4b4c77b5b8$export$18e8f4b987e6c111);
$parcel$export(module.exports, "matchQuery", () => $6dac5f4b4c77b5b8$export$c5d1efe363797780);
$parcel$export(module.exports, "hashQueryKeyByOptions", () => $6dac5f4b4c77b5b8$export$cc90ca97bc0d73fd);
$parcel$export(module.exports, "partialMatchKey", () => $6dac5f4b4c77b5b8$export$2f07189bb9fa26a7);
$parcel$export(module.exports, "matchMutation", () => $6dac5f4b4c77b5b8$export$a1ea5fb559f63ae3);
$parcel$export(module.exports, "hashQueryKey", () => $6dac5f4b4c77b5b8$export$5fcb678681417b54);
$parcel$export(module.exports, "replaceEqualDeep", () => $6dac5f4b4c77b5b8$export$77a71fc411098696);
$parcel$export(module.exports, "shallowEqualObjects", () => $6dac5f4b4c77b5b8$export$3e67810a3f0e9f1c);
$parcel$export(module.exports, "sleep", () => $6dac5f4b4c77b5b8$export$e772c8ff12451969);
$parcel$export(module.exports, "scheduleMicrotask", () => $6dac5f4b4c77b5b8$export$4304cb76768ca134);
$parcel$export(module.exports, "getAbortController", () => $6dac5f4b4c77b5b8$export$382ca5d13a8f252c);

var $g6Hsb = parcelRequire("g6Hsb");
var $6dac5f4b4c77b5b8$export$6acf61af03e62db = typeof window === "undefined";
function $6dac5f4b4c77b5b8$export$8793edee2d425525() {
    return undefined;
}
function $6dac5f4b4c77b5b8$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $6dac5f4b4c77b5b8$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $6dac5f4b4c77b5b8$export$4d32d63f64b825b9(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $6dac5f4b4c77b5b8$export$acaf96a27438246b(array1, array2) {
    return array1.filter(function(x) {
        return array2.indexOf(x) === -1;
    });
}
function $6dac5f4b4c77b5b8$export$224e3b7078227b8a(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $6dac5f4b4c77b5b8$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $6dac5f4b4c77b5b8$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$6dac5f4b4c77b5b8$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return (0, $g6Hsb.default)({}, arg3, {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $g6Hsb.default)({}, arg2, {
        queryKey: arg1
    });
}
function $6dac5f4b4c77b5b8$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($6dac5f4b4c77b5b8$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return (0, $g6Hsb.default)({}, arg3, {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $g6Hsb.default)({}, arg2, {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === "function") return (0, $g6Hsb.default)({}, arg2, {
        mutationFn: arg1
    });
    return (0, $g6Hsb.default)({}, arg1);
}
function $6dac5f4b4c77b5b8$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $6dac5f4b4c77b5b8$export$aaae5295ec3351c9(arg1) ? [
        (0, $g6Hsb.default)({}, arg2, {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $6dac5f4b4c77b5b8$export$42387eeaac09cf54(arg1, arg2) {
    return $6dac5f4b4c77b5b8$export$aaae5295ec3351c9(arg1) ? (0, $g6Hsb.default)({}, arg2, {
        mutationKey: arg1
    }) : arg1;
}
function $6dac5f4b4c77b5b8$export$eafbe052e989494f(active, inactive) {
    if (active === true && inactive === true || active == null && inactive == null) return "all";
    else if (active === false && inactive === false) return "none";
    else {
        // At this point, active|inactive can only be true|false or false|true
        // so, when only one value is provided, the missing one has to be the negated value
        var isActive = active != null ? active : !inactive;
        return isActive ? "active" : "inactive";
    }
}
function $6dac5f4b4c77b5b8$export$c5d1efe363797780(filters, query) {
    var active = filters.active, exact = filters.exact, fetching = filters.fetching, inactive = filters.inactive, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if ($6dac5f4b4c77b5b8$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $6dac5f4b4c77b5b8$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$6dac5f4b4c77b5b8$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    var queryStatusFilter = $6dac5f4b4c77b5b8$export$eafbe052e989494f(active, inactive);
    if (queryStatusFilter === "none") return false;
    else if (queryStatusFilter !== "all") {
        var isActive = query.isActive();
        if (queryStatusFilter === "active" && !isActive) return false;
        if (queryStatusFilter === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetching === "boolean" && query.isFetching() !== fetching) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $6dac5f4b4c77b5b8$export$a1ea5fb559f63ae3(filters, mutation) {
    var exact = filters.exact, fetching = filters.fetching, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if ($6dac5f4b4c77b5b8$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($6dac5f4b4c77b5b8$export$5fcb678681417b54(mutation.options.mutationKey) !== $6dac5f4b4c77b5b8$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$6dac5f4b4c77b5b8$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $6dac5f4b4c77b5b8$export$cc90ca97bc0d73fd(queryKey, options) {
    var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $6dac5f4b4c77b5b8$export$5fcb678681417b54;
    return hashFn(queryKey);
}
function $6dac5f4b4c77b5b8$export$5fcb678681417b54(queryKey) {
    var asArray = $6dac5f4b4c77b5b8$export$4d32d63f64b825b9(queryKey);
    return $6dac5f4b4c77b5b8$export$e7f2f041280beb00(asArray);
}
function $6dac5f4b4c77b5b8$export$e7f2f041280beb00(value) {
    return JSON.stringify(value, function(_, val) {
        return $6dac5f4b4c77b5b8$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function $6dac5f4b4c77b5b8$export$2f07189bb9fa26a7(a, b) {
    return $6dac5f4b4c77b5b8$export$3bc9138b70293839($6dac5f4b4c77b5b8$export$4d32d63f64b825b9(a), $6dac5f4b4c77b5b8$export$4d32d63f64b825b9(b));
}
function $6dac5f4b4c77b5b8$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some(function(key) {
        return !$6dac5f4b4c77b5b8$export$3bc9138b70293839(a[key], b[key]);
    });
    return false;
}
function $6dac5f4b4c77b5b8$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    var array = Array.isArray(a) && Array.isArray(b);
    if (array || $6dac5f4b4c77b5b8$export$53b83ca8eaab0383(a) && $6dac5f4b4c77b5b8$export$53b83ca8eaab0383(b)) {
        var aSize = array ? a.length : Object.keys(a).length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = $6dac5f4b4c77b5b8$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $6dac5f4b4c77b5b8$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $6dac5f4b4c77b5b8$export$53b83ca8eaab0383(o) {
    if (!$6dac5f4b4c77b5b8$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!$6dac5f4b4c77b5b8$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $6dac5f4b4c77b5b8$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $6dac5f4b4c77b5b8$export$aaae5295ec3351c9(value) {
    return typeof value === "string" || Array.isArray(value);
}
function $6dac5f4b4c77b5b8$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $6dac5f4b4c77b5b8$export$e772c8ff12451969(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $6dac5f4b4c77b5b8$export$4304cb76768ca134(callback) {
    Promise.resolve().then(callback).catch(function(error) {
        return setTimeout(function() {
            throw error;
        });
    });
}
function $6dac5f4b4c77b5b8$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
}

});


parcelRegister("g6Wac", function(module, exports) {

$parcel$export(module.exports, "Mutation", () => $bbaa52f745b437a3$export$17b8b19c814bcf56);
$parcel$export(module.exports, "getDefaultState", () => $bbaa52f745b437a3$export$a1659b54bac3252a);

var $g6Hsb = parcelRequire("g6Hsb");

var $lta08 = parcelRequire("lta08");

var $iISSM = parcelRequire("iISSM");

var $nNKt4 = parcelRequire("nNKt4");

var $9pMTd = parcelRequire("9pMTd");
var $bbaa52f745b437a3$export$17b8b19c814bcf56 = /*#__PURE__*/ function() {
    function Mutation(config) {
        this.options = (0, $g6Hsb.default)({}, config.defaultOptions, config.options);
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.observers = [];
        this.state = config.state || $bbaa52f745b437a3$export$a1659b54bac3252a();
        this.meta = config.meta;
    }
    var _proto = Mutation.prototype;
    _proto.setState = function setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) this.observers.push(observer);
    };
    _proto.removeObserver = function removeObserver(observer) {
        this.observers = this.observers.filter(function(x) {
            return x !== observer;
        });
    };
    _proto.cancel = function cancel() {
        if (this.retryer) {
            this.retryer.cancel();
            return this.retryer.promise.then((0, $9pMTd.noop)).catch((0, $9pMTd.noop));
        }
        return Promise.resolve();
    };
    _proto.continue = function _continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    };
    _proto.execute = function execute() {
        var _this = this;
        var data;
        var restored = this.state.status === "loading";
        var promise = Promise.resolve();
        if (!restored) {
            this.dispatch({
                type: "loading",
                variables: this.options.variables
            });
            promise = promise.then(function() {
                // Notify cache callback
                _this.mutationCache.config.onMutate == null || _this.mutationCache.config.onMutate(_this.state.variables, _this);
            }).then(function() {
                return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
            }).then(function(context) {
                if (context !== _this.state.context) _this.dispatch({
                    type: "loading",
                    context: context,
                    variables: _this.state.variables
                });
            });
        }
        return promise.then(function() {
            return _this.executeMutation();
        }).then(function(result) {
            data = result; // Notify cache callback
            _this.mutationCache.config.onSuccess == null || _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
        }).then(function() {
            return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
        }).then(function() {
            return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
        }).then(function() {
            _this.dispatch({
                type: "success",
                data: data
            });
            return data;
        }).catch(function(error) {
            // Notify cache callback
            _this.mutationCache.config.onError == null || _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
            (0, $lta08.getLogger)().error(error);
            return Promise.resolve().then(function() {
                return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
            }).then(function() {
                return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
            }).then(function() {
                _this.dispatch({
                    type: "error",
                    error: error
                });
                throw error;
            });
        });
    };
    _proto.executeMutation = function executeMutation() {
        var _this2 = this, _this$options$retry;
        this.retryer = new (0, $nNKt4.Retryer)({
            fn: function fn() {
                if (!_this2.options.mutationFn) return Promise.reject("No mutationFn found");
                return _this2.options.mutationFn(_this2.state.variables);
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: "failed"
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: "pause"
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: "continue"
                });
            },
            retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
            retryDelay: this.options.retryDelay
        });
        return this.retryer.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = $bbaa52f745b437a3$var$reducer(this.state, action);
        (0, $iISSM.notifyManager).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onMutationUpdate(action);
            });
            _this3.mutationCache.notify(_this3);
        });
    };
    return Mutation;
}();
function $bbaa52f745b437a3$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}
function $bbaa52f745b437a3$var$reducer(state, action) {
    switch(action.type){
        case "failed":
            return (0, $g6Hsb.default)({}, state, {
                failureCount: state.failureCount + 1
            });
        case "pause":
            return (0, $g6Hsb.default)({}, state, {
                isPaused: true
            });
        case "continue":
            return (0, $g6Hsb.default)({}, state, {
                isPaused: false
            });
        case "loading":
            return (0, $g6Hsb.default)({}, state, {
                context: action.context,
                data: undefined,
                error: null,
                isPaused: false,
                status: "loading",
                variables: action.variables
            });
        case "success":
            return (0, $g6Hsb.default)({}, state, {
                data: action.data,
                error: null,
                status: "success",
                isPaused: false
            });
        case "error":
            return (0, $g6Hsb.default)({}, state, {
                data: undefined,
                error: action.error,
                failureCount: state.failureCount + 1,
                isPaused: false,
                status: "error"
            });
        case "setState":
            return (0, $g6Hsb.default)({}, state, action.state);
        default:
            return state;
    }
}

});
parcelRegister("lta08", function(module, exports) {

$parcel$export(module.exports, "getLogger", () => $fa141072a0a18572$export$2b1d391cd05230fd);
$parcel$export(module.exports, "setLogger", () => $fa141072a0a18572$export$3abbd92f765bee58);
// TYPES
// FUNCTIONS
var $fa141072a0a18572$var$logger = console;
function $fa141072a0a18572$export$2b1d391cd05230fd() {
    return $fa141072a0a18572$var$logger;
}
function $fa141072a0a18572$export$3abbd92f765bee58(newLogger) {
    $fa141072a0a18572$var$logger = newLogger;
}

});

parcelRegister("nNKt4", function(module, exports) {

$parcel$export(module.exports, "isCancelable", () => $0478bd1be7ecd7cd$export$22e08d49843051be);
$parcel$export(module.exports, "isCancelledError", () => $0478bd1be7ecd7cd$export$986cc6445c1d323);
$parcel$export(module.exports, "Retryer", () => $0478bd1be7ecd7cd$export$586a619a4618a582);

var $9mNYT = parcelRequire("9mNYT");

var $40FMQ = parcelRequire("40FMQ");

var $9pMTd = parcelRequire("9pMTd");
function $0478bd1be7ecd7cd$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function $0478bd1be7ecd7cd$export$22e08d49843051be(value) {
    return typeof (value == null ? void 0 : value.cancel) === "function";
}
var $0478bd1be7ecd7cd$export$a8430ed4188f35a9 = function CancelledError(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
};
function $0478bd1be7ecd7cd$export$986cc6445c1d323(value) {
    return value instanceof $0478bd1be7ecd7cd$export$a8430ed4188f35a9;
} // CLASS
var $0478bd1be7ecd7cd$export$586a619a4618a582 = function Retryer(config) {
    var _this = this;
    var cancelRetry = false;
    var cancelFn;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    this.abort = config.abort;
    this.cancel = function(cancelOptions) {
        return cancelFn == null ? void 0 : cancelFn(cancelOptions);
    };
    this.cancelRetry = function() {
        cancelRetry = true;
    };
    this.continueRetry = function() {
        cancelRetry = false;
    };
    this.continue = function() {
        return continueFn == null ? void 0 : continueFn();
    };
    this.failureCount = 0;
    this.isPaused = false;
    this.isResolved = false;
    this.isTransportCancelable = false;
    this.promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var resolve = function resolve(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    var reject = function reject(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    var pause = function pause() {
        return new Promise(function(continueResolve) {
            continueFn = continueResolve;
            _this.isPaused = true;
            config.onPause == null || config.onPause();
        }).then(function() {
            continueFn = undefined;
            _this.isPaused = false;
            config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    var run = function run() {
        // Do nothing if already resolved
        if (_this.isResolved) return;
        var promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        } // Create callback to cancel this fetch
        cancelFn = function cancelFn(cancelOptions) {
            if (!_this.isResolved) {
                reject(new $0478bd1be7ecd7cd$export$a8430ed4188f35a9(cancelOptions));
                _this.abort == null || _this.abort(); // Cancel transport if supported
                if ($0478bd1be7ecd7cd$export$22e08d49843051be(promiseOrValue)) try {
                    promiseOrValue.cancel();
                } catch (_unused) {}
            }
        }; // Check if the transport layer support cancellation
        _this.isTransportCancelable = $0478bd1be7ecd7cd$export$22e08d49843051be(promiseOrValue);
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (_this.isResolved) return;
             // Do we need to retry the request?
            var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $0478bd1be7ecd7cd$var$defaultRetryDelay;
            var delay = typeof retryDelay === "function" ? retryDelay(_this.failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === "number" && _this.failureCount < retry || typeof retry === "function" && retry(_this.failureCount, error);
            if (cancelRetry || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            _this.failureCount++; // Notify on fail
            config.onFail == null || config.onFail(_this.failureCount, error); // Delay
            (0, $9pMTd.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(function() {
                if (!(0, $9mNYT.focusManager).isFocused() || !(0, $40FMQ.onlineManager).isOnline()) return pause();
            }).then(function() {
                if (cancelRetry) reject(error);
                else run();
            });
        });
    }; // Start loop
    run();
};

});
parcelRegister("9mNYT", function(module, exports) {

$parcel$export(module.exports, "focusManager", () => $6d1cf056b4a2d6f5$export$6bf54661be5b02cf);

var $7rgHR = parcelRequire("7rgHR");

var $76ORa = parcelRequire("76ORa");

var $9pMTd = parcelRequire("9pMTd");
var $6d1cf056b4a2d6f5$export$86f1af424b2ca4de = /*#__PURE__*/ function(_Subscribable) {
    (0, $7rgHR.default)(FocusManager, _Subscribable);
    function FocusManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onFocus) {
            var _window;
            if (!(0, $9pMTd.isServer) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onFocus();
                }; // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
        };
        return _this;
    }
    var _proto = FocusManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(focused) {
            if (typeof focused === "boolean") _this2.setFocused(focused);
            else _this2.onFocus();
        });
    };
    _proto.setFocused = function setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    };
    _proto.onFocus = function onFocus() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isFocused = function isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    };
    return FocusManager;
}((0, $76ORa.Subscribable));
var $6d1cf056b4a2d6f5$export$6bf54661be5b02cf = new $6d1cf056b4a2d6f5$export$86f1af424b2ca4de();

});
parcelRegister("76ORa", function(module, exports) {

$parcel$export(module.exports, "Subscribable", () => $52d08af7e87c35d7$export$d26086b469ecdbcc);
var $52d08af7e87c35d7$export$d26086b469ecdbcc = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        var callback = listener || function() {
            return undefined;
        };
        this.listeners.push(callback);
        this.onSubscribe();
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== callback;
            });
            _this.onUnsubscribe();
        };
    };
    _proto.hasListeners = function hasListeners() {
        return this.listeners.length > 0;
    };
    _proto.onSubscribe = function onSubscribe() {};
    _proto.onUnsubscribe = function onUnsubscribe() {};
    return Subscribable;
}();

});


parcelRegister("40FMQ", function(module, exports) {

$parcel$export(module.exports, "onlineManager", () => $2eb79382ea51a42f$export$b113e788b2dd3fdc);

var $7rgHR = parcelRequire("7rgHR");

var $76ORa = parcelRequire("76ORa");

var $9pMTd = parcelRequire("9pMTd");
var $2eb79382ea51a42f$export$58774fb55d5ff7fc = /*#__PURE__*/ function(_Subscribable) {
    (0, $7rgHR.default)(OnlineManager, _Subscribable);
    function OnlineManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onOnline) {
            var _window;
            if (!(0, $9pMTd.isServer) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onOnline();
                }; // Listen to online
                window.addEventListener("online", listener, false);
                window.addEventListener("offline", listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("online", listener);
                    window.removeEventListener("offline", listener);
                };
            }
        };
        return _this;
    }
    var _proto = OnlineManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(online) {
            if (typeof online === "boolean") _this2.setOnline(online);
            else _this2.onOnline();
        });
    };
    _proto.setOnline = function setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    };
    _proto.onOnline = function onOnline() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isOnline = function isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    };
    return OnlineManager;
}((0, $76ORa.Subscribable));
var $2eb79382ea51a42f$export$b113e788b2dd3fdc = new $2eb79382ea51a42f$export$58774fb55d5ff7fc();

});




parcelRegister("k71hw", function(module, exports) {

$parcel$export(module.exports, "QueryClient", () => $ea45749362442c87$export$405d0624ed55a03f);

var $g6Hsb = parcelRequire("g6Hsb");

var $9pMTd = parcelRequire("9pMTd");

var $bOJGO = parcelRequire("bOJGO");

var $l1slT = parcelRequire("l1slT");

var $9mNYT = parcelRequire("9mNYT");

var $40FMQ = parcelRequire("40FMQ");

var $iISSM = parcelRequire("iISSM");

var $9aKmC = parcelRequire("9aKmC");
var $ea45749362442c87$export$405d0624ed55a03f = /*#__PURE__*/ function() {
    function QueryClient(config) {
        if (config === void 0) config = {};
        this.queryCache = config.queryCache || new (0, $bOJGO.QueryCache)();
        this.mutationCache = config.mutationCache || new (0, $l1slT.MutationCache)();
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    var _proto = QueryClient.prototype;
    _proto.mount = function mount() {
        var _this = this;
        this.unsubscribeFocus = (0, $9mNYT.focusManager).subscribe(function() {
            if ((0, $9mNYT.focusManager).isFocused() && (0, $40FMQ.onlineManager).isOnline()) {
                _this.mutationCache.onFocus();
                _this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $40FMQ.onlineManager).subscribe(function() {
            if ((0, $9mNYT.focusManager).isFocused() && (0, $40FMQ.onlineManager).isOnline()) {
                _this.mutationCache.onOnline();
                _this.queryCache.onOnline();
            }
        });
    };
    _proto.unmount = function unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    };
    _proto.isFetching = function isFetching(arg1, arg2) {
        var _parseFilterArgs = (0, $9pMTd.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs[0];
        filters.fetching = true;
        return this.queryCache.findAll(filters).length;
    };
    _proto.isMutating = function isMutating(filters) {
        return this.mutationCache.findAll((0, $g6Hsb.default)({}, filters, {
            fetching: true
        })).length;
    };
    _proto.getQueryData = function getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    };
    _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref) {
            var queryKey = _ref.queryKey, state = _ref.state;
            var data = state.data;
            return [
                queryKey,
                data
            ];
        });
    };
    _proto.setQueryData = function setQueryData(queryKey, updater, options) {
        var parsedOptions = (0, $9pMTd.parseQueryArgs)(queryKey);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(updater, options);
    };
    _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
        var _this2 = this;
        return (0, $iISSM.notifyManager).batch(function() {
            return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref2) {
                var queryKey = _ref2.queryKey;
                return [
                    queryKey,
                    _this2.setQueryData(queryKey, updater, options)
                ];
            });
        });
    };
    _proto.getQueryState = function getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    };
    _proto.removeQueries = function removeQueries(arg1, arg2) {
        var _parseFilterArgs2 = (0, $9pMTd.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs2[0];
        var queryCache = this.queryCache;
        (0, $iISSM.notifyManager).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                queryCache.remove(query);
            });
        });
    };
    _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
        var _this3 = this;
        var _parseFilterArgs3 = (0, $9pMTd.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs3[0], options = _parseFilterArgs3[1];
        var queryCache = this.queryCache;
        var refetchFilters = (0, $g6Hsb.default)({}, filters, {
            active: true
        });
        return (0, $iISSM.notifyManager).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                query.reset();
            });
            return _this3.refetchQueries(refetchFilters, options);
        });
    };
    _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
        var _this4 = this;
        var _parseFilterArgs4 = (0, $9pMTd.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs4[0], _parseFilterArgs4$ = _parseFilterArgs4[1], cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        var promises = (0, $iISSM.notifyManager).batch(function() {
            return _this4.queryCache.findAll(filters).map(function(query) {
                return query.cancel(cancelOptions);
            });
        });
        return Promise.all(promises).then((0, $9pMTd.noop)).catch((0, $9pMTd.noop));
    };
    _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
        var _ref3, _filters$refetchActiv, _filters$refetchInact, _this5 = this;
        var _parseFilterArgs5 = (0, $9pMTd.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs5[0], options = _parseFilterArgs5[1];
        var refetchFilters = (0, $g6Hsb.default)({}, filters, {
            // if filters.refetchActive is not provided and filters.active is explicitly false,
            // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
            active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
            inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
        });
        return (0, $iISSM.notifyManager).batch(function() {
            _this5.queryCache.findAll(filters).forEach(function(query) {
                query.invalidate();
            });
            return _this5.refetchQueries(refetchFilters, options);
        });
    };
    _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
        var _this6 = this;
        var _parseFilterArgs6 = (0, $9pMTd.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs6[0], options = _parseFilterArgs6[1];
        var promises = (0, $iISSM.notifyManager).batch(function() {
            return _this6.queryCache.findAll(filters).map(function(query) {
                return query.fetch(undefined, (0, $g6Hsb.default)({}, options, {
                    meta: {
                        refetchPage: filters == null ? void 0 : filters.refetchPage
                    }
                }));
            });
        });
        var promise = Promise.all(promises).then((0, $9pMTd.noop));
        if (!(options == null ? void 0 : options.throwOnError)) promise = promise.catch((0, $9pMTd.noop));
        return promise;
    };
    _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $9pMTd.parseQueryArgs)(arg1, arg2, arg3);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        var query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    };
    _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $9pMTd.noop)).catch((0, $9pMTd.noop));
    };
    _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $9pMTd.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $9aKmC.infiniteQueryBehavior)();
        return this.fetchQuery(parsedOptions);
    };
    _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $9pMTd.noop)).catch((0, $9pMTd.noop));
    };
    _proto.cancelMutations = function cancelMutations() {
        var _this7 = this;
        var promises = (0, $iISSM.notifyManager).batch(function() {
            return _this7.mutationCache.getAll().map(function(mutation) {
                return mutation.cancel();
            });
        });
        return Promise.all(promises).then((0, $9pMTd.noop)).catch((0, $9pMTd.noop));
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        return this.getMutationCache().resumePausedMutations();
    };
    _proto.executeMutation = function executeMutation(options) {
        return this.mutationCache.build(this, options).execute();
    };
    _proto.getQueryCache = function getQueryCache() {
        return this.queryCache;
    };
    _proto.getMutationCache = function getMutationCache() {
        return this.mutationCache;
    };
    _proto.getDefaultOptions = function getDefaultOptions() {
        return this.defaultOptions;
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
        var result = this.queryDefaults.find(function(x) {
            return (0, $9pMTd.hashQueryKey)(queryKey) === (0, $9pMTd.hashQueryKey)(x.queryKey);
        });
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    };
    _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
        var _this$queryDefaults$f;
        return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function(x) {
            return (0, $9pMTd.partialMatchKey)(queryKey, x.queryKey);
        })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
    };
    _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
        var result = this.mutationDefaults.find(function(x) {
            return (0, $9pMTd.hashQueryKey)(mutationKey) === (0, $9pMTd.hashQueryKey)(x.mutationKey);
        });
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    };
    _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
        var _this$mutationDefault;
        return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function(x) {
            return (0, $9pMTd.partialMatchKey)(mutationKey, x.mutationKey);
        })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
    };
    _proto.defaultQueryOptions = function defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        var defaultedOptions = (0, $g6Hsb.default)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $9pMTd.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        return defaultedOptions;
    };
    _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
        return this.defaultQueryOptions(options);
    };
    _proto.defaultMutationOptions = function defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return (0, $g6Hsb.default)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
            _defaulted: true
        });
    };
    _proto.clear = function clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    };
    return QueryClient;
}();

});
parcelRegister("bOJGO", function(module, exports) {

$parcel$export(module.exports, "QueryCache", () => $89a7ce2f28604a68$export$5dde0cd941da8468);

var $7rgHR = parcelRequire("7rgHR");

var $9pMTd = parcelRequire("9pMTd");

var $i434m = parcelRequire("i434m");

var $iISSM = parcelRequire("iISSM");

var $76ORa = parcelRequire("76ORa");
var $89a7ce2f28604a68$export$5dde0cd941da8468 = /*#__PURE__*/ function(_Subscribable) {
    (0, $7rgHR.default)(QueryCache, _Subscribable);
    function QueryCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.queries = [];
        _this.queriesMap = {};
        return _this;
    }
    var _proto = QueryCache.prototype;
    _proto.build = function build(client, options, state) {
        var _options$queryHash;
        var queryKey = options.queryKey;
        var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $9pMTd.hashQueryKeyByOptions)(queryKey, options);
        var query = this.get(queryHash);
        if (!query) {
            query = new (0, $i434m.Query)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    };
    _proto.add = function add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "queryAdded",
                query: query
            });
        }
    };
    _proto.remove = function remove(query) {
        var queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter(function(x) {
                return x !== query;
            });
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "queryRemoved",
                query: query
            });
        }
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $iISSM.notifyManager).batch(function() {
            _this2.queries.forEach(function(query) {
                _this2.remove(query);
            });
        });
    };
    _proto.get = function get(queryHash) {
        return this.queriesMap[queryHash];
    };
    _proto.getAll = function getAll() {
        return this.queries;
    };
    _proto.find = function find(arg1, arg2) {
        var _parseFilterArgs = (0, $9pMTd.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs[0];
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find(function(query) {
            return (0, $9pMTd.matchQuery)(filters, query);
        });
    };
    _proto.findAll = function findAll(arg1, arg2) {
        var _parseFilterArgs2 = (0, $9pMTd.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs2[0];
        return Object.keys(filters).length > 0 ? this.queries.filter(function(query) {
            return (0, $9pMTd.matchQuery)(filters, query);
        }) : this.queries;
    };
    _proto.notify = function notify(event) {
        var _this3 = this;
        (0, $iISSM.notifyManager).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(event);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        var _this4 = this;
        (0, $iISSM.notifyManager).batch(function() {
            _this4.queries.forEach(function(query) {
                query.onFocus();
            });
        });
    };
    _proto.onOnline = function onOnline() {
        var _this5 = this;
        (0, $iISSM.notifyManager).batch(function() {
            _this5.queries.forEach(function(query) {
                query.onOnline();
            });
        });
    };
    return QueryCache;
}((0, $76ORa.Subscribable));

});
parcelRegister("i434m", function(module, exports) {

$parcel$export(module.exports, "Query", () => $d26afb332758d6fb$export$62297b13309008b2);

var $g6Hsb = parcelRequire("g6Hsb");

var $9pMTd = parcelRequire("9pMTd");

var $iISSM = parcelRequire("iISSM");

var $lta08 = parcelRequire("lta08");

var $nNKt4 = parcelRequire("nNKt4");
var $d26afb332758d6fb$export$62297b13309008b2 = /*#__PURE__*/ function() {
    function Query(config) {
        this.abortSignalConsumed = false;
        this.hadObservers = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || this.getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
        this.scheduleGc();
    }
    var _proto = Query.prototype;
    _proto.setOptions = function setOptions(options) {
        var _this$options$cacheTi;
        this.options = (0, $g6Hsb.default)({}, this.defaultOptions, options);
        this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 300000);
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.scheduleGc = function scheduleGc() {
        var _this = this;
        this.clearGcTimeout();
        if ((0, $9pMTd.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(function() {
            _this.optionalRemove();
        }, this.cacheTime);
    };
    _proto.clearGcTimeout = function clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    };
    _proto.optionalRemove = function optionalRemove() {
        if (!this.observers.length) {
            if (this.state.isFetching) {
                if (this.hadObservers) this.scheduleGc();
            } else this.cache.remove(this);
        }
    };
    _proto.setData = function setData(updater, options) {
        var _this$options$isDataE, _this$options;
        var prevData = this.state.data; // Get the new data
        var data = (0, $9pMTd.functionalUpdate)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
        if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) data = prevData;
        else if (this.options.structuralSharing !== false) // Structurally share data between prev and new data if needed
        data = (0, $9pMTd.replaceEqualDeep)(prevData, data);
         // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt
        });
        return data;
    };
    _proto.setState = function setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    };
    _proto.cancel = function cancel(options) {
        var _this$retryer;
        var promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $9pMTd.noop)).catch((0, $9pMTd.noop)) : Promise.resolve();
    };
    _proto.destroy = function destroy() {
        this.clearGcTimeout();
        this.cancel({
            silent: true
        });
    };
    _proto.reset = function reset() {
        this.destroy();
        this.setState(this.initialState);
    };
    _proto.isActive = function isActive() {
        return this.observers.some(function(observer) {
            return observer.options.enabled !== false;
        });
    };
    _proto.isFetching = function isFetching() {
        return this.state.isFetching;
    };
    _proto.isStale = function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(observer) {
            return observer.getCurrentResult().isStale;
        });
    };
    _proto.isStaleByTime = function isStaleByTime(staleTime) {
        if (staleTime === void 0) staleTime = 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $9pMTd.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    };
    _proto.onFocus = function onFocus() {
        var _this$retryer2;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnWindowFocus();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    };
    _proto.onOnline = function onOnline() {
        var _this$retryer3;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnReconnect();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
            this.hadObservers = true; // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    };
    _proto.removeObserver = function removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter(function(x) {
                return x !== observer;
            });
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.retryer.isTransportCancelable || this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                if (this.cacheTime) this.scheduleGc();
                else this.cache.remove(this);
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    };
    _proto.getObserversCount = function getObserversCount() {
        return this.observers.length;
    };
    _proto.invalidate = function invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    };
    _proto.fetch = function fetch(options, fetchOptions) {
        var _this2 = this, _this$options$behavio, _context$fetchOptions, _abortController$abor;
        if (this.state.isFetching) {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            var observer = this.observers.find(function(x) {
                return x.options.queryFn;
            });
            if (observer) this.setOptions(observer.options);
        }
        var queryKey = (0, $9pMTd.ensureQueryKeyArray)(this.queryKey);
        var abortController = (0, $9pMTd.getAbortController)(); // Create query function context
        var queryFnContext = {
            queryKey: queryKey,
            pageParam: undefined,
            meta: this.meta
        };
        Object.defineProperty(queryFnContext, "signal", {
            enumerable: true,
            get: function get() {
                if (abortController) {
                    _this2.abortSignalConsumed = true;
                    return abortController.signal;
                }
                return undefined;
            }
        }); // Create fetch function
        var fetchFn = function fetchFn() {
            if (!_this2.options.queryFn) return Promise.reject("Missing queryFn");
            _this2.abortSignalConsumed = false;
            return _this2.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        var context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
            var _this$options$behavio2;
            (_this$options$behavio2 = this.options.behavior) == null || _this$options$behavio2.onFetch(context);
        } // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        } // Try to fetch the data
        this.retryer = new (0, $nNKt4.Retryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
            onSuccess: function onSuccess(data) {
                _this2.setData(data); // Notify cache callback
                _this2.cache.config.onSuccess == null || _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onError: function onError(error) {
                // Optimistically update state if needed
                if (!((0, $nNKt4.isCancelledError)(error) && error.silent)) _this2.dispatch({
                    type: "error",
                    error: error
                });
                if (!(0, $nNKt4.isCancelledError)(error)) {
                    // Notify cache callback
                    _this2.cache.config.onError == null || _this2.cache.config.onError(error, _this2); // Log error
                    (0, $lta08.getLogger)().error(error);
                } // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: "failed"
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: "pause"
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay
        });
        this.promise = this.retryer.promise;
        return this.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = this.reducer(this.state, action);
        (0, $iISSM.notifyManager).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onQueryUpdate(action);
            });
            _this3.cache.notify({
                query: _this3,
                type: "queryUpdated",
                action: action
            });
        });
    };
    _proto.getDefaultState = function getDefaultState(options) {
        var data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
        var hasInitialData = typeof options.initialData !== "undefined";
        var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
        var hasData = typeof data !== "undefined";
        return {
            data: data,
            dataUpdateCount: 0,
            dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
            error: null,
            errorUpdateCount: 0,
            errorUpdatedAt: 0,
            fetchFailureCount: 0,
            fetchMeta: null,
            isFetching: false,
            isInvalidated: false,
            isPaused: false,
            status: hasData ? "success" : "idle"
        };
    };
    _proto.reducer = function reducer(state, action) {
        var _action$meta, _action$dataUpdatedAt;
        switch(action.type){
            case "failed":
                return (0, $g6Hsb.default)({}, state, {
                    fetchFailureCount: state.fetchFailureCount + 1
                });
            case "pause":
                return (0, $g6Hsb.default)({}, state, {
                    isPaused: true
                });
            case "continue":
                return (0, $g6Hsb.default)({}, state, {
                    isPaused: false
                });
            case "fetch":
                return (0, $g6Hsb.default)({}, state, {
                    fetchFailureCount: 0,
                    fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                    isFetching: true,
                    isPaused: false
                }, !state.dataUpdatedAt && {
                    error: null,
                    status: "loading"
                });
            case "success":
                return (0, $g6Hsb.default)({}, state, {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                    error: null,
                    fetchFailureCount: 0,
                    isFetching: false,
                    isInvalidated: false,
                    isPaused: false,
                    status: "success"
                });
            case "error":
                var error = action.error;
                if ((0, $nNKt4.isCancelledError)(error) && error.revert && this.revertState) return (0, $g6Hsb.default)({}, this.revertState);
                return (0, $g6Hsb.default)({}, state, {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    isFetching: false,
                    isPaused: false,
                    status: "error"
                });
            case "invalidate":
                return (0, $g6Hsb.default)({}, state, {
                    isInvalidated: true
                });
            case "setState":
                return (0, $g6Hsb.default)({}, state, action.state);
            default:
                return state;
        }
    };
    return Query;
}();

});


parcelRegister("9aKmC", function(module, exports) {

$parcel$export(module.exports, "infiniteQueryBehavior", () => $6ad90322ebacb773$export$84470d1367601e8d);

var $nNKt4 = parcelRequire("nNKt4");

var $9pMTd = parcelRequire("9pMTd");
function $6ad90322ebacb773$export$84470d1367601e8d() {
    return {
        onFetch: function onFetch(context) {
            context.fetchFn = function() {
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                var abortController = (0, $9pMTd.getAbortController)();
                var abortSignal = abortController == null ? void 0 : abortController.signal;
                var newPageParams = oldPageParams;
                var cancelled = false; // Get query function
                var queryFn = context.options.queryFn || function() {
                    return Promise.reject("Missing queryFn");
                };
                var buildNewPages = function buildNewPages(pages, param, page, previous) {
                    newPageParams = previous ? [
                        param
                    ].concat(newPageParams) : [].concat(newPageParams, [
                        param
                    ]);
                    return previous ? [
                        page
                    ].concat(pages) : [].concat(pages, [
                        page
                    ]);
                }; // Create function to fetch a page
                var fetchPage = function fetchPage(pages, manual, param, previous) {
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    var queryFnContext = {
                        queryKey: context.queryKey,
                        signal: abortSignal,
                        pageParam: param,
                        meta: context.meta
                    };
                    var queryFnResult = queryFn(queryFnContext);
                    var promise = Promise.resolve(queryFnResult).then(function(page) {
                        return buildNewPages(pages, param, page, previous);
                    });
                    if ((0, $nNKt4.isCancelable)(queryFnResult)) {
                        var promiseAsAny = promise;
                        promiseAsAny.cancel = queryFnResult.cancel;
                    }
                    return promise;
                };
                var promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    var manual = typeof pageParam !== "undefined";
                    var param = manual ? pageParam : $6ad90322ebacb773$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    var _manual = typeof pageParam !== "undefined";
                    var _param = _manual ? pageParam : $6ad90322ebacb773$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, _manual, _param, true);
                } else (function() {
                    newPageParams = [];
                    var manual = typeof context.options.getNextPageParam === "undefined";
                    var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    var _loop = function _loop(i) {
                        promise = promise.then(function(pages) {
                            var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                            if (shouldFetchNextPage) {
                                var _param2 = manual ? oldPageParams[i] : $6ad90322ebacb773$export$1186159d57de7255(context.options, pages);
                                return fetchPage(pages, manual, _param2);
                            }
                            return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                        });
                    };
                    for(var i = 1; i < oldPages.length; i++)_loop(i);
                })();
                var finalPromise = promise.then(function(pages) {
                    return {
                        pages: pages,
                        pageParams: newPageParams
                    };
                });
                var finalPromiseAsAny = finalPromise;
                finalPromiseAsAny.cancel = function() {
                    cancelled = true;
                    abortController == null || abortController.abort();
                    if ((0, $nNKt4.isCancelable)(promise)) promise.cancel();
                };
                return finalPromise;
            };
        }
    };
}
function $6ad90322ebacb773$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $6ad90322ebacb773$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
function $6ad90322ebacb773$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        var nextPageParam = $6ad90322ebacb773$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
}
function $6ad90322ebacb773$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        var previousPageParam = $6ad90322ebacb773$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
}

});


parcelRegister("aR1zK", function(module, exports) {

$parcel$export(module.exports, "QueryClientProvider", () => (parcelRequire("dRtsf")).QueryClientProvider);
$parcel$export(module.exports, "useQueryClient", () => (parcelRequire("dRtsf")).useQueryClient);
$parcel$export(module.exports, "useIsFetching", () => (parcelRequire("4t5s9")).useIsFetching);
$parcel$export(module.exports, "useMutation", () => (parcelRequire("lKmTf")).useMutation);
$parcel$export(module.exports, "useQuery", () => (parcelRequire("ipyAV")).useQuery);
// Side effects
parcelRequire("clDuZ");
parcelRequire("ku3lK");

var $dRtsf = parcelRequire("dRtsf");


var $4t5s9 = parcelRequire("4t5s9");


var $lKmTf = parcelRequire("lKmTf");

var $ipyAV = parcelRequire("ipyAV");





});
parcelRegister("clDuZ", function(module, exports) {

var $iISSM = parcelRequire("iISSM");

var $m2i4D = parcelRequire("m2i4D");
(0, $iISSM.notifyManager).setBatchNotifyFunction((0, $m2i4D.unstable_batchedUpdates));

});
parcelRegister("m2i4D", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => $0423d5096714625b$export$c78a37762a8d58e1);

var $lOkAX = parcelRequire("lOkAX");
var $0423d5096714625b$export$c78a37762a8d58e1 = (0, (/*@__PURE__*/$parcel$interopDefault($lOkAX))).unstable_batchedUpdates;

});


parcelRegister("ku3lK", function(module, exports) {

var $lta08 = parcelRequire("lta08");

var $ET5yy = parcelRequire("ET5yy");
(0, $lta08.setLogger)((0, $ET5yy.logger));

});
parcelRegister("ET5yy", function(module, exports) {

$parcel$export(module.exports, "logger", () => $07ae77fe6575ed1b$export$af88d00dbe7f521);
var $07ae77fe6575ed1b$export$af88d00dbe7f521 = console;

});


parcelRegister("dRtsf", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", () => $a17712b02fc30dd7$export$22e77b9572c4fded);
$parcel$export(module.exports, "QueryClientProvider", () => $a17712b02fc30dd7$export$45604f0cc8ae667b);

var $aOzEm = parcelRequire("aOzEm");
var $a17712b02fc30dd7$var$defaultContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createContext(undefined);
var $a17712b02fc30dd7$var$QueryClientSharingContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $a17712b02fc30dd7$var$getQueryClientContext(contextSharing) {
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $a17712b02fc30dd7$var$defaultContext;
        return window.ReactQueryClientContext;
    }
    return $a17712b02fc30dd7$var$defaultContext;
}
var $a17712b02fc30dd7$export$22e77b9572c4fded = function useQueryClient() {
    var queryClient = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useContext($a17712b02fc30dd7$var$getQueryClientContext((0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useContext($a17712b02fc30dd7$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
var $a17712b02fc30dd7$export$45604f0cc8ae667b = function QueryClientProvider(_ref) {
    var client = _ref.client, _ref$contextSharing = _ref.contextSharing, contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing, children = _ref.children;
    (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    var Context = $a17712b02fc30dd7$var$getQueryClientContext(contextSharing);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createElement($a17712b02fc30dd7$var$QueryClientSharingContext.Provider, {
        value: contextSharing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createElement(Context.Provider, {
        value: client
    }, children));
};

});

parcelRegister("4t5s9", function(module, exports) {

$parcel$export(module.exports, "useIsFetching", () => $340e19bad8588edd$export$625b2ff71316bcd3);

var $aOzEm = parcelRequire("aOzEm");

var $iISSM = parcelRequire("iISSM");

var $9pMTd = parcelRequire("9pMTd");

var $dRtsf = parcelRequire("dRtsf");
var $340e19bad8588edd$var$checkIsFetching = function checkIsFetching(queryClient, filters, isFetching, setIsFetching) {
    var newIsFetching = queryClient.isFetching(filters);
    if (isFetching !== newIsFetching) setIsFetching(newIsFetching);
};
function $340e19bad8588edd$export$625b2ff71316bcd3(arg1, arg2) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useRef(false);
    var queryClient = (0, $dRtsf.useQueryClient)();
    var _parseFilterArgs = (0, $9pMTd.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs[0];
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useState(queryClient.isFetching(filters)), isFetching = _React$useState[0], setIsFetching = _React$useState[1];
    var filtersRef = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useRef(filters);
    filtersRef.current = filters;
    var isFetchingRef = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useRef(isFetching);
    isFetchingRef.current = isFetching;
    (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useEffect(function() {
        mountedRef.current = true;
        $340e19bad8588edd$var$checkIsFetching(queryClient, filtersRef.current, isFetchingRef.current, setIsFetching);
        var unsubscribe = queryClient.getQueryCache().subscribe((0, $iISSM.notifyManager).batchCalls(function() {
            if (mountedRef.current) $340e19bad8588edd$var$checkIsFetching(queryClient, filtersRef.current, isFetchingRef.current, setIsFetching);
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        queryClient
    ]);
    return isFetching;
}

});

parcelRegister("lKmTf", function(module, exports) {

$parcel$export(module.exports, "useMutation", () => $fd4fa652b7ac6aaa$export$609860bf8b0084c);

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");

var $iISSM = parcelRequire("iISSM");

var $9pMTd = parcelRequire("9pMTd");

var $jfj0S = parcelRequire("jfj0S");

var $dRtsf = parcelRequire("dRtsf");

var $1DkQ0 = parcelRequire("1DkQ0");
function $fd4fa652b7ac6aaa$export$609860bf8b0084c(arg1, arg2, arg3) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useState(0), forceUpdate = _React$useState[1];
    var options = (0, $9pMTd.parseMutationArgs)(arg1, arg2, arg3);
    var queryClient = (0, $dRtsf.useQueryClient)();
    var obsRef = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useRef();
    if (!obsRef.current) obsRef.current = new (0, $jfj0S.MutationObserver)(queryClient, options);
    else obsRef.current.setOptions(options);
    var currentResult = obsRef.current.getCurrentResult();
    (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = obsRef.current.subscribe((0, $iISSM.notifyManager).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, []);
    var mutate = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useCallback(function(variables, mutateOptions) {
        obsRef.current.mutate(variables, mutateOptions).catch((0, $9pMTd.noop));
    }, []);
    if (currentResult.error && (0, $1DkQ0.shouldThrowError)(undefined, obsRef.current.options.useErrorBoundary, [
        currentResult.error
    ])) throw currentResult.error;
    return (0, $g6Hsb.default)({}, currentResult, {
        mutate: mutate,
        mutateAsync: currentResult.mutate
    });
}

});
parcelRegister("jfj0S", function(module, exports) {

$parcel$export(module.exports, "MutationObserver", () => $e02e2a9fc2e6a973$export$d3c1860ee66f291a);

var $g6Hsb = parcelRequire("g6Hsb");

var $7rgHR = parcelRequire("7rgHR");

var $g6Wac = parcelRequire("g6Wac");

var $iISSM = parcelRequire("iISSM");

var $76ORa = parcelRequire("76ORa");
var $e02e2a9fc2e6a973$export$d3c1860ee66f291a = /*#__PURE__*/ function(_Subscribable) {
    (0, $7rgHR.default)(MutationObserver, _Subscribable);
    function MutationObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.setOptions(options);
        _this.bindMethods();
        _this.updateResult();
        return _this;
    }
    var _proto = MutationObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    };
    _proto.setOptions = function setOptions(options) {
        this.options = this.client.defaultMutationOptions(options);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    };
    _proto.onMutationUpdate = function onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        var notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.reset = function reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    };
    _proto.mutate = function mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, (0, $g6Hsb.default)({}, this.options, {
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        }));
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    };
    _proto.updateResult = function updateResult() {
        var state = this.currentMutation ? this.currentMutation.state : (0, $g6Wac.getDefaultState)();
        var result = (0, $g6Hsb.default)({}, state, {
            isLoading: state.status === "loading",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        });
        this.currentResult = result;
    };
    _proto.notify = function notify(options) {
        var _this2 = this;
        (0, $iISSM.notifyManager).batch(function() {
            // First trigger the mutate callbacks
            if (_this2.mutateOptions) {
                if (options.onSuccess) {
                    _this2.mutateOptions.onSuccess == null || _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
                } else if (options.onError) {
                    _this2.mutateOptions.onError == null || _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) _this2.listeners.forEach(function(listener) {
                listener(_this2.currentResult);
            });
        });
    };
    return MutationObserver;
}((0, $76ORa.Subscribable));

});

parcelRegister("1DkQ0", function(module, exports) {

$parcel$export(module.exports, "shouldThrowError", () => $130998ec36750165$export$2072f68e6c3507cf);
function $130998ec36750165$export$2072f68e6c3507cf(suspense, _useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary.apply(void 0, params);
     // Allow useErrorBoundary to override suspense's throwing behavior
    if (typeof _useErrorBoundary === "boolean") return _useErrorBoundary; // If suspense is enabled default to throwing errors
    return !!suspense;
}

});


parcelRegister("ipyAV", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $d675658bbdbad21b$export$dd0a697e1782aedd);

var $crRAA = parcelRequire("crRAA");

var $9pMTd = parcelRequire("9pMTd");

var $a2HMi = parcelRequire("a2HMi");
function $d675658bbdbad21b$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    var parsedOptions = (0, $9pMTd.parseQueryArgs)(arg1, arg2, arg3);
    return (0, $a2HMi.useBaseQuery)(parsedOptions, (0, $crRAA.QueryObserver));
}

});
parcelRegister("crRAA", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", () => $9101935225b73fef$export$a06cf8c0066f0d4c);

var $g6Hsb = parcelRequire("g6Hsb");

var $7rgHR = parcelRequire("7rgHR");

var $9pMTd = parcelRequire("9pMTd");

var $iISSM = parcelRequire("iISSM");

var $9mNYT = parcelRequire("9mNYT");

var $76ORa = parcelRequire("76ORa");

var $lta08 = parcelRequire("lta08");

var $nNKt4 = parcelRequire("nNKt4");
var $9101935225b73fef$export$a06cf8c0066f0d4c = /*#__PURE__*/ function(_Subscribable) {
    (0, $7rgHR.default)(QueryObserver, _Subscribable);
    function QueryObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.options = options;
        _this.trackedProps = [];
        _this.selectError = null;
        _this.bindMethods();
        _this.setOptions(options);
        return _this;
    }
    var _proto = QueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    };
    _proto.onSubscribe = function onSubscribe() {
        if (this.listeners.length === 1) {
            this.currentQuery.addObserver(this);
            if ($9101935225b73fef$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
        return $9101935225b73fef$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    };
    _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
        return $9101935225b73fef$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.clearTimers();
        this.currentQuery.removeObserver(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        var prevOptions = this.options;
        var prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryObserverOptions(options);
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        var mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $9101935225b73fef$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return this.createResult(query, defaultedOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.trackResult = function trackResult(result, defaultedOptions) {
        var _this2 = this;
        var trackedResult = {};
        var trackProp = function trackProp(key) {
            if (!_this2.trackedProps.includes(key)) _this2.trackedProps.push(key);
        };
        Object.keys(result).forEach(function(key) {
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: function get() {
                    trackProp(key);
                    return result[key];
                }
            });
        });
        if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) trackProp("error");
        return trackedResult;
    };
    _proto.getNextResult = function getNextResult(options) {
        var _this3 = this;
        return new Promise(function(resolve, reject) {
            var unsubscribe = _this3.subscribe(function(result) {
                if (!result.isFetching) {
                    unsubscribe();
                    if (result.isError && (options == null ? void 0 : options.throwOnError)) reject(result.error);
                    else resolve(result);
                }
            });
        });
    };
    _proto.getCurrentQuery = function getCurrentQuery() {
        return this.currentQuery;
    };
    _proto.remove = function remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    };
    _proto.refetch = function refetch(options) {
        return this.fetch((0, $g6Hsb.default)({}, options, {
            meta: {
                refetchPage: options == null ? void 0 : options.refetchPage
            }
        }));
    };
    _proto.fetchOptimistic = function fetchOptimistic(options) {
        var _this4 = this;
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return query.fetch().then(function() {
            return _this4.createResult(query, defaultedOptions);
        });
    };
    _proto.fetch = function fetch(fetchOptions) {
        var _this5 = this;
        return this.executeFetch(fetchOptions).then(function() {
            _this5.updateResult();
            return _this5.currentResult;
        });
    };
    _proto.executeFetch = function executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        var promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $9pMTd.noop));
        return promise;
    };
    _proto.updateStaleTimeout = function updateStaleTimeout() {
        var _this6 = this;
        this.clearStaleTimeout();
        if ((0, $9pMTd.isServer) || this.currentResult.isStale || !(0, $9pMTd.isValidTimeout)(this.options.staleTime)) return;
        var time = (0, $9pMTd.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        var timeout = time + 1;
        this.staleTimeoutId = setTimeout(function() {
            if (!_this6.currentResult.isStale) _this6.updateResult();
        }, timeout);
    };
    _proto.computeRefetchInterval = function computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    };
    _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
        var _this7 = this;
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $9pMTd.isServer) || this.options.enabled === false || !(0, $9pMTd.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(function() {
            if (_this7.options.refetchIntervalInBackground || (0, $9mNYT.focusManager).isFocused()) _this7.executeFetch();
        }, this.currentRefetchInterval);
    };
    _proto.updateTimers = function updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    };
    _proto.clearTimers = function clearTimers() {
        this.clearStaleTimeout();
        this.clearRefetchInterval();
    };
    _proto.clearStaleTimeout = function clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    };
    _proto.clearRefetchInterval = function clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    };
    _proto.createResult = function createResult(query, options) {
        var prevQuery = this.currentQuery;
        var prevOptions = this.options;
        var prevResult = this.currentResult;
        var prevResultState = this.currentResultState;
        var prevResultOptions = this.currentResultOptions;
        var queryChange = query !== prevQuery;
        var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        var state = query.state;
        var dataUpdatedAt = state.dataUpdatedAt, error = state.error, errorUpdatedAt = state.errorUpdatedAt, isFetching = state.isFetching, status = state.status;
        var isPreviousData = false;
        var isPlaceholderData = false;
        var data; // Optimistically set result in fetching state if needed
        if (options.optimisticResults) {
            var mounted = this.hasListeners();
            var fetchOnMount = !mounted && $9101935225b73fef$var$shouldFetchOnMount(query, options);
            var fetchOptionally = mounted && $9101935225b73fef$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                isFetching = true;
                if (!dataUpdatedAt) status = "loading";
            }
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                if (options.structuralSharing !== false) data = (0, $9pMTd.replaceEqualDeep)(prevResult == null ? void 0 : prevResult.data, data);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                (0, $lta08.getLogger)().error(selectError);
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && (status === "loading" || status === "idle")) {
            var placeholderData; // Memoize placeholder data
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    if (options.structuralSharing !== false) placeholderData = (0, $9pMTd.replaceEqualDeep)(prevResult == null ? void 0 : prevResult.data, placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    (0, $lta08.getLogger)().error(selectError);
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = placeholderData;
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        var result = {
            status: status,
            isLoading: status === "loading",
            isSuccess: status === "success",
            isError: status === "error",
            isIdle: status === "idle",
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && status !== "loading",
            isLoadingError: status === "error" && state.dataUpdatedAt === 0,
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: status === "error" && state.dataUpdatedAt !== 0,
            isStale: $9101935225b73fef$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    };
    _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
        if (!prevResult) return true;
        var _this$options = this.options, notifyOnChangeProps = _this$options.notifyOnChangeProps, notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
        if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) return true;
        if (notifyOnChangeProps === "tracked" && !this.trackedProps.length) return true;
        var includedProps = notifyOnChangeProps === "tracked" ? this.trackedProps : notifyOnChangeProps;
        return Object.keys(result).some(function(key) {
            var typedKey = key;
            var changed = result[typedKey] !== prevResult[typedKey];
            var isIncluded = includedProps == null ? void 0 : includedProps.some(function(x) {
                return x === key;
            });
            var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function(x) {
                return x === key;
            });
            return changed && !isExcluded && (!includedProps || isIncluded);
        });
    };
    _proto.updateResult = function updateResult(notifyOptions) {
        var prevResult = this.currentResult;
        this.currentResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify if something has changed
        if ((0, $9pMTd.shallowEqualObjects)(this.currentResult, prevResult)) return;
         // Determine which callbacks to trigger
        var defaultNotifyOptions = {
            cache: true
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) defaultNotifyOptions.listeners = true;
        this.notify((0, $g6Hsb.default)({}, defaultNotifyOptions, notifyOptions));
    };
    _proto.updateQuery = function updateQuery() {
        var query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        var prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    };
    _proto.onQueryUpdate = function onQueryUpdate(action) {
        var notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error" && !(0, $nNKt4.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    };
    _proto.notify = function notify(notifyOptions) {
        var _this8 = this;
        (0, $iISSM.notifyManager).batch(function() {
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                _this8.options.onSuccess == null || _this8.options.onSuccess(_this8.currentResult.data);
                _this8.options.onSettled == null || _this8.options.onSettled(_this8.currentResult.data, null);
            } else if (notifyOptions.onError) {
                _this8.options.onError == null || _this8.options.onError(_this8.currentResult.error);
                _this8.options.onSettled == null || _this8.options.onSettled(undefined, _this8.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) _this8.listeners.forEach(function(listener) {
                listener(_this8.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) _this8.client.getQueryCache().notify({
                query: _this8.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    };
    return QueryObserver;
}((0, $76ORa.Subscribable));
function $9101935225b73fef$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $9101935225b73fef$var$shouldFetchOnMount(query, options) {
    return $9101935225b73fef$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $9101935225b73fef$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $9101935225b73fef$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        var value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $9101935225b73fef$var$isStale(query, options);
    }
    return false;
}
function $9101935225b73fef$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $9101935225b73fef$var$isStale(query, options);
}
function $9101935225b73fef$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}

});

parcelRegister("a2HMi", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", () => $74fc0cae030bc0eb$export$fff0865807e996c5);

var $aOzEm = parcelRequire("aOzEm");

var $iISSM = parcelRequire("iISSM");

var $8ynFG = parcelRequire("8ynFG");

var $dRtsf = parcelRequire("dRtsf");

var $1DkQ0 = parcelRequire("1DkQ0");
function $74fc0cae030bc0eb$export$fff0865807e996c5(options, Observer) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, $dRtsf.useQueryClient)();
    var errorResetBoundary = (0, $8ynFG.useQueryErrorResetBoundary)();
    var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions.optimisticResults = true; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $iISSM.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $iISSM.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $iISSM.notifyManager).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
         // Set cache time to 1 if the option has been set to 0
        // when using suspense to prevent infinite loop of fetches
        if (defaultedOptions.cacheTime === 0) defaultedOptions.cacheTime = 1;
    }
    if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) defaultedOptions.retryOnMount = false;
    }
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useState(function() {
        return new Observer(queryClient, defaultedOptions);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedOptions);
    (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useEffect(function() {
        mountedRef.current = true;
        errorResetBoundary.clearReset();
        var unsubscribe = observer.subscribe((0, $iISSM.notifyManager).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        })); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        errorResetBoundary,
        observer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if (defaultedOptions.suspense && result.isLoading) throw observer.fetchOptimistic(defaultedOptions).then(function(_ref) {
        var data = _ref.data;
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch(function(error) {
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });
     // Handle error boundary
    if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $1DkQ0.shouldThrowError)(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [
        result.error,
        observer.getCurrentQuery()
    ])) throw result.error;
     // Handle result property usage tracking
    if (defaultedOptions.notifyOnChangeProps === "tracked") result = observer.trackResult(result, defaultedOptions);
    return result;
}

});
parcelRegister("8ynFG", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", () => $63a3dc5153e979e5$export$50dfac555130cafd);

var $aOzEm = parcelRequire("aOzEm");
function $63a3dc5153e979e5$var$createValue() {
    var _isReset = false;
    return {
        clearReset: function clearReset() {
            _isReset = false;
        },
        reset: function reset() {
            _isReset = true;
        },
        isReset: function isReset() {
            return _isReset;
        }
    };
}
var $63a3dc5153e979e5$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createContext($63a3dc5153e979e5$var$createValue()); // HOOK
var $63a3dc5153e979e5$export$50dfac555130cafd = function useQueryErrorResetBoundary() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useContext($63a3dc5153e979e5$var$QueryErrorResetBoundaryContext);
}; // COMPONENT
var $63a3dc5153e979e5$export$ddb9962d870f2330 = function QueryErrorResetBoundary(_ref) {
    var children = _ref.children;
    var value = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useMemo(function() {
        return $63a3dc5153e979e5$var$createValue();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createElement($63a3dc5153e979e5$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};

});





parcelRegister("jyGS9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d272ddb7b40a20$export$2e2bcd8739ae039);


var $2mMef = parcelRequire("2mMef");
"use client";
const $e3d272ddb7b40a20$var$Box = (0, $2mMef.default)();
var $e3d272ddb7b40a20$export$2e2bcd8739ae039 = $e3d272ddb7b40a20$var$Box;

});

parcelRegister("3ax2v", function(module, exports) {

$parcel$export(module.exports, "Guide", () => $ca27e4d5c98dded4$export$dd9cef36367ff841);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $7mDwS = parcelRequire("7mDwS");

var $8aalP = parcelRequire("8aalP");
var $8p0qe = parcelRequire("8p0qe");

var $3HZFp = parcelRequire("3HZFp");

var $iviOa = parcelRequire("iviOa");

var $hbDGZ = parcelRequire("hbDGZ");

var $2BlcB = parcelRequire("2BlcB");
function $ca27e4d5c98dded4$export$dd9cef36367ff841({ useCase: useCase, sx: sx }) {
    const guideCtx = (0, $iviOa.useGuide)();
    if (!useCase) return null;
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3HZFp))), {
        className: "Guide",
        title: "Walkthrough",
        sx: {
            maxHeight: "100%",
            isolation: "isolate",
            borderRadius: 0,
            border: "none",
            "@media (prefers-reduced-motion)": {
                animation: "none"
            },
            animation: "slide 0.5s ease-out",
            "@keyframes slide": {
                "0%": {
                    opacity: 0
                },
                "100%": {
                    opacity: 1
                }
            },
            "& h1,h2": {
                borderBottom: "1px solid rgb(90% 90% 90%)"
            },
            ...sx
        },
        actions: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8p0qe.default), {
            sx: {
                fontSize: "1rem"
            },
            onClick: ()=>guideCtx.closeGuide(),
            children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $7mDwS.default), {})
        }),
        footer: /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $8aalP.default), {
            sx: {
                textAlign: "center"
            },
            children: [
                "Need help? You can reach us in the",
                " ",
                /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8aalP.default), {
                    component: "a",
                    target: "_blank",
                    href: (0, $2BlcB.communitySlack),
                    children: "community Slack"
                }),
                " ",
                "or",
                " ",
                /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8aalP.default), {
                    component: "a",
                    target: "_blank",
                    href: (0, $2BlcB.supportEmail),
                    children: "email support"
                }),
                "."
            ]
        }),
        children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $hbDGZ.MDXProvider), {
            children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $aOzEm.Suspense), {
                fallback: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8aalP.default), {
                    sx: {
                        color: "text.secondary",
                        textAlign: "center",
                        paddingY: "2ch"
                    },
                    children: "Error loading guide"
                }),
                children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8aalP.default), {
                    sx: {
                        height: "100%",
                        overflowY: "auto",
                        overflowX: "hidden",
                        padding: "0 2ch 1ch"
                    },
                    children: /*#__PURE__*/ (0, $2T9xh.jsx)(useCase.Content, {})
                })
            })
        })
    });
}

});
parcelRegister("7mDwS", function(module, exports) {

$parcel$export(module.exports, "default", () => $55c9402fcf4cd565$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $55c9402fcf4cd565$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");

});
parcelRegister("9hLGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c2ab168e6726d85$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");

var $8BJZS = parcelRequire("8BJZS");

var $2T9xh = parcelRequire("2T9xh");
"use client";
function $6c2ab168e6726d85$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8BJZS.default), (0, $g6Hsb.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $8BJZS.default).muiName;
    return /*#__PURE__*/ $aOzEm.memo(/*#__PURE__*/ $aOzEm.forwardRef(Component));
}

});
parcelRegister("8BJZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6445757ef9a7b0b9$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $63Oo6 = parcelRequire("63Oo6");

var $gEb5G = parcelRequire("gEb5G");

var $25zst = parcelRequire("25zst");

var $cR1EV = parcelRequire("cR1EV");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $6445757ef9a7b0b9$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $6445757ef9a7b0b9$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $63Oo6.default)(color)}`,
            `fontSize${(0, $63Oo6.default)(fontSize)}`
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $cR1EV.getSvgIconUtilityClass), classes);
};
const $6445757ef9a7b0b9$var$SvgIconRoot = (0, $25zst.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $63Oo6.default)(ownerState.color)}`],
            styles[`fontSize${(0, $63Oo6.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $6445757ef9a7b0b9$var$SvgIcon = /*#__PURE__*/ $aOzEm.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $cAqXo.default)(props, $6445757ef9a7b0b9$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $aOzEm.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $g6Hsb.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $6445757ef9a7b0b9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($6445757ef9a7b0b9$var$SvgIconRoot, (0, $g6Hsb.default)({
        as: component,
        className: (0, $g45Wv.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $2T9xh.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$6445757ef9a7b0b9$var$SvgIcon.muiName = "SvgIcon";
var $6445757ef9a7b0b9$export$2e2bcd8739ae039 = $6445757ef9a7b0b9$var$SvgIcon;

});
parcelRegister("cR1EV", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $95bbb8c1f6acf7c0$export$c7c50641356bdfa5);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $95bbb8c1f6acf7c0$export$c7c50641356bdfa5(slot) {
    return (0, $6vnyE.default)("MuiSvgIcon", slot);
}
const $95bbb8c1f6acf7c0$var$svgIconClasses = (0, $cyhE3.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $95bbb8c1f6acf7c0$export$2e2bcd8739ae039 = $95bbb8c1f6acf7c0$var$svgIconClasses;

});




parcelRegister("8p0qe", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e0fc544d395d6d$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");


var $b2r0b = parcelRequire("b2r0b");

var $fOENh = parcelRequire("fOENh");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $cdbdN = parcelRequire("cdbdN");

var $63Oo6 = parcelRequire("63Oo6");

var $kvGh8 = parcelRequire("kvGh8");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $61e0fc544d395d6d$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $61e0fc544d395d6d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $63Oo6.default)(color)}`,
            edge && `edge${(0, $63Oo6.default)(edge)}`,
            `size${(0, $63Oo6.default)(size)}`
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $kvGh8.getIconButtonUtilityClass), classes);
};
const $61e0fc544d395d6d$var$IconButtonRoot = (0, $25zst.default)((0, $cdbdN.default), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $63Oo6.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $63Oo6.default)(ownerState.edge)}`],
            styles[`size${(0, $63Oo6.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fOENh.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $g6Hsb.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $g6Hsb.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $g6Hsb.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fOENh.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $kvGh8.default).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $61e0fc544d395d6d$var$IconButton = /*#__PURE__*/ $aOzEm.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $cAqXo.default)(props, $61e0fc544d395d6d$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $61e0fc544d395d6d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($61e0fc544d395d6d$var$IconButtonRoot, (0, $g6Hsb.default)({
        className: (0, $g45Wv.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $61e0fc544d395d6d$export$2e2bcd8739ae039 = $61e0fc544d395d6d$var$IconButton;

});
parcelRegister("cdbdN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e3f67518d3e1ee1$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");


var $b2r0b = parcelRequire("b2r0b");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $eedeo = parcelRequire("eedeo");

var $aAt37 = parcelRequire("aAt37");

var $f0YqC = parcelRequire("f0YqC");

var $8jMm3 = parcelRequire("8jMm3");

var $a6YiW = parcelRequire("a6YiW");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $8e3f67518d3e1ee1$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $8e3f67518d3e1ee1$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $b2r0b.default)(slots, (0, $a6YiW.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $8e3f67518d3e1ee1$export$7ec0dcc5e3cdcd36 = (0, $25zst.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $a6YiW.default).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $8e3f67518d3e1ee1$var$ButtonBase = /*#__PURE__*/ $aOzEm.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $cAqXo.default)(props, $8e3f67518d3e1ee1$var$_excluded);
    const buttonRef = $aOzEm.useRef(null);
    const rippleRef = $aOzEm.useRef(null);
    const handleRippleRef = (0, $eedeo.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $f0YqC.default)();
    const [focusVisible, setFocusVisible] = $aOzEm.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $aOzEm.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $aOzEm.useState(false);
    $aOzEm.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $aOzEm.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $aAt37.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $aAt37.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $aOzEm.useRef(false);
    const handleKeyDown = (0, $aAt37.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $aAt37.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $eedeo.default)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $8e3f67518d3e1ee1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($8e3f67518d3e1ee1$export$7ec0dcc5e3cdcd36, (0, $g6Hsb.default)({
        as: ComponentProp,
        className: (0, $g45Wv.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $2T9xh.jsx)((0, $8jMm3.default), (0, $g6Hsb.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $8e3f67518d3e1ee1$export$2e2bcd8739ae039 = $8e3f67518d3e1ee1$var$ButtonBase;

});
parcelRegister("eedeo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5bca2e7bd89d605$export$2e2bcd8739ae039);

var $6KMJ0 = parcelRequire("6KMJ0");
"use client";
var $a5bca2e7bd89d605$export$2e2bcd8739ae039 = (0, $6KMJ0.default);

});
parcelRegister("6KMJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eacd5b06e26ece6$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");

var $iff6Y = parcelRequire("iff6Y");
"use client";
function $4eacd5b06e26ece6$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $aOzEm.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $iff6Y.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRegister("iff6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4855985228f1d8d$export$2e2bcd8739ae039);
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $d4855985228f1d8d$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});



parcelRegister("aAt37", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b53ccbf3b801cf6$export$2e2bcd8739ae039);

var $b5mPz = parcelRequire("b5mPz");
"use client";
var $7b53ccbf3b801cf6$export$2e2bcd8739ae039 = (0, $b5mPz.default);

});
parcelRegister("b5mPz", function(module, exports) {

$parcel$export(module.exports, "default", () => $8121df14329ef0ec$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");

var $3jQQ9 = parcelRequire("3jQQ9");
"use client";
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */ function $8121df14329ef0ec$var$useEventCallback(fn) {
    const ref = $aOzEm.useRef(fn);
    (0, $3jQQ9.default)(()=>{
        ref.current = fn;
    });
    return $aOzEm.useCallback((...args)=>// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}
var $8121df14329ef0ec$export$2e2bcd8739ae039 = $8121df14329ef0ec$var$useEventCallback;

});
parcelRegister("3jQQ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $26ac2269d045676c$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");
"use client";
const $26ac2269d045676c$var$useEnhancedEffect = typeof window !== "undefined" ? $aOzEm.useLayoutEffect : $aOzEm.useEffect;
var $26ac2269d045676c$export$2e2bcd8739ae039 = $26ac2269d045676c$var$useEnhancedEffect;

});



parcelRegister("f0YqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $aee5bae66cdc4985$export$2e2bcd8739ae039);

var $9c4Ax = parcelRequire("9c4Ax");
"use client";
var $aee5bae66cdc4985$export$2e2bcd8739ae039 = (0, $9c4Ax.default);

});
parcelRegister("9c4Ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b18cb2c354365ed$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");
"use client";
let $6b18cb2c354365ed$var$hadKeyboardEvent = true;
let $6b18cb2c354365ed$var$hadFocusVisibleRecently = false;
let $6b18cb2c354365ed$var$hadFocusVisibleRecentlyTimeout;
const $6b18cb2c354365ed$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $6b18cb2c354365ed$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $6b18cb2c354365ed$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $6b18cb2c354365ed$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $6b18cb2c354365ed$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $6b18cb2c354365ed$var$handlePointerDown() {
    $6b18cb2c354365ed$var$hadKeyboardEvent = false;
}
function $6b18cb2c354365ed$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($6b18cb2c354365ed$var$hadFocusVisibleRecently) $6b18cb2c354365ed$var$hadKeyboardEvent = true;
    }
}
function $6b18cb2c354365ed$var$prepare(doc) {
    doc.addEventListener("keydown", $6b18cb2c354365ed$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $6b18cb2c354365ed$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $6b18cb2c354365ed$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $6b18cb2c354365ed$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $6b18cb2c354365ed$var$handleVisibilityChange, true);
}
function $6b18cb2c354365ed$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $6b18cb2c354365ed$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $6b18cb2c354365ed$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $6b18cb2c354365ed$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $6b18cb2c354365ed$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $6b18cb2c354365ed$var$handleVisibilityChange, true);
}
function $6b18cb2c354365ed$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $6b18cb2c354365ed$var$hadKeyboardEvent || $6b18cb2c354365ed$var$focusTriggersKeyboardModality(target);
}
function $6b18cb2c354365ed$export$2e2bcd8739ae039() {
    const ref = $aOzEm.useCallback((node)=>{
        if (node != null) $6b18cb2c354365ed$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $aOzEm.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $6b18cb2c354365ed$var$hadFocusVisibleRecently = true;
            window.clearTimeout($6b18cb2c354365ed$var$hadFocusVisibleRecentlyTimeout);
            $6b18cb2c354365ed$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $6b18cb2c354365ed$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($6b18cb2c354365ed$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}

});


parcelRegister("8jMm3", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e59b5104d721a7$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $aOzEm = parcelRequire("aOzEm");


var $kaarV = parcelRequire("kaarV");

var $g45Wv = parcelRequire("g45Wv");

var $e2SFW = parcelRequire("e2SFW");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $ebGt4 = parcelRequire("ebGt4");

var $5aw74 = parcelRequire("5aw74");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $60e59b5104d721a7$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $60e59b5104d721a7$var$_ = (t)=>t, $60e59b5104d721a7$var$_t, $60e59b5104d721a7$var$_t2, $60e59b5104d721a7$var$_t3, $60e59b5104d721a7$var$_t4;
const $60e59b5104d721a7$var$DURATION = 550;
const $60e59b5104d721a7$export$95d0c9356b2231a3 = 80;
const $60e59b5104d721a7$var$enterKeyframe = (0, $e2SFW.keyframes)($60e59b5104d721a7$var$_t || ($60e59b5104d721a7$var$_t = $60e59b5104d721a7$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $60e59b5104d721a7$var$exitKeyframe = (0, $e2SFW.keyframes)($60e59b5104d721a7$var$_t2 || ($60e59b5104d721a7$var$_t2 = $60e59b5104d721a7$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $60e59b5104d721a7$var$pulsateKeyframe = (0, $e2SFW.keyframes)($60e59b5104d721a7$var$_t3 || ($60e59b5104d721a7$var$_t3 = $60e59b5104d721a7$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $60e59b5104d721a7$export$f6b7418508c72c25 = (0, $25zst.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $60e59b5104d721a7$export$676cfe7b12693c4b = (0, $25zst.default)((0, $ebGt4.default), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($60e59b5104d721a7$var$_t4 || ($60e59b5104d721a7$var$_t4 = $60e59b5104d721a7$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $5aw74.default).rippleVisible, $60e59b5104d721a7$var$enterKeyframe, $60e59b5104d721a7$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $5aw74.default).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $5aw74.default).child, (0, $5aw74.default).childLeaving, $60e59b5104d721a7$var$exitKeyframe, $60e59b5104d721a7$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $5aw74.default).childPulsate, $60e59b5104d721a7$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $60e59b5104d721a7$var$TouchRipple = /*#__PURE__*/ $aOzEm.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $cAqXo.default)(props, $60e59b5104d721a7$var$_excluded);
    const [ripples, setRipples] = $aOzEm.useState([]);
    const nextKey = $aOzEm.useRef(0);
    const rippleCallback = $aOzEm.useRef(null);
    $aOzEm.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $aOzEm.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $aOzEm.useRef(0);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $aOzEm.useRef(null);
    const container = $aOzEm.useRef(null);
    $aOzEm.useEffect(()=>{
        return ()=>{
            if (startTimer.current) clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $aOzEm.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $2T9xh.jsx)($60e59b5104d721a7$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $g45Wv.default)(classes.ripple, (0, $5aw74.default).ripple),
                        rippleVisible: (0, $g45Wv.default)(classes.rippleVisible, (0, $5aw74.default).rippleVisible),
                        ripplePulsate: (0, $g45Wv.default)(classes.ripplePulsate, (0, $5aw74.default).ripplePulsate),
                        child: (0, $g45Wv.default)(classes.child, (0, $5aw74.default).child),
                        childLeaving: (0, $g45Wv.default)(classes.childLeaving, (0, $5aw74.default).childLeaving),
                        childPulsate: (0, $g45Wv.default)(classes.childPulsate, (0, $5aw74.default).childPulsate)
                    },
                    timeout: $60e59b5104d721a7$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $aOzEm.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $60e59b5104d721a7$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $aOzEm.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $aOzEm.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $aOzEm.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($60e59b5104d721a7$export$f6b7418508c72c25, (0, $g6Hsb.default)({
        className: (0, $g45Wv.default)((0, $5aw74.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $kaarV.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $60e59b5104d721a7$export$2e2bcd8739ae039 = $60e59b5104d721a7$var$TouchRipple;

});
parcelRegister("kaarV", function(module, exports) {

$parcel$export(module.exports, "default", () => $eadcd8de08056f49$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $6hnK6 = parcelRequire("6hnK6");

var $7rgHR = parcelRequire("7rgHR");


var $aOzEm = parcelRequire("aOzEm");

var $1MyB0 = parcelRequire("1MyB0");

var $lXdrM = parcelRequire("lXdrM");
var $eadcd8de08056f49$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $eadcd8de08056f49$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $eadcd8de08056f49$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $7rgHR.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $6hnK6.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $lXdrM.getInitialChildMapping)(nextProps, handleExited) : (0, $lXdrM.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $lXdrM.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $g6Hsb.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $cAqXo.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $eadcd8de08056f49$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createElement((0, $1MyB0.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createElement((0, $1MyB0.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).Component);
$eadcd8de08056f49$var$TransitionGroup.propTypes = {};
$eadcd8de08056f49$var$TransitionGroup.defaultProps = $eadcd8de08056f49$var$defaultProps;
var $eadcd8de08056f49$export$2e2bcd8739ae039 = $eadcd8de08056f49$var$TransitionGroup;

});
parcelRegister("6hnK6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4926bf607d3b7531$export$2e2bcd8739ae039);
function $4926bf607d3b7531$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("1MyB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $14c51c2ea1444892$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");
var $14c51c2ea1444892$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createContext(null);

});

parcelRegister("lXdrM", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $ffb989f5f9fb8e0d$export$bbc8a025727ea824);
$parcel$export(module.exports, "getInitialChildMapping", () => $ffb989f5f9fb8e0d$export$fa71e2345c31d7a2);
$parcel$export(module.exports, "getNextChildMapping", () => $ffb989f5f9fb8e0d$export$36fd1af28d383ec0);

var $aOzEm = parcelRequire("aOzEm");
function $ffb989f5f9fb8e0d$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $aOzEm.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $aOzEm.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $ffb989f5f9fb8e0d$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $ffb989f5f9fb8e0d$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $ffb989f5f9fb8e0d$export$fa71e2345c31d7a2(props, onExited) {
    return $ffb989f5f9fb8e0d$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $aOzEm.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $ffb989f5f9fb8e0d$var$getProp(child, "appear", props),
            enter: $ffb989f5f9fb8e0d$var$getProp(child, "enter", props),
            exit: $ffb989f5f9fb8e0d$var$getProp(child, "exit", props)
        });
    });
}
function $ffb989f5f9fb8e0d$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $ffb989f5f9fb8e0d$export$bbc8a025727ea824(nextProps.children);
    var children = $ffb989f5f9fb8e0d$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $aOzEm.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $aOzEm.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $aOzEm.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $ffb989f5f9fb8e0d$var$getProp(child, "exit", nextProps),
            enter: $ffb989f5f9fb8e0d$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $aOzEm.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $aOzEm.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $aOzEm.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $ffb989f5f9fb8e0d$var$getProp(child, "exit", nextProps),
            enter: $ffb989f5f9fb8e0d$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRegister("ebGt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5430902a54581fe$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $2T9xh = parcelRequire("2T9xh");
"use client";
function $a5430902a54581fe$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $aOzEm.useState(false);
    const rippleClassName = (0, $g45Wv.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $g45Wv.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $aOzEm.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)("span", {
            className: childClassName
        })
    });
}
var $a5430902a54581fe$export$2e2bcd8739ae039 = $a5430902a54581fe$var$Ripple;

});

parcelRegister("5aw74", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c36cbe7fe2a28de$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $3c36cbe7fe2a28de$export$b464606f735ab902(slot) {
    return (0, $6vnyE.default)("MuiTouchRipple", slot);
}
const $3c36cbe7fe2a28de$var$touchRippleClasses = (0, $cyhE3.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $3c36cbe7fe2a28de$export$2e2bcd8739ae039 = $3c36cbe7fe2a28de$var$touchRippleClasses;

});


parcelRegister("a6YiW", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", () => $75c93e2476af08a9$export$fccb0498dcd99783);
$parcel$export(module.exports, "default", () => $75c93e2476af08a9$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $75c93e2476af08a9$export$fccb0498dcd99783(slot) {
    return (0, $6vnyE.default)("MuiButtonBase", slot);
}
const $75c93e2476af08a9$var$buttonBaseClasses = (0, $cyhE3.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $75c93e2476af08a9$export$2e2bcd8739ae039 = $75c93e2476af08a9$var$buttonBaseClasses;

});


parcelRegister("kvGh8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getIconButtonUtilityClass", () => $eee77eeae4d50936$export$5e8702d71474f093);
$parcel$export(module.exports, "default", () => $eee77eeae4d50936$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $eee77eeae4d50936$export$5e8702d71474f093(slot) {
    return (0, $6vnyE.default)("MuiIconButton", slot);
}
const $eee77eeae4d50936$var$iconButtonClasses = (0, $cyhE3.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $eee77eeae4d50936$export$2e2bcd8739ae039 = $eee77eeae4d50936$var$iconButtonClasses;

});


parcelRegister("3HZFp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Frame = void 0;

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $8aalP = parcelRequire("8aalP");
var $crazb = parcelRequire("crazb");
var $8p0qe = parcelRequire("8p0qe");
var $7Wk6y = parcelRequire("7Wk6y");
var $gvXbM = parcelRequire("gvXbM");
var $hvbBd = parcelRequire("hvbBd");

var $cZLdX = parcelRequire("cZLdX");
var $1JXVa = parcelRequire("1JXVa");
var $904LW = parcelRequire("904LW");
var $kfgBH = parcelRequire("kfgBH");
var $5lhcX = parcelRequire("5lhcX");

var $497Ri = parcelRequire("497Ri");

var $8V5Nr = parcelRequire("8V5Nr");
const $2b3539011d6d9ec7$var$headerFooterCommonStyles = {
    padding: "2px 8px",
    color: "text.secondary",
    alignItems: "center",
    fontSize: "0.8em",
    height: "3em",
    display: "grid",
    placeItems: "center stretch",
    margin: 0
};
function $2b3539011d6d9ec7$var$Frame({ ["data-testid"]: testId = null, className: className, icon: icon, title: title, titleHelp: titleHelp = null, tip: tip = "", header: header = null, footer: footer = null, actions: actions = null, maximized: maximized = false, onToggleMaximized: onToggleMaximized = null, children: children, sx: sx = {}, component: component = "div", isCollapsible: isCollapsibleProp, isPaywalled: isPaywalled = false }) {
    var _a;
    const frameGroupCtx = (0, $497Ri.useFrameGroupCtx)();
    const [expanded, setExpanded] = (0, $aOzEm.useState)((_a = frameGroupCtx === null || frameGroupCtx === void 0 ? void 0 : frameGroupCtx.defaultExpanded) !== null && _a !== void 0 ? _a : true);
    const toggleExpanded = ()=>setExpanded((e)=>!e);
    const isCollapsible = (0, $aOzEm.useMemo)(()=>{
        return typeof isCollapsibleProp != "undefined" ? isCollapsibleProp : Boolean(frameGroupCtx) ? frameGroupCtx.count > 1 : false;
    }, [
        frameGroupCtx,
        isCollapsibleProp
    ]);
    const body = (0, $aOzEm.useMemo)(()=>{
        const box = (0, $2T9xh.jsxs)($8aalP.default, Object.assign({
            sx: {
                gridArea: "body",
                display: "grid",
                placeItems: "stretch",
                overflow: "auto",
                position: "relative",
                pointerEvents: isPaywalled ? "none" : undefined
            }
        }, {
            children: [
                children,
                isPaywalled ? (0, $2T9xh.jsx)($8V5Nr.Paywall, {}) : null
            ]
        }));
        if (isCollapsible) return (0, $2T9xh.jsx)($crazb.default, Object.assign({
            in: expanded
        }, {
            children: box
        }));
        return box;
    }, [
        children,
        expanded,
        isCollapsible,
        isPaywalled
    ]);
    return (0, $2T9xh.jsxs)($gvXbM.default, Object.assign({
        "data-testid": testId,
        className: `Frame ${className}`,
        component: component,
        sx: Object.assign({
            border: "1px solid rgba(0,0,0,0.1)",
            bgcolor: "background.paper",
            isolation: "isolate",
            borderRadius: "4px",
            display: "grid",
            minHeight: 0,
            gridTemplateRows: "min-content min-content minmax(0px, 1fr) min-content",
            gridTemplateAreas: `
          "title"
          "header"
          "body"
          "footer"
        `,
            overflow: "hidden"
        }, sx)
    }, {
        children: [
            (0, $2T9xh.jsxs)($8aalP.default, Object.assign({
                sx: {
                    gridArea: "title",
                    backgroundColor: "background.paper",
                    top: 0,
                    zIndex: 1,
                    display: "flex",
                    alignItems: "center",
                    padding: "4px 4px 4px 16px",
                    borderRadius: "4px 4px 0 0",
                    borderBottom: "solid 1px rgb(90% 90% 90%)",
                    height: "3.65em"
                }
            }, {
                children: [
                    (0, $2T9xh.jsxs)("label", Object.assign({
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: "1ch",
                            cursor: isCollapsible ? "pointer" : undefined
                        }
                    }, {
                        children: [
                            isCollapsible ? (0, $2T9xh.jsx)($8p0qe.default, Object.assign({
                                onClick: toggleExpanded
                            }, {
                                children: (0, $2T9xh.jsx)($cZLdX.default, {
                                    style: {
                                        rotate: expanded ? "90deg" : "0deg",
                                        transition: "rotate 0.2s"
                                    }
                                })
                            })) : null,
                            (0, $2T9xh.jsxs)($8aalP.default, Object.assign({
                                sx: {
                                    fontSize: "1.1em",
                                    whiteSpace: "nowrap",
                                    fontWeight: "500",
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "1ch",
                                    alignItems: "center"
                                }
                            }, {
                                children: [
                                    icon,
                                    (0, $2T9xh.jsx)("span", Object.assign({
                                        style: {
                                            minWidth: frameGroupCtx === null || frameGroupCtx === void 0 ? void 0 : frameGroupCtx.titleMinWidth
                                        }
                                    }, {
                                        children: title
                                    })),
                                    (0, $2T9xh.jsx)("a", {
                                        id: typeof title == "string" ? title : undefined
                                    })
                                ]
                            })),
                            tip ? (0, $2T9xh.jsx)($hvbBd.default, Object.assign({
                                title: tip,
                                arrow: true
                            }, {
                                children: (0, $2T9xh.jsx)($kfgBH.default, {
                                    fontSize: "inherit",
                                    sx: {
                                        color: "text.secondary"
                                    }
                                })
                            })) : null,
                            titleHelp ? (0, $2T9xh.jsx)($8aalP.default, Object.assign({
                                sx: {
                                    color: "text.secondary",
                                    fontSize: "0.9em"
                                }
                            }, {
                                children: titleHelp
                            })) : titleHelp
                        ]
                    })),
                    (0, $2T9xh.jsx)($8aalP.default, {
                        sx: {
                            flexGrow: 1,
                            minWidth: "1ch"
                        }
                    }),
                    (0, $2T9xh.jsx)($8aalP.default, Object.assign({
                        sx: {
                            marginRight: "1ch"
                        }
                    }, {
                        children: isPaywalled ? (0, $2T9xh.jsxs)($8aalP.default, Object.assign({
                            sx: {
                                display: "flex",
                                gap: "0.6ex",
                                alignItems: "center",
                                fontSize: "0.9em",
                                color: "text.secondary"
                            }
                        }, {
                            children: [
                                (0, $2T9xh.jsx)($5lhcX.default, {
                                    sx: {
                                        color: "var(--de-color-blue)"
                                    }
                                }),
                                "To change these settings you must",
                                (0, $2T9xh.jsx)($7Wk6y.default, Object.assign({
                                    href: "https://www.decodable.co/contact",
                                    target: "_blank",
                                    onClick: (e)=>{
                                        if (e.altKey || e.ctrlKey || e.metaKey) return;
                                        if ("Pylon" in window && typeof window.Pylon === "function") {
                                            e.preventDefault();
                                            window.Pylon("showNewMessage", `I'm interested in upgrading my plan to gain access to the ${title} feature.`);
                                        }
                                    }
                                }, {
                                    children: "contact support"
                                })),
                                " ",
                                "and upgrade your plan."
                            ]
                        })) : actions
                    })),
                    onToggleMaximized ? (0, $2T9xh.jsx)($8p0qe.default, Object.assign({
                        sx: {
                            marginLeft: "1ch"
                        },
                        onClick: onToggleMaximized
                    }, {
                        children: maximized ? (0, $2T9xh.jsx)($904LW.default, {
                            fontSize: "inherit"
                        }) : (0, $2T9xh.jsx)($1JXVa.default, {
                            fontSize: "inherit"
                        })
                    })) : null
                ]
            })),
            header ? (0, $2T9xh.jsx)($8aalP.default, Object.assign({
                sx: Object.assign({
                    gridArea: "header",
                    borderBottom: "solid 1px rgb(90%, 90%, 90%)"
                }, $2b3539011d6d9ec7$var$headerFooterCommonStyles)
            }, {
                children: header
            })) : null,
            body,
            footer ? (0, $2T9xh.jsx)($8aalP.default, Object.assign({
                sx: Object.assign(Object.assign({
                    gridArea: "footer",
                    borderTop: "solid 1px rgb(90%, 90%, 90%)"
                }, $2b3539011d6d9ec7$var$headerFooterCommonStyles), {
                    height: "2em",
                    bgcolor: "background.default",
                    borderRadius: "0 0 4px 4px"
                })
            }, {
                children: footer
            })) : null
        ]
    }));
}
module.exports.Frame = $2b3539011d6d9ec7$var$Frame;
module.exports.default = $2b3539011d6d9ec7$var$Frame;

});
parcelRegister("crazb", function(module, exports) {

$parcel$export(module.exports, "default", () => $90e033ec5ed6a648$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");

var $g45Wv = parcelRequire("g45Wv");


var $i5PBN = parcelRequire("i5PBN");


var $b2r0b = parcelRequire("b2r0b");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $j4Dko = parcelRequire("j4Dko");

var $iI1wU = parcelRequire("iI1wU");

var $57YGU = parcelRequire("57YGU");

var $eedeo = parcelRequire("eedeo");

var $hEP7F = parcelRequire("hEP7F");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $90e033ec5ed6a648$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $90e033ec5ed6a648$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $hEP7F.getCollapseUtilityClass), classes);
};
const $90e033ec5ed6a648$var$CollapseRoot = (0, $25zst.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, $g6Hsb.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const $90e033ec5ed6a648$var$CollapseWrapper = (0, $25zst.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $g6Hsb.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const $90e033ec5ed6a648$var$CollapseWrapperInner = (0, $25zst.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $g6Hsb.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $90e033ec5ed6a648$var$Collapse = /*#__PURE__*/ $aOzEm.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = "0px", component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = "vertical", style: style, timeout: timeout = (0, $j4Dko.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $i5PBN.default) } = props, other = (0, $cAqXo.default)(props, $90e033ec5ed6a648$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $90e033ec5ed6a648$var$useUtilityClasses(ownerState);
    const theme = (0, $57YGU.default)();
    const timer = $aOzEm.useRef();
    const wrapperRef = $aOzEm.useRef(null);
    const autoTransitionDuration = $aOzEm.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    $aOzEm.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    const nodeRef = $aOzEm.useRef(null);
    const handleRef = (0, $eedeo.default)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $iI1wU.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $iI1wU.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTransitionDuration.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $2T9xh.jsx)(TransitionComponent, (0, $g6Hsb.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $2T9xh.jsx)($90e033ec5ed6a648$var$CollapseRoot, (0, $g6Hsb.default)({
                as: component,
                className: (0, $g45Wv.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, $g6Hsb.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ownerState: (0, $g6Hsb.default)({}, ownerState, {
                    state: state
                }),
                ref: handleRef
            }, childProps, {
                children: /*#__PURE__*/ (0, $2T9xh.jsx)($90e033ec5ed6a648$var$CollapseWrapper, {
                    ownerState: (0, $g6Hsb.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $2T9xh.jsx)($90e033ec5ed6a648$var$CollapseWrapperInner, {
                        ownerState: (0, $g6Hsb.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$90e033ec5ed6a648$var$Collapse.muiSupportAuto = true;
var $90e033ec5ed6a648$export$2e2bcd8739ae039 = $90e033ec5ed6a648$var$Collapse;

});
parcelRegister("i5PBN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2c0b9ffa4e8ee66$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $7rgHR = parcelRequire("7rgHR");


var $aOzEm = parcelRequire("aOzEm");

var $lOkAX = parcelRequire("lOkAX");

var $3w1fM = parcelRequire("3w1fM");


var $1MyB0 = parcelRequire("1MyB0");

var $1vDy2 = parcelRequire("1vDy2");
var $d2c0b9ffa4e8ee66$export$bb38bb9a1161268 = "unmounted";
var $d2c0b9ffa4e8ee66$export$84cbff306f539230 = "exited";
var $d2c0b9ffa4e8ee66$export$df38205c966be359 = "entering";
var $d2c0b9ffa4e8ee66$export$78e9e6e3e014d60a = "entered";
var $d2c0b9ffa4e8ee66$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $d2c0b9ffa4e8ee66$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $7rgHR.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $d2c0b9ffa4e8ee66$export$84cbff306f539230;
                _this.appearStatus = $d2c0b9ffa4e8ee66$export$df38205c966be359;
            } else initialStatus = $d2c0b9ffa4e8ee66$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $d2c0b9ffa4e8ee66$export$bb38bb9a1161268;
        else initialStatus = $d2c0b9ffa4e8ee66$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $d2c0b9ffa4e8ee66$export$bb38bb9a1161268) return {
            status: $d2c0b9ffa4e8ee66$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $d2c0b9ffa4e8ee66$export$df38205c966be359 && status !== $d2c0b9ffa4e8ee66$export$78e9e6e3e014d60a) nextStatus = $d2c0b9ffa4e8ee66$export$df38205c966be359;
            } else if (status === $d2c0b9ffa4e8ee66$export$df38205c966be359 || status === $d2c0b9ffa4e8ee66$export$78e9e6e3e014d60a) nextStatus = $d2c0b9ffa4e8ee66$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $d2c0b9ffa4e8ee66$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($lOkAX))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $1vDy2.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $d2c0b9ffa4e8ee66$export$84cbff306f539230) this.setState({
            status: $d2c0b9ffa4e8ee66$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($lOkAX))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $3w1fM.default).disabled) {
            this.safeSetState({
                status: $d2c0b9ffa4e8ee66$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $d2c0b9ffa4e8ee66$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $d2c0b9ffa4e8ee66$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($lOkAX))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $3w1fM.default).disabled) {
            this.safeSetState({
                status: $d2c0b9ffa4e8ee66$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $d2c0b9ffa4e8ee66$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $d2c0b9ffa4e8ee66$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($lOkAX))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $d2c0b9ffa4e8ee66$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cAqXo.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createElement((0, $1MyB0.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).Component);
$d2c0b9ffa4e8ee66$var$Transition.contextType = (0, $1MyB0.default);
$d2c0b9ffa4e8ee66$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $d2c0b9ffa4e8ee66$var$noop() {}
$d2c0b9ffa4e8ee66$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $d2c0b9ffa4e8ee66$var$noop,
    onEntering: $d2c0b9ffa4e8ee66$var$noop,
    onEntered: $d2c0b9ffa4e8ee66$var$noop,
    onExit: $d2c0b9ffa4e8ee66$var$noop,
    onExiting: $d2c0b9ffa4e8ee66$var$noop,
    onExited: $d2c0b9ffa4e8ee66$var$noop
};
$d2c0b9ffa4e8ee66$var$Transition.UNMOUNTED = $d2c0b9ffa4e8ee66$export$bb38bb9a1161268;
$d2c0b9ffa4e8ee66$var$Transition.EXITED = $d2c0b9ffa4e8ee66$export$84cbff306f539230;
$d2c0b9ffa4e8ee66$var$Transition.ENTERING = $d2c0b9ffa4e8ee66$export$df38205c966be359;
$d2c0b9ffa4e8ee66$var$Transition.ENTERED = $d2c0b9ffa4e8ee66$export$78e9e6e3e014d60a;
$d2c0b9ffa4e8ee66$var$Transition.EXITING = $d2c0b9ffa4e8ee66$export$4aacc83d4d59139f;
var $d2c0b9ffa4e8ee66$export$2e2bcd8739ae039 = $d2c0b9ffa4e8ee66$var$Transition;

});
parcelRegister("3w1fM", function(module, exports) {

$parcel$export(module.exports, "default", () => $28f555282ba6a6c8$export$2e2bcd8739ae039);
var $28f555282ba6a6c8$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("1vDy2", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $11975d1f68c85878$export$7d26bbb1236dafd6);
var $11975d1f68c85878$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("iI1wU", function(module, exports) {

$parcel$export(module.exports, "reflow", () => $d9ed85d56f12712f$export$b7a864e1eaef9de5);
$parcel$export(module.exports, "getTransitionProps", () => $d9ed85d56f12712f$export$8cb1e9b404609ae9);
const $d9ed85d56f12712f$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $d9ed85d56f12712f$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

});

parcelRegister("hEP7F", function(module, exports) {

$parcel$export(module.exports, "getCollapseUtilityClass", () => $cdadd3fab2c90b25$export$5162da8f798e0959);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $cdadd3fab2c90b25$export$5162da8f798e0959(slot) {
    return (0, $6vnyE.default)("MuiCollapse", slot);
}
const $cdadd3fab2c90b25$var$collapseClasses = (0, $cyhE3.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
var $cdadd3fab2c90b25$export$2e2bcd8739ae039 = $cdadd3fab2c90b25$var$collapseClasses;

});


parcelRegister("7Wk6y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c7d8b8d3238a3d5$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");


var $b2r0b = parcelRequire("b2r0b");

var $63Oo6 = parcelRequire("63Oo6");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $f0YqC = parcelRequire("f0YqC");

var $eedeo = parcelRequire("eedeo");

var $gdH9i = parcelRequire("gdH9i");

var $7rfeq = parcelRequire("7rfeq");

var $8JEdX = parcelRequire("8JEdX");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $5c7d8b8d3238a3d5$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $5c7d8b8d3238a3d5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $63Oo6.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $7rfeq.getLinkUtilityClass), classes);
};
const $5c7d8b8d3238a3d5$var$LinkRoot = (0, $25zst.default)((0, $gdH9i.default), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $63Oo6.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $g6Hsb.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, $g6Hsb.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, $8JEdX.default)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $7rfeq.default).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $5c7d8b8d3238a3d5$var$Link = /*#__PURE__*/ $aOzEm.forwardRef(function Link(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit", sx: sx } = props, other = (0, $cAqXo.default)(props, $5c7d8b8d3238a3d5$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $f0YqC.default)();
    const [focusVisible, setFocusVisible] = $aOzEm.useState(false);
    const handlerRef = (0, $eedeo.default)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $g6Hsb.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $5c7d8b8d3238a3d5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($5c7d8b8d3238a3d5$var$LinkRoot, (0, $g6Hsb.default)({
        color: color,
        className: (0, $g45Wv.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $8JEdX.colorTransformations)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $5c7d8b8d3238a3d5$export$2e2bcd8739ae039 = $5c7d8b8d3238a3d5$var$Link;

});
parcelRegister("gdH9i", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcef54bdff1a9595$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $9LbnZ = parcelRequire("9LbnZ");

var $b2r0b = parcelRequire("b2r0b");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $63Oo6 = parcelRequire("63Oo6");

var $4KMU5 = parcelRequire("4KMU5");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $bcef54bdff1a9595$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $bcef54bdff1a9595$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $63Oo6.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $4KMU5.getTypographyUtilityClass), classes);
};
const $bcef54bdff1a9595$export$140e2f5526d3cad8 = (0, $25zst.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $63Oo6.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $bcef54bdff1a9595$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $bcef54bdff1a9595$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $bcef54bdff1a9595$var$transformDeprecatedColors = (color)=>{
    return $bcef54bdff1a9595$var$colorTransformations[color] || color;
};
const $bcef54bdff1a9595$var$Typography = /*#__PURE__*/ $aOzEm.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $bcef54bdff1a9595$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $9LbnZ.default)((0, $g6Hsb.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $bcef54bdff1a9595$var$defaultVariantMapping } = props, other = (0, $cAqXo.default)(props, $bcef54bdff1a9595$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $bcef54bdff1a9595$var$defaultVariantMapping[variant]) || "span";
    const classes = $bcef54bdff1a9595$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($bcef54bdff1a9595$export$140e2f5526d3cad8, (0, $g6Hsb.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $g45Wv.default)(classes.root, className)
    }, other));
});
var $bcef54bdff1a9595$export$2e2bcd8739ae039 = $bcef54bdff1a9595$var$Typography;

});
parcelRegister("4KMU5", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", () => $3761648ac7ff7edd$export$24c1f8f60cbac79e);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $3761648ac7ff7edd$export$24c1f8f60cbac79e(slot) {
    return (0, $6vnyE.default)("MuiTypography", slot);
}
const $3761648ac7ff7edd$var$typographyClasses = (0, $cyhE3.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $3761648ac7ff7edd$export$2e2bcd8739ae039 = $3761648ac7ff7edd$var$typographyClasses;

});


parcelRegister("7rfeq", function(module, exports) {

$parcel$export(module.exports, "getLinkUtilityClass", () => $56a6deba5516a49a$export$d6efab9620b78fec);
$parcel$export(module.exports, "default", () => $56a6deba5516a49a$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $56a6deba5516a49a$export$d6efab9620b78fec(slot) {
    return (0, $6vnyE.default)("MuiLink", slot);
}
const $56a6deba5516a49a$var$linkClasses = (0, $cyhE3.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $56a6deba5516a49a$export$2e2bcd8739ae039 = $56a6deba5516a49a$var$linkClasses;

});

parcelRegister("8JEdX", function(module, exports) {

$parcel$export(module.exports, "colorTransformations", () => $65c1ba62fd70b1b6$export$c4e140d5d351182b);
$parcel$export(module.exports, "default", () => $65c1ba62fd70b1b6$export$2e2bcd8739ae039);

var $fOENh = parcelRequire("fOENh");
var $kPcDk = parcelRequire("kPcDk");
const $65c1ba62fd70b1b6$export$c4e140d5d351182b = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $65c1ba62fd70b1b6$var$transformDeprecatedColors = (color)=>{
    return $65c1ba62fd70b1b6$export$c4e140d5d351182b[color] || color;
};
const $65c1ba62fd70b1b6$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $65c1ba62fd70b1b6$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $kPcDk.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $kPcDk.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $fOENh.alpha)(color, 0.4);
};
var $65c1ba62fd70b1b6$export$2e2bcd8739ae039 = $65c1ba62fd70b1b6$var$getTextDecoration;

});


parcelRegister("gvXbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c05d744779c35411$export$2e2bcd8739ae039);


var $6XLpC = parcelRequire("6XLpC");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");
"use client";
const $c05d744779c35411$var$Stack = (0, $6XLpC.default)({
    createStyledComponent: (0, $25zst.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $gEb5G.default)({
            props: inProps,
            name: "MuiStack"
        })
});
var $c05d744779c35411$export$2e2bcd8739ae039 = $c05d744779c35411$var$Stack;

});
parcelRegister("6XLpC", function(module, exports) {

$parcel$export(module.exports, "default", () => $511d07dbf5cc65d2$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $hH5Br = parcelRequire("hH5Br");
var $b2r0b = parcelRequire("b2r0b");
var $6vnyE = parcelRequire("6vnyE");

var $699oI = parcelRequire("699oI");

var $k00du = parcelRequire("k00du");

var $9LbnZ = parcelRequire("9LbnZ");

var $9TLkt = parcelRequire("9TLkt");

var $j3LVw = parcelRequire("j3LVw");

var $fupEq = parcelRequire("fupEq");

var $2T9xh = parcelRequire("2T9xh");
const $511d07dbf5cc65d2$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $511d07dbf5cc65d2$var$defaultTheme = (0, $9TLkt.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $511d07dbf5cc65d2$var$defaultCreateStyledComponent = (0, $699oI.default)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $511d07dbf5cc65d2$var$useThemePropsDefault(props) {
    return (0, $k00du.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $511d07dbf5cc65d2$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $511d07dbf5cc65d2$var$joinChildren(children, separator) {
    const childrenArray = $aOzEm.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $aOzEm.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $511d07dbf5cc65d2$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $511d07dbf5cc65d2$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $g6Hsb.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $j3LVw.handleBreakpoints)({
        theme: theme
    }, (0, $j3LVw.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $fupEq.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $j3LVw.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $j3LVw.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $fupEq.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$511d07dbf5cc65d2$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $fupEq.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $hH5Br.default)(styles, (0, $j3LVw.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $j3LVw.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $511d07dbf5cc65d2$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $511d07dbf5cc65d2$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $511d07dbf5cc65d2$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $b2r0b.default)(slots, (slot)=>(0, $6vnyE.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($511d07dbf5cc65d2$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $aOzEm.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $9LbnZ.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $cAqXo.default)(props, $511d07dbf5cc65d2$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $2T9xh.jsx)(StackRoot, (0, $g6Hsb.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $g45Wv.default)(classes.root, className)
        }, other, {
            children: divider ? $511d07dbf5cc65d2$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}

});
parcelRegister("699oI", function(module, exports) {

$parcel$export(module.exports, "default", () => $479adf88a222fe40$export$2e2bcd8739ae039);

var $jcnej = parcelRequire("jcnej");
const $479adf88a222fe40$var$styled = (0, $jcnej.default)();
var $479adf88a222fe40$export$2e2bcd8739ae039 = $479adf88a222fe40$var$styled;

});



parcelRegister("hvbBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbde5449ae6bcc9f$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");


var $iwvVh = parcelRequire("iwvVh");
var $b2r0b = parcelRequire("b2r0b");

var $fOENh = parcelRequire("fOENh");

var $25zst = parcelRequire("25zst");

var $57YGU = parcelRequire("57YGU");

var $gEb5G = parcelRequire("gEb5G");

var $63Oo6 = parcelRequire("63Oo6");

var $fe2oA = parcelRequire("fe2oA");

var $lDhl9 = parcelRequire("lDhl9");

var $aAt37 = parcelRequire("aAt37");

var $eedeo = parcelRequire("eedeo");

var $cqmYq = parcelRequire("cqmYq");

var $f0YqC = parcelRequire("f0YqC");

var $duffS = parcelRequire("duffS");

var $29Oj8 = parcelRequire("29Oj8");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $cbde5449ae6bcc9f$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $cbde5449ae6bcc9f$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $cbde5449ae6bcc9f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $63Oo6.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $29Oj8.getTooltipUtilityClass), classes);
};
const $cbde5449ae6bcc9f$var$TooltipPopper = (0, $25zst.default)((0, $lDhl9.default), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $g6Hsb.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $29Oj8.default).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $29Oj8.default).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $29Oj8.default).arrow}`]: (0, $g6Hsb.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $29Oj8.default).arrow}`]: (0, $g6Hsb.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $cbde5449ae6bcc9f$var$TooltipTooltip = (0, $25zst.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $63Oo6.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $fOENh.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$cbde5449ae6bcc9f$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $29Oj8.default).popper}[data-popper-placement*="left"] &`]: (0, $g6Hsb.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $g6Hsb.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $g6Hsb.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $29Oj8.default).popper}[data-popper-placement*="right"] &`]: (0, $g6Hsb.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $g6Hsb.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $g6Hsb.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $29Oj8.default).popper}[data-popper-placement*="top"] &`]: (0, $g6Hsb.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $29Oj8.default).popper}[data-popper-placement*="bottom"] &`]: (0, $g6Hsb.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $cbde5449ae6bcc9f$var$TooltipArrow = (0, $25zst.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $fOENh.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $cbde5449ae6bcc9f$var$hystersisOpen = false;
let $cbde5449ae6bcc9f$var$hystersisTimer = null;
let $cbde5449ae6bcc9f$var$cursorPosition = {
    x: 0,
    y: 0
};
function $cbde5449ae6bcc9f$export$b9ee5a7ace0541f8() {
    $cbde5449ae6bcc9f$var$hystersisOpen = false;
    clearTimeout($cbde5449ae6bcc9f$var$hystersisTimer);
}
function $cbde5449ae6bcc9f$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $cbde5449ae6bcc9f$var$Tooltip = /*#__PURE__*/ $aOzEm.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $fe2oA.default), TransitionProps: TransitionProps } = props, other = (0, $cAqXo.default)(props, $cbde5449ae6bcc9f$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $aOzEm.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $2T9xh.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $57YGU.default)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = $aOzEm.useState();
    const [arrowRef, setArrowRef] = $aOzEm.useState(null);
    const ignoreNonTouchEvents = $aOzEm.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = $aOzEm.useRef();
    const enterTimer = $aOzEm.useRef();
    const leaveTimer = $aOzEm.useRef();
    const touchTimer = $aOzEm.useRef();
    const [openState, setOpenState] = (0, $duffS.default)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $cqmYq.default)(idProp);
    const prevUserSelect = $aOzEm.useRef();
    const stopTouchInteraction = $aOzEm.useCallback(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        clearTimeout(touchTimer.current);
    }, []);
    $aOzEm.useEffect(()=>{
        return ()=>{
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            stopTouchInteraction();
        };
    }, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        clearTimeout($cbde5449ae6bcc9f$var$hystersisTimer);
        $cbde5449ae6bcc9f$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $aAt37.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        clearTimeout($cbde5449ae6bcc9f$var$hystersisTimer);
        $cbde5449ae6bcc9f$var$hystersisTimer = setTimeout(()=>{
            $cbde5449ae6bcc9f$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose && open) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(()=>{
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        if (enterDelay || $cbde5449ae6bcc9f$var$hystersisOpen && enterNextDelay) enterTimer.current = setTimeout(()=>{
            handleOpen(event);
        }, $cbde5449ae6bcc9f$var$hystersisOpen ? enterNextDelay : enterDelay);
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveDelay);
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $f0YqC.default)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $aOzEm.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.current = setTimeout(()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        }, enterTouchDelay);
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveTouchDelay);
    };
    $aOzEm.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $eedeo.default)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    if (!title && title !== 0) open = false;
    const popperRef = $aOzEm.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $cbde5449ae6bcc9f$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $g6Hsb.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $g45Wv.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $cbde5449ae6bcc9f$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $cbde5449ae6bcc9f$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $cbde5449ae6bcc9f$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $cbde5449ae6bcc9f$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $aOzEm.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $g6Hsb.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $cbde5449ae6bcc9f$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $cbde5449ae6bcc9f$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $fe2oA.default);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $cbde5449ae6bcc9f$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $cbde5449ae6bcc9f$var$TooltipArrow;
    const popperProps = (0, $iwvVh.appendOwnerState)(PopperComponent, (0, $g6Hsb.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $g45Wv.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $iwvVh.appendOwnerState)(TransitionComponent, (0, $g6Hsb.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $iwvVh.appendOwnerState)(TooltipComponent, (0, $g6Hsb.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $g45Wv.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $iwvVh.appendOwnerState)(ArrowComponent, (0, $g6Hsb.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $g45Wv.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($aOzEm.Fragment, {
        children: [
            /*#__PURE__*/ $aOzEm.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $2T9xh.jsx)(PopperComponent, (0, $g6Hsb.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $lDhl9.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $cbde5449ae6bcc9f$var$cursorPosition.y,
                            left: $cbde5449ae6bcc9f$var$cursorPosition.x,
                            right: $cbde5449ae6bcc9f$var$cursorPosition.x,
                            bottom: $cbde5449ae6bcc9f$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $2T9xh.jsx)(TransitionComponent, (0, $g6Hsb.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $2T9xh.jsxs)(TooltipComponent, (0, $g6Hsb.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $2T9xh.jsx)(ArrowComponent, (0, $g6Hsb.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $cbde5449ae6bcc9f$export$2e2bcd8739ae039 = $cbde5449ae6bcc9f$var$Tooltip;

});
parcelRegister("iwvVh", function(module, exports) {

$parcel$export(module.exports, "appendOwnerState", () => $d7c3fa5b706ef9d3$export$b089efb01a7bdf50);

var $g6Hsb = parcelRequire("g6Hsb");

var $cwzzR = parcelRequire("cwzzR");
function $d7c3fa5b706ef9d3$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $cwzzR.isHostComponent)(elementType)) return otherProps;
    return (0, $g6Hsb.default)({}, otherProps, {
        ownerState: (0, $g6Hsb.default)({}, otherProps.ownerState, ownerState)
    });
}

});
parcelRegister("cwzzR", function(module, exports) {

$parcel$export(module.exports, "isHostComponent", () => $91e4121bbcf420eb$export$e28348cc2430497);
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $91e4121bbcf420eb$export$e28348cc2430497(element) {
    return typeof element === "string";
}

});


parcelRegister("fe2oA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b15a058a7b51490d$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $aOzEm = parcelRequire("aOzEm");



var $i5PBN = parcelRequire("i5PBN");

var $57YGU = parcelRequire("57YGU");

var $iI1wU = parcelRequire("iI1wU");

var $eedeo = parcelRequire("eedeo");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $b15a058a7b51490d$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $b15a058a7b51490d$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $b15a058a7b51490d$var$styles = {
    entering: {
        opacity: 1,
        transform: $b15a058a7b51490d$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $b15a058a7b51490d$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $b15a058a7b51490d$var$Grow = /*#__PURE__*/ $aOzEm.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $i5PBN.default) } = props, other = (0, $cAqXo.default)(props, $b15a058a7b51490d$var$_excluded);
    const timer = $aOzEm.useRef();
    const autoTimeout = $aOzEm.useRef();
    const theme = (0, $57YGU.default)();
    const nodeRef = $aOzEm.useRef(null);
    const handleRef = (0, $eedeo.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $iI1wU.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $iI1wU.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $b15a058a7b51490d$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $iI1wU.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $b15a058a7b51490d$var$isWebKit154 ? duration : duration * 0.666,
                delay: $b15a058a7b51490d$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $b15a058a7b51490d$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $aOzEm.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $2T9xh.jsx)(TransitionComponent, (0, $g6Hsb.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $aOzEm.cloneElement(children, (0, $g6Hsb.default)({
                style: (0, $g6Hsb.default)({
                    opacity: 0,
                    transform: $b15a058a7b51490d$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $b15a058a7b51490d$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$b15a058a7b51490d$var$Grow.muiSupportAuto = true;
var $b15a058a7b51490d$export$2e2bcd8739ae039 = $b15a058a7b51490d$var$Grow;

});

parcelRegister("lDhl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbfab0e25b2c9f96$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $hazws = parcelRequire("hazws");

var $8BSy0 = parcelRequire("8BSy0");



var $aOzEm = parcelRequire("aOzEm");

var $25zst = parcelRequire("25zst");
var $gEb5G = parcelRequire("gEb5G");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $fbfab0e25b2c9f96$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $fbfab0e25b2c9f96$var$PopperRoot = (0, $25zst.default)((0, $hazws.Popper), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $fbfab0e25b2c9f96$var$Popper = /*#__PURE__*/ $aOzEm.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, $8BSy0.default)();
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $cAqXo.default)(props, $fbfab0e25b2c9f96$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $g6Hsb.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($fbfab0e25b2c9f96$var$PopperRoot, (0, $g6Hsb.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $fbfab0e25b2c9f96$export$2e2bcd8739ae039 = $fbfab0e25b2c9f96$var$Popper;

});
parcelRegister("hazws", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $c7feece3c290fde7$export$badac9ada3a0bdf9);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $aOzEm = parcelRequire("aOzEm");

var $6Bp1O = parcelRequire("6Bp1O");
var $3jQQ9 = parcelRequire("3jQQ9");
var $6KMJ0 = parcelRequire("6KMJ0");

var $eC8JC = parcelRequire("eC8JC");


var $b2r0b = parcelRequire("b2r0b");

var $bRiYQ = parcelRequire("bRiYQ");

var $iT5tT = parcelRequire("iT5tT");

var $74GFZ = parcelRequire("74GFZ");

var $2Nbvd = parcelRequire("2Nbvd");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $c7feece3c290fde7$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $c7feece3c290fde7$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $c7feece3c290fde7$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $c7feece3c290fde7$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $c7feece3c290fde7$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $c7feece3c290fde7$var$isVirtualElement(element) {
    return !$c7feece3c290fde7$var$isHTMLElement(element);
}
const $c7feece3c290fde7$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $2Nbvd.useClassNamesOverride)((0, $iT5tT.getPopperUtilityClass)));
};
const $c7feece3c290fde7$var$defaultPopperOptions = {};
const $c7feece3c290fde7$var$PopperTooltip = /*#__PURE__*/ $aOzEm.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $cAqXo.default)(props, $c7feece3c290fde7$var$_excluded);
    const tooltipRef = $aOzEm.useRef(null);
    const ownRef = (0, $6KMJ0.default)(tooltipRef, forwardedRef);
    const popperRef = $aOzEm.useRef(null);
    const handlePopperRef = (0, $6KMJ0.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $aOzEm.useRef(handlePopperRef);
    (0, $3jQQ9.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $aOzEm.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $c7feece3c290fde7$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $aOzEm.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $aOzEm.useState($c7feece3c290fde7$var$resolveAnchorEl(anchorEl));
    $aOzEm.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $aOzEm.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($c7feece3c290fde7$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $3jQQ9.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $eC8JC.createPopper)(resolvedAnchorElement, tooltipRef.current, (0, $g6Hsb.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $c7feece3c290fde7$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $74GFZ.useSlotProps)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $2T9xh.jsx)(Root, (0, $g6Hsb.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $c7feece3c290fde7$export$badac9ada3a0bdf9 = /*#__PURE__*/ $aOzEm.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $c7feece3c290fde7$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $cAqXo.default)(props, $c7feece3c290fde7$var$_excluded2);
    const [exited, setExited] = $aOzEm.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $c7feece3c290fde7$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $c7feece3c290fde7$var$isHTMLElement(resolvedAnchorEl) ? (0, $6Bp1O.default)(resolvedAnchorEl).body : (0, $6Bp1O.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $bRiYQ.Portal), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)($c7feece3c290fde7$var$PopperTooltip, (0, $g6Hsb.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $g6Hsb.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});

});
parcelRegister("6Bp1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ce99cdd66068947$export$2e2bcd8739ae039);
function $4ce99cdd66068947$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("eC8JC", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $aa3b63d891f91fec$export$8f7491d57c8f97a9);

var $4V275 = parcelRequire("4V275");

var $geQuT = parcelRequire("geQuT");

var $7ZHE0 = parcelRequire("7ZHE0");

var $afU4d = parcelRequire("afU4d");

var $aXiGB = parcelRequire("aXiGB");

var $hG2VF = parcelRequire("hG2VF");

var $4IRle = parcelRequire("4IRle");

var $ld8FA = parcelRequire("ld8FA");

var $lf1nX = parcelRequire("lf1nX");

var $9oFx8 = parcelRequire("9oFx8");


var $aa3b63d891f91fec$export$d34966752335dd47 = [
    (0, $geQuT.default),
    (0, $7ZHE0.default),
    (0, $afU4d.default),
    (0, $aXiGB.default),
    (0, $hG2VF.default),
    (0, $4IRle.default),
    (0, $ld8FA.default),
    (0, $lf1nX.default),
    (0, $9oFx8.default)
];
var $aa3b63d891f91fec$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $4V275.popperGenerator)({
    defaultModifiers: $aa3b63d891f91fec$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("4V275", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $394e1ff770634326$export$ed5e13716264f202);

var $jMA7q = parcelRequire("jMA7q");

var $4kMg2 = parcelRequire("4kMg2");

var $lUXC0 = parcelRequire("lUXC0");

var $5OFrK = parcelRequire("5OFrK");

var $atXp6 = parcelRequire("atXp6");

var $gYKMa = parcelRequire("gYKMa");

var $c6qvH = parcelRequire("c6qvH");


var $5CNaU = parcelRequire("5CNaU");
var $394e1ff770634326$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $394e1ff770634326$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $394e1ff770634326$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $394e1ff770634326$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $394e1ff770634326$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $5CNaU.isElement)(reference) ? (0, $lUXC0.default)(reference) : reference.contextElement ? (0, $lUXC0.default)(reference.contextElement) : [],
                    popper: (0, $lUXC0.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $atXp6.default)((0, $c6qvH.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$394e1ff770634326$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $jMA7q.default)(reference, (0, $5OFrK.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $4kMg2.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $gYKMa.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$394e1ff770634326$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $394e1ff770634326$export$8f7491d57c8f97a9 = /*#__PURE__*/ $394e1ff770634326$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("jMA7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $e66e8477a5d7283e$export$2e2bcd8739ae039);

var $f53mG = parcelRequire("f53mG");

var $9mACt = parcelRequire("9mACt");

var $fY2kK = parcelRequire("fY2kK");

var $5CNaU = parcelRequire("5CNaU");

var $7gY7D = parcelRequire("7gY7D");

var $ge6D4 = parcelRequire("ge6D4");

var $2a0mE = parcelRequire("2a0mE");

var $1FFOO = parcelRequire("1FFOO");
function $e66e8477a5d7283e$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $1FFOO.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $1FFOO.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $e66e8477a5d7283e$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $5CNaU.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $5CNaU.isHTMLElement)(offsetParent) && $e66e8477a5d7283e$var$isElementScaled(offsetParent);
    var documentElement = (0, $ge6D4.default)(offsetParent);
    var rect = (0, $f53mG.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $fY2kK.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $2a0mE.default)(documentElement)) scroll = (0, $9mACt.default)(offsetParent);
        if ((0, $5CNaU.isHTMLElement)(offsetParent)) {
            offsets = (0, $f53mG.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $7gY7D.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("f53mG", function(module, exports) {

$parcel$export(module.exports, "default", () => $afa9eedae7533fcc$export$2e2bcd8739ae039);

var $5CNaU = parcelRequire("5CNaU");

var $1FFOO = parcelRequire("1FFOO");

var $kEyle = parcelRequire("kEyle");

var $ciyDt = parcelRequire("ciyDt");
function $afa9eedae7533fcc$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $5CNaU.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $1FFOO.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $1FFOO.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $5CNaU.isElement)(element) ? (0, $kEyle.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $ciyDt.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("5CNaU", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $4186a5771eea5d10$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $4186a5771eea5d10$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $4186a5771eea5d10$export$af51f0f06c0f328a);

var $kEyle = parcelRequire("kEyle");
function $4186a5771eea5d10$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $kEyle.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $4186a5771eea5d10$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $kEyle.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $4186a5771eea5d10$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $kEyle.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("kEyle", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0922e8f7aa887c1$export$2e2bcd8739ae039);
function $f0922e8f7aa887c1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("1FFOO", function(module, exports) {

$parcel$export(module.exports, "max", () => $137a0f0dfbf7c046$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $137a0f0dfbf7c046$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $137a0f0dfbf7c046$export$2077e0241d6afd3c);
var $137a0f0dfbf7c046$export$8960430cfd85939f = Math.max;
var $137a0f0dfbf7c046$export$96ec731ed4dcb222 = Math.min;
var $137a0f0dfbf7c046$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("ciyDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f42086afab857b8$export$2e2bcd8739ae039);

var $hxHUO = parcelRequire("hxHUO");
function $8f42086afab857b8$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $hxHUO.default)());
}

});
parcelRegister("hxHUO", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc579563b10a4ab7$export$2e2bcd8739ae039);
function $cc579563b10a4ab7$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("9mACt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d12930634d6054a$export$2e2bcd8739ae039);

var $2yPuF = parcelRequire("2yPuF");

var $kEyle = parcelRequire("kEyle");

var $5CNaU = parcelRequire("5CNaU");

var $5TLOj = parcelRequire("5TLOj");
function $6d12930634d6054a$export$2e2bcd8739ae039(node) {
    if (node === (0, $kEyle.default)(node) || !(0, $5CNaU.isHTMLElement)(node)) return (0, $2yPuF.default)(node);
    else return (0, $5TLOj.default)(node);
}

});
parcelRegister("2yPuF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dd6b3515f502917$export$2e2bcd8739ae039);

var $kEyle = parcelRequire("kEyle");
function $1dd6b3515f502917$export$2e2bcd8739ae039(node) {
    var win = (0, $kEyle.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("5TLOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $44b72cf3a7c62a9d$export$2e2bcd8739ae039);
function $44b72cf3a7c62a9d$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("fY2kK", function(module, exports) {

$parcel$export(module.exports, "default", () => $02fff8db01f807d6$export$2e2bcd8739ae039);
function $02fff8db01f807d6$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("7gY7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $54b8aa061856937f$export$2e2bcd8739ae039);

var $f53mG = parcelRequire("f53mG");

var $ge6D4 = parcelRequire("ge6D4");

var $2yPuF = parcelRequire("2yPuF");
function $54b8aa061856937f$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $f53mG.default)((0, $ge6D4.default)(element)).left + (0, $2yPuF.default)(element).scrollLeft;
}

});
parcelRegister("ge6D4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd031895c4c5a48f$export$2e2bcd8739ae039);

var $5CNaU = parcelRequire("5CNaU");
function $bd031895c4c5a48f$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $5CNaU.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("2a0mE", function(module, exports) {

$parcel$export(module.exports, "default", () => $192ccc49605a69d0$export$2e2bcd8739ae039);

var $d5uEE = parcelRequire("d5uEE");
function $192ccc49605a69d0$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $d5uEE.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("d5uEE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9873855962048939$export$2e2bcd8739ae039);

var $kEyle = parcelRequire("kEyle");
function $9873855962048939$export$2e2bcd8739ae039(element) {
    return (0, $kEyle.default)(element).getComputedStyle(element);
}

});



parcelRegister("4kMg2", function(module, exports) {

$parcel$export(module.exports, "default", () => $327e76acf6dd7194$export$2e2bcd8739ae039);

var $f53mG = parcelRequire("f53mG");
function $327e76acf6dd7194$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $f53mG.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("lUXC0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff4d11a1dc936d8d$export$2e2bcd8739ae039);

var $alKvn = parcelRequire("alKvn");

var $euare = parcelRequire("euare");

var $kEyle = parcelRequire("kEyle");

var $2a0mE = parcelRequire("2a0mE");
function $ff4d11a1dc936d8d$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $alKvn.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $kEyle.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $2a0mE.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($ff4d11a1dc936d8d$export$2e2bcd8739ae039((0, $euare.default)(target)));
}

});
parcelRegister("alKvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $788ff07baf238f45$export$2e2bcd8739ae039);

var $euare = parcelRequire("euare");

var $2a0mE = parcelRequire("2a0mE");

var $fY2kK = parcelRequire("fY2kK");

var $5CNaU = parcelRequire("5CNaU");
function $788ff07baf238f45$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $fY2kK.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $5CNaU.isHTMLElement)(node) && (0, $2a0mE.default)(node)) return node;
    return $788ff07baf238f45$export$2e2bcd8739ae039((0, $euare.default)(node));
}

});
parcelRegister("euare", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8bbf6dda45b8c85$export$2e2bcd8739ae039);

var $fY2kK = parcelRequire("fY2kK");

var $ge6D4 = parcelRequire("ge6D4");

var $5CNaU = parcelRequire("5CNaU");
function $a8bbf6dda45b8c85$export$2e2bcd8739ae039(element) {
    if ((0, $fY2kK.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $5CNaU.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $ge6D4.default)(element) // fallback
    );
}

});



parcelRegister("5OFrK", function(module, exports) {

$parcel$export(module.exports, "default", () => $43c1c5b180461f85$export$2e2bcd8739ae039);

var $kEyle = parcelRequire("kEyle");

var $fY2kK = parcelRequire("fY2kK");

var $d5uEE = parcelRequire("d5uEE");

var $5CNaU = parcelRequire("5CNaU");

var $1IdSj = parcelRequire("1IdSj");

var $euare = parcelRequire("euare");

var $hxHUO = parcelRequire("hxHUO");
function $43c1c5b180461f85$var$getTrueOffsetParent(element) {
    if (!(0, $5CNaU.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $d5uEE.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $43c1c5b180461f85$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $hxHUO.default)());
    var isIE = /Trident/i.test((0, $hxHUO.default)());
    if (isIE && (0, $5CNaU.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $d5uEE.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $euare.default)(element);
    if ((0, $5CNaU.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $5CNaU.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $fY2kK.default)(currentNode)) < 0){
        var css = (0, $d5uEE.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $43c1c5b180461f85$export$2e2bcd8739ae039(element) {
    var window = (0, $kEyle.default)(element);
    var offsetParent = $43c1c5b180461f85$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $1IdSj.default)(offsetParent) && (0, $d5uEE.default)(offsetParent).position === "static")offsetParent = $43c1c5b180461f85$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $fY2kK.default)(offsetParent) === "html" || (0, $fY2kK.default)(offsetParent) === "body" && (0, $d5uEE.default)(offsetParent).position === "static")) return window;
    return offsetParent || $43c1c5b180461f85$var$getContainingBlock(element) || window;
}

});
parcelRegister("1IdSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $13f4a9d0968bf6e0$export$2e2bcd8739ae039);

var $fY2kK = parcelRequire("fY2kK");
function $13f4a9d0968bf6e0$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $fY2kK.default)(element)) >= 0;
}

});


parcelRegister("atXp6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a1ab12a86bd2428$export$2e2bcd8739ae039);

var $4Zd7m = parcelRequire("4Zd7m");
function $7a1ab12a86bd2428$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $7a1ab12a86bd2428$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $7a1ab12a86bd2428$var$order(modifiers); // order based on phase
    return (0, $4Zd7m.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("4Zd7m", function(module, exports) {

$parcel$export(module.exports, "top", () => $3a1708db4f88a35d$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $3a1708db4f88a35d$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $3a1708db4f88a35d$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $3a1708db4f88a35d$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $3a1708db4f88a35d$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $3a1708db4f88a35d$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $3a1708db4f88a35d$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $3a1708db4f88a35d$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $3a1708db4f88a35d$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $3a1708db4f88a35d$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $3a1708db4f88a35d$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $3a1708db4f88a35d$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $3a1708db4f88a35d$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $3a1708db4f88a35d$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $3a1708db4f88a35d$export$d087d3878fdf71d5);
var $3a1708db4f88a35d$export$1e95b668f3b82d = "top";
var $3a1708db4f88a35d$export$40e543e69a8b3fbb = "bottom";
var $3a1708db4f88a35d$export$79ffe56a765070d2 = "right";
var $3a1708db4f88a35d$export$eabcd2c8791e7bf4 = "left";
var $3a1708db4f88a35d$export$dfb5619354ba860 = "auto";
var $3a1708db4f88a35d$export$aec2ce47c367b8c3 = [
    $3a1708db4f88a35d$export$1e95b668f3b82d,
    $3a1708db4f88a35d$export$40e543e69a8b3fbb,
    $3a1708db4f88a35d$export$79ffe56a765070d2,
    $3a1708db4f88a35d$export$eabcd2c8791e7bf4
];
var $3a1708db4f88a35d$export$b3571188c770cc5a = "start";
var $3a1708db4f88a35d$export$bd5df0f255a350f8 = "end";
var $3a1708db4f88a35d$export$390fd549c5303b4d = "clippingParents";
var $3a1708db4f88a35d$export$d7b7311ec04a3e8f = "viewport";
var $3a1708db4f88a35d$export$ae5ab1c730825774 = "popper";
var $3a1708db4f88a35d$export$ca50aac9f3ba507f = "reference";
var $3a1708db4f88a35d$export$368f9a87e87fa4e1 = /*#__PURE__*/ $3a1708db4f88a35d$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $3a1708db4f88a35d$export$b3571188c770cc5a,
        placement + "-" + $3a1708db4f88a35d$export$bd5df0f255a350f8
    ]);
}, []);
var $3a1708db4f88a35d$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($3a1708db4f88a35d$export$aec2ce47c367b8c3, [
    $3a1708db4f88a35d$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $3a1708db4f88a35d$export$b3571188c770cc5a,
        placement + "-" + $3a1708db4f88a35d$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $3a1708db4f88a35d$export$421679a7c3d56e = "beforeRead";
var $3a1708db4f88a35d$export$aafa59e2e03f2942 = "read";
var $3a1708db4f88a35d$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $3a1708db4f88a35d$export$c65e99957a05207c = "beforeMain";
var $3a1708db4f88a35d$export$f22da7240b7add18 = "main";
var $3a1708db4f88a35d$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $3a1708db4f88a35d$export$8d4d2d70e7d46032 = "beforeWrite";
var $3a1708db4f88a35d$export$68d8715fc104d294 = "write";
var $3a1708db4f88a35d$export$70a6e5159acce2e6 = "afterWrite";
var $3a1708db4f88a35d$export$d087d3878fdf71d5 = [
    $3a1708db4f88a35d$export$421679a7c3d56e,
    $3a1708db4f88a35d$export$aafa59e2e03f2942,
    $3a1708db4f88a35d$export$6964f6c886723980,
    $3a1708db4f88a35d$export$c65e99957a05207c,
    $3a1708db4f88a35d$export$f22da7240b7add18,
    $3a1708db4f88a35d$export$bab79516f2d662fe,
    $3a1708db4f88a35d$export$8d4d2d70e7d46032,
    $3a1708db4f88a35d$export$68d8715fc104d294,
    $3a1708db4f88a35d$export$70a6e5159acce2e6
];

});


parcelRegister("gYKMa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5c688ac57331c1a$export$2e2bcd8739ae039);
function $c5c688ac57331c1a$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("c6qvH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cfa9bf4dfeedca2$export$2e2bcd8739ae039);
function $8cfa9bf4dfeedca2$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("geQuT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd26ad04ef1bada5$export$2e2bcd8739ae039);

var $kEyle = parcelRequire("kEyle");
var $bd26ad04ef1bada5$var$passive = {
    passive: true
};
function $bd26ad04ef1bada5$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $kEyle.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $bd26ad04ef1bada5$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $bd26ad04ef1bada5$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $bd26ad04ef1bada5$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $bd26ad04ef1bada5$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $bd26ad04ef1bada5$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $bd26ad04ef1bada5$var$effect,
    data: {}
};

});

parcelRegister("7ZHE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d2015bf8c5b2396$export$2e2bcd8739ae039);

var $bhdYs = parcelRequire("bhdYs");
function $5d2015bf8c5b2396$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $bhdYs.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $5d2015bf8c5b2396$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $5d2015bf8c5b2396$var$popperOffsets,
    data: {}
};

});
parcelRegister("bhdYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $835c1f320f0d62d6$export$2e2bcd8739ae039);

var $d5PQg = parcelRequire("d5PQg");

var $cekwV = parcelRequire("cekwV");

var $avRZ6 = parcelRequire("avRZ6");

var $4Zd7m = parcelRequire("4Zd7m");
function $835c1f320f0d62d6$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $d5PQg.default)(placement) : null;
    var variation = placement ? (0, $cekwV.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $4Zd7m.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $4Zd7m.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $4Zd7m.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $4Zd7m.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $avRZ6.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $4Zd7m.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $4Zd7m.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("d5PQg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9883f4b6a2f14ae9$export$2e2bcd8739ae039);

function $9883f4b6a2f14ae9$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("cekwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e76b7b3b354dcef$export$2e2bcd8739ae039);
function $8e76b7b3b354dcef$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("avRZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a76acd08dbb713b$export$2e2bcd8739ae039);
function $7a76acd08dbb713b$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("afU4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $7776cbd36b16dfec$export$2e2bcd8739ae039);

var $4Zd7m = parcelRequire("4Zd7m");

var $5OFrK = parcelRequire("5OFrK");

var $kEyle = parcelRequire("kEyle");

var $ge6D4 = parcelRequire("ge6D4");

var $d5uEE = parcelRequire("d5uEE");

var $d5PQg = parcelRequire("d5PQg");

var $cekwV = parcelRequire("cekwV");

var $1FFOO = parcelRequire("1FFOO");
var $7776cbd36b16dfec$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $7776cbd36b16dfec$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $1FFOO.round)(x * dpr) / dpr || 0,
        y: (0, $1FFOO.round)(y * dpr) / dpr || 0
    };
}
function $7776cbd36b16dfec$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $4Zd7m.left);
    var sideY = (0, $4Zd7m.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5OFrK.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $kEyle.default)(popper)) {
            offsetParent = (0, $ge6D4.default)(popper);
            if ((0, $d5uEE.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $4Zd7m.top) || (placement === (0, $4Zd7m.left) || placement === (0, $4Zd7m.right)) && variation === (0, $4Zd7m.end)) {
            sideY = (0, $4Zd7m.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $4Zd7m.left) || (placement === (0, $4Zd7m.top) || placement === (0, $4Zd7m.bottom)) && variation === (0, $4Zd7m.end)) {
            sideX = (0, $4Zd7m.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $7776cbd36b16dfec$var$unsetSides);
    var _ref4 = roundOffsets === true ? $7776cbd36b16dfec$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $kEyle.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $7776cbd36b16dfec$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $d5PQg.default)(state.placement),
        variation: (0, $cekwV.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $7776cbd36b16dfec$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $7776cbd36b16dfec$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $7776cbd36b16dfec$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $7776cbd36b16dfec$var$computeStyles,
    data: {}
};

});

parcelRegister("aXiGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f9de8c61072731b$export$2e2bcd8739ae039);

var $fY2kK = parcelRequire("fY2kK");

var $5CNaU = parcelRequire("5CNaU");
// and applies them to the HTMLElements such as popper and arrow
function $7f9de8c61072731b$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $5CNaU.isHTMLElement)(element) || !(0, $fY2kK.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7f9de8c61072731b$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $5CNaU.isHTMLElement)(element) || !(0, $fY2kK.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7f9de8c61072731b$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7f9de8c61072731b$var$applyStyles,
    effect: $7f9de8c61072731b$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("hG2VF", function(module, exports) {

$parcel$export(module.exports, "default", () => $cde8a1989376ed8d$export$2e2bcd8739ae039);

var $d5PQg = parcelRequire("d5PQg");

var $4Zd7m = parcelRequire("4Zd7m");
function $cde8a1989376ed8d$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $d5PQg.default)(placement);
    var invertDistance = [
        (0, $4Zd7m.left),
        (0, $4Zd7m.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $4Zd7m.left),
        (0, $4Zd7m.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $cde8a1989376ed8d$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $4Zd7m.placements).reduce(function(acc, placement) {
        acc[placement] = $cde8a1989376ed8d$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cde8a1989376ed8d$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $cde8a1989376ed8d$var$offset
};

});

parcelRegister("4IRle", function(module, exports) {

$parcel$export(module.exports, "default", () => $3704a5f7a6c24605$export$2e2bcd8739ae039);

var $uFQ0A = parcelRequire("uFQ0A");

var $d5PQg = parcelRequire("d5PQg");

var $2tYGh = parcelRequire("2tYGh");

var $9jDm5 = parcelRequire("9jDm5");

var $dnvUn = parcelRequire("dnvUn");

var $4Zd7m = parcelRequire("4Zd7m");

var $cekwV = parcelRequire("cekwV");
function $3704a5f7a6c24605$var$getExpandedFallbackPlacements(placement) {
    if ((0, $d5PQg.default)(placement) === (0, $4Zd7m.auto)) return [];
    var oppositePlacement = (0, $uFQ0A.default)(placement);
    return [
        (0, $2tYGh.default)(placement),
        oppositePlacement,
        (0, $2tYGh.default)(oppositePlacement)
    ];
}
function $3704a5f7a6c24605$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $d5PQg.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $uFQ0A.default)(preferredPlacement)
    ] : $3704a5f7a6c24605$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $d5PQg.default)(placement) === (0, $4Zd7m.auto) ? (0, $dnvUn.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $d5PQg.default)(placement);
        var isStartVariation = (0, $cekwV.default)(placement) === (0, $4Zd7m.start);
        var isVertical = [
            (0, $4Zd7m.top),
            (0, $4Zd7m.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $9jDm5.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $4Zd7m.right) : (0, $4Zd7m.left) : isStartVariation ? (0, $4Zd7m.bottom) : (0, $4Zd7m.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $uFQ0A.default)(mainVariationSide);
        var altVariationSide = (0, $uFQ0A.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $3704a5f7a6c24605$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $3704a5f7a6c24605$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("uFQ0A", function(module, exports) {

$parcel$export(module.exports, "default", () => $05c34194dd1266c0$export$2e2bcd8739ae039);
var $05c34194dd1266c0$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $05c34194dd1266c0$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $05c34194dd1266c0$var$hash[matched];
    });
}

});

parcelRegister("2tYGh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ced5c2dd1b69044$export$2e2bcd8739ae039);
var $1ced5c2dd1b69044$var$hash = {
    start: "end",
    end: "start"
};
function $1ced5c2dd1b69044$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $1ced5c2dd1b69044$var$hash[matched];
    });
}

});

parcelRegister("9jDm5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c846a85ce9a27c3$export$2e2bcd8739ae039);

var $5HE9Q = parcelRequire("5HE9Q");

var $ge6D4 = parcelRequire("ge6D4");

var $f53mG = parcelRequire("f53mG");

var $bhdYs = parcelRequire("bhdYs");

var $5dvEh = parcelRequire("5dvEh");

var $4Zd7m = parcelRequire("4Zd7m");

var $5CNaU = parcelRequire("5CNaU");

var $aZYrb = parcelRequire("aZYrb");

var $4kO7M = parcelRequire("4kO7M");
function $6c846a85ce9a27c3$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $4Zd7m.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $4Zd7m.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $4Zd7m.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $aZYrb.default)(typeof padding !== "number" ? padding : (0, $4kO7M.default)(padding, (0, $4Zd7m.basePlacements)));
    var altContext = elementContext === (0, $4Zd7m.popper) ? (0, $4Zd7m.reference) : (0, $4Zd7m.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5HE9Q.default)((0, $5CNaU.isElement)(element) ? element : element.contextElement || (0, $ge6D4.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $f53mG.default)(state.elements.reference);
    var popperOffsets = (0, $bhdYs.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $5dvEh.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $4Zd7m.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $4Zd7m.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $4Zd7m.right),
                (0, $4Zd7m.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $4Zd7m.top),
                (0, $4Zd7m.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5HE9Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $42701e671a7ea99e$export$2e2bcd8739ae039);

var $4Zd7m = parcelRequire("4Zd7m");

var $cU2ab = parcelRequire("cU2ab");

var $5br61 = parcelRequire("5br61");

var $lUXC0 = parcelRequire("lUXC0");

var $5OFrK = parcelRequire("5OFrK");

var $ge6D4 = parcelRequire("ge6D4");

var $d5uEE = parcelRequire("d5uEE");

var $5CNaU = parcelRequire("5CNaU");

var $f53mG = parcelRequire("f53mG");

var $euare = parcelRequire("euare");

var $64fqF = parcelRequire("64fqF");

var $fY2kK = parcelRequire("fY2kK");

var $5dvEh = parcelRequire("5dvEh");

var $1FFOO = parcelRequire("1FFOO");
function $42701e671a7ea99e$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $f53mG.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $42701e671a7ea99e$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $4Zd7m.viewport) ? (0, $5dvEh.default)((0, $cU2ab.default)(element, strategy)) : (0, $5CNaU.isElement)(clippingParent) ? $42701e671a7ea99e$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $5dvEh.default)((0, $5br61.default)((0, $ge6D4.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $42701e671a7ea99e$var$getClippingParents(element) {
    var clippingParents = (0, $lUXC0.default)((0, $euare.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $d5uEE.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $5CNaU.isHTMLElement)(element) ? (0, $5OFrK.default)(element) : element;
    if (!(0, $5CNaU.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $5CNaU.isElement)(clippingParent) && (0, $64fqF.default)(clippingParent, clipperElement) && (0, $fY2kK.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $42701e671a7ea99e$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $42701e671a7ea99e$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $42701e671a7ea99e$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $1FFOO.max)(rect.top, accRect.top);
        accRect.right = (0, $1FFOO.min)(rect.right, accRect.right);
        accRect.bottom = (0, $1FFOO.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $1FFOO.max)(rect.left, accRect.left);
        return accRect;
    }, $42701e671a7ea99e$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("cU2ab", function(module, exports) {

$parcel$export(module.exports, "default", () => $964c648fbee9f83b$export$2e2bcd8739ae039);

var $kEyle = parcelRequire("kEyle");

var $ge6D4 = parcelRequire("ge6D4");

var $7gY7D = parcelRequire("7gY7D");

var $ciyDt = parcelRequire("ciyDt");
function $964c648fbee9f83b$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $kEyle.default)(element);
    var html = (0, $ge6D4.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $ciyDt.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $7gY7D.default)(element),
        y: y
    };
}

});

parcelRegister("5br61", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c62ff8a667ddd9b$export$2e2bcd8739ae039);

var $ge6D4 = parcelRequire("ge6D4");

var $d5uEE = parcelRequire("d5uEE");

var $7gY7D = parcelRequire("7gY7D");

var $2yPuF = parcelRequire("2yPuF");

var $1FFOO = parcelRequire("1FFOO");
function $3c62ff8a667ddd9b$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $ge6D4.default)(element);
    var winScroll = (0, $2yPuF.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $1FFOO.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $1FFOO.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $7gY7D.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $d5uEE.default)(body || html).direction === "rtl") x += (0, $1FFOO.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("64fqF", function(module, exports) {

$parcel$export(module.exports, "default", () => $46af15b8a9331d53$export$2e2bcd8739ae039);

var $5CNaU = parcelRequire("5CNaU");
function $46af15b8a9331d53$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $5CNaU.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("5dvEh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cc6b7657b52f47d$export$2e2bcd8739ae039);
function $3cc6b7657b52f47d$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("aZYrb", function(module, exports) {

$parcel$export(module.exports, "default", () => $801e7b7bc8a47a06$export$2e2bcd8739ae039);

var $17oaM = parcelRequire("17oaM");
function $801e7b7bc8a47a06$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $17oaM.default)(), paddingObject);
}

});
parcelRegister("17oaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d09321a0b9442e6$export$2e2bcd8739ae039);
function $0d09321a0b9442e6$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("4kO7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $327fe95b1f150ec0$export$2e2bcd8739ae039);
function $327fe95b1f150ec0$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("dnvUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bd62cb072801d0b$export$2e2bcd8739ae039);

var $cekwV = parcelRequire("cekwV");

var $4Zd7m = parcelRequire("4Zd7m");

var $9jDm5 = parcelRequire("9jDm5");

var $d5PQg = parcelRequire("d5PQg");
function $9bd62cb072801d0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $4Zd7m.placements) : _options$allowedAutoP;
    var variation = (0, $cekwV.default)(placement);
    var placements = variation ? flipVariations ? (0, $4Zd7m.variationPlacements) : (0, $4Zd7m.variationPlacements).filter(function(placement) {
        return (0, $cekwV.default)(placement) === variation;
    }) : (0, $4Zd7m.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9jDm5.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $d5PQg.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("ld8FA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7118986b147982c$export$2e2bcd8739ae039);

var $4Zd7m = parcelRequire("4Zd7m");

var $d5PQg = parcelRequire("d5PQg");

var $avRZ6 = parcelRequire("avRZ6");

var $i8A1r = parcelRequire("i8A1r");

var $3yYi1 = parcelRequire("3yYi1");

var $4kMg2 = parcelRequire("4kMg2");

var $5OFrK = parcelRequire("5OFrK");

var $9jDm5 = parcelRequire("9jDm5");

var $cekwV = parcelRequire("cekwV");

var $17oaM = parcelRequire("17oaM");

var $1FFOO = parcelRequire("1FFOO");
function $f7118986b147982c$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9jDm5.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $d5PQg.default)(state.placement);
    var variation = (0, $cekwV.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $avRZ6.default)(basePlacement);
    var altAxis = (0, $i8A1r.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $4Zd7m.top) : (0, $4Zd7m.left);
        var altSide = mainAxis === "y" ? (0, $4Zd7m.bottom) : (0, $4Zd7m.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $4Zd7m.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $4Zd7m.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $4kMg2.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $17oaM.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $3yYi1.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5OFrK.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $3yYi1.within)(tether ? (0, $1FFOO.min)(min, tetherMin) : min, offset, tether ? (0, $1FFOO.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $4Zd7m.top) : (0, $4Zd7m.left);
        var _altSide = mainAxis === "x" ? (0, $4Zd7m.bottom) : (0, $4Zd7m.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $4Zd7m.top),
            (0, $4Zd7m.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $3yYi1.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $3yYi1.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f7118986b147982c$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $f7118986b147982c$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("i8A1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $d344ea9dc6cc8da7$export$2e2bcd8739ae039);
function $d344ea9dc6cc8da7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("3yYi1", function(module, exports) {

$parcel$export(module.exports, "within", () => $2983505dbd1a8056$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $2983505dbd1a8056$export$86c8af6d3ef0b4a);

var $1FFOO = parcelRequire("1FFOO");
function $2983505dbd1a8056$export$f28d906d67a997f3(min, value, max) {
    return (0, $1FFOO.max)(min, (0, $1FFOO.min)(value, max));
}
function $2983505dbd1a8056$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $2983505dbd1a8056$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("lf1nX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f76c12ca267af3a8$export$2e2bcd8739ae039);

var $d5PQg = parcelRequire("d5PQg");

var $4kMg2 = parcelRequire("4kMg2");

var $64fqF = parcelRequire("64fqF");

var $5OFrK = parcelRequire("5OFrK");

var $avRZ6 = parcelRequire("avRZ6");

var $3yYi1 = parcelRequire("3yYi1");

var $aZYrb = parcelRequire("aZYrb");

var $4kO7M = parcelRequire("4kO7M");

var $4Zd7m = parcelRequire("4Zd7m");
var $f76c12ca267af3a8$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $aZYrb.default)(typeof padding !== "number" ? padding : (0, $4kO7M.default)(padding, (0, $4Zd7m.basePlacements)));
};
function $f76c12ca267af3a8$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $d5PQg.default)(state.placement);
    var axis = (0, $avRZ6.default)(basePlacement);
    var isVertical = [
        (0, $4Zd7m.left),
        (0, $4Zd7m.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f76c12ca267af3a8$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $4kMg2.default)(arrowElement);
    var minProp = axis === "y" ? (0, $4Zd7m.top) : (0, $4Zd7m.left);
    var maxProp = axis === "y" ? (0, $4Zd7m.bottom) : (0, $4Zd7m.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5OFrK.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $3yYi1.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f76c12ca267af3a8$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $64fqF.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f76c12ca267af3a8$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f76c12ca267af3a8$var$arrow,
    effect: $f76c12ca267af3a8$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("9oFx8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d76929fd22b9b48$export$2e2bcd8739ae039);

var $4Zd7m = parcelRequire("4Zd7m");

var $9jDm5 = parcelRequire("9jDm5");
function $6d76929fd22b9b48$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $6d76929fd22b9b48$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $4Zd7m.top),
        (0, $4Zd7m.right),
        (0, $4Zd7m.bottom),
        (0, $4Zd7m.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $6d76929fd22b9b48$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9jDm5.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $9jDm5.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $6d76929fd22b9b48$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $6d76929fd22b9b48$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $6d76929fd22b9b48$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $6d76929fd22b9b48$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $6d76929fd22b9b48$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $6d76929fd22b9b48$var$hide
};

});


parcelRegister("bRiYQ", function(module, exports) {

$parcel$export(module.exports, "Portal", () => $8a235e0c1520db11$export$602eac185826482c);

var $aOzEm = parcelRequire("aOzEm");

var $lOkAX = parcelRequire("lOkAX");


var $iff6Y = parcelRequire("iff6Y");
var $3jQQ9 = parcelRequire("3jQQ9");
var $6KMJ0 = parcelRequire("6KMJ0");

var $2T9xh = parcelRequire("2T9xh");
"use client";
function $8a235e0c1520db11$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $8a235e0c1520db11$export$602eac185826482c = /*#__PURE__*/ $aOzEm.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $aOzEm.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $6KMJ0.default)(/*#__PURE__*/ $aOzEm.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $3jQQ9.default)(()=>{
        if (!disablePortal) setMountNode($8a235e0c1520db11$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $3jQQ9.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $iff6Y.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $iff6Y.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $aOzEm.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $aOzEm.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $2T9xh.jsx)($aOzEm.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $2T9xh.jsx)($aOzEm.Fragment, {
        children: mountNode ? /*#__PURE__*/ $lOkAX.createPortal(children, mountNode) : mountNode
    });
});

});

parcelRegister("iT5tT", function(module, exports) {

$parcel$export(module.exports, "getPopperUtilityClass", () => $dc019d83835c1a3e$export$1b69b6cd0fa638a1);

var $6vnyE = parcelRequire("6vnyE");

var $cyhE3 = parcelRequire("cyhE3");
function $dc019d83835c1a3e$export$1b69b6cd0fa638a1(slot) {
    return (0, $6vnyE.default)("MuiPopper", slot);
}
const $dc019d83835c1a3e$export$b6aa214021e734b0 = (0, $cyhE3.default)("MuiPopper", [
    "root"
]);

});

parcelRegister("74GFZ", function(module, exports) {

$parcel$export(module.exports, "useSlotProps", () => $526a02c3c35ca20f$export$1e5c9e6e4e15efe3);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $6KMJ0 = parcelRequire("6KMJ0");

var $iwvVh = parcelRequire("iwvVh");

var $lfyVJ = parcelRequire("lfyVJ");

var $bxsXl = parcelRequire("bxsXl");
"use client";
const $526a02c3c35ca20f$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $526a02c3c35ca20f$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $cAqXo.default)(parameters, $526a02c3c35ca20f$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $bxsXl.resolveComponentProps)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $lfyVJ.mergeSlotProps)((0, $g6Hsb.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $6KMJ0.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $iwvVh.appendOwnerState)(elementType, (0, $g6Hsb.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}

});
parcelRegister("lfyVJ", function(module, exports) {

$parcel$export(module.exports, "mergeSlotProps", () => $f786181cb9cc9d66$export$b01d1e419b049226);

var $g6Hsb = parcelRequire("g6Hsb");

var $g45Wv = parcelRequire("g45Wv");

var $1WyaQ = parcelRequire("1WyaQ");

var $gpRKW = parcelRequire("gpRKW");
function $f786181cb9cc9d66$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $g45Wv.default)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $g6Hsb.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $g6Hsb.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $1WyaQ.extractEventHandlers)((0, $g6Hsb.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $gpRKW.omitEventHandlers)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $gpRKW.omitEventHandlers)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $g45Wv.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $g6Hsb.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $g6Hsb.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}

});
parcelRegister("1WyaQ", function(module, exports) {

$parcel$export(module.exports, "extractEventHandlers", () => $16a5b775d8afe0cc$export$24d5698b57eff81c);
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $16a5b775d8afe0cc$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

});

parcelRegister("gpRKW", function(module, exports) {

$parcel$export(module.exports, "omitEventHandlers", () => $bf38ae032bd6c20c$export$2ac0fa4d3a39be45);
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $bf38ae032bd6c20c$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

});


parcelRegister("bxsXl", function(module, exports) {

$parcel$export(module.exports, "resolveComponentProps", () => $86693cd9d217f1e9$export$308c24034cde71de);
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $86693cd9d217f1e9$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}

});


parcelRegister("2Nbvd", function(module, exports) {

$parcel$export(module.exports, "useClassNamesOverride", () => $208914869d751886$export$b0f7603cd2f9ee15);

var $aOzEm = parcelRequire("aOzEm");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $208914869d751886$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $208914869d751886$var$ClassNameConfiguratorContext = /*#__PURE__*/ $aOzEm.createContext($208914869d751886$var$defaultContextValue);
function $208914869d751886$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $aOzEm.useContext($208914869d751886$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $208914869d751886$export$2efe1f5e70172ae9(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $aOzEm.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($208914869d751886$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}

});



parcelRegister("cqmYq", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b9bbcf741f90ae$export$2e2bcd8739ae039);

var $2Us5L = parcelRequire("2Us5L");
"use client";
var $90b9bbcf741f90ae$export$2e2bcd8739ae039 = (0, $2Us5L.default);

});
parcelRegister("2Us5L", function(module, exports) {

$parcel$export(module.exports, "default", () => $21e69a342e045cf2$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");
"use client";
let $21e69a342e045cf2$var$globalId = 0;
function $21e69a342e045cf2$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $aOzEm.useState(idOverride);
    const id = idOverride || defaultId;
    $aOzEm.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $21e69a342e045cf2$var$globalId += 1;
            setDefaultId(`mui-${$21e69a342e045cf2$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $21e69a342e045cf2$var$maybeReactUseId = $aOzEm["useId".toString()];
function $21e69a342e045cf2$export$2e2bcd8739ae039(idOverride) {
    if ($21e69a342e045cf2$var$maybeReactUseId !== undefined) {
        const reactId = $21e69a342e045cf2$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $21e69a342e045cf2$var$useGlobalId(idOverride);
}

});


parcelRegister("duffS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d19e90ebd4bb5ba$export$2e2bcd8739ae039);

var $ddhug = parcelRequire("ddhug");
"use client";
var $9d19e90ebd4bb5ba$export$2e2bcd8739ae039 = (0, $ddhug.default);

});
parcelRegister("ddhug", function(module, exports) {

$parcel$export(module.exports, "default", () => $99ea0ddb6ff9867e$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");
"use client";
function $99ea0ddb6ff9867e$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $aOzEm.useRef(controlled !== undefined);
    const [valueState, setValue] = $aOzEm.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $aOzEm.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("29Oj8", function(module, exports) {

$parcel$export(module.exports, "getTooltipUtilityClass", () => $19237212e04f5e77$export$837848f5f6cee923);
$parcel$export(module.exports, "default", () => $19237212e04f5e77$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $19237212e04f5e77$export$837848f5f6cee923(slot) {
    return (0, $6vnyE.default)("MuiTooltip", slot);
}
const $19237212e04f5e77$var$tooltipClasses = (0, $cyhE3.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $19237212e04f5e77$export$2e2bcd8739ae039 = $19237212e04f5e77$var$tooltipClasses;

});


parcelRegister("cZLdX", function(module, exports) {

$parcel$export(module.exports, "default", () => $975fd04518a7175e$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $975fd04518a7175e$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight");

});

parcelRegister("1JXVa", function(module, exports) {

$parcel$export(module.exports, "default", () => $1448798298d62da0$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $1448798298d62da0$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
}), "Fullscreen");

});

parcelRegister("904LW", function(module, exports) {

$parcel$export(module.exports, "default", () => $68d7d0d19403e429$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $68d7d0d19403e429$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
}), "FullscreenExit");

});

parcelRegister("kfgBH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebd2172a62bc89ab$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $ebd2172a62bc89ab$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
}), "Info");

});

parcelRegister("5lhcX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e3c4312ac15dee9$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $3e3c4312ac15dee9$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "m23 12-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z"
}), "NewReleases");

});

parcelRegister("497Ri", function(module, exports) {
"use strict";
var $304e19446d0a3b69$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $304e19446d0a3b69$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $304e19446d0a3b69$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $304e19446d0a3b69$var$__createBinding(result, mod, k);
    }
    $304e19446d0a3b69$var$__setModuleDefault(result, mod);
    return result;
};
var $304e19446d0a3b69$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FrameGroup = module.exports.useFrameGroupCtx = module.exports.frameGroupCtx = void 0;

var $2T9xh = parcelRequire("2T9xh");

const $304e19446d0a3b69$var$react_1 = $304e19446d0a3b69$var$__importStar((parcelRequire("aOzEm")));

var $jyGS9 = parcelRequire("jyGS9");
module.exports.frameGroupCtx = (0, $304e19446d0a3b69$var$react_1.createContext)(null);
function $304e19446d0a3b69$var$useFrameGroupCtx() {
    return (0, $304e19446d0a3b69$var$react_1.useContext)(module.exports.frameGroupCtx);
}
module.exports.useFrameGroupCtx = $304e19446d0a3b69$var$useFrameGroupCtx;
function $304e19446d0a3b69$var$FrameGroup(_a) {
    var { sx: sx, children: children } = _a, props = $304e19446d0a3b69$var$__rest(_a, [
        "sx",
        "children"
    ]);
    const ctx = (0, $304e19446d0a3b69$var$react_1.useMemo)(()=>{
        const childCount = $304e19446d0a3b69$var$react_1.default.Children.toArray(children).filter(Boolean).length;
        return Object.assign({
            count: childCount
        }, props);
    }, [
        children
    ]);
    return (0, $2T9xh.jsx)($jyGS9.default, Object.assign({
        sx: Object.assign({
            display: "grid",
            padding: "2ch",
            gap: "2ch",
            placeContent: "start stretch",
            width: "100%",
            maxWidth: "200ch",
            marginX: "auto"
        }, sx)
    }, {
        children: (0, $2T9xh.jsx)(module.exports.frameGroupCtx.Provider, Object.assign({
            value: ctx
        }, {
            children: children
        }))
    }));
}
module.exports.FrameGroup = $304e19446d0a3b69$var$FrameGroup;

});

parcelRegister("8V5Nr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Paywall = void 0;

var $2T9xh = parcelRequire("2T9xh");

var $8aalP = parcelRequire("8aalP");
/**
 * A paywall that appears on hover and prompts the user to upgrade.
 * Currently designed & implemented specifically for use around a
 * Frame body, though it should work in other places as well.
 *
 * The paywall uses absolute positioning to occlude the desired
 * content, so there must be a relatively positioned parent to
 * scope the paywall to a that portion of the UI.
 */ function $67e824a8ecc370de$var$Paywall({ sx: sx }) {
    return (0, $2T9xh.jsx)($8aalP.default, {
        sx: Object.assign({
            pointerEvents: "auto",
            cursor: "not-allowed",
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            transition: "background-color 0.2s",
            "&:hover": {
                bgcolor: "rgba(0 0 0 / 4%)"
            }
        }, sx)
    });
}
module.exports.Paywall = $67e824a8ecc370de$var$Paywall;

});


parcelRegister("iviOa", function(module, exports) {

$parcel$export(module.exports, "useGuide", () => $d5277c9913a46d86$export$e2a645cd9d6a0957);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");
const $d5277c9913a46d86$export$b3f904f25eabb807 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createContext(null);
const $d5277c9913a46d86$export$b080dbea39efe9a9 = function({ children: children = null }) {
    const [state, setState] = (0, $aOzEm.useState)({
        activeGuide: null
    });
    return /*#__PURE__*/ (0, $2T9xh.jsx)($d5277c9913a46d86$export$b3f904f25eabb807.Provider, {
        value: {
            state: state,
            openGuide (useCase) {
                setState((s)=>({
                        ...s,
                        activeGuide: useCase
                    }));
            },
            closeGuide () {
                setState((s)=>({
                        ...s,
                        activeGuide: null
                    }));
            }
        },
        children: children
    });
};
function $d5277c9913a46d86$export$e2a645cd9d6a0957() {
    return (0, $aOzEm.useContext)($d5277c9913a46d86$export$b3f904f25eabb807);
}

});

parcelRegister("hbDGZ", function(module, exports) {

$parcel$export(module.exports, "MDXProvider", () => $f25ae79480c402a4$export$1cf78dad7550a52b);

var $2T9xh = parcelRequire("2T9xh");
parcelRequire("aOzEm");

var $ilJvq = parcelRequire("ilJvq");

var $2Wdb2 = parcelRequire("2Wdb2");

var $eV469 = parcelRequire("eV469");

var $gga7I = parcelRequire("gga7I");

var $F94Hv = parcelRequire("F94Hv");

var $7f29r = parcelRequire("7f29r");

var $jyGS9 = parcelRequire("jyGS9");

var $4In7L = parcelRequire("4In7L");
function $f25ae79480c402a4$export$1cf78dad7550a52b({ children: children }) {
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $ilJvq.MDXProvider), {
        components: {
            a: $f25ae79480c402a4$export$b688253958b8dfe7,
            pre: $f25ae79480c402a4$export$bba54bd7e8a0d398
        },
        children: children
    });
}
function $f25ae79480c402a4$export$b688253958b8dfe7(props) {
    const { activeAccount: activeAccount } = (0, $gga7I.useActiveAccount)();
    return props.href[0] == "~" ? /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Wdb2))), {
        ...props,
        href: props.href.replace(/^~/, "/" + activeAccount?.name)
    }) : /*#__PURE__*/ (0, $2T9xh.jsxs)("a", {
        target: "_blank",
        ...props,
        children: [
            props.children,
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $F94Hv.default), {
                sx: {
                    fontSize: "0.8em",
                    verticalAlign: "middle"
                }
            })
        ]
    });
}
function $f25ae79480c402a4$export$bba54bd7e8a0d398(props) {
    const showSnackbar = (0, $4In7L.useSnackbar)();
    const copyButtonWidth = "3.2ch";
    const isSQL = props.children.props.className == "language-sql";
    const style = {
        overflowX: "auto",
        border: "1px solid rgb(90% 90% 90%)",
        borderRadius: "1ch",
        padding: `1ch ${copyButtonWidth} 1ch 1ch`
    };
    if (isSQL) return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
        sx: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eV469))), {
                language: "sql",
                style: style,
                children: props.children
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7f29r))), {
                text: props.children.props.children,
                sx: {
                    width: copyButtonWidth,
                    padding: "4px",
                    fontSize: "inherit",
                    position: "absolute",
                    top: "0px",
                    right: "0px",
                    bgcolor: "white",
                    "&:hover": {
                        bgcolor: "rgb(95% 95% 95%)"
                    },
                    borderRadius: "1ch",
                    border: "1px solid rgb(90% 90% 90%)"
                },
                onClick: ()=>showSnackbar({
                        title: "Copied!"
                    })
            })
        ]
    });
    return /*#__PURE__*/ (0, $2T9xh.jsx)("pre", {
        style: style,
        children: props.children
    });
}

});
parcelRegister("ilJvq", function(module, exports) {

$parcel$export(module.exports, "MDXProvider", () => $d5bd7cad89d3435c$export$1cf78dad7550a52b);

var $aOzEm = parcelRequire("aOzEm");
function $d5bd7cad89d3435c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d5bd7cad89d3435c$var$_extends() {
    $d5bd7cad89d3435c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d5bd7cad89d3435c$var$_extends.apply(this, arguments);
}
function $d5bd7cad89d3435c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d5bd7cad89d3435c$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d5bd7cad89d3435c$var$ownKeys(Object(source), true).forEach(function(key) {
            $d5bd7cad89d3435c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d5bd7cad89d3435c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d5bd7cad89d3435c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d5bd7cad89d3435c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d5bd7cad89d3435c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $d5bd7cad89d3435c$var$isFunction = function isFunction(obj) {
    return typeof obj === "function";
};
var $d5bd7cad89d3435c$export$d7de0f1cab697634 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createContext({});
var $d5bd7cad89d3435c$export$aae81db1754c1e05 = function withMDXComponents(Component) {
    return function(props) {
        var allComponents = $d5bd7cad89d3435c$export$ba49c9ffd2310961(props.components);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createElement(Component, $d5bd7cad89d3435c$var$_extends({}, props, {
            components: allComponents
        }));
    };
};
var $d5bd7cad89d3435c$export$ba49c9ffd2310961 = function useMDXComponents(components) {
    var contextComponents = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useContext($d5bd7cad89d3435c$export$d7de0f1cab697634);
    var allComponents = contextComponents;
    if (components) allComponents = $d5bd7cad89d3435c$var$isFunction(components) ? components(contextComponents) : $d5bd7cad89d3435c$var$_objectSpread2($d5bd7cad89d3435c$var$_objectSpread2({}, contextComponents), components);
    return allComponents;
};
var $d5bd7cad89d3435c$export$1cf78dad7550a52b = function MDXProvider(props) {
    var allComponents = $d5bd7cad89d3435c$export$ba49c9ffd2310961(props.components);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createElement($d5bd7cad89d3435c$export$d7de0f1cab697634.Provider, {
        value: allComponents
    }, props.children);
};
var $d5bd7cad89d3435c$var$TYPE_PROP_NAME = "mdxType";
var $d5bd7cad89d3435c$var$DEFAULTS = {
    inlineCode: "code",
    wrapper: function wrapper(_ref) {
        var children = _ref.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).Fragment, {}, children);
    }
};
var $d5bd7cad89d3435c$var$MDXCreateElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).forwardRef(function(props, ref) {
    var propComponents = props.components, mdxType = props.mdxType, originalType = props.originalType, parentName = props.parentName, etc = $d5bd7cad89d3435c$var$_objectWithoutProperties(props, [
        "components",
        "mdxType",
        "originalType",
        "parentName"
    ]);
    var components = $d5bd7cad89d3435c$export$ba49c9ffd2310961(propComponents);
    var type = mdxType;
    var Component = components["".concat(parentName, ".").concat(type)] || components[type] || $d5bd7cad89d3435c$var$DEFAULTS[type] || originalType;
    if (propComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createElement(Component, $d5bd7cad89d3435c$var$_objectSpread2($d5bd7cad89d3435c$var$_objectSpread2({
        ref: ref
    }, etc), {}, {
        components: propComponents
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createElement(Component, $d5bd7cad89d3435c$var$_objectSpread2({
        ref: ref
    }, etc));
});
$d5bd7cad89d3435c$var$MDXCreateElement.displayName = "MDXCreateElement";
function $d5bd7cad89d3435c$export$5beccd7059e5fba5(type, props) {
    var args = arguments;
    var mdxType = props && props.mdxType;
    if (typeof type === "string" || mdxType) {
        var argsLength = args.length;
        var createElementArgArray = new Array(argsLength);
        createElementArgArray[0] = $d5bd7cad89d3435c$var$MDXCreateElement;
        var newProps = {};
        for(var key in props)if (hasOwnProperty.call(props, key)) newProps[key] = props[key];
        newProps.originalType = type;
        newProps[$d5bd7cad89d3435c$var$TYPE_PROP_NAME] = typeof type === "string" ? type : mdxType;
        createElementArgArray[1] = newProps;
        for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
        return (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createElement.apply(null, createElementArgArray);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).createElement.apply(null, args);
}

});

parcelRegister("2Wdb2", function(module, exports) {
"use strict";
var $223b38367571ed1d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ButtonLink = module.exports.Link = void 0;

var $2T9xh = parcelRequire("2T9xh");

const $223b38367571ed1d$var$react_1 = $223b38367571ed1d$var$__importDefault((parcelRequire("aOzEm")));

var $bteot = parcelRequire("bteot");

var $bfLP6 = parcelRequire("bfLP6");
var $7Wk6y = parcelRequire("7Wk6y");
module.exports.Link = $223b38367571ed1d$var$react_1.default.forwardRef(function Link(props, ref) {
    const LinkAdapter = (0, $bteot.useLink)();
    if (LinkAdapter) return (0, $2T9xh.jsx)($7Wk6y.default, Object.assign({
        ref: ref,
        component: LinkAdapter
    }, props));
    return (0, $2T9xh.jsx)($7Wk6y.default, Object.assign({
        component: "a",
        ref: ref
    }, props));
});
function $223b38367571ed1d$var$ButtonLink(props) {
    const LinkAdapter = (0, $bteot.useLink)();
    if (LinkAdapter) return (0, $2T9xh.jsx)($bfLP6.default, Object.assign({
        component: LinkAdapter
    }, props));
    return (0, $2T9xh.jsx)($bfLP6.default, Object.assign({}, props));
}
module.exports.ButtonLink = $223b38367571ed1d$var$ButtonLink;
module.exports.default = module.exports.Link;

});
parcelRegister("bfLP6", function(module, exports) {

$parcel$export(module.exports, "default", () => $83163119a892117e$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $2nDro = parcelRequire("2nDro");

var $b2r0b = parcelRequire("b2r0b");

var $fOENh = parcelRequire("fOENh");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $cdbdN = parcelRequire("cdbdN");

var $63Oo6 = parcelRequire("63Oo6");

var $d0jIa = parcelRequire("d0jIa");

var $7S6m0 = parcelRequire("7S6m0");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $83163119a892117e$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $83163119a892117e$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $63Oo6.default)(color)}`,
            `size${(0, $63Oo6.default)(size)}`,
            `${variant}Size${(0, $63Oo6.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $63Oo6.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $63Oo6.default)(size)}`
        ]
    };
    const composedClasses = (0, $b2r0b.default)(slots, (0, $d0jIa.getButtonUtilityClass), classes);
    return (0, $g6Hsb.default)({}, classes, composedClasses);
};
const $83163119a892117e$var$commonIconStyles = (ownerState)=>(0, $g6Hsb.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $83163119a892117e$var$ButtonRoot = (0, $25zst.default)((0, $cdbdN.default), {
    shouldForwardProp: (prop)=>(0, $25zst.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $63Oo6.default)(ownerState.color)}`],
            styles[`size${(0, $63Oo6.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $63Oo6.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $g6Hsb.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $g6Hsb.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fOENh.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fOENh.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fOENh.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $g6Hsb.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $d0jIa.default).focusVisible}`]: (0, $g6Hsb.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $d0jIa.default).disabled}`]: (0, $g6Hsb.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $fOENh.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $d0jIa.default).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $d0jIa.default).disabled}`]: {
            boxShadow: "none"
        }
    });
const $83163119a892117e$var$ButtonStartIcon = (0, $25zst.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $63Oo6.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $g6Hsb.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $83163119a892117e$var$commonIconStyles(ownerState)));
const $83163119a892117e$var$ButtonEndIcon = (0, $25zst.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $63Oo6.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $g6Hsb.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $83163119a892117e$var$commonIconStyles(ownerState)));
const $83163119a892117e$var$Button = /*#__PURE__*/ $aOzEm.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $aOzEm.useContext((0, $7S6m0.default));
    const resolvedProps = (0, $2nDro.default)(contextProps, inProps);
    const props = (0, $gEb5G.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $cAqXo.default)(props, $83163119a892117e$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $83163119a892117e$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $2T9xh.jsx)($83163119a892117e$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $2T9xh.jsx)($83163119a892117e$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($83163119a892117e$var$ButtonRoot, (0, $g6Hsb.default)({
        ownerState: ownerState,
        className: (0, $g45Wv.default)(contextProps.className, classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $g45Wv.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $83163119a892117e$export$2e2bcd8739ae039 = $83163119a892117e$var$Button;

});
parcelRegister("d0jIa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getButtonUtilityClass", () => $977a90b168f9d211$export$5a6f9035944c8119);
$parcel$export(module.exports, "default", () => $977a90b168f9d211$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $977a90b168f9d211$export$5a6f9035944c8119(slot) {
    return (0, $6vnyE.default)("MuiButton", slot);
}
const $977a90b168f9d211$var$buttonClasses = (0, $cyhE3.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $977a90b168f9d211$export$2e2bcd8739ae039 = $977a90b168f9d211$var$buttonClasses;

});

parcelRegister("7S6m0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bb2814a7b912164$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");
/**
 * @ignore - internal component.
 */ const $5bb2814a7b912164$var$ButtonGroupContext = /*#__PURE__*/ $aOzEm.createContext({});
var $5bb2814a7b912164$export$2e2bcd8739ae039 = $5bb2814a7b912164$var$ButtonGroupContext;

});



parcelRegister("eV469", function(module, exports) {
"use strict";
var $adc9915b8c35ca03$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Prism = void 0;

var $2T9xh = parcelRequire("2T9xh");

const $adc9915b8c35ca03$var$prismjs_1 = $adc9915b8c35ca03$var$__importDefault((parcelRequire("hq8Rx")));
parcelRequire("aJIEm");
parcelRequire("6B7qQ");

var $aOzEm = parcelRequire("aOzEm");

var $dJTQM = parcelRequire("dJTQM");
module.exports.default = $adc9915b8c35ca03$var$Prism;
function $adc9915b8c35ca03$var$Prism(props) {
    const ref = (0, $aOzEm.useRef)(null);
    const theme = (0, $dJTQM.useDecodableTheme)();
    const Wrapper = props.inline ? "span" : "pre";
    (0, $aOzEm.useLayoutEffect)(()=>{
        $adc9915b8c35ca03$var$prismjs_1.default.highlightElement(ref.current);
    }, [
        props.children
    ]);
    return (0, $2T9xh.jsx)(Wrapper, Object.assign({
        className: `language-${props.language}`,
        style: Object.assign({
            margin: 0,
            fontFamily: theme.typography.code.fontFamily
        }, props.style)
    }, {
        children: (0, $2T9xh.jsx)("code", Object.assign({
            ref: ref
        }, {
            children: props.children
        }))
    }));
}
module.exports.Prism = $adc9915b8c35ca03$var$Prism;

});
parcelRegister("hq8Rx", function(module, exports) {
/* **********************************************
     Begin prism-core.js
********************************************** */ /// <reference lib="WebWorker"/>
var $caebbd46d35c9ccc$var$_self = typeof window !== "undefined" ? window // if in browser
 : typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var $caebbd46d35c9ccc$var$Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj["__id"]) Object.defineProperty(obj, "__id", {
                    value: ++uniqueId
                });
                return obj["__id"];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case "Object":
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case "Array":
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return "none";
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, "gi"), "");
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add("language-" + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === "undefined") return null;
                if ("currentScript" in document && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName("script");
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = "no-" + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === "Object" && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === "Array" && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run("before-highlightall", env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run("before-all-elements-highlight", env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === "pre") _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run("before-insert", env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run("after-highlight", env);
                _.hooks.run("complete", env);
                callback && callback.call(env.element);
            }
            _.hooks.run("before-sanity-check", env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === "pre" && !parent.hasAttribute("tabindex")) parent.setAttribute("tabindex", "0");
            if (!env.code) {
                _.hooks.run("complete", env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run("before-highlight", env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run("before-tokenize", env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run("after-tokenize", env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || "").length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == "string") return o;
        if (Array.isArray(o)) {
            var s = "";
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: "span",
            classes: [
                "token",
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run("wrap", env);
        var attributes = "";
        for(var name in env.attributes)attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
        return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + "," + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + "," + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener("message", function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute("data-manual")) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === "loading" || readyState === "interactive" && script && script.defer) document.addEventListener("DOMContentLoaded", highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}($caebbd46d35c9ccc$var$_self);
if (0, module.exports) module.exports = $caebbd46d35c9ccc$var$Prism;
// hack for components to work correctly in node.js
if (typeof $parcel$global !== "undefined") $parcel$global.Prism = $caebbd46d35c9ccc$var$Prism;
// some additional documentation/types
/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */ /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */ /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */ /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ /* **********************************************
     Begin prism-markup.js
********************************************** */ $caebbd46d35c9ccc$var$Prism.languages.markup = {
    "comment": {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    "prolog": {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    "doctype": {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            "internal-subset": {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            "string": {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            "punctuation": /^<!|>$|[[\]]/,
            "doctype-tag": /^DOCTYPE/i,
            "name": /[^\s<>'"]+/
        }
    },
    "cdata": {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    "tag": {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            "tag": {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    "punctuation": /^<\/?/,
                    "namespace": /^[^\s>\/:]+:/
                }
            },
            "special-attr": [],
            "attr-value": {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    "punctuation": [
                        {
                            pattern: /^=/,
                            alias: "attr-equals"
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            "punctuation": /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    "namespace": /^[^\s>\/:]+:/
                }
            }
        }
    },
    "entity": [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
$caebbd46d35c9ccc$var$Prism.languages.markup["tag"].inside["attr-value"].inside["entity"] = $caebbd46d35c9ccc$var$Prism.languages.markup["entity"];
$caebbd46d35c9ccc$var$Prism.languages.markup["doctype"].inside["internal-subset"].inside = $caebbd46d35c9ccc$var$Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
$caebbd46d35c9ccc$var$Prism.hooks.add("wrap", function(env) {
    if (env.type === "entity") env.attributes["title"] = env.content.replace(/&amp;/, "&");
});
Object.defineProperty($caebbd46d35c9ccc$var$Prism.languages.markup.tag, "addInlined", {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside["language-" + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $caebbd46d35c9ccc$var$Prism.languages[lang]
        };
        includedCdataInside["cdata"] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            "included-cdata": {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside["language-" + lang] = {
            pattern: /[\s\S]+/,
            inside: $caebbd46d35c9ccc$var$Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), "i"),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        $caebbd46d35c9ccc$var$Prism.languages.insertBefore("markup", "cdata", def);
    }
});
Object.defineProperty($caebbd46d35c9ccc$var$Prism.languages.markup.tag, "addAttribute", {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function(attrName, lang) {
        $caebbd46d35c9ccc$var$Prism.languages.markup.tag.inside["special-attr"].push({
            pattern: RegExp(/(^|["'\s])/.source + "(?:" + attrName + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
            lookbehind: true,
            inside: {
                "attr-name": /^[^\s=]+/,
                "attr-value": {
                    pattern: /=[\s\S]+/,
                    inside: {
                        "value": {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                "language-" + lang
                            ],
                            inside: $caebbd46d35c9ccc$var$Prism.languages[lang]
                        },
                        "punctuation": [
                            {
                                pattern: /^=/,
                                alias: "attr-equals"
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
$caebbd46d35c9ccc$var$Prism.languages.html = $caebbd46d35c9ccc$var$Prism.languages.markup;
$caebbd46d35c9ccc$var$Prism.languages.mathml = $caebbd46d35c9ccc$var$Prism.languages.markup;
$caebbd46d35c9ccc$var$Prism.languages.svg = $caebbd46d35c9ccc$var$Prism.languages.markup;
$caebbd46d35c9ccc$var$Prism.languages.xml = $caebbd46d35c9ccc$var$Prism.languages.extend("markup", {});
$caebbd46d35c9ccc$var$Prism.languages.ssml = $caebbd46d35c9ccc$var$Prism.languages.xml;
$caebbd46d35c9ccc$var$Prism.languages.atom = $caebbd46d35c9ccc$var$Prism.languages.xml;
$caebbd46d35c9ccc$var$Prism.languages.rss = $caebbd46d35c9ccc$var$Prism.languages.xml;
/* **********************************************
     Begin prism-css.js
********************************************** */ (function(Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
        "comment": /\/\*[\s\S]*?\*\//,
        "atrule": {
            pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + string.source + ")*?" + /(?:;|(?=\s*\{))/.source),
            inside: {
                "rule": /^@[\w-]+/,
                "selector-function-argument": {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: "selector"
                },
                "keyword": {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        "url": {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp("\\burl\\((?:" + string.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
            greedy: true,
            inside: {
                "function": /^url/i,
                "punctuation": /^\(|\)$/,
                "string": {
                    pattern: RegExp("^" + string.source + "$"),
                    alias: "url"
                }
            }
        },
        "selector": {
            pattern: RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|" + string.source + ")*(?=\\s*\\{)"),
            lookbehind: true
        },
        "string": {
            pattern: string,
            greedy: true
        },
        "property": {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        "important": /!important\b/i,
        "function": {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        "punctuation": /[(){};:,]/
    };
    Prism.languages.css["atrule"].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
        markup.tag.addInlined("style", "css");
        markup.tag.addAttribute("style", "css");
    }
})($caebbd46d35c9ccc$var$Prism);
/* **********************************************
     Begin prism-clike.js
********************************************** */ $caebbd46d35c9ccc$var$Prism.languages.clike = {
    "comment": [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    "string": {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            "punctuation": /[.\\]/
        }
    },
    "keyword": /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    "boolean": /\b(?:false|true)\b/,
    "function": /\b\w+(?=\()/,
    "number": /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    "operator": /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    "punctuation": /[{}[\];(),.:]/
};
/* **********************************************
     Begin prism-javascript.js
********************************************** */ $caebbd46d35c9ccc$var$Prism.languages.javascript = $caebbd46d35c9ccc$var$Prism.languages.extend("clike", {
    "class-name": [
        $caebbd46d35c9ccc$var$Prism.languages.clike["class-name"],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    "keyword": [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    "function": /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    "number": {
        pattern: RegExp(/(^|[^\w$])/.source + "(?:" + // constant
        (/NaN|Infinity/.source + "|" + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
        /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source),
        lookbehind: true
    },
    "operator": /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
$caebbd46d35c9ccc$var$Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
$caebbd46d35c9ccc$var$Prism.languages.insertBefore("javascript", "keyword", {
    "regex": {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            "regex-source": {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: "language-regex",
                inside: $caebbd46d35c9ccc$var$Prism.languages.regex
            },
            "regex-delimiter": /^\/|\/$/,
            "regex-flags": /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
    },
    "parameter": [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $caebbd46d35c9ccc$var$Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $caebbd46d35c9ccc$var$Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $caebbd46d35c9ccc$var$Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $caebbd46d35c9ccc$var$Prism.languages.javascript
        }
    ],
    "constant": /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
$caebbd46d35c9ccc$var$Prism.languages.insertBefore("javascript", "string", {
    "hashbang": {
        pattern: /^#!.*/,
        greedy: true,
        alias: "comment"
    },
    "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
            },
            "interpolation": {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    "interpolation-punctuation": {
                        pattern: /^\$\{|\}$/,
                        alias: "punctuation"
                    },
                    rest: $caebbd46d35c9ccc$var$Prism.languages.javascript
                }
            },
            "string": /[\s\S]+/
        }
    },
    "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: "property"
    }
});
$caebbd46d35c9ccc$var$Prism.languages.insertBefore("javascript", "operator", {
    "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: "property"
    }
});
if ($caebbd46d35c9ccc$var$Prism.languages.markup) {
    $caebbd46d35c9ccc$var$Prism.languages.markup.tag.addInlined("script", "javascript");
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    $caebbd46d35c9ccc$var$Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript");
}
$caebbd46d35c9ccc$var$Prism.languages.js = $caebbd46d35c9ccc$var$Prism.languages.javascript;
/* **********************************************
     Begin prism-file-highlight.js
********************************************** */ (function() {
    if (typeof $caebbd46d35c9ccc$var$Prism === "undefined" || typeof document === "undefined") return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    var LOADING_MESSAGE = "Loading\u2026";
    var FAILURE_MESSAGE = function(status, message) {
        return "\u2716 Error " + status + " while fetching file: " + message;
    };
    var FAILURE_EMPTY_MESSAGE = "\u2716 Error: File does not exist or is empty";
    var EXTENSIONS = {
        "js": "javascript",
        "py": "python",
        "rb": "ruby",
        "ps1": "powershell",
        "psm1": "powershell",
        "sh": "bash",
        "bat": "batch",
        "h": "c",
        "tex": "latex"
    };
    var STATUS_ATTR = "data-src-status";
    var STATUS_LOADING = "loading";
    var STATUS_LOADED = "loaded";
    var STATUS_FAILED = "failed";
    var SELECTOR = "pre[data-src]:not([" + STATUS_ATTR + '="' + STATUS_LOADED + '"])' + ":not([" + STATUS_ATTR + '="' + STATUS_LOADING + '"])';
    /**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */ function loadFile(src, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", src, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                if (xhr.status < 400 && xhr.responseText) success(xhr.responseText);
                else if (xhr.status >= 400) error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
                else error(FAILURE_EMPTY_MESSAGE);
            }
        };
        xhr.send(null);
    }
    /**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */ function parseRange(range) {
        var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || "");
        if (m) {
            var start = Number(m[1]);
            var comma = m[2];
            var end = m[3];
            if (!comma) return [
                start,
                start
            ];
            if (!end) return [
                start,
                undefined
            ];
            return [
                start,
                Number(end)
            ];
        }
        return undefined;
    }
    $caebbd46d35c9ccc$var$Prism.hooks.add("before-highlightall", function(env) {
        env.selector += ", " + SELECTOR;
    });
    $caebbd46d35c9ccc$var$Prism.hooks.add("before-sanity-check", function(env) {
        var pre = /** @type {HTMLPreElement} */ env.element;
        if (pre.matches(SELECTOR)) {
            env.code = ""; // fast-path the whole thing and go to complete
            pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading
            // add code element with loading message
            var code = pre.appendChild(document.createElement("CODE"));
            code.textContent = LOADING_MESSAGE;
            var src = pre.getAttribute("data-src");
            var language = env.language;
            if (language === "none") {
                // the language might be 'none' because there is no language set;
                // in this case, we want to use the extension as the language
                var extension = (/\.(\w+)$/.exec(src) || [
                    ,
                    "none"
                ])[1];
                language = EXTENSIONS[extension] || extension;
            }
            // set language classes
            $caebbd46d35c9ccc$var$Prism.util.setLanguage(code, language);
            $caebbd46d35c9ccc$var$Prism.util.setLanguage(pre, language);
            // preload the language
            var autoloader = $caebbd46d35c9ccc$var$Prism.plugins.autoloader;
            if (autoloader) autoloader.loadLanguages(language);
            // load file
            loadFile(src, function(text) {
                // mark as loaded
                pre.setAttribute(STATUS_ATTR, STATUS_LOADED);
                // handle data-range
                var range = parseRange(pre.getAttribute("data-range"));
                if (range) {
                    var lines = text.split(/\r\n?|\n/g);
                    // the range is one-based and inclusive on both ends
                    var start = range[0];
                    var end = range[1] == null ? lines.length : range[1];
                    if (start < 0) start += lines.length;
                    start = Math.max(0, Math.min(start - 1, lines.length));
                    if (end < 0) end += lines.length;
                    end = Math.max(0, Math.min(end, lines.length));
                    text = lines.slice(start, end).join("\n");
                    // add data-start for line numbers
                    if (!pre.hasAttribute("data-start")) pre.setAttribute("data-start", String(start + 1));
                }
                // highlight code
                code.textContent = text;
                $caebbd46d35c9ccc$var$Prism.highlightElement(code);
            }, function(error) {
                // mark as failed
                pre.setAttribute(STATUS_ATTR, STATUS_FAILED);
                code.textContent = error;
            });
        }
    });
    $caebbd46d35c9ccc$var$Prism.plugins.fileHighlight = {
        /**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */ highlight: function highlight(container) {
            var elements = (container || document).querySelectorAll(SELECTOR);
            for(var i = 0, element; element = elements[i++];)$caebbd46d35c9ccc$var$Prism.highlightElement(element);
        }
    };
    var logged = false;
    /** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */ $caebbd46d35c9ccc$var$Prism.fileHighlight = function() {
        if (!logged) {
            console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.");
            logged = true;
        }
        $caebbd46d35c9ccc$var$Prism.plugins.fileHighlight.highlight.apply(this, arguments);
    };
})();

});

parcelRegister("aJIEm", function(module, exports) {
// https://www.json.org/json-en.html
Prism.languages.json = {
    "property": {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
        lookbehind: true,
        greedy: true
    },
    "string": {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
        lookbehind: true,
        greedy: true
    },
    "comment": {
        pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    "number": /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    "punctuation": /[{}[\],]/,
    "operator": /:/,
    "boolean": /\b(?:false|true)\b/,
    "null": {
        pattern: /\bnull\b/,
        alias: "keyword"
    }
};
Prism.languages.webmanifest = Prism.languages.json;

});

parcelRegister("6B7qQ", function(module, exports) {
Prism.languages.sql = {
    "comment": {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: true
    },
    "variable": [
        {
            pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
            greedy: true
        },
        /@[\w.$]+/
    ],
    "string": {
        pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
        greedy: true,
        lookbehind: true
    },
    "identifier": {
        pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
        greedy: true,
        lookbehind: true,
        inside: {
            "punctuation": /^`|`$/
        }
    },
    "function": /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
    "keyword": /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    "boolean": /\b(?:FALSE|NULL|TRUE)\b/i,
    "number": /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    "operator": /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    "punctuation": /[;[\]()`,.]/
};

});


parcelRegister("gga7I", function(module, exports) {

$parcel$export(module.exports, "ErrUnauthorized", () => $ab1f55354ca35c2f$export$14a25834bf5fa686);
$parcel$export(module.exports, "AccountsProvider", () => $ab1f55354ca35c2f$export$64532285fd71d0e8);
$parcel$export(module.exports, "useAccounts", () => $ab1f55354ca35c2f$export$c229550bd86eba85);
$parcel$export(module.exports, "useActiveAccount", () => $ab1f55354ca35c2f$export$388ab3b6b5756211);
$parcel$export(module.exports, "useAccountFromPath", () => $ab1f55354ca35c2f$export$6bc8ee7ba69cd5c7);
$parcel$export(module.exports, "useAccountLogin", () => $ab1f55354ca35c2f$export$fcad80534f5e1627);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $1M3WI = parcelRequire("1M3WI");

var $hJHPU = parcelRequire("hJHPU");
parcelRequire("4UEYn");
var $ipyAV = parcelRequire("ipyAV");

var $cleXH = parcelRequire("cleXH");

var $5YTEB = parcelRequire("5YTEB");

var $4In7L = parcelRequire("4In7L");
const $ab1f55354ca35c2f$export$dc0f4f74aeb1d096 = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
const $ab1f55354ca35c2f$export$14a25834bf5fa686 = new Error("unauthorized");
function $ab1f55354ca35c2f$export$64532285fd71d0e8({ children: children }) {
    const { isLoading: authLoading, isAuthenticated: isAuthenticated } = (0, $1M3WI.useAuth)();
    const decodableApiFetch = (0, $hJHPU.useDecodableApiFetch)();
    const { isLoading: isLoading, data: accounts, error: error, refetch: refetch } = (0, $ipyAV.useQuery)([
        "accounts"
    ], async ()=>(await decodableApiFetch("/v1alpha2/accounts")).items, {
        enabled: !authLoading && isAuthenticated,
        refetchOnWindowFocus: false
    });
    const value = {
        isLoading: isLoading,
        error: error,
        accounts: accounts,
        refresh: refetch
    };
    return /*#__PURE__*/ (0, $2T9xh.jsx)($ab1f55354ca35c2f$export$dc0f4f74aeb1d096.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)($ab1f55354ca35c2f$export$6cb2a0d8ae6a90e, {
            children: children
        })
    });
}
function $ab1f55354ca35c2f$export$c229550bd86eba85() {
    const ctx = (0, $aOzEm.useContext)($ab1f55354ca35c2f$export$dc0f4f74aeb1d096);
    if (ctx == null) throw new Error(`useAccounts may only be used in the context of an AccountsProvider!`);
    return ctx;
}
const $ab1f55354ca35c2f$export$65a60e3879fa41ea = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $ab1f55354ca35c2f$export$f59d6210b31fa7b8() {
    const { isLoading: authLoading, isAuthenticated: isAuthenticated, jwt: jwt, error: authError } = (0, $1M3WI.useAuth)();
    const decodableApiFetch = (0, $hJHPU.useDecodableApiFetch)();
    const { isLoading: accountsLoading, accounts: accounts, error: accountsError } = $ab1f55354ca35c2f$export$c229550bd86eba85();
    const isLoading = authLoading || accountsLoading || isAuthenticated && !jwt;
    const error = authError || accountsError;
    // Find the active account from the accounts list matching the org on the JWT
    const activeAccount = (0, $aOzEm.useMemo)(()=>{
        if (!jwt || !accounts) return;
        const account = accounts?.find((acc)=>acc.auth0_org_id === jwt.org_id);
        return account;
    }, [
        accounts,
        jwt
    ]);
    const showSnackbar = (0, $4In7L.useSnackbar)();
    const { data: accountInfo, isLoading: accountInfoIsLoading, error: accountInfoError, refetch: refetchAccountInfo } = (0, $ipyAV.useQuery)([
        "accounts",
        "info",
        activeAccount?.name
    ], ()=>{
        let fetchOpts = activeAccount.cell ? {
            targetCell: activeAccount.cell
        } : {
            accountName: activeAccount.name
        };
        return decodableApiFetch(`/v1alpha2/accounts/${activeAccount.name}`, {}, fetchOpts);
    }, {
        enabled: Boolean(activeAccount?.name),
        refetchOnWindowFocus: false,
        onError: (err)=>{
            showSnackbar({
                title: `Failed to retrieve account information`,
                message: err.message ?? err.toString(),
                severity: "error"
            });
        }
    });
    return {
        isLoading: isLoading,
        error: error,
        refetchAccountInfo: refetchAccountInfo,
        activeAccount: activeAccount,
        accountInfo: accountInfo,
        accountInfoIsLoading: accountInfoIsLoading,
        accountInfoError: accountInfoError
    };
}
function $ab1f55354ca35c2f$export$6cb2a0d8ae6a90e({ children: children }) {
    const ctx = $ab1f55354ca35c2f$export$f59d6210b31fa7b8();
    return /*#__PURE__*/ (0, $2T9xh.jsx)($ab1f55354ca35c2f$export$65a60e3879fa41ea.Provider, {
        value: ctx,
        children: children
    });
}
function $ab1f55354ca35c2f$export$388ab3b6b5756211() {
    const ctx = (0, $aOzEm.useContext)($ab1f55354ca35c2f$export$65a60e3879fa41ea);
    if (ctx == null) throw new Error(`useActiveAccount may only be used in the context of an ActiveAccountProvider!`);
    return ctx;
}
function $ab1f55354ca35c2f$export$6bc8ee7ba69cd5c7() {
    const { accountName: accountNameFromPath } = (0, $5YTEB.useParams)();
    const { isLoading: accountsLoading, error: accountsError, accounts: accounts } = $ab1f55354ca35c2f$export$c229550bd86eba85();
    const { accountFromPath: accountFromPath } = (0, $aOzEm.useMemo)(()=>{
        const accountFromPath = accounts?.find((acct)=>acct.name == accountNameFromPath);
        return {
            accountFromPath: accountFromPath
        };
    }, [
        accountNameFromPath,
        accounts
    ]);
    return {
        accountNameFromPath: accountNameFromPath,
        accountFromPath: accountFromPath,
        isValid: !!accountFromPath,
        isLoading: accountsLoading,
        error: accountsError
    };
}
function $ab1f55354ca35c2f$export$fcad80534f5e1627() {
    const { isLoading: authIsLoading, loginWithRedirect: loginWithRedirect } = (0, $1M3WI.useAuth)();
    const [state, setState] = (0, $aOzEm.useState)({
        intent: null,
        error: null,
        isLoading: false
    });
    (0, $aOzEm.useEffect)(()=>{
        if (authIsLoading || !state.intent) return;
        loginWithRedirect((0, $cleXH.auth0LoginOptions)({
            organization: state.intent.account.auth0_org_id,
            target: state.intent.target
        })).then(()=>{
            setState((state)=>({
                    ...state,
                    isLoading: false
                }));
        }).catch((err)=>{
            setState((state)=>({
                    ...state,
                    intent: null,
                    error: err,
                    isLoading: false
                }));
        });
    }, [
        authIsLoading,
        loginWithRedirect,
        state.intent
    ]);
    return {
        login: ({ target: target = $ab1f55354ca35c2f$var$currentLocation(), account: account })=>{
            setState((state)=>({
                    ...state,
                    error: null,
                    isLoading: true,
                    intent: {
                        target: target,
                        account: account
                    }
                }));
        },
        ...state
    };
}
function $ab1f55354ca35c2f$export$7ca38d52d6739f08() {
    const { activeAccount: activeAccount } = $ab1f55354ca35c2f$export$388ab3b6b5756211();
    return {
        connection (id) {
            return `/${activeAccount.name}/connections/${id}`;
        },
        stream (id) {
            return `/${activeAccount.name}/streams/${id}`;
        },
        pipeline (id, version = "latest") {
            return `/${activeAccount.name}/pipelines/${id}?version=${version}`;
        }
    };
}
function $ab1f55354ca35c2f$var$currentLocation() {
    return window.location.pathname + window.location.search;
}

});
parcelRegister("1M3WI", function(module, exports) {

$parcel$export(module.exports, "AuthProvider", () => $46e850a8a0d410eb$export$87091915187a1a85);
$parcel$export(module.exports, "useAuth", () => $46e850a8a0d410eb$export$1d39dc5b47e56ff0);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $8Rfza = parcelRequire("8Rfza");

var $3lxZM = parcelRequire("3lxZM");
const $46e850a8a0d410eb$export$a0fd8390cfe8ae69 = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $46e850a8a0d410eb$export$5f43681baaf0c9fe() {
    const [accessToken, setAccessToken] = (0, $aOzEm.useState)(null);
    const [jwt, setJwt] = (0, $aOzEm.useState)(null);
    const { getAccessTokenSilently: getAccessTokenSilently, isLoading: isLoading, isAuthenticated: isAuthenticated, user: user, loginWithRedirect: loginWithRedirect, logout: logout, error: error } = (0, $8Rfza.useAuth0)();
    (0, $aOzEm.useEffect)(()=>{
        let cancel = false;
        if (isLoading || !isAuthenticated) return;
        (async function() {
            try {
                const accessToken = await getAccessTokenSilently();
                if (!cancel) {
                    setAccessToken(accessToken);
                    setJwt((0, $3lxZM.default)(accessToken));
                }
            } catch (ex) {
                console.warn("Could not retrieve token", ex);
                throw ex;
            }
        })();
        return ()=>{
            cancel = true;
        };
    }, [
        isLoading,
        isAuthenticated
    ]);
    return {
        accessToken: accessToken,
        getAccessTokenSilently: getAccessTokenSilently,
        isAuthenticated: isAuthenticated,
        isLoading: isLoading,
        error: error,
        jwt: jwt,
        loginWithRedirect: loginWithRedirect,
        logout: (...params)=>{
            sessionStorage.clear();
            logout(...params);
        },
        user: user
    };
}
function $46e850a8a0d410eb$export$87091915187a1a85({ children: children }) {
    const ctx = $46e850a8a0d410eb$export$5f43681baaf0c9fe();
    return /*#__PURE__*/ (0, $2T9xh.jsx)($46e850a8a0d410eb$export$a0fd8390cfe8ae69.Provider, {
        value: ctx,
        children: children
    });
}
function $46e850a8a0d410eb$export$1d39dc5b47e56ff0() {
    const ctx = (0, $aOzEm.useContext)($46e850a8a0d410eb$export$a0fd8390cfe8ae69);
    if (ctx == null) throw new Error("useAuth may only be used in the context of an AuthProvider!");
    return ctx;
}

});
parcelRegister("3lxZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $26fdb413b19bce3a$export$2e2bcd8739ae039);
function $26fdb413b19bce3a$var$e(e) {
    this.message = e;
}
$26fdb413b19bce3a$var$e.prototype = new Error, $26fdb413b19bce3a$var$e.prototype.name = "InvalidCharacterError";
var $26fdb413b19bce3a$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $26fdb413b19bce3a$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $26fdb413b19bce3a$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($26fdb413b19bce3a$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $26fdb413b19bce3a$var$r(t);
    }
}
function $26fdb413b19bce3a$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $26fdb413b19bce3a$var$o(e, r) {
    if ("string" != typeof e) throw new $26fdb413b19bce3a$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($26fdb413b19bce3a$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $26fdb413b19bce3a$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$26fdb413b19bce3a$export$b9721ef022f71a68.prototype = new Error, $26fdb413b19bce3a$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $26fdb413b19bce3a$export$2e2bcd8739ae039 = $26fdb413b19bce3a$var$o;

});


parcelRegister("hJHPU", function(module, exports) {

$parcel$export(module.exports, "useDecodableApiFetch", () => $287ccda8abe47909$export$f28c26d564b72a03);
$parcel$export(module.exports, "AccountScopedFetchProvider", () => $287ccda8abe47909$export$9cd9619eb6277173);
$parcel$export(module.exports, "useAccountScopedFetch", () => $287ccda8abe47909$export$8559c5d9d4c6fac3);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $5YTEB = parcelRequire("5YTEB");

var $1M3WI = parcelRequire("1M3WI");

var $gga7I = parcelRequire("gga7I");

var $lboKA = parcelRequire("lboKA");

var $ek6Yt = parcelRequire("ek6Yt");

var $2aiPz = parcelRequire("2aiPz");
function $287ccda8abe47909$export$f28c26d564b72a03() {
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $1M3WI.useAuth)();
    return (0, $aOzEm.useCallback)($287ccda8abe47909$export$b750129622defee0({
        getAccessTokenSilently: getAccessTokenSilently
    }), []);
}
// Capturing this value at module load time helps ensure a XSS attack
// cannot simply monkey-patch the browser fetch function to intercept
// future requests with users' auth tokens & other data.
const $287ccda8abe47909$var$defaultFetch = globalThis.fetch;
function $287ccda8abe47909$export$b750129622defee0({ getAccessTokenSilently: getAccessTokenSilently, fetch: fetch = $287ccda8abe47909$var$defaultFetch }) {
    const client = new (0, $ek6Yt.ControlPlaneClient)({
        fetch: fetch,
        getAccessToken: getAccessTokenSilently
    });
    return async function decodableApiFetch(path, requestInit = {}, opts = {}) {
        const headers = new Headers(requestInit.headers);
        let body = requestInit.body;
        if (typeof body == "object" && !(body instanceof FormData)) {
            headers.set("Content-Type", "application/json");
            body = JSON.stringify(body);
        }
        const response = await client.fetch(`${$287ccda8abe47909$export$87ba857dec1daeb1((0, $2aiPz.config), opts)}${path}`, {
            ...requestInit,
            method: requestInit.method || (body ? "POST" : "GET"),
            headers: headers,
            body: body
        });
        if (response.headers.get("Content-Type") === "application/json") return (0, $lboKA.JSONbig).parse(await response.text());
        else if (response.headers.get("Content-Disposition")?.includes("attachment")) return response;
        else return await response.text();
    };
}
const $287ccda8abe47909$export$853a69d40d024ce0 = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $287ccda8abe47909$export$9cd9619eb6277173({ children: children = null }) {
    const { accountName: accountName } = (0, $5YTEB.useParams)();
    const { accounts: accounts, refresh: refreshAccounts } = (0, $gga7I.useAccounts)();
    const baseUrlStrategyRef = (0, $aOzEm.useRef)({
        accountName: accountName
    });
    if (!accountName) throw new Error("Programmer Error: AccountScopedFetchProvider must be rendered in a route with an accountName parameter");
    const genericFetch = $287ccda8abe47909$export$f28c26d564b72a03();
    const decodableApiFetch = (0, $aOzEm.useMemo)(()=>async (path, args, opts)=>{
            const baseUrlStrategy = baseUrlStrategyRef.current;
            try {
                return await genericFetch(path, args, {
                    ...baseUrlStrategy,
                    ...opts ?? {}
                });
            } catch (originalErr) {
                // After the initial account creation, the account's subdomain is sometimes not immediately resolvable.
                // Here we work around this by falling back to the subdomain of the cell that hosts the account.
                if (!(originalErr instanceof TypeError) || !!baseUrlStrategy.targetCell) // If this doesn't look like a possible DNS issue, or we're already using the targetCell, fail fast.
                throw originalErr;
                let cell;
                try {
                    cell = accounts?.find((a)=>a.name == accountName)?.cell;
                    if (!cell) cell = (await refreshAccounts()).data?.find((a)=>a.name == accountName)?.cell;
                } catch (accountsErr) {
                    // Ignore: We'll throw the orignal error below if we failed to get the cell for any reason.
                    console.error("Failed to read the accounts list (ignoring)", accountsErr);
                }
                if (!cell) throw originalErr;
                // Update the baseUrlStrategyRef so that we use the cell's subdomain by default going forward.
                baseUrlStrategyRef.current = {
                    targetCell: cell
                };
                return genericFetch(path, args, {
                    ...baseUrlStrategyRef.current,
                    ...opts ?? {}
                });
            }
        }, [
        genericFetch,
        accounts
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($287ccda8abe47909$export$853a69d40d024ce0.Provider, {
        value: decodableApiFetch,
        children: children
    });
}
function $287ccda8abe47909$export$8559c5d9d4c6fac3() {
    const decodableApiFetch = (0, $aOzEm.useContext)($287ccda8abe47909$export$853a69d40d024ce0);
    if (!decodableApiFetch) throw new Error("Programmer Error: useAccountScopedFetch may only be called in the context of an AccountScopedFetchProvider");
    return decodableApiFetch;
}
function $287ccda8abe47909$export$87ba857dec1daeb1(config, opts) {
    if (opts.accountName) return $287ccda8abe47909$var$makeAccountApiUrlBase(config, opts.accountName);
    return $287ccda8abe47909$var$makeCellApiUrlBase(config, opts.targetCell);
}
function $287ccda8abe47909$var$makeCellApiUrlBase(config, targetCell) {
    return config.DECODABLE_CELL_API_URL_TEMPLATE.replace("{}", targetCell || config.DECODABLE_ENV);
}
function $287ccda8abe47909$var$makeAccountApiUrlBase(config, accountName) {
    return config.DECODABLE_ACCOUNT_API_URL_TEMPLATE.replace("{}", accountName);
}

});
parcelRegister("lboKA", function(module, exports) {

$parcel$export(module.exports, "JSONbig", () => $3648dd57cc7ec3db$export$eb211d683c5a911);

var $lXKPD = parcelRequire("lXKPD");
const { parse: $3648dd57cc7ec3db$var$bigParse, stringify: $3648dd57cc7ec3db$var$bigStringify } = (0, (/*@__PURE__*/$parcel$interopDefault($lXKPD)))({
    useNativeBigInt: true
});
const $3648dd57cc7ec3db$var$parse = (...args)=>{
    try {
        return $3648dd57cc7ec3db$var$bigParse(...args);
    } catch (e) {
        console.error(e);
        return JSON.parse(...args);
    }
};
const $3648dd57cc7ec3db$var$stringify = (...args)=>{
    try {
        return $3648dd57cc7ec3db$var$bigStringify(...args);
    } catch (e) {
        console.error(e);
        return JSON.stringify(...args);
    }
};
const $3648dd57cc7ec3db$export$eb211d683c5a911 = {
    parse: $3648dd57cc7ec3db$var$parse,
    stringify: $3648dd57cc7ec3db$var$stringify
};

});
parcelRegister("lXKPD", function(module, exports) {

var $5d29U = parcelRequire("5d29U");
var $ffd36f7ce4056646$require$json_stringify = $5d29U.stringify;

var $6Bm2W = parcelRequire("6Bm2W");
module.exports = function(options) {
    return {
        parse: $6Bm2W(options),
        stringify: $ffd36f7ce4056646$require$json_stringify
    };
};
//create the default method members with no options applied for backwards compatibility
module.exports.parse = $6Bm2W();
module.exports.stringify = $ffd36f7ce4056646$require$json_stringify;

});
parcelRegister("5d29U", function(module, exports) {

var $8Tuld = parcelRequire("8Tuld");
/*
    json2.js
    2013-05-26

    Public Domain.

    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.

    See http://www.JSON.org/js.html


    This code should be minified before deployment.
    See http://javascript.crockford.com/jsmin.html

    USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
    NOT CONTROL.


    This file creates a global JSON object containing two methods: stringify
    and parse.

        JSON.stringify(value, replacer, space)
            value       any JavaScript value, usually an object or array.

            replacer    an optional parameter that determines how object
                        values are stringified for objects. It can be a
                        function or an array of strings.

            space       an optional parameter that specifies the indentation
                        of nested structures. If it is omitted, the text will
                        be packed without extra whitespace. If it is a number,
                        it will specify the number of spaces to indent at each
                        level. If it is a string (such as '\t' or '&nbsp;'),
                        it contains the characters used to indent at each level.

            This method produces a JSON text from a JavaScript value.

            When an object value is found, if the object contains a toJSON
            method, its toJSON method will be called and the result will be
            stringified. A toJSON method does not serialize: it returns the
            value represented by the name/value pair that should be serialized,
            or undefined if nothing should be serialized. The toJSON method
            will be passed the key associated with the value, and this will be
            bound to the value

            For example, this would serialize Dates as ISO strings.

                Date.prototype.toJSON = function (key) {
                    function f(n) {
                        // Format integers to have at least two digits.
                        return n < 10 ? '0' + n : n;
                    }

                    return this.getUTCFullYear()   + '-' +
                         f(this.getUTCMonth() + 1) + '-' +
                         f(this.getUTCDate())      + 'T' +
                         f(this.getUTCHours())     + ':' +
                         f(this.getUTCMinutes())   + ':' +
                         f(this.getUTCSeconds())   + 'Z';
                };

            You can provide an optional replacer method. It will be passed the
            key and value of each member, with this bound to the containing
            object. The value that is returned from your method will be
            serialized. If your method returns undefined, then the member will
            be excluded from the serialization.

            If the replacer parameter is an array of strings, then it will be
            used to select the members to be serialized. It filters the results
            such that only members with keys listed in the replacer array are
            stringified.

            Values that do not have JSON representations, such as undefined or
            functions, will not be serialized. Such values in objects will be
            dropped; in arrays they will be replaced with null. You can use
            a replacer function to replace those with JSON values.
            JSON.stringify(undefined) returns undefined.

            The optional space parameter produces a stringification of the
            value that is filled with line breaks and indentation to make it
            easier to read.

            If the space parameter is a non-empty string, then that string will
            be used for indentation. If the space parameter is a number, then
            the indentation will be that many spaces.

            Example:

            text = JSON.stringify(['e', {pluribus: 'unum'}]);
            // text is '["e",{"pluribus":"unum"}]'


            text = JSON.stringify(['e', {pluribus: 'unum'}], null, '\t');
            // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'

            text = JSON.stringify([new Date()], function (key, value) {
                return this[key] instanceof Date ?
                    'Date(' + this[key] + ')' : value;
            });
            // text is '["Date(---current time---)"]'


        JSON.parse(text, reviver)
            This method parses a JSON text to produce an object or array.
            It can throw a SyntaxError exception.

            The optional reviver parameter is a function that can filter and
            transform the results. It receives each of the keys and values,
            and its return value is used instead of the original value.
            If it returns what it received, then the structure is not modified.
            If it returns undefined then the member is deleted.

            Example:

            // Parse the text. Values that look like ISO date strings will
            // be converted to Date objects.

            myData = JSON.parse(text, function (key, value) {
                var a;
                if (typeof value === 'string') {
                    a =
/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
                    if (a) {
                        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
                            +a[5], +a[6]));
                    }
                }
                return value;
            });

            myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
                var d;
                if (typeof value === 'string' &&
                        value.slice(0, 5) === 'Date(' &&
                        value.slice(-1) === ')') {
                    d = new Date(value.slice(5, -1));
                    if (d) {
                        return d;
                    }
                }
                return value;
            });


    This is a reference implementation. You are free to copy, modify, or
    redistribute.
*/ /*jslint evil: true, regexp: true */ /*members "", "\b", "\t", "\n", "\f", "\r", "\"", JSON, "\\", apply,
    call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/ // Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.
var $3cafd753ed8a5a48$var$JSON = module.exports;
(function() {
    "use strict";
    function f(n) {
        // Format integers to have at least two digits.
        return n < 10 ? "0" + n : n;
    }
    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, gap, indent, meta = {
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
    }, rep;
    function quote(string) {
        // If the string contains no control characters, no quote characters, and no
        // backslash characters, then we can safely slap some quotes around it.
        // Otherwise we must also replace the offending characters with safe escape
        // sequences.
        escapable.lastIndex = 0;
        return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
            var c = meta[a];
            return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + string + '"';
    }
    function str(key, holder) {
        // Produce a string from holder[key].
        var i, k, v, length, mind = gap, partial, value = holder[key], isBigNumber = value != null && (value instanceof $8Tuld || $8Tuld.isBigNumber(value));
        // If the value has a toJSON method, call it to obtain a replacement value.
        if (value && typeof value === "object" && typeof value.toJSON === "function") value = value.toJSON(key);
        // If we were called with a replacer function, then call the replacer to
        // obtain a replacement value.
        if (typeof rep === "function") value = rep.call(holder, key, value);
        // What happens next depends on the value's type.
        switch(typeof value){
            case "string":
                if (isBigNumber) return value;
                else return quote(value);
            case "number":
                // JSON numbers must be finite. Encode non-finite numbers as null.
                return isFinite(value) ? String(value) : "null";
            case "boolean":
            case "null":
            case "bigint":
                // If the value is a boolean or null, convert it to a string. Note:
                // typeof null does not produce 'null'. The case is included here in
                // the remote chance that this gets fixed someday.
                return String(value);
            // If the type is 'object', we might be dealing with an object or an array or
            // null.
            case "object":
                // Due to a specification blunder in ECMAScript, typeof null is 'object',
                // so watch out for that case.
                if (!value) return "null";
                // Make an array to hold the partial results of stringifying this object value.
                gap += indent;
                partial = [];
                // Is the value an array?
                if (Object.prototype.toString.apply(value) === "[object Array]") {
                    // The value is an array. Stringify every element. Use null as a placeholder
                    // for non-JSON values.
                    length = value.length;
                    for(i = 0; i < length; i += 1)partial[i] = str(i, value) || "null";
                    // Join all of the elements together, separated with commas, and wrap them in
                    // brackets.
                    v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                    gap = mind;
                    return v;
                }
                // If the replacer is an array, use it to select the members to be stringified.
                if (rep && typeof rep === "object") {
                    length = rep.length;
                    for(i = 0; i < length; i += 1)if (typeof rep[i] === "string") {
                        k = rep[i];
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                } else // Otherwise, iterate through all of the keys in the object.
                Object.keys(value).forEach(function(k) {
                    var v = str(k, value);
                    if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                });
                // Join all of the member texts together, separated with commas,
                // and wrap them in braces.
                v = partial.length === 0 ? "{}" : gap ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" : "{" + partial.join(",") + "}";
                gap = mind;
                return v;
        }
    }
    // If the JSON object does not yet have a stringify method, give it one.
    if (typeof $3cafd753ed8a5a48$var$JSON.stringify !== "function") $3cafd753ed8a5a48$var$JSON.stringify = function(value, replacer, space) {
        // The stringify method takes a value and an optional replacer, and an optional
        // space parameter, and returns a JSON text. The replacer can be a function
        // that can replace values, or an array of strings that will select the keys.
        // A default replacer method can be provided. Use of the space parameter can
        // produce text that is more easily readable.
        var i;
        gap = "";
        indent = "";
        // If the space parameter is a number, make an indent string containing that
        // many spaces.
        if (typeof space === "number") for(i = 0; i < space; i += 1)indent += " ";
        else if (typeof space === "string") indent = space;
        // If there is a replacer, it must be a function or an array.
        // Otherwise, throw an error.
        rep = replacer;
        if (replacer && typeof replacer !== "function" && (typeof replacer !== "object" || typeof replacer.length !== "number")) throw new Error("JSON.stringify");
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str("", {
            "": value
        });
    };
})();

});
parcelRegister("8Tuld", function(module, exports) {
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == "number") && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == "number") {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == "[object Array]") {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + "Invalid BigNumber: " + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "5e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == "object") {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == "object") {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != "object") throw Error(bignumberError + "Argument not an object: " + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
            }
            return (format.prefix || "") + str + (format.suffix || "");
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, "0");
                } else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(module.exports);

});


parcelRegister("6Bm2W", function(module, exports) {
var $4ce74cc3d095312d$var$BigNumber = null;
// regexpxs extracted from
// (c) BSD-3-Clause
// https://github.com/fastify/secure-json-parse/graphs/contributors and https://github.com/hapijs/bourne/graphs/contributors
const $4ce74cc3d095312d$var$suspectProtoRx = /(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])/;
const $4ce74cc3d095312d$var$suspectConstructorRx = /(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)/;

/*
    json_parse.js
    2012-06-20

    Public Domain.

    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.

    This file creates a json_parse function.
    During create you can (optionally) specify some behavioural switches

        require('json-bigint')(options)

            The optional options parameter holds switches that drive certain
            aspects of the parsing process:
            * options.strict = true will warn about duplicate-key usage in the json.
              The default (strict = false) will silently ignore those and overwrite
              values for keys that are in duplicate use.

    The resulting function follows this signature:
        json_parse(text, reviver)
            This method parses a JSON text to produce an object or array.
            It can throw a SyntaxError exception.

            The optional reviver parameter is a function that can filter and
            transform the results. It receives each of the keys and values,
            and its return value is used instead of the original value.
            If it returns what it received, then the structure is not modified.
            If it returns undefined then the member is deleted.

            Example:

            // Parse the text. Values that look like ISO date strings will
            // be converted to Date objects.

            myData = json_parse(text, function (key, value) {
                var a;
                if (typeof value === 'string') {
                    a =
/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
                    if (a) {
                        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
                            +a[5], +a[6]));
                    }
                }
                return value;
            });

    This is a reference implementation. You are free to copy, modify, or
    redistribute.

    This code should be minified before deployment.
    See http://javascript.crockford.com/jsmin.html

    USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
    NOT CONTROL.
*/ /*members "", "\"", "\/", "\\", at, b, call, charAt, f, fromCharCode,
    hasOwnProperty, message, n, name, prototype, push, r, t, text
*/ var $4ce74cc3d095312d$var$json_parse = function(options) {
    "use strict";
    // This is a function that can parse a JSON text, producing a JavaScript
    // data structure. It is a simple, recursive descent parser. It does not use
    // eval or regular expressions, so it can be used as a model for implementing
    // a JSON parser in other languages.
    // We are defining the function inside of another function to avoid creating
    // global variables.
    // Default options one can override by passing options to the parse()
    var _options = {
        strict: false,
        storeAsString: false,
        alwaysParseAsBig: false,
        useNativeBigInt: false,
        protoAction: "error",
        constructorAction: "error"
    };
    // If there are options, then use them to override the default _options
    if (options !== undefined && options !== null) {
        if (options.strict === true) _options.strict = true;
        if (options.storeAsString === true) _options.storeAsString = true;
        _options.alwaysParseAsBig = options.alwaysParseAsBig === true ? options.alwaysParseAsBig : false;
        _options.useNativeBigInt = options.useNativeBigInt === true ? options.useNativeBigInt : false;
        if (typeof options.constructorAction !== "undefined") {
            if (options.constructorAction === "error" || options.constructorAction === "ignore" || options.constructorAction === "preserve") _options.constructorAction = options.constructorAction;
            else throw new Error(`Incorrect value for constructorAction option, must be "error", "ignore" or undefined but passed ${options.constructorAction}`);
        }
        if (typeof options.protoAction !== "undefined") {
            if (options.protoAction === "error" || options.protoAction === "ignore" || options.protoAction === "preserve") _options.protoAction = options.protoAction;
            else throw new Error(`Incorrect value for protoAction option, must be "error", "ignore" or undefined but passed ${options.protoAction}`);
        }
    }
    var at, ch, escapee = {
        '"': '"',
        "\\": "\\",
        "/": "/",
        b: "\b",
        f: "\f",
        n: "\n",
        r: "\r",
        t: "	"
    }, text, error = function(m) {
        // Call error when something is wrong.
        throw {
            name: "SyntaxError",
            message: m,
            at: at,
            text: text
        };
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error("Expected '" + c + "' instead of '" + ch + "'");
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = "";
        if (ch === "-") {
            string = "-";
            next("-");
        }
        while(ch >= "0" && ch <= "9"){
            string += ch;
            next();
        }
        if (ch === ".") {
            string += ".";
            while(next() && ch >= "0" && ch <= "9")string += ch;
        }
        if (ch === "e" || ch === "E") {
            string += ch;
            next();
            if (ch === "-" || ch === "+") {
                string += ch;
                next();
            }
            while(ch >= "0" && ch <= "9"){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error("Bad number");
        else {
            if ($4ce74cc3d095312d$var$BigNumber == null) $4ce74cc3d095312d$var$BigNumber = (parcelRequire("8Tuld"));
            if (Number.isSafeInteger(number)) return !_options.alwaysParseAsBig ? number : _options.useNativeBigInt ? BigInt(number) : new $4ce74cc3d095312d$var$BigNumber(number);
            else // Number with fractional part should be treated as number(double) including big integers in scientific notation, i.e 1.79e+308
            return _options.storeAsString ? string : /[\.eE]/.test(string) ? number : _options.useNativeBigInt ? BigInt(string) : new $4ce74cc3d095312d$var$BigNumber(string);
        }
    }, string = function() {
        // Parse a string value.
        var hex, i, string = "", uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') {
            var startAt = at;
            while(next()){
                if (ch === '"') {
                    if (at - 1 > startAt) string += text.substring(startAt, at - 1);
                    next();
                    return string;
                }
                if (ch === "\\") {
                    if (at - 1 > startAt) string += text.substring(startAt, at - 1);
                    next();
                    if (ch === "u") {
                        uffff = 0;
                        for(i = 0; i < 4; i += 1){
                            hex = parseInt(next(), 16);
                            if (!isFinite(hex)) break;
                            uffff = uffff * 16 + hex;
                        }
                        string += String.fromCharCode(uffff);
                    } else if (typeof escapee[ch] === "string") string += escapee[ch];
                    else break;
                    startAt = at;
                }
            }
        }
        error("Bad string");
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= " ")next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case "t":
                next("t");
                next("r");
                next("u");
                next("e");
                return true;
            case "f":
                next("f");
                next("a");
                next("l");
                next("s");
                next("e");
                return false;
            case "n":
                next("n");
                next("u");
                next("l");
                next("l");
                return null;
        }
        error("Unexpected '" + ch + "'");
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === "[") {
            next("[");
            white();
            if (ch === "]") {
                next("]");
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === "]") {
                    next("]");
                    return array;
                }
                next(",");
                white();
            }
        }
        error("Bad array");
    }, object = function() {
        // Parse an object value.
        var key, object = Object.create(null);
        if (ch === "{") {
            next("{");
            white();
            if (ch === "}") {
                next("}");
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(":");
                if (_options.strict === true && Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                if ($4ce74cc3d095312d$var$suspectProtoRx.test(key) === true) {
                    if (_options.protoAction === "error") error("Object contains forbidden prototype property");
                    else if (_options.protoAction === "ignore") value();
                    else object[key] = value();
                } else if ($4ce74cc3d095312d$var$suspectConstructorRx.test(key) === true) {
                    if (_options.constructorAction === "error") error("Object contains forbidden constructor property");
                    else if (_options.constructorAction === "ignore") value();
                    else object[key] = value();
                } else object[key] = value();
                white();
                if (ch === "}") {
                    next("}");
                    return object;
                }
                next(",");
                white();
            }
        }
        error("Bad object");
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string, a number,
        // or a word.
        white();
        switch(ch){
            case "{":
                return object();
            case "[":
                return array();
            case '"':
                return string();
            case "-":
                return number();
            default:
                return ch >= "0" && ch <= "9" ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the above
    // functions and variables.
    return function(source, reviver) {
        var result;
        text = source + "";
        at = 0;
        ch = " ";
        result = value();
        white();
        if (ch) error("Syntax error");
        // If there is a reviver function, we recursively walk the new structure,
        // passing each name/value pair to the reviver function for possible
        // transformation, starting with a temporary root object that holds the result
        // in an empty key. If there is not a reviver function, we simply return the
        // result.
        return typeof reviver === "function" ? function walk(holder, key) {
            var k, v, value = holder[key];
            if (value && typeof value === "object") Object.keys(value).forEach(function(k) {
                v = walk(value, k);
                if (v !== undefined) value[k] = v;
                else delete value[k];
            });
            return reviver.call(holder, key, value);
        }({
            "": result
        }, "") : result;
    };
};
module.exports = $4ce74cc3d095312d$var$json_parse;

});



parcelRegister("ek6Yt", function(module, exports) {
// @tsignore

module.exports = (parcelRequire("i3WSD"));

});
parcelRegister("i3WSD", function(module, exports) {
"use strict";
var $d2662e2bb689d86c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d2662e2bb689d86c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d2662e2bb689d86c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d2662e2bb689d86c$var$__exportStar((parcelRequire("kqe9W")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("2FK14")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("hL5Ef")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("1tbis")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("3Lmfz")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("3GiXi")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("1LuDF")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("8E5lb")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("55F8r")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("4xiZF")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("jbO67")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("4uUhZ")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("eQ7rz")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("lh9lt")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("dLGOr")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("i1a44")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("eA63m")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("2jzPR")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("1on64")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("jvm42")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("kgnVh")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("38WPK")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("cXYct")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("e7MfT")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("4TRwZ")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("6HR42")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("GOHlA")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("3gq5r")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("2MINJ")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("5s7CS")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("032gY")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("6vsFc")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("a0N3i")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("68Tzh")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("fRGdT")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("kquI2")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("dGfjY")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("hOxb2")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("lnRTe")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("btQPI")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("17JVE")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("fC8t2")), module.exports);

$d2662e2bb689d86c$var$__exportStar((parcelRequire("70q3F")), module.exports);

});
parcelRegister("kqe9W", function(module, exports) {
"use strict";
// This file holds types that are common to the domain-specific APIs.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.apiVersion = void 0;
module.exports.apiVersion = "v1alpha2";

});

parcelRegister("2FK14", function(module, exports) {
"use strict";
var $1f231af96d7f53a9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.authMiddleware = module.exports.corsMiddleware = module.exports.apiErrorMiddleware = module.exports.applyFetchMiddleware = void 0;

var $hL5Ef = parcelRequire("hL5Ef");
function $1f231af96d7f53a9$var$applyFetchMiddleware(middleware, fetch) {
    let wrappedFetch = fetch;
    for(let i = middleware.length - 1; i >= 0; --i){
        const prevHead = wrappedFetch;
        wrappedFetch = function(req) {
            return middleware[i](req, prevHead);
        };
    }
    return (...args)=>{
        const request = new Request(...args);
        return wrappedFetch(request);
    };
}
module.exports.applyFetchMiddleware = $1f231af96d7f53a9$var$applyFetchMiddleware;
/** Throws a DecodableApiError for any non-200 response */ function $1f231af96d7f53a9$var$apiErrorMiddleware(request, next) {
    return $1f231af96d7f53a9$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield next(request);
        if (!response.ok) throw yield $hL5Ef.DecodableApiError.fromResponse(response);
        return response;
    });
}
module.exports.apiErrorMiddleware = $1f231af96d7f53a9$var$apiErrorMiddleware;
/** Applies the cords mode to all requests */ function $1f231af96d7f53a9$var$corsMiddleware(req, next) {
    return $1f231af96d7f53a9$var$__awaiter(this, void 0, void 0, function*() {
        return next(new Request(req, {
            mode: "cors"
        }));
    });
}
module.exports.corsMiddleware = $1f231af96d7f53a9$var$corsMiddleware;
function $1f231af96d7f53a9$var$authMiddleware(getAccessToken) {
    return function authMiddleware(req, next) {
        return $1f231af96d7f53a9$var$__awaiter(this, void 0, void 0, function*() {
            if (!req.headers.has("Authorization")) req.headers.set("Authorization", `Bearer ${yield getAccessToken()}`);
            return next(req);
        });
    };
}
module.exports.authMiddleware = $1f231af96d7f53a9$var$authMiddleware;

});
parcelRegister("hL5Ef", function(module, exports) {
"use strict";
var $cedb3511ebf5555d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecodableApiError = void 0;
class $cedb3511ebf5555d$var$DecodableApiError extends Error {
    constructor(status, statusText, body, requestId = ""){
        super(`API response not OK:\n${status} \u{2014} ${statusText}`);
        this.isDecodableApiError = true;
        this.status = status;
        this.statusText = statusText;
        this.requestId = requestId;
        // todo: This maintains legacy behavior, but maybe just use a `body` field instead?
        if (body && typeof body === "object") Object.assign(this, body);
    }
    static fromResponse(response) {
        var _a, _b;
        return $cedb3511ebf5555d$var$__awaiter(this, void 0, void 0, function*() {
            let body = null;
            if (((_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("Content-Type")) == "application/json") try {
                body = yield response.json();
            } catch (_c) {
            // ignored - parsing the error details is best effort
            }
            const requestId = (_b = response.headers) === null || _b === void 0 ? void 0 : _b.get("x-request-id");
            return new $cedb3511ebf5555d$var$DecodableApiError(response.status, response.statusText, body, requestId);
        });
    }
    toString() {
        if (typeof this.message === "string") return this.message;
        return super.toString();
    }
}
module.exports.DecodableApiError = $cedb3511ebf5555d$var$DecodableApiError;

});


parcelRegister("1tbis", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataPlaneClient = module.exports.ControlPlaneClient = module.exports.Client = void 0;

var $2FK14 = parcelRequire("2FK14");
const $1121432541801e25$var$nativeFetch = globalThis.fetch;
class $1121432541801e25$var$Client {
    constructor({ fetch: fetch = $1121432541801e25$var$nativeFetch, middleware: middleware = $1121432541801e25$var$Client.middleware } = {}){
        this.baseFetch = (0, $2FK14.applyFetchMiddleware)(middleware, fetch);
    }
    fetch(...args) {
        return this.baseFetch(...args);
    }
}
module.exports.Client = $1121432541801e25$var$Client;
$1121432541801e25$var$Client.middleware = [
    $2FK14.corsMiddleware,
    $2FK14.apiErrorMiddleware
];
class $1121432541801e25$var$ControlPlaneClient {
    static buildMiddleware(getAccessToken) {
        return [
            (0, $2FK14.authMiddleware)(getAccessToken),
            ...$1121432541801e25$var$Client.middleware
        ];
    }
    constructor({ getAccessToken: getAccessToken, fetch: fetch = $1121432541801e25$var$nativeFetch, middleware: middleware = $1121432541801e25$var$ControlPlaneClient.buildMiddleware(getAccessToken) }){
        this.baseClient = new $1121432541801e25$var$Client({
            fetch: fetch,
            middleware: middleware
        });
    }
    fetch(...args) {
        return this.baseClient.fetch(...args);
    }
}
module.exports.ControlPlaneClient = $1121432541801e25$var$ControlPlaneClient;
class $1121432541801e25$var$DataPlaneClient {
    static buildMiddleware() {
        return $1121432541801e25$var$Client.middleware.slice();
    }
    constructor({ host: host, scheme: scheme = host.startsWith("localhost") ? "http" : "https", fetch: fetch = $1121432541801e25$var$nativeFetch, middleware: middleware = $1121432541801e25$var$DataPlaneClient.buildMiddleware() }){
        this.host = host;
        this.scheme = scheme;
        this.baseClient = new $1121432541801e25$var$Client({
            fetch: fetch,
            middleware: middleware
        });
    }
    fetch(...args) {
        // If the caller passes only a path, build a full URL from
        // the scheme & host provided to the constructor.
        if (typeof args[0] === "string" && args[0][0] === "/") args[0] = `${this.scheme}://${this.host}${args[0]}`;
        return this.baseClient.fetch(...args);
    }
}
module.exports.DataPlaneClient = $1121432541801e25$var$DataPlaneClient;

});

parcelRegister("3Lmfz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.errorStates = module.exports.runnableKinds = module.exports.contentTypeHeader = module.exports.authorizationHeader = module.exports.applicationJsonType = void 0;
module.exports.applicationJsonType = "application/json";
module.exports.authorizationHeader = "Authorization";
module.exports.contentTypeHeader = "Content-Type";
module.exports.runnableKinds = [
    "pipeline",
    "connection"
];
module.exports.errorStates = [
    "FAILED",
    "RETRYING"
];

});

parcelRegister("3GiXi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bearerToken = module.exports.toSearchParams = module.exports.isRunnable = module.exports.isRunnableResource = void 0;

var $3Lmfz = parcelRequire("3Lmfz");
function $2ae3ff7d7a45da29$var$isRunnableResource(resource) {
    return $2ae3ff7d7a45da29$var$isRunnable(resource === null || resource === void 0 ? void 0 : resource.kind);
}
module.exports.isRunnableResource = $2ae3ff7d7a45da29$var$isRunnableResource;
function $2ae3ff7d7a45da29$var$isRunnable(kind) {
    return $3Lmfz.runnableKinds.includes(kind);
}
module.exports.isRunnable = $2ae3ff7d7a45da29$var$isRunnable;
function $2ae3ff7d7a45da29$var$toSearchParams(obj) {
    const search = new URLSearchParams();
    Object.entries(obj).forEach(([key, value])=>{
        if (key !== "id" && value !== null && value !== undefined) search.set(key, value.toString());
    });
    return search;
}
module.exports.toSearchParams = $2ae3ff7d7a45da29$var$toSearchParams;
function $2ae3ff7d7a45da29$var$bearerToken(tokenValue) {
    return `Bearer ${tokenValue}`;
}
module.exports.bearerToken = $2ae3ff7d7a45da29$var$bearerToken;

});

parcelRegister("1LuDF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccessService = void 0;

var $kqe9W = parcelRequire("kqe9W");
class $1491f271654adeec$var$AccessService {
    constructor(fetch){
        this.apiVersion = $kqe9W.apiVersion;
        this.fetch = fetch;
    }
    basePath(resourceType) {
        return `/${this.apiVersion}/access/${resourceType}`;
    }
    listGroups() {
        return this.fetch(this.basePath("groups"), {
            method: "GET"
        });
    }
    createGroup(params) {
        return this.fetch(this.basePath("groups"), {
            method: "POST",
            body: params.group
        });
    }
    getGroup(params) {
        return this.fetch(`${this.basePath("groups")}/${params.id}`, {
            method: "GET"
        });
    }
    updateGroup(params) {
        return this.fetch(this.basePath("groups"), {
            method: "POST",
            body: params.group
        });
    }
    deleteGroup(params) {
        return this.fetch(`${this.basePath("groups")}/${params.id}`, {
            method: "DELETE"
        });
    }
    listGroupUsers(params) {
        return this.fetch(`${this.basePath("groups")}/${params.id}/users`, {
            method: "GET"
        });
    }
    addGroupUser(params) {
        return this.fetch(`${this.basePath("groups")}/${params.groupId}/users/${encodeURIComponent(params.userId)}`, {
            method: "PUT"
        });
    }
    removeGroupUser(params) {
        return this.fetch(`${this.basePath("groups")}/${params.groupId}/users/${encodeURIComponent(params.userId)}`, {
            method: "DELETE"
        });
    }
    listGroupRoles(params) {
        return this.fetch(`${this.basePath("groups")}/${params.id}/roles`, {
            method: "GET"
        });
    }
    addGroupRole(params) {
        return this.fetch(`${this.basePath("groups")}/${params.groupId}/roles/${params.roleId}`, {
            method: "PUT"
        });
    }
    removeGroupRole(params) {
        return this.fetch(`${this.basePath("groups")}/${params.groupId}/roles/${params.roleId}`, {
            method: "DELETE"
        });
    }
    listRoles() {
        return this.fetch(this.basePath("roles"), {
            method: "GET"
        });
    }
    getRole(params) {
        return this.fetch(`${this.basePath("roles")}/${params.id}`, {
            method: "GET"
        });
    }
    createRole(params) {
        return this.fetch(this.basePath("roles"), {
            method: "POST",
            body: params.role
        });
    }
    updateRole(params) {
        return this.fetch(this.basePath("roles"), {
            method: "POST",
            body: params.role
        });
    }
    deleteRole(params) {
        return this.fetch(`${this.basePath("roles")}/${params.id}`, {
            method: "DELETE"
        });
    }
    listRoleGroups(params) {
        return this.fetch(`${this.basePath("roles")}/${params.id}/groups`, {
            method: "GET"
        });
    }
    listRolePermissions(params) {
        return this.fetch(`${this.basePath("roles")}/${params.id}/permissions`, {
            method: "GET"
        });
    }
    setRolePermissions(params) {
        return this.fetch(`${this.basePath("roles")}/${params.id}/permissions`, {
            method: "PUT",
            body: params.permissions
        });
    }
    listUsers() {
        return this.fetch(this.basePath("users"), {
            method: "GET"
        });
    }
    getUser(params) {
        return this.fetch(`${this.basePath("users")}/${encodeURIComponent(params.id)}`, {
            method: "GET"
        });
    }
    getUserGroups(params) {
        return this.fetch(`${this.basePath("users")}/${encodeURIComponent(params.id)}/groups`, {
            method: "GET"
        });
    }
}
module.exports.AccessService = $1491f271654adeec$var$AccessService;
module.exports.default = $1491f271654adeec$var$AccessService;

});

parcelRegister("8E5lb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("55F8r", function(module, exports) {
"use strict";
var $3b4d53f96c7062a5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3b4d53f96c7062a5$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccountsService = void 0;

var $kqe9W = parcelRequire("kqe9W");
function $3b4d53f96c7062a5$var$toSearchParams(obj) {
    const search = new URLSearchParams();
    Object.entries(obj).forEach(([key, value])=>{
        if (key !== "id" && value !== undefined) search.set(key, value.toString());
    });
    return search;
}
class $3b4d53f96c7062a5$var$AccountsService {
    constructor(fetch){
        this.apiVersion = $kqe9W.apiVersion;
        this.fetch = fetch;
    }
    /**
     * Get a list of Decodable Accounts of which the authenticated user is a member.
     * @param params.pageSize The maximum number of items to return.
     * @param params.pageToken A token that indicates the page to fetch.
     * @param params.view The amount of data to return for the resource(s).
     *
     * A value of `basic` returns the standard properties of the resource. It may also produce data that is
     * considered "computationally cheap" to return. Specifying `basic` is the same as omitting this parameter.
     *
     * The behavior of `full` is service-dependent, but generally includes more fields. This can mean additional status
     * or version data, or even expanding references to contained resources. This should be used when the cost of an
     * additional API roundtrip is greater than the overhead of the request.
     *
     * @returns any A list of Decodable Accounts.
     * @returns Error An error has occurred.
     * @throws ApiError
     */ listUserAccounts(params) {
        const { pageSize: pageSize, pageToken: pageToken, view: view } = params;
        return this.fetch(`/${this.apiVersion}/accounts?${$3b4d53f96c7062a5$var$toSearchParams({
            pageSize: pageSize,
            pageToken: pageToken,
            view: view
        })}`);
    }
    /**
     * Create a Decodable Account.
     */ createAccount(params) {
        const { requestBody: body } = params;
        return this.fetch(`/${this.apiVersion}/accounts`, {
            method: "POST",
            body: body
        });
    }
    /**
     * Gets metadata for the account.
     */ getAccountMetadata() {
        return this.fetch(`/${this.apiVersion}/accounts/metadata`);
    }
    /**
     * Gets information for the account.
     */ getAccountInformation(params) {
        const { id: id } = params;
        return this.fetch(`/${this.apiVersion}/accounts/${id}`);
    }
    /**
     * Update a Decodable Account.
     */ updateAccount(params) {
        const { id: id } = params, body = $3b4d53f96c7062a5$var$__rest(params, [
            "id"
        ]);
        return this.fetch(`/${this.apiVersion}/accounts/${id}`, {
            method: "PATCH",
            body: body
        });
    }
    requestCustomPipelineAccess() {
        return this.fetch(`/${this.apiVersion}/accounts/request-custom-pipeline-access`, {
            method: "POST"
        });
    }
    uploadCertificateSigningRequest(accountName, opts) {
        const formData = new FormData();
        formData.append("file", opts.csr);
        return this.fetch(`/${this.apiVersion}/accounts/${accountName}/certificate_signing_request`, {
            method: "POST",
            body: formData
        });
    }
    getSignedCertificate(accountName) {
        return $3b4d53f96c7062a5$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.fetch(`/${this.apiVersion}/accounts/${accountName}/certificate`, {
                method: "GET"
            });
            const disposition = response.headers.get("Content-Disposition");
            /**
             * Will capture all characters inside the filename quotes.
             * Ex:  'filename="some-file.txt"' -> 'some-file.txt'
             */ const filenameRegex = /filename="([^"]+)"/;
            const match = disposition.match(filenameRegex);
            return {
                blob: yield response.blob(),
                filename: match ? match[1] : "certificate.pem"
            };
        });
    }
}
module.exports.AccountsService = $3b4d53f96c7062a5$var$AccountsService;

});

parcelRegister("4xiZF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jbO67", function(module, exports) {
"use strict";
var $df85e7c27b2c05d4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $df85e7c27b2c05d4$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionsService = void 0;

var $kqe9W = parcelRequire("kqe9W");

var $3GiXi = parcelRequire("3GiXi");
class $df85e7c27b2c05d4$var$ConnectionsService {
    constructor(fetch){
        this.apiVersion = $kqe9W.apiVersion;
        /**
         * Translate types from external to Decodable.
         */ this.translateTypesFromExternal = (requestBody)=>{
            return this.fetch(`/${this.apiVersion}/external/translate-types-from-external`, {
                method: "POST",
                body: requestBody
            });
        };
        /**
         * Translate types to external from Decodable.
         */ this.translateTypesToExternal = (requestBody)=>{
            return this.fetch(`/${this.apiVersion}/external/translate-types-to-external`, {
                method: "POST",
                body: requestBody
            });
        };
        /**
         * Scan and return all matching resources in an external system.
         * @returns any A request and token issued by the control plane API for use with the data plane API.
         */ this.getScanExternalResourcesToken = ({ connector: connector, properties: properties })=>{
            const body = {
                connector: connector,
                properties: Object.entries(properties).reduce((acc, [key, value])=>{
                    // any empty string properties should be `null` instead
                    acc[key] = value === "" ? null : value;
                    return acc;
                }, {})
            };
            return this.fetch(`/${this.apiVersion}/external/scan-resources/token`, {
                method: "POST",
                body: body
            });
        };
        /**
         * Create given resources in an external system.
         * @returns any A request and token issued by the control plane API for use with the data plane API.
         */ this.getCreateExternalResourcesToken = (requestBody)=>{
            return this.fetch(`/${this.apiVersion}/external/create-resources/token`, {
                method: "POST",
                body: requestBody
            });
        };
        this.fetch = fetch;
    }
    getMetricsToken(params) {
        return this.fetch(`/${this.apiVersion}/connections/${params.id}/metrics/token`, {
            method: "POST"
        });
    }
    listConnections(params = {}) {
        return this.fetch(`/${this.apiVersion}/connections?response_schema_v=v2&${(0, $3GiXi.toSearchParams)(params)}`);
    }
    getConnection(params) {
        const { id: id } = params, search = $df85e7c27b2c05d4$var$__rest(params, [
            "id"
        ]);
        return this.fetch(`/${this.apiVersion}/connections/${id}?response_schema_v=v2&${(0, $3GiXi.toSearchParams)(search)}`);
    }
    activateConnection(params) {
        const { start_position: start_position, task_size: task_size } = params, searchParams = $df85e7c27b2c05d4$var$__rest(params, [
            "start_position",
            "task_size"
        ]);
        return this.fetch(`/${this.apiVersion}/connections/${params.id}/activate?response_schema_v=v2&${(0, $3GiXi.toSearchParams)(searchParams)}`, {
            method: "POST",
            body: {
                start_position: start_position,
                task_size: task_size
            }
        });
    }
    createConnection(connection, params) {
        return this.fetch(`/${this.apiVersion}/connections?response_schema_v=v2&${(0, $3GiXi.toSearchParams)(params)}`, {
            method: "POST",
            body: connection
        });
    }
    deactivateConnection(params) {
        return this.fetch(`/${this.apiVersion}/connections/${params.id}/deactivate?response_schema_v=v2&${(0, $3GiXi.toSearchParams)(params)}`, {
            method: "POST"
        });
    }
    deleteConnection(id) {
        return this.fetch(`/${this.apiVersion}/connections/${id}`, {
            method: "DELETE"
        });
    }
    updateConnection(params) {
        return this.fetch(`/${this.apiVersion}/connections/${params.id}?response_schema_v=v2&`, {
            method: "PATCH",
            body: params.body
        });
    }
    getDependencies(params) {
        return $df85e7c27b2c05d4$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this.fetch(`/${this.apiVersion}/connections/${params.id}/dependencies`);
            [
                ...Object.values(result.inputs),
                ...Object.values(result.outputs)
            ].forEach((v)=>v.resourceType = v.resourceType.toUpperCase());
            return result;
        });
    }
    getExistingConnectivityCheckToken(id, requestBody) {
        return $df85e7c27b2c05d4$var$__awaiter(this, void 0, void 0, function*() {
            return this.fetch(`/${this.apiVersion}/connections/${id}/connectivity-check/token`, {
                method: "POST",
                body: requestBody
            });
        });
    }
    getUncreatedConnectivityCheckToken(requestBody) {
        return $df85e7c27b2c05d4$var$__awaiter(this, void 0, void 0, function*() {
            return this.fetch(`/${this.apiVersion}/connectivity-check/token`, {
                method: "POST",
                body: requestBody
            });
        });
    }
    getEventsToken(params) {
        return $df85e7c27b2c05d4$var$__awaiter(this, void 0, void 0, function*() {
            return this.fetch(`/${this.apiVersion}/connections/${params.connection_id}/events/upload-ui/token`, {
                method: "POST",
                body: JSON.stringify({
                    events: params.events
                })
            });
        });
    }
}
module.exports.ConnectionsService = $df85e7c27b2c05d4$var$ConnectionsService;
module.exports.default = $df85e7c27b2c05d4$var$ConnectionsService;

});

parcelRegister("4uUhZ", function(module, exports) {
"use strict";
var $3465a09de46e13d8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionsDataService = void 0;

var $kqe9W = parcelRequire("kqe9W");
class $3465a09de46e13d8$var$ConnectionsDataService {
    constructor({ client: client }){
        this.apiVersion = $kqe9W.apiVersion;
        this.client = client;
    }
    getMetrics(params) {
        return $3465a09de46e13d8$var$__awaiter(this, void 0, void 0, function*() {
            return (yield this.client.fetch(`/${this.apiVersion}/connections/${params.id}/metrics`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${params.auth_token}`,
                    "Content-Type": "application/json"
                },
                body: params.data_plane_request
            })).json();
        });
    }
    runConnectivityCheck(params) {
        return $3465a09de46e13d8$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.client.fetch(`/${this.apiVersion}/connectivity-check`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${params.auth_token}`,
                    "Content-Type": "application/json"
                },
                body: params.data_plane_request
            });
        });
    }
    /**
     * Scan and return all matching resources in an external system.
     * Requires a bearer token for this operation issued by the control plane API.
     *
     * @param params A scan external resources request request body.
     * @returns any A scan external resources response.
     * @returns Error An error has occurred.
     */ scanExternalResources(params) {
        return $3465a09de46e13d8$var$__awaiter(this, void 0, void 0, function*() {
            return (yield this.client.fetch(`/${this.apiVersion}/external/scan-resources`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${params.auth_token}`,
                    "Content-Type": "application/json"
                },
                body: params.data_plane_request
            })).json();
        });
    }
    /**
     * Create given resources in an external system.
     * Requires a bearer token for this operation issued by the control plane API.
     *
     * @param params A create external resources request body.
     * @returns any A create external resources response.
     * @returns Error An error has occurred.
     */ createExternalResources(params) {
        return $3465a09de46e13d8$var$__awaiter(this, void 0, void 0, function*() {
            return (yield this.client.fetch(`/${this.apiVersion}/external/create-resources`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${params.auth_token}`,
                    "Content-Type": "application/json"
                },
                body: params.data_plane_request
            })).json();
        });
    }
    postEvents(params) {
        return $3465a09de46e13d8$var$__awaiter(this, void 0, void 0, function*() {
            const body = "events" in params ? JSON.stringify({
                events: params.events
            }) : params.data_plane_request;
            return (yield this.client.fetch(`/${this.apiVersion}/connections/${params.connection_id}/events-ui`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${params.auth_token}`,
                    "Content-Type": "application/json"
                },
                body: body
            })).json();
        });
    }
}
module.exports.ConnectionsDataService = $3465a09de46e13d8$var$ConnectionsDataService;
module.exports.default = $3465a09de46e13d8$var$ConnectionsDataService;

});

parcelRegister("eQ7rz", function(module, exports) {
"use strict";
// todo: Dedup some of these types w/ streams & pipelines.
//       Defering this until we extract a decodable-sdk-js
//       package, and keeping each domain's api type
//       definition file self-contained for now.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lh9lt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiagnosticsService = void 0;

var $kqe9W = parcelRequire("kqe9W");
class $f7d26f45ad31c3de$var$DiagnosticsService {
    constructor(fetch){
        this.apiVersion = $kqe9W.apiVersion;
        this.fetch = fetch;
    }
    getToken(params) {
        return this.fetch(`/${this.apiVersion}/diagnostics/tokens`, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(params)
        });
    }
}
module.exports.DiagnosticsService = $f7d26f45ad31c3de$var$DiagnosticsService;

});

parcelRegister("dLGOr", function(module, exports) {
"use strict";
var $a060dfd153e09d8c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiagnosticsDataService = void 0;

var $kqe9W = parcelRequire("kqe9W");
const $a060dfd153e09d8c$var$configurationError = "Contact Decodable support to ensure your data plane is properly configured to support diagnostics.";
class $a060dfd153e09d8c$var$DiagnosticsDataService {
    constructor({ client: client }){
        this.apiVersion = $kqe9W.apiVersion;
        this.client = client;
    }
    getDiagnostics(params) {
        return $a060dfd153e09d8c$var$__awaiter(this, void 0, void 0, function*() {
            let response;
            try {
                response = yield this.client.fetch(`/${this.apiVersion}/diagnostics`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${params.token}`,
                        "Content-Type": "application/json",
                        Accept: "application/x-tar"
                    },
                    body: params.data_plane_request
                });
            } catch (ex) {
                // If the fetch fails, it's likely the data plane API is not upgraded.
                // It could also be misconfigured. Suggest the user contact support to
                // verify their configuration.
                throw new Error($a060dfd153e09d8c$var$configurationError, ex);
            }
            // Legacy data plane API may reject this request. Use the configuration
            // error in these cases so we can walk them through the upgrade.
            // This is a bit imprecise but glosses over a breaking API change.
            if (!response.ok) throw new Error($a060dfd153e09d8c$var$configurationError);
            return response.blob();
        });
    }
}
module.exports.DiagnosticsDataService = $a060dfd153e09d8c$var$DiagnosticsDataService;

});

parcelRegister("i1a44", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eA63m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2jzPR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FileService = void 0;

var $kqe9W = parcelRequire("kqe9W");
class $1af9274c3f8fdc9d$var$FileService {
    constructor(fetch){
        this.fetch = fetch;
        this.apiVersion = $kqe9W.apiVersion;
    }
    getFileMetadataBySha(payload) {
        return this.fetch(`/${this.apiVersion}/files/${payload.sha}?type=${payload.type}`, {
            method: "GET"
        });
    }
    getFileUploadToken(params) {
        return this.fetch(`/${this.apiVersion}/files/upload-token`, {
            method: "POST",
            body: params.body
        });
    }
}
module.exports.FileService = $1af9274c3f8fdc9d$var$FileService;

});

parcelRegister("1on64", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FileDataService = void 0;

var $kqe9W = parcelRequire("kqe9W");

var $3Lmfz = parcelRequire("3Lmfz");

var $3GiXi = parcelRequire("3GiXi");
class $1039f2e28f5e1815$var$FileDataService {
    constructor({ client: client }){
        this.apiVersion = $kqe9W.apiVersion;
        this.client = client;
    }
    fileUpload(params) {
        const formData = new FormData();
        formData.append("file", params.body.file);
        formData.append("type", new Blob([
            JSON.stringify(params.body.type)
        ], {
            type: $3Lmfz.applicationJsonType
        }));
        formData.append("request", new Blob([
            params.body.request
        ], {
            type: $3Lmfz.applicationJsonType
        }));
        return this.client.fetch(`/${this.apiVersion}/files`, {
            method: "POST",
            headers: {
                [$3Lmfz.authorizationHeader]: (0, $3GiXi.bearerToken)(params.fileUploadToken)
            },
            body: formData
        }).then((response)=>response.json());
    }
}
module.exports.FileDataService = $1039f2e28f5e1815$var$FileDataService;

});

parcelRegister("jvm42", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kgnVh", function(module, exports) {
"use strict";
var $ec07dbdf0061f9ec$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LineageService = void 0;

var $kqe9W = parcelRequire("kqe9W");
class $ec07dbdf0061f9ec$var$LineageService {
    constructor(fetch){
        this.apiVersion = $kqe9W.apiVersion;
        this.fetch = fetch;
    }
    getLineage(req) {
        return $ec07dbdf0061f9ec$var$__awaiter(this, void 0, void 0, function*() {
            const resp = yield this.fetch(`/${this.apiVersion}/lineage`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: req != null ? JSON.stringify(req) : undefined
            });
            return resp;
        });
    }
}
module.exports.LineageService = $ec07dbdf0061f9ec$var$LineageService;

});

parcelRegister("38WPK", function(module, exports) {
"use strict";
var $249fc19aa4be916c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $249fc19aa4be916c$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PipelinesService = void 0;

var $kqe9W = parcelRequire("kqe9W");

var $3GiXi = parcelRequire("3GiXi");
class $249fc19aa4be916c$var$PipelinesService {
    constructor(fetch){
        this.apiVersion = $kqe9W.apiVersion;
        this.fetch = fetch;
    }
    getMetricsToken(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.id}/metrics/token?version=${params.version}`, {
            method: "POST"
        });
    }
    listPipelines(params = {}) {
        return this.fetch(`/${this.apiVersion}/pipelines?${(0, $3GiXi.toSearchParams)(params)}`);
    }
    getPipeline(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.id}?${(0, $3GiXi.toSearchParams)(params)}`);
    }
    createPipeline(params) {
        const { body: body } = params;
        return this.fetch(`/${this.apiVersion}/pipelines`, {
            method: "POST",
            body: body
        });
    }
    updatePipeline(params) {
        const { id: id, body: body } = params;
        return this.fetch(`/${this.apiVersion}/pipelines/${id}`, {
            method: "PATCH",
            body: body
        });
    }
    createCustomPipeline(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/custom`, {
            method: "POST",
            body: params.body
        });
    }
    getCustomPipelineFlinkVersions() {
        return this.fetch(`/${this.apiVersion}/pipelines/custom/flink-versions`);
    }
    updateCustomPipeline(params) {
        const { id: id, body: body } = params;
        return this.fetch(`/${this.apiVersion}/pipelines/custom/${id}`, {
            method: "PATCH",
            body: body
        });
    }
    deletePipeline(id) {
        return this.fetch(`/${this.apiVersion}/pipelines/${id}`, {
            method: "DELETE"
        });
    }
    activatePipeline(params) {
        const { start_positions: start_positions, task_size: task_size, start_from_snapshot_id: start_from_snapshot_id } = params, searchParams = $249fc19aa4be916c$var$__rest(params, [
            "start_positions",
            "task_size",
            "start_from_snapshot_id"
        ]);
        return this.fetch(`/${this.apiVersion}/pipelines/${params.id}/activate?${(0, $3GiXi.toSearchParams)(searchParams)}`, {
            body: {
                task_size: task_size,
                start_positions: start_positions,
                start_from_snapshot_id: start_from_snapshot_id
            },
            method: "POST"
        });
    }
    deactivatePipeline(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.id}/deactivate?${(0, $3GiXi.toSearchParams)(params)}`, {
            method: "POST"
        });
    }
    streams(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.id}/streams`);
    }
    getDependencies(params) {
        return $249fc19aa4be916c$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this.fetch(`/${this.apiVersion}/pipelines/${params.id}/dependencies?version=${params.version}`);
            [
                ...Object.values(result.inputs),
                ...Object.values(result.outputs)
            ].forEach((v)=>v.resourceType = v.resourceType.toUpperCase());
            return result;
        });
    }
    getOutputStream({ sql: sql }) {
        return this.fetch(`/${this.apiVersion}/pipelines/outputStream?response_schema_v=v2&`, {
            method: "POST",
            body: {
                sql: sql
            }
        });
    }
    getFlinkUiToken(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.id}/flink-ui/token?${(0, $3GiXi.toSearchParams)(params)}`, {
            method: "POST"
        });
    }
    listSnapshots(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.pipelineId}/snapshots`);
    }
    getSnapshot(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.pipelineId}/snapshots/${params.snapshotId}`);
    }
    createSnapshot(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.pipeline_id}/snapshots`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(params)
        });
    }
    deleteSnapshot(params) {
        return this.fetch(`/${this.apiVersion}/pipelines/${params.pipelineId}/snapshots/${params.snapshotId}`, {
            method: "DELETE"
        });
    }
}
module.exports.PipelinesService = $249fc19aa4be916c$var$PipelinesService;
module.exports.default = $249fc19aa4be916c$var$PipelinesService;

});

parcelRegister("cXYct", function(module, exports) {
"use strict";
var $9709b13a99eadd96$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PipelinesDataService = void 0;

var $kqe9W = parcelRequire("kqe9W");

var $3GiXi = parcelRequire("3GiXi");

var $3Lmfz = parcelRequire("3Lmfz");
class $9709b13a99eadd96$var$PipelinesDataService {
    constructor({ client: client }){
        this.apiVersion = $kqe9W.apiVersion;
        this.client = client;
    }
    getMetrics(params) {
        return $9709b13a99eadd96$var$__awaiter(this, void 0, void 0, function*() {
            return (yield this.client.fetch(`/${this.apiVersion}/pipelines/${params.id}/metrics`, {
                method: "POST",
                headers: {
                    [$3Lmfz.authorizationHeader]: (0, $3GiXi.bearerToken)(params.auth_token),
                    [$3Lmfz.contentTypeHeader]: $3Lmfz.applicationJsonType
                },
                body: params.data_plane_request
            })).json();
        });
    }
}
module.exports.PipelinesDataService = $9709b13a99eadd96$var$PipelinesDataService;
module.exports.default = $9709b13a99eadd96$var$PipelinesDataService;

});

parcelRegister("e7MfT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.customPipelineTypes = void 0;
module.exports.customPipelineTypes = [
    "JAVA",
    "PYTHON"
];

});

parcelRegister("4TRwZ", function(module, exports) {
"use strict";
var $3915d2a88ee897b8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PreviewService = void 0;

var $kqe9W = parcelRequire("kqe9W");
class $3915d2a88ee897b8$var$PreviewService {
    constructor(fetch){
        this.apiVersion = $kqe9W.apiVersion;
        this.fetch = fetch;
    }
    getPreviewToken(params) {
        return $3915d2a88ee897b8$var$__awaiter(this, void 0, void 0, function*() {
            return this.fetch(`/${this.apiVersion}/preview/tokens`, {
                method: "POST",
                body: JSON.stringify(params),
                headers: {
                    "Content-Type": "application/json"
                }
            });
        });
    }
    /** @deprecated Use the PreviewDataApi instead */ createPreview(params) {
        return $3915d2a88ee897b8$var$__awaiter(this, void 0, void 0, function*() {
            let resp;
            resp = yield this.fetch(`/${this.apiVersion}/preview`, {
                method: "POST",
                body: JSON.stringify(params),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            // Tag legacy preview objects as "CHANGE" stream producers.
            //
            // Before DE-3061, they were all implicitly change streams,
            // so this maintains legacy behavior.
            if (!("output_stream_type" in resp)) return Object.assign(Object.assign({}, resp), {
                output_stream_type: "CHANGE"
            });
            return resp;
        });
    }
    /** @deprecated Use the PreviewDataApi instead */ getPreview(params) {
        return $3915d2a88ee897b8$var$__awaiter(this, void 0, void 0, function*() {
            const query = params.pagination_token ? `?token=${params.pagination_token}` : "";
            return this.fetch(`/${this.apiVersion}/preview/${params.id}${query}`);
        });
    }
    getDependencies(sql) {
        return this.fetch(`/${this.apiVersion}/preview/dependencies`, {
            method: "POST",
            body: JSON.stringify({
                sql: sql
            }),
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
}
module.exports.PreviewService = $3915d2a88ee897b8$var$PreviewService;
module.exports.default = $3915d2a88ee897b8$var$PreviewService;

});

parcelRegister("6HR42", function(module, exports) {
"use strict";
var $4e1febafb13f636a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PreviewDataService = void 0;

var $kqe9W = parcelRequire("kqe9W");
class $4e1febafb13f636a$var$PreviewDataService {
    constructor({ client: client }){
        this.apiVersion = $kqe9W.apiVersion;
        this.client = client;
    }
    createPreview(params) {
        return $4e1febafb13f636a$var$__awaiter(this, void 0, void 0, function*() {
            return (yield this.client.fetch(`/${this.apiVersion}/sql/preview`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${params.auth_token}`,
                    "Content-Type": "application/json"
                },
                body: params.data_plane_request
            })).json();
        });
    }
    getPreview(params) {
        return $4e1febafb13f636a$var$__awaiter(this, void 0, void 0, function*() {
            return (yield this.client.fetch(`/${this.apiVersion}/sql/preview`, {
                headers: {
                    Authorization: `Bearer ${params.auth_token}`,
                    "decodable-token": params.pagination_token
                }
            })).json();
        });
    }
}
module.exports.PreviewDataService = $4e1febafb13f636a$var$PreviewDataService;
module.exports.default = $4e1febafb13f636a$var$PreviewDataService;

});

parcelRegister("GOHlA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3gq5r", function(module, exports) {
"use strict";
var $260719fec3919579$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryService = void 0;

var $kqe9W = parcelRequire("kqe9W");
class $260719fec3919579$var$QueryService {
    constructor(fetch){
        this.fetch = fetch;
        this.apiVersion = $kqe9W.apiVersion;
    }
    listSecrets(params = {}) {
        return this.query(Object.assign({
            operation: "list",
            kinds: [
                "secret"
            ],
            keep_ids: true,
            spec_versions: {
                secret: "v1"
            }
        }, params));
    }
    listPipelines(params = {}) {
        return this.query(Object.assign({
            operation: "list",
            kinds: [
                "pipeline"
            ],
            keep_ids: true,
            spec_versions: {
                pipeline: "v2"
            }
        }, params));
    }
    listConnections(params = {}) {
        return this.query(Object.assign({
            operation: "list",
            kinds: [
                "connection"
            ],
            keep_ids: true,
            spec_versions: {
                connection: "v2"
            }
        }, params));
    }
    listStreams(params = {}) {
        return this.query(Object.assign({
            operation: "list",
            kinds: [
                "stream"
            ],
            keep_ids: true,
            include_immutables: true,
            spec_versions: {
                stream: "v1"
            }
        }, params));
    }
    query(params) {
        var _a, _b, _c, _d, _e;
        var _f, _g, _h, _j;
        return $260719fec3919579$var$__awaiter(this, void 0, void 0, function*() {
            /**
             * Ensure we always have a stable default
             * See # incident-2024-10-24-job-status-errors
             */ if (params.spec_versions !== null) {
                (_a = params.spec_versions) !== null && _a !== void 0 ? _a : params.spec_versions = {};
                (_b = (_f = params.spec_versions).pipeline) !== null && _b !== void 0 ? _b : _f.pipeline = "v2";
                (_c = (_g = params.spec_versions).connection) !== null && _c !== void 0 ? _c : _g.connection = "v2";
                (_d = (_h = params.spec_versions).stream) !== null && _d !== void 0 ? _d : _h.stream = "v1";
                (_e = (_j = params.spec_versions).secret) !== null && _e !== void 0 ? _e : _j.secret = "v1";
            }
            const data = yield this.fetch(`/${this.apiVersion}/query`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-yaml"
                },
                body: JSON.stringify(params)
            });
            return data.items;
        });
    }
    apply(params, opts = {
        dryRun: false
    }) {
        return $260719fec3919579$var$__awaiter(this, void 0, void 0, function*() {
            const data = yield this.fetch(`/${this.apiVersion}/apply?dry_run=${opts.dryRun}`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-yaml"
                },
                body: JSON.stringify(params)
            });
            return data.items;
        });
    }
    queryAsYaml(params) {
        return $260719fec3919579$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.fetch(`/${this.apiVersion}/query`, {
                method: "POST",
                headers: {
                    Accept: "application/x-yaml",
                    "Content-Type": "application/x-yaml"
                },
                body: JSON.stringify(params)
            });
        });
    }
    applyAsYaml(yaml, opts = {
        dryRun: false
    }) {
        return $260719fec3919579$var$__awaiter(this, void 0, void 0, function*() {
            const data = yield this.fetch(`/${this.apiVersion}/apply?dry_run=${opts.dryRun}`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-yaml"
                },
                body: yaml
            });
            return data.items;
        });
    }
}
module.exports.QueryService = $260719fec3919579$var$QueryService;

});

parcelRegister("2MINJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5s7CS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SchemaService = void 0;

var $kqe9W = parcelRequire("kqe9W");
class $3f857baaeb331571$var$SchemaService {
    constructor(fetch){
        this.apiVersion = $kqe9W.apiVersion;
        this.fetch = fetch;
    }
    compileSchema(body) {
        return this.fetch(`/${this.apiVersion}/schema/compile`, {
            method: "POST",
            body: body
        });
    }
}
module.exports.SchemaService = $3f857baaeb331571$var$SchemaService;
module.exports.default = $3f857baaeb331571$var$SchemaService;

});

parcelRegister("032gY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6vsFc", function(module, exports) {
"use strict";
var $4bcbdf4fc9d0605e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamsService = void 0;

var $kqe9W = parcelRequire("kqe9W");

var $3GiXi = parcelRequire("3GiXi");
class $4bcbdf4fc9d0605e$var$StreamsService {
    constructor(fetch){
        this.apiVersion = $kqe9W.apiVersion;
        this.fetch = fetch;
    }
    listStreams(params = {}) {
        return this.fetch(`/${this.apiVersion}/streams?response_schema_v=v2&${(0, $3GiXi.toSearchParams)(params)}`);
    }
    getStream(params) {
        return this.fetch(`/${this.apiVersion}/streams/${params.id}?response_schema_v=v2&${(0, $3GiXi.toSearchParams)(params)}`);
    }
    createStream({ stream: stream, allowEquivalent: allowEquivalent = false, allowEvolution: allowEvolution = false }) {
        const params = (0, $3GiXi.toSearchParams)({
            response_schema_v: "v2",
            allow_equivalent: allowEquivalent,
            allow_evolution: allowEvolution
        });
        return this.fetch(`/${this.apiVersion}/streams?${params}`, {
            method: "POST",
            body: stream
        });
    }
    deleteStream(id) {
        return this.fetch(`/${this.apiVersion}/streams/${id}?response_schema_v=v2&`, {
            method: "DELETE"
        });
    }
    updateStream(params) {
        const { id: id, body: body } = params;
        return this.fetch(`/${this.apiVersion}/streams/${id}?response_schema_v=v2&`, {
            method: "PATCH",
            body: body
        });
    }
    /** @deprecated Use the StreamsDataService instead */ clearStream(id) {
        return this.fetch(`/${this.apiVersion}/streams/${id}/clear?response_schema_v=v2&`, {
            method: "POST"
        });
    }
    getDependencies(params) {
        return $4bcbdf4fc9d0605e$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this.fetch(`/${this.apiVersion}/streams/${params.id}/dependencies?response_schema_v=v2&`);
            [
                ...Object.values(result.inputs),
                ...Object.values(result.outputs)
            ].forEach((v)=>v.resourceType = v.resourceType.toUpperCase());
            return result;
        });
    }
    getPreview(params) {
        return $4bcbdf4fc9d0605e$var$__awaiter(this, void 0, void 0, function*() {
            return this.fetch(`/${this.apiVersion}/streams/${params.id}/preview`);
        });
    }
    getPreviewToken(params) {
        return $4bcbdf4fc9d0605e$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.fetch(`/${this.apiVersion}/streams/${params.id}/preview/token`, {
                method: "POST"
            });
        });
    }
    getClearToken(params) {
        return $4bcbdf4fc9d0605e$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.fetch(`/${this.apiVersion}/streams/${params.id}/clear/token`, {
                method: "POST"
            });
        });
    }
}
module.exports.StreamsService = $4bcbdf4fc9d0605e$var$StreamsService;
module.exports.default = $4bcbdf4fc9d0605e$var$StreamsService;

});

parcelRegister("a0N3i", function(module, exports) {
"use strict";
var $749ff43497bdc4be$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamsDataService = void 0;

var $kqe9W = parcelRequire("kqe9W");
class $749ff43497bdc4be$var$StreamsDataService {
    constructor({ client: client }){
        this.apiVersion = $kqe9W.apiVersion;
        this.client = client;
    }
    clearStream(params) {
        return $749ff43497bdc4be$var$__awaiter(this, void 0, void 0, function*() {
            yield this.client.fetch(`/${this.apiVersion}/streams/${params.id}/clear`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${params.token}`
                }
            });
        });
    }
    getPreview(params) {
        return $749ff43497bdc4be$var$__awaiter(this, void 0, void 0, function*() {
            return (yield this.client.fetch(`/${this.apiVersion}/streams/${params.id}/preview`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${params.token}`
                }
            })).json();
        });
    }
}
module.exports.StreamsDataService = $749ff43497bdc4be$var$StreamsDataService;
module.exports.default = $749ff43497bdc4be$var$StreamsDataService;

});

parcelRegister("68Tzh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fRGdT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TasksService = void 0;

var $kqe9W = parcelRequire("kqe9W");
class $b8cc8edbea1d4b76$var$TasksService {
    constructor(fetch){
        this.apiVersion = $kqe9W.apiVersion;
        this.fetch = fetch;
    }
    /**
     * Get available task sizes.
     * @returns {TaskSizes} A description of available task sizes.
     * @returns Error An error has occurred.
     * @throws ApiError
     */ getTasks() {
        return this.fetch(`/${this.apiVersion}/tasks/sizes`, {
            method: "GET"
        });
    }
}
module.exports.TasksService = $b8cc8edbea1d4b76$var$TasksService;

});

parcelRegister("kquI2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dGfjY", function(module, exports) {
"use strict";
var $9f5b151377eb0f90$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SecretsService = void 0;

var $kqe9W = parcelRequire("kqe9W");

var $3GiXi = parcelRequire("3GiXi");
class $9f5b151377eb0f90$var$SecretsService {
    constructor(fetch){
        this.apiVersion = $kqe9W.apiVersion;
        this.fetch = fetch;
    }
    listSecrets(params) {
        return this.fetch(`/${this.apiVersion}/secrets?${(0, $3GiXi.toSearchParams)({
            pageSize: params === null || params === void 0 ? void 0 : params.pageSize,
            pageToken: params === null || params === void 0 ? void 0 : params.pageToken
        })}`);
    }
    createSecret(params) {
        const { secret: secret } = params;
        return this.fetch(`/${this.apiVersion}/secrets`, {
            method: "POST",
            body: secret
        });
    }
    getSecret(params) {
        const { id: id } = params;
        return this.fetch(`/${this.apiVersion}/secrets/${id}`);
    }
    updateSecret(params) {
        const { id: id, secret: secret } = params;
        return this.fetch(`/${this.apiVersion}/secrets/${id}`, {
            method: "PATCH",
            body: secret
        });
    }
    deleteSecret(params) {
        return $9f5b151377eb0f90$var$__awaiter(this, void 0, void 0, function*() {
            const { id: id } = params;
            yield this.fetch(`/${this.apiVersion}/secrets/${id}`, {
                method: "DELETE"
            });
        });
    }
    getSecretPlaintextToken(params) {
        const { id: id } = params;
        return this.fetch(`/${this.apiVersion}/secrets/${id}/plaintext/token`, {
            method: "POST"
        });
    }
}
module.exports.SecretsService = $9f5b151377eb0f90$var$SecretsService;
module.exports.default = $9f5b151377eb0f90$var$SecretsService;

});

parcelRegister("hOxb2", function(module, exports) {
"use strict";
var $cf80d76d79340786$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SecretsDataService = void 0;

var $kqe9W = parcelRequire("kqe9W");
class $cf80d76d79340786$var$SecretsDataService {
    constructor({ client: client }){
        this.apiVersion = $kqe9W.apiVersion;
        this.client = client;
    }
    setSecretPlaintext(params) {
        return $cf80d76d79340786$var$__awaiter(this, void 0, void 0, function*() {
            yield this.client.fetch(`/${this.apiVersion}/secrets/plaintext`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${params.token}`,
                    "Content-Type": "application/json",
                    "decodable-plaintext-base64": btoa(params.plaintext)
                },
                body: params.data_plane_request
            });
        });
    }
}
module.exports.SecretsDataService = $cf80d76d79340786$var$SecretsDataService;

});

parcelRegister("lnRTe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("btQPI", function(module, exports) {
"use strict";
var $85bb62b468fd6d6d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TagsService = void 0;

var $kqe9W = parcelRequire("kqe9W");
class $85bb62b468fd6d6d$var$TagsService {
    constructor(fetch){
        this.fetch = fetch;
        this.apiVersion = $kqe9W.apiVersion;
    }
    getKeys() {
        return $85bb62b468fd6d6d$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.fetch(`/${this.apiVersion}/tags/keys`, {
                method: "GET"
            });
        });
    }
    getValuesByKey(key) {
        return $85bb62b468fd6d6d$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.fetch(`/${this.apiVersion}/tags/keys/${key}/values`, {
                method: "GET"
            });
        });
    }
}
module.exports.TagsService = $85bb62b468fd6d6d$var$TagsService;

});

parcelRegister("17JVE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fC8t2", function(module, exports) {
"use strict";
var $b5e0f915d58fe309$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UsageService = void 0;

var $kqe9W = parcelRequire("kqe9W");
class $b5e0f915d58fe309$var$UsageService {
    constructor(fetch){
        this.fetch = fetch;
        this.apiVersion = $kqe9W.apiVersion;
    }
    timeseries(request) {
        return $b5e0f915d58fe309$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.fetch(`/${this.apiVersion}/usage/timeseries`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(request)
            });
        });
    }
}
module.exports.UsageService = $b5e0f915d58fe309$var$UsageService;

});

parcelRegister("70q3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});




parcelRegister("cleXH", function(module, exports) {

$parcel$export(module.exports, "sample", () => $4b378e94b01628ea$export$4812e460280c6ef2);
$parcel$export(module.exports, "rootUrl", () => $4b378e94b01628ea$export$e238283959402bc7);
$parcel$export(module.exports, "auth0LoginOptions", () => $4b378e94b01628ea$export$a773014e68795735);
$parcel$export(module.exports, "emailRegex", () => $4b378e94b01628ea$export$976c37132e9c6a10);
$parcel$export(module.exports, "splitEmailList", () => $4b378e94b01628ea$export$f0ddc3e5fec56d2d);
const $4b378e94b01628ea$export$e772c8ff12451969 = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $4b378e94b01628ea$export$4812e460280c6ef2 = (list)=>list[Math.floor(Math.random() * list.length)];
const $4b378e94b01628ea$export$e238283959402bc7 = (location)=>location.protocol + "//" + location.host;
const $4b378e94b01628ea$export$a773014e68795735 = ({ target: target, organization: organization } = {})=>{
    return {
        authorizationParams: {
            organization: organization
        },
        appState: {
            returnTo: `${window.location.origin}/-/callback/auth`,
            target: target || window.location.pathname + window.location.search
        }
    };
};
const $4b378e94b01628ea$export$976c37132e9c6a10 = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function $4b378e94b01628ea$export$f0ddc3e5fec56d2d(emails) {
    return (emails || "").split(/[\s,]+/).filter((e)=>e !== "");
}

});

parcelRegister("4In7L", function(module, exports) {

$parcel$export(module.exports, "useSnackbar", () => $abd8de5ce23c7402$export$1c97ac2c9a6e7c09);
$parcel$export(module.exports, "default", () => $abd8de5ce23c7402$export$2e2bcd8739ae039);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $2HnwK = parcelRequire("2HnwK");
var $hWbHi = parcelRequire("hWbHi");
var $gL7Hl = parcelRequire("gL7Hl");

var $8aalP = parcelRequire("8aalP");
const $abd8de5ce23c7402$export$216a88342db54c29 = /*#__PURE__*/ (0, $aOzEm.createContext)(()=>{});
function $abd8de5ce23c7402$export$1c97ac2c9a6e7c09() {
    return (0, $aOzEm.useContext)($abd8de5ce23c7402$export$216a88342db54c29);
}
function $abd8de5ce23c7402$export$2e2bcd8739ae039({ children: children, autoHideDuration: autoHideDuration = 5000 }) {
    const [data, setData] = (0, $aOzEm.useState)(null);
    const showSnackbar = (snackData)=>setData(snackData);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($abd8de5ce23c7402$export$216a88342db54c29.Provider, {
        value: showSnackbar,
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $gL7Hl.default), {
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right"
                },
                open: !!data,
                onClose: ()=>{
                    setData(null);
                },
                autoHideDuration: data?.severity == "error" ? undefined : autoHideDuration,
                sx: {
                    userSelect: "all",
                    maxWidth: "1200px"
                },
                children: data && /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $2HnwK.default), {
                    severity: data.severity || "info",
                    sx: {
                        marginLeft: 2
                    },
                    children: [
                        data.title && /*#__PURE__*/ (0, $2T9xh.jsx)((0, $hWbHi.default), {
                            children: data.title
                        }),
                        Boolean(data.message) ? /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8aalP.default), {
                            component: "pre",
                            sx: {
                                padding: 0,
                                margin: 0,
                                overflow: "auto",
                                maxHeight: "90vh",
                                textWrap: "wrap",
                                fontFamily: "var(--font-family)"
                            },
                            children: data.message
                        }) : null
                    ]
                })
            }),
            children
        ]
    });
}

});
parcelRegister("2HnwK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f71d8ebc70d0182$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $fOENh = parcelRequire("fOENh");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $63Oo6 = parcelRequire("63Oo6");

var $h0mm1 = parcelRequire("h0mm1");

var $5B34R = parcelRequire("5B34R");

var $8p0qe = parcelRequire("8p0qe");

var $hMuBF = parcelRequire("hMuBF");

var $koDVN = parcelRequire("koDVN");

var $96kC3 = parcelRequire("96kC3");

var $1EyLv = parcelRequire("1EyLv");

var $7rIga = parcelRequire("7rIga");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $1f71d8ebc70d0182$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $1f71d8ebc70d0182$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${variant}${(0, $63Oo6.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            "icon"
        ],
        message: [
            "message"
        ],
        action: [
            "action"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $5B34R.getAlertUtilityClass), classes);
};
const $1f71d8ebc70d0182$var$AlertRoot = (0, $25zst.default)((0, $h0mm1.default), {
    name: "MuiAlert",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $63Oo6.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const getColor = theme.palette.mode === "light" ? (0, $fOENh.darken) : (0, $fOENh.lighten);
    const getBackgroundColor = theme.palette.mode === "light" ? (0, $fOENh.lighten) : (0, $fOENh.darken);
    const color = ownerState.color || ownerState.severity;
    return (0, $g6Hsb.default)({}, theme.typography.body2, {
        backgroundColor: "transparent",
        display: "flex",
        padding: "6px 16px"
    }, color && ownerState.variant === "standard" && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
        [`& .${(0, $5B34R.default).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette[color].main
        }
    }, color && ownerState.variant === "outlined" && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
        [`& .${(0, $5B34R.default).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette[color].main
        }
    }, color && ownerState.variant === "filled" && (0, $g6Hsb.default)({
        fontWeight: theme.typography.fontWeightMedium
    }, theme.vars ? {
        color: theme.vars.palette.Alert[`${color}FilledColor`],
        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
    } : {
        backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main,
        color: theme.palette.getContrastText(theme.palette[color].main)
    }));
});
const $1f71d8ebc70d0182$var$AlertIcon = (0, $25zst.default)("div", {
    name: "MuiAlert",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: "7px 0",
    display: "flex",
    fontSize: 22,
    opacity: 0.9
});
const $1f71d8ebc70d0182$var$AlertMessage = (0, $25zst.default)("div", {
    name: "MuiAlert",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0",
    minWidth: 0,
    overflow: "auto"
});
const $1f71d8ebc70d0182$var$AlertAction = (0, $25zst.default)("div", {
    name: "MuiAlert",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "flex-start",
    padding: "4px 0 0 16px",
    marginLeft: "auto",
    marginRight: -8
});
const $1f71d8ebc70d0182$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $hMuBF.default), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $koDVN.default), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $96kC3.default), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $1EyLv.default), {
        fontSize: "inherit"
    })
};
const $1f71d8ebc70d0182$var$Alert = /*#__PURE__*/ $aOzEm.forwardRef(function Alert(inProps, ref) {
    var _ref, _slots$closeButton, _ref2, _slots$closeIcon, _slotProps$closeButto, _slotProps$closeIcon;
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiAlert"
    });
    const { action: action, children: children, className: className, closeText: closeText = "Close", color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $1f71d8ebc70d0182$var$defaultIconMapping, onClose: onClose, role: role = "alert", severity: severity = "success", slotProps: slotProps = {}, slots: slots = {}, variant: variant = "standard" } = props, other = (0, $cAqXo.default)(props, $1f71d8ebc70d0182$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant
    });
    const classes = $1f71d8ebc70d0182$var$useUtilityClasses(ownerState);
    const AlertCloseButton = (_ref = (_slots$closeButton = slots.closeButton) != null ? _slots$closeButton : components.CloseButton) != null ? _ref : (0, $8p0qe.default);
    const AlertCloseIcon = (_ref2 = (_slots$closeIcon = slots.closeIcon) != null ? _slots$closeIcon : components.CloseIcon) != null ? _ref2 : (0, $7rIga.default);
    const closeButtonProps = (_slotProps$closeButto = slotProps.closeButton) != null ? _slotProps$closeButto : componentsProps.closeButton;
    const closeIconProps = (_slotProps$closeIcon = slotProps.closeIcon) != null ? _slotProps$closeIcon : componentsProps.closeIcon;
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($1f71d8ebc70d0182$var$AlertRoot, (0, $g6Hsb.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $g45Wv.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $2T9xh.jsx)($1f71d8ebc70d0182$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $1f71d8ebc70d0182$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $2T9xh.jsx)($1f71d8ebc70d0182$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $2T9xh.jsx)($1f71d8ebc70d0182$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $2T9xh.jsx)($1f71d8ebc70d0182$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $2T9xh.jsx)(AlertCloseButton, (0, $g6Hsb.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $2T9xh.jsx)(AlertCloseIcon, (0, $g6Hsb.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $1f71d8ebc70d0182$export$2e2bcd8739ae039 = $1f71d8ebc70d0182$var$Alert;

});
parcelRegister("h0mm1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c613c6d8e676d7c6$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");


var $b2r0b = parcelRequire("b2r0b");

var $fOENh = parcelRequire("fOENh");

var $25zst = parcelRequire("25zst");

var $bQeZg = parcelRequire("bQeZg");

var $gEb5G = parcelRequire("gEb5G");


var $lwWbT = parcelRequire("lwWbT");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $c613c6d8e676d7c6$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $c613c6d8e676d7c6$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $lwWbT.getPaperUtilityClass), classes);
};
const $c613c6d8e676d7c6$var$PaperRoot = (0, $25zst.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $g6Hsb.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $g6Hsb.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $fOENh.alpha)("#fff", (0, $bQeZg.default)(ownerState.elevation))}, ${(0, $fOENh.alpha)("#fff", (0, $bQeZg.default)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $c613c6d8e676d7c6$var$Paper = /*#__PURE__*/ $aOzEm.forwardRef(function Paper(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $cAqXo.default)(props, $c613c6d8e676d7c6$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $c613c6d8e676d7c6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($c613c6d8e676d7c6$var$PaperRoot, (0, $g6Hsb.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $g45Wv.default)(classes.root, className),
        ref: ref
    }, other));
});
var $c613c6d8e676d7c6$export$2e2bcd8739ae039 = $c613c6d8e676d7c6$var$Paper;

});
parcelRegister("bQeZg", function(module, exports) {

$parcel$export(module.exports, "default", () => $89f02d2d4c6c5e7f$export$2e2bcd8739ae039);
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $89f02d2d4c6c5e7f$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $89f02d2d4c6c5e7f$export$2e2bcd8739ae039 = $89f02d2d4c6c5e7f$var$getOverlayAlpha;

});

parcelRegister("lwWbT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getPaperUtilityClass", () => $fac9b99d92e29e4d$export$29cdb466b9b6f20b);
$parcel$export(module.exports, "default", () => $fac9b99d92e29e4d$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $fac9b99d92e29e4d$export$29cdb466b9b6f20b(slot) {
    return (0, $6vnyE.default)("MuiPaper", slot);
}
const $fac9b99d92e29e4d$var$paperClasses = (0, $cyhE3.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $fac9b99d92e29e4d$export$2e2bcd8739ae039 = $fac9b99d92e29e4d$var$paperClasses;

});


parcelRegister("5B34R", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getAlertUtilityClass", () => $4132cb950d2d0b44$export$69aecd24bc2cf7e3);
$parcel$export(module.exports, "default", () => $4132cb950d2d0b44$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $4132cb950d2d0b44$export$69aecd24bc2cf7e3(slot) {
    return (0, $6vnyE.default)("MuiAlert", slot);
}
const $4132cb950d2d0b44$var$alertClasses = (0, $cyhE3.default)("MuiAlert", [
    "root",
    "action",
    "icon",
    "message",
    "filled",
    "filledSuccess",
    "filledInfo",
    "filledWarning",
    "filledError",
    "outlined",
    "outlinedSuccess",
    "outlinedInfo",
    "outlinedWarning",
    "outlinedError",
    "standard",
    "standardSuccess",
    "standardInfo",
    "standardWarning",
    "standardError"
]);
var $4132cb950d2d0b44$export$2e2bcd8739ae039 = $4132cb950d2d0b44$var$alertClasses;

});

parcelRegister("hMuBF", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1ea930b81b4df0$export$2e2bcd8739ae039);
parcelRequire("aOzEm");

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $cf1ea930b81b4df0$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");

});

parcelRegister("koDVN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed9506080f5b98e7$export$2e2bcd8739ae039);
parcelRequire("aOzEm");

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $ed9506080f5b98e7$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");

});

parcelRegister("96kC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a04a9e0c870b38e$export$2e2bcd8739ae039);
parcelRequire("aOzEm");

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $6a04a9e0c870b38e$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");

});

parcelRegister("1EyLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $13447e84afc20764$export$2e2bcd8739ae039);
parcelRequire("aOzEm");

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $13447e84afc20764$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");

});

parcelRegister("7rIga", function(module, exports) {

$parcel$export(module.exports, "default", () => $56bd6315a426483c$export$2e2bcd8739ae039);
parcelRequire("aOzEm");

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $56bd6315a426483c$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");

});


parcelRegister("hWbHi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0f0ed4ce421057e$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $gdH9i = parcelRequire("gdH9i");

var $8OCgK = parcelRequire("8OCgK");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $d0f0ed4ce421057e$var$_excluded = [
    "className"
];
const $d0f0ed4ce421057e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $8OCgK.getAlertTitleUtilityClass), classes);
};
const $d0f0ed4ce421057e$var$AlertTitleRoot = (0, $25zst.default)((0, $gdH9i.default), {
    name: "MuiAlertTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
});
const $d0f0ed4ce421057e$var$AlertTitle = /*#__PURE__*/ $aOzEm.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiAlertTitle"
    });
    const { className: className } = props, other = (0, $cAqXo.default)(props, $d0f0ed4ce421057e$var$_excluded);
    const ownerState = props;
    const classes = $d0f0ed4ce421057e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($d0f0ed4ce421057e$var$AlertTitleRoot, (0, $g6Hsb.default)({
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $g45Wv.default)(classes.root, className)
    }, other));
});
var $d0f0ed4ce421057e$export$2e2bcd8739ae039 = $d0f0ed4ce421057e$var$AlertTitle;

});
parcelRegister("8OCgK", function(module, exports) {

$parcel$export(module.exports, "getAlertTitleUtilityClass", () => $66b0adb2d798424c$export$5269a5bce2c2f987);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $66b0adb2d798424c$export$5269a5bce2c2f987(slot) {
    return (0, $6vnyE.default)("MuiAlertTitle", slot);
}
const $66b0adb2d798424c$var$alertTitleClasses = (0, $cyhE3.default)("MuiAlertTitle", [
    "root"
]);
var $66b0adb2d798424c$export$2e2bcd8739ae039 = $66b0adb2d798424c$var$alertTitleClasses;

});


parcelRegister("gL7Hl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c33701d01c6c1111$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $b2r0b = parcelRequire("b2r0b");
var $74GFZ = parcelRequire("74GFZ");

var $l2o47 = parcelRequire("l2o47");

var $crxmS = parcelRequire("crxmS");

var $25zst = parcelRequire("25zst");

var $57YGU = parcelRequire("57YGU");

var $gEb5G = parcelRequire("gEb5G");

var $63Oo6 = parcelRequire("63Oo6");

var $fe2oA = parcelRequire("fe2oA");

var $63SsS = parcelRequire("63SsS");

var $iSJPG = parcelRequire("iSJPG");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $c33701d01c6c1111$var$_excluded = [
    "onEnter",
    "onExited"
], $c33701d01c6c1111$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $c33701d01c6c1111$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            "root",
            `anchorOrigin${(0, $63Oo6.default)(anchorOrigin.vertical)}${(0, $63Oo6.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $iSJPG.getSnackbarUtilityClass), classes);
};
const $c33701d01c6c1111$var$SnackbarRoot = (0, $25zst.default)("div", {
    name: "MuiSnackbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $63Oo6.default)(ownerState.anchorOrigin.vertical)}${(0, $63Oo6.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    };
    return (0, $g6Hsb.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: "fixed",
        display: "flex",
        left: 8,
        right: 8,
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.anchorOrigin.vertical === "top" ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === "left" && {
        justifyContent: "flex-start"
    }, ownerState.anchorOrigin.horizontal === "right" && {
        justifyContent: "flex-end"
    }, {
        [theme.breakpoints.up("sm")]: (0, $g6Hsb.default)({}, ownerState.anchorOrigin.vertical === "top" ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === "center" && center, ownerState.anchorOrigin.horizontal === "left" && {
            left: 24,
            right: "auto"
        }, ownerState.anchorOrigin.horizontal === "right" && {
            right: 24,
            left: "auto"
        })
    });
});
const $c33701d01c6c1111$var$Snackbar = /*#__PURE__*/ $aOzEm.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiSnackbar"
    });
    const theme = (0, $57YGU.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: "bottom",
        horizontal: "left"
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $fe2oA.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $cAqXo.default)(props.TransitionProps, $c33701d01c6c1111$var$_excluded), other = (0, $cAqXo.default)(props, $c33701d01c6c1111$var$_excluded2);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $c33701d01c6c1111$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $crxmS.useSnackbar)((0, $g6Hsb.default)({}, ownerState));
    const [exited, setExited] = $aOzEm.useState(true);
    const rootProps = (0, $74GFZ.useSlotProps)({
        elementType: $c33701d01c6c1111$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $l2o47.ClickAwayListener), (0, $g6Hsb.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $2T9xh.jsx)($c33701d01c6c1111$var$SnackbarRoot, (0, $g6Hsb.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $2T9xh.jsx)(TransitionComponent, (0, $g6Hsb.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === "top" ? "down" : "up",
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $2T9xh.jsx)((0, $63SsS.default), (0, $g6Hsb.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $c33701d01c6c1111$export$2e2bcd8739ae039 = $c33701d01c6c1111$var$Snackbar;

});
parcelRegister("l2o47", function(module, exports) {

$parcel$export(module.exports, "ClickAwayListener", () => $f50c73c61827f388$export$58385c17fee43f89);

var $aOzEm = parcelRequire("aOzEm");


var $6Bp1O = parcelRequire("6Bp1O");
var $b5mPz = parcelRequire("b5mPz");
var $6KMJ0 = parcelRequire("6KMJ0");

var $2T9xh = parcelRequire("2T9xh");
"use client";
function $f50c73c61827f388$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $f50c73c61827f388$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base-ui/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base-ui/react-click-away-listener/components-api/#click-away-listener)
 */ function $f50c73c61827f388$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = "onClick", onClickAway: onClickAway, touchEvent: touchEvent = "onTouchEnd" } = props;
    const movedRef = $aOzEm.useRef(false);
    const nodeRef = $aOzEm.useRef(null);
    const activatedRef = $aOzEm.useRef(false);
    const syntheticEventRef = $aOzEm.useRef(false);
    $aOzEm.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $6KMJ0.default)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $b5mPz.default)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $6Bp1O.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $f50c73c61827f388$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $aOzEm.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $f50c73c61827f388$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $6Bp1O.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $aOzEm.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $f50c73c61827f388$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $6Bp1O.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($aOzEm.Fragment, {
        children: /*#__PURE__*/ $aOzEm.cloneElement(children, childrenProps)
    });
}

});

parcelRegister("crxmS", function(module, exports) {

$parcel$export(module.exports, "useSnackbar", () => $90f1e3d0a16cc609$export$1c97ac2c9a6e7c09);

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");

var $b5mPz = parcelRequire("b5mPz");

var $1WyaQ = parcelRequire("1WyaQ");
"use client";
function $90f1e3d0a16cc609$export$1c97ac2c9a6e7c09(parameters) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = $aOzEm.useRef();
    $aOzEm.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, "escapeKeyDown");
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $b5mPz.default)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $b5mPz.default)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(()=>{
            handleClose(null, "timeout");
        }, autoHideDurationParam);
    });
    $aOzEm.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return ()=>{
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, "clickaway");
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = ()=>{
        clearTimeout(timerAutoHide.current);
    };
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $aOzEm.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $aOzEm.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return ()=>{
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $1WyaQ.extractEventHandlers)(parameters);
        const externalEventHandlers = (0, $g6Hsb.default)({}, propsEventHandlers, otherHandlers);
        return (0, $g6Hsb.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: "presentation"
        }, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}

});

parcelRegister("63SsS", function(module, exports) {

$parcel$export(module.exports, "default", () => $469d457764d65f73$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $fOENh = parcelRequire("fOENh");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $h0mm1 = parcelRequire("h0mm1");

var $eASlo = parcelRequire("eASlo");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $469d457764d65f73$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $469d457764d65f73$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        action: [
            "action"
        ],
        message: [
            "message"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $eASlo.getSnackbarContentUtilityClass), classes);
};
const $469d457764d65f73$var$SnackbarContentRoot = (0, $25zst.default)((0, $h0mm1.default), {
    name: "MuiSnackbarContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === "light" ? 0.8 : 0.98;
    const backgroundColor = (0, $fOENh.emphasize)(theme.palette.background.default, emphasis);
    return (0, $g6Hsb.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            flexGrow: "initial",
            minWidth: 288
        }
    });
});
const $469d457764d65f73$var$SnackbarContentMessage = (0, $25zst.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0"
});
const $469d457764d65f73$var$SnackbarContentAction = (0, $25zst.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: 16,
    marginRight: -8
});
const $469d457764d65f73$var$SnackbarContent = /*#__PURE__*/ $aOzEm.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiSnackbarContent"
    });
    const { action: action, className: className, message: message, role: role = "alert" } = props, other = (0, $cAqXo.default)(props, $469d457764d65f73$var$_excluded);
    const ownerState = props;
    const classes = $469d457764d65f73$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($469d457764d65f73$var$SnackbarContentRoot, (0, $g6Hsb.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $g45Wv.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)($469d457764d65f73$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $2T9xh.jsx)($469d457764d65f73$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $469d457764d65f73$export$2e2bcd8739ae039 = $469d457764d65f73$var$SnackbarContent;

});
parcelRegister("eASlo", function(module, exports) {

$parcel$export(module.exports, "getSnackbarContentUtilityClass", () => $a9fe9519bf12d46a$export$def81488db1a3216);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $a9fe9519bf12d46a$export$def81488db1a3216(slot) {
    return (0, $6vnyE.default)("MuiSnackbarContent", slot);
}
const $a9fe9519bf12d46a$var$snackbarContentClasses = (0, $cyhE3.default)("MuiSnackbarContent", [
    "root",
    "message",
    "action"
]);
var $a9fe9519bf12d46a$export$2e2bcd8739ae039 = $a9fe9519bf12d46a$var$snackbarContentClasses;

});


parcelRegister("iSJPG", function(module, exports) {

$parcel$export(module.exports, "getSnackbarUtilityClass", () => $dbf0d28d350a6f3c$export$6cb096457f5926f4);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $dbf0d28d350a6f3c$export$6cb096457f5926f4(slot) {
    return (0, $6vnyE.default)("MuiSnackbar", slot);
}
const $dbf0d28d350a6f3c$var$snackbarClasses = (0, $cyhE3.default)("MuiSnackbar", [
    "root",
    "anchorOriginTopCenter",
    "anchorOriginBottomCenter",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft"
]);
var $dbf0d28d350a6f3c$export$2e2bcd8739ae039 = $dbf0d28d350a6f3c$var$snackbarClasses;

});




parcelRegister("F94Hv", function(module, exports) {

$parcel$export(module.exports, "default", () => $07bade850b4311b6$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $07bade850b4311b6$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
}), "Launch");

});

parcelRegister("7f29r", function(module, exports) {
"use strict";
var $545b9a557f909439$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $545b9a557f909439$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2T9xh = parcelRequire("2T9xh");

var $8p0qe = parcelRequire("8p0qe");

const $545b9a557f909439$var$Copy_1 = $545b9a557f909439$var$__importDefault((parcelRequire("aANqM")));
function $545b9a557f909439$var$CopyButton(_a) {
    var { text: text, sx: sx = {}, component: component = $8p0qe.default, icon: icon = (0, $2T9xh.jsx)($545b9a557f909439$var$Copy_1.default, {}) } = _a, buttonProps = $545b9a557f909439$var$__rest(_a, [
        "text",
        "sx",
        "component",
        "icon"
    ]);
    return (0, $2T9xh.jsx)($8p0qe.default, Object.assign({
        "data-testid": "CopyButton",
        sx: sx
    }, buttonProps, {
        onClick: (e)=>{
            var _a;
            window.navigator.clipboard.writeText(text);
            (_a = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick) === null || _a === void 0 || _a.call(buttonProps, e);
        }
    }, {
        children: icon
    }));
}
module.exports.default = $545b9a557f909439$var$CopyButton;

});
parcelRegister("aANqM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2T9xh = parcelRequire("2T9xh");
function $7b639c1d533540a5$var$Copy(props) {
    return (0, $2T9xh.jsx)("svg", Object.assign({
        width: "17",
        height: "20",
        viewBox: "0 0 17 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: (0, $2T9xh.jsx)("path", {
            d: "M12.3332 0.833252H2.33317C1.4165 0.833252 0.666504 1.58325 0.666504 2.49992V14.1666H2.33317V2.49992H12.3332V0.833252ZM14.8332 4.16658H5.6665C4.74984 4.16658 3.99984 4.91658 3.99984 5.83325V17.4999C3.99984 18.4166 4.74984 19.1666 5.6665 19.1666H14.8332C15.7498 19.1666 16.4998 18.4166 16.4998 17.4999V5.83325C16.4998 4.91658 15.7498 4.16658 14.8332 4.16658ZM14.8332 17.4999H5.6665V5.83325H14.8332V17.4999Z",
            fill: "#2F74F9"
        })
    }));
}
module.exports.default = $7b639c1d533540a5$var$Copy;

});



parcelRegister("2BlcB", function(module, exports) {

$parcel$export(module.exports, "communitySlack", () => $286d6e7ccb670527$export$14a95983978733e6);
$parcel$export(module.exports, "supportEmail", () => $286d6e7ccb670527$export$c02101c931e9d519);
const $286d6e7ccb670527$export$a7d5826721d22e5a = "https://docs.decodable.co";
const $286d6e7ccb670527$export$14a95983978733e6 = "https://join.slack.com/t/decodablecommunity/shared_invite/zt-uvow71bk-Uf914umgpoyIbOQSxriJkA";
const $286d6e7ccb670527$export$c02101c931e9d519 = "mailto:support@decodable.co";

});


parcelRegister("cigwJ", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryFallback", () => $4b3a583048c88948$export$8a28b7e38e4685dd);

var $2T9xh = parcelRequire("2T9xh");

var $c1uoF = parcelRequire("c1uoF");

var $8aalP = parcelRequire("8aalP");

var $bfLP6 = parcelRequire("bfLP6");

var $aOzEm = parcelRequire("aOzEm");

var $iYUUD = parcelRequire("iYUUD");
function $4b3a583048c88948$export$8a28b7e38e4685dd({ error: error, recordError: recordError }) {
    const agent = (0, $iYUUD.useAgent)();
    (0, $aOzEm.useEffect)(()=>{
        if (error) {
            const shouldReport = recordError?.(error);
            if (shouldReport == undefined || shouldReport == true) agent.recordError("ErrorBoundaryFallback", error);
        }
    }, [
        error
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8aalP.default), {
        sx: {
            display: "grid",
            placeItems: "start center",
            paddingTop: "4rem"
        },
        children: /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $8aalP.default), {
            sx: {
                display: "grid",
                gridTemplateColumns: "auto auto"
            },
            children: [
                /*#__PURE__*/ (0, $2T9xh.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c1uoF))),
                    alt: "",
                    style: {
                        placeSelf: "center",
                        width: "40px",
                        marginRight: "2ch"
                    }
                }),
                /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $8aalP.default), {
                    sx: {
                        borderLeft: "solid 1px rgb(80% 80% 80%)",
                        padding: "2ch"
                    },
                    children: [
                        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8aalP.default), {
                            component: "h1",
                            sx: {
                                margin: 0
                            },
                            children: "Oops!"
                        }),
                        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8aalP.default), {
                            component: "p",
                            children: "There was a problem processing the request."
                        }),
                        /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $8aalP.default), {
                            component: "p",
                            children: [
                                "Try reloading the page, or go back ",
                                /*#__PURE__*/ (0, $2T9xh.jsx)("a", {
                                    href: "/",
                                    children: "home"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $8aalP.default), {
                            component: "p",
                            children: [
                                "If the problem persists please reach out to",
                                " ",
                                /*#__PURE__*/ (0, $2T9xh.jsx)("a", {
                                    href: "mailto:support@decodable.co",
                                    children: "support"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $bfLP6.default), {
                            sx: {
                                minWidth: "20ch"
                            },
                            variant: "contained",
                            color: "primary",
                            onClick: ()=>document.location.reload(),
                            children: "Reload Page"
                        })
                    ]
                })
            ]
        })
    });
}

});
parcelRegister("c1uoF", function(module, exports) {
module.exports = new URL("DecodableLogoSmall.97d73fec.svg", import.meta.url).toString();

});

parcelRegister("iYUUD", function(module, exports) {

$parcel$export(module.exports, "AgentProvider", () => $8da27409aa3bdc8a$export$fa73ece464084944);
$parcel$export(module.exports, "useAgent", () => $8da27409aa3bdc8a$export$85d81337da19dc64);

var $2T9xh = parcelRequire("2T9xh");

var $cYUE7 = parcelRequire("cYUE7");

var $aOzEm = parcelRequire("aOzEm");

var $2aiPz = parcelRequire("2aiPz");
const $8da27409aa3bdc8a$export$75c2f768dc9d8bf0 = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $8da27409aa3bdc8a$export$fa73ece464084944({ children: children }) {
    const isLocal = window.location.origin.includes("localhost") || !(0, $2aiPz.default).DATADOG_CLIENT_TOKEN;
    const ctx = isLocal ? (0, $cYUE7.DecodableAgent).withLocalProvider() : (0, $cYUE7.DecodableAgent).withDataDogProvider({
        credentials: {
            clientToken: (0, $2aiPz.default).DATADOG_CLIENT_TOKEN
        },
        service: "web-app",
        version: (0, $2aiPz.default).GIT_SHA,
        env: (0, $2aiPz.default).DECODABLE_ENV
    });
    return /*#__PURE__*/ (0, $2T9xh.jsx)($8da27409aa3bdc8a$export$75c2f768dc9d8bf0.Provider, {
        value: ctx,
        children: children
    });
}
function $8da27409aa3bdc8a$export$85d81337da19dc64() {
    const agent = (0, $aOzEm.useContext)($8da27409aa3bdc8a$export$75c2f768dc9d8bf0);
    if (!agent) throw new Error("useAgent may only be used in the context of a AgentProvider");
    return agent;
}

});
parcelRegister("cYUE7", function(module, exports) {

module.exports = (parcelRequire("1Dd4o"));

});
parcelRegister("1Dd4o", function(module, exports) {
"use strict";
var $1303925adbd4648e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1303925adbd4648e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1303925adbd4648e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1303925adbd4648e$var$__exportStar((parcelRequire("6nq3R")), module.exports);

});
parcelRegister("6nq3R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecodableAgent = void 0;

var $lFjwZ = parcelRequire("lFjwZ");

var $ajzHa = parcelRequire("ajzHa");
class $4a491b47b944eccf$var$DecodableAgent {
    constructor(opts){
        this.provider = opts.provider;
    }
    static withLocalProvider() {
        const provider = new $ajzHa.LocalProvider();
        return new $4a491b47b944eccf$var$DecodableAgent({
            provider: provider
        });
    }
    static withDataDogProvider(config) {
        const provider = new $lFjwZ.DatadogProvider();
        provider.init(config);
        return new $4a491b47b944eccf$var$DecodableAgent({
            provider: provider
        });
    }
    init(...args) {
        this.provider.init(...args);
    }
    cleanup(...args) {
        this.provider.cleanup(...args);
    }
    recordInfo(message, messageContext) {
        this.provider.recordInfo(message, messageContext);
    }
    recordWarning(message, messageContext, error) {
        this.provider.recordWarn(message, messageContext, error);
    }
    recordError(message, error, messageContext) {
        this.provider.recordError(message, error, messageContext);
    }
    setUser(user) {
        this.provider.setUser(user);
    }
    setUserProperty(key, value) {
        this.provider.setUserProperty(key, value);
    }
}
module.exports.DecodableAgent = $4a491b47b944eccf$var$DecodableAgent;

});
parcelRegister("lFjwZ", function(module, exports) {
"use strict";
var $fc5c93c2bfc1abb6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fc5c93c2bfc1abb6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fc5c93c2bfc1abb6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fc5c93c2bfc1abb6$var$__exportStar((parcelRequire("3n5nP")), module.exports);

$fc5c93c2bfc1abb6$var$__exportStar((parcelRequire("5DIKD")), module.exports);

});
parcelRegister("3n5nP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5DIKD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DatadogProvider = void 0;

var $fAotD = parcelRequire("fAotD");
class $41b34ee692dc931c$var$DatadogProvider {
    init(config) {
        try {
            // https://docs.datadoghq.com/logs/log_collection/javascript/
            $fAotD.datadogLogs.init({
                clientToken: config.credentials.clientToken,
                service: config.service,
                version: config.version,
                forwardErrorsToLogs: false,
                sessionSampleRate: 100,
                telemetrySampleRate: 0
            });
            $fAotD.datadogLogs.setGlobalContext({
                dp_env: config.env
            });
        } catch (error) {
            console.error("Unable to initialize datadog", error);
        }
    }
    cleanup() {}
    setUser(user) {
        try {
            $fAotD.datadogLogs.setUser(user);
        } catch (error) {
            console.error("Unable to set user", error);
        }
    }
    setUserProperty(key, value) {
        try {
            $fAotD.datadogLogs.setUserProperty(key, value);
        } catch (error) {
            console.error("Unable to set property on user", error);
        }
    }
    recordInfo(message, messageContext) {
        try {
            $fAotD.datadogLogs.logger.info(message, messageContext);
        } catch (error) {
            console.error("Unable to record info", error);
        }
    }
    recordWarn(message, messageContext, error) {
        try {
            $fAotD.datadogLogs.logger.warn(message, messageContext, error);
        } catch (error) {
            console.error("Unable to record warning", error);
        }
    }
    recordError(message, error, messageContext) {
        try {
            $fAotD.datadogLogs.logger.error(message, messageContext, error);
        } catch (error) {
            console.error("Unable to record error", error);
        }
    }
}
module.exports.DatadogProvider = $41b34ee692dc931c$var$DatadogProvider;

});
parcelRegister("fAotD", function(module, exports) {

$parcel$export(module.exports, "datadogLogs", () => $b58d34738eae672c$export$64696fc4da45d740);

var $i2h7K = parcelRequire("i2h7K");
var $hAJkc = parcelRequire("hAJkc");

var $g1NPx = parcelRequire("g1NPx");

var $h0Smi = parcelRequire("h0Smi");

var $bWwuo = parcelRequire("bWwuo");
var $b58d34738eae672c$export$64696fc4da45d740 = (0, $g1NPx.makeLogsPublicApi)((0, $h0Smi.startLogs));
(0, $i2h7K.defineGlobal)((0, $hAJkc.getGlobalObject)(), "DD_LOGS", $b58d34738eae672c$export$64696fc4da45d740);

});
parcelRegister("i2h7K", function(module, exports) {

$parcel$export(module.exports, "makePublicApi", () => $d215b259b1c4bf9c$export$119e7fe763fbc1d1);
$parcel$export(module.exports, "defineGlobal", () => $d215b259b1c4bf9c$export$884b45263866f2b7);

var $impqY = parcelRequire("impqY");

var $5JqHL = parcelRequire("5JqHL");

var $iD7Tb = parcelRequire("iD7Tb");
function $d215b259b1c4bf9c$export$119e7fe763fbc1d1(stub) {
    var publicApi = (0, $iD7Tb.assign)({
        version: "5.15.0",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function(callback) {
            callback();
        }
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, "_setDebug", {
        get: function() {
            return 0, $5JqHL.setDebugMode;
        },
        enumerable: false
    });
    return publicApi;
}
function $d215b259b1c4bf9c$export$884b45263866f2b7(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) existingGlobalVariable.q.forEach(function(fn) {
        return (0, $impqY.catchUserErrors)(fn, "onReady callback threw an error:")();
    });
}

});
parcelRegister("impqY", function(module, exports) {

$parcel$export(module.exports, "catchUserErrors", () => $d5de02bed0d74ebf$export$a7d71543eda007d0);

var $gqtZo = parcelRequire("gqtZo");
function $d5de02bed0d74ebf$export$a7d71543eda007d0(fn, errorMsg) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        try {
            return fn.apply(void 0, args);
        } catch (err) {
            (0, $gqtZo.display).error(errorMsg, err);
        }
    };
}

});
parcelRegister("gqtZo", function(module, exports) {

$parcel$export(module.exports, "ConsoleApiName", () => $bf5656463ef0a318$export$d37676e8a94e6b40);
$parcel$export(module.exports, "globalConsole", () => $bf5656463ef0a318$export$d07b2d1b8b601164);
$parcel$export(module.exports, "originalConsoleMethods", () => $bf5656463ef0a318$export$77c4ce905194557b);
$parcel$export(module.exports, "display", () => $bf5656463ef0a318$export$79693fdaa4661ff2);
/* eslint-disable local-rules/disallow-side-effects */ /**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */ var $bf5656463ef0a318$export$d37676e8a94e6b40 = {
    log: "log",
    debug: "debug",
    info: "info",
    warn: "warn",
    error: "error"
};
var $bf5656463ef0a318$export$d07b2d1b8b601164 = console;
var $bf5656463ef0a318$export$77c4ce905194557b = {};
Object.keys($bf5656463ef0a318$export$d37676e8a94e6b40).forEach(function(name) {
    $bf5656463ef0a318$export$77c4ce905194557b[name] = $bf5656463ef0a318$export$d07b2d1b8b601164[name];
});
var $bf5656463ef0a318$var$PREFIX = "Datadog Browser SDK:";
var $bf5656463ef0a318$export$79693fdaa4661ff2 = {
    debug: $bf5656463ef0a318$export$77c4ce905194557b.debug.bind($bf5656463ef0a318$export$d07b2d1b8b601164, $bf5656463ef0a318$var$PREFIX),
    log: $bf5656463ef0a318$export$77c4ce905194557b.log.bind($bf5656463ef0a318$export$d07b2d1b8b601164, $bf5656463ef0a318$var$PREFIX),
    info: $bf5656463ef0a318$export$77c4ce905194557b.info.bind($bf5656463ef0a318$export$d07b2d1b8b601164, $bf5656463ef0a318$var$PREFIX),
    warn: $bf5656463ef0a318$export$77c4ce905194557b.warn.bind($bf5656463ef0a318$export$d07b2d1b8b601164, $bf5656463ef0a318$var$PREFIX),
    error: $bf5656463ef0a318$export$77c4ce905194557b.error.bind($bf5656463ef0a318$export$d07b2d1b8b601164, $bf5656463ef0a318$var$PREFIX)
};

});


parcelRegister("5JqHL", function(module, exports) {

$parcel$export(module.exports, "startMonitorErrorCollection", () => $42c5debb83bf95d3$export$2fa3dec4f40a39a2);
$parcel$export(module.exports, "setDebugMode", () => $42c5debb83bf95d3$export$2be227cb6aa211be);
$parcel$export(module.exports, "monitored", () => $42c5debb83bf95d3$export$efef192ceb8f8a31);
$parcel$export(module.exports, "monitor", () => $42c5debb83bf95d3$export$ec5b303098bc4b7f);
$parcel$export(module.exports, "callMonitored", () => $42c5debb83bf95d3$export$b69eb0f8afebfb6d);
$parcel$export(module.exports, "displayIfDebugEnabled", () => $42c5debb83bf95d3$export$54b26de4de044ec5);

var $gqtZo = parcelRequire("gqtZo");
var $42c5debb83bf95d3$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $42c5debb83bf95d3$var$onMonitorErrorCollected;
var $42c5debb83bf95d3$var$debugMode = false;
function $42c5debb83bf95d3$export$2fa3dec4f40a39a2(newOnMonitorErrorCollected) {
    $42c5debb83bf95d3$var$onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function $42c5debb83bf95d3$export$2be227cb6aa211be(newDebugMode) {
    $42c5debb83bf95d3$var$debugMode = newDebugMode;
}
function $42c5debb83bf95d3$export$6c5b5d0667b12cfc() {
    $42c5debb83bf95d3$var$onMonitorErrorCollected = undefined;
    $42c5debb83bf95d3$var$debugMode = false;
}
function $42c5debb83bf95d3$export$efef192ceb8f8a31(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var decorated = $42c5debb83bf95d3$var$onMonitorErrorCollected ? $42c5debb83bf95d3$export$ec5b303098bc4b7f(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function $42c5debb83bf95d3$export$ec5b303098bc4b7f(fn) {
    return function() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return $42c5debb83bf95d3$export$b69eb0f8afebfb6d(fn, this, arguments);
    }; // consider output type has input type
}
function $42c5debb83bf95d3$export$b69eb0f8afebfb6d(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    } catch (e) {
        $42c5debb83bf95d3$export$54b26de4de044ec5(e);
        if ($42c5debb83bf95d3$var$onMonitorErrorCollected) try {
            $42c5debb83bf95d3$var$onMonitorErrorCollected(e);
        } catch (e) {
            $42c5debb83bf95d3$export$54b26de4de044ec5(e);
        }
    }
}
function $42c5debb83bf95d3$export$54b26de4de044ec5() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if ($42c5debb83bf95d3$var$debugMode) (0, $gqtZo.display).error.apply((0, $gqtZo.display), $42c5debb83bf95d3$var$__spreadArray([
        "[MONITOR]"
    ], args, false));
}

});

parcelRegister("iD7Tb", function(module, exports) {

$parcel$export(module.exports, "includes", () => $d901fd1b5fde3391$export$ee2e0f811dca1807);
$parcel$export(module.exports, "arrayFrom", () => $d901fd1b5fde3391$export$b1a47efd00197c76);
$parcel$export(module.exports, "find", () => $d901fd1b5fde3391$export$71aa6c912b956294);
$parcel$export(module.exports, "objectValues", () => $d901fd1b5fde3391$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "objectEntries", () => $d901fd1b5fde3391$export$6a29ade99f81ec8a);
$parcel$export(module.exports, "startsWith", () => $d901fd1b5fde3391$export$68326237475e9a7d);
$parcel$export(module.exports, "endsWith", () => $d901fd1b5fde3391$export$10fdab3683b55b22);
$parcel$export(module.exports, "assign", () => $d901fd1b5fde3391$export$e6e34fd1f2686227);
function $d901fd1b5fde3391$export$ee2e0f811dca1807(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
function $d901fd1b5fde3391$export$b1a47efd00197c76(arrayLike) {
    if (Array.from) return Array.from(arrayLike);
    var array = [];
    if (arrayLike instanceof Set) arrayLike.forEach(function(item) {
        return array.push(item);
    });
    else for(var i = 0; i < arrayLike.length; i++)array.push(arrayLike[i]);
    return array;
}
function $d901fd1b5fde3391$export$71aa6c912b956294(array, predicate) {
    for(var i = 0; i < array.length; i += 1){
        var item = array[i];
        if (predicate(item, i)) return item;
    }
    return undefined;
}
function $d901fd1b5fde3391$export$296de88ccac4bedb(array, predicate) {
    for(var i = array.length - 1; i >= 0; i -= 1){
        var item = array[i];
        if (predicate(item, i, array)) return item;
    }
    return undefined;
}
function $d901fd1b5fde3391$export$4b80e395e36b5a56(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
function $d901fd1b5fde3391$export$ad1854f4a08c15f8(object) {
    return Object.keys(object).map(function(key) {
        return object[key];
    });
}
function $d901fd1b5fde3391$export$6a29ade99f81ec8a(object) {
    return Object.keys(object).map(function(key) {
        return [
            key,
            object[key]
        ];
    });
}
function $d901fd1b5fde3391$export$68326237475e9a7d(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
function $d901fd1b5fde3391$export$10fdab3683b55b22(candidate, search) {
    return candidate.slice(-search.length) === search;
}
function $d901fd1b5fde3391$export$e6e34fd1f2686227(target) {
    var toAssign = [];
    for(var _i = 1; _i < arguments.length; _i++)toAssign[_i - 1] = arguments[_i];
    toAssign.forEach(function(source) {
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    });
    return target;
}

});


parcelRegister("hAJkc", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", () => $cce8f508d43b7a71$export$256479dc0cea61c4);
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */ function $cce8f508d43b7a71$export$256479dc0cea61c4() {
    if (typeof globalThis === "object") return globalThis;
    Object.defineProperty(Object.prototype, "_dd_temp_", {
        get: function() {
            return this;
        },
        configurable: true
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== "object") {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === "object") globalObject = self;
        else if (typeof window === "object") globalObject = window;
        else globalObject = {};
    }
    return globalObject;
}

});

parcelRegister("g1NPx", function(module, exports) {

$parcel$export(module.exports, "makeLogsPublicApi", () => $bab36496f3f99ebc$export$39525f74d82d4cd7);

var $iD7Tb = parcelRequire("iD7Tb");
var $duXxw = parcelRequire("duXxw");
var $krSzL = parcelRequire("krSzL");
var $ha2ro = parcelRequire("ha2ro");
var $bxRq9 = parcelRequire("bxRq9");
var $2JJbR = parcelRequire("2JJbR");
var $8wwlK = parcelRequire("8wwlK");
var $i2h7K = parcelRequire("i2h7K");
var $5JqHL = parcelRequire("5JqHL");
var $41fUm = parcelRequire("41fUm");
var $gwojm = parcelRequire("gwojm");

var $bWwuo = parcelRequire("bWwuo");

var $8xDUU = parcelRequire("8xDUU");

var $1gCUO = parcelRequire("1gCUO");
var $bab36496f3f99ebc$var$LOGS_STORAGE_KEY = "logs";
function $bab36496f3f99ebc$export$39525f74d82d4cd7(startLogsImpl) {
    var customerDataTrackerManager = (0, $ha2ro.createCustomerDataTrackerManager)();
    var globalContextManager = (0, $krSzL.createContextManager)(customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */ ));
    var userContextManager = (0, $krSzL.createContextManager)(customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */ ));
    var trackingConsentState = (0, $bxRq9.createTrackingConsentState)();
    function getCommonContext() {
        return (0, $8xDUU.buildCommonContext)(globalContextManager, userContextManager);
    }
    var strategy = (0, $1gCUO.createPreStartStrategy)(getCommonContext, trackingConsentState, function(initConfiguration, configuration) {
        if (initConfiguration.storeContextsAcrossPages) {
            (0, $gwojm.storeContextManager)(configuration, globalContextManager, $bab36496f3f99ebc$var$LOGS_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */ );
            (0, $gwojm.storeContextManager)(configuration, userContextManager, $bab36496f3f99ebc$var$LOGS_STORAGE_KEY, 1 /* CustomerDataType.User */ );
        }
        var startLogsResult = startLogsImpl(initConfiguration, configuration, getCommonContext, trackingConsentState);
        strategy = $bab36496f3f99ebc$var$createPostStartStrategy(initConfiguration, startLogsResult);
        return startLogsResult;
    });
    var customLoggers = {};
    var mainLogger = new (0, $bWwuo.Logger)(function() {
        var params = [];
        for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
        return strategy.handleLog.apply(strategy, params);
    }, customerDataTrackerManager.createDetachedTracker());
    return (0, $i2h7K.makePublicApi)({
        logger: mainLogger,
        init: (0, $5JqHL.monitor)(function(initConfiguration) {
            return strategy.init(initConfiguration);
        }),
        /**
         * Set the tracking consent of the current user.
         *
         * @param {"granted" | "not-granted"} trackingConsent The user tracking consent
         *
         * Logs will be sent only if it is set to "granted". This value won't be stored by the library
         * across page loads: you will need to call this method or set the appropriate `trackingConsent`
         * field in the init() method at each page load.
         *
         * If this method is called before the init() method, the provided value will take precedence
         * over the one provided as initialization parameter.
         */ setTrackingConsent: (0, $5JqHL.monitor)(function(trackingConsent) {
            return trackingConsentState.update(trackingConsent);
        }),
        getGlobalContext: (0, $5JqHL.monitor)(function() {
            return globalContextManager.getContext();
        }),
        setGlobalContext: (0, $5JqHL.monitor)(function(context) {
            return globalContextManager.setContext(context);
        }),
        setGlobalContextProperty: (0, $5JqHL.monitor)(function(key, value) {
            return globalContextManager.setContextProperty(key, value);
        }),
        removeGlobalContextProperty: (0, $5JqHL.monitor)(function(key) {
            return globalContextManager.removeContextProperty(key);
        }),
        clearGlobalContext: (0, $5JqHL.monitor)(function() {
            return globalContextManager.clearContext();
        }),
        createLogger: (0, $5JqHL.monitor)(function(name, conf) {
            if (conf === void 0) conf = {};
            customLoggers[name] = new (0, $bWwuo.Logger)(function() {
                var params = [];
                for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
                return strategy.handleLog.apply(strategy, params);
            }, customerDataTrackerManager.createDetachedTracker(), (0, $41fUm.sanitize)(name), conf.handler, conf.level, (0, $41fUm.sanitize)(conf.context));
            return customLoggers[name];
        }),
        getLogger: (0, $5JqHL.monitor)(function(name) {
            return customLoggers[name];
        }),
        getInitConfiguration: (0, $5JqHL.monitor)(function() {
            return (0, $2JJbR.deepClone)(strategy.initConfiguration);
        }),
        getInternalContext: (0, $5JqHL.monitor)(function(startTime) {
            return strategy.getInternalContext(startTime);
        }),
        setUser: (0, $5JqHL.monitor)(function(newUser) {
            if ((0, $duXxw.checkUser)(newUser)) userContextManager.setContext((0, $duXxw.sanitizeUser)(newUser));
        }),
        getUser: (0, $5JqHL.monitor)(function() {
            return userContextManager.getContext();
        }),
        setUserProperty: (0, $5JqHL.monitor)(function(key, property) {
            var _a;
            var sanitizedProperty = (0, $duXxw.sanitizeUser)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0, $5JqHL.monitor)(function(key) {
            return userContextManager.removeContextProperty(key);
        }),
        clearUser: (0, $5JqHL.monitor)(function() {
            return userContextManager.clearContext();
        })
    });
}
function $bab36496f3f99ebc$var$createPostStartStrategy(initConfiguration, startLogsResult) {
    return (0, $iD7Tb.assign)({
        init: function(initConfiguration) {
            (0, $8wwlK.displayAlreadyInitializedError)("DD_LOGS", initConfiguration);
        },
        initConfiguration: initConfiguration
    }, startLogsResult);
}

});
parcelRegister("duXxw", function(module, exports) {

$parcel$export(module.exports, "sanitizeUser", () => $9d3c4309eec445fb$export$cb88b31dcf3267e1);
$parcel$export(module.exports, "checkUser", () => $9d3c4309eec445fb$export$77a0cf2b32e9e53d);

var $gqtZo = parcelRequire("gqtZo");

var $2UzQr = parcelRequire("2UzQr");

var $iD7Tb = parcelRequire("iD7Tb");
function $9d3c4309eec445fb$export$cb88b31dcf3267e1(newUser) {
    // We shallow clone only to prevent mutation of user data.
    var user = (0, $iD7Tb.assign)({}, newUser);
    var keys = [
        "id",
        "name",
        "email"
    ];
    keys.forEach(function(key) {
        if (key in user) user[key] = String(user[key]);
    });
    return user;
}
function $9d3c4309eec445fb$export$77a0cf2b32e9e53d(newUser) {
    var isValid = (0, $2UzQr.getType)(newUser) === "object";
    if (!isValid) (0, $gqtZo.display).error("Unsupported user:", newUser);
    return isValid;
}

});
parcelRegister("2UzQr", function(module, exports) {

$parcel$export(module.exports, "getType", () => $21ec9dbfc59354ac$export$e2b5c5db9e2009fd);
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */ function $21ec9dbfc59354ac$export$e2b5c5db9e2009fd(value) {
    if (value === null) return "null";
    if (Array.isArray(value)) return "array";
    return typeof value;
}

});


parcelRegister("krSzL", function(module, exports) {

$parcel$export(module.exports, "createContextManager", () => $ee30a9e0ee1b4cb7$export$fe3149b78a43e1ad);

var $2JJbR = parcelRequire("2JJbR");

var $2UzQr = parcelRequire("2UzQr");

var $41fUm = parcelRequire("41fUm");

var $3jm7f = parcelRequire("3jm7f");
function $ee30a9e0ee1b4cb7$export$fe3149b78a43e1ad(customerDataTracker) {
    var context = {};
    var changeObservable = new (0, $3jm7f.Observable)();
    var contextManager = {
        getContext: function() {
            return (0, $2JJbR.deepClone)(context);
        },
        setContext: function(newContext) {
            if ((0, $2UzQr.getType)(newContext) === "object") {
                context = (0, $41fUm.sanitize)(newContext);
                customerDataTracker.updateCustomerData(context);
            } else contextManager.clearContext();
            changeObservable.notify();
        },
        setContextProperty: function(key, property) {
            context[key] = (0, $41fUm.sanitize)(property);
            customerDataTracker.updateCustomerData(context);
            changeObservable.notify();
        },
        removeContextProperty: function(key) {
            delete context[key];
            customerDataTracker.updateCustomerData(context);
            changeObservable.notify();
        },
        clearContext: function() {
            context = {};
            customerDataTracker.resetCustomerData();
            changeObservable.notify();
        },
        changeObservable: changeObservable
    };
    return contextManager;
}

});
parcelRegister("2JJbR", function(module, exports) {

$parcel$export(module.exports, "deepClone", () => $1fe2d69379779456$export$b7d58db314e0ac27);
$parcel$export(module.exports, "combine", () => $1fe2d69379779456$export$1be1fc439b849fdf);

var $2UzQr = parcelRequire("2UzQr");
function $1fe2d69379779456$export$f00f2bc10b5384e6(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) circularReferenceChecker = $1fe2d69379779456$var$createCircularReferenceChecker();
    // ignore the source if it is undefined
    if (source === undefined) return destination;
    if (typeof source !== "object" || source === null) // primitive values - just return source
    return source;
    else if (source instanceof Date) return new Date(source.getTime());
    else if (source instanceof RegExp) {
        var flags = source.flags || // old browsers compatibility
        [
            source.global ? "g" : "",
            source.ignoreCase ? "i" : "",
            source.multiline ? "m" : "",
            source.sticky ? "y" : "",
            source.unicode ? "u" : ""
        ].join("");
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) // remove circular references
    return undefined;
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for(var i = 0; i < source.length; ++i)merged_1[i] = $1fe2d69379779456$export$f00f2bc10b5384e6(merged_1[i], source[i], circularReferenceChecker);
        return merged_1;
    }
    var merged = (0, $2UzQr.getType)(destination) === "object" ? destination : {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) merged[key] = $1fe2d69379779456$export$f00f2bc10b5384e6(merged[key], source[key], circularReferenceChecker);
    return merged;
}
function $1fe2d69379779456$export$b7d58db314e0ac27(value) {
    return $1fe2d69379779456$export$f00f2bc10b5384e6(undefined, value);
}
function $1fe2d69379779456$export$1be1fc439b849fdf() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    var destination;
    for(var _a = 0, sources_1 = sources; _a < sources_1.length; _a++){
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) continue;
        destination = $1fe2d69379779456$export$f00f2bc10b5384e6(destination, source);
    }
    return destination;
}
function $1fe2d69379779456$var$createCircularReferenceChecker() {
    if (typeof WeakSet !== "undefined") {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function(value) {
                var has = set_1.has(value);
                if (!has) set_1.add(value);
                return has;
            }
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function(value) {
            var has = array.indexOf(value) >= 0;
            if (!has) array.push(value);
            return has;
        }
    };
}

});

parcelRegister("41fUm", function(module, exports) {

$parcel$export(module.exports, "sanitize", () => $2ed3986ce876ef7d$export$83d2e9e3e4ee39ed);

var $gqtZo = parcelRequire("gqtZo");

var $3EczY = parcelRequire("3EczY");

var $gS5dB = parcelRequire("gS5dB");
// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
var $2ed3986ce876ef7d$var$SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * (0, $3EczY.ONE_KIBI_BYTE);
// Symbol for the root element of the JSONPath used for visited objects
var $2ed3986ce876ef7d$var$JSON_PATH_ROOT_ELEMENT = "$";
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
var $2ed3986ce876ef7d$var$KEY_DECORATION_LENGTH = 3;
function $2ed3986ce876ef7d$export$83d2e9e3e4ee39ed(source, maxCharacterCount) {
    var _a;
    if (maxCharacterCount === void 0) maxCharacterCount = $2ed3986ce876ef7d$var$SANITIZE_DEFAULT_MAX_CHARACTER_COUNT;
    // Unbind any toJSON function we may have on [] or {} prototypes
    var restoreObjectPrototypeToJson = (0, $gS5dB.detachToJsonMethod)(Object.prototype);
    var restoreArrayPrototypeToJson = (0, $gS5dB.detachToJsonMethod)(Array.prototype);
    // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
    var containerQueue = [];
    var visitedObjectsWithPath = new WeakMap();
    var sanitizedData = $2ed3986ce876ef7d$var$sanitizeProcessor(source, $2ed3986ce876ef7d$var$JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
    var accumulatedCharacterCount = ((_a = JSON.stringify(sanitizedData)) === null || _a === void 0 ? void 0 : _a.length) || 0;
    if (accumulatedCharacterCount > maxCharacterCount) {
        $2ed3986ce876ef7d$var$warnOverCharacterLimit(maxCharacterCount, "discarded", source);
        return undefined;
    }
    while(containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount){
        var containerToProcess = containerQueue.shift();
        var separatorLength = 0; // 0 for the first element, 1 for subsequent elements
        // Arrays and Objects have to be handled distinctly to ensure
        // we do not pick up non-numerical properties from Arrays
        if (Array.isArray(containerToProcess.source)) for(var key = 0; key < containerToProcess.source.length; key++){
            var targetData = $2ed3986ce876ef7d$var$sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
            if (targetData !== undefined) accumulatedCharacterCount += JSON.stringify(targetData).length;
            else // When an element of an Array (targetData) is undefined, it is serialized as null:
            // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
            accumulatedCharacterCount += 4;
            accumulatedCharacterCount += separatorLength;
            separatorLength = 1;
            if (accumulatedCharacterCount > maxCharacterCount) {
                $2ed3986ce876ef7d$var$warnOverCharacterLimit(maxCharacterCount, "truncated", source);
                break;
            }
            containerToProcess.target[key] = targetData;
        }
        else {
            for(var key in containerToProcess.source)if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                var targetData = $2ed3986ce876ef7d$var$sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                // When a property of an object has an undefined value, it will be dropped during serialization:
                // JSON.stringify({a:undefined}) => '{}'
                if (targetData !== undefined) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length + separatorLength + key.length + $2ed3986ce876ef7d$var$KEY_DECORATION_LENGTH;
                    separatorLength = 1;
                }
                if (accumulatedCharacterCount > maxCharacterCount) {
                    $2ed3986ce876ef7d$var$warnOverCharacterLimit(maxCharacterCount, "truncated", source);
                    break;
                }
                containerToProcess.target[key] = targetData;
            }
        }
    }
    // Rebind detached toJSON functions
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */ function $2ed3986ce876ef7d$var$sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    // Start by handling toJSON, as we want to sanitize its output
    var sourceToSanitize = $2ed3986ce876ef7d$var$tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== "object") return $2ed3986ce876ef7d$var$sanitizePrimitivesAndFunctions(sourceToSanitize);
    var sanitizedSource = $2ed3986ce876ef7d$var$sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== "[Object]" && sanitizedSource !== "[Array]" && sanitizedSource !== "[Error]") return sanitizedSource;
    // Handle potential cyclic references
    // We need to use source as sourceToSanitize could be a reference to a new object
    // At this stage, we know the source is an object type
    var sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) return "[Reference seen at ".concat(visitedObjectsWithPath.get(sourceAsObject), "]");
    // Add processed source to queue
    var currentPath = key !== undefined ? "".concat(parentPath, ".").concat(key) : parentPath;
    var target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({
        source: sourceToSanitize,
        target: target,
        path: currentPath
    });
    return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */ function $2ed3986ce876ef7d$var$sanitizePrimitivesAndFunctions(value) {
    // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
    if (typeof value === "bigint") return "[BigInt] ".concat(value.toString());
    // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
    // so it won't prevent stringify from serializing later
    if (typeof value === "function") return "[Function] ".concat(value.name || "unknown");
    // JSON.stringify() does not serialize symbols.
    if (typeof value === "symbol") return "[Symbol] ".concat(value.description || value.toString());
    return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 * - IE11 does not return a distinct type for objects such as Map, WeakMap, ... These objects will pass through and their
 * properties enumerated if any.
 *
 */ function $2ed3986ce876ef7d$var$sanitizeObjects(value) {
    try {
        // Handle events - Keep a simple implementation to avoid breaking changes
        if (value instanceof Event) return {
            isTrusted: value.isTrusted
        };
        // Handle all remaining object types in a generic way
        var result = Object.prototype.toString.call(value);
        var match = result.match(/\[object (.*)\]/);
        if (match && match[1]) return "[".concat(match[1], "]");
    } catch (_a) {
    // If the previous serialization attempts failed, and we cannot convert using
    // Object.prototype.toString, declare the value unserializable
    }
    return "[Unserializable]";
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */ function $2ed3986ce876ef7d$var$tryToApplyToJSON(value) {
    var object = value;
    if (object && typeof object.toJSON === "function") try {
        return object.toJSON();
    } catch (_a) {
    // If toJSON fails, we continue by trying to serialize the value manually
    }
    return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */ function $2ed3986ce876ef7d$var$warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    (0, $gqtZo.display).warn("The data provided has been ".concat(changeType, " as it is over the limit of ").concat(maxCharacterCount, " characters:"), source);
}

});
parcelRegister("3EczY", function(module, exports) {

$parcel$export(module.exports, "ONE_KIBI_BYTE", () => $2a7edd84fd02a9d3$export$756c3d65870c899e);
$parcel$export(module.exports, "ONE_MEBI_BYTE", () => $2a7edd84fd02a9d3$export$377b1474fc07c10f);
$parcel$export(module.exports, "computeBytesCount", () => $2a7edd84fd02a9d3$export$36cba7c53d8f13a2);
var $2a7edd84fd02a9d3$export$756c3d65870c899e = 1024;
var $2a7edd84fd02a9d3$export$377b1474fc07c10f = 1024 * $2a7edd84fd02a9d3$export$756c3d65870c899e;
// eslint-disable-next-line no-control-regex
var $2a7edd84fd02a9d3$var$HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function $2a7edd84fd02a9d3$export$36cba7c53d8f13a2(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!$2a7edd84fd02a9d3$var$HAS_MULTI_BYTES_CHARACTERS.test(candidate)) return candidate.length;
    if (window.TextEncoder !== undefined) return new TextEncoder().encode(candidate).length;
    return new Blob([
        candidate
    ]).size;
}
function $2a7edd84fd02a9d3$export$28e250f55413be00(buffers) {
    var length = buffers.reduce(function(total, buffer) {
        return total + buffer.length;
    }, 0);
    var result = new Uint8Array(length);
    var offset = 0;
    for(var _i = 0, buffers_1 = buffers; _i < buffers_1.length; _i++){
        var buffer = buffers_1[_i];
        result.set(buffer, offset);
        offset += buffer.length;
    }
    return result;
}

});

parcelRegister("gS5dB", function(module, exports) {

$parcel$export(module.exports, "jsonStringify", () => $c485bcbdb210dda5$export$1f8609334739c2b6);
$parcel$export(module.exports, "detachToJsonMethod", () => $c485bcbdb210dda5$export$f6ec9d87b663748);

var $dBtKo = parcelRequire("dBtKo");
function $c485bcbdb210dda5$export$1f8609334739c2b6(value, replacer, space) {
    if (typeof value !== "object" || value === null) return JSON.stringify(value);
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    var restoreObjectPrototypeToJson = $c485bcbdb210dda5$export$f6ec9d87b663748(Object.prototype);
    var restoreArrayPrototypeToJson = $c485bcbdb210dda5$export$f6ec9d87b663748(Array.prototype);
    var restoreValuePrototypeToJson = $c485bcbdb210dda5$export$f6ec9d87b663748(Object.getPrototypeOf(value));
    var restoreValueToJson = $c485bcbdb210dda5$export$f6ec9d87b663748(value);
    try {
        return JSON.stringify(value, replacer, space);
    } catch (_a) {
        return "<error: unable to serialize object>";
    } finally{
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function $c485bcbdb210dda5$export$f6ec9d87b663748(value) {
    var object = value;
    var objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return function() {
            object.toJSON = objectToJson;
        };
    }
    return 0, $dBtKo.noop;
}

});
parcelRegister("dBtKo", function(module, exports) {

$parcel$export(module.exports, "throttle", () => $9e75ce46bf710abf$export$de363e709c412c8a);
$parcel$export(module.exports, "noop", () => $9e75ce46bf710abf$export$8793edee2d425525);

var $kiWyZ = parcelRequire("kiWyZ");
function $9e75ce46bf710abf$export$de363e709c412c8a(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function() {
            var parameters = [];
            for(var _i = 0; _i < arguments.length; _i++)parameters[_i] = arguments[_i];
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) fn.apply(void 0, parameters);
            else pendingExecutionWithParameters = parameters;
            inWaitPeriod = true;
            pendingTimeoutId = (0, $kiWyZ.setTimeout)(function() {
                if (needTrailingExecution && pendingExecutionWithParameters) fn.apply(void 0, pendingExecutionWithParameters);
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function() {
            (0, $kiWyZ.clearTimeout)(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        }
    };
}
function $9e75ce46bf710abf$export$8793edee2d425525() {}

});
parcelRegister("kiWyZ", function(module, exports) {

$parcel$export(module.exports, "setTimeout", () => $ec82ea8b4ce5687d$export$831dc9f2ab0a617b);
$parcel$export(module.exports, "clearTimeout", () => $ec82ea8b4ce5687d$export$4e6a25ba7ce9d78e);
$parcel$export(module.exports, "setInterval", () => $ec82ea8b4ce5687d$export$cda6c73645970615);
$parcel$export(module.exports, "clearInterval", () => $ec82ea8b4ce5687d$export$5c0dc72231454d02);

var $76Lcq = parcelRequire("76Lcq");

var $5JqHL = parcelRequire("5JqHL");

var $hAJkc = parcelRequire("hAJkc");
function $ec82ea8b4ce5687d$export$831dc9f2ab0a617b(callback, delay) {
    return (0, $76Lcq.getZoneJsOriginalValue)((0, $hAJkc.getGlobalObject)(), "setTimeout")((0, $5JqHL.monitor)(callback), delay);
}
function $ec82ea8b4ce5687d$export$4e6a25ba7ce9d78e(timeoutId) {
    (0, $76Lcq.getZoneJsOriginalValue)((0, $hAJkc.getGlobalObject)(), "clearTimeout")(timeoutId);
}
function $ec82ea8b4ce5687d$export$cda6c73645970615(callback, delay) {
    return (0, $76Lcq.getZoneJsOriginalValue)((0, $hAJkc.getGlobalObject)(), "setInterval")((0, $5JqHL.monitor)(callback), delay);
}
function $ec82ea8b4ce5687d$export$5c0dc72231454d02(timeoutId) {
    (0, $76Lcq.getZoneJsOriginalValue)((0, $hAJkc.getGlobalObject)(), "clearInterval")(timeoutId);
}

});
parcelRegister("76Lcq", function(module, exports) {

$parcel$export(module.exports, "getZoneJsOriginalValue", () => $52cdb4c370041c5d$export$610f486206760177);

var $hAJkc = parcelRequire("hAJkc");
function $52cdb4c370041c5d$export$610f486206760177(target, name) {
    var browserWindow = (0, $hAJkc.getGlobalObject)();
    var original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === "function") original = target[browserWindow.Zone.__symbol__(name)];
    if (!original) original = target[name];
    return original;
}

});





parcelRegister("3jm7f", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $26944d302ad5ec29$export$77cea355fa80b5f4);
$parcel$export(module.exports, "mergeObservables", () => $26944d302ad5ec29$export$ca54b410f15f44fe);
var $26944d302ad5ec29$export$77cea355fa80b5f4 = /** @class */ function() {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function(f) {
        var _this = this;
        if (!this.observers.length && this.onFirstSubscribe) this.onLastUnsubscribe = this.onFirstSubscribe(this) || undefined;
        this.observers.push(f);
        return {
            unsubscribe: function() {
                _this.observers = _this.observers.filter(function(other) {
                    return f !== other;
                });
                if (!_this.observers.length && _this.onLastUnsubscribe) _this.onLastUnsubscribe();
            }
        };
    };
    Observable.prototype.notify = function(data) {
        this.observers.forEach(function(observer) {
            return observer(data);
        });
    };
    return Observable;
}();
function $26944d302ad5ec29$export$ca54b410f15f44fe() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return new $26944d302ad5ec29$export$77cea355fa80b5f4(function(globalObservable) {
        var subscriptions = observables.map(function(observable) {
            return observable.subscribe(function(data) {
                return globalObservable.notify(data);
            });
        });
        return function() {
            return subscriptions.forEach(function(subscription) {
                return subscription.unsubscribe();
            });
        };
    });
}

});


parcelRegister("ha2ro", function(module, exports) {

$parcel$export(module.exports, "createCustomerDataTrackerManager", () => $c7e5438797f55206$export$91e74adeb321d399);

var $3EczY = parcelRequire("3EczY");

var $dBtKo = parcelRequire("dBtKo");

var $gS5dB = parcelRequire("gS5dB");

var $gqtZo = parcelRequire("gqtZo");

var $3h3z3 = parcelRequire("3h3z3");
var $c7e5438797f55206$export$856a8907751d74c7 = 3 * (0, $3EczY.ONE_KIBI_BYTE);
var $c7e5438797f55206$export$c5b99750d2340cdd = 16 * (0, $3EczY.ONE_KIBI_BYTE);
var $c7e5438797f55206$export$e4441139afa265bd = 200;
function $c7e5438797f55206$export$91e74adeb321d399(compressionStatus) {
    if (compressionStatus === void 0) compressionStatus = 2 /* CustomerDataCompressionStatus.Disabled */ ;
    var customerDataTrackers = new Map();
    var alreadyWarned = false;
    function checkCustomerDataLimit(initialBytesCount) {
        if (initialBytesCount === void 0) initialBytesCount = 0;
        if (alreadyWarned || compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */ ) return;
        var bytesCountLimit = compressionStatus === 2 /* CustomerDataCompressionStatus.Disabled */  ? $c7e5438797f55206$export$856a8907751d74c7 : $c7e5438797f55206$export$c5b99750d2340cdd;
        var bytesCount = initialBytesCount;
        customerDataTrackers.forEach(function(tracker) {
            bytesCount += tracker.getBytesCount();
        });
        if (bytesCount > bytesCountLimit) {
            $c7e5438797f55206$var$displayCustomerDataLimitReachedWarning(bytesCountLimit);
            alreadyWarned = true;
        }
    }
    return {
        /**
         * Creates a detached tracker. The manager will not store a reference to that tracker, and the
         * bytes count will be counted independently from other detached trackers.
         *
         * This is particularly useful when we don't know when the tracker will be unused, so we don't
         * leak memory (ex: when used in Logger instances).
         */ createDetachedTracker: function() {
            var tracker = $c7e5438797f55206$export$1cff91322f949d75(function() {
                return checkCustomerDataLimit(tracker.getBytesCount());
            });
            return tracker;
        },
        /**
         * Creates a tracker if it doesn't exist, and returns it.
         */ getOrCreateTracker: function(type) {
            if (!customerDataTrackers.has(type)) customerDataTrackers.set(type, $c7e5438797f55206$export$1cff91322f949d75(checkCustomerDataLimit));
            return customerDataTrackers.get(type);
        },
        setCompressionStatus: function(newCompressionStatus) {
            if (compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */ ) {
                compressionStatus = newCompressionStatus;
                checkCustomerDataLimit();
            }
        },
        getCompressionStatus: function() {
            return compressionStatus;
        },
        stop: function() {
            customerDataTrackers.forEach(function(tracker) {
                return tracker.stop();
            });
            customerDataTrackers.clear();
        }
    };
}
function $c7e5438797f55206$export$1cff91322f949d75(checkCustomerDataLimit) {
    var bytesCountCache = 0;
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call context APIs synchronously multiple times in a row
    var _a = (0, $dBtKo.throttle)(function(context) {
        bytesCountCache = (0, $3EczY.computeBytesCount)((0, $gS5dB.jsonStringify)(context));
        checkCustomerDataLimit();
    }, $c7e5438797f55206$export$e4441139afa265bd), computeBytesCountThrottled = _a.throttled, cancelComputeBytesCount = _a.cancel;
    var resetBytesCount = function() {
        cancelComputeBytesCount();
        bytesCountCache = 0;
    };
    return {
        updateCustomerData: function(context) {
            if ((0, $3h3z3.isEmptyObject)(context)) resetBytesCount();
            else computeBytesCountThrottled(context);
        },
        resetCustomerData: resetBytesCount,
        getBytesCount: function() {
            return bytesCountCache;
        },
        stop: function() {
            cancelComputeBytesCount();
        }
    };
}
function $c7e5438797f55206$var$displayCustomerDataLimitReachedWarning(bytesCountLimit) {
    (0, $gqtZo.display).warn("Customer data exceeds the recommended ".concat(bytesCountLimit / (0, $3EczY.ONE_KIBI_BYTE), "KiB threshold. More details: https://docs.datadoghq.com/real_user_monitoring/browser/troubleshooting/#customer-data-exceeds-the-recommended-threshold-warning"));
}

});
parcelRegister("3h3z3", function(module, exports) {

$parcel$export(module.exports, "shallowClone", () => $2625b9716ad4366e$export$370e8311c3cdebd9);
$parcel$export(module.exports, "objectHasValue", () => $2625b9716ad4366e$export$783ef1184b4cd483);
$parcel$export(module.exports, "isEmptyObject", () => $2625b9716ad4366e$export$83b788b1a3698c03);

var $iD7Tb = parcelRequire("iD7Tb");
function $2625b9716ad4366e$export$370e8311c3cdebd9(object) {
    return (0, $iD7Tb.assign)({}, object);
}
function $2625b9716ad4366e$export$783ef1184b4cd483(object, value) {
    return Object.keys(object).some(function(key) {
        return object[key] === value;
    });
}
function $2625b9716ad4366e$export$83b788b1a3698c03(object) {
    return Object.keys(object).length === 0;
}
function $2625b9716ad4366e$export$825e789796ab7275(object, fn) {
    var newObject = {};
    for(var _i = 0, _a = Object.keys(object); _i < _a.length; _i++){
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}

});


parcelRegister("bxRq9", function(module, exports) {

$parcel$export(module.exports, "TrackingConsent", () => $867c3704d0ac1caf$export$52745dd8ee2d32b2);
$parcel$export(module.exports, "createTrackingConsentState", () => $867c3704d0ac1caf$export$6a999af43d888e18);

var $3jm7f = parcelRequire("3jm7f");
var $867c3704d0ac1caf$export$52745dd8ee2d32b2 = {
    GRANTED: "granted",
    NOT_GRANTED: "not-granted"
};
function $867c3704d0ac1caf$export$6a999af43d888e18(currentConsent) {
    var observable = new (0, $3jm7f.Observable)();
    return {
        tryToInit: function(trackingConsent) {
            if (!currentConsent) currentConsent = trackingConsent;
        },
        update: function(trackingConsent) {
            currentConsent = trackingConsent;
            observable.notify();
        },
        isGranted: function() {
            return currentConsent === $867c3704d0ac1caf$export$52745dd8ee2d32b2.GRANTED;
        },
        observable: observable
    };
}

});

parcelRegister("8wwlK", function(module, exports) {

$parcel$export(module.exports, "displayAlreadyInitializedError", () => $634a67e52c74f786$export$b25c854130ebaef9);

var $gqtZo = parcelRequire("gqtZo");
function $634a67e52c74f786$export$b25c854130ebaef9(sdkName, initConfiguration) {
    if (!initConfiguration.silentMultipleInit) (0, $gqtZo.display).error("".concat(sdkName, " is already initialized."));
}

});

parcelRegister("gwojm", function(module, exports) {

$parcel$export(module.exports, "storeContextManager", () => $c0727e340b5c5f4c$export$a658cbc041b124d0);

var $eVXiU = parcelRequire("eVXiU");

var $2JJbR = parcelRequire("2JJbR");
var $c0727e340b5c5f4c$var$CONTEXT_STORE_KEY_PREFIX = "_dd_c";
var $c0727e340b5c5f4c$var$storageListeners = [];
function $c0727e340b5c5f4c$export$a658cbc041b124d0(configuration, contextManager, productKey, customerDataType) {
    var storageKey = $c0727e340b5c5f4c$export$c2d6dd7271dc8ae0(productKey, customerDataType);
    $c0727e340b5c5f4c$var$storageListeners.push((0, $eVXiU.addEventListener)(configuration, window, (0, $eVXiU.DOM_EVENT).STORAGE, function(_a) {
        var key = _a.key;
        if (storageKey === key) synchronizeWithStorage();
    }));
    contextManager.changeObservable.subscribe(dumpToStorage);
    contextManager.setContext((0, $2JJbR.combine)(getFromStorage(), contextManager.getContext()));
    function synchronizeWithStorage() {
        contextManager.setContext(getFromStorage());
    }
    function dumpToStorage() {
        localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
    }
    function getFromStorage() {
        var rawContext = localStorage.getItem(storageKey);
        return rawContext !== null ? JSON.parse(rawContext) : {};
    }
}
function $c0727e340b5c5f4c$export$c2d6dd7271dc8ae0(productKey, customerDataType) {
    return "".concat($c0727e340b5c5f4c$var$CONTEXT_STORE_KEY_PREFIX, "_").concat(productKey, "_").concat(customerDataType);
}
function $c0727e340b5c5f4c$export$c82fd872f963a6c() {
    $c0727e340b5c5f4c$var$storageListeners.map(function(listener) {
        return listener.stop();
    });
}

});
parcelRegister("eVXiU", function(module, exports) {

$parcel$export(module.exports, "DOM_EVENT", () => $adf46412df29ddd9$export$54664c6599f7afe2);
$parcel$export(module.exports, "addEventListener", () => $adf46412df29ddd9$export$3f65cefe8380dbea);
$parcel$export(module.exports, "addEventListeners", () => $adf46412df29ddd9$export$40a4ed63e5cb7043);

var $5JqHL = parcelRequire("5JqHL");

var $76Lcq = parcelRequire("76Lcq");
var $adf46412df29ddd9$export$54664c6599f7afe2;
(function(DOM_EVENT) {
    DOM_EVENT["BEFORE_UNLOAD"] = "beforeunload";
    DOM_EVENT["CLICK"] = "click";
    DOM_EVENT["DBL_CLICK"] = "dblclick";
    DOM_EVENT["KEY_DOWN"] = "keydown";
    DOM_EVENT["LOAD"] = "load";
    DOM_EVENT["POP_STATE"] = "popstate";
    DOM_EVENT["SCROLL"] = "scroll";
    DOM_EVENT["TOUCH_START"] = "touchstart";
    DOM_EVENT["TOUCH_END"] = "touchend";
    DOM_EVENT["TOUCH_MOVE"] = "touchmove";
    DOM_EVENT["VISIBILITY_CHANGE"] = "visibilitychange";
    DOM_EVENT["PAGE_SHOW"] = "pageshow";
    DOM_EVENT["FREEZE"] = "freeze";
    DOM_EVENT["RESUME"] = "resume";
    DOM_EVENT["DOM_CONTENT_LOADED"] = "DOMContentLoaded";
    DOM_EVENT["POINTER_DOWN"] = "pointerdown";
    DOM_EVENT["POINTER_UP"] = "pointerup";
    DOM_EVENT["POINTER_CANCEL"] = "pointercancel";
    DOM_EVENT["HASH_CHANGE"] = "hashchange";
    DOM_EVENT["PAGE_HIDE"] = "pagehide";
    DOM_EVENT["MOUSE_DOWN"] = "mousedown";
    DOM_EVENT["MOUSE_UP"] = "mouseup";
    DOM_EVENT["MOUSE_MOVE"] = "mousemove";
    DOM_EVENT["FOCUS"] = "focus";
    DOM_EVENT["BLUR"] = "blur";
    DOM_EVENT["CONTEXT_MENU"] = "contextmenu";
    DOM_EVENT["RESIZE"] = "resize";
    DOM_EVENT["CHANGE"] = "change";
    DOM_EVENT["INPUT"] = "input";
    DOM_EVENT["PLAY"] = "play";
    DOM_EVENT["PAUSE"] = "pause";
    DOM_EVENT["SECURITY_POLICY_VIOLATION"] = "securitypolicyviolation";
    DOM_EVENT["SELECTION_CHANGE"] = "selectionchange";
    DOM_EVENT["STORAGE"] = "storage";
})($adf46412df29ddd9$export$54664c6599f7afe2 || ($adf46412df29ddd9$export$54664c6599f7afe2 = {}));
function $adf46412df29ddd9$export$3f65cefe8380dbea(configuration, eventTarget, eventName, listener, options) {
    return $adf46412df29ddd9$export$40a4ed63e5cb7043(configuration, eventTarget, [
        eventName
    ], listener, options);
}
function $adf46412df29ddd9$export$40a4ed63e5cb7043(configuration, eventTarget, eventNames, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var listenerWithMonitor = (0, $5JqHL.monitor)(function(event) {
        if (!event.isTrusted && !event.__ddIsTrusted && !configuration.allowUntrustedEvents) return;
        if (once) stop();
        listener(event);
    });
    var options = passive ? {
        capture: capture,
        passive: passive
    } : capture;
    var add = (0, $76Lcq.getZoneJsOriginalValue)(eventTarget, "addEventListener");
    eventNames.forEach(function(eventName) {
        return add.call(eventTarget, eventName, listenerWithMonitor, options);
    });
    function stop() {
        var remove = (0, $76Lcq.getZoneJsOriginalValue)(eventTarget, "removeEventListener");
        eventNames.forEach(function(eventName) {
            return remove.call(eventTarget, eventName, listenerWithMonitor, options);
        });
    }
    return {
        stop: stop
    };
}

});


parcelRegister("bWwuo", function(module, exports) {

$parcel$export(module.exports, "StatusType", () => $8b1e50272cf2e3a0$export$e35c1996c6f482ad);
$parcel$export(module.exports, "HandlerType", () => $8b1e50272cf2e3a0$export$533bc3391342c4f6);
$parcel$export(module.exports, "STATUSES", () => $8b1e50272cf2e3a0$export$b41c0f52c41112e3);
$parcel$export(module.exports, "Logger", () => $8b1e50272cf2e3a0$export$efa9a398d6368992);

var $kklrV = parcelRequire("kklrV");
var $2JJbR = parcelRequire("2JJbR");
var $oZ6HF = parcelRequire("oZ6HF");
var $ezY4f = parcelRequire("ezY4f");
var $krSzL = parcelRequire("krSzL");
var $1PeMs = parcelRequire("1PeMs");
var $5JqHL = parcelRequire("5JqHL");
var $41fUm = parcelRequire("41fUm");
var $8b1e50272cf2e3a0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8b1e50272cf2e3a0$export$e35c1996c6f482ad = {
    debug: "debug",
    error: "error",
    info: "info",
    warn: "warn"
};
var $8b1e50272cf2e3a0$export$533bc3391342c4f6 = {
    console: "console",
    http: "http",
    silent: "silent"
};
var $8b1e50272cf2e3a0$export$b41c0f52c41112e3 = Object.keys($8b1e50272cf2e3a0$export$e35c1996c6f482ad);
var $8b1e50272cf2e3a0$export$efa9a398d6368992 = /** @class */ function() {
    function Logger(handleLogStrategy, customerDataTracker, name, handlerType, level, loggerContext) {
        if (handlerType === void 0) handlerType = $8b1e50272cf2e3a0$export$533bc3391342c4f6.http;
        if (level === void 0) level = $8b1e50272cf2e3a0$export$e35c1996c6f482ad.debug;
        if (loggerContext === void 0) loggerContext = {};
        this.handleLogStrategy = handleLogStrategy;
        this.handlerType = handlerType;
        this.level = level;
        this.contextManager = (0, $krSzL.createContextManager)(customerDataTracker);
        this.contextManager.setContext(loggerContext);
        if (name) this.contextManager.setContextProperty("logger", {
            name: name
        });
    }
    Logger.prototype.log = function(message, messageContext, status, error) {
        if (status === void 0) status = $8b1e50272cf2e3a0$export$e35c1996c6f482ad.info;
        var errorContext;
        if (error !== undefined && error !== null) {
            var stackTrace = error instanceof Error ? (0, $ezY4f.computeStackTrace)(error) : undefined;
            var rawError = (0, $oZ6HF.computeRawError)({
                stackTrace: stackTrace,
                originalError: error,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */ ,
                source: (0, $1PeMs.ErrorSource).LOGGER,
                handling: "handled" /* ErrorHandling.HANDLED */ ,
                startClocks: (0, $kklrV.clocksNow)()
            });
            errorContext = {
                stack: rawError.stack,
                kind: rawError.type,
                message: rawError.message,
                causes: rawError.causes
            };
        }
        var sanitizedMessageContext = (0, $41fUm.sanitize)(messageContext);
        var context = errorContext ? (0, $2JJbR.combine)({
            error: errorContext
        }, sanitizedMessageContext) : sanitizedMessageContext;
        this.handleLogStrategy({
            message: (0, $41fUm.sanitize)(message),
            context: context,
            status: status
        }, this);
    };
    Logger.prototype.debug = function(message, messageContext, error) {
        this.log(message, messageContext, $8b1e50272cf2e3a0$export$e35c1996c6f482ad.debug, error);
    };
    Logger.prototype.info = function(message, messageContext, error) {
        this.log(message, messageContext, $8b1e50272cf2e3a0$export$e35c1996c6f482ad.info, error);
    };
    Logger.prototype.warn = function(message, messageContext, error) {
        this.log(message, messageContext, $8b1e50272cf2e3a0$export$e35c1996c6f482ad.warn, error);
    };
    Logger.prototype.error = function(message, messageContext, error) {
        this.log(message, messageContext, $8b1e50272cf2e3a0$export$e35c1996c6f482ad.error, error);
    };
    Logger.prototype.setContext = function(context) {
        this.contextManager.setContext(context);
    };
    Logger.prototype.getContext = function() {
        return this.contextManager.getContext();
    };
    Logger.prototype.setContextProperty = function(key, value) {
        this.contextManager.setContextProperty(key, value);
    };
    Logger.prototype.removeContextProperty = function(key) {
        this.contextManager.removeContextProperty(key);
    };
    Logger.prototype.clearContext = function() {
        this.contextManager.clearContext();
    };
    Logger.prototype.setHandler = function(handler) {
        this.handlerType = handler;
    };
    Logger.prototype.getHandler = function() {
        return this.handlerType;
    };
    Logger.prototype.setLevel = function(level) {
        this.level = level;
    };
    Logger.prototype.getLevel = function() {
        return this.level;
    };
    $8b1e50272cf2e3a0$var$__decorate([
        (0, $5JqHL.monitored)
    ], Logger.prototype, "log", null);
    return Logger;
}();

});
parcelRegister("kklrV", function(module, exports) {

$parcel$export(module.exports, "ONE_SECOND", () => $ecc65053f30f4873$export$32c0454ceff7f92d);
$parcel$export(module.exports, "ONE_MINUTE", () => $ecc65053f30f4873$export$35acaebf644db34e);
$parcel$export(module.exports, "ONE_HOUR", () => $ecc65053f30f4873$export$82541edf19e5e3b0);
$parcel$export(module.exports, "getRelativeTime", () => $ecc65053f30f4873$export$493c11ff22f45a24);
$parcel$export(module.exports, "dateNow", () => $ecc65053f30f4873$export$ceae11818251d43c);
$parcel$export(module.exports, "addDuration", () => $ecc65053f30f4873$export$c0c581816dedfc70);
$parcel$export(module.exports, "timeStampNow", () => $ecc65053f30f4873$export$71f52cdbbf629086);
$parcel$export(module.exports, "relativeNow", () => $ecc65053f30f4873$export$53cb631b087d9e92);
$parcel$export(module.exports, "clocksNow", () => $ecc65053f30f4873$export$67898643147706d3);
$parcel$export(module.exports, "clocksOrigin", () => $ecc65053f30f4873$export$d8b428538156d05f);
$parcel$export(module.exports, "elapsed", () => $ecc65053f30f4873$export$e04aa69d28450d55);

var $i44dp = parcelRequire("i44dp");
var $ecc65053f30f4873$export$32c0454ceff7f92d = 1000;
var $ecc65053f30f4873$export$35acaebf644db34e = 60 * $ecc65053f30f4873$export$32c0454ceff7f92d;
var $ecc65053f30f4873$export$82541edf19e5e3b0 = 60 * $ecc65053f30f4873$export$35acaebf644db34e;
var $ecc65053f30f4873$export$a97a1358cbb650ab = 24 * $ecc65053f30f4873$export$82541edf19e5e3b0;
var $ecc65053f30f4873$export$99cafda57477293d = 365 * $ecc65053f30f4873$export$a97a1358cbb650ab;
function $ecc65053f30f4873$export$6d554362ef4543f2(relative) {
    return {
        relative: relative,
        timeStamp: $ecc65053f30f4873$var$getCorrectedTimeStamp(relative)
    };
}
function $ecc65053f30f4873$export$1208e92a226eb540(timeStamp) {
    return {
        relative: $ecc65053f30f4873$export$493c11ff22f45a24(timeStamp),
        timeStamp: timeStamp
    };
}
function $ecc65053f30f4873$var$getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = $ecc65053f30f4873$export$ceae11818251d43c() - performance.now();
    // apply correction only for positive drift
    if (correctedOrigin > $ecc65053f30f4873$var$getNavigationStart()) return Math.round($ecc65053f30f4873$export$c0c581816dedfc70(correctedOrigin, relativeTime));
    return $ecc65053f30f4873$export$3eddb21a9c389dec(relativeTime);
}
function $ecc65053f30f4873$export$5dcf4148298ed557() {
    return Math.round($ecc65053f30f4873$export$ceae11818251d43c() - $ecc65053f30f4873$export$c0c581816dedfc70($ecc65053f30f4873$var$getNavigationStart(), performance.now()));
}
function $ecc65053f30f4873$export$cc7917ebd320fa93(duration) {
    if (!(0, $i44dp.isNumber)(duration)) return duration;
    return (0, $i44dp.round)(duration * 1e6, 0);
}
function $ecc65053f30f4873$export$ceae11818251d43c() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
function $ecc65053f30f4873$export$71f52cdbbf629086() {
    return $ecc65053f30f4873$export$ceae11818251d43c();
}
function $ecc65053f30f4873$export$53cb631b087d9e92() {
    return performance.now();
}
function $ecc65053f30f4873$export$67898643147706d3() {
    return {
        relative: $ecc65053f30f4873$export$53cb631b087d9e92(),
        timeStamp: $ecc65053f30f4873$export$71f52cdbbf629086()
    };
}
function $ecc65053f30f4873$export$d8b428538156d05f() {
    return {
        relative: 0,
        timeStamp: $ecc65053f30f4873$var$getNavigationStart()
    };
}
function $ecc65053f30f4873$export$e04aa69d28450d55(start, end) {
    return end - start;
}
function $ecc65053f30f4873$export$c0c581816dedfc70(a, b) {
    return a + b;
}
function $ecc65053f30f4873$export$493c11ff22f45a24(timestamp) {
    return timestamp - $ecc65053f30f4873$var$getNavigationStart();
}
function $ecc65053f30f4873$export$3eddb21a9c389dec(relativeTime) {
    return Math.round($ecc65053f30f4873$export$c0c581816dedfc70($ecc65053f30f4873$var$getNavigationStart(), relativeTime));
}
function $ecc65053f30f4873$export$dc53cd187b19c9f8(time) {
    return time < $ecc65053f30f4873$export$99cafda57477293d;
}
/**
 * Navigation start slightly change on some rare cases
 */ var $ecc65053f30f4873$var$navigationStart;
function $ecc65053f30f4873$var$getNavigationStart() {
    if ($ecc65053f30f4873$var$navigationStart === undefined) $ecc65053f30f4873$var$navigationStart = performance.timing.navigationStart;
    return $ecc65053f30f4873$var$navigationStart;
}
function $ecc65053f30f4873$export$4db21cdd0be0ff26() {
    $ecc65053f30f4873$var$navigationStart = undefined;
}

});
parcelRegister("i44dp", function(module, exports) {

$parcel$export(module.exports, "performDraw", () => $d26bdece15b26885$export$72c7afebfef3b500);
$parcel$export(module.exports, "round", () => $d26bdece15b26885$export$2077e0241d6afd3c);
$parcel$export(module.exports, "isPercentage", () => $d26bdece15b26885$export$d86432a85610ea90);
$parcel$export(module.exports, "isNumber", () => $d26bdece15b26885$export$7e4aa119212bc614);
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */ function $d26bdece15b26885$export$72c7afebfef3b500(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function $d26bdece15b26885$export$2077e0241d6afd3c(num, decimals) {
    return +num.toFixed(decimals);
}
function $d26bdece15b26885$export$d86432a85610ea90(value) {
    return $d26bdece15b26885$export$7e4aa119212bc614(value) && value >= 0 && value <= 100;
}
function $d26bdece15b26885$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}

});


parcelRegister("oZ6HF", function(module, exports) {

$parcel$export(module.exports, "NO_ERROR_STACK_PRESENT_MESSAGE", () => $04b1a49b473c3376$export$25ad0fcc62fe3571);
$parcel$export(module.exports, "computeRawError", () => $04b1a49b473c3376$export$b8dc46b79c72ee26);
$parcel$export(module.exports, "toStackTraceString", () => $04b1a49b473c3376$export$36ad41d7075a6f2b);
$parcel$export(module.exports, "flattenErrorCauses", () => $04b1a49b473c3376$export$bf9a979d43c83a9);
$parcel$export(module.exports, "tryToGetFingerprint", () => $04b1a49b473c3376$export$1c18937f21a7f1f7);
$parcel$export(module.exports, "formatErrorMessage", () => $04b1a49b473c3376$export$5201d50a34753d71);
$parcel$export(module.exports, "getFileFromStackTraceString", () => $04b1a49b473c3376$export$edc1986890374033);
$parcel$export(module.exports, "createHandlingStack", () => $04b1a49b473c3376$export$46c2cbbc853cd95b);

var $5JqHL = parcelRequire("5JqHL");

var $41fUm = parcelRequire("41fUm");

var $dBtKo = parcelRequire("dBtKo");

var $gS5dB = parcelRequire("gS5dB");

var $ezY4f = parcelRequire("ezY4f");
var $04b1a49b473c3376$export$25ad0fcc62fe3571 = "No stack, consider using an instance of Error";
function $04b1a49b473c3376$export$b8dc46b79c72ee26(_a) {
    var stackTrace = _a.stackTrace, originalError = _a.originalError, handlingStack = _a.handlingStack, startClocks = _a.startClocks, nonErrorPrefix = _a.nonErrorPrefix, source = _a.source, handling = _a.handling;
    var isErrorInstance = originalError instanceof Error;
    var message = $04b1a49b473c3376$var$computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError);
    var stack = $04b1a49b473c3376$var$hasUsableStack(isErrorInstance, stackTrace) ? $04b1a49b473c3376$export$36ad41d7075a6f2b(stackTrace) : $04b1a49b473c3376$export$25ad0fcc62fe3571;
    var causes = isErrorInstance ? $04b1a49b473c3376$export$bf9a979d43c83a9(originalError, source) : undefined;
    var type = stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name;
    var fingerprint = $04b1a49b473c3376$export$1c18937f21a7f1f7(originalError);
    return {
        startClocks: startClocks,
        source: source,
        handling: handling,
        handlingStack: handlingStack,
        originalError: originalError,
        type: type,
        message: message,
        stack: stack,
        causes: causes,
        fingerprint: fingerprint
    };
}
function $04b1a49b473c3376$var$computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name) ? stackTrace.message : !isErrorInstance ? "".concat(nonErrorPrefix, " ").concat((0, $gS5dB.jsonStringify)((0, $41fUm.sanitize)(originalError))) : "Empty message";
}
function $04b1a49b473c3376$var$hasUsableStack(isErrorInstance, stackTrace) {
    if (stackTrace === undefined) return false;
    if (isErrorInstance) return true;
    // handle cases where tracekit return stack = [] or stack = [{url: undefined, line: undefined, column: undefined}]
    // TODO rework tracekit integration to avoid generating those unusable stack
    return stackTrace.stack.length > 0 && (stackTrace.stack.length > 1 || stackTrace.stack[0].url !== undefined);
}
function $04b1a49b473c3376$export$1c18937f21a7f1f7(originalError) {
    return originalError instanceof Error && "dd_fingerprint" in originalError ? String(originalError.dd_fingerprint) : undefined;
}
function $04b1a49b473c3376$export$36ad41d7075a6f2b(stack) {
    var result = $04b1a49b473c3376$export$5201d50a34753d71(stack);
    stack.stack.forEach(function(frame) {
        var func = frame.func === "?" ? "<anonymous>" : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(", "), ")") : "";
        var line = frame.line ? ":".concat(frame.line) : "";
        var column = frame.line && frame.column ? ":".concat(frame.column) : "";
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
function $04b1a49b473c3376$export$edc1986890374033(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function $04b1a49b473c3376$export$5201d50a34753d71(stack) {
    return "".concat(stack.name || "Error", ": ").concat(stack.message);
}
function $04b1a49b473c3376$export$46c2cbbc853cd95b() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */ var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) try {
        throw error;
    } catch (e) {
        (0, $dBtKo.noop)();
    }
    (0, $5JqHL.callMonitored)(function() {
        var stackTrace = (0, $ezY4f.computeStackTrace)(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = $04b1a49b473c3376$export$36ad41d7075a6f2b(stackTrace);
    });
    return formattedStack;
}
function $04b1a49b473c3376$export$bf9a979d43c83a9(error, parentSource) {
    var currentError = error;
    var causes = [];
    while((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10){
        var stackTrace = (0, $ezY4f.computeStackTrace)(currentError.cause);
        causes.push({
            message: currentError.cause.message,
            source: parentSource,
            type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
            stack: stackTrace && $04b1a49b473c3376$export$36ad41d7075a6f2b(stackTrace)
        });
        currentError = currentError.cause;
    }
    return causes.length ? causes : undefined;
}

});
parcelRegister("ezY4f", function(module, exports) {

$parcel$export(module.exports, "computeStackTrace", () => $a9d2edb52deec5c9$export$81296eded4f2ac09);
$parcel$export(module.exports, "computeStackTraceFromOnErrorMessage", () => $a9d2edb52deec5c9$export$e8e53f0e2ff18afa);
/**
 * Cross-browser stack trace computation.
 *
 * Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
 */ 
var $iD7Tb = parcelRequire("iD7Tb");
var $a9d2edb52deec5c9$var$UNKNOWN_FUNCTION = "?";
function $a9d2edb52deec5c9$export$81296eded4f2ac09(ex) {
    var stack = [];
    var stackProperty = $a9d2edb52deec5c9$var$tryToGetString(ex, "stack");
    var exString = String(ex);
    if (stackProperty && (0, $iD7Tb.startsWith)(stackProperty, exString)) stackProperty = stackProperty.slice(exString.length);
    if (stackProperty) stackProperty.split("\n").forEach(function(line) {
        var stackFrame = $a9d2edb52deec5c9$var$parseChromeLine(line) || $a9d2edb52deec5c9$var$parseChromeAnonymousLine(line) || $a9d2edb52deec5c9$var$parseWinLine(line) || $a9d2edb52deec5c9$var$parseGeckoLine(line);
        if (stackFrame) {
            if (!stackFrame.func && stackFrame.line) stackFrame.func = $a9d2edb52deec5c9$var$UNKNOWN_FUNCTION;
            stack.push(stackFrame);
        }
    });
    return {
        message: $a9d2edb52deec5c9$var$tryToGetString(ex, "message"),
        name: $a9d2edb52deec5c9$var$tryToGetString(ex, "name"),
        stack: stack
    };
}
var $a9d2edb52deec5c9$var$fileUrl = "((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)";
var $a9d2edb52deec5c9$var$filePosition = "(?::(\\d+))";
var $a9d2edb52deec5c9$var$CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat($a9d2edb52deec5c9$var$fileUrl).concat($a9d2edb52deec5c9$var$filePosition, "?").concat($a9d2edb52deec5c9$var$filePosition, "?\\)?\\s*$"), "i");
var $a9d2edb52deec5c9$var$CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat($a9d2edb52deec5c9$var$filePosition).concat($a9d2edb52deec5c9$var$filePosition, "\\)"));
function $a9d2edb52deec5c9$var$parseChromeLine(line) {
    var parts = $a9d2edb52deec5c9$var$CHROME_LINE_RE.exec(line);
    if (!parts) return;
    var isNative = parts[2] && parts[2].indexOf("native") === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
    var submatch = $a9d2edb52deec5c9$var$CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [
            parts[2]
        ] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || $a9d2edb52deec5c9$var$UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined
    };
}
var $a9d2edb52deec5c9$var$CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat($a9d2edb52deec5c9$var$fileUrl).concat($a9d2edb52deec5c9$var$filePosition, "?").concat($a9d2edb52deec5c9$var$filePosition, "??\\s*$"), "i");
function $a9d2edb52deec5c9$var$parseChromeAnonymousLine(line) {
    var parts = $a9d2edb52deec5c9$var$CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) return;
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: $a9d2edb52deec5c9$var$UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1]
    };
}
var $a9d2edb52deec5c9$var$WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function $a9d2edb52deec5c9$var$parseWinLine(line) {
    var parts = $a9d2edb52deec5c9$var$WINJS_LINE_RE.exec(line);
    if (!parts) return;
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || $a9d2edb52deec5c9$var$UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2]
    };
}
var $a9d2edb52deec5c9$var$GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var $a9d2edb52deec5c9$var$GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function $a9d2edb52deec5c9$var$parseGeckoLine(line) {
    var parts = $a9d2edb52deec5c9$var$GECKO_LINE_RE.exec(line);
    if (!parts) return;
    var isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
    var submatch = $a9d2edb52deec5c9$var$GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(",") : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || $a9d2edb52deec5c9$var$UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3]
    };
}
function $a9d2edb52deec5c9$var$tryToGetString(candidate, property) {
    if (typeof candidate !== "object" || !candidate || !(property in candidate)) return undefined;
    var value = candidate[property];
    return typeof value === "string" ? value : undefined;
}
function $a9d2edb52deec5c9$export$e8e53f0e2ff18afa(messageObj, url, line, column) {
    var stack = [
        {
            url: url,
            column: column,
            line: line
        }
    ];
    var _a = $a9d2edb52deec5c9$var$tryToParseMessage(messageObj), name = _a.name, message = _a.message;
    return {
        name: name,
        message: message,
        stack: stack
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var $a9d2edb52deec5c9$var$ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function $a9d2edb52deec5c9$var$tryToParseMessage(messageObj) {
    var _a;
    var name;
    var message;
    if (({}).toString.call(messageObj) === "[object String]") _a = $a9d2edb52deec5c9$var$ERROR_TYPES_RE.exec(messageObj), name = _a[1], message = _a[2];
    return {
        name: name,
        message: message
    };
}

});


parcelRegister("1PeMs", function(module, exports) {

$parcel$export(module.exports, "ErrorSource", () => $154604faaf34e9a0$export$4f7d2dba9330699b);
var $154604faaf34e9a0$export$4f7d2dba9330699b = {
    AGENT: "agent",
    CONSOLE: "console",
    CUSTOM: "custom",
    LOGGER: "logger",
    NETWORK: "network",
    SOURCE: "source",
    REPORT: "report"
};

});


parcelRegister("8xDUU", function(module, exports) {

$parcel$export(module.exports, "buildCommonContext", () => $63805e797485528b$export$ef57df7b19d2c9ab);
function $63805e797485528b$export$ef57df7b19d2c9ab(globalContextManager, userContextManager) {
    return {
        view: {
            referrer: document.referrer,
            url: window.location.href
        },
        context: globalContextManager.getContext(),
        user: userContextManager.getContext()
    };
}

});

parcelRegister("1gCUO", function(module, exports) {

$parcel$export(module.exports, "createPreStartStrategy", () => $0ec578d30ad39ec5$export$8f7002373dcc6602);

var $iD7Tb = parcelRequire("iD7Tb");
var $3qcqs = parcelRequire("3qcqs");
var $5Q4S1 = parcelRequire("5Q4S1");
var $gqtZo = parcelRequire("gqtZo");
var $8wwlK = parcelRequire("8wwlK");
var $dBtKo = parcelRequire("dBtKo");
var $kklrV = parcelRequire("kklrV");

var $kOKbp = parcelRequire("kOKbp");
function $0ec578d30ad39ec5$export$8f7002373dcc6602(getCommonContext, trackingConsentState, doStartLogs) {
    var bufferApiCalls = new (0, $3qcqs.BoundedBuffer)();
    var cachedInitConfiguration;
    var cachedConfiguration;
    var trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartLogs);
    function tryStartLogs() {
        if (!cachedConfiguration || !cachedInitConfiguration || !trackingConsentState.isGranted()) return;
        trackingConsentStateSubscription.unsubscribe();
        var startLogsResult = doStartLogs(cachedInitConfiguration, cachedConfiguration);
        bufferApiCalls.drain(startLogsResult);
    }
    return {
        init: function(initConfiguration) {
            if (!initConfiguration) {
                (0, $gqtZo.display).error("Missing configuration");
                return;
            }
            if ((0, $5Q4S1.canUseEventBridge)()) initConfiguration = $0ec578d30ad39ec5$var$overrideInitConfigurationForBridge(initConfiguration);
            // Expose the initial configuration regardless of initialization success.
            cachedInitConfiguration = initConfiguration;
            if (cachedConfiguration) {
                (0, $8wwlK.displayAlreadyInitializedError)("DD_LOGS", initConfiguration);
                return;
            }
            var configuration = (0, $kOKbp.validateAndBuildLogsConfiguration)(initConfiguration);
            if (!configuration) return;
            cachedConfiguration = configuration;
            trackingConsentState.tryToInit(configuration.trackingConsent);
            tryStartLogs();
        },
        get initConfiguration () {
            return cachedInitConfiguration;
        },
        getInternalContext: (0, $dBtKo.noop),
        handleLog: function(message, statusType, context, date) {
            if (context === void 0) context = getCommonContext();
            if (date === void 0) date = (0, $kklrV.timeStampNow)();
            bufferApiCalls.add(function(startLogsResult) {
                return startLogsResult.handleLog(message, statusType, context, date);
            });
        }
    };
}
function $0ec578d30ad39ec5$var$overrideInitConfigurationForBridge(initConfiguration) {
    return (0, $iD7Tb.assign)({}, initConfiguration, {
        clientToken: "empty"
    });
}

});
parcelRegister("3qcqs", function(module, exports) {

$parcel$export(module.exports, "BoundedBuffer", () => $27dd704992e5a608$export$6f427737fb8ce4c5);

var $6P8NY = parcelRequire("6P8NY");
var $27dd704992e5a608$var$BUFFER_LIMIT = 500;
var $27dd704992e5a608$export$6f427737fb8ce4c5 = /** @class */ function() {
    function BoundedBuffer() {
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function(callback) {
        var length = this.buffer.push(callback);
        if (length > $27dd704992e5a608$var$BUFFER_LIMIT) this.buffer.splice(0, 1);
    };
    BoundedBuffer.prototype.remove = function(callback) {
        (0, $6P8NY.removeItem)(this.buffer, callback);
    };
    BoundedBuffer.prototype.drain = function(arg) {
        this.buffer.forEach(function(callback) {
            return callback(arg);
        });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}();

});
parcelRegister("6P8NY", function(module, exports) {

$parcel$export(module.exports, "removeDuplicates", () => $4f7e56040d61392a$export$2e2262a44ac61957);
$parcel$export(module.exports, "removeItem", () => $4f7e56040d61392a$export$fe2d9b4e03920b4c);

var $iD7Tb = parcelRequire("iD7Tb");
function $4f7e56040d61392a$export$2e2262a44ac61957(array) {
    var set = new Set();
    array.forEach(function(item) {
        return set.add(item);
    });
    return (0, $iD7Tb.arrayFrom)(set);
}
function $4f7e56040d61392a$export$fe2d9b4e03920b4c(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}

});


parcelRegister("5Q4S1", function(module, exports) {

$parcel$export(module.exports, "getEventBridge", () => $4405963c68ddbcd5$export$86c8e1e7efd0dfc1);
$parcel$export(module.exports, "canUseEventBridge", () => $4405963c68ddbcd5$export$a8ab916fee43a31b);

var $iD7Tb = parcelRequire("iD7Tb");

var $hAJkc = parcelRequire("hAJkc");
function $4405963c68ddbcd5$export$86c8e1e7efd0dfc1() {
    var eventBridgeGlobal = $4405963c68ddbcd5$var$getEventBridgeGlobal();
    if (!eventBridgeGlobal) return;
    return {
        getCapabilities: function() {
            var _a;
            return JSON.parse(((_a = eventBridgeGlobal.getCapabilities) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal)) || "[]");
        },
        getPrivacyLevel: function() {
            var _a;
            return (_a = eventBridgeGlobal.getPrivacyLevel) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal);
        },
        getAllowedWebViewHosts: function() {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function(eventType, event, viewId) {
            var view = viewId ? {
                id: viewId
            } : undefined;
            eventBridgeGlobal.send(JSON.stringify({
                eventType: eventType,
                event: event,
                view: view
            }));
        }
    };
}
function $4405963c68ddbcd5$export$c3d8d1f8445a3630(capability) {
    var bridge = $4405963c68ddbcd5$export$86c8e1e7efd0dfc1();
    return !!bridge && (0, $iD7Tb.includes)(bridge.getCapabilities(), capability);
}
function $4405963c68ddbcd5$export$a8ab916fee43a31b(currentHost) {
    var _a;
    if (currentHost === void 0) currentHost = (_a = (0, $hAJkc.getGlobalObject)().location) === null || _a === void 0 ? void 0 : _a.hostname;
    var bridge = $4405963c68ddbcd5$export$86c8e1e7efd0dfc1();
    return !!bridge && bridge.getAllowedWebViewHosts().some(function(allowedHost) {
        return currentHost === allowedHost || (0, $iD7Tb.endsWith)(currentHost, ".".concat(allowedHost));
    });
}
function $4405963c68ddbcd5$var$getEventBridgeGlobal() {
    return (0, $hAJkc.getGlobalObject)().DatadogEventBridge;
}

});

parcelRegister("kOKbp", function(module, exports) {

$parcel$export(module.exports, "validateAndBuildLogsConfiguration", () => $f27c4d265cb1422c$export$97b29d6675c29e61);
$parcel$export(module.exports, "serializeLogsConfiguration", () => $f27c4d265cb1422c$export$3cd09719b205537a);

var $iD7Tb = parcelRequire("iD7Tb");
var $gqtZo = parcelRequire("gqtZo");
var $3EczY = parcelRequire("3EczY");
var $nxPM5 = parcelRequire("nxPM5");
var $6P8NY = parcelRequire("6P8NY");
var $cgPDT = parcelRequire("cgPDT");
var $f27c4d265cb1422c$export$22e00ed24ca2e25e = 32 * (0, $3EczY.ONE_KIBI_BYTE);
function $f27c4d265cb1422c$export$97b29d6675c29e61(initConfiguration) {
    if (initConfiguration.usePciIntake === true && initConfiguration.site && initConfiguration.site !== "datadoghq.com") (0, $gqtZo.display).warn("PCI compliance for Logs is only available for Datadog organizations in the US1 site. Default intake will be used.");
    var baseConfiguration = (0, $cgPDT.validateAndBuildConfiguration)(initConfiguration);
    var forwardConsoleLogs = $f27c4d265cb1422c$export$68e7946e3a1d7eed(initConfiguration.forwardConsoleLogs, (0, $iD7Tb.objectValues)((0, $gqtZo.ConsoleApiName)), "Forward Console Logs");
    var forwardReports = $f27c4d265cb1422c$export$68e7946e3a1d7eed(initConfiguration.forwardReports, (0, $iD7Tb.objectValues)((0, $nxPM5.RawReportType)), "Forward Reports");
    if (!baseConfiguration || !forwardConsoleLogs || !forwardReports) return;
    if (initConfiguration.forwardErrorsToLogs && !(0, $iD7Tb.includes)(forwardConsoleLogs, (0, $gqtZo.ConsoleApiName).error)) forwardConsoleLogs.push((0, $gqtZo.ConsoleApiName).error);
    return (0, $iD7Tb.assign)({
        forwardErrorsToLogs: initConfiguration.forwardErrorsToLogs !== false,
        forwardConsoleLogs: forwardConsoleLogs,
        forwardReports: forwardReports,
        requestErrorResponseLengthLimit: $f27c4d265cb1422c$export$22e00ed24ca2e25e
    }, baseConfiguration);
}
function $f27c4d265cb1422c$export$68e7946e3a1d7eed(option, allowedValues, label) {
    if (option === undefined) return [];
    if (!(option === "all" || Array.isArray(option) && option.every(function(api) {
        return (0, $iD7Tb.includes)(allowedValues, api);
    }))) {
        (0, $gqtZo.display).error("".concat(label, ' should be "all" or an array with allowed values "').concat(allowedValues.join('", "'), '"'));
        return;
    }
    return option === "all" ? allowedValues : (0, $6P8NY.removeDuplicates)(option);
}
function $f27c4d265cb1422c$export$3cd09719b205537a(configuration) {
    var baseSerializedInitConfiguration = (0, $cgPDT.serializeConfiguration)(configuration);
    return (0, $iD7Tb.assign)({
        forward_errors_to_logs: configuration.forwardErrorsToLogs,
        forward_console_logs: configuration.forwardConsoleLogs,
        forward_reports: configuration.forwardReports,
        use_pci_intake: configuration.usePciIntake
    }, baseSerializedInitConfiguration);
}

});
parcelRegister("nxPM5", function(module, exports) {

$parcel$export(module.exports, "RawReportType", () => $046c64d6d45901e2$export$1bd494ac7adbb6ce);
$parcel$export(module.exports, "initReportObservable", () => $046c64d6d45901e2$export$645a986d81bb5490);

var $oZ6HF = parcelRequire("oZ6HF");

var $5JqHL = parcelRequire("5JqHL");

var $3jm7f = parcelRequire("3jm7f");

var $eVXiU = parcelRequire("eVXiU");

var $iD7Tb = parcelRequire("iD7Tb");

var $yXsvp = parcelRequire("yXsvp");
var $046c64d6d45901e2$export$1bd494ac7adbb6ce = {
    intervention: "intervention",
    deprecation: "deprecation",
    cspViolation: "csp_violation"
};
function $046c64d6d45901e2$export$645a986d81bb5490(configuration, apis) {
    var observables = [];
    if ((0, $iD7Tb.includes)(apis, $046c64d6d45901e2$export$1bd494ac7adbb6ce.cspViolation)) observables.push($046c64d6d45901e2$var$createCspViolationReportObservable(configuration));
    var reportTypes = apis.filter(function(api) {
        return api !== $046c64d6d45901e2$export$1bd494ac7adbb6ce.cspViolation;
    });
    if (reportTypes.length) observables.push($046c64d6d45901e2$var$createReportObservable(reportTypes));
    return (0, $3jm7f.mergeObservables).apply(void 0, observables);
}
function $046c64d6d45901e2$var$createReportObservable(reportTypes) {
    return new (0, $3jm7f.Observable)(function(observable) {
        if (!window.ReportingObserver) return;
        var handleReports = (0, $5JqHL.monitor)(function(reports, _) {
            return reports.forEach(function(report) {
                observable.notify($046c64d6d45901e2$var$buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true
        });
        observer.observe();
        return function() {
            observer.disconnect();
        };
    });
}
function $046c64d6d45901e2$var$createCspViolationReportObservable(configuration) {
    return new (0, $3jm7f.Observable)(function(observable) {
        var stop = (0, $eVXiU.addEventListener)(configuration, document, (0, $eVXiU.DOM_EVENT).SECURITY_POLICY_VIOLATION, function(event) {
            observable.notify($046c64d6d45901e2$var$buildRawReportFromCspViolation(event));
        }).stop;
        return stop;
    });
}
function $046c64d6d45901e2$var$buildRawReportFromReport(report) {
    var type = report.type, body = report.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        originalReport: report,
        stack: $046c64d6d45901e2$var$buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber)
    };
}
function $046c64d6d45901e2$var$buildRawReportFromCspViolation(event) {
    var type = $046c64d6d45901e2$export$1bd494ac7adbb6ce.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: $046c64d6d45901e2$export$1bd494ac7adbb6ce.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: $046c64d6d45901e2$var$buildStack(event.effectiveDirective, event.originalPolicy ? "".concat(message, ' of the policy "').concat((0, $yXsvp.safeTruncate)(event.originalPolicy, 100, "..."), '"') : "no policy", event.sourceFile, event.lineNumber, event.columnNumber),
        originalReport: event
    };
}
function $046c64d6d45901e2$var$buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return sourceFile ? (0, $oZ6HF.toStackTraceString)({
        name: name,
        message: message,
        stack: [
            {
                func: "?",
                url: sourceFile,
                line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
                column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined
            }
        ]
    }) : undefined;
}

});
parcelRegister("yXsvp", function(module, exports) {

$parcel$export(module.exports, "generateUUID", () => $06914c5d06679353$export$e73c8bd0f20705a);
$parcel$export(module.exports, "findCommaSeparatedValue", () => $06914c5d06679353$export$fe87bb5193f3e70);
$parcel$export(module.exports, "findCommaSeparatedValues", () => $06914c5d06679353$export$58032b923d63748e);
$parcel$export(module.exports, "safeTruncate", () => $06914c5d06679353$export$b26462d2f74496cd);
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */ function $06914c5d06679353$export$e73c8bd0f20705a(placeholder) {
    return placeholder ? (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, $06914c5d06679353$export$e73c8bd0f20705a);
}
var $06914c5d06679353$var$COMMA_SEPARATED_KEY_VALUE = /([\w-]+)\s*=\s*([^;]+)/g;
function $06914c5d06679353$export$fe87bb5193f3e70(rawString, name) {
    $06914c5d06679353$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var match = $06914c5d06679353$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            if (match[1] === name) return match[2];
        } else break;
    }
}
function $06914c5d06679353$export$58032b923d63748e(rawString) {
    var result = new Map();
    $06914c5d06679353$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var match = $06914c5d06679353$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) result.set(match[1], match[2]);
        else break;
    }
    return result;
}
function $06914c5d06679353$export$b26462d2f74496cd(candidate, length, suffix) {
    if (suffix === void 0) suffix = "";
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) return candidate;
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}

});


parcelRegister("cgPDT", function(module, exports) {

$parcel$export(module.exports, "validateAndBuildConfiguration", () => $8eef09bfc51d7f9b$export$bb3dd6b9741fea90);
$parcel$export(module.exports, "serializeConfiguration", () => $8eef09bfc51d7f9b$export$948cb0730656da11);

var $impqY = parcelRequire("impqY");

var $gqtZo = parcelRequire("gqtZo");

var $ayJ3T = parcelRequire("ayJ3T");

var $kklrV = parcelRequire("kklrV");

var $i44dp = parcelRequire("i44dp");

var $3EczY = parcelRequire("3EczY");

var $3h3z3 = parcelRequire("3h3z3");

var $iD7Tb = parcelRequire("iD7Tb");

var $8qPJm = parcelRequire("8qPJm");

var $bxRq9 = parcelRequire("bxRq9");

var $lah1R = parcelRequire("lah1R");
var $8eef09bfc51d7f9b$export$e8c12a778f5ad67c = {
    ALLOW: "allow",
    MASK: "mask",
    MASK_USER_INPUT: "mask-user-input"
};
var $8eef09bfc51d7f9b$export$d060b603b6f9a5d5 = {
    ALL: "all",
    SAMPLED: "sampled"
};
function $8eef09bfc51d7f9b$export$bb3dd6b9741fea90(initConfiguration) {
    var _a, _b, _c, _d;
    if (!initConfiguration || !initConfiguration.clientToken) {
        (0, $gqtZo.display).error("Client Token is not configured, we will not send any data.");
        return;
    }
    if (initConfiguration.sessionSampleRate !== undefined && !(0, $i44dp.isPercentage)(initConfiguration.sessionSampleRate)) {
        (0, $gqtZo.display).error("Session Sample Rate should be a number between 0 and 100");
        return;
    }
    if (initConfiguration.telemetrySampleRate !== undefined && !(0, $i44dp.isPercentage)(initConfiguration.telemetrySampleRate)) {
        (0, $gqtZo.display).error("Telemetry Sample Rate should be a number between 0 and 100");
        return;
    }
    if (initConfiguration.telemetryConfigurationSampleRate !== undefined && !(0, $i44dp.isPercentage)(initConfiguration.telemetryConfigurationSampleRate)) {
        (0, $gqtZo.display).error("Telemetry Configuration Sample Rate should be a number between 0 and 100");
        return;
    }
    if (initConfiguration.trackingConsent !== undefined && !(0, $3h3z3.objectHasValue)((0, $bxRq9.TrackingConsent), initConfiguration.trackingConsent)) {
        (0, $gqtZo.display).error('Tracking Consent should be either "granted" or "not-granted"');
        return;
    }
    // Set the experimental feature flags as early as possible, so we can use them in most places
    if (Array.isArray(initConfiguration.enableExperimentalFeatures)) (0, $ayJ3T.addExperimentalFeatures)(initConfiguration.enableExperimentalFeatures.filter(function(flag) {
        return (0, $3h3z3.objectHasValue)((0, $ayJ3T.ExperimentalFeature), flag);
    }));
    return (0, $iD7Tb.assign)({
        beforeSend: initConfiguration.beforeSend && (0, $impqY.catchUserErrors)(initConfiguration.beforeSend, "beforeSend threw an error:"),
        sessionStoreStrategyType: (0, $8qPJm.selectSessionStoreStrategyType)(initConfiguration),
        sessionSampleRate: (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        service: initConfiguration.service,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        allowUntrustedEvents: !!initConfiguration.allowUntrustedEvents,
        trackingConsent: (_d = initConfiguration.trackingConsent) !== null && _d !== void 0 ? _d : (0, $bxRq9.TrackingConsent).GRANTED,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */ batchBytesLimit: 16 * (0, $3EczY.ONE_KIBI_BYTE),
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */ flushTimeout: 30 * (0, $kklrV.ONE_SECOND),
        /**
         * Logs intake limit
         */ batchMessagesLimit: 50,
        messageBytesLimit: 256 * (0, $3EczY.ONE_KIBI_BYTE)
    }, (0, $lah1R.computeTransportConfiguration)(initConfiguration));
}
function $8eef09bfc51d7f9b$export$948cb0730656da11(initConfiguration) {
    return {
        session_sample_rate: initConfiguration.sessionSampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_cross_site_session_cookie: initConfiguration.useCrossSiteSessionCookie,
        use_partitioned_cross_site_session_cookie: initConfiguration.usePartitionedCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: !!initConfiguration.proxy,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
        store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
        allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
        tracking_consent: initConfiguration.trackingConsent
    };
}

});
parcelRegister("ayJ3T", function(module, exports) {

$parcel$export(module.exports, "ExperimentalFeature", () => $7b0008af97723d06$export$8c1a7666d5772525);
$parcel$export(module.exports, "addExperimentalFeatures", () => $7b0008af97723d06$export$6d36e587aa761763);
$parcel$export(module.exports, "isExperimentalFeatureEnabled", () => $7b0008af97723d06$export$ada3eaf101ef7eb6);
$parcel$export(module.exports, "getExperimentalFeatures", () => $7b0008af97723d06$export$45a70c97bd86e1c8);
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */ // We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag
// eslint-disable-next-line no-restricted-syntax
var $7b0008af97723d06$export$8c1a7666d5772525;
(function(ExperimentalFeature) {
    ExperimentalFeature["PAGEHIDE"] = "pagehide";
    ExperimentalFeature["FEATURE_FLAGS"] = "feature_flags";
    ExperimentalFeature["RESOURCE_PAGE_STATES"] = "resource_page_states";
    ExperimentalFeature["COLLECT_FLUSH_REASON"] = "collect_flush_reason";
    ExperimentalFeature["ZERO_LCP_TELEMETRY"] = "zero_lcp_telemetry";
    ExperimentalFeature["DISABLE_REPLAY_INLINE_CSS"] = "disable_replay_inline_css";
    ExperimentalFeature["WRITABLE_RESOURCE_GRAPHQL"] = "writable_resource_graphql";
    ExperimentalFeature["CUSTOM_VITALS"] = "custom_vitals";
})($7b0008af97723d06$export$8c1a7666d5772525 || ($7b0008af97723d06$export$8c1a7666d5772525 = {}));
var $7b0008af97723d06$var$enabledExperimentalFeatures = new Set();
function $7b0008af97723d06$export$6d36e587aa761763(enabledFeatures) {
    enabledFeatures.forEach(function(flag) {
        $7b0008af97723d06$var$enabledExperimentalFeatures.add(flag);
    });
}
function $7b0008af97723d06$export$ada3eaf101ef7eb6(featureName) {
    return $7b0008af97723d06$var$enabledExperimentalFeatures.has(featureName);
}
function $7b0008af97723d06$export$4248398637d8b60d() {
    $7b0008af97723d06$var$enabledExperimentalFeatures.clear();
}
function $7b0008af97723d06$export$45a70c97bd86e1c8() {
    return $7b0008af97723d06$var$enabledExperimentalFeatures;
}

});

parcelRegister("8qPJm", function(module, exports) {

$parcel$export(module.exports, "selectSessionStoreStrategyType", () => $6238e11543f4e04b$export$2ae22598cc9269e0);
$parcel$export(module.exports, "startSessionStore", () => $6238e11543f4e04b$export$99eabf0f32a21670);

var $kiWyZ = parcelRequire("kiWyZ");

var $3jm7f = parcelRequire("3jm7f");

var $kklrV = parcelRequire("kklrV");

var $dBtKo = parcelRequire("dBtKo");

var $yXsvp = parcelRequire("yXsvp");

var $a6Vhx = parcelRequire("a6Vhx");

var $7ycc4 = parcelRequire("7ycc4");

var $2wB0t = parcelRequire("2wB0t");

var $7v2ct = parcelRequire("7v2ct");
var $6238e11543f4e04b$export$97790393ff416f6c = (0, $kklrV.ONE_SECOND);
function $6238e11543f4e04b$export$2ae22598cc9269e0(initConfiguration) {
    var sessionStoreStrategyType = (0, $7ycc4.selectCookieStrategy)(initConfiguration);
    if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) sessionStoreStrategyType = (0, $2wB0t.selectLocalStorageStrategy)();
    return sessionStoreStrategyType;
}
function $6238e11543f4e04b$export$99eabf0f32a21670(sessionStoreStrategyType, productKey, computeSessionState) {
    var renewObservable = new (0, $3jm7f.Observable)();
    var expireObservable = new (0, $3jm7f.Observable)();
    var sessionStoreStrategy = sessionStoreStrategyType.type === "Cookie" ? (0, $7ycc4.initCookieStrategy)(sessionStoreStrategyType.cookieOptions) : (0, $2wB0t.initLocalStorageStrategy)();
    var clearSession = sessionStoreStrategy.clearSession, retrieveSession = sessionStoreStrategy.retrieveSession;
    var watchSessionTimeoutId = (0, $kiWyZ.setInterval)(watchSession, $6238e11543f4e04b$export$97790393ff416f6c);
    var sessionCache = retrieveActiveSession();
    var _a = (0, $dBtKo.throttle)(function() {
        var isTracked;
        (0, $7v2ct.processSessionStoreOperations)({
            process: function(sessionState) {
                var synchronizedSession = synchronizeSession(sessionState);
                isTracked = expandOrRenewSessionState(synchronizedSession);
                return synchronizedSession;
            },
            after: function(sessionState) {
                if (isTracked && !hasSessionInCache()) renewSessionInCache(sessionState);
                sessionCache = sessionState;
            }
        }, sessionStoreStrategy);
    }, $6238e11543f4e04b$export$97790393ff416f6c), throttledExpandOrRenewSession = _a.throttled, cancelExpandOrRenewSession = _a.cancel;
    function expandSession() {
        (0, $7v2ct.processSessionStoreOperations)({
            process: function(sessionState) {
                return hasSessionInCache() ? synchronizeSession(sessionState) : undefined;
            }
        }, sessionStoreStrategy);
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session store
     * - if the session is not active, clear the session store and expire the session cache
     */ function watchSession() {
        (0, $7v2ct.processSessionStoreOperations)({
            process: function(sessionState) {
                return !isActiveSession(sessionState) ? {} : undefined;
            },
            after: synchronizeSession
        }, sessionStoreStrategy);
    }
    function synchronizeSession(sessionState) {
        if (!isActiveSession(sessionState)) sessionState = {};
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(sessionState)) expireSessionInCache();
            else sessionCache = sessionState;
        }
        return sessionState;
    }
    function expandOrRenewSessionState(sessionState) {
        var _a = computeSessionState(sessionState[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        sessionState[productKey] = trackingType;
        if (isTracked && !sessionState.id) {
            sessionState.id = (0, $yXsvp.generateUUID)();
            sessionState.created = String((0, $kklrV.dateNow)());
        }
        return isTracked;
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(sessionState) {
        return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
    }
    function expireSessionInCache() {
        sessionCache = {};
        expireObservable.notify();
    }
    function renewSessionInCache(sessionState) {
        sessionCache = sessionState;
        renewObservable.notify();
    }
    function retrieveActiveSession() {
        var session = retrieveSession();
        if (isActiveSession(session)) return session;
        return {};
    }
    function isActiveSession(sessionState) {
        // created and expire can be undefined for versions which was not storing them
        // these checks could be removed when older versions will not be available/live anymore
        return (sessionState.created === undefined || (0, $kklrV.dateNow)() - Number(sessionState.created) < (0, $a6Vhx.SESSION_TIME_OUT_DELAY)) && (sessionState.expire === undefined || (0, $kklrV.dateNow)() < Number(sessionState.expire));
    }
    return {
        expandOrRenewSession: throttledExpandOrRenewSession,
        expandSession: expandSession,
        getSession: function() {
            return sessionCache;
        },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        expire: function() {
            cancelExpandOrRenewSession();
            clearSession();
            synchronizeSession({});
        },
        stop: function() {
            (0, $kiWyZ.clearInterval)(watchSessionTimeoutId);
        }
    };
}

});
parcelRegister("a6Vhx", function(module, exports) {

$parcel$export(module.exports, "SESSION_TIME_OUT_DELAY", () => $75c6e5ed03122e95$export$324def7afe89d7e8);
$parcel$export(module.exports, "SESSION_EXPIRATION_DELAY", () => $75c6e5ed03122e95$export$481fdd126dba0912);

var $kklrV = parcelRequire("kklrV");
var $75c6e5ed03122e95$export$324def7afe89d7e8 = 4 * (0, $kklrV.ONE_HOUR);
var $75c6e5ed03122e95$export$481fdd126dba0912 = 15 * (0, $kklrV.ONE_MINUTE);

});

parcelRegister("7ycc4", function(module, exports) {

$parcel$export(module.exports, "selectCookieStrategy", () => $57f52ac5f672db07$export$88fc2ec23ae4ccfd);
$parcel$export(module.exports, "initCookieStrategy", () => $57f52ac5f672db07$export$96a0082cb9ded337);

var $hG3O4 = parcelRequire("hG3O4");

var $80vso = parcelRequire("80vso");

var $e79rA = parcelRequire("e79rA");

var $a6Vhx = parcelRequire("a6Vhx");

var $2O6RC = parcelRequire("2O6RC");

var $9jC8p = parcelRequire("9jC8p");
function $57f52ac5f672db07$export$88fc2ec23ae4ccfd(initConfiguration) {
    var cookieOptions = $57f52ac5f672db07$export$d037e740f60b1dc5(initConfiguration);
    return (0, $80vso.areCookiesAuthorized)(cookieOptions) ? {
        type: "Cookie",
        cookieOptions: cookieOptions
    } : undefined;
}
function $57f52ac5f672db07$export$96a0082cb9ded337(cookieOptions) {
    var cookieStore = {
        /**
         * Lock strategy allows mitigating issues due to concurrent access to cookie.
         * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
         */ isLockEnabled: (0, $hG3O4.isChromium)(),
        persistSession: $57f52ac5f672db07$var$persistSessionCookie(cookieOptions),
        retrieveSession: $57f52ac5f672db07$var$retrieveSessionCookie,
        clearSession: $57f52ac5f672db07$var$deleteSessionCookie(cookieOptions)
    };
    (0, $e79rA.tryOldCookiesMigration)(cookieStore);
    return cookieStore;
}
function $57f52ac5f672db07$var$persistSessionCookie(options) {
    return function(session) {
        (0, $80vso.setCookie)((0, $9jC8p.SESSION_STORE_KEY), (0, $2O6RC.toSessionString)(session), (0, $a6Vhx.SESSION_EXPIRATION_DELAY), options);
    };
}
function $57f52ac5f672db07$var$retrieveSessionCookie() {
    var sessionString = (0, $80vso.getCookie)((0, $9jC8p.SESSION_STORE_KEY));
    return (0, $2O6RC.toSessionState)(sessionString);
}
function $57f52ac5f672db07$var$deleteSessionCookie(options) {
    return function() {
        (0, $80vso.deleteCookie)((0, $9jC8p.SESSION_STORE_KEY), options);
    };
}
function $57f52ac5f672db07$export$d037e740f60b1dc5(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = !!initConfiguration.useSecureSessionCookie || !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.crossSite = !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.partitioned = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) cookieOptions.domain = (0, $80vso.getCurrentSite)();
    return cookieOptions;
}

});
parcelRegister("hG3O4", function(module, exports) {

$parcel$export(module.exports, "isChromium", () => $cde94fccbe0b4623$export$dd401a4677e99039);
function $cde94fccbe0b4623$export$7e7b1a9668aaed8() {
    return $cde94fccbe0b4623$var$detectBrowserCached() === 0 /* Browser.IE */ ;
}
function $cde94fccbe0b4623$export$dd401a4677e99039() {
    return $cde94fccbe0b4623$var$detectBrowserCached() === 1 /* Browser.CHROMIUM */ ;
}
function $cde94fccbe0b4623$export$95df08bae54cb4df() {
    return $cde94fccbe0b4623$var$detectBrowserCached() === 2 /* Browser.SAFARI */ ;
}
var $cde94fccbe0b4623$var$browserCache;
function $cde94fccbe0b4623$var$detectBrowserCached() {
    return $cde94fccbe0b4623$var$browserCache !== null && $cde94fccbe0b4623$var$browserCache !== void 0 ? $cde94fccbe0b4623$var$browserCache : $cde94fccbe0b4623$var$browserCache = $cde94fccbe0b4623$export$2d31490a0c05f094();
}
function $cde94fccbe0b4623$export$2d31490a0c05f094(browserWindow) {
    var _a;
    if (browserWindow === void 0) browserWindow = window;
    var userAgent = browserWindow.navigator.userAgent;
    if (browserWindow.chrome || /HeadlessChrome/.test(userAgent)) return 1 /* Browser.CHROMIUM */ ;
    if (// navigator.vendor is deprecated, but it is the most resilient way we found to detect
    // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
    // useragent test as a semi-working fallback.
    ((_a = browserWindow.navigator.vendor) === null || _a === void 0 ? void 0 : _a.indexOf("Apple")) === 0 || /safari/i.test(userAgent) && !/chrome|android/i.test(userAgent)) return 2 /* Browser.SAFARI */ ;
    if (browserWindow.document.documentMode) return 0 /* Browser.IE */ ;
    return 3 /* Browser.OTHER */ ;
}

});

parcelRegister("80vso", function(module, exports) {

$parcel$export(module.exports, "setCookie", () => $018124062f6ef84d$export$110700823644f4a6);
$parcel$export(module.exports, "getCookie", () => $018124062f6ef84d$export$4be65e66cfa2648a);
$parcel$export(module.exports, "getInitCookie", () => $018124062f6ef84d$export$379e6c34a14280ba);
$parcel$export(module.exports, "deleteCookie", () => $018124062f6ef84d$export$b43e45590305ffaa);
$parcel$export(module.exports, "areCookiesAuthorized", () => $018124062f6ef84d$export$29b13dee24cadcda);
$parcel$export(module.exports, "getCurrentSite", () => $018124062f6ef84d$export$8d7fb5ac3c42095);

var $gqtZo = parcelRequire("gqtZo");

var $kklrV = parcelRequire("kklrV");

var $yXsvp = parcelRequire("yXsvp");
function $018124062f6ef84d$export$110700823644f4a6(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? "none" : "strict";
    var domain = options && options.domain ? ";domain=".concat(options.domain) : "";
    var secure = options && options.secure ? ";secure" : "";
    var partitioned = options && options.partitioned ? ";partitioned" : "";
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure).concat(partitioned);
}
function $018124062f6ef84d$export$4be65e66cfa2648a(name) {
    return (0, $yXsvp.findCommaSeparatedValue)(document.cookie, name);
}
var $018124062f6ef84d$var$initCookieParsed;
function $018124062f6ef84d$export$379e6c34a14280ba(name) {
    if (!$018124062f6ef84d$var$initCookieParsed) $018124062f6ef84d$var$initCookieParsed = (0, $yXsvp.findCommaSeparatedValues)(document.cookie);
    return $018124062f6ef84d$var$initCookieParsed.get(name);
}
function $018124062f6ef84d$export$c97a852288b43516() {
    $018124062f6ef84d$var$initCookieParsed = undefined;
}
function $018124062f6ef84d$export$b43e45590305ffaa(name, options) {
    $018124062f6ef84d$export$110700823644f4a6(name, "", 0, options);
}
function $018124062f6ef84d$export$29b13dee24cadcda(options) {
    if (document.cookie === undefined || document.cookie === null) return false;
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat((0, $yXsvp.generateUUID)());
        var testCookieValue = "test";
        $018124062f6ef84d$export$110700823644f4a6(testCookieName, testCookieValue, (0, $kklrV.ONE_MINUTE), options);
        var isCookieCorrectlySet = $018124062f6ef84d$export$4be65e66cfa2648a(testCookieName) === testCookieValue;
        $018124062f6ef84d$export$b43e45590305ffaa(testCookieName, options);
        return isCookieCorrectlySet;
    } catch (error) {
        (0, $gqtZo.display).error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */ var $018124062f6ef84d$var$getCurrentSiteCache;
function $018124062f6ef84d$export$8d7fb5ac3c42095() {
    if ($018124062f6ef84d$var$getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat((0, $yXsvp.generateUUID)());
        var testCookieValue = "test";
        var domainLevels = window.location.hostname.split(".");
        var candidateDomain = domainLevels.pop();
        while(domainLevels.length && !$018124062f6ef84d$export$4be65e66cfa2648a(testCookieName)){
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            $018124062f6ef84d$export$110700823644f4a6(testCookieName, testCookieValue, (0, $kklrV.ONE_SECOND), {
                domain: candidateDomain
            });
        }
        $018124062f6ef84d$export$b43e45590305ffaa(testCookieName, {
            domain: candidateDomain
        });
        $018124062f6ef84d$var$getCurrentSiteCache = candidateDomain;
    }
    return $018124062f6ef84d$var$getCurrentSiteCache;
}

});

parcelRegister("e79rA", function(module, exports) {

$parcel$export(module.exports, "tryOldCookiesMigration", () => $a4690b8450fb57ca$export$308239c26bbf40d4);

var $80vso = parcelRequire("80vso");

var $9jC8p = parcelRequire("9jC8p");

var $2O6RC = parcelRequire("2O6RC");
var $a4690b8450fb57ca$export$9b0bbb4e1ef88c6d = "_dd";
var $a4690b8450fb57ca$export$4231281e64250ad5 = "_dd_r";
var $a4690b8450fb57ca$export$381d62e3ee200c01 = "_dd_l";
var $a4690b8450fb57ca$export$50ae25e0cd1ada34 = "rum";
var $a4690b8450fb57ca$export$c47fdbea9837fd34 = "logs";
function $a4690b8450fb57ca$export$308239c26bbf40d4(cookieStoreStrategy) {
    var sessionString = (0, $80vso.getInitCookie)((0, $9jC8p.SESSION_STORE_KEY));
    if (!sessionString) {
        var oldSessionId = (0, $80vso.getInitCookie)($a4690b8450fb57ca$export$9b0bbb4e1ef88c6d);
        var oldRumType = (0, $80vso.getInitCookie)($a4690b8450fb57ca$export$4231281e64250ad5);
        var oldLogsType = (0, $80vso.getInitCookie)($a4690b8450fb57ca$export$381d62e3ee200c01);
        var session = {};
        if (oldSessionId) session.id = oldSessionId;
        if (oldLogsType && /^[01]$/.test(oldLogsType)) session[$a4690b8450fb57ca$export$c47fdbea9837fd34] = oldLogsType;
        if (oldRumType && /^[012]$/.test(oldRumType)) session[$a4690b8450fb57ca$export$50ae25e0cd1ada34] = oldRumType;
        if (!(0, $2O6RC.isSessionInExpiredState)(session)) {
            (0, $2O6RC.expandSessionState)(session);
            cookieStoreStrategy.persistSession(session);
        }
    }
}

});
parcelRegister("9jC8p", function(module, exports) {

$parcel$export(module.exports, "SESSION_STORE_KEY", () => $6c83782198af3cca$export$dce9f2ddeb0efe71);
var $6c83782198af3cca$export$dce9f2ddeb0efe71 = "_dd_s";

});

parcelRegister("2O6RC", function(module, exports) {

$parcel$export(module.exports, "isSessionInExpiredState", () => $20b5934590cb2b45$export$7b5aaa833707368f);
$parcel$export(module.exports, "expandSessionState", () => $20b5934590cb2b45$export$112e1a1467f7ca28);
$parcel$export(module.exports, "toSessionString", () => $20b5934590cb2b45$export$df489f56daf61eef);
$parcel$export(module.exports, "toSessionState", () => $20b5934590cb2b45$export$fa3c08092be8a0e4);

var $3h3z3 = parcelRequire("3h3z3");

var $iD7Tb = parcelRequire("iD7Tb");

var $kklrV = parcelRequire("kklrV");

var $a6Vhx = parcelRequire("a6Vhx");
var $20b5934590cb2b45$var$SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var $20b5934590cb2b45$var$SESSION_ENTRY_SEPARATOR = "&";
function $20b5934590cb2b45$export$7b5aaa833707368f(session) {
    return (0, $3h3z3.isEmptyObject)(session);
}
function $20b5934590cb2b45$export$112e1a1467f7ca28(session) {
    session.expire = String((0, $kklrV.dateNow)() + (0, $a6Vhx.SESSION_EXPIRATION_DELAY));
}
function $20b5934590cb2b45$export$df489f56daf61eef(session) {
    return (0, $iD7Tb.objectEntries)(session).map(function(_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    }).join($20b5934590cb2b45$var$SESSION_ENTRY_SEPARATOR);
}
function $20b5934590cb2b45$export$fa3c08092be8a0e4(sessionString) {
    var session = {};
    if ($20b5934590cb2b45$var$isValidSessionString(sessionString)) sessionString.split($20b5934590cb2b45$var$SESSION_ENTRY_SEPARATOR).forEach(function(entry) {
        var matches = $20b5934590cb2b45$var$SESSION_ENTRY_REGEXP.exec(entry);
        if (matches !== null) {
            var key = matches[1], value = matches[2];
            session[key] = value;
        }
    });
    return session;
}
function $20b5934590cb2b45$var$isValidSessionString(sessionString) {
    return !!sessionString && (sessionString.indexOf($20b5934590cb2b45$var$SESSION_ENTRY_SEPARATOR) !== -1 || $20b5934590cb2b45$var$SESSION_ENTRY_REGEXP.test(sessionString));
}

});



parcelRegister("2wB0t", function(module, exports) {

$parcel$export(module.exports, "selectLocalStorageStrategy", () => $1d6b46ae6946dc0f$export$4d20c6f83e85c567);
$parcel$export(module.exports, "initLocalStorageStrategy", () => $1d6b46ae6946dc0f$export$f96a432ca80663c2);

var $yXsvp = parcelRequire("yXsvp");

var $2O6RC = parcelRequire("2O6RC");

var $9jC8p = parcelRequire("9jC8p");
var $1d6b46ae6946dc0f$var$LOCAL_STORAGE_TEST_KEY = "_dd_test_";
function $1d6b46ae6946dc0f$export$4d20c6f83e85c567() {
    try {
        var id = (0, $yXsvp.generateUUID)();
        var testKey = "".concat($1d6b46ae6946dc0f$var$LOCAL_STORAGE_TEST_KEY).concat(id);
        localStorage.setItem(testKey, id);
        var retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? {
            type: "LocalStorage"
        } : undefined;
    } catch (e) {
        return undefined;
    }
}
function $1d6b46ae6946dc0f$export$f96a432ca80663c2() {
    return {
        isLockEnabled: false,
        persistSession: $1d6b46ae6946dc0f$var$persistInLocalStorage,
        retrieveSession: $1d6b46ae6946dc0f$var$retrieveSessionFromLocalStorage,
        clearSession: $1d6b46ae6946dc0f$var$clearSessionFromLocalStorage
    };
}
function $1d6b46ae6946dc0f$var$persistInLocalStorage(sessionState) {
    localStorage.setItem((0, $9jC8p.SESSION_STORE_KEY), (0, $2O6RC.toSessionString)(sessionState));
}
function $1d6b46ae6946dc0f$var$retrieveSessionFromLocalStorage() {
    var sessionString = localStorage.getItem((0, $9jC8p.SESSION_STORE_KEY));
    return (0, $2O6RC.toSessionState)(sessionString);
}
function $1d6b46ae6946dc0f$var$clearSessionFromLocalStorage() {
    localStorage.removeItem((0, $9jC8p.SESSION_STORE_KEY));
}

});

parcelRegister("7v2ct", function(module, exports) {

$parcel$export(module.exports, "processSessionStoreOperations", () => $575d228c777f7a09$export$5efeffeb1c7b84cb);

var $kiWyZ = parcelRequire("kiWyZ");

var $yXsvp = parcelRequire("yXsvp");

var $2O6RC = parcelRequire("2O6RC");
var $575d228c777f7a09$export$af5f677cffbf8829 = 10;
var $575d228c777f7a09$export$63e0e5fbdb17b26 = 100;
var $575d228c777f7a09$var$bufferedOperations = [];
var $575d228c777f7a09$var$ongoingOperations;
function $575d228c777f7a09$export$5efeffeb1c7b84cb(operations, sessionStoreStrategy, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) numberOfRetries = 0;
    var isLockEnabled = sessionStoreStrategy.isLockEnabled, retrieveSession = sessionStoreStrategy.retrieveSession, persistSession = sessionStoreStrategy.persistSession, clearSession = sessionStoreStrategy.clearSession;
    if (!$575d228c777f7a09$var$ongoingOperations) $575d228c777f7a09$var$ongoingOperations = operations;
    if (operations !== $575d228c777f7a09$var$ongoingOperations) {
        $575d228c777f7a09$var$bufferedOperations.push(operations);
        return;
    }
    if (isLockEnabled && numberOfRetries >= $575d228c777f7a09$export$63e0e5fbdb17b26) {
        $575d228c777f7a09$var$next(sessionStoreStrategy);
        return;
    }
    var currentLock;
    var currentSession = retrieveSession();
    if (isLockEnabled) {
        // if someone has lock, retry later
        if (currentSession.lock) {
            $575d228c777f7a09$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = (0, $yXsvp.generateUUID)();
        currentSession.lock = currentLock;
        persistSession(currentSession);
        // if lock is not acquired, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            $575d228c777f7a09$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentSession);
    if (isLockEnabled) {
        // if lock corrupted after process, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            $575d228c777f7a09$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        if ((0, $2O6RC.isSessionInExpiredState)(processedSession)) clearSession();
        else {
            (0, $2O6RC.expandSessionState)(processedSession);
            persistSession(processedSession);
        }
    }
    if (isLockEnabled) // correctly handle lock around expiration would require to handle this case properly at several levels
    // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
    {
        if (!(processedSession && (0, $2O6RC.isSessionInExpiredState)(processedSession))) {
            // if lock corrupted after persist, retry later
            currentSession = retrieveSession();
            if (currentSession.lock !== currentLock) {
                $575d228c777f7a09$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
                return;
            }
            delete currentSession.lock;
            persistSession(currentSession);
            processedSession = currentSession;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date session state value => the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 || _a.call(operations, processedSession || currentSession);
    $575d228c777f7a09$var$next(sessionStoreStrategy);
}
function $575d228c777f7a09$var$retryLater(operations, sessionStore, currentNumberOfRetries) {
    (0, $kiWyZ.setTimeout)(function() {
        $575d228c777f7a09$export$5efeffeb1c7b84cb(operations, sessionStore, currentNumberOfRetries + 1);
    }, $575d228c777f7a09$export$af5f677cffbf8829);
}
function $575d228c777f7a09$var$next(sessionStore) {
    $575d228c777f7a09$var$ongoingOperations = undefined;
    var nextOperations = $575d228c777f7a09$var$bufferedOperations.shift();
    if (nextOperations) $575d228c777f7a09$export$5efeffeb1c7b84cb(nextOperations, sessionStore);
}

});


parcelRegister("lah1R", function(module, exports) {

$parcel$export(module.exports, "computeTransportConfiguration", () => $f687bdc4f25e91fc$export$2cf2d9e8f31925e6);

var $iD7Tb = parcelRequire("iD7Tb");

var $cEoM2 = parcelRequire("cEoM2");

var $cAQEz = parcelRequire("cAQEz");

var $cwLk7 = parcelRequire("cwLk7");
function $f687bdc4f25e91fc$export$2cf2d9e8f31925e6(initConfiguration) {
    var site = initConfiguration.site || (0, $cwLk7.INTAKE_SITE_US1);
    var tags = (0, $cAQEz.buildTags)(initConfiguration);
    var endpointBuilders = $f687bdc4f25e91fc$var$computeEndpointBuilders(initConfiguration, tags);
    var intakeUrlPrefixes = $f687bdc4f25e91fc$var$computeIntakeUrlPrefixes(endpointBuilders, site);
    var replicaConfiguration = $f687bdc4f25e91fc$var$computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
    return (0, $iD7Tb.assign)({
        isIntakeUrl: function(url) {
            return intakeUrlPrefixes.some(function(intakeEndpoint) {
                return url.indexOf(intakeEndpoint) === 0;
            });
        },
        replica: replicaConfiguration,
        site: site
    }, endpointBuilders);
}
function $f687bdc4f25e91fc$var$computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: (0, $cEoM2.createEndpointBuilder)(initConfiguration, "logs", tags),
        rumEndpointBuilder: (0, $cEoM2.createEndpointBuilder)(initConfiguration, "rum", tags),
        sessionReplayEndpointBuilder: (0, $cEoM2.createEndpointBuilder)(initConfiguration, "replay", tags)
    };
}
function $f687bdc4f25e91fc$var$computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
    if (!initConfiguration.replica) return;
    var replicaConfiguration = (0, $iD7Tb.assign)({}, initConfiguration, {
        site: (0, $cwLk7.INTAKE_SITE_US1),
        clientToken: initConfiguration.replica.clientToken
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: (0, $cEoM2.createEndpointBuilder)(replicaConfiguration, "logs", tags),
        rumEndpointBuilder: (0, $cEoM2.createEndpointBuilder)(replicaConfiguration, "rum", tags)
    };
    intakeUrlPrefixes.push.apply(intakeUrlPrefixes, (0, $iD7Tb.objectValues)(replicaEndpointBuilders).map(function(builder) {
        return builder.urlPrefix;
    }));
    return (0, $iD7Tb.assign)({
        applicationId: initConfiguration.replica.applicationId
    }, replicaEndpointBuilders);
}
function $f687bdc4f25e91fc$var$computeIntakeUrlPrefixes(endpointBuilders, site) {
    var intakeUrlPrefixes = (0, $iD7Tb.objectValues)(endpointBuilders).map(function(builder) {
        return builder.urlPrefix;
    });
    if (site === (0, $cwLk7.INTAKE_SITE_US1)) intakeUrlPrefixes.push("https://".concat((0, $cwLk7.PCI_INTAKE_HOST_US1), "/"));
    return intakeUrlPrefixes;
}

});
parcelRegister("cEoM2", function(module, exports) {

$parcel$export(module.exports, "createEndpointBuilder", () => $935c7007aed32784$export$b84621d9b3dd3f17);

var $kklrV = parcelRequire("kklrV");

var $ddsGY = parcelRequire("ddsGY");

var $ayJ3T = parcelRequire("ayJ3T");

var $yXsvp = parcelRequire("yXsvp");

var $cwLk7 = parcelRequire("cwLk7");
function $935c7007aed32784$export$b84621d9b3dd3f17(initConfiguration, trackType, configurationTags) {
    var buildUrlWithParameters = $935c7007aed32784$var$createEndpointUrlWithParametersBuilder(initConfiguration, trackType);
    return {
        build: function(api, payload) {
            var parameters = $935c7007aed32784$var$buildEndpointParameters(initConfiguration, trackType, configurationTags, api, payload);
            return buildUrlWithParameters(parameters);
        },
        urlPrefix: buildUrlWithParameters(""),
        trackType: trackType
    };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */ function $935c7007aed32784$var$createEndpointUrlWithParametersBuilder(initConfiguration, trackType) {
    var path = "/api/v2/".concat(trackType);
    var proxy = initConfiguration.proxy;
    if (typeof proxy === "string") {
        var normalizedProxyUrl_1 = (0, $ddsGY.normalizeUrl)(proxy);
        return function(parameters) {
            return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters)));
        };
    }
    if (typeof proxy === "function") return function(parameters) {
        return proxy({
            path: path,
            parameters: parameters
        });
    };
    var host = $935c7007aed32784$var$buildEndpointHost(trackType, initConfiguration);
    return function(parameters) {
        return "https://".concat(host).concat(path, "?").concat(parameters);
    };
}
function $935c7007aed32784$var$buildEndpointHost(trackType, initConfiguration) {
    var _a = initConfiguration.site, site = _a === void 0 ? (0, $cwLk7.INTAKE_SITE_US1) : _a, internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
    if (trackType === "logs" && initConfiguration.usePciIntake && site === (0, $cwLk7.INTAKE_SITE_US1)) return 0, $cwLk7.PCI_INTAKE_HOST_US1;
    if (internalAnalyticsSubdomain && site === (0, $cwLk7.INTAKE_SITE_US1)) return "".concat(internalAnalyticsSubdomain, ".").concat((0, $cwLk7.INTAKE_SITE_US1));
    if (site === (0, $cwLk7.INTAKE_SITE_FED_STAGING)) return "http-intake.logs.".concat(site);
    var domainParts = site.split(".");
    var extension = domainParts.pop();
    return "browser-intake-".concat(domainParts.join("-"), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */ function $935c7007aed32784$var$buildEndpointParameters(_a, trackType, configurationTags, api, _b) {
    var clientToken = _a.clientToken, internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
    var retry = _b.retry, flushReason = _b.flushReason, encoding = _b.encoding;
    var tags = [
        "sdk_version:".concat("5.15.0"),
        "api:".concat(api)
    ].concat(configurationTags);
    if (flushReason && (0, $ayJ3T.isExperimentalFeatureEnabled)((0, $ayJ3T.ExperimentalFeature).COLLECT_FLUSH_REASON)) tags.push("flush_reason:".concat(flushReason));
    if (retry) tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
    var parameters = [
        "ddsource=browser",
        "ddtags=".concat(encodeURIComponent(tags.join(","))),
        "dd-api-key=".concat(clientToken),
        "dd-evp-origin-version=".concat(encodeURIComponent("5.15.0")),
        "dd-evp-origin=browser",
        "dd-request-id=".concat((0, $yXsvp.generateUUID)())
    ];
    if (encoding) parameters.push("dd-evp-encoding=".concat(encoding));
    if (trackType === "rum") parameters.push("batch_time=".concat((0, $kklrV.timeStampNow)()));
    if (internalAnalyticsSubdomain) parameters.reverse();
    return parameters.join("&");
}

});
parcelRegister("ddsGY", function(module, exports) {

$parcel$export(module.exports, "normalizeUrl", () => $99f2bee9f3dc32f8$export$6535eb414fa2c8b6);

var $gS5dB = parcelRequire("gS5dB");
function $99f2bee9f3dc32f8$export$6535eb414fa2c8b6(url) {
    return $99f2bee9f3dc32f8$export$b5cd97dee32de81d(url, location.href).href;
}
function $99f2bee9f3dc32f8$export$bef94a5618bf18bf(url) {
    try {
        return !!$99f2bee9f3dc32f8$export$b5cd97dee32de81d(url);
    } catch (_a) {
        return false;
    }
}
function $99f2bee9f3dc32f8$export$ba1b94ff70383687(url) {
    var pathname = $99f2bee9f3dc32f8$export$b5cd97dee32de81d(url).pathname;
    return pathname[0] === "/" ? pathname : "/".concat(pathname);
}
function $99f2bee9f3dc32f8$export$b5cd97dee32de81d(url, base) {
    var supportedURL = $99f2bee9f3dc32f8$var$getSupportedUrl();
    if (supportedURL) try {
        return base !== undefined ? new supportedURL(url, base) : new supportedURL(url);
    } catch (error) {
        throw new Error("Failed to construct URL: ".concat(String(error), " ").concat((0, $gS5dB.jsonStringify)({
            url: url,
            base: base
        })));
    }
    if (base === undefined && !/:/.test(url)) throw new Error("Invalid URL: '".concat(url, "'"));
    var doc = document;
    var anchorElement = doc.createElement("a");
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument("");
        var baseElement = doc.createElement("base");
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var $99f2bee9f3dc32f8$var$originalURL = URL;
var $99f2bee9f3dc32f8$var$isURLSupported;
function $99f2bee9f3dc32f8$var$getSupportedUrl() {
    if ($99f2bee9f3dc32f8$var$isURLSupported === undefined) try {
        var url = new $99f2bee9f3dc32f8$var$originalURL("http://test/path");
        $99f2bee9f3dc32f8$var$isURLSupported = url.href === "http://test/path";
    } catch (_a) {
        $99f2bee9f3dc32f8$var$isURLSupported = false;
    }
    return $99f2bee9f3dc32f8$var$isURLSupported ? $99f2bee9f3dc32f8$var$originalURL : undefined;
}

});

parcelRegister("cwLk7", function(module, exports) {

$parcel$export(module.exports, "INTAKE_SITE_STAGING", () => $91ed2ea86dd317a4$export$a204b9d5a62f1e2c);
$parcel$export(module.exports, "INTAKE_SITE_FED_STAGING", () => $91ed2ea86dd317a4$export$62cc10d94d5ff7fd);
$parcel$export(module.exports, "INTAKE_SITE_US1", () => $91ed2ea86dd317a4$export$6b79fd7dd2f5fb9a);
$parcel$export(module.exports, "INTAKE_SITE_US1_FED", () => $91ed2ea86dd317a4$export$241ba7106e833c7b);
$parcel$export(module.exports, "PCI_INTAKE_HOST_US1", () => $91ed2ea86dd317a4$export$e02f42b31d885a8c);
var $91ed2ea86dd317a4$export$a204b9d5a62f1e2c = "datad0g.com";
var $91ed2ea86dd317a4$export$62cc10d94d5ff7fd = "dd0g-gov.com";
var $91ed2ea86dd317a4$export$6b79fd7dd2f5fb9a = "datadoghq.com";
var $91ed2ea86dd317a4$export$7452d85ec570d2ea = "datadoghq.eu";
var $91ed2ea86dd317a4$export$241ba7106e833c7b = "ddog-gov.com";
var $91ed2ea86dd317a4$export$e02f42b31d885a8c = "pci.browser-intake-datadoghq.com";

});


parcelRegister("cAQEz", function(module, exports) {

$parcel$export(module.exports, "buildTags", () => $92b1b0aff01108ff$export$ebabee42db672bb6);

var $gqtZo = parcelRequire("gqtZo");
var $92b1b0aff01108ff$export$4f41fac0b8471c73 = 200;
function $92b1b0aff01108ff$export$ebabee42db672bb6(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) tags.push($92b1b0aff01108ff$export$4478cda40be33ba2("env", env));
    if (service) tags.push($92b1b0aff01108ff$export$4478cda40be33ba2("service", service));
    if (version) tags.push($92b1b0aff01108ff$export$4478cda40be33ba2("version", version));
    if (datacenter) tags.push($92b1b0aff01108ff$export$4478cda40be33ba2("datacenter", datacenter));
    return tags;
}
var $92b1b0aff01108ff$var$FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function $92b1b0aff01108ff$export$4478cda40be33ba2(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = $92b1b0aff01108ff$export$4f41fac0b8471c73 - key.length - 1;
    if (rawValue.length > valueSizeLimit || $92b1b0aff01108ff$var$FORBIDDEN_CHARACTERS.test(rawValue)) (0, $gqtZo.display).warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, "_");
    return "".concat(key, ":").concat(sanitizedValue);
}

});






parcelRegister("h0Smi", function(module, exports) {

$parcel$export(module.exports, "startLogs", () => $c62c9a40524e8dee$export$660a5342b09224dc);

var $5Q4S1 = parcelRequire("5Q4S1");
var $aZtSh = parcelRequire("aZtSh");
var $8bRVY = parcelRequire("8bRVY");
var $9fPw5 = parcelRequire("9fPw5");

var $jZy8A = parcelRequire("jZy8A");

var $6PxVO = parcelRequire("6PxVO");

var $5evzm = parcelRequire("5evzm");

var $9lcxI = parcelRequire("9lcxI");

var $iWFqL = parcelRequire("iWFqL");

var $eJIwd = parcelRequire("eJIwd");

var $kyXIx = parcelRequire("kyXIx");

var $7wIAO = parcelRequire("7wIAO");

var $2KImc = parcelRequire("2KImc");

var $fMB8i = parcelRequire("fMB8i");

var $cWqpl = parcelRequire("cWqpl");

var $ax858 = parcelRequire("ax858");

var $9uavD = parcelRequire("9uavD");
function $c62c9a40524e8dee$export$660a5342b09224dc(initConfiguration, configuration, getCommonContext, // `startLogs` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startLogs` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState) {
    var lifeCycle = new (0, $kyXIx.LifeCycle)();
    var cleanupTasks = [];
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */ , function(log) {
        return (0, $8bRVY.sendToExtension)("logs", log);
    });
    var reportError = (0, $ax858.startReportError)(lifeCycle);
    var pageExitObservable = (0, $aZtSh.createPageExitObservable)(configuration);
    var session = configuration.sessionStoreStrategyType && !(0, $5Q4S1.canUseEventBridge)() && !(0, $9fPw5.willSyntheticsInjectRum)() ? (0, $jZy8A.startLogsSessionManager)(configuration, trackingConsentState) : (0, $jZy8A.startLogsSessionManagerStub)(configuration);
    var stopLogsTelemetry = (0, $9uavD.startLogsTelemetry)(initConfiguration, configuration, reportError, pageExitObservable, session).stop;
    cleanupTasks.push(function() {
        return stopLogsTelemetry();
    });
    (0, $iWFqL.startNetworkErrorCollection)(configuration, lifeCycle);
    (0, $eJIwd.startRuntimeErrorCollection)(configuration, lifeCycle);
    (0, $5evzm.startConsoleCollection)(configuration, lifeCycle);
    (0, $9lcxI.startReportCollection)(configuration, lifeCycle);
    var handleLog = (0, $7wIAO.startLoggerCollection)(lifeCycle).handleLog;
    (0, $6PxVO.startLogsAssembly)(session, configuration, lifeCycle, getCommonContext, reportError);
    if (!(0, $5Q4S1.canUseEventBridge)()) {
        var stopLogsBatch_1 = (0, $2KImc.startLogsBatch)(configuration, lifeCycle, reportError, pageExitObservable, session).stop;
        cleanupTasks.push(function() {
            return stopLogsBatch_1();
        });
    } else (0, $fMB8i.startLogsBridge)(lifeCycle);
    var internalContext = (0, $cWqpl.startInternalContext)(session);
    return {
        handleLog: handleLog,
        getInternalContext: internalContext.get,
        stop: function() {
            cleanupTasks.forEach(function(task) {
                return task();
            });
        }
    };
}

});
parcelRegister("aZtSh", function(module, exports) {

$parcel$export(module.exports, "createPageExitObservable", () => $8006c65be925ad0a$export$ff7f79b1ae5ce683);
$parcel$export(module.exports, "isPageExitReason", () => $8006c65be925ad0a$export$cbb6b5cdbd0f2b60);

var $ayJ3T = parcelRequire("ayJ3T");

var $3jm7f = parcelRequire("3jm7f");

var $iD7Tb = parcelRequire("iD7Tb");

var $dBtKo = parcelRequire("dBtKo");

var $eVXiU = parcelRequire("eVXiU");
var $8006c65be925ad0a$export$69c8658089134213 = {
    HIDDEN: "visibility_hidden",
    UNLOADING: "before_unload",
    PAGEHIDE: "page_hide",
    FROZEN: "page_frozen"
};
function $8006c65be925ad0a$export$ff7f79b1ae5ce683(configuration) {
    return new (0, $3jm7f.Observable)(function(observable) {
        var pagehideEnabled = (0, $ayJ3T.isExperimentalFeatureEnabled)((0, $ayJ3T.ExperimentalFeature).PAGEHIDE);
        var stopListeners = (0, $eVXiU.addEventListeners)(configuration, window, [
            (0, $eVXiU.DOM_EVENT).VISIBILITY_CHANGE,
            (0, $eVXiU.DOM_EVENT).FREEZE,
            (0, $eVXiU.DOM_EVENT).PAGE_HIDE
        ], function(event) {
            if (event.type === (0, $eVXiU.DOM_EVENT).PAGE_HIDE && pagehideEnabled) /**
                 * Only event that detect page unload events while being compatible with the back/forward cache (bfcache)
                 */ observable.notify({
                reason: $8006c65be925ad0a$export$69c8658089134213.PAGEHIDE
            });
            else if (event.type === (0, $eVXiU.DOM_EVENT).VISIBILITY_CHANGE && document.visibilityState === "hidden") /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */ observable.notify({
                reason: $8006c65be925ad0a$export$69c8658089134213.HIDDEN
            });
            else if (event.type === (0, $eVXiU.DOM_EVENT).FREEZE) /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */ observable.notify({
                reason: $8006c65be925ad0a$export$69c8658089134213.FROZEN
            });
        }, {
            capture: true
        }).stop;
        var stopBeforeUnloadListener = (0, $dBtKo.noop);
        if (!pagehideEnabled) stopBeforeUnloadListener = (0, $eVXiU.addEventListener)(configuration, window, (0, $eVXiU.DOM_EVENT).BEFORE_UNLOAD, function() {
            observable.notify({
                reason: $8006c65be925ad0a$export$69c8658089134213.UNLOADING
            });
        }).stop;
        return function() {
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
}
function $8006c65be925ad0a$export$cbb6b5cdbd0f2b60(reason) {
    return (0, $iD7Tb.includes)((0, $iD7Tb.objectValues)($8006c65be925ad0a$export$69c8658089134213), reason);
}

});

parcelRegister("8bRVY", function(module, exports) {

$parcel$export(module.exports, "sendToExtension", () => $5f692ff9e26813c2$export$528ac5c14fe2fa6b);
function $5f692ff9e26813c2$export$528ac5c14fe2fa6b(type, payload) {
    var callback = window.__ddBrowserSdkExtensionCallback;
    if (callback) callback({
        type: type,
        payload: payload
    });
}

});

parcelRegister("9fPw5", function(module, exports) {

$parcel$export(module.exports, "willSyntheticsInjectRum", () => $6bcd79dfc3c2f350$export$749ed8af36cd25e0);
$parcel$export(module.exports, "getSyntheticsTestId", () => $6bcd79dfc3c2f350$export$8ea5b4a47d6660d5);
$parcel$export(module.exports, "getSyntheticsResultId", () => $6bcd79dfc3c2f350$export$75da4270a596d87b);

var $80vso = parcelRequire("80vso");
var $6bcd79dfc3c2f350$export$ef391ea72457ea48 = "datadog-synthetics-public-id";
var $6bcd79dfc3c2f350$export$a2c8b6e1d6d69dc9 = "datadog-synthetics-result-id";
var $6bcd79dfc3c2f350$export$c8a0c5680e097130 = "datadog-synthetics-injects-rum";
function $6bcd79dfc3c2f350$export$749ed8af36cd25e0() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || (0, $80vso.getInitCookie)($6bcd79dfc3c2f350$export$c8a0c5680e097130));
}
function $6bcd79dfc3c2f350$export$8ea5b4a47d6660d5() {
    var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || (0, $80vso.getInitCookie)($6bcd79dfc3c2f350$export$ef391ea72457ea48);
    return typeof value === "string" ? value : undefined;
}
function $6bcd79dfc3c2f350$export$75da4270a596d87b() {
    var value = window._DATADOG_SYNTHETICS_RESULT_ID || (0, $80vso.getInitCookie)($6bcd79dfc3c2f350$export$a2c8b6e1d6d69dc9);
    return typeof value === "string" ? value : undefined;
}

});

parcelRegister("jZy8A", function(module, exports) {

$parcel$export(module.exports, "startLogsSessionManager", () => $e8de31cf304f2b55$export$3f8657259c35672b);
$parcel$export(module.exports, "startLogsSessionManagerStub", () => $e8de31cf304f2b55$export$272a61c5dde71b62);

var $3jm7f = parcelRequire("3jm7f");
var $i44dp = parcelRequire("i44dp");
var $1qyWm = parcelRequire("1qyWm");
var $e8de31cf304f2b55$export$c47fdbea9837fd34 = "logs";
function $e8de31cf304f2b55$export$3f8657259c35672b(configuration, trackingConsentState) {
    var sessionManager = (0, $1qyWm.startSessionManager)(configuration, $e8de31cf304f2b55$export$c47fdbea9837fd34, function(rawTrackingType) {
        return $e8de31cf304f2b55$var$computeSessionState(configuration, rawTrackingType);
    }, trackingConsentState);
    return {
        findTrackedSession: function(startTime) {
            var session = sessionManager.findActiveSession(startTime);
            return session && session.trackingType === "1" /* LoggerTrackingType.TRACKED */  ? {
                id: session.id
            } : undefined;
        },
        expireObservable: sessionManager.expireObservable
    };
}
function $e8de31cf304f2b55$export$272a61c5dde71b62(configuration) {
    var isTracked = $e8de31cf304f2b55$var$computeTrackingType(configuration) === "1" /* LoggerTrackingType.TRACKED */ ;
    var session = isTracked ? {} : undefined;
    return {
        findTrackedSession: function() {
            return session;
        },
        expireObservable: new (0, $3jm7f.Observable)()
    };
}
function $e8de31cf304f2b55$var$computeTrackingType(configuration) {
    if (!(0, $i44dp.performDraw)(configuration.sessionSampleRate)) return "0" /* LoggerTrackingType.NOT_TRACKED */ ;
    return "1" /* LoggerTrackingType.TRACKED */ ;
}
function $e8de31cf304f2b55$var$computeSessionState(configuration, rawSessionType) {
    var trackingType = $e8de31cf304f2b55$var$hasValidLoggerSession(rawSessionType) ? rawSessionType : $e8de31cf304f2b55$var$computeTrackingType(configuration);
    return {
        trackingType: trackingType,
        isTracked: trackingType === "1" /* LoggerTrackingType.TRACKED */ 
    };
}
function $e8de31cf304f2b55$var$hasValidLoggerSession(trackingType) {
    return trackingType === "0" /* LoggerTrackingType.NOT_TRACKED */  || trackingType === "1" /* LoggerTrackingType.TRACKED */ ;
}

});
parcelRegister("1qyWm", function(module, exports) {

$parcel$export(module.exports, "startSessionManager", () => $10a3528c4f5658d7$export$3b6b9a4f35a367c5);

var $3jm7f = parcelRequire("3jm7f");

var $liDuh = parcelRequire("liDuh");

var $kklrV = parcelRequire("kklrV");

var $eVXiU = parcelRequire("eVXiU");

var $kiWyZ = parcelRequire("kiWyZ");

var $a6Vhx = parcelRequire("a6Vhx");

var $8qPJm = parcelRequire("8qPJm");
var $10a3528c4f5658d7$export$3d1fb0c94cce8478 = (0, $kklrV.ONE_MINUTE);
var $10a3528c4f5658d7$var$SESSION_CONTEXT_TIMEOUT_DELAY = (0, $a6Vhx.SESSION_TIME_OUT_DELAY);
var $10a3528c4f5658d7$var$stopCallbacks = [];
function $10a3528c4f5658d7$export$3b6b9a4f35a367c5(configuration, productKey, computeSessionState, trackingConsentState) {
    var renewObservable = new (0, $3jm7f.Observable)();
    var expireObservable = new (0, $3jm7f.Observable)();
    // TODO - Improve configuration type and remove assertion
    var sessionStore = (0, $8qPJm.startSessionStore)(configuration.sessionStoreStrategyType, productKey, computeSessionState);
    $10a3528c4f5658d7$var$stopCallbacks.push(function() {
        return sessionStore.stop();
    });
    var sessionContextHistory = new (0, $liDuh.ValueHistory)($10a3528c4f5658d7$var$SESSION_CONTEXT_TIMEOUT_DELAY);
    $10a3528c4f5658d7$var$stopCallbacks.push(function() {
        return sessionContextHistory.stop();
    });
    sessionStore.renewObservable.subscribe(function() {
        sessionContextHistory.add(buildSessionContext(), (0, $kklrV.relativeNow)());
        renewObservable.notify();
    });
    sessionStore.expireObservable.subscribe(function() {
        expireObservable.notify();
        sessionContextHistory.closeActive((0, $kklrV.relativeNow)());
    });
    // We expand/renew session unconditionally as tracking consent is always granted when the session
    // manager is started.
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), (0, $kklrV.clocksOrigin)().relative);
    trackingConsentState.observable.subscribe(function() {
        if (trackingConsentState.isGranted()) sessionStore.expandOrRenewSession();
        else sessionStore.expire();
    });
    $10a3528c4f5658d7$var$trackActivity(configuration, function() {
        if (trackingConsentState.isGranted()) sessionStore.expandOrRenewSession();
    });
    $10a3528c4f5658d7$var$trackVisibility(configuration, function() {
        return sessionStore.expandSession();
    });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey]
        };
    }
    return {
        findActiveSession: function(startTime) {
            return sessionContextHistory.find(startTime);
        },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        expire: sessionStore.expire
    };
}
function $10a3528c4f5658d7$export$c08596f6814fce4f() {
    $10a3528c4f5658d7$var$stopCallbacks.forEach(function(e) {
        return e();
    });
    $10a3528c4f5658d7$var$stopCallbacks = [];
}
function $10a3528c4f5658d7$var$trackActivity(configuration, expandOrRenewSession) {
    var stop = (0, $eVXiU.addEventListeners)(configuration, window, [
        (0, $eVXiU.DOM_EVENT).CLICK,
        (0, $eVXiU.DOM_EVENT).TOUCH_START,
        (0, $eVXiU.DOM_EVENT).KEY_DOWN,
        (0, $eVXiU.DOM_EVENT).SCROLL
    ], expandOrRenewSession, {
        capture: true,
        passive: true
    }).stop;
    $10a3528c4f5658d7$var$stopCallbacks.push(stop);
}
function $10a3528c4f5658d7$var$trackVisibility(configuration, expandSession) {
    var expandSessionWhenVisible = function() {
        if (document.visibilityState === "visible") expandSession();
    };
    var stop = (0, $eVXiU.addEventListener)(configuration, document, (0, $eVXiU.DOM_EVENT).VISIBILITY_CHANGE, expandSessionWhenVisible).stop;
    $10a3528c4f5658d7$var$stopCallbacks.push(stop);
    var visibilityCheckInterval = (0, $kiWyZ.setInterval)(expandSessionWhenVisible, $10a3528c4f5658d7$export$3d1fb0c94cce8478);
    $10a3528c4f5658d7$var$stopCallbacks.push(function() {
        (0, $kiWyZ.clearInterval)(visibilityCheckInterval);
    });
}

});
parcelRegister("liDuh", function(module, exports) {

$parcel$export(module.exports, "ValueHistory", () => $f819e8cf0fbcba61$export$b054dd6fcf79fa19);

var $kiWyZ = parcelRequire("kiWyZ");

var $6P8NY = parcelRequire("6P8NY");

var $kklrV = parcelRequire("kklrV");
var $f819e8cf0fbcba61$var$END_OF_TIMES = Infinity;
var $f819e8cf0fbcba61$export$7cf440d5901bea64 = (0, $kklrV.ONE_MINUTE);
/**
 * Store and keep track of values spans. This whole class assumes that values are added in
 * chronological order (i.e. all entries have an increasing start time).
 */ var $f819e8cf0fbcba61$export$b054dd6fcf79fa19 = /** @class */ function() {
    function ValueHistory(expireDelay, maxEntries) {
        var _this = this;
        this.expireDelay = expireDelay;
        this.maxEntries = maxEntries;
        this.entries = [];
        this.clearOldValuesInterval = (0, $kiWyZ.setInterval)(function() {
            return _this.clearOldValues();
        }, $f819e8cf0fbcba61$export$7cf440d5901bea64);
    }
    /**
     * Add a value to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */ ValueHistory.prototype.add = function(value, startTime) {
        var _this = this;
        var entry = {
            value: value,
            startTime: startTime,
            endTime: $f819e8cf0fbcba61$var$END_OF_TIMES,
            remove: function() {
                (0, $6P8NY.removeItem)(_this.entries, entry);
            },
            close: function(endTime) {
                entry.endTime = endTime;
            }
        };
        if (this.maxEntries && this.entries.length >= this.maxEntries) this.entries.pop();
        this.entries.unshift(entry);
        return entry;
    };
    /**
     * Return the latest value that was active during `startTime`, or the currently active value
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     */ ValueHistory.prototype.find = function(startTime) {
        if (startTime === void 0) startTime = $f819e8cf0fbcba61$var$END_OF_TIMES;
        for(var _i = 0, _a = this.entries; _i < _a.length; _i++){
            var entry = _a[_i];
            if (entry.startTime <= startTime) {
                if (startTime <= entry.endTime) return entry.value;
                break;
            }
        }
    };
    /**
     * Helper function to close the currently active value, if any. This method assumes that entries
     * are not overlapping.
     */ ValueHistory.prototype.closeActive = function(endTime) {
        var latestEntry = this.entries[0];
        if (latestEntry && latestEntry.endTime === $f819e8cf0fbcba61$var$END_OF_TIMES) latestEntry.close(endTime);
    };
    /**
     * Return all values with an active period overlapping with the duration,
     * or all values that were active during `startTime` if no duration is provided,
     * or all currently active values if no `startTime` is provided.
     */ ValueHistory.prototype.findAll = function(startTime, duration) {
        if (startTime === void 0) startTime = $f819e8cf0fbcba61$var$END_OF_TIMES;
        if (duration === void 0) duration = 0;
        var endTime = (0, $kklrV.addDuration)(startTime, duration);
        return this.entries.filter(function(entry) {
            return entry.startTime <= endTime && startTime <= entry.endTime;
        }).map(function(entry) {
            return entry.value;
        });
    };
    /**
     * Remove all entries from this collection.
     */ ValueHistory.prototype.reset = function() {
        this.entries = [];
    };
    /**
     * Stop internal garbage collection of past entries.
     */ ValueHistory.prototype.stop = function() {
        (0, $kiWyZ.clearInterval)(this.clearOldValuesInterval);
    };
    ValueHistory.prototype.clearOldValues = function() {
        var oldTimeThreshold = (0, $kklrV.relativeNow)() - this.expireDelay;
        while(this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold)this.entries.pop();
    };
    return ValueHistory;
}();

});



parcelRegister("6PxVO", function(module, exports) {

$parcel$export(module.exports, "startLogsAssembly", () => $4f91d394223c53b4$export$627391049aa7b21e);

var $2JJbR = parcelRequire("2JJbR");
var $dKyzW = parcelRequire("dKyzW");
var $1PeMs = parcelRequire("1PeMs");
var $kklrV = parcelRequire("kklrV");
var $3h3z3 = parcelRequire("3h3z3");

var $bWwuo = parcelRequire("bWwuo");

var $21nkp = parcelRequire("21nkp");
function $4f91d394223c53b4$export$627391049aa7b21e(sessionManager, configuration, lifeCycle, getCommonContext, reportError) {
    var statusWithCustom = (0, $bWwuo.STATUSES).concat([
        "custom"
    ]);
    var logRateLimiters = {};
    statusWithCustom.forEach(function(status) {
        logRateLimiters[status] = (0, $dKyzW.createEventRateLimiter)(status, configuration.eventRateLimiterThreshold, reportError);
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , function(_a) {
        var _b, _c;
        var rawLogsEvent = _a.rawLogsEvent, _d = _a.messageContext, messageContext = _d === void 0 ? undefined : _d, _e = _a.savedCommonContext, savedCommonContext = _e === void 0 ? undefined : _e, domainContext = _a.domainContext;
        var startTime = (0, $kklrV.getRelativeTime)(rawLogsEvent.date);
        var session = sessionManager.findTrackedSession(startTime);
        if (!session) return;
        var commonContext = savedCommonContext || getCommonContext();
        var log = (0, $2JJbR.combine)({
            service: configuration.service,
            session_id: session.id,
            // Insert user first to allow overrides from global context
            usr: !(0, $3h3z3.isEmptyObject)(commonContext.user) ? commonContext.user : undefined,
            view: commonContext.view
        }, commonContext.context, (0, $21nkp.getRUMInternalContext)(startTime), rawLogsEvent, messageContext);
        if (((_b = configuration.beforeSend) === null || _b === void 0 ? void 0 : _b.call(configuration, log, domainContext)) === false || log.origin !== (0, $1PeMs.ErrorSource).AGENT && ((_c = logRateLimiters[log.status]) !== null && _c !== void 0 ? _c : logRateLimiters["custom"]).isLimitReached()) return;
        lifeCycle.notify(1 /* LifeCycleEventType.LOG_COLLECTED */ , log);
    });
}

});
parcelRegister("dKyzW", function(module, exports) {

$parcel$export(module.exports, "createEventRateLimiter", () => $a02a64dbca739880$export$eafcd5d914e17d69);

var $kiWyZ = parcelRequire("kiWyZ");

var $kklrV = parcelRequire("kklrV");

var $1PeMs = parcelRequire("1PeMs");
function $a02a64dbca739880$export$eafcd5d914e17d69(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function() {
            if (eventCount === 0) (0, $kiWyZ.setTimeout)(function() {
                eventCount = 0;
            }, (0, $kklrV.ONE_MINUTE));
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: (0, $1PeMs.ErrorSource).AGENT,
                        startClocks: (0, $kklrV.clocksNow)()
                    });
                } finally{
                    allowNextEvent = false;
                }
            }
            return true;
        }
    };
}

});

parcelRegister("21nkp", function(module, exports) {

$parcel$export(module.exports, "getRUMInternalContext", () => $178dc541740d4a76$export$e2386d255c9a7886);

var $g1PLZ = parcelRequire("g1PLZ");
var $9fPw5 = parcelRequire("9fPw5");
var $178dc541740d4a76$var$logsSentBeforeRumInjectionTelemetryAdded = false;
function $178dc541740d4a76$export$e2386d255c9a7886(startTime) {
    var browserWindow = window;
    if ((0, $9fPw5.willSyntheticsInjectRum)()) {
        var context = getInternalContextFromRumGlobal(browserWindow.DD_RUM_SYNTHETICS);
        if (!context && !$178dc541740d4a76$var$logsSentBeforeRumInjectionTelemetryAdded) {
            $178dc541740d4a76$var$logsSentBeforeRumInjectionTelemetryAdded = true;
            (0, $g1PLZ.addTelemetryDebug)("Logs sent before RUM is injected by the synthetics worker", {
                testId: (0, $9fPw5.getSyntheticsTestId)(),
                resultId: (0, $9fPw5.getSyntheticsResultId)()
            });
        }
        return context;
    }
    return getInternalContextFromRumGlobal(browserWindow.DD_RUM);
    function getInternalContextFromRumGlobal(rumGlobal) {
        if (rumGlobal && rumGlobal.getInternalContext) return rumGlobal.getInternalContext(startTime);
    }
}
function $178dc541740d4a76$export$9b06af1b36b3cd98() {
    $178dc541740d4a76$var$logsSentBeforeRumInjectionTelemetryAdded = false;
}

});
parcelRegister("g1PLZ", function(module, exports) {

$parcel$export(module.exports, "startTelemetry", () => $bab4e65ce554c79f$export$a1198c4bba5d5e18);
$parcel$export(module.exports, "addTelemetryError", () => $bab4e65ce554c79f$export$2e825f93958b0e6a);
$parcel$export(module.exports, "isTelemetryReplicationAllowed", () => $bab4e65ce554c79f$export$2b39c4ac778572fb);
$parcel$export(module.exports, "addTelemetryDebug", () => $bab4e65ce554c79f$export$d922954195a17683);
$parcel$export(module.exports, "addTelemetryConfiguration", () => $bab4e65ce554c79f$export$d546dcbd09bc447f);

var $gqtZo = parcelRequire("gqtZo");

var $oZ6HF = parcelRequire("oZ6HF");

var $ayJ3T = parcelRequire("ayJ3T");

var $cwLk7 = parcelRequire("cwLk7");

var $3jm7f = parcelRequire("3jm7f");

var $kklrV = parcelRequire("kklrV");

var $5JqHL = parcelRequire("5JqHL");

var $8bRVY = parcelRequire("8bRVY");

var $iD7Tb = parcelRequire("iD7Tb");

var $i44dp = parcelRequire("i44dp");

var $gS5dB = parcelRequire("gS5dB");

var $2JJbR = parcelRequire("2JJbR");

var $ezY4f = parcelRequire("ezY4f");

var $fI9Ko = parcelRequire("fI9Ko");

var $3k1Ur = parcelRequire("3k1Ur");
var $bab4e65ce554c79f$var$ALLOWED_FRAME_URLS = [
    "https://www.datadoghq-browser-agent.com",
    "https://www.datad0g-browser-agent.com",
    "https://d3uc069fcn7uxw.cloudfront.net",
    "https://d20xtzwzcl0ceb.cloudfront.net",
    "http://localhost",
    "<anonymous>"
];
var $bab4e65ce554c79f$var$TELEMETRY_EXCLUDED_SITES = [
    (0, $cwLk7.INTAKE_SITE_US1_FED)
];
var $bab4e65ce554c79f$var$telemetryConfiguration = {
    maxEventsPerPage: 0,
    sentEventCount: 0,
    telemetryEnabled: false,
    telemetryConfigurationEnabled: false
};
var $bab4e65ce554c79f$var$onRawTelemetryEventCollected;
function $bab4e65ce554c79f$export$a1198c4bba5d5e18(telemetryService, configuration) {
    var contextProvider;
    var observable = new (0, $3jm7f.Observable)();
    $bab4e65ce554c79f$var$telemetryConfiguration.telemetryEnabled = !(0, $iD7Tb.includes)($bab4e65ce554c79f$var$TELEMETRY_EXCLUDED_SITES, configuration.site) && (0, $i44dp.performDraw)(configuration.telemetrySampleRate);
    $bab4e65ce554c79f$var$telemetryConfiguration.telemetryConfigurationEnabled = $bab4e65ce554c79f$var$telemetryConfiguration.telemetryEnabled && (0, $i44dp.performDraw)(configuration.telemetryConfigurationSampleRate);
    var runtimeEnvInfo = $bab4e65ce554c79f$var$getRuntimeEnvInfo();
    $bab4e65ce554c79f$var$onRawTelemetryEventCollected = function(rawEvent) {
        if ($bab4e65ce554c79f$var$telemetryConfiguration.telemetryEnabled) {
            var event_1 = toTelemetryEvent(telemetryService, rawEvent, runtimeEnvInfo);
            observable.notify(event_1);
            (0, $8bRVY.sendToExtension)("telemetry", event_1);
        }
    };
    (0, $5JqHL.startMonitorErrorCollection)($bab4e65ce554c79f$export$2e825f93958b0e6a);
    (0, $iD7Tb.assign)($bab4e65ce554c79f$var$telemetryConfiguration, {
        maxEventsPerPage: configuration.maxTelemetryEventsPerPage,
        sentEventCount: 0
    });
    function toTelemetryEvent(telemetryService, event, runtimeEnvInfo) {
        return (0, $2JJbR.combine)({
            type: "telemetry",
            date: (0, $kklrV.timeStampNow)(),
            service: telemetryService,
            version: "5.15.0",
            source: "browser",
            _dd: {
                format_version: 2
            },
            telemetry: (0, $2JJbR.combine)(event, {
                runtime_env: runtimeEnvInfo,
                connectivity: (0, $fI9Ko.getConnectivity)()
            }),
            experimental_features: (0, $iD7Tb.arrayFrom)((0, $ayJ3T.getExperimentalFeatures)())
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function(provider) {
            contextProvider = provider;
        },
        observable: observable,
        enabled: $bab4e65ce554c79f$var$telemetryConfiguration.telemetryEnabled
    };
}
function $bab4e65ce554c79f$var$getRuntimeEnvInfo() {
    return {
        is_local_file: window.location.protocol === "file:",
        is_worker: "WorkerGlobalScope" in self
    };
}
function $bab4e65ce554c79f$export$fa01c94923483298() {
    var events = [];
    (0, $iD7Tb.assign)($bab4e65ce554c79f$var$telemetryConfiguration, {
        maxEventsPerPage: Infinity,
        sentEventCount: 0
    });
    $bab4e65ce554c79f$var$onRawTelemetryEventCollected = function(event) {
        events.push(event);
    };
    return events;
}
function $bab4e65ce554c79f$export$bcc442d9456bda5() {
    $bab4e65ce554c79f$var$onRawTelemetryEventCollected = undefined;
}
function $bab4e65ce554c79f$export$2b39c4ac778572fb(configuration) {
    return configuration.site === (0, $cwLk7.INTAKE_SITE_STAGING);
}
function $bab4e65ce554c79f$export$d922954195a17683(message, context) {
    (0, $5JqHL.displayIfDebugEnabled)((0, $gqtZo.ConsoleApiName).debug, message, context);
    $bab4e65ce554c79f$var$addTelemetry((0, $iD7Tb.assign)({
        type: (0, $3k1Ur.TelemetryType).log,
        message: message,
        status: "debug" /* StatusType.debug */ 
    }, context));
}
function $bab4e65ce554c79f$export$2e825f93958b0e6a(e, context) {
    $bab4e65ce554c79f$var$addTelemetry((0, $iD7Tb.assign)({
        type: (0, $3k1Ur.TelemetryType).log,
        status: "error" /* StatusType.error */ 
    }, $bab4e65ce554c79f$export$7b5b869ee98c16ab(e), context));
}
function $bab4e65ce554c79f$export$d546dcbd09bc447f(configuration) {
    if ($bab4e65ce554c79f$var$telemetryConfiguration.telemetryConfigurationEnabled) $bab4e65ce554c79f$var$addTelemetry({
        type: (0, $3k1Ur.TelemetryType).configuration,
        configuration: configuration
    });
}
function $bab4e65ce554c79f$var$addTelemetry(event) {
    if ($bab4e65ce554c79f$var$onRawTelemetryEventCollected && $bab4e65ce554c79f$var$telemetryConfiguration.sentEventCount < $bab4e65ce554c79f$var$telemetryConfiguration.maxEventsPerPage) {
        $bab4e65ce554c79f$var$telemetryConfiguration.sentEventCount += 1;
        $bab4e65ce554c79f$var$onRawTelemetryEventCollected(event);
    }
}
function $bab4e65ce554c79f$export$7b5b869ee98c16ab(e) {
    if (e instanceof Error) {
        var stackTrace = (0, $ezY4f.computeStackTrace)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0, $oZ6HF.toStackTraceString)($bab4e65ce554c79f$export$cb9c82b4610a83c3(stackTrace))
            },
            message: stackTrace.message
        };
    }
    return {
        error: {
            stack: (0, $oZ6HF.NO_ERROR_STACK_PRESENT_MESSAGE)
        },
        message: "".concat("Uncaught" /* NonErrorPrefix.UNCAUGHT */ , " ").concat((0, $gS5dB.jsonStringify)(e))
    };
}
function $bab4e65ce554c79f$export$cb9c82b4610a83c3(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function(frame) {
        return !frame.url || $bab4e65ce554c79f$var$ALLOWED_FRAME_URLS.some(function(allowedFrameUrl) {
            return (0, $iD7Tb.startsWith)(frame.url, allowedFrameUrl);
        });
    });
    return stackTrace;
}

});
parcelRegister("fI9Ko", function(module, exports) {

$parcel$export(module.exports, "getConnectivity", () => $b70286af2a678d02$export$5c86d3b16901f3ce);
function $b70286af2a678d02$export$5c86d3b16901f3ce() {
    var _a;
    var navigator = window.navigator;
    return {
        status: navigator.onLine ? "connected" : "not_connected",
        interfaces: navigator.connection && navigator.connection.type ? [
            navigator.connection.type
        ] : undefined,
        effective_type: (_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType
    };
}

});

parcelRegister("3k1Ur", function(module, exports) {

$parcel$export(module.exports, "TelemetryType", () => $26b4b87fd546381e$export$8c1a12d9d019b209);
var $26b4b87fd546381e$export$8c1a12d9d019b209 = {
    log: "log",
    configuration: "configuration"
};

});




parcelRegister("5evzm", function(module, exports) {

$parcel$export(module.exports, "startConsoleCollection", () => $3cf6bf90523923e4$export$601e91d68ece5c12);

var $gqtZo = parcelRequire("gqtZo");
var $1PeMs = parcelRequire("1PeMs");
var $f2BI6 = parcelRequire("f2BI6");
var $kklrV = parcelRequire("kklrV");

var $bWwuo = parcelRequire("bWwuo");
var $3cf6bf90523923e4$var$_a;
var $3cf6bf90523923e4$export$aed7c9a1c59f7d58 = ($3cf6bf90523923e4$var$_a = {}, $3cf6bf90523923e4$var$_a[(0, $gqtZo.ConsoleApiName).log] = (0, $bWwuo.StatusType).info, $3cf6bf90523923e4$var$_a[(0, $gqtZo.ConsoleApiName).debug] = (0, $bWwuo.StatusType).debug, $3cf6bf90523923e4$var$_a[(0, $gqtZo.ConsoleApiName).info] = (0, $bWwuo.StatusType).info, $3cf6bf90523923e4$var$_a[(0, $gqtZo.ConsoleApiName).warn] = (0, $bWwuo.StatusType).warn, $3cf6bf90523923e4$var$_a[(0, $gqtZo.ConsoleApiName).error] = (0, $bWwuo.StatusType).error, $3cf6bf90523923e4$var$_a);
function $3cf6bf90523923e4$export$601e91d68ece5c12(configuration, lifeCycle) {
    var consoleSubscription = (0, $f2BI6.initConsoleObservable)(configuration.forwardConsoleLogs).subscribe(function(log) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
            rawLogsEvent: {
                date: (0, $kklrV.timeStampNow)(),
                message: log.message,
                origin: (0, $1PeMs.ErrorSource).CONSOLE,
                error: log.api === (0, $gqtZo.ConsoleApiName).error ? {
                    stack: log.stack,
                    fingerprint: log.fingerprint,
                    causes: log.causes
                } : undefined,
                status: $3cf6bf90523923e4$export$aed7c9a1c59f7d58[log.api]
            }
        });
    });
    return {
        stop: function() {
            consoleSubscription.unsubscribe();
        }
    };
}

});
parcelRegister("f2BI6", function(module, exports) {

$parcel$export(module.exports, "initConsoleObservable", () => $af344b67e881c0c5$export$688fb0189cfcddd4);

var $oZ6HF = parcelRequire("oZ6HF");

var $3jm7f = parcelRequire("3jm7f");

var $gqtZo = parcelRequire("gqtZo");

var $5JqHL = parcelRequire("5JqHL");

var $41fUm = parcelRequire("41fUm");

var $iD7Tb = parcelRequire("iD7Tb");

var $gS5dB = parcelRequire("gS5dB");

var $ezY4f = parcelRequire("ezY4f");
var $af344b67e881c0c5$var$consoleObservablesByApi = {};
function $af344b67e881c0c5$export$688fb0189cfcddd4(apis) {
    var consoleObservables = apis.map(function(api) {
        if (!$af344b67e881c0c5$var$consoleObservablesByApi[api]) $af344b67e881c0c5$var$consoleObservablesByApi[api] = $af344b67e881c0c5$var$createConsoleObservable(api);
        return $af344b67e881c0c5$var$consoleObservablesByApi[api];
    });
    return (0, $3jm7f.mergeObservables).apply(void 0, consoleObservables);
}
function $af344b67e881c0c5$export$1356159d86f98c58() {
    $af344b67e881c0c5$var$consoleObservablesByApi = {};
}
function $af344b67e881c0c5$var$createConsoleObservable(api) {
    return new (0, $3jm7f.Observable)(function(observable) {
        var originalConsoleApi = (0, $gqtZo.globalConsole)[api];
        (0, $gqtZo.globalConsole)[api] = function() {
            var params = [];
            for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
            originalConsoleApi.apply(console, params);
            var handlingStack = (0, $oZ6HF.createHandlingStack)();
            (0, $5JqHL.callMonitored)(function() {
                observable.notify($af344b67e881c0c5$var$buildConsoleLog(params, api, handlingStack));
            });
        };
        return function() {
            (0, $gqtZo.globalConsole)[api] = originalConsoleApi;
        };
    });
}
function $af344b67e881c0c5$var$buildConsoleLog(params, api, handlingStack) {
    var message = params.map(function(param) {
        return $af344b67e881c0c5$var$formatConsoleParameters(param);
    }).join(" ");
    var stack;
    var fingerprint;
    var causes;
    if (api === (0, $gqtZo.ConsoleApiName).error) {
        var firstErrorParam = (0, $iD7Tb.find)(params, function(param) {
            return param instanceof Error;
        });
        stack = firstErrorParam ? (0, $oZ6HF.toStackTraceString)((0, $ezY4f.computeStackTrace)(firstErrorParam)) : undefined;
        fingerprint = (0, $oZ6HF.tryToGetFingerprint)(firstErrorParam);
        causes = firstErrorParam ? (0, $oZ6HF.flattenErrorCauses)(firstErrorParam, "console") : undefined;
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
        fingerprint: fingerprint,
        causes: causes
    };
}
function $af344b67e881c0c5$var$formatConsoleParameters(param) {
    if (typeof param === "string") return (0, $41fUm.sanitize)(param);
    if (param instanceof Error) return (0, $oZ6HF.formatErrorMessage)((0, $ezY4f.computeStackTrace)(param));
    return (0, $gS5dB.jsonStringify)((0, $41fUm.sanitize)(param), undefined, 2);
}

});


parcelRegister("9lcxI", function(module, exports) {

$parcel$export(module.exports, "startReportCollection", () => $6ccfcdf3f7811938$export$764db0aca1d0911);

var $1PeMs = parcelRequire("1PeMs");
var $oZ6HF = parcelRequire("oZ6HF");
var $nxPM5 = parcelRequire("nxPM5");
var $kklrV = parcelRequire("kklrV");

var $bWwuo = parcelRequire("bWwuo");
var $6ccfcdf3f7811938$var$_a;
var $6ccfcdf3f7811938$var$LogStatusForReport = ($6ccfcdf3f7811938$var$_a = {}, $6ccfcdf3f7811938$var$_a[(0, $nxPM5.RawReportType).cspViolation] = (0, $bWwuo.StatusType).error, $6ccfcdf3f7811938$var$_a[(0, $nxPM5.RawReportType).intervention] = (0, $bWwuo.StatusType).error, $6ccfcdf3f7811938$var$_a[(0, $nxPM5.RawReportType).deprecation] = (0, $bWwuo.StatusType).warn, $6ccfcdf3f7811938$var$_a);
function $6ccfcdf3f7811938$export$764db0aca1d0911(configuration, lifeCycle) {
    var reportSubscription = (0, $nxPM5.initReportObservable)(configuration, configuration.forwardReports).subscribe(function(report) {
        var message = report.message;
        var status = $6ccfcdf3f7811938$var$LogStatusForReport[report.type];
        var error;
        if (status === (0, $bWwuo.StatusType).error) error = {
            kind: report.subtype,
            stack: report.stack
        };
        else if (report.stack) message += " Found in ".concat((0, $oZ6HF.getFileFromStackTraceString)(report.stack));
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
            rawLogsEvent: {
                date: (0, $kklrV.timeStampNow)(),
                message: message,
                origin: (0, $1PeMs.ErrorSource).REPORT,
                error: error,
                status: status
            }
        });
    });
    return {
        stop: function() {
            reportSubscription.unsubscribe();
        }
    };
}

});

parcelRegister("iWFqL", function(module, exports) {

$parcel$export(module.exports, "startNetworkErrorCollection", () => $dcadc810ddaa0154$export$d0c7c81096ec95e);

var $ezY4f = parcelRequire("ezY4f");
var $1PeMs = parcelRequire("1PeMs");
var $8l5rT = parcelRequire("8l5rT");
var $2q4A2 = parcelRequire("2q4A2");
var $3qBcr = parcelRequire("3qBcr");
var $5JqHL = parcelRequire("5JqHL");
var $dBtKo = parcelRequire("dBtKo");
var $idVn8 = parcelRequire("idVn8");
var $oZ6HF = parcelRequire("oZ6HF");

var $bWwuo = parcelRequire("bWwuo");
function $dcadc810ddaa0154$export$d0c7c81096ec95e(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) return {
        stop: (0, $dBtKo.noop)
    };
    var xhrSubscription = (0, $2q4A2.initXhrObservable)(configuration).subscribe(function(context) {
        if (context.state === "complete") handleResponse("xhr" /* RequestType.XHR */ , context);
    });
    var fetchSubscription = (0, $8l5rT.initFetchObservable)().subscribe(function(context) {
        if (context.state === "resolve") handleResponse("fetch" /* RequestType.FETCH */ , context);
    });
    function handleResponse(type, request) {
        if (!configuration.isIntakeUrl(request.url) && ($dcadc810ddaa0154$var$isRejected(request) || (0, $3qBcr.isServerError)(request.status))) {
            if ("xhr" in request) $dcadc810ddaa0154$export$f2e44bf057d87410(request.xhr, configuration, onResponseDataAvailable);
            else if (request.response) $dcadc810ddaa0154$export$10a388a857793df5(request.response, configuration, onResponseDataAvailable);
            else if (request.error) $dcadc810ddaa0154$export$4dbd4776a6c225a(request.error, configuration, onResponseDataAvailable);
        }
        function onResponseDataAvailable(responseData) {
            var domainContext = {
                isAborted: request.isAborted
            };
            lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
                rawLogsEvent: {
                    message: "".concat($dcadc810ddaa0154$var$format(type), " error ").concat(request.method, " ").concat(request.url),
                    date: request.startClocks.timeStamp,
                    error: {
                        stack: responseData || "Failed to load"
                    },
                    http: {
                        method: request.method,
                        status_code: request.status,
                        url: request.url
                    },
                    status: (0, $bWwuo.StatusType).error,
                    origin: (0, $1PeMs.ErrorSource).NETWORK
                },
                domainContext: domainContext
            });
        }
    }
    return {
        stop: function() {
            xhrSubscription.unsubscribe();
            fetchSubscription.unsubscribe();
        }
    };
}
function $dcadc810ddaa0154$export$f2e44bf057d87410(xhr, configuration, callback) {
    if (typeof xhr.response === "string") callback($dcadc810ddaa0154$var$truncateResponseText(xhr.response, configuration));
    else callback(xhr.response);
}
function $dcadc810ddaa0154$export$4dbd4776a6c225a(error, configuration, callback) {
    callback($dcadc810ddaa0154$var$truncateResponseText((0, $oZ6HF.toStackTraceString)((0, $ezY4f.computeStackTrace)(error)), configuration));
}
function $dcadc810ddaa0154$export$10a388a857793df5(response, configuration, callback) {
    var clonedResponse = (0, $3qBcr.tryToClone)(response);
    if (!clonedResponse || !clonedResponse.body) // if the clone failed or if the body is null, let's not try to read it.
    callback();
    else if (!window.TextDecoder) // If the browser doesn't support TextDecoder, let's read the whole response then truncate it.
    //
    // This should only be the case on early versions of Edge (before they migrated to Chromium).
    // Even if it could be possible to implement a workaround for the missing TextDecoder API (using
    // a Blob and FileReader), we found another issue preventing us from reading only the first
    // bytes from the response: contrary to other browsers, when reading from the cloned response,
    // if the original response gets canceled, the cloned response is also canceled and we can't
    // know about it.  In the following illustration, the promise returned by `reader.read()` may
    // never be fulfilled:
    //
    // fetch('/').then((response) => {
    //   const reader = response.clone().body.getReader()
    //   readMore()
    //   function readMore() {
    //     reader.read().then(
    //       (result) => {
    //         if (result.done) {
    //           console.log('done')
    //         } else {
    //           readMore()
    //         }
    //       },
    //       () => console.log('error')
    //     )
    //   }
    //   response.body.getReader().cancel()
    // })
    clonedResponse.text().then((0, $5JqHL.monitor)(function(text) {
        return callback($dcadc810ddaa0154$var$truncateResponseText(text, configuration));
    }), (0, $5JqHL.monitor)(function(error) {
        return callback("Unable to retrieve response: ".concat(error));
    }));
    else $dcadc810ddaa0154$var$truncateResponseStream(clonedResponse.body, configuration.requestErrorResponseLengthLimit, function(error, responseText) {
        if (error) callback("Unable to retrieve response: ".concat(error));
        else callback(responseText);
    });
}
function $dcadc810ddaa0154$var$isRejected(request) {
    return request.status === 0 && request.responseType !== "opaque";
}
function $dcadc810ddaa0154$var$truncateResponseText(responseText, configuration) {
    if (responseText.length > configuration.requestErrorResponseLengthLimit) return "".concat(responseText.substring(0, configuration.requestErrorResponseLengthLimit), "...");
    return responseText;
}
function $dcadc810ddaa0154$var$format(type) {
    if ("xhr" /* RequestType.XHR */  === type) return "XHR";
    return "Fetch";
}
function $dcadc810ddaa0154$var$truncateResponseStream(stream, bytesLimit, callback) {
    (0, $idVn8.readBytesFromStream)(stream, function(error, bytes, limitExceeded) {
        if (error) callback(error);
        else {
            var responseText = new TextDecoder().decode(bytes);
            if (limitExceeded) responseText += "...";
            callback(undefined, responseText);
        }
    }, {
        bytesLimit: bytesLimit,
        collectStreamBody: true
    });
}

});
parcelRegister("8l5rT", function(module, exports) {

$parcel$export(module.exports, "initFetchObservable", () => $612482f325a88c44$export$68d940e9b7f5282c);

var $18Uuo = parcelRequire("18Uuo");

var $5JqHL = parcelRequire("5JqHL");

var $3jm7f = parcelRequire("3jm7f");

var $kklrV = parcelRequire("kklrV");

var $ddsGY = parcelRequire("ddsGY");
var $612482f325a88c44$var$fetchObservable;
function $612482f325a88c44$export$68d940e9b7f5282c() {
    if (!$612482f325a88c44$var$fetchObservable) $612482f325a88c44$var$fetchObservable = $612482f325a88c44$var$createFetchObservable();
    return $612482f325a88c44$var$fetchObservable;
}
function $612482f325a88c44$var$createFetchObservable() {
    return new (0, $3jm7f.Observable)(function(observable) {
        if (!window.fetch) return;
        var stop = (0, $18Uuo.instrumentMethod)(window, "fetch", function(call) {
            return $612482f325a88c44$var$beforeSend(call, observable);
        }).stop;
        return stop;
    });
}
function $612482f325a88c44$var$beforeSend(_a, observable) {
    var parameters = _a.parameters, onPostCall = _a.onPostCall;
    var input = parameters[0], init = parameters[1];
    var methodFromParams = init && init.method;
    if (methodFromParams === undefined && input instanceof Request) methodFromParams = input.method;
    var method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : "GET";
    var url = input instanceof Request ? input.url : (0, $ddsGY.normalizeUrl)(String(input));
    var startClocks = (0, $kklrV.clocksNow)();
    var context = {
        state: "start",
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url
    };
    observable.notify(context);
    // Those properties can be changed by observable subscribers
    parameters[0] = context.input;
    parameters[1] = context.init;
    onPostCall(function(responsePromise) {
        return $612482f325a88c44$var$afterSend(observable, responsePromise, context);
    });
}
function $612482f325a88c44$var$afterSend(observable, responsePromise, startContext) {
    var reportFetch = function(response) {
        var context = startContext;
        context.state = "resolve";
        if ("stack" in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
        } else if ("status" in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
        }
        observable.notify(context);
    };
    responsePromise.then((0, $5JqHL.monitor)(reportFetch), (0, $5JqHL.monitor)(reportFetch));
}

});
parcelRegister("18Uuo", function(module, exports) {

$parcel$export(module.exports, "instrumentMethod", () => $0d525b5f63f893af$export$f00f71a511cb3cac);

var $kiWyZ = parcelRequire("kiWyZ");

var $5JqHL = parcelRequire("5JqHL");

var $dBtKo = parcelRequire("dBtKo");

var $iD7Tb = parcelRequire("iD7Tb");
function $0d525b5f63f893af$export$f00f71a511cb3cac(targetPrototype, method, onPreCall) {
    var original = targetPrototype[method];
    if (typeof original !== "function") {
        if ((0, $iD7Tb.startsWith)(method, "on")) original = (0, $dBtKo.noop);
        else return {
            stop: (0, $dBtKo.noop)
        };
    }
    var instrumentation = $0d525b5f63f893af$var$createInstrumentedMethod(original, onPreCall);
    var instrumentationWrapper = function() {
        if (typeof instrumentation !== "function") return undefined;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
        return instrumentation.apply(this, arguments);
    };
    targetPrototype[method] = instrumentationWrapper;
    return {
        stop: function() {
            if (targetPrototype[method] === instrumentationWrapper) targetPrototype[method] = original;
            else instrumentation = original;
        }
    };
}
function $0d525b5f63f893af$var$createInstrumentedMethod(original, onPreCall) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return function() {
        var parameters = (0, $iD7Tb.arrayFrom)(arguments);
        var postCallCallback;
        (0, $5JqHL.callMonitored)(onPreCall, null, [
            {
                target: this,
                parameters: parameters,
                onPostCall: function(callback) {
                    postCallCallback = callback;
                }
            }
        ]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        var result = original.apply(this, parameters);
        if (postCallCallback) (0, $5JqHL.callMonitored)(postCallCallback, null, [
            result
        ]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return result;
    };
}
function $0d525b5f63f893af$export$2a2b9a3e88aa9011(targetPrototype, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) return {
        stop: (0, $dBtKo.noop)
    };
    var stoppedInstrumentation = (0, $dBtKo.noop);
    var instrumentation = function(target, value) {
        // put hooked setter into event loop to avoid of set latency
        (0, $kiWyZ.setTimeout)(function() {
            if (instrumentation !== stoppedInstrumentation) after(target, value);
        }, 0);
    };
    var instrumentationWrapper = function(value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(targetPrototype, property, {
        set: instrumentationWrapper
    });
    return {
        stop: function() {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(targetPrototype, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) Object.defineProperty(targetPrototype, property, originalDescriptor);
            instrumentation = stoppedInstrumentation;
        }
    };
}

});


parcelRegister("2q4A2", function(module, exports) {

$parcel$export(module.exports, "initXhrObservable", () => $1c318fffdd094920$export$1b29a115c614eaec);

var $18Uuo = parcelRequire("18Uuo");

var $3jm7f = parcelRequire("3jm7f");

var $kklrV = parcelRequire("kklrV");

var $ddsGY = parcelRequire("ddsGY");

var $3h3z3 = parcelRequire("3h3z3");

var $eVXiU = parcelRequire("eVXiU");
var $1c318fffdd094920$var$xhrObservable;
var $1c318fffdd094920$var$xhrContexts = new WeakMap();
function $1c318fffdd094920$export$1b29a115c614eaec(configuration) {
    if (!$1c318fffdd094920$var$xhrObservable) $1c318fffdd094920$var$xhrObservable = $1c318fffdd094920$var$createXhrObservable(configuration);
    return $1c318fffdd094920$var$xhrObservable;
}
function $1c318fffdd094920$var$createXhrObservable(configuration) {
    return new (0, $3jm7f.Observable)(function(observable) {
        var stopInstrumentingStart = (0, $18Uuo.instrumentMethod)(XMLHttpRequest.prototype, "open", $1c318fffdd094920$var$openXhr).stop;
        var stopInstrumentingSend = (0, $18Uuo.instrumentMethod)(XMLHttpRequest.prototype, "send", function(call) {
            $1c318fffdd094920$var$sendXhr(call, configuration, observable);
        }).stop;
        var stopInstrumentingAbort = (0, $18Uuo.instrumentMethod)(XMLHttpRequest.prototype, "abort", $1c318fffdd094920$var$abortXhr).stop;
        return function() {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
}
function $1c318fffdd094920$var$openXhr(_a) {
    var xhr = _a.target, _b = _a.parameters, method = _b[0], url = _b[1];
    $1c318fffdd094920$var$xhrContexts.set(xhr, {
        state: "open",
        method: String(method).toUpperCase(),
        url: (0, $ddsGY.normalizeUrl)(String(url))
    });
}
function $1c318fffdd094920$var$sendXhr(_a, configuration, observable) {
    var xhr = _a.target;
    var context = $1c318fffdd094920$var$xhrContexts.get(xhr);
    if (!context) return;
    var startContext = context;
    startContext.state = "start";
    startContext.startClocks = (0, $kklrV.clocksNow)();
    startContext.isAborted = false;
    startContext.xhr = xhr;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = (0, $18Uuo.instrumentMethod)(xhr, "onreadystatechange", function() {
        if (xhr.readyState === XMLHttpRequest.DONE) // Try to report the XHR as soon as possible, because the XHR may be mutated by the
        // application during a future event. For example, Angular is calling .abort() on
        // completed requests during an onreadystatechange event, so the status becomes '0'
        // before the request is collected.
        onEnd();
    }).stop;
    var onEnd = function() {
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) return;
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = "complete";
        completeContext.duration = (0, $kklrV.elapsed)(startContext.startClocks.timeStamp, (0, $kklrV.timeStampNow)());
        completeContext.status = xhr.status;
        observable.notify((0, $3h3z3.shallowClone)(completeContext));
    };
    var unsubscribeLoadEndListener = (0, $eVXiU.addEventListener)(configuration, xhr, "loadend", onEnd).stop;
    observable.notify(startContext);
}
function $1c318fffdd094920$var$abortXhr(_a) {
    var xhr = _a.target;
    var context = $1c318fffdd094920$var$xhrContexts.get(xhr);
    if (context) context.isAborted = true;
}

});

parcelRegister("3qBcr", function(module, exports) {

$parcel$export(module.exports, "isServerError", () => $27f0a7e4c1e40459$export$a7cbe72d7c4012af);
$parcel$export(module.exports, "tryToClone", () => $27f0a7e4c1e40459$export$8a0df03d5faeada4);
function $27f0a7e4c1e40459$export$a7cbe72d7c4012af(status) {
    return status >= 500;
}
function $27f0a7e4c1e40459$export$8a0df03d5faeada4(response) {
    try {
        return response.clone();
    } catch (e) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}

});

parcelRegister("idVn8", function(module, exports) {

$parcel$export(module.exports, "readBytesFromStream", () => $d445f1ca77059fd3$export$ecd154de096317dd);

var $5JqHL = parcelRequire("5JqHL");

var $dBtKo = parcelRequire("dBtKo");
function $d445f1ca77059fd3$export$ecd154de096317dd(stream, callback, options) {
    var reader = stream.getReader();
    var chunks = [];
    var readBytesCount = 0;
    readMore();
    function readMore() {
        reader.read().then((0, $5JqHL.monitor)(function(result) {
            if (result.done) {
                onDone();
                return;
            }
            if (options.collectStreamBody) chunks.push(result.value);
            readBytesCount += result.value.length;
            if (readBytesCount > options.bytesLimit) onDone();
            else readMore();
        }), (0, $5JqHL.monitor)(function(error) {
            return callback(error);
        }));
    }
    function onDone() {
        reader.cancel().catch(// we don't care if cancel fails, but we still need to catch the error to avoid reporting it
        // as an unhandled rejection
        (0, $dBtKo.noop));
        var bytes;
        var limitExceeded;
        if (options.collectStreamBody) {
            var completeBuffer_1;
            if (chunks.length === 1) // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
            // use it directly.
            completeBuffer_1 = chunks[0];
            else {
                // else, we need to copy buffers into a larger buffer to concatenate them.
                completeBuffer_1 = new Uint8Array(readBytesCount);
                var offset_1 = 0;
                chunks.forEach(function(chunk) {
                    completeBuffer_1.set(chunk, offset_1);
                    offset_1 += chunk.length;
                });
            }
            bytes = completeBuffer_1.slice(0, options.bytesLimit);
            limitExceeded = completeBuffer_1.length > options.bytesLimit;
        }
        callback(undefined, bytes, limitExceeded);
    }
}

});


parcelRegister("eJIwd", function(module, exports) {

$parcel$export(module.exports, "startRuntimeErrorCollection", () => $aba7cd1b07c6951f$export$ae6d2c609a1d871);

var $1PeMs = parcelRequire("1PeMs");
var $dBtKo = parcelRequire("dBtKo");
var $3jm7f = parcelRequire("3jm7f");
var $lqcY8 = parcelRequire("lqcY8");

var $bWwuo = parcelRequire("bWwuo");
function $aba7cd1b07c6951f$export$ae6d2c609a1d871(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) return {
        stop: (0, $dBtKo.noop)
    };
    var rawErrorObservable = new (0, $3jm7f.Observable)();
    var stopRuntimeErrorTracking = (0, $lqcY8.trackRuntimeError)(rawErrorObservable).stop;
    var rawErrorSubscription = rawErrorObservable.subscribe(function(rawError) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
            rawLogsEvent: {
                message: rawError.message,
                date: rawError.startClocks.timeStamp,
                error: {
                    kind: rawError.type,
                    stack: rawError.stack,
                    causes: rawError.causes
                },
                origin: (0, $1PeMs.ErrorSource).SOURCE,
                status: (0, $bWwuo.StatusType).error
            }
        });
    });
    return {
        stop: function() {
            stopRuntimeErrorTracking();
            rawErrorSubscription.unsubscribe();
        }
    };
}

});
parcelRegister("lqcY8", function(module, exports) {

$parcel$export(module.exports, "trackRuntimeError", () => $f986160fee21793b$export$5f76c2084a9e04d);

var $18Uuo = parcelRequire("18Uuo");

var $kklrV = parcelRequire("kklrV");

var $ezY4f = parcelRequire("ezY4f");

var $oZ6HF = parcelRequire("oZ6HF");

var $1PeMs = parcelRequire("1PeMs");
function $f986160fee21793b$export$5f76c2084a9e04d(errorObservable) {
    var handleRuntimeError = function(stackTrace, originalError) {
        var rawError = (0, $oZ6HF.computeRawError)({
            stackTrace: stackTrace,
            originalError: originalError,
            startClocks: (0, $kklrV.clocksNow)(),
            nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */ ,
            source: (0, $1PeMs.ErrorSource).SOURCE,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */ 
        });
        errorObservable.notify(rawError);
    };
    var stopInstrumentingOnError = $f986160fee21793b$export$f636584f9e54fd1(handleRuntimeError).stop;
    var stopInstrumentingOnUnhandledRejection = $f986160fee21793b$export$fac10d06c5b5cb33(handleRuntimeError).stop;
    return {
        stop: function() {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        }
    };
}
function $f986160fee21793b$export$f636584f9e54fd1(callback) {
    return (0, $18Uuo.instrumentMethod)(window, "onerror", function(_a) {
        var _b = _a.parameters, messageObj = _b[0], url = _b[1], line = _b[2], column = _b[3], errorObj = _b[4];
        var stackTrace;
        if (errorObj instanceof Error) stackTrace = (0, $ezY4f.computeStackTrace)(errorObj);
        else stackTrace = (0, $ezY4f.computeStackTraceFromOnErrorMessage)(messageObj, url, line, column);
        callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
    });
}
function $f986160fee21793b$export$fac10d06c5b5cb33(callback) {
    return (0, $18Uuo.instrumentMethod)(window, "onunhandledrejection", function(_a) {
        var e = _a.parameters[0];
        var reason = e.reason || "Empty reason";
        var stack = (0, $ezY4f.computeStackTrace)(reason);
        callback(stack, reason);
    });
}

});


parcelRegister("kyXIx", function(module, exports) {

$parcel$export(module.exports, "LifeCycle", () => $ef854e3b0f4c01a6$export$6af70476896cbaec);

var $fWqpV = parcelRequire("fWqpV");
var $ef854e3b0f4c01a6$export$6af70476896cbaec = (0, $fWqpV.AbstractLifeCycle);

});
parcelRegister("fWqpV", function(module, exports) {

$parcel$export(module.exports, "AbstractLifeCycle", () => $b9b0c3b2f4f67606$export$cf0c49d09be0ebd8);
var $b9b0c3b2f4f67606$export$cf0c49d09be0ebd8 = /** @class */ function() {
    function AbstractLifeCycle() {
        this.callbacks = {};
    }
    AbstractLifeCycle.prototype.notify = function(eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) eventCallbacks.forEach(function(callback) {
            return callback(data);
        });
    };
    AbstractLifeCycle.prototype.subscribe = function(eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) this.callbacks[eventType] = [];
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function() {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function(other) {
                    return callback !== other;
                });
            }
        };
    };
    return AbstractLifeCycle;
}();

});


parcelRegister("7wIAO", function(module, exports) {

$parcel$export(module.exports, "startLoggerCollection", () => $57ae1cbd0cd77feb$export$a909fdf2eb14fa81);

var $2JJbR = parcelRequire("2JJbR");
var $1PeMs = parcelRequire("1PeMs");
var $gqtZo = parcelRequire("gqtZo");
var $iD7Tb = parcelRequire("iD7Tb");
var $kklrV = parcelRequire("kklrV");

var $bWwuo = parcelRequire("bWwuo");
var $57ae1cbd0cd77feb$var$_a;
var $57ae1cbd0cd77feb$export$33137eb87fdcc0f7 = ($57ae1cbd0cd77feb$var$_a = {}, $57ae1cbd0cd77feb$var$_a[(0, $bWwuo.StatusType).debug] = 0, $57ae1cbd0cd77feb$var$_a[(0, $bWwuo.StatusType).info] = 1, $57ae1cbd0cd77feb$var$_a[(0, $bWwuo.StatusType).warn] = 2, $57ae1cbd0cd77feb$var$_a[(0, $bWwuo.StatusType).error] = 3, $57ae1cbd0cd77feb$var$_a);
function $57ae1cbd0cd77feb$export$a909fdf2eb14fa81(lifeCycle) {
    function handleLog(logsMessage, logger, savedCommonContext, savedDate) {
        var messageContext = (0, $2JJbR.combine)(logger.getContext(), logsMessage.context);
        if ($57ae1cbd0cd77feb$export$4f612ab7b7b1d133(logsMessage.status, (0, $bWwuo.HandlerType).console, logger)) $57ae1cbd0cd77feb$var$displayInConsole(logsMessage, messageContext);
        if ($57ae1cbd0cd77feb$export$4f612ab7b7b1d133(logsMessage.status, (0, $bWwuo.HandlerType).http, logger)) lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
            rawLogsEvent: {
                date: savedDate || (0, $kklrV.timeStampNow)(),
                message: logsMessage.message,
                status: logsMessage.status,
                origin: (0, $1PeMs.ErrorSource).LOGGER
            },
            messageContext: messageContext,
            savedCommonContext: savedCommonContext
        });
    }
    return {
        handleLog: handleLog
    };
}
function $57ae1cbd0cd77feb$export$4f612ab7b7b1d133(status, handlerType, logger) {
    var loggerHandler = logger.getHandler();
    var sanitizedHandlerType = Array.isArray(loggerHandler) ? loggerHandler : [
        loggerHandler
    ];
    return $57ae1cbd0cd77feb$export$33137eb87fdcc0f7[status] >= $57ae1cbd0cd77feb$export$33137eb87fdcc0f7[logger.getLevel()] && (0, $iD7Tb.includes)(sanitizedHandlerType, handlerType);
}
function $57ae1cbd0cd77feb$var$displayInConsole(logsMessage, messageContext) {
    (0, $gqtZo.originalConsoleMethods)[logsMessage.status].call((0, $gqtZo.globalConsole), logsMessage.message, messageContext);
}

});

parcelRegister("2KImc", function(module, exports) {

$parcel$export(module.exports, "startLogsBatch", () => $2012490634853bbe$export$e4658c4e9fa6ec0a);

var $1XqPc = parcelRequire("1XqPc");
var $1zhTz = parcelRequire("1zhTz");
function $2012490634853bbe$export$e4658c4e9fa6ec0a(configuration, lifeCycle, reportError, pageExitObservable, session) {
    var batch = (0, $1zhTz.startBatchWithReplica)(configuration, {
        endpoint: configuration.logsEndpointBuilder,
        encoder: (0, $1XqPc.createIdentityEncoder)()
    }, configuration.replica && {
        endpoint: configuration.replica.logsEndpointBuilder,
        encoder: (0, $1XqPc.createIdentityEncoder)()
    }, reportError, pageExitObservable, session.expireObservable);
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */ , function(serverLogsEvent) {
        batch.add(serverLogsEvent);
    });
    return batch;
}

});
parcelRegister("1XqPc", function(module, exports) {

$parcel$export(module.exports, "createIdentityEncoder", () => $16d01bf5e7828032$export$b5341466c7007825);

var $3EczY = parcelRequire("3EczY");
function $16d01bf5e7828032$export$b5341466c7007825() {
    var output = "";
    var outputBytesCount = 0;
    return {
        isAsync: false,
        get isEmpty () {
            return !output;
        },
        write: function(data, callback) {
            var additionalEncodedBytesCount = (0, $3EczY.computeBytesCount)(data);
            outputBytesCount += additionalEncodedBytesCount;
            output += data;
            if (callback) callback(additionalEncodedBytesCount);
        },
        finish: function(callback) {
            callback(this.finishSync());
        },
        finishSync: function() {
            var result = {
                output: output,
                outputBytesCount: outputBytesCount,
                rawBytesCount: outputBytesCount,
                pendingData: ""
            };
            output = "";
            outputBytesCount = 0;
            return result;
        },
        estimateEncodedBytesCount: function(data) {
            return data.length;
        }
    };
}

});

parcelRegister("1zhTz", function(module, exports) {

$parcel$export(module.exports, "startBatchWithReplica", () => $1246f0fb644b8b4f$export$b8ccdd9bc4dcc76e);

var $iR2Pi = parcelRequire("iR2Pi");

var $91XN6 = parcelRequire("91XN6");

var $f5Twx = parcelRequire("f5Twx");
function $1246f0fb644b8b4f$export$b8ccdd9bc4dcc76e(configuration, primary, replica, reportError, pageExitObservable, sessionExpireObservable) {
    var primaryBatch = createBatch(configuration, primary);
    var replicaBatch = replica && createBatch(configuration, replica);
    function createBatch(configuration, _a) {
        var endpoint = _a.endpoint, encoder = _a.encoder;
        return new (0, $iR2Pi.Batch)(encoder, (0, $91XN6.createHttpRequest)(configuration, endpoint, configuration.batchBytesLimit, reportError), (0, $f5Twx.createFlushController)({
            messagesLimit: configuration.batchMessagesLimit,
            bytesLimit: configuration.batchBytesLimit,
            durationLimit: configuration.flushTimeout,
            pageExitObservable: pageExitObservable,
            sessionExpireObservable: sessionExpireObservable
        }), configuration.messageBytesLimit);
    }
    return {
        flushObservable: primaryBatch.flushController.flushObservable,
        add: function(message, replicated) {
            if (replicated === void 0) replicated = true;
            primaryBatch.add(message);
            if (replicaBatch && replicated) replicaBatch.add(replica.transformMessage ? replica.transformMessage(message) : message);
        },
        upsert: function(message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) replicaBatch.upsert(replica.transformMessage ? replica.transformMessage(message) : message, key);
        },
        stop: function() {
            primaryBatch.stop();
            replicaBatch === null || replicaBatch === void 0 || replicaBatch.stop();
        }
    };
}

});
parcelRegister("iR2Pi", function(module, exports) {

$parcel$export(module.exports, "Batch", () => $db9f5e80e1df1afb$export$33b107562567fc47);

var $gqtZo = parcelRequire("gqtZo");

var $iD7Tb = parcelRequire("iD7Tb");

var $aZtSh = parcelRequire("aZtSh");

var $gS5dB = parcelRequire("gS5dB");

var $3EczY = parcelRequire("3EczY");
var $db9f5e80e1df1afb$export$33b107562567fc47 = /** @class */ function() {
    function Batch(encoder, request, flushController, messageBytesLimit) {
        var _this = this;
        this.encoder = encoder;
        this.request = request;
        this.flushController = flushController;
        this.messageBytesLimit = messageBytesLimit;
        this.upsertBuffer = {};
        this.flushSubscription = this.flushController.flushObservable.subscribe(function(event) {
            return _this.flush(event);
        });
    }
    Batch.prototype.add = function(message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function(message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.stop = function() {
        this.flushSubscription.unsubscribe();
    };
    Batch.prototype.flush = function(event) {
        var upsertMessages = (0, $iD7Tb.objectValues)(this.upsertBuffer).join("\n");
        this.upsertBuffer = {};
        var isPageExit = (0, $aZtSh.isPageExitReason)(event.reason);
        var send = isPageExit ? this.request.sendOnExit : this.request.send;
        if (isPageExit && // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
        // if the encoder is async we need to send two requests in some cases (one for encoded data
        // and the other for non-encoded data). But if it's not async, we don't have to worry about
        // it and always send a single request.
        this.encoder.isAsync) {
            var encoderResult = this.encoder.finishSync();
            // Send encoded messages
            if (encoderResult.outputBytesCount) send($db9f5e80e1df1afb$var$formatPayloadFromEncoder(encoderResult, event));
            // Send messages that are not yet encoded at this point
            var pendingMessages = [
                encoderResult.pendingData,
                upsertMessages
            ].filter(Boolean).join("\n");
            if (pendingMessages) send({
                data: pendingMessages,
                bytesCount: (0, $3EczY.computeBytesCount)(pendingMessages),
                flushReason: event.reason
            });
        } else {
            if (upsertMessages) this.encoder.write(this.encoder.isEmpty ? upsertMessages : "\n".concat(upsertMessages));
            this.encoder.finish(function(encoderResult) {
                send($db9f5e80e1df1afb$var$formatPayloadFromEncoder(encoderResult, event));
            });
        }
    };
    Batch.prototype.addOrUpdate = function(message, key) {
        var serializedMessage = (0, $gS5dB.jsonStringify)(message);
        var estimatedMessageBytesCount = this.encoder.estimateEncodedBytesCount(serializedMessage);
        if (estimatedMessageBytesCount >= this.messageBytesLimit) {
            (0, $gqtZo.display).warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
            return;
        }
        if (this.hasMessageFor(key)) this.remove(key);
        this.push(serializedMessage, estimatedMessageBytesCount, key);
    };
    Batch.prototype.push = function(serializedMessage, estimatedMessageBytesCount, key) {
        var _this = this;
        this.flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
        if (key !== undefined) {
            this.upsertBuffer[key] = serializedMessage;
            this.flushController.notifyAfterAddMessage();
        } else this.encoder.write(this.encoder.isEmpty ? serializedMessage : "\n".concat(serializedMessage), function(realMessageBytesCount) {
            _this.flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
        });
    };
    Batch.prototype.remove = function(key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesCount = this.encoder.estimateEncodedBytesCount(removedMessage);
        this.flushController.notifyAfterRemoveMessage(messageBytesCount);
    };
    Batch.prototype.hasMessageFor = function(key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    return Batch;
}();
function $db9f5e80e1df1afb$var$formatPayloadFromEncoder(encoderResult, flushEvent) {
    var data;
    if (typeof encoderResult.output === "string") data = encoderResult.output;
    else data = new Blob([
        encoderResult.output
    ], {
        // This will set the 'Content-Type: text/plain' header. Reasoning:
        // * The intake rejects the request if there is no content type.
        // * The browser will issue CORS preflight requests if we set it to 'application/json', which
        // could induce higher intake load (and maybe has other impacts).
        // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
        // new lines.
        type: "text/plain"
    });
    return {
        data: data,
        bytesCount: encoderResult.outputBytesCount,
        encoding: encoderResult.encoding,
        flushReason: flushEvent.reason
    };
}

});

parcelRegister("91XN6", function(module, exports) {

$parcel$export(module.exports, "createHttpRequest", () => $69329646f7b298a1$export$58d47321b4325073);

var $g1PLZ = parcelRequire("g1PLZ");

var $5JqHL = parcelRequire("5JqHL");

var $eVXiU = parcelRequire("eVXiU");

var $k80VE = parcelRequire("k80VE");
function $69329646f7b298a1$export$58d47321b4325073(configuration, endpointBuilder, bytesLimit, reportError) {
    var retryState = (0, $k80VE.newRetryState)();
    var sendStrategyForRetry = function(payload, onResponse) {
        return $69329646f7b298a1$export$4d5d13cecdd8b94d(configuration, endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function(payload) {
            (0, $k80VE.sendWithRetryStrategy)(payload, retryState, sendStrategyForRetry, endpointBuilder.trackType, reportError);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */ sendOnExit: function(payload) {
            $69329646f7b298a1$var$sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload);
        }
    };
}
function $69329646f7b298a1$var$sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload) {
    var canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
    if (canUseBeacon) try {
        var beaconUrl = endpointBuilder.build("beacon", payload);
        var isQueued = navigator.sendBeacon(beaconUrl, payload.data);
        if (isQueued) return;
    } catch (e) {
        $69329646f7b298a1$var$reportBeaconError(e);
    }
    var xhrUrl = endpointBuilder.build("xhr", payload);
    $69329646f7b298a1$export$998d51f5856d10f5(configuration, xhrUrl, payload.data);
}
var $69329646f7b298a1$var$hasReportedBeaconError = false;
function $69329646f7b298a1$var$reportBeaconError(e) {
    if (!$69329646f7b298a1$var$hasReportedBeaconError) {
        $69329646f7b298a1$var$hasReportedBeaconError = true;
        (0, $g1PLZ.addTelemetryError)(e);
    }
}
function $69329646f7b298a1$export$4d5d13cecdd8b94d(configuration, endpointBuilder, bytesLimit, payload, onResponse) {
    var canUseKeepAlive = $69329646f7b298a1$var$isKeepAliveSupported() && payload.bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        var fetchUrl = endpointBuilder.build("fetch", payload);
        fetch(fetchUrl, {
            method: "POST",
            body: payload.data,
            keepalive: true,
            mode: "cors"
        }).then((0, $5JqHL.monitor)(function(response) {
            return onResponse === null || onResponse === void 0 ? void 0 : onResponse({
                status: response.status,
                type: response.type
            });
        }), (0, $5JqHL.monitor)(function() {
            var xhrUrl = endpointBuilder.build("xhr", payload);
            // failed to queue the request
            $69329646f7b298a1$export$998d51f5856d10f5(configuration, xhrUrl, payload.data, onResponse);
        }));
    } else {
        var xhrUrl = endpointBuilder.build("xhr", payload);
        $69329646f7b298a1$export$998d51f5856d10f5(configuration, xhrUrl, payload.data, onResponse);
    }
}
function $69329646f7b298a1$var$isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && "keepalive" in new Request("http://a");
    } catch (_a) {
        return false;
    }
}
function $69329646f7b298a1$export$998d51f5856d10f5(configuration, url, data, onResponse) {
    var request = new XMLHttpRequest();
    request.open("POST", url, true);
    if (data instanceof Blob) // When using a Blob instance, IE does not use its 'type' to define the 'Content-Type' header
    // automatically, so the intake request ends up being rejected with an HTTP status 415
    // Defining the header manually fixes this issue.
    request.setRequestHeader("Content-Type", data.type);
    (0, $eVXiU.addEventListener)(configuration, request, "loadend", function() {
        onResponse === null || onResponse === void 0 || onResponse({
            status: request.status
        });
    }, {
        // prevent multiple onResponse callbacks
        // if the xhr instance is reused by a third party
        once: true
    });
    request.send(data);
}

});
parcelRegister("k80VE", function(module, exports) {

$parcel$export(module.exports, "sendWithRetryStrategy", () => $03c815c81379208a$export$96c9f5ab1844e401);
$parcel$export(module.exports, "newRetryState", () => $03c815c81379208a$export$1663dd4904e17e74);

var $kiWyZ = parcelRequire("kiWyZ");

var $kklrV = parcelRequire("kklrV");

var $3EczY = parcelRequire("3EczY");

var $3qBcr = parcelRequire("3qBcr");

var $1PeMs = parcelRequire("1PeMs");
var $03c815c81379208a$export$b0eb5f34be1e4aa5 = 80 * (0, $3EczY.ONE_KIBI_BYTE);
var $03c815c81379208a$export$86ca45574dbc49bd = 32;
var $03c815c81379208a$export$5557f582a01f898f = 3 * (0, $3EczY.ONE_MEBI_BYTE);
var $03c815c81379208a$export$ba196f7860333423 = (0, $kklrV.ONE_MINUTE);
var $03c815c81379208a$export$c3914d5086178577 = (0, $kklrV.ONE_SECOND);
function $03c815c81379208a$export$96c9f5ab1844e401(payload, state, sendStrategy, trackType, reportError) {
    if (state.transportStatus === 0 /* TransportStatus.UP */  && state.queuedPayloads.size() === 0 && state.bandwidthMonitor.canHandle(payload)) $03c815c81379208a$var$send(payload, state, sendStrategy, {
        onSuccess: function() {
            return $03c815c81379208a$var$retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */ , state, sendStrategy, trackType, reportError);
        },
        onFailure: function() {
            state.queuedPayloads.enqueue(payload);
            $03c815c81379208a$var$scheduleRetry(state, sendStrategy, trackType, reportError);
        }
    });
    else state.queuedPayloads.enqueue(payload);
}
function $03c815c81379208a$var$scheduleRetry(state, sendStrategy, trackType, reportError) {
    if (state.transportStatus !== 2 /* TransportStatus.DOWN */ ) return;
    (0, $kiWyZ.setTimeout)(function() {
        var payload = state.queuedPayloads.first();
        $03c815c81379208a$var$send(payload, state, sendStrategy, {
            onSuccess: function() {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = $03c815c81379208a$export$c3914d5086178577;
                $03c815c81379208a$var$retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */ , state, sendStrategy, trackType, reportError);
            },
            onFailure: function() {
                state.currentBackoffTime = Math.min($03c815c81379208a$export$ba196f7860333423, state.currentBackoffTime * 2);
                $03c815c81379208a$var$scheduleRetry(state, sendStrategy, trackType, reportError);
            }
        });
    }, state.currentBackoffTime);
}
function $03c815c81379208a$var$send(payload, state, sendStrategy, _a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, function(response) {
        state.bandwidthMonitor.remove(payload);
        if (!$03c815c81379208a$var$shouldRetryRequest(response)) {
            state.transportStatus = 0 /* TransportStatus.UP */ ;
            onSuccess();
        } else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus = state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */  : 2 /* TransportStatus.DOWN */ ;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status
            };
            onFailure();
        }
    });
}
function $03c815c81379208a$var$retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError) {
    if (reason === 0 /* RetryReason.AFTER_SUCCESS */  && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: "Reached max ".concat(trackType, " events size queued for upload: ").concat($03c815c81379208a$export$5557f582a01f898f / (0, $3EczY.ONE_MEBI_BYTE), "MiB"),
            source: (0, $1PeMs.ErrorSource).AGENT,
            startClocks: (0, $kklrV.clocksNow)()
        });
        state.queueFullReported = true;
    }
    var previousQueue = state.queuedPayloads;
    state.queuedPayloads = $03c815c81379208a$var$newPayloadQueue();
    while(previousQueue.size() > 0)$03c815c81379208a$export$96c9f5ab1844e401(previousQueue.dequeue(), state, sendStrategy, trackType, reportError);
}
function $03c815c81379208a$var$shouldRetryRequest(response) {
    return response.type !== "opaque" && (response.status === 0 && !navigator.onLine || response.status === 408 || response.status === 429 || (0, $3qBcr.isServerError)(response.status));
}
function $03c815c81379208a$export$1663dd4904e17e74() {
    return {
        transportStatus: 0 /* TransportStatus.UP */ ,
        currentBackoffTime: $03c815c81379208a$export$c3914d5086178577,
        bandwidthMonitor: $03c815c81379208a$var$newBandwidthMonitor(),
        queuedPayloads: $03c815c81379208a$var$newPayloadQueue(),
        queueFullReported: false
    };
}
function $03c815c81379208a$var$newPayloadQueue() {
    var queue = [];
    return {
        bytesCount: 0,
        enqueue: function(payload) {
            if (this.isFull()) return;
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
        },
        first: function() {
            return queue[0];
        },
        dequeue: function() {
            var payload = queue.shift();
            if (payload) this.bytesCount -= payload.bytesCount;
            return payload;
        },
        size: function() {
            return queue.length;
        },
        isFull: function() {
            return this.bytesCount >= $03c815c81379208a$export$5557f582a01f898f;
        }
    };
}
function $03c815c81379208a$var$newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle: function(payload) {
            return this.ongoingRequestCount === 0 || this.ongoingByteCount + payload.bytesCount <= $03c815c81379208a$export$b0eb5f34be1e4aa5 && this.ongoingRequestCount < $03c815c81379208a$export$86ca45574dbc49bd;
        },
        add: function(payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove: function(payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        }
    };
}

});


parcelRegister("f5Twx", function(module, exports) {

$parcel$export(module.exports, "createFlushController", () => $afd26484b25aaad0$export$afc20ff9bd852d2b);

var $3jm7f = parcelRequire("3jm7f");

var $kiWyZ = parcelRequire("kiWyZ");
function $afd26484b25aaad0$export$afc20ff9bd852d2b(_a) {
    var messagesLimit = _a.messagesLimit, bytesLimit = _a.bytesLimit, durationLimit = _a.durationLimit, pageExitObservable = _a.pageExitObservable, sessionExpireObservable = _a.sessionExpireObservable;
    var pageExitSubscription = pageExitObservable.subscribe(function(event) {
        return flush(event.reason);
    });
    var sessionExpireSubscription = sessionExpireObservable.subscribe(function() {
        return flush("session_expire");
    });
    var flushObservable = new (0, $3jm7f.Observable)(function() {
        return function() {
            pageExitSubscription.unsubscribe();
            sessionExpireSubscription.unsubscribe();
        };
    });
    var currentBytesCount = 0;
    var currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) return;
        var messagesCount = currentMessagesCount;
        var bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount: messagesCount,
            bytesCount: bytesCount
        });
    }
    var durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === undefined) durationLimitTimeoutId = (0, $kiWyZ.setTimeout)(function() {
            flush("duration_limit");
        }, durationLimit);
    }
    function cancelDurationLimitTimeout() {
        (0, $kiWyZ.clearTimeout)(durationLimitTimeoutId);
        durationLimitTimeoutId = undefined;
    }
    return {
        flushObservable: flushObservable,
        get messagesCount () {
            return currentMessagesCount;
        },
        /**
         * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right before adding the message, so no flush
         * event can happen after `notifyBeforeAddMessage` and before adding the message.
         *
         * @param estimatedMessageBytesCount: an estimation of the message bytes count once it is
         * actually added.
         */ notifyBeforeAddMessage: function(estimatedMessageBytesCount) {
            if (currentBytesCount + estimatedMessageBytesCount >= bytesLimit) flush("bytes_limit");
            // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
            // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
            // to notify when a flush is needed (for example on page exit).
            currentMessagesCount += 1;
            currentBytesCount += estimatedMessageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
         * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
         *
         * This function can be called asynchronously after the message was added, but in this case it
         * should not be called if a flush event occurred in between.
         *
         * @param messageBytesCountDiff: the difference between the estimated message bytes count and
         * its actual bytes count once added to the pool.
         */ notifyAfterAddMessage: function(messageBytesCountDiff) {
            if (messageBytesCountDiff === void 0) messageBytesCountDiff = 0;
            currentBytesCount += messageBytesCountDiff;
            if (currentMessagesCount >= messagesLimit) flush("messages_limit");
            else if (currentBytesCount >= bytesLimit) flush("bytes_limit");
        },
        /**
         * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right after removing the message, so no flush
         * event can happen after removing the message and before `notifyAfterRemoveMessage`.
         *
         * @param messageBytesCount: the message bytes count that was added to the pool. Should
         * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
         * `notifyAfterAddMessage`.
         */ notifyAfterRemoveMessage: function(messageBytesCount) {
            currentBytesCount -= messageBytesCount;
            currentMessagesCount -= 1;
            if (currentMessagesCount === 0) cancelDurationLimitTimeout();
        }
    };
}

});



parcelRegister("fMB8i", function(module, exports) {

$parcel$export(module.exports, "startLogsBridge", () => $b7d8248691c9107d$export$4849c54cce6266f6);

var $5Q4S1 = parcelRequire("5Q4S1");
function $b7d8248691c9107d$export$4849c54cce6266f6(lifeCycle) {
    var bridge = (0, $5Q4S1.getEventBridge)();
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */ , function(serverLogsEvent) {
        bridge.send("log", serverLogsEvent);
    });
}

});

parcelRegister("cWqpl", function(module, exports) {

$parcel$export(module.exports, "startInternalContext", () => $96bf62d73be35ec8$export$ee941cf091e8459);
function $96bf62d73be35ec8$export$ee941cf091e8459(sessionManager) {
    return {
        get: function(startTime) {
            var trackedSession = sessionManager.findTrackedSession(startTime);
            if (trackedSession) return {
                session_id: trackedSession.id
            };
        }
    };
}

});

parcelRegister("ax858", function(module, exports) {

$parcel$export(module.exports, "startReportError", () => $7ab34159054d9eb3$export$ec67f68cd82e645c);

var $g1PLZ = parcelRequire("g1PLZ");
var $1PeMs = parcelRequire("1PeMs");

var $bWwuo = parcelRequire("bWwuo");
function $7ab34159054d9eb3$export$ec67f68cd82e645c(lifeCycle) {
    return function(error) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
            rawLogsEvent: {
                message: error.message,
                date: error.startClocks.timeStamp,
                origin: (0, $1PeMs.ErrorSource).AGENT,
                status: (0, $bWwuo.StatusType).error
            }
        });
        (0, $g1PLZ.addTelemetryDebug)("Error reported to customer", {
            "error.message": error.message
        });
    };
}

});

parcelRegister("9uavD", function(module, exports) {

$parcel$export(module.exports, "startLogsTelemetry", () => $6e7f11535dfc7f62$export$83b27ed75e4578fb);

var $g1PLZ = parcelRequire("g1PLZ");
var $5Q4S1 = parcelRequire("5Q4S1");
var $1XqPc = parcelRequire("1XqPc");
var $1zhTz = parcelRequire("1zhTz");

var $21nkp = parcelRequire("21nkp");

var $kOKbp = parcelRequire("kOKbp");
function $6e7f11535dfc7f62$export$83b27ed75e4578fb(initConfiguration, configuration, reportError, pageExitObservable, session) {
    var telemetry = (0, $g1PLZ.startTelemetry)("browser-logs-sdk" /* TelemetryService.LOGS */ , configuration);
    telemetry.setContextProvider(function() {
        var _a, _b, _c, _d, _e, _f;
        return {
            application: {
                id: (_a = (0, $21nkp.getRUMInternalContext)()) === null || _a === void 0 ? void 0 : _a.application_id
            },
            session: {
                id: (_b = session.findTrackedSession()) === null || _b === void 0 ? void 0 : _b.id
            },
            view: {
                id: (_d = (_c = (0, $21nkp.getRUMInternalContext)()) === null || _c === void 0 ? void 0 : _c.view) === null || _d === void 0 ? void 0 : _d.id
            },
            action: {
                id: (_f = (_e = (0, $21nkp.getRUMInternalContext)()) === null || _e === void 0 ? void 0 : _e.user_action) === null || _f === void 0 ? void 0 : _f.id
            }
        };
    });
    var cleanupTasks = [];
    if ((0, $5Q4S1.canUseEventBridge)()) {
        var bridge_1 = (0, $5Q4S1.getEventBridge)();
        var telemetrySubscription_1 = telemetry.observable.subscribe(function(event) {
            return bridge_1.send("internal_telemetry", event);
        });
        cleanupTasks.push(function() {
            return telemetrySubscription_1.unsubscribe();
        });
    } else {
        var telemetryBatch_1 = (0, $1zhTz.startBatchWithReplica)(configuration, {
            endpoint: configuration.rumEndpointBuilder,
            encoder: (0, $1XqPc.createIdentityEncoder)()
        }, configuration.replica && {
            endpoint: configuration.replica.rumEndpointBuilder,
            encoder: (0, $1XqPc.createIdentityEncoder)()
        }, reportError, pageExitObservable, session.expireObservable);
        cleanupTasks.push(function() {
            return telemetryBatch_1.stop();
        });
        var telemetrySubscription_2 = telemetry.observable.subscribe(function(event) {
            return telemetryBatch_1.add(event, (0, $g1PLZ.isTelemetryReplicationAllowed)(configuration));
        });
        cleanupTasks.push(function() {
            return telemetrySubscription_2.unsubscribe();
        });
    }
    (0, $g1PLZ.addTelemetryConfiguration)((0, $kOKbp.serializeLogsConfiguration)(initConfiguration));
    return {
        telemetry: telemetry,
        stop: function() {
            cleanupTasks.forEach(function(task) {
                return task();
            });
        }
    };
}

});





parcelRegister("ajzHa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LocalProvider = void 0;
class $78275e0a13276d05$var$LocalProvider {
    init(...args) {
        console.info("Initialized decodable agent with local provider");
    }
    cleanup(...args) {
        console.info("Cleaned up decodable agent with local provider");
    }
    setUser(user) {
        console.info("Setting user", user);
    }
    setUserProperty(key, value) {
        console.info("Setting property on user", {
            [key]: value
        });
    }
    recordInfo(message, messageContext) {
        console.log(message, messageContext);
    }
    recordWarn(message, messageContext, error) {
        console.warn(message, messageContext, error);
    }
    recordError(message, error, messageContext) {
        console.error(message, error, messageContext);
    }
}
module.exports.LocalProvider = $78275e0a13276d05$var$LocalProvider;

});






parcelRegister("iuWnt", function(module, exports) {

$parcel$export(module.exports, "ScheduledAlerts", () => $c0159efeab3abb18$export$9ba69cb205dca49e);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $7Wk6y = parcelRequire("7Wk6y");
var $hvbBd = parcelRequire("hvbBd");

var $boPMs = parcelRequire("boPMs");

var $bXjp5 = parcelRequire("bXjp5");

var $gga7I = parcelRequire("gga7I");

var $11Ed5 = parcelRequire("11Ed5");

var $F94Hv = parcelRequire("F94Hv");
const $c0159efeab3abb18$var$scheduledAlerts = [
    //// Example maintenance window alert.
    // {
    //   key: "2024-04-03-dev-demo",
    //   type: "maintenance",
    //   message:
    //     "Stream creation and preview features may be unavailable during the window.",
    //   time: {
    //     start: new Date("2024-04-03T21:00:00.000Z"),
    //     end: new Date("2024-04-03T24:00:00.000Z"),
    //   },
    //   location: {
    //     // All of the dev cells, for PR demonstration purposes.
    //     cells: ["5", "6", "10", "11", "13", "14", "18"],
    //   },
    // },
    {
        key: "2024-04-30-VHOL",
        location: {
            global: true
        },
        type: "cta",
        message: "Hands-on Lab: Set up a real-time ETL pipeline with Gunnar Morling and Hans-Peter Grahsl on July 30th!",
        time: {
            start: new Date("2024-07-19T00:00:00.000Z"),
            end: new Date("2024-07-30T15:00:00.000Z")
        },
        cta: {
            label: "\uD83D\uDC49 Register",
            url: "https://info.decodable.co/lab-intro-to-real-time-etl-with-decodable?utm_medium=popup&utm_source=product&utm_term=&utm_content=&utm_campaign=hands-on-lab"
        }
    }
];
function $c0159efeab3abb18$export$4f87a9f0b6c60f75(alerts, account, dismissedAlerts, // Injectable for testing.
now = new Date()) {
    return alerts.find((alert)=>!dismissedAlerts.includes(alert.key) && alert.time.start.getTime() - (alert.type == "maintenance" ? 1 : 0) * (0, $11Ed5.timeUnit).day <= now.getTime() && alert.time.end.getTime() > now.getTime() && (alert.location.global || alert.location.regions?.includes(account.region) || alert.location.cells?.includes(account.cell)));
}
const $c0159efeab3abb18$var$dismissedAlertsStorageKey = "dismissedAlerts";
function $c0159efeab3abb18$export$9ba69cb205dca49e() {
    const storage = localStorage;
    const { activeAccount: activeAccount } = (0, $gga7I.useActiveAccount)();
    const [dismissedAlerts, setDismissedAlerts] = (0, $aOzEm.useState)(()=>$c0159efeab3abb18$var$tryParseJsonArray(storage.getItem($c0159efeab3abb18$var$dismissedAlertsStorageKey) ?? "[]", []));
    const dismissAlert = (0, $aOzEm.useCallback)(function(alertKey) {
        const dismissed = [
            ...dismissedAlerts,
            alertKey
        ];
        setDismissedAlerts(dismissed);
        storage.setItem($c0159efeab3abb18$var$dismissedAlertsStorageKey, JSON.stringify(dismissed));
    }, [
        dismissedAlerts
    ]);
    if (!activeAccount) return null;
    const activeAlertParams = $c0159efeab3abb18$export$4f87a9f0b6c60f75($c0159efeab3abb18$var$scheduledAlerts, activeAccount, dismissedAlerts);
    switch(activeAlertParams?.type){
        case "cta":
            return /*#__PURE__*/ (0, $2T9xh.jsx)($c0159efeab3abb18$export$cf23fe7fbd71fa51, {
                params: activeAlertParams,
                onDismiss: ()=>dismissAlert(activeAlertParams.key)
            });
        case "maintenance":
            return /*#__PURE__*/ (0, $2T9xh.jsx)($c0159efeab3abb18$export$394f2c5524088a22, {
                params: activeAlertParams,
                onDismiss: ()=>dismissAlert(activeAlertParams.key)
            });
        default:
            return null;
    }
}
function $c0159efeab3abb18$export$cf23fe7fbd71fa51({ params: params, onDismiss: onDismiss }) {
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bXjp5))), {
        severity: "info",
        sx: {
            margin: 0,
            padding: 0,
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)("span", {
                children: params.message
            }),
            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $7Wk6y.default), {
                sx: {
                    cursor: "pointer",
                    color: "inherit",
                    textDecoration: "underline",
                    marginLeft: "1.2ch"
                },
                href: params.cta.url,
                target: "_blank",
                children: [
                    params.cta.label,
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $F94Hv.default), {
                        sx: {
                            fontSize: "1em",
                            verticalAlign: "middle"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $7Wk6y.default), {
                sx: {
                    cursor: "pointer",
                    color: "inherit",
                    textDecoration: "underline",
                    marginLeft: "1.2ch"
                },
                onClick: onDismiss,
                children: "Dismiss"
            })
        ]
    });
}
function $c0159efeab3abb18$export$394f2c5524088a22({ params: params, onDismiss: onDismiss }) {
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bXjp5))), {
        severity: "warning",
        sx: {
            margin: 0,
            paddingX: 1,
            paddingY: 0,
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsxs)("span", {
                children: [
                    "A maintenance window is scheduled to begin on",
                    " ",
                    /*#__PURE__*/ (0, $2T9xh.jsx)($c0159efeab3abb18$var$Timestamp, {
                        timestamp: params.time.start
                    }),
                    " and end on ",
                    /*#__PURE__*/ (0, $2T9xh.jsx)($c0159efeab3abb18$var$Timestamp, {
                        timestamp: params.time.end
                    }),
                    ". ",
                    params.message
                ]
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $7Wk6y.default), {
                sx: {
                    cursor: "pointer",
                    color: "inherit",
                    textDecoration: "underline",
                    marginLeft: "1.2ch"
                },
                onClick: onDismiss,
                children: "Dismiss"
            })
        ]
    });
}
function $c0159efeab3abb18$var$Timestamp({ timestamp: timestamp }) {
    const { isoWithTimeZone: isoWithTimeZone, offset: offset } = (0, $aOzEm.useMemo)(()=>{
        const isoWithTimeZone = (0, (/*@__PURE__*/$parcel$interopDefault($boPMs)))(timestamp).toISOString(true);
        let offset = isoWithTimeZone.match(/(Z|[+-]\d\d:?(\d\d)?)$/)?.[0] ?? "local";
        offset = offset?.[0] == "Z" ? "UTC" : `UTC${offset}`;
        return {
            isoWithTimeZone: isoWithTimeZone,
            offset: offset
        };
    }, [
        timestamp
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $hvbBd.default), {
        title: isoWithTimeZone,
        children: /*#__PURE__*/ (0, $2T9xh.jsxs)("span", {
            style: {
                textDecoration: "underline"
            },
            children: [
                (0, (/*@__PURE__*/$parcel$interopDefault($boPMs)))(timestamp).format("D MMMM YYYY [at] h:mmA").trim(),
                " (",
                offset,
                ")"
            ]
        })
    });
}
// Parse the given string as an array,
// returning the given defaultValue if something goes wrong.
function $c0159efeab3abb18$var$tryParseJsonArray(json, defaultValue) {
    try {
        const maybeArray = JSON.parse(json);
        if (Array.isArray(maybeArray)) return maybeArray;
        return defaultValue;
    } catch  {
        return defaultValue;
    }
}

});
parcelRegister("boPMs", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("bXjp5", function(module, exports) {
"use strict";
var $8b444190083f7246$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8b444190083f7246$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2T9xh = parcelRequire("2T9xh");

const $8b444190083f7246$var$Alert_1 = $8b444190083f7246$var$__importDefault((parcelRequire("2JSAm")));
// A variant of the "Alert" component that spans across the screen and centers its content.
function $8b444190083f7246$var$AlertBanner(_a) {
    var alertProps = $8b444190083f7246$var$__rest(_a, []);
    return (0, $2T9xh.jsx)($8b444190083f7246$var$Alert_1.default, Object.assign({}, alertProps, {
        sx: Object.assign({
            borderRadius: 0,
            justifyContent: "center"
        }, alertProps.sx)
    }));
}
module.exports.default = $8b444190083f7246$var$AlertBanner;

});
parcelRegister("2JSAm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("2HnwK")).default);
$parcel$export(module.exports, "alertClasses", () => (parcelRequire("5B34R")).default);

var $2HnwK = parcelRequire("2HnwK");

var $5B34R = parcelRequire("5B34R");
"use client";
$parcel$exportWildcard(module.exports, $5B34R);

});


parcelRegister("11Ed5", function(module, exports) {

$parcel$export(module.exports, "timeUnit", () => $490efe44a68c37c0$export$a37c2d802be87f33);
$parcel$export(module.exports, "convertDuration", () => $490efe44a68c37c0$export$3082151037402ab5);
const $490efe44a68c37c0$var$millisecond = 1;
const $490efe44a68c37c0$var$second = 1000;
const $490efe44a68c37c0$var$minute = $490efe44a68c37c0$var$second * 60;
const $490efe44a68c37c0$var$hour = $490efe44a68c37c0$var$minute * 60;
const $490efe44a68c37c0$var$day = $490efe44a68c37c0$var$hour * 24;
const $490efe44a68c37c0$export$a37c2d802be87f33 = {
    millisecond: $490efe44a68c37c0$var$millisecond,
    second: $490efe44a68c37c0$var$second,
    minute: $490efe44a68c37c0$var$minute,
    hour: $490efe44a68c37c0$var$hour,
    day: $490efe44a68c37c0$var$day
};
function $490efe44a68c37c0$export$e772c8ff12451969(duration, unit = $490efe44a68c37c0$export$a37c2d802be87f33.millisecond) {
    return new Promise((resolve)=>{
        setTimeout(()=>resolve(null), duration * unit);
    });
}
function $490efe44a68c37c0$export$3082151037402ab5(duration, from, to) {
    return duration * $490efe44a68c37c0$export$a37c2d802be87f33[from] / $490efe44a68c37c0$export$a37c2d802be87f33[to];
}

});


parcelRegister("bMDHv", function(module, exports) {

$parcel$export(module.exports, "SideNav", () => $0d4d377ffbca00aa$export$1a35787d6353cf6a);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $5YTEB = parcelRequire("5YTEB");

var $cB0tV = parcelRequire("cB0tV");
var $byVw4 = parcelRequire("byVw4");
var $F94Hv = parcelRequire("F94Hv");
var $fKNLT = parcelRequire("fKNLT");
var $8OtCk = parcelRequire("8OtCk");

var $bfLP6 = parcelRequire("bfLP6");

var $jyGS9 = parcelRequire("jyGS9");

var $2Wdb2 = parcelRequire("2Wdb2");

var $ctp2t = parcelRequire("ctp2t");

var $4aqud = parcelRequire("4aqud");

var $jVvcL = parcelRequire("jVvcL");

var $ePYFP = parcelRequire("ePYFP");

var $1UcJI = parcelRequire("1UcJI");
const $0d4d377ffbca00aa$var$iconStyle = {
    fontSize: "1.4rem"
};
const $0d4d377ffbca00aa$var$navItemPadding = "1ch";
function $0d4d377ffbca00aa$export$1a35787d6353cf6a({ sx: sx }) {
    const { accountName: accountName } = (0, $5YTEB.useParams)();
    const upperNav = (0, $aOzEm.useMemo)(()=>[
            /*#__PURE__*/ (0, $2T9xh.jsx)($0d4d377ffbca00aa$var$NavItem, {
                icon: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $byVw4.default), {
                    sx: {
                        color: "primary",
                        ...$0d4d377ffbca00aa$var$iconStyle
                    }
                }),
                label: "Dashboard",
                href: `/${accountName}`
            }, "Dashboard"),
            /*#__PURE__*/ (0, $2T9xh.jsx)($0d4d377ffbca00aa$var$NavItem, {
                icon: /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ctp2t))), {
                    style: $0d4d377ffbca00aa$var$iconStyle
                }),
                label: "Connections",
                href: "connections"
            }, "Connections"),
            /*#__PURE__*/ (0, $2T9xh.jsx)($0d4d377ffbca00aa$var$NavItem, {
                icon: /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jVvcL))), {
                    style: $0d4d377ffbca00aa$var$iconStyle
                }),
                label: "Streams",
                href: "streams"
            }, "Streams"),
            /*#__PURE__*/ (0, $2T9xh.jsx)($0d4d377ffbca00aa$var$NavItem, {
                icon: /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4aqud))), {
                    style: $0d4d377ffbca00aa$var$iconStyle
                }),
                label: "Pipelines",
                href: "pipelines"
            }, "Pipelines")
        ], []);
    const lowerNav = (0, $aOzEm.useMemo)(()=>[
            /*#__PURE__*/ (0, $2T9xh.jsx)($0d4d377ffbca00aa$var$NavItem, {
                icon: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $fKNLT.default), {
                    style: $0d4d377ffbca00aa$var$iconStyle
                }),
                label: "Secrets",
                href: "secrets"
            }, "Secrets"),
            /*#__PURE__*/ (0, $2T9xh.jsx)($0d4d377ffbca00aa$var$NavItem, {
                icon: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $ePYFP.GroupIcon), {
                    style: $0d4d377ffbca00aa$var$iconStyle
                }),
                label: "Access Control",
                stem: "access",
                href: "access/users"
            }, "Access Control"),
            /*#__PURE__*/ (0, $2T9xh.jsx)($0d4d377ffbca00aa$var$NavItem, {
                icon: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8OtCk.default), {
                    style: $0d4d377ffbca00aa$var$iconStyle
                }),
                label: "Account Management",
                href: "account"
            }, "Account Management"),
            /*#__PURE__*/ (0, $2T9xh.jsx)($0d4d377ffbca00aa$var$NavItem, {
                label: /*#__PURE__*/ (0, $2T9xh.jsxs)("span", {
                    children: [
                        "Docs",
                        " ",
                        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $F94Hv.default), {
                            sx: {
                                fontSize: "0.9em",
                                verticalAlign: "middle"
                            }
                        })
                    ]
                }),
                icon: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $cB0tV.default), {
                    style: $0d4d377ffbca00aa$var$iconStyle
                }),
                href: "https://docs.decodable.co/"
            }, "Docs")
        ], []);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
        sx: {
            maxHeight: "100%",
            width: "10ch",
            bgcolor: "background.paper",
            borderRight: `solid 1px ${$0d4d377ffbca00aa$var$gray(90)}`,
            display: "grid",
            gridTemplateRows: "1fr auto",
            placeItems: "stretch",
            ...sx
        },
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                component: "nav",
                sx: {
                    display: "grid",
                    placeItems: "stretch",
                    overflow: "auto"
                },
                children: /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
                    sx: {
                        display: "grid",
                        placeItems: "stretch",
                        gridTemplateRows: `auto repeat(${upperNav.length}, auto) 1fr repeat(${lowerNav.length}, auto)`,
                        gridTemplateColumns: "1fr"
                    },
                    children: [
                        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $2Wdb2.ButtonLink), {
                            href: `/${accountName}`,
                            disableRipple: true,
                            sx: {
                                "&:hover": {
                                    bgcolor: "initial"
                                }
                            },
                            children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $1UcJI.DecodableLogoSmall), {
                                viewBox: "0 0 100 100",
                                style: {
                                    placeSelf: "center",
                                    width: "36px",
                                    height: "36px",
                                    margin: `calc(1.3rem + ${$0d4d377ffbca00aa$var$navItemPadding}) 0 1.3rem`
                                }
                            })
                        }),
                        upperNav,
                        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {}),
                        lowerNav
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                sx: {
                    borderTop: "1px solid rgb(90% 90% 90%)",
                    height: "85px",
                    width: "100%",
                    margin: 0,
                    padding: 0
                }
            })
        ]
    });
}
const $0d4d377ffbca00aa$var$NavItem = function NavItem({ icon: icon, label: label, href: href, stem: stem = href, onClick: onClick, sx: sx }) {
    const location = (0, $5YTEB.useLocation)();
    const pathname = location.pathname;
    const stemLocation = pathname[0] == "/" ? pathname.indexOf("/", 1) + 1 : 0;
    const isActive = location.pathname === href || stem && stemLocation > 0 ? location.pathname.slice(stemLocation, stemLocation + stem.length) == stem : false;
    const isExternalLink = href?.startsWith("http");
    const target = isExternalLink ? "_blank" : undefined;
    const ButtonComponent = isExternalLink ? (0, $bfLP6.default) : (0, $2Wdb2.ButtonLink);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)(ButtonComponent, {
        href: href,
        target: target,
        onClick: onClick,
        sx: {
            width: "100%",
            overflow: "hidden",
            padding: $0d4d377ffbca00aa$var$navItemPadding,
            margin: 0,
            display: "grid",
            gridTemplateColumns: "1fr",
            gridTemplateRows: "auto auto",
            placeItems: "center",
            fontWeight: 600,
            borderRadius: 0,
            color: isActive ? "text.primary" : "text.secondary",
            "&:hover": {
                color: "text.primary"
            },
            boxSizing: "border-box",
            borderRight: isActive ? "solid 2px black" : "none",
            borderLeft: "none",
            borderTop: "none"
        },
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                children: icon
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                sx: {
                    fontSize: "0.7rem",
                    paddingX: "0.2ch",
                    textAlign: "center",
                    lineHeight: "0.8rem"
                },
                children: label
            })
        ]
    });
};
function $0d4d377ffbca00aa$var$gray(percent) {
    return `rgb(${percent}% ${percent}% ${percent}%)`;
}
const $0d4d377ffbca00aa$var$communitySlackUrl = "https://decodablecommunity.slack.com/join/shared_invite/zt-uvow71bk-Uf914umgpoyIbOQSxriJkA#/shared-invite/email";

});
parcelRegister("cB0tV", function(module, exports) {

$parcel$export(module.exports, "default", () => $92b9505e22e03634$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $92b9505e22e03634$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
}), "Article");

});

parcelRegister("byVw4", function(module, exports) {

$parcel$export(module.exports, "default", () => $86af7c35f1028773$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $86af7c35f1028773$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
}), "Dashboard");

});

parcelRegister("fKNLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b781c278dcc7fae4$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $b781c278dcc7fae4$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
}), "Lock");

});

parcelRegister("8OtCk", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a9f79420ff2356$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $66a9f79420ff2356$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
}), "Settings");

});

parcelRegister("ctp2t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2T9xh = parcelRequire("2T9xh");
function $914b9da75fe826bb$var$Connection({ style: style }) {
    return (0, $2T9xh.jsxs)("svg", Object.assign({
        style: style,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $2T9xh.jsx)("circle", {
                cx: "12",
                cy: "11.9998",
                r: "5.14286",
                fill: "#0E0F18"
            }),
            (0, $2T9xh.jsx)("path", {
                d: "M15.0857 3.77126C15.0857 5.47545 13.7042 6.85698 12 6.85698C10.2958 6.85698 8.91431 5.47545 8.91431 3.77126C8.91431 2.06707 10.2958 0.685547 12 0.685547C13.7042 0.685547 15.0857 2.06707 15.0857 3.77126Z",
                fill: "#44E1BC"
            }),
            (0, $2T9xh.jsx)("path", {
                d: "M6.85716 11.9998C6.85716 13.704 5.47564 15.0855 3.77144 15.0855C2.06725 15.0855 0.68573 13.704 0.68573 11.9998C0.68573 10.2956 2.06725 8.91406 3.77144 8.91406C5.47564 8.91406 6.85716 10.2956 6.85716 11.9998Z",
                fill: "#44E1BC"
            }),
            (0, $2T9xh.jsx)("path", {
                d: "M23.3143 11.9998C23.3143 13.704 21.9328 15.0855 20.2286 15.0855C18.5244 15.0855 17.1429 13.704 17.1429 11.9998C17.1429 10.2956 18.5244 8.91406 20.2286 8.91406C21.9328 8.91406 23.3143 10.2956 23.3143 11.9998Z",
                fill: "#44E1BC"
            }),
            (0, $2T9xh.jsx)("path", {
                d: "M15.0857 20.2283C15.0857 21.9325 13.7042 23.314 12 23.314C10.2958 23.314 8.91431 21.9325 8.91431 20.2283C8.91431 18.5241 10.2958 17.1426 12 17.1426C13.7042 17.1426 15.0857 18.5241 15.0857 20.2283Z",
                fill: "#44E1BC"
            })
        ]
    }));
}
module.exports.default = $914b9da75fe826bb$var$Connection;

});

parcelRegister("4aqud", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2T9xh = parcelRequire("2T9xh");
function $308ca43faf997ce2$var$Pipeline({ style: style }) {
    return (0, $2T9xh.jsxs)("svg", Object.assign({
        style: style,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $2T9xh.jsx)("ellipse", {
                cx: "11.7203",
                cy: "11.9999",
                rx: "8.11128",
                ry: "8.11128",
                fill: "#0E0F18"
            }),
            (0, $2T9xh.jsx)("rect", {
                x: "1.37143",
                y: "9.48242",
                width: "21.2571",
                height: "5.03459",
                fill: "#0E0F18"
            }),
            (0, $2T9xh.jsx)("rect", {
                width: "21.2571",
                height: "5.03459",
                transform: "matrix(-0.500055 0.865994 -0.866057 -0.499945 19.2722 3.88867)",
                fill: "#0E0F18"
            }),
            (0, $2T9xh.jsx)("rect", {
                width: "21.2571",
                height: "5.03459",
                transform: "matrix(-0.500055 -0.865994 0.866057 -0.499945 15.3564 22.6289)",
                fill: "#0E0F18"
            }),
            (0, $2T9xh.jsx)("circle", {
                cx: "11.7203",
                cy: "11.7206",
                r: "3.63609",
                fill: "#FF70F1"
            })
        ]
    }));
}
module.exports.default = $308ca43faf997ce2$var$Pipeline;

});

parcelRegister("jVvcL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2T9xh = parcelRequire("2T9xh");
function $e81b8bd90889fb9f$var$Stream({ style: style }) {
    return (0, $2T9xh.jsxs)("svg", Object.assign({
        style: style,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $2T9xh.jsx)("ellipse", {
                cx: "12.1804",
                cy: "12.3428",
                rx: "8.22857",
                ry: "8.22857",
                fill: "#FFE182"
            }),
            (0, $2T9xh.jsx)("rect", {
                x: "14.3458",
                y: "10.6104",
                width: "8.66166",
                height: "3.46466",
                fill: "#FFE182"
            }),
            (0, $2T9xh.jsx)("circle", {
                cx: "12.1804",
                cy: "12.343",
                r: "4.76391",
                fill: "#0E0F18"
            }),
            (0, $2T9xh.jsx)("rect", {
                x: "0.920288",
                y: "10.6104",
                width: "8.66165",
                height: "3.46466",
                fill: "#0E0F18"
            })
        ]
    }));
}
module.exports.default = $e81b8bd90889fb9f$var$Stream;

});

parcelRegister("ePYFP", function(module, exports) {

$parcel$export(module.exports, "GroupIcon", () => $d06805f168b9006b$export$97eeb400c5f33310);

var $f9CrJ = parcelRequire("f9CrJ");
const $d06805f168b9006b$export$97eeb400c5f33310 = (0, $f9CrJ.default);

});
parcelRegister("f9CrJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b08584ebd9afdf40$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $b08584ebd9afdf40$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
}), "Group");

});


parcelRegister("1UcJI", function(module, exports) {

$parcel$export(module.exports, "DecodableLogoSmall", () => $0dfa62c7e107632c$export$b7ef7aa1da7144fe);

var $2T9xh = parcelRequire("2T9xh");
parcelRequire("aOzEm");
function $0dfa62c7e107632c$export$b7ef7aa1da7144fe(props) {
    return /*#__PURE__*/ (0, $2T9xh.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)("path", {
            fill: "#06091A",
            d: "M0 87.137v-20.06c6.21 0 12.167-2.466 16.559-6.856a23.4 23.4 0 0 0 0-33.1A23.424 23.424 0 0 0 0 20.265V.202a43.503 43.503 0 0 1 30.498 12.87 43.458 43.458 0 0 1 12.599 30.597 43.458 43.458 0 0 1-12.6 30.598A43.503 43.503 0 0 1 0 87.137ZM84.777 87.137l-27.515-27.5a22.586 22.586 0 0 1 0-31.916L84.777.216 100 15.432 71.731 43.686 100 71.936 84.777 87.137Z"
        })
    });
}

});


parcelRegister("8iH6y", function(module, exports) {

$parcel$export(module.exports, "default", () => $37b562e47861cfdb$export$2e2bcd8739ae039);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");
parcelRequire("57CDS");
var $5YTEB = parcelRequire("5YTEB");

var $2HnwK = parcelRequire("2HnwK");

var $7OQOe = parcelRequire("7OQOe");

var $gga7I = parcelRequire("gga7I");

var $2aiPz = parcelRequire("2aiPz");

var $1M3WI = parcelRequire("1M3WI");

var $cleXH = parcelRequire("cleXH");

var $lU03w = parcelRequire("lU03w");

var $i08ji = parcelRequire("i08ji");

var $22SrL = parcelRequire("22SrL");

var $29pjJ = parcelRequire("29pjJ");

var $d9FmX = parcelRequire("d9FmX");
function $37b562e47861cfdb$var$openCookieSettings() {
    // https://docs.osano.com/hiding-the-cookie-widget
    globalThis.Osano.cm.showDrawer("osano-cm-dom-info-dialog-open");
}
const $37b562e47861cfdb$export$c4e96258f3b6511 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).memo(function TopBar({ isLoading: isLoading = false, renderNav: renderNav, disableLogo: disableLogo }) {
    const { loginWithRedirect: loginWithRedirect, logout: logout, user: user, isLoading: isAuthLoading } = (0, $1M3WI.useAuth)();
    const navigate = (0, $5YTEB.useNavigate)();
    const { accounts: accounts } = (0, $gga7I.useAccounts)();
    const activeAccountCtx = (0, $gga7I.useActiveAccount)();
    const dispatch = (0, $29pjJ.useAppEventDispatch)();
    const { delayPassed: loadingDelayPassed } = (0, (/*@__PURE__*/$parcel$interopDefault($d9FmX)))(300);
    const login = ()=>loginWithRedirect((0, $cleXH.auth0LoginOptions)());
    const logoutToRoot = ()=>{
        dispatch("logout");
        logout({
            logoutParams: {
                returnTo: (0, $cleXH.rootUrl)(window.location)
            }
        });
    };
    return isAuthLoading ? /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7OQOe))), {
        disableLogo: disableLogo,
        anonymous: true
    }) : /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $2T9xh.Fragment), {
        children: [
            (0, $2aiPz.default).DECODABLE_ENV == "local" && /*#__PURE__*/ (0, $2T9xh.jsx)($37b562e47861cfdb$var$DevModeIndicator, {
                devUrl: (0, $2aiPz.default).DECODABLE_ACCOUNT_API_URL_TEMPLATE
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $i08ji.DataPlaneSetupAlert), {
                activeAccountCtx: activeAccountCtx
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7OQOe))), {
                disableLogo: disableLogo,
                user: user,
                userLoading: isAuthLoading,
                activeAccount: activeAccountCtx.activeAccount,
                homeHref: activeAccountCtx.activeAccount ? `/${activeAccountCtx.activeAccount.name}` : "/",
                onLogIn: login,
                renderNav: renderNav,
                renderActions: ()=>/*#__PURE__*/ (0, $2T9xh.jsx)((0, $22SrL.default), {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: activeAccountCtx.activeAccount ? /*#__PURE__*/ (0, $2T9xh.jsx)((0, $lU03w.OpenCommandPaletteButton), {}) : null
                    }),
                isLoading: loadingDelayPassed && isLoading,
                accountSwitcherPopoverProps: {
                    accountInfo: activeAccountCtx?.accountInfo,
                    accounts: accounts,
                    onLogOut: logoutToRoot,
                    onManageAccount: ()=>navigate(`/${activeAccountCtx.activeAccount.name}/account`),
                    onChangeAccount: (account)=>navigate(`/${account.name}`),
                    onNewAccount: ()=>navigate(`/-/accounts/create`),
                    onOpenCookieSettings: $37b562e47861cfdb$var$openCookieSettings
                }
            })
        ]
    });
});
$37b562e47861cfdb$export$c4e96258f3b6511.displayName;
var $37b562e47861cfdb$export$2e2bcd8739ae039 = $37b562e47861cfdb$export$c4e96258f3b6511;
function $37b562e47861cfdb$var$DevModeIndicator({ devUrl: devUrl }) {
    if (!devUrl) return null;
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $2HnwK.default), {
        severity: "warning",
        className: "dev-url",
        sx: {
            position: "fixed",
            bottom: 0,
            right: 0
        },
        children: [
            "Using API URL: ",
            devUrl
        ]
    });
}

});
parcelRegister("7OQOe", function(module, exports) {
"use strict";
var $5b162ab6e997b114$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2T9xh = parcelRequire("2T9xh");

const $5b162ab6e997b114$var$AppBar_1 = $5b162ab6e997b114$var$__importDefault((parcelRequire("bysGN")));

const $5b162ab6e997b114$var$Box_1 = $5b162ab6e997b114$var$__importDefault((parcelRequire("gBqWC")));

const $5b162ab6e997b114$var$Divider_1 = $5b162ab6e997b114$var$__importDefault((parcelRequire("eutNw")));

const $5b162ab6e997b114$var$Button_1 = $5b162ab6e997b114$var$__importDefault((parcelRequire("8EWcI")));

const $5b162ab6e997b114$var$AccountSwitcher_1 = $5b162ab6e997b114$var$__importDefault((parcelRequire("fkd9e")));

const $5b162ab6e997b114$var$LoadingBar_1 = $5b162ab6e997b114$var$__importDefault((parcelRequire("6ZsTd")));

const $5b162ab6e997b114$var$DecodableLogo_1 = $5b162ab6e997b114$var$__importDefault((parcelRequire("3WNkq")));

var $bteot = parcelRequire("bteot");
function $5b162ab6e997b114$var$AppBar({ anonymous: anonymous, disableLogo: disableLogo, user: user, userLoading: userLoading, activeAccount: activeAccount, homeHref: homeHref, onLogIn: onLogIn, renderNav: renderNav, renderActions: renderActions, isLoading: isLoading, accountSwitcherPopoverProps: accountSwitcherPopoverProps } = {
    userLoading: false
}) {
    const LinkComponent = (0, $bteot.useLink)();
    return (0, $2T9xh.jsxs)($5b162ab6e997b114$var$AppBar_1.default, Object.assign({
        elevation: 0,
        position: "sticky"
    }, {
        children: [
            (0, $2T9xh.jsxs)($5b162ab6e997b114$var$Box_1.default, Object.assign({
                sx: {
                    display: "grid",
                    placeItems: "stretch left",
                    gridTemplateAreas: '"left center right"',
                    gridTemplateColumns: "min-content auto 1fr"
                }
            }, {
                children: [
                    (0, $2T9xh.jsx)($5b162ab6e997b114$var$Box_1.default, Object.assign({
                        sx: {
                            flexGrow: 1,
                            flexDirection: "row",
                            display: "flex",
                            justifyContent: "flex-start"
                        }
                    }, {
                        children: disableLogo ? null : (0, $2T9xh.jsx)($5b162ab6e997b114$var$Button_1.default, Object.assign({
                            href: homeHref || "/",
                            component: LinkComponent,
                            sx: {
                                px: 2,
                                "&:hover": {
                                    bgcolor: "inherit"
                                }
                            }
                        }, {
                            children: (0, $2T9xh.jsx)($5b162ab6e997b114$var$DecodableLogo_1.default, {
                                style: {
                                    width: "16ch"
                                }
                            })
                        }))
                    })),
                    (0, $2T9xh.jsx)($5b162ab6e997b114$var$Box_1.default, Object.assign({
                        sx: {
                            placeSelf: "stretch",
                            display: "grid"
                        }
                    }, {
                        children: renderNav && renderNav()
                    })),
                    (0, $2T9xh.jsxs)($5b162ab6e997b114$var$Box_1.default, Object.assign({
                        sx: {
                            placeSelf: "stretch end",
                            display: "flex"
                        }
                    }, {
                        children: [
                            (0, $2T9xh.jsx)($5b162ab6e997b114$var$Box_1.default, Object.assign({
                                sx: {
                                    placeSelf: "center",
                                    display: "flex",
                                    alignItems: "center",
                                    padding: 0,
                                    paddingRight: "0.5ch",
                                    borderRight: "1px solid rgba(0,0,0,0.1)",
                                    borderRadius: 0,
                                    height: "100%"
                                }
                            }, {
                                children: renderActions && renderActions()
                            })),
                            !anonymous && !userLoading && user && (0, $2T9xh.jsx)($5b162ab6e997b114$var$AccountSwitcher_1.default, {
                                user: user,
                                activeAccount: activeAccount,
                                popoverProps: accountSwitcherPopoverProps,
                                buttonProps: {
                                    sx: {
                                        height: "100%"
                                    }
                                }
                            }),
                            !anonymous && !userLoading && user == undefined && (0, $2T9xh.jsx)($5b162ab6e997b114$var$Button_1.default, Object.assign({
                                sx: {
                                    height: "100%",
                                    borderRadius: 0
                                },
                                onClick: onLogIn
                            }, {
                                children: "Sign In"
                            }))
                        ]
                    }))
                ]
            })),
            (0, $2T9xh.jsx)($5b162ab6e997b114$var$Divider_1.default, {}),
            isLoading ? (0, $2T9xh.jsx)($5b162ab6e997b114$var$LoadingBar_1.default, {}) : null
        ]
    }));
}
module.exports.default = $5b162ab6e997b114$var$AppBar;

});
parcelRegister("bysGN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("d03LO")).default);
$parcel$export(module.exports, "appBarClasses", () => (parcelRequire("b2ohC")).default);

var $d03LO = parcelRequire("d03LO");

var $b2ohC = parcelRequire("b2ohC");
"use client";
$parcel$exportWildcard(module.exports, $b2ohC);

});
parcelRegister("d03LO", function(module, exports) {

$parcel$export(module.exports, "default", () => $976e3325d5ad13a5$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $63Oo6 = parcelRequire("63Oo6");

var $h0mm1 = parcelRequire("h0mm1");

var $b2ohC = parcelRequire("b2ohC");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $976e3325d5ad13a5$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $976e3325d5ad13a5$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $63Oo6.default)(color)}`,
            `position${(0, $63Oo6.default)(position)}`
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $b2ohC.getAppBarUtilityClass), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $976e3325d5ad13a5$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const $976e3325d5ad13a5$var$AppBarRoot = (0, $25zst.default)((0, $h0mm1.default), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $63Oo6.default)(ownerState.position)}`],
            styles[`color${(0, $63Oo6.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $g6Hsb.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $g6Hsb.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $g6Hsb.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $g6Hsb.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $976e3325d5ad13a5$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $976e3325d5ad13a5$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $976e3325d5ad13a5$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $976e3325d5ad13a5$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const $976e3325d5ad13a5$var$AppBar = /*#__PURE__*/ $aOzEm.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className, color: color = "primary", enableColorOnDark: enableColorOnDark = false, position: position = "fixed" } = props, other = (0, $cAqXo.default)(props, $976e3325d5ad13a5$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $976e3325d5ad13a5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($976e3325d5ad13a5$var$AppBarRoot, (0, $g6Hsb.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $g45Wv.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $976e3325d5ad13a5$export$2e2bcd8739ae039 = $976e3325d5ad13a5$var$AppBar;

});
parcelRegister("b2ohC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getAppBarUtilityClass", () => $8092b7bc2995c2ac$export$47a2da616e55e8e9);
$parcel$export(module.exports, "default", () => $8092b7bc2995c2ac$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $8092b7bc2995c2ac$export$47a2da616e55e8e9(slot) {
    return (0, $6vnyE.default)("MuiAppBar", slot);
}
const $8092b7bc2995c2ac$var$appBarClasses = (0, $cyhE3.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent"
]);
var $8092b7bc2995c2ac$export$2e2bcd8739ae039 = $8092b7bc2995c2ac$var$appBarClasses;

});



parcelRegister("gBqWC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("8aalP")).default);

var $8aalP = parcelRequire("8aalP");
"use client";

});

parcelRegister("eutNw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("9kABs")).default);
$parcel$export(module.exports, "dividerClasses", () => (parcelRequire("fBz0E")).default);

var $9kABs = parcelRequire("9kABs");

var $fBz0E = parcelRequire("fBz0E");
"use client";
$parcel$exportWildcard(module.exports, $fBz0E);

});
parcelRegister("9kABs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cb25ff3e08093f0$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $fOENh = parcelRequire("fOENh");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $fBz0E = parcelRequire("fBz0E");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $6cb25ff3e08093f0$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $6cb25ff3e08093f0$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $fBz0E.getDividerUtilityClass), classes);
};
const $6cb25ff3e08093f0$var$DividerRoot = (0, $25zst.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $fOENh.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState: ownerState })=>(0, $g6Hsb.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $g6Hsb.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $6cb25ff3e08093f0$var$DividerWrapper = (0, $25zst.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $6cb25ff3e08093f0$var$Divider = /*#__PURE__*/ $aOzEm.forwardRef(function Divider(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? "div" : "hr", flexItem: flexItem = false, light: light = false, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth" } = props, other = (0, $cAqXo.default)(props, $6cb25ff3e08093f0$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $6cb25ff3e08093f0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($6cb25ff3e08093f0$var$DividerRoot, (0, $g6Hsb.default)({
        as: component,
        className: (0, $g45Wv.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $2T9xh.jsx)($6cb25ff3e08093f0$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $6cb25ff3e08093f0$var$Divider.muiSkipListHighlight = true;
var $6cb25ff3e08093f0$export$2e2bcd8739ae039 = $6cb25ff3e08093f0$var$Divider;

});
parcelRegister("fBz0E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getDividerUtilityClass", () => $b5c577dd426afa64$export$46f01d01378ec5a2);
$parcel$export(module.exports, "default", () => $b5c577dd426afa64$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $b5c577dd426afa64$export$46f01d01378ec5a2(slot) {
    return (0, $6vnyE.default)("MuiDivider", slot);
}
const $b5c577dd426afa64$var$dividerClasses = (0, $cyhE3.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $b5c577dd426afa64$export$2e2bcd8739ae039 = $b5c577dd426afa64$var$dividerClasses;

});



parcelRegister("8EWcI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("bfLP6")).default);
$parcel$export(module.exports, "buttonClasses", () => (parcelRequire("d0jIa")).default);

var $bfLP6 = parcelRequire("bfLP6");

var $d0jIa = parcelRequire("d0jIa");
"use client";
$parcel$exportWildcard(module.exports, $d0jIa);

});

parcelRegister("fkd9e", function(module, exports) {
"use strict";
var $b282ec2ce6ea77c7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.compareAccounts = module.exports.planDisplayName = void 0;

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

const $b282ec2ce6ea77c7$var$Dns_1 = $b282ec2ce6ea77c7$var$__importDefault((parcelRequire("4J31E")));

const $b282ec2ce6ea77c7$var$ArrowDropDown_1 = $b282ec2ce6ea77c7$var$__importDefault((parcelRequire("8fO6J")));

const $b282ec2ce6ea77c7$var$Payment_1 = $b282ec2ce6ea77c7$var$__importDefault((parcelRequire("iOIbu")));

const $b282ec2ce6ea77c7$var$Avatar_1 = $b282ec2ce6ea77c7$var$__importDefault((parcelRequire("lwcBU")));

const $b282ec2ce6ea77c7$var$Box_1 = $b282ec2ce6ea77c7$var$__importDefault((parcelRequire("gBqWC")));

const $b282ec2ce6ea77c7$var$Button_1 = $b282ec2ce6ea77c7$var$__importDefault((parcelRequire("8EWcI")));

const $b282ec2ce6ea77c7$var$Stack_1 = $b282ec2ce6ea77c7$var$__importDefault((parcelRequire("iZ9ll")));

const $b282ec2ce6ea77c7$var$Popover_1 = $b282ec2ce6ea77c7$var$__importDefault((parcelRequire("2uDMf")));

var $bteot = parcelRequire("bteot");

var $gHT8P = parcelRequire("gHT8P");
var $kLsl2 = parcelRequire("kLsl2");
var $4uHU0 = parcelRequire("4uHU0");
var $8OtCk = parcelRequire("8OtCk");
function $b282ec2ce6ea77c7$var$AccountSwitcher({ user: user, activeAccount: activeAccount, popoverProps: popoverProps, buttonProps: buttonProps }) {
    const anchorRef = (0, $aOzEm.useRef)();
    const [open, setOpen] = (0, $aOzEm.useState)(false);
    if (!user) return null;
    const avatar = (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Avatar_1.default, {
        sx: {
            width: "32px",
            height: "32px"
        },
        src: user.picture,
        imgProps: {
            referrerPolicy: "no-referrer"
        }
    });
    const arrow = (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$ArrowDropDown_1.default, {
        sx: {
            transform: open ? "rotate(180deg)" : undefined,
            color: "text.secondary"
        }
    });
    let anchor;
    if (activeAccount) anchor = (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Button_1.default, Object.assign({
        ref: anchorRef
    }, buttonProps, {
        onClick: (...args)=>{
            var _a;
            (_a = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick) === null || _a === void 0 || _a.call(buttonProps, ...args);
            setOpen(!open);
        }
    }, {
        children: (0, $2T9xh.jsxs)($b282ec2ce6ea77c7$var$Stack_1.default, Object.assign({
            direction: "row",
            spacing: 2,
            sx: {
                width: "100%",
                alignItems: "center",
                px: "1ch",
                overflow: "hidden"
            }
        }, {
            children: [
                avatar,
                (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$AccountSummary, {
                    sx: {
                        lineHeight: "1.2em",
                        flexShrink: 1
                    },
                    account: activeAccount,
                    isActive: true
                }),
                arrow
            ]
        }))
    }));
    else anchor = (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Button_1.default, Object.assign({
        ref: anchorRef,
        onClick: ()=>setOpen(!open)
    }, {
        children: avatar
    }));
    return (0, $2T9xh.jsxs)($2T9xh.Fragment, {
        children: [
            anchor,
            (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$AccountSwitcherPopover, Object.assign({
                open: open,
                onClose: ()=>setOpen(false),
                anchor: anchorRef,
                activeAccount: activeAccount
            }, popoverProps))
        ]
    });
}
module.exports.default = $b282ec2ce6ea77c7$var$AccountSwitcher;
const $b282ec2ce6ea77c7$var$borderStyle = "1px solid rgb(90% 90% 90%)";
function $b282ec2ce6ea77c7$var$AccountSwitcherPopover({ open: open, anchor: anchor, accounts: accounts, activeAccount: activeAccount, accountInfo: accountInfo, onClose: onClose, onLogOut: onLogOut, onManageAccount: onManageAccount, onChangeAccount: onChangeAccount, onNewAccount: onNewAccount, onOpenCookieSettings: onOpenCookieSettings }) {
    const LinkComponent = (0, $bteot.useLink)();
    if (!(anchor === null || anchor === void 0 ? void 0 : anchor.current)) return null;
    const otherAccounts = (accounts || []).filter((a)=>a.name != (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.name)).sort($b282ec2ce6ea77c7$var$compareAccounts);
    let otherAccountsLabel = activeAccount ? "Other Accounts" : "Accounts";
    if (otherAccounts.length == 0) {
        if (!(accounts === null || accounts === void 0 ? void 0 : accounts.length)) otherAccountsLabel = "Your are not a member of any accounts";
        else otherAccountsLabel = "Your are not a member of any other accounts";
    }
    return (0, $2T9xh.jsxs)($b282ec2ce6ea77c7$var$Popover_1.default, Object.assign({
        open: open,
        onClose: onClose,
        anchorEl: anchor === null || anchor === void 0 ? void 0 : anchor.current,
        anchorOrigin: {
            vertical: "top",
            horizontal: "right"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "right"
        },
        sx: {
            overflow: "hidden"
        },
        PaperProps: {
            sx: {
                overflow: "hidden",
                maxHeight: "max(95vh, 30rem)",
                display: "grid",
                width: "400px",
                gridTemplateRows: "auto auto 1fr",
                "& > *": {
                    borderBottom: $b282ec2ce6ea77c7$var$borderStyle
                },
                "& > :last-child": {
                    borderBottom: "none"
                }
            }
        }
    }, {
        children: [
            (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Box_1.default, {
                children: activeAccount && (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$AccountDetails, {
                    account: activeAccount,
                    accountInfo: accountInfo,
                    onManageAccount: ()=>{
                        onManageAccount === null || onManageAccount === void 0 || onManageAccount();
                        onClose === null || onClose === void 0 || onClose();
                    }
                })
            }),
            (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Box_1.default, Object.assign({
                sx: {
                    fontWeight: "600",
                    fontSize: "90%",
                    color: "text.secondary",
                    bgcolor: "background.default",
                    padding: 1
                }
            }, {
                children: (0, $2T9xh.jsx)("span", {
                    children: otherAccountsLabel
                })
            })),
            (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Box_1.default, Object.assign({
                sx: {
                    display: "grid",
                    overflowY: "auto"
                }
            }, {
                children: otherAccounts === null || otherAccounts === void 0 ? void 0 : otherAccounts.map((acc, i)=>(0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Button_1.default, Object.assign({
                        component: LinkComponent,
                        href: `/${acc.name}`,
                        sx: {
                            borderBottom: i == otherAccounts.length - 1 ? undefined : $b282ec2ce6ea77c7$var$borderStyle,
                            justifyContent: "stretch"
                        },
                        onClick: ()=>onChangeAccount === null || onChangeAccount === void 0 ? void 0 : onChangeAccount(acc)
                    }, {
                        children: (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$AccountSummary, {
                            account: acc,
                            isActive: false
                        })
                    }), acc.name))
            })),
            onNewAccount ? (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Box_1.default, Object.assign({
                sx: {
                    padding: 1
                }
            }, {
                children: (0, $2T9xh.jsxs)($b282ec2ce6ea77c7$var$Button_1.default, Object.assign({
                    fullWidth: true,
                    variant: "contained",
                    color: "secondary",
                    sx: {
                        display: "flex",
                        gap: "1ch",
                        fontWeight: "500",
                        border: $b282ec2ce6ea77c7$var$borderStyle
                    },
                    onClick: ()=>{
                        onClose === null || onClose === void 0 || onClose();
                        onNewAccount();
                    }
                }, {
                    children: [
                        (0, $2T9xh.jsx)($gHT8P.default, {}),
                        " New Account"
                    ]
                }))
            })) : null,
            onLogOut ? (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Box_1.default, Object.assign({
                sx: {
                    padding: 1
                }
            }, {
                children: (0, $2T9xh.jsxs)($b282ec2ce6ea77c7$var$Button_1.default, Object.assign({
                    fullWidth: true,
                    variant: "contained",
                    sx: {
                        display: "flex",
                        gap: "1ch",
                        fontWeight: "500",
                        border: $b282ec2ce6ea77c7$var$borderStyle
                    },
                    onClick: ()=>{
                        onClose === null || onClose === void 0 || onClose();
                        onLogOut();
                    }
                }, {
                    children: [
                        (0, $2T9xh.jsx)($4uHU0.default, {}),
                        " Sign Out"
                    ]
                }))
            })) : null,
            onOpenCookieSettings ? (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Box_1.default, Object.assign({
                sx: {
                    display: "flex",
                    justifyContent: "right"
                }
            }, {
                children: (0, $2T9xh.jsxs)($b282ec2ce6ea77c7$var$Button_1.default, Object.assign({
                    variant: "text",
                    color: "secondary",
                    sx: {
                        display: "flex",
                        gap: "0.8ch",
                        fontWeight: "500",
                        fontSize: "0.75rem",
                        color: "text.secondary"
                    },
                    onClick: ()=>{
                        onClose === null || onClose === void 0 || onClose();
                        onOpenCookieSettings();
                    }
                }, {
                    children: [
                        (0, $2T9xh.jsx)($kLsl2.default, {
                            sx: {
                                fontSize: "1rem"
                            }
                        }),
                        "Cookies"
                    ]
                }))
            })) : null
        ]
    }));
}
function $b282ec2ce6ea77c7$var$AccountDetails({ account: account, accountInfo: accountInfo, onManageAccount: onManageAccount }) {
    const LinkComponent = (0, $bteot.useLink)();
    return (0, $2T9xh.jsxs)($b282ec2ce6ea77c7$var$Stack_1.default, Object.assign({
        sx: {
            alignItems: "flex-start",
            minWidth: "400px",
            padding: 1
        }
    }, {
        children: [
            (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Box_1.default, Object.assign({
                sx: {
                    fontWeight: "600"
                }
            }, {
                children: account === null || account === void 0 ? void 0 : account.display_name
            })),
            (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Box_1.default, Object.assign({
                sx: {
                    color: "text.secondary"
                }
            }, {
                children: (0, $2T9xh.jsx)("pre", Object.assign({
                    style: {
                        margin: 0,
                        whiteSpace: "pre-wrap"
                    }
                }, {
                    children: (0, $2T9xh.jsx)("code", {
                        children: account === null || account === void 0 ? void 0 : account.name
                    })
                }))
            })),
            (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$IconBullet, {
                sx: {
                    marginTop: 1
                },
                icon: (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Dns_1.default, {}),
                text: "Cloud Region",
                secondaryText: account === null || account === void 0 ? void 0 : account.region
            }),
            (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$IconBullet, {
                sx: {
                    marginTop: 1
                },
                icon: (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Payment_1.default, {}),
                text: "Plan",
                secondaryText: $b282ec2ce6ea77c7$var$planDisplayName(accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.subscription.plan_id)
            }),
            (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Stack_1.default, Object.assign({
                direction: "row",
                justifyContent: "stretch",
                alignSelf: "stretch",
                alignItems: "center",
                spacing: 1,
                marginTop: 1
            }, {
                children: (0, $2T9xh.jsxs)($b282ec2ce6ea77c7$var$Button_1.default, Object.assign({
                    variant: "contained",
                    component: LinkComponent,
                    href: `/${account.name}/account`,
                    color: "secondary",
                    sx: {
                        display: "flex",
                        gap: "1ch",
                        fontWeight: "500",
                        width: "100%",
                        border: "1px solid rgb(90% 90% 90%)"
                    },
                    onClick: (e)=>{
                        if (onManageAccount) {
                            e.preventDefault();
                            onManageAccount();
                        }
                    }
                }, {
                    children: [
                        (0, $2T9xh.jsx)($8OtCk.default, {}),
                        " Manage Account"
                    ]
                }))
            }))
        ]
    }));
}
function $b282ec2ce6ea77c7$var$IconBullet({ sx: sx, icon: icon, text: text, secondaryText: secondaryText }) {
    return (0, $2T9xh.jsxs)($b282ec2ce6ea77c7$var$Stack_1.default, Object.assign({
        direction: "row",
        sx: Object.assign({
            justifyContent: "flex-start",
            alignItems: "center"
        }, sx)
    }, {
        children: [
            (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Box_1.default, Object.assign({
                sx: {
                    padding: 1,
                    paddingRight: 2
                }
            }, {
                children: icon
            })),
            (0, $2T9xh.jsxs)($b282ec2ce6ea77c7$var$Stack_1.default, Object.assign({
                sx: {
                    alignItems: "flex-start",
                    justifyContent: "center"
                }
            }, {
                children: [
                    (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Box_1.default, Object.assign({
                        sx: {
                            fontWeight: "500"
                        }
                    }, {
                        children: text
                    })),
                    secondaryText ? (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Box_1.default, Object.assign({
                        sx: {
                            color: "text.secondary"
                        }
                    }, {
                        children: secondaryText
                    })) : null
                ]
            }))
        ]
    }));
}
function $b282ec2ce6ea77c7$var$AccountSummary({ sx: sx, account: account, isActive: isActive }) {
    return (0, $2T9xh.jsxs)($b282ec2ce6ea77c7$var$Stack_1.default, Object.assign({
        sx: Object.assign({
            maxWidth: "100%",
            alignItems: "flex-start",
            paddingX: 1
        }, sx)
    }, {
        children: [
            (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Box_1.default, Object.assign({
                sx: {
                    maxWidth: "100%",
                    fontWeight: isActive ? "500" : undefined,
                    fontSize: "110%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }
            }, {
                children: account.display_name
            })),
            (0, $2T9xh.jsx)($b282ec2ce6ea77c7$var$Box_1.default, Object.assign({
                sx: {
                    color: "text.secondary"
                }
            }, {
                children: account === null || account === void 0 ? void 0 : account.region
            }))
        ]
    }));
}
function $b282ec2ce6ea77c7$var$planDisplayName(plan_id) {
    switch(plan_id){
        case "free":
            return "Developer";
        case "on_demand":
            return "Team";
        case "enterprise":
            return "Enterprise";
        case "internal_test":
            return "Internal Test";
        default:
            return plan_id;
    }
}
module.exports.planDisplayName = $b282ec2ce6ea77c7$var$planDisplayName;
function $b282ec2ce6ea77c7$var$compareAccounts(a, b) {
    var _a, _b;
    // We generally sort by lower-cased display name, but break ties by case-sensitive match,
    // and finally by the region name. So the sort keys are these tokens separated by the nul char.
    const nul = "\0";
    const aKey = `${(_a = a.display_name) === null || _a === void 0 ? void 0 : _a.toLowerCase()}${nul}${a.display_name}${nul}${a === null || a === void 0 ? void 0 : a.region}`;
    const bKey = `${(_b = b.display_name) === null || _b === void 0 ? void 0 : _b.toLowerCase()}${nul}${b.display_name}${nul}${b === null || b === void 0 ? void 0 : b.region}`;
    if (aKey < bKey) return -1;
    if (aKey > bKey) return 1;
    return 0;
}
module.exports.compareAccounts = $b282ec2ce6ea77c7$var$compareAccounts;

});
parcelRegister("4J31E", function(module, exports) {
"use strict";
"use client";

var $8uFn9 = parcelRequire("8uFn9");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $370db637c20e41ce$var$_createSvgIcon = $8uFn9((parcelRequire("5QdpD")));

var $2T9xh = parcelRequire("2T9xh");
var $370db637c20e41ce$var$_default = (0, $370db637c20e41ce$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
}), "Dns");
module.exports.default = $370db637c20e41ce$var$_default;

});
parcelRegister("8uFn9", function(module, exports) {
function $62f137c411bca01b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $62f137c411bca01b$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5QdpD", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9hLGI.default;
    }
});

var $9hLGI = parcelRequire("9hLGI");

});


parcelRegister("8fO6J", function(module, exports) {
"use strict";
"use client";

var $8uFn9 = parcelRequire("8uFn9");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $602697c7b4b87b03$var$_createSvgIcon = $8uFn9((parcelRequire("5QdpD")));

var $2T9xh = parcelRequire("2T9xh");
var $602697c7b4b87b03$var$_default = (0, $602697c7b4b87b03$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), "ArrowDropDown");
module.exports.default = $602697c7b4b87b03$var$_default;

});

parcelRegister("iOIbu", function(module, exports) {
"use strict";
"use client";

var $8uFn9 = parcelRequire("8uFn9");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db2f2b93c3ece9d6$var$_createSvgIcon = $8uFn9((parcelRequire("5QdpD")));

var $2T9xh = parcelRequire("2T9xh");
var $db2f2b93c3ece9d6$var$_default = (0, $db2f2b93c3ece9d6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
}), "Payment");
module.exports.default = $db2f2b93c3ece9d6$var$_default;

});

parcelRegister("lwcBU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("7R5TO")).default);
$parcel$export(module.exports, "avatarClasses", () => (parcelRequire("4YDwL")).default);

var $7R5TO = parcelRequire("7R5TO");

var $4YDwL = parcelRequire("4YDwL");
"use client";
$parcel$exportWildcard(module.exports, $4YDwL);

});
parcelRegister("7R5TO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b820f19aefd00d7$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $iPMvO = parcelRequire("iPMvO");

var $4YDwL = parcelRequire("4YDwL");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $5b820f19aefd00d7$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $5b820f19aefd00d7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $4YDwL.getAvatarUtilityClass), classes);
};
const $5b820f19aefd00d7$var$AvatarRoot = (0, $25zst.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === "square" && {
        borderRadius: 0
    }, ownerState.colorDefault && (0, $g6Hsb.default)({
        color: (theme.vars || theme).palette.background.default
    }, theme.vars ? {
        backgroundColor: theme.vars.palette.Avatar.defaultBg
    } : {
        backgroundColor: theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600]
    })));
const $5b820f19aefd00d7$var$AvatarImg = (0, $25zst.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $5b820f19aefd00d7$var$AvatarFallback = (0, $25zst.default)((0, $iPMvO.default), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function $5b820f19aefd00d7$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $aOzEm.useState(false);
    $aOzEm.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $5b820f19aefd00d7$var$Avatar = /*#__PURE__*/ $aOzEm.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt: alt, children: childrenProp, className: className, component: component = "div", imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = "circular" } = props, other = (0, $cAqXo.default)(props, $5b820f19aefd00d7$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $5b820f19aefd00d7$var$useLoaded((0, $g6Hsb.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, $g6Hsb.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $5b820f19aefd00d7$var$useUtilityClasses(ownerState);
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $2T9xh.jsx)($5b820f19aefd00d7$var$AvatarImg, (0, $g6Hsb.default)({
        alt: alt,
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        ownerState: ownerState,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $2T9xh.jsx)($5b820f19aefd00d7$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $2T9xh.jsx)($5b820f19aefd00d7$var$AvatarRoot, (0, $g6Hsb.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $g45Wv.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $5b820f19aefd00d7$export$2e2bcd8739ae039 = $5b820f19aefd00d7$var$Avatar;

});
parcelRegister("iPMvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $db629ee4874ce3cf$export$2e2bcd8739ae039);
parcelRequire("aOzEm");

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $db629ee4874ce3cf$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");

});

parcelRegister("4YDwL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getAvatarUtilityClass", () => $39fb6d5df8221b22$export$ffd560f22c0ecf04);
$parcel$export(module.exports, "default", () => $39fb6d5df8221b22$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $39fb6d5df8221b22$export$ffd560f22c0ecf04(slot) {
    return (0, $6vnyE.default)("MuiAvatar", slot);
}
const $39fb6d5df8221b22$var$avatarClasses = (0, $cyhE3.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $39fb6d5df8221b22$export$2e2bcd8739ae039 = $39fb6d5df8221b22$var$avatarClasses;

});



parcelRegister("iZ9ll", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("gvXbM")).default);
$parcel$export(module.exports, "stackClasses", () => (parcelRequire("jV4z7")).default);

var $gvXbM = parcelRequire("gvXbM");

var $jV4z7 = parcelRequire("jV4z7");
"use client";

});
parcelRegister("jV4z7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e806e1d0001ec551$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $e806e1d0001ec551$export$d667a7de734a892c(slot) {
    return (0, $6vnyE.default)("MuiStack", slot);
}
const $e806e1d0001ec551$var$stackClasses = (0, $cyhE3.default)("MuiStack", [
    "root"
]);
var $e806e1d0001ec551$export$2e2bcd8739ae039 = $e806e1d0001ec551$var$stackClasses;

});


parcelRegister("2uDMf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("9wBxU")).default);
$parcel$export(module.exports, "popoverClasses", () => (parcelRequire("hEyAT")).default);

var $9wBxU = parcelRequire("9wBxU");

var $hEyAT = parcelRequire("hEyAT");
"use client";
$parcel$exportWildcard(module.exports, $9wBxU);
$parcel$exportWildcard(module.exports, $hEyAT);

});
parcelRegister("9wBxU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getOffsetTop", () => $6ef43a0eadc1505e$export$6fcff0dc60346367);
$parcel$export(module.exports, "getOffsetLeft", () => $6ef43a0eadc1505e$export$a6a488ff68b1bf7b);
$parcel$export(module.exports, "PopoverRoot", () => $6ef43a0eadc1505e$export$bcce13685275fc99);
$parcel$export(module.exports, "PopoverPaper", () => $6ef43a0eadc1505e$export$821346c38a2d9390);
$parcel$export(module.exports, "default", () => $6ef43a0eadc1505e$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $cwzzR = parcelRequire("cwzzR");
var $b2r0b = parcelRequire("b2r0b");
var $74GFZ = parcelRequire("74GFZ");


var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $kUqcz = parcelRequire("kUqcz");

var $h2Mbk = parcelRequire("h2Mbk");

var $bXNbj = parcelRequire("bXNbj");

var $eedeo = parcelRequire("eedeo");

var $fe2oA = parcelRequire("fe2oA");

var $k9mDT = parcelRequire("k9mDT");

var $h0mm1 = parcelRequire("h0mm1");

var $hEyAT = parcelRequire("hEyAT");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $6ef43a0eadc1505e$var$_excluded = [
    "onEntering"
], $6ef43a0eadc1505e$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $6ef43a0eadc1505e$var$_excluded3 = [
    "slotProps"
];
function $6ef43a0eadc1505e$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $6ef43a0eadc1505e$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $6ef43a0eadc1505e$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $6ef43a0eadc1505e$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $6ef43a0eadc1505e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $hEyAT.getPopoverUtilityClass), classes);
};
const $6ef43a0eadc1505e$export$bcce13685275fc99 = (0, $25zst.default)((0, $k9mDT.default), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $6ef43a0eadc1505e$export$821346c38a2d9390 = (0, $25zst.default)((0, $h0mm1.default), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $6ef43a0eadc1505e$var$Popover = /*#__PURE__*/ $aOzEm.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $fe2oA.default), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $cAqXo.default)(props.TransitionProps, $6ef43a0eadc1505e$var$_excluded), other = (0, $cAqXo.default)(props, $6ef43a0eadc1505e$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $aOzEm.useRef();
    const handlePaperRef = (0, $eedeo.default)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $6ef43a0eadc1505e$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $aOzEm.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $6ef43a0eadc1505e$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $h2Mbk.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $6ef43a0eadc1505e$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $6ef43a0eadc1505e$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $aOzEm.useCallback((elemRect)=>{
        return {
            vertical: $6ef43a0eadc1505e$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $6ef43a0eadc1505e$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $aOzEm.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $6ef43a0eadc1505e$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $bXNbj.default)($6ef43a0eadc1505e$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $6ef43a0eadc1505e$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $aOzEm.useState(open);
    const setPositioningStyles = $aOzEm.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $aOzEm.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $aOzEm.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $aOzEm.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $aOzEm.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $kUqcz.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $bXNbj.default)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $h2Mbk.default)($6ef43a0eadc1505e$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $6ef43a0eadc1505e$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $6ef43a0eadc1505e$export$821346c38a2d9390;
    const paperProps = (0, $74GFZ.useSlotProps)({
        elementType: PaperSlot,
        externalSlotProps: (0, $g6Hsb.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $g6Hsb.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $g45Wv.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $74GFZ.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $g45Wv.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $cAqXo.default)(_useSlotProps, $6ef43a0eadc1505e$var$_excluded3);
    return /*#__PURE__*/ (0, $2T9xh.jsx)(RootSlot, (0, $g6Hsb.default)({}, rootProps, !(0, $cwzzR.isHostComponent)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $2T9xh.jsx)(TransitionComponent, (0, $g6Hsb.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $2T9xh.jsx)(PaperSlot, (0, $g6Hsb.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $6ef43a0eadc1505e$export$2e2bcd8739ae039 = $6ef43a0eadc1505e$var$Popover;

});
parcelRegister("kUqcz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f38d5cba9b332a57$export$2e2bcd8739ae039);

var $kdu4X = parcelRequire("kdu4X");
var $f38d5cba9b332a57$export$2e2bcd8739ae039 = (0, $kdu4X.default);

});
parcelRegister("kdu4X", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb7c5a9f1f91c124$export$2e2bcd8739ae039);
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $eb7c5a9f1f91c124$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});


parcelRegister("h2Mbk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c687ff7657b7cff6$export$2e2bcd8739ae039);

var $6Bp1O = parcelRequire("6Bp1O");
var $c687ff7657b7cff6$export$2e2bcd8739ae039 = (0, $6Bp1O.default);

});

parcelRegister("bXNbj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b5b5acc18fae204$export$2e2bcd8739ae039);

var $kFAoC = parcelRequire("kFAoC");
var $8b5b5acc18fae204$export$2e2bcd8739ae039 = (0, $kFAoC.default);

});
parcelRegister("kFAoC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0c3de82a6431d3b$export$2e2bcd8739ae039);

var $6Bp1O = parcelRequire("6Bp1O");
function $f0c3de82a6431d3b$export$2e2bcd8739ae039(node) {
    const doc = (0, $6Bp1O.default)(node);
    return doc.defaultView || window;
}

});


parcelRegister("k9mDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $eab6363890652b6a$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");


var $74GFZ = parcelRequire("74GFZ");

var $j2DCq = parcelRequire("j2DCq");

var $b2r0b = parcelRequire("b2r0b");

var $h4JfZ = parcelRequire("h4JfZ");

var $bRiYQ = parcelRequire("bRiYQ");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $kLW6G = parcelRequire("kLW6G");

var $l3TDa = parcelRequire("l3TDa");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $eab6363890652b6a$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $eab6363890652b6a$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $l3TDa.getModalUtilityClass), classes);
};
const $eab6363890652b6a$var$ModalRoot = (0, $25zst.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $eab6363890652b6a$var$ModalBackdrop = (0, $25zst.default)((0, $kLW6G.default), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $eab6363890652b6a$var$Modal = /*#__PURE__*/ $aOzEm.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $gEb5G.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $eab6363890652b6a$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $cAqXo.default)(props, $eab6363890652b6a$var$_excluded);
    const propsWithDefaults = (0, $g6Hsb.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $j2DCq.useModal)((0, $g6Hsb.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $g6Hsb.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $eab6363890652b6a$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $eab6363890652b6a$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $74GFZ.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $g45Wv.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $74GFZ.useSlotProps)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $g6Hsb.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $g45Wv.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $bRiYQ.Portal), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $2T9xh.jsxs)(RootSlot, (0, $g6Hsb.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $2T9xh.jsx)(BackdropSlot, (0, $g6Hsb.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $2T9xh.jsx)((0, $h4JfZ.FocusTrap), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $aOzEm.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $eab6363890652b6a$export$2e2bcd8739ae039 = $eab6363890652b6a$var$Modal;

});
parcelRegister("j2DCq", function(module, exports) {

$parcel$export(module.exports, "useModal", () => $ddccefab9982f1af$export$33ffd74ebf07f060);

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");

var $9aj3x = parcelRequire("9aj3x");
var $6Bp1O = parcelRequire("6Bp1O");
var $b5mPz = parcelRequire("b5mPz");
var $6KMJ0 = parcelRequire("6KMJ0");

var $1WyaQ = parcelRequire("1WyaQ");

var $2AXQn = parcelRequire("2AXQn");
"use client";
function $ddccefab9982f1af$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $ddccefab9982f1af$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $ddccefab9982f1af$var$defaultManager = new (0, $2AXQn.ModalManager)();
function $ddccefab9982f1af$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $ddccefab9982f1af$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $aOzEm.useRef({});
    const mountNodeRef = $aOzEm.useRef(null);
    const modalRef = $aOzEm.useRef(null);
    const handleRef = (0, $6KMJ0.default)(modalRef, rootRef);
    const [exited, setExited] = $aOzEm.useState(!open);
    const hasTransition = $ddccefab9982f1af$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $6Bp1O.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $b5mPz.default)(()=>{
        const resolvedContainer = $ddccefab9982f1af$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $aOzEm.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $b5mPz.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $2AXQn.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $aOzEm.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $aOzEm.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $aOzEm.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $1WyaQ.extractEventHandlers)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $g6Hsb.default)({}, propsEventHandlers, otherHandlers);
        return (0, $g6Hsb.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $g6Hsb.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $9aj3x.default)(handleEnter, children.props.onEnter),
            onExited: (0, $9aj3x.default)(handleExited, children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}

});
parcelRegister("9aj3x", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ac3d462a017e2fe$export$2e2bcd8739ae039);
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $6ac3d462a017e2fe$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("2AXQn", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", () => $1e3d5d4dc4b72d59$export$e1bd0c6150f13d96);
$parcel$export(module.exports, "ModalManager", () => $1e3d5d4dc4b72d59$export$ce11c4ecd08cea67);

var $jMwIo = parcelRequire("jMwIo");
var $6Bp1O = parcelRequire("6Bp1O");
var $kFAoC = parcelRequire("kFAoC");
// Is a vertical scrollbar displayed?
function $1e3d5d4dc4b72d59$var$isOverflowing(container) {
    const doc = (0, $6Bp1O.default)(container);
    if (doc.body === container) return (0, $kFAoC.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $1e3d5d4dc4b72d59$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $1e3d5d4dc4b72d59$var$getPaddingRight(element) {
    return parseInt((0, $kFAoC.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $1e3d5d4dc4b72d59$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $1e3d5d4dc4b72d59$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$1e3d5d4dc4b72d59$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $1e3d5d4dc4b72d59$export$e1bd0c6150f13d96(element, show);
    });
}
function $1e3d5d4dc4b72d59$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $1e3d5d4dc4b72d59$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($1e3d5d4dc4b72d59$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $jMwIo.default)((0, $6Bp1O.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$1e3d5d4dc4b72d59$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $6Bp1O.default)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$1e3d5d4dc4b72d59$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $6Bp1O.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $kFAoC.default)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $1e3d5d4dc4b72d59$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $1e3d5d4dc4b72d59$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $1e3d5d4dc4b72d59$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $1e3d5d4dc4b72d59$var$getHiddenSiblings(container);
        $1e3d5d4dc4b72d59$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $1e3d5d4dc4b72d59$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $1e3d5d4dc4b72d59$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $1e3d5d4dc4b72d59$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $1e3d5d4dc4b72d59$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $1e3d5d4dc4b72d59$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $1e3d5d4dc4b72d59$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $1e3d5d4dc4b72d59$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

});
parcelRegister("jMwIo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e66be088fe1e34b3$export$2e2bcd8739ae039);
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $e66be088fe1e34b3$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

});



parcelRegister("h4JfZ", function(module, exports) {

$parcel$export(module.exports, "FocusTrap", () => $c6e5ea74eedef37a$export$34eba2437817a67b);

var $aOzEm = parcelRequire("aOzEm");


var $6Bp1O = parcelRequire("6Bp1O");
var $6KMJ0 = parcelRequire("6KMJ0");

var $2T9xh = parcelRequire("2T9xh");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $c6e5ea74eedef37a$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $c6e5ea74eedef37a$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $c6e5ea74eedef37a$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $c6e5ea74eedef37a$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $c6e5ea74eedef37a$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $c6e5ea74eedef37a$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($c6e5ea74eedef37a$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $c6e5ea74eedef37a$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$c6e5ea74eedef37a$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $c6e5ea74eedef37a$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $c6e5ea74eedef37a$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $c6e5ea74eedef37a$var$defaultGetTabbable, isEnabled: isEnabled = $c6e5ea74eedef37a$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $aOzEm.useRef(false);
    const sentinelStart = $aOzEm.useRef(null);
    const sentinelEnd = $aOzEm.useRef(null);
    const nodeToRestore = $aOzEm.useRef(null);
    const reactFocusEventTarget = $aOzEm.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $aOzEm.useRef(false);
    const rootRef = $aOzEm.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $6KMJ0.default)(children.ref, rootRef);
    const lastKeydown = $aOzEm.useRef(null);
    $aOzEm.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $aOzEm.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $6Bp1O.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $aOzEm.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $6Bp1O.default)(rootRef.current);
        const contain = (nativeEvent)=>{
            const { current: rootElement } = rootRef;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (!rootElement.contains(doc.activeElement)) {
                // if the focus event is not coming from inside the children's react tree, reset the refs
                if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
                else if (reactFocusEventTarget.current !== null) return;
                if (!activated.current) return;
                let tabbable = [];
                if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
                if (tabbable.length > 0) {
                    var _lastKeydown$current, _lastKeydown$current2;
                    const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                    const focusNext = tabbable[0];
                    const focusPrevious = tabbable[tabbable.length - 1];
                    if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                        if (isShiftTab) focusPrevious.focus();
                        else focusNext.focus();
                    }
                } else rootElement.focus();
            }
        };
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain(null);
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($aOzEm.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $aOzEm.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}

});

parcelRegister("kLW6G", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1f545404a29cec5$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $3RfNY = parcelRequire("3RfNY");

var $3KSDY = parcelRequire("3KSDY");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $f1f545404a29cec5$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $f1f545404a29cec5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $3KSDY.getBackdropUtilityClass), classes);
};
const $f1f545404a29cec5$var$BackdropRoot = (0, $25zst.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $g6Hsb.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $f1f545404a29cec5$var$Backdrop = /*#__PURE__*/ $aOzEm.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $3RfNY.default), transitionDuration: transitionDuration } = props, other = (0, $cAqXo.default)(props, $f1f545404a29cec5$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $f1f545404a29cec5$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $2T9xh.jsx)(TransitionComponent, (0, $g6Hsb.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $2T9xh.jsx)($f1f545404a29cec5$var$BackdropRoot, (0, $g6Hsb.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $g45Wv.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $g6Hsb.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $f1f545404a29cec5$export$2e2bcd8739ae039 = $f1f545404a29cec5$var$Backdrop;

});
parcelRegister("3RfNY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf294dee115fd50$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $aOzEm = parcelRequire("aOzEm");


var $i5PBN = parcelRequire("i5PBN");


var $57YGU = parcelRequire("57YGU");

var $iI1wU = parcelRequire("iI1wU");

var $eedeo = parcelRequire("eedeo");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $2cf294dee115fd50$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $2cf294dee115fd50$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $2cf294dee115fd50$var$Fade = /*#__PURE__*/ $aOzEm.forwardRef(function Fade(props, ref) {
    const theme = (0, $57YGU.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $i5PBN.default) } = props, other = (0, $cAqXo.default)(props, $2cf294dee115fd50$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $aOzEm.useRef(null);
    const handleRef = (0, $eedeo.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $iI1wU.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $iI1wU.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $iI1wU.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $2T9xh.jsx)(TransitionComponent, (0, $g6Hsb.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $aOzEm.cloneElement(children, (0, $g6Hsb.default)({
                style: (0, $g6Hsb.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $2cf294dee115fd50$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $2cf294dee115fd50$export$2e2bcd8739ae039 = $2cf294dee115fd50$var$Fade;

});

parcelRegister("3KSDY", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", () => $2bc00e156c987c55$export$9927a91fd93152bd);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $2bc00e156c987c55$export$9927a91fd93152bd(slot) {
    return (0, $6vnyE.default)("MuiBackdrop", slot);
}
const $2bc00e156c987c55$var$backdropClasses = (0, $cyhE3.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $2bc00e156c987c55$export$2e2bcd8739ae039 = $2bc00e156c987c55$var$backdropClasses;

});


parcelRegister("l3TDa", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", () => $f55507e5764378ad$export$67960e22b12a638d);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $f55507e5764378ad$export$67960e22b12a638d(slot) {
    return (0, $6vnyE.default)("MuiModal", slot);
}
const $f55507e5764378ad$var$modalClasses = (0, $cyhE3.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $f55507e5764378ad$export$2e2bcd8739ae039 = $f55507e5764378ad$var$modalClasses;

});


parcelRegister("hEyAT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getPopoverUtilityClass", () => $cda101c264f7c318$export$88f455dd56c95edb);
$parcel$export(module.exports, "default", () => $cda101c264f7c318$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $cda101c264f7c318$export$88f455dd56c95edb(slot) {
    return (0, $6vnyE.default)("MuiPopover", slot);
}
const $cda101c264f7c318$var$popoverClasses = (0, $cyhE3.default)("MuiPopover", [
    "root",
    "paper"
]);
var $cda101c264f7c318$export$2e2bcd8739ae039 = $cda101c264f7c318$var$popoverClasses;

});



parcelRegister("gHT8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $c29b6f6cdc27f01e$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $c29b6f6cdc27f01e$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add");

});

parcelRegister("kLsl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1de2dd597c67102$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $f1de2dd597c67102$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M21.95 10.99c-1.79-.03-3.7-1.95-2.68-4.22-2.98 1-5.77-1.59-5.19-4.56C6.95.71 2 6.58 2 12c0 5.52 4.48 10 10 10 5.89 0 10.54-5.08 9.95-11.01zM8.5 15c-.83 0-1.5-.67-1.5-1.5S7.67 12 8.5 12s1.5.67 1.5 1.5S9.33 15 8.5 15zm2-5C9.67 10 9 9.33 9 8.5S9.67 7 10.5 7s1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
}), "Cookie");

});

parcelRegister("4uHU0", function(module, exports) {

$parcel$export(module.exports, "default", () => $345c04debf513bea$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $345c04debf513bea$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
}), "Logout");

});


parcelRegister("6ZsTd", function(module, exports) {
"use strict";
var $516ed9758fd2252c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2T9xh = parcelRequire("2T9xh");

var $28Apm = parcelRequire("28Apm");

const $516ed9758fd2252c$var$useDelay_1 = $516ed9758fd2252c$var$__importDefault((parcelRequire("d9FmX")));
/**
 * LoadingBar is a wrapper over the MUI LinearProgress.
 *
 * This component avoids "Flash of Loading Bar" for quickly loding resources by waiting
 * for a short delay before rendering.
 *
 */ function $516ed9758fd2252c$var$LoadingBar({ height: height = "2px", delay: delay = 350 }) {
    const { delayPassed: delayPassed } = (0, $516ed9758fd2252c$var$useDelay_1.default)(delay);
    return delayPassed ? (0, $2T9xh.jsx)($28Apm.default, {
        className: "LoadingBar",
        sx: {
            height: height,
            marginTop: `-${height}`,
            "& .MuiLinearProgress-bar": {
                bgcolor: "rgb(30%, 30%, 30%)"
            }
        }
    }) : null;
}
module.exports.default = $516ed9758fd2252c$var$LoadingBar;

});
parcelRegister("28Apm", function(module, exports) {

$parcel$export(module.exports, "default", () => $18e891fdab2f43d7$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $e2SFW = parcelRequire("e2SFW");
var $fOENh = parcelRequire("fOENh");

var $63Oo6 = parcelRequire("63Oo6");

var $57YGU = parcelRequire("57YGU");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $jouCI = parcelRequire("jouCI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $18e891fdab2f43d7$var$_excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let $18e891fdab2f43d7$var$_ = (t)=>t, $18e891fdab2f43d7$var$_t, $18e891fdab2f43d7$var$_t2, $18e891fdab2f43d7$var$_t3, $18e891fdab2f43d7$var$_t4, $18e891fdab2f43d7$var$_t5, $18e891fdab2f43d7$var$_t6;
const $18e891fdab2f43d7$var$TRANSITION_DURATION = 4; // seconds
const $18e891fdab2f43d7$var$indeterminate1Keyframe = (0, $e2SFW.keyframes)($18e891fdab2f43d7$var$_t || ($18e891fdab2f43d7$var$_t = $18e891fdab2f43d7$var$_`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const $18e891fdab2f43d7$var$indeterminate2Keyframe = (0, $e2SFW.keyframes)($18e891fdab2f43d7$var$_t2 || ($18e891fdab2f43d7$var$_t2 = $18e891fdab2f43d7$var$_`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const $18e891fdab2f43d7$var$bufferKeyframe = (0, $e2SFW.keyframes)($18e891fdab2f43d7$var$_t3 || ($18e891fdab2f43d7$var$_t3 = $18e891fdab2f43d7$var$_`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const $18e891fdab2f43d7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $63Oo6.default)(color)}`,
            variant
        ],
        dashed: [
            "dashed",
            `dashedColor${(0, $63Oo6.default)(color)}`
        ],
        bar1: [
            "bar",
            `barColor${(0, $63Oo6.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar1Indeterminate",
            variant === "determinate" && "bar1Determinate",
            variant === "buffer" && "bar1Buffer"
        ],
        bar2: [
            "bar",
            variant !== "buffer" && `barColor${(0, $63Oo6.default)(color)}`,
            variant === "buffer" && `color${(0, $63Oo6.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar2Indeterminate",
            variant === "buffer" && "bar2Buffer"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $jouCI.getLinearProgressUtilityClass), classes);
};
const $18e891fdab2f43d7$var$getColorShade = (theme, color)=>{
    if (color === "inherit") return "currentColor";
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === "light" ? (0, $fOENh.lighten)(theme.palette[color].main, 0.62) : (0, $fOENh.darken)(theme.palette[color].main, 0.5);
};
const $18e891fdab2f43d7$var$LinearProgressRoot = (0, $25zst.default)("span", {
    name: "MuiLinearProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $63Oo6.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $g6Hsb.default)({
        position: "relative",
        overflow: "hidden",
        display: "block",
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        "@media print": {
            colorAdjust: "exact"
        },
        backgroundColor: $18e891fdab2f43d7$var$getColorShade(theme, ownerState.color)
    }, ownerState.color === "inherit" && ownerState.variant !== "buffer" && {
        backgroundColor: "none",
        "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "currentColor",
            opacity: 0.3
        }
    }, ownerState.variant === "buffer" && {
        backgroundColor: "transparent"
    }, ownerState.variant === "query" && {
        transform: "rotate(180deg)"
    }));
const $18e891fdab2f43d7$var$LinearProgressDashed = (0, $25zst.default)("span", {
    name: "MuiLinearProgress",
    slot: "Dashed",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $63Oo6.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const backgroundColor = $18e891fdab2f43d7$var$getColorShade(theme, ownerState.color);
    return (0, $g6Hsb.default)({
        position: "absolute",
        marginTop: 0,
        height: "100%",
        width: "100%"
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: "10px 10px",
        backgroundPosition: "0 -23px"
    });
}, (0, $e2SFW.css)($18e891fdab2f43d7$var$_t4 || ($18e891fdab2f43d7$var$_t4 = $18e891fdab2f43d7$var$_`
    animation: ${0} 3s infinite linear;
  `), $18e891fdab2f43d7$var$bufferKeyframe));
const $18e891fdab2f43d7$var$LinearProgressBar1 = (0, $25zst.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar1",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $63Oo6.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar1Indeterminate,
            ownerState.variant === "determinate" && styles.bar1Determinate,
            ownerState.variant === "buffer" && styles.bar1Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $g6Hsb.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left",
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "determinate" && {
        transition: `transform .${$18e891fdab2f43d7$var$TRANSITION_DURATION}s linear`
    }, ownerState.variant === "buffer" && {
        zIndex: 1,
        transition: `transform .${$18e891fdab2f43d7$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $e2SFW.css)($18e891fdab2f43d7$var$_t5 || ($18e891fdab2f43d7$var$_t5 = $18e891fdab2f43d7$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), $18e891fdab2f43d7$var$indeterminate1Keyframe));
const $18e891fdab2f43d7$var$LinearProgressBar2 = (0, $25zst.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar2",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $63Oo6.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar2Indeterminate,
            ownerState.variant === "buffer" && styles.bar2Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $g6Hsb.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left"
    }, ownerState.variant !== "buffer" && {
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, ownerState.variant === "buffer" && {
        backgroundColor: $18e891fdab2f43d7$var$getColorShade(theme, ownerState.color),
        transition: `transform .${$18e891fdab2f43d7$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $e2SFW.css)($18e891fdab2f43d7$var$_t6 || ($18e891fdab2f43d7$var$_t6 = $18e891fdab2f43d7$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), $18e891fdab2f43d7$var$indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $18e891fdab2f43d7$var$LinearProgress = /*#__PURE__*/ $aOzEm.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiLinearProgress"
    });
    const { className: className, color: color = "primary", value: value, valueBuffer: valueBuffer, variant: variant = "indeterminate" } = props, other = (0, $cAqXo.default)(props, $18e891fdab2f43d7$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $18e891fdab2f43d7$var$useUtilityClasses(ownerState);
    const theme = (0, $57YGU.default)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === "determinate" || variant === "buffer") {
        if (value !== undefined) {
            rootProps["aria-valuenow"] = Math.round(value);
            rootProps["aria-valuemin"] = 0;
            rootProps["aria-valuemax"] = 100;
            let transform = value - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === "buffer") {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($18e891fdab2f43d7$var$LinearProgressRoot, (0, $g6Hsb.default)({
        className: (0, $g45Wv.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === "buffer" ? /*#__PURE__*/ (0, $2T9xh.jsx)($18e891fdab2f43d7$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $2T9xh.jsx)($18e891fdab2f43d7$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === "determinate" ? null : /*#__PURE__*/ (0, $2T9xh.jsx)($18e891fdab2f43d7$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
var $18e891fdab2f43d7$export$2e2bcd8739ae039 = $18e891fdab2f43d7$var$LinearProgress;

});
parcelRegister("jouCI", function(module, exports) {

$parcel$export(module.exports, "getLinearProgressUtilityClass", () => $e1e8035d93ea9a6f$export$bc8a6ea1eb17d7c6);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $e1e8035d93ea9a6f$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $6vnyE.default)("MuiLinearProgress", slot);
}
const $e1e8035d93ea9a6f$var$linearProgressClasses = (0, $cyhE3.default)("MuiLinearProgress", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "determinate",
    "indeterminate",
    "buffer",
    "query",
    "dashed",
    "dashedColorPrimary",
    "dashedColorSecondary",
    "bar",
    "barColorPrimary",
    "barColorSecondary",
    "bar1Indeterminate",
    "bar1Determinate",
    "bar1Buffer",
    "bar2Indeterminate",
    "bar2Buffer"
]);
var $e1e8035d93ea9a6f$export$2e2bcd8739ae039 = $e1e8035d93ea9a6f$var$linearProgressClasses;

});



parcelRegister("3WNkq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2T9xh = parcelRequire("2T9xh");
function $2dfd0d776dd4d9b2$var$DecodableLogo({ style: style = {} } = {}) {
    return (0, $2T9xh.jsx)("svg", Object.assign({
        width: "161",
        height: "38",
        viewBox: "0 0 161 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style
    }, {
        children: (0, $2T9xh.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11 29.0249V24.3985C12.4954 24.3985 13.9296 23.8298 14.987 22.8174C16.0444 21.8051 16.6385 20.4321 16.6385 19.0004C16.6385 17.5688 16.0444 16.1957 14.987 15.1834C13.9296 14.1711 12.4954 13.6024 11 13.6024V8.9751C13.7607 8.9991 16.3998 10.0659 18.3431 11.9433C20.2864 13.8207 21.3767 16.3569 21.3767 19C21.3767 21.6431 20.2864 24.1793 18.3431 26.0567C16.3998 27.9341 13.7607 29.0009 11 29.0249ZM31.4126 29.0249L24.7876 22.6824C23.7695 21.7056 23.1977 20.382 23.1977 19.0021C23.1977 17.6221 23.7695 16.2985 24.7876 15.3217L31.4126 8.97838L35.078 12.4875L28.2716 19.0037L35.078 25.5191L31.4126 29.0249ZM50.903 11.2323V26.7547H48.9784V24.9975C48.5321 25.6111 47.9672 26.0783 47.2839 26.3991C46.6005 26.7198 45.8474 26.8802 45.0245 26.8802C43.9507 26.8802 42.9884 26.6431 42.1376 26.169C41.2869 25.6948 40.6175 25.0323 40.1293 24.1816C39.6551 23.3169 39.4181 22.3267 39.4181 21.211C39.4181 20.0953 39.6551 19.1121 40.1293 18.2613C40.6175 17.4106 41.2869 16.7481 42.1376 16.274C42.9884 15.7998 43.9507 15.5627 45.0245 15.5627C45.8195 15.5627 46.5517 15.7161 47.2211 16.0229C47.8905 16.3158 48.4484 16.7551 48.8947 17.3409V11.2323H50.903ZM45.1919 25.123C45.8892 25.123 46.5238 24.9626 47.0956 24.6418C47.6674 24.3071 48.1137 23.8469 48.4344 23.2611C48.7552 22.6614 48.9156 21.9781 48.9156 21.211C48.9156 20.4439 48.7552 19.7675 48.4344 19.1818C48.1137 18.5821 47.6674 18.1219 47.0956 17.8011C46.5238 17.4803 45.8892 17.3199 45.1919 17.3199C44.4806 17.3199 43.8391 17.4803 43.2673 17.8011C42.7094 18.1219 42.2631 18.5821 41.9284 19.1818C41.6077 19.7675 41.4473 20.4439 41.4473 21.211C41.4473 21.9781 41.6077 22.6614 41.9284 23.2611C42.2631 23.8469 42.7094 24.3071 43.2673 24.6418C43.8391 24.9626 44.4806 25.123 45.1919 25.123ZM64.7234 21.2738C64.7234 21.4272 64.7094 21.6294 64.6815 21.8804H55.6861C55.8116 22.8567 56.2369 23.6447 56.9622 24.2444C57.7013 24.8301 58.6148 25.123 59.7026 25.123C61.0275 25.123 62.0944 24.6767 62.9033 23.7841L64.0121 25.0811C63.51 25.6669 62.8824 26.1132 62.1293 26.42C61.3902 26.7268 60.5603 26.8802 59.6399 26.8802C58.4684 26.8802 57.4294 26.6431 56.5228 26.169C55.6163 25.6808 54.912 25.0044 54.41 24.1398C53.9218 23.2751 53.6778 22.2988 53.6778 21.211C53.6778 20.1371 53.9149 19.1678 54.389 18.3032C54.8772 17.4385 55.5396 16.7691 56.3764 16.2949C57.2271 15.8067 58.1825 15.5627 59.2424 15.5627C60.3023 15.5627 61.2437 15.8067 62.0666 16.2949C62.9033 16.7691 63.5519 17.4385 64.0121 18.3032C64.4863 19.1678 64.7234 20.158 64.7234 21.2738ZM59.2424 17.2572C58.2801 17.2572 57.4712 17.5501 56.8157 18.1358C56.1742 18.7216 55.7976 19.4886 55.6861 20.437H62.7987C62.6872 19.5026 62.3036 18.7425 61.6482 18.1567C61.0066 17.557 60.2047 17.2572 59.2424 17.2572ZM69.3111 26.148C70.2037 26.6362 71.2148 26.8802 72.3445 26.8802C73.3486 26.8802 74.2412 26.678 75.0222 26.2736C75.8172 25.8552 76.4308 25.2624 76.8632 24.4954L75.336 23.5331C74.9874 24.063 74.555 24.4605 74.039 24.7255C73.523 24.9905 72.9512 25.123 72.3236 25.123C71.5984 25.123 70.9429 24.9626 70.3571 24.6418C69.7853 24.3211 69.3321 23.8678 68.9973 23.282C68.6766 22.6823 68.5162 21.992 68.5162 21.211C68.5162 20.4439 68.6766 19.7675 68.9973 19.1818C69.3321 18.5821 69.7853 18.1219 70.3571 17.8011C70.9429 17.4803 71.5984 17.3199 72.3236 17.3199C72.9512 17.3199 73.523 17.4524 74.039 17.7174C74.555 17.9824 74.9874 18.3799 75.336 18.9098L76.8632 17.9266C76.4308 17.1596 75.8172 16.5738 75.0222 16.1694C74.2412 15.7649 73.3486 15.5627 72.3445 15.5627C71.2148 15.5627 70.2037 15.8067 69.3111 16.2949C68.4325 16.7691 67.7422 17.4385 67.2401 18.3032C66.738 19.1539 66.487 20.1232 66.487 21.211C66.487 22.2988 66.738 23.2751 67.2401 24.1398C67.7422 24.9905 68.4325 25.6599 69.3111 26.148ZM84.0486 26.8802C82.9468 26.8802 81.9566 26.6362 81.078 26.148C80.1993 25.6599 79.509 24.9905 79.0069 24.1398C78.5188 23.2751 78.2747 22.2988 78.2747 21.211C78.2747 20.1232 78.5188 19.1539 79.0069 18.3032C79.509 17.4385 80.1993 16.7691 81.078 16.2949C81.9566 15.8067 82.9468 15.5627 84.0486 15.5627C85.1503 15.5627 86.1336 15.8067 86.9982 16.2949C87.8769 16.7691 88.5602 17.4385 89.0484 18.3032C89.5504 19.1539 89.8015 20.1232 89.8015 21.211C89.8015 22.2988 89.5504 23.2751 89.0484 24.1398C88.5602 24.9905 87.8769 25.6599 86.9982 26.148C86.1336 26.6362 85.1503 26.8802 84.0486 26.8802ZM84.0486 25.123C84.7598 25.123 85.3944 24.9626 85.9523 24.6418C86.5241 24.3071 86.9704 23.8469 87.2911 23.2611C87.6119 22.6614 87.7723 21.9781 87.7723 21.211C87.7723 20.4439 87.6119 19.7675 87.2911 19.1818C86.9704 18.5821 86.5241 18.1219 85.9523 17.8011C85.3944 17.4803 84.7598 17.3199 84.0486 17.3199C83.3373 17.3199 82.6958 17.4803 82.124 17.8011C81.5661 18.1219 81.1198 18.5821 80.7851 19.1818C80.4643 19.7675 80.3039 20.4439 80.3039 21.211C80.3039 21.9781 80.4643 22.6614 80.7851 23.2611C81.1198 23.8469 81.5661 24.3071 82.124 24.6418C82.6958 24.9626 83.3373 25.123 84.0486 25.123ZM103.039 26.7547V11.2323H101.03V17.3409C100.584 16.7551 100.026 16.3158 99.3569 16.0229C98.6874 15.7161 97.9553 15.5627 97.1603 15.5627C96.0864 15.5627 95.1241 15.7998 94.2734 16.274C93.4227 16.7481 92.7532 17.4106 92.2651 18.2613C91.7909 19.1121 91.5538 20.0953 91.5538 21.211C91.5538 22.3267 91.7909 23.3169 92.2651 24.1816C92.7532 25.0323 93.4227 25.6948 94.2734 26.169C95.1241 26.6431 96.0864 26.8802 97.1603 26.8802C97.9831 26.8802 98.7363 26.7198 99.4196 26.3991C100.103 26.0783 100.668 25.6111 101.114 24.9975V26.7547H103.039ZM99.2314 24.6418C98.6596 24.9626 98.025 25.123 97.3277 25.123C96.6164 25.123 95.9749 24.9626 95.4031 24.6418C94.8452 24.3071 94.3989 23.8469 94.0642 23.2611C93.7434 22.6614 93.583 21.9781 93.583 21.211C93.583 20.4439 93.7434 19.7675 94.0642 19.1818C94.3989 18.5821 94.8452 18.1219 95.4031 17.8011C95.9749 17.4803 96.6164 17.3199 97.3277 17.3199C98.025 17.3199 98.6596 17.4803 99.2314 17.8011C99.8032 18.1219 100.249 18.5821 100.57 19.1818C100.891 19.7675 101.051 20.4439 101.051 21.211C101.051 21.9781 100.891 22.6614 100.57 23.2611C100.249 23.8469 99.8032 24.3071 99.2314 24.6418ZM110.876 15.5627C112.41 15.5627 113.582 15.9392 114.391 16.6923C115.213 17.4455 115.625 18.5681 115.625 20.0604V26.7547H113.721V25.2903C113.386 25.8064 112.905 26.2038 112.278 26.4828C111.664 26.7477 110.932 26.8802 110.081 26.8802C108.84 26.8802 107.843 26.5804 107.09 25.9807C106.35 25.381 105.981 24.593 105.981 23.6168C105.981 22.6405 106.337 21.8595 107.048 21.2738C107.759 20.6741 108.889 20.3742 110.437 20.3742H113.617V19.9767C113.617 19.1121 113.366 18.4496 112.863 17.9894C112.361 17.5291 111.622 17.299 110.646 17.299C109.991 17.299 109.349 17.4106 108.721 17.6337C108.094 17.8429 107.564 18.1288 107.131 18.4914L106.295 16.9852C106.866 16.525 107.55 16.1763 108.345 15.9392C109.14 15.6882 109.984 15.5627 110.876 15.5627ZM110.416 25.3322C111.183 25.3322 111.845 25.1648 112.403 24.8301C112.961 24.4814 113.366 23.9933 113.617 23.3657V21.8177H110.52C108.819 21.8177 107.968 22.3895 107.968 23.5331C107.968 24.0909 108.184 24.5303 108.617 24.851C109.049 25.1718 109.649 25.3322 110.416 25.3322ZM128.107 16.274C127.256 15.7998 126.294 15.5627 125.22 15.5627C124.425 15.5627 123.693 15.7161 123.023 16.0229C122.354 16.3158 121.796 16.7551 121.35 17.3409V11.2323H119.341V26.7547H121.266V24.9975C121.712 25.6111 122.277 26.0783 122.96 26.3991C123.644 26.7198 124.397 26.8802 125.22 26.8802C126.294 26.8802 127.256 26.6431 128.107 26.169C128.957 25.6948 129.62 25.0323 130.094 24.1816C130.582 23.3169 130.826 22.3267 130.826 21.211C130.826 20.0953 130.582 19.1121 130.094 18.2613C129.62 17.4106 128.957 16.7481 128.107 16.274ZM126.956 24.6418C126.398 24.9626 125.764 25.123 125.052 25.123C124.355 25.123 123.721 24.9626 123.149 24.6418C122.577 24.3071 122.131 23.8469 121.81 23.2611C121.489 22.6614 121.329 21.9781 121.329 21.211C121.329 20.4439 121.489 19.7675 121.81 19.1818C122.131 18.5821 122.577 18.1219 123.149 17.8011C123.721 17.4803 124.355 17.3199 125.052 17.3199C125.764 17.3199 126.398 17.4803 126.956 17.8011C127.528 18.1219 127.974 18.5821 128.295 19.1818C128.63 19.7675 128.797 20.4439 128.797 21.211C128.797 21.9781 128.63 22.6614 128.295 23.2611C127.974 23.8469 127.528 24.3071 126.956 24.6418ZM133.601 11.2323H135.609V26.7547H133.601V11.2323ZM149.423 21.8804C149.45 21.6294 149.464 21.4272 149.464 21.2738C149.464 20.158 149.227 19.1678 148.753 18.3032C148.293 17.4385 147.644 16.7691 146.808 16.2949C145.985 15.8067 145.043 15.5627 143.983 15.5627C142.924 15.5627 141.968 15.8067 141.117 16.2949C140.281 16.7691 139.618 17.4385 139.13 18.3032C138.656 19.1678 138.419 20.1371 138.419 21.211C138.419 22.2988 138.663 23.2751 139.151 24.1398C139.653 25.0044 140.357 25.6808 141.264 26.169C142.17 26.6431 143.209 26.8802 144.381 26.8802C145.301 26.8802 146.131 26.7268 146.87 26.42C147.623 26.1132 148.251 25.6669 148.753 25.0811L147.644 23.7841C146.836 24.6767 145.769 25.123 144.444 25.123C143.356 25.123 142.442 24.8301 141.703 24.2444C140.978 23.6447 140.553 22.8567 140.427 21.8804H149.423ZM141.557 18.1358C142.212 17.5501 143.021 17.2572 143.983 17.2572C144.946 17.2572 145.748 17.557 146.389 18.1567C147.045 18.7425 147.428 19.5026 147.54 20.437H140.427C140.539 19.4886 140.915 18.7216 141.557 18.1358Z",
            fill: "#0E0F18"
        })
    }));
}
module.exports.default = $2dfd0d776dd4d9b2$var$DecodableLogo;

});


parcelRegister("lU03w", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteProvider", () => $38420c53f1664521$export$239aa920d9ce6f0e);
$parcel$export(module.exports, "OpenCommandPaletteButton", () => $38420c53f1664521$export$b51c8c685b91ebad);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $a2IZi = parcelRequire("a2IZi");

var $4MSgn = parcelRequire("4MSgn");
var $8p0qe = parcelRequire("8p0qe");
var $hvbBd = parcelRequire("hvbBd");

var $3Nqau = parcelRequire("3Nqau");

var $hrwsS = parcelRequire("hrwsS");

var $5YTEB = parcelRequire("5YTEB");

var $33d8t = parcelRequire("33d8t");

var $7aAxC = parcelRequire("7aAxC");
var $cB0tV = parcelRequire("cB0tV");
var $deADQ = parcelRequire("deADQ");
var $8EsI6 = parcelRequire("8EsI6");
var $fKNLT = parcelRequire("fKNLT");
var $goopS = parcelRequire("goopS");
var $5PdGJ = parcelRequire("5PdGJ");
var $6fKva = parcelRequire("6fKva");

var $ctp2t = parcelRequire("ctp2t");

var $jVvcL = parcelRequire("jVvcL");

var $4aqud = parcelRequire("4aqud");

var $ePYFP = parcelRequire("ePYFP");

var $676nd = parcelRequire("676nd");

var $gga7I = parcelRequire("gga7I");
const $38420c53f1664521$var$communitySlackUrl = "https://decodablecommunity.slack.com/join/shared_invite/zt-uvow71bk-Uf914umgpoyIbOQSxriJkA#/shared-invite/email";
const $38420c53f1664521$export$3b06f432b734ec95 = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $38420c53f1664521$export$239aa920d9ce6f0e({ children: children }) {
    const [isOpen, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useState(false);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($38420c53f1664521$export$3b06f432b734ec95.Provider, {
        value: {
            setOpen: setOpen
        },
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)($38420c53f1664521$export$96678decff44c9ff, {
                isOpen: isOpen,
                setOpen: setOpen
            }),
            children
        ]
    });
}
function $38420c53f1664521$export$6b58f9610017fbb7() {
    const value = (0, $aOzEm.useContext)($38420c53f1664521$export$3b06f432b734ec95);
    if (value == null) return {
        setOpen: ()=>{
            throw new Error("Cannot open command palette. No provider present.");
        }
    };
    return value;
}
const $38420c53f1664521$export$96678decff44c9ff = ({ isOpen: isOpen, setOpen: setOpen })=>{
    const { activeAccount: activeAccount } = (0, $gga7I.useActiveAccount)();
    // Toggle the menu when ⌘K is pressed
    (0, $aOzEm.useEffect)(()=>{
        const down = (e)=>{
            if (activeAccount && e.key === "k" && (e.metaKey || e.altKey)) {
                e.preventDefault();
                setOpen((open)=>!open);
            }
        };
        document.addEventListener("keydown", down);
        return ()=>document.removeEventListener("keydown", down);
    }, [
        activeAccount
    ]);
    const navigate = (0, $5YTEB.useNavigate)();
    const handleNavigate = (...args)=>{
        setOpen(false);
        return (0, $aOzEm.startTransition)(()=>navigate(...args));
    };
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $4MSgn.default), {
        open: isOpen,
        onClose: ()=>setOpen(false),
        fullWidth: true,
        maxWidth: "sm",
        keepMounted: false,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)($38420c53f1664521$export$d5c1975cbb44d2a4, {
            navigate: handleNavigate
        })
    });
};
function $38420c53f1664521$export$d5c1975cbb44d2a4({ navigate: navigate, openTab: openTab = (url)=>window.open(url, "_blank") }) {
    const [filter, setFilter] = (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).useState("");
    const { activeAccount: activeAccount, accountInfo: accountInfo } = (0, $gga7I.useActiveAccount)();
    const hasCustomPipelines = accountInfo?.subscription.capabilities.includes("custom_pipelines");
    const basePath = (0, $33d8t.usePath)({
        accountName: activeAccount?.name
    });
    const connectionsPath = (0, $33d8t.usePath)({
        accountName: activeAccount?.name,
        resourceType: "connection"
    });
    const streamsPath = (0, $33d8t.usePath)({
        accountName: activeAccount?.name,
        resourceType: "stream"
    });
    const pipelinesPath = (0, $33d8t.usePath)({
        accountName: activeAccount?.name,
        resourceType: "pipeline"
    });
    const usersPath = (0, $33d8t.usePath)({
        accountName: activeAccount?.name,
        resourceType: "user"
    });
    const groupsPath = (0, $33d8t.usePath)({
        accountName: activeAccount?.name,
        resourceType: "group"
    });
    const rolesPath = (0, $33d8t.usePath)({
        accountName: activeAccount?.name,
        resourceType: "role"
    });
    function handleNavigate(to, options) {
        navigate(to, options);
        setFilter("");
    }
    // Note: We supply the 'value' prop, even when not strictly necessary,
    // as a workaround for https://github.com/pacocoursey/cmdk/issues/40.
    // Otherwise the filter is not correctly applied when backspacing.
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command), {
        className: $3Nqau["decodable-cmd-palette"],
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hrwsS))), {
                TextFieldProps: {
                    inputRef: (e)=>e?.focus(),
                    placeholder: "Search commands",
                    value: filter,
                    onChange: (e)=>setFilter(e.target.value),
                    fullWidth: true,
                    sx: {
                        padding: 1
                    }
                }
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $a2IZi.Command).Input, {
                style: {
                    display: "none"
                },
                value: filter
            }),
            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).List, {
                children: [
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $a2IZi.Command).Empty, {
                        children: "No results"
                    }),
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $a2IZi.Command).Separator, {}),
                    /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Group, {
                        heading: "Manage Resources",
                        children: [
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                onSelect: ()=>handleNavigate(connectionsPath),
                                value: "View connections",
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ctp2t))), {}),
                                    " View connections"
                                ]
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                onSelect: ()=>handleNavigate(`${connectionsPath}/create`),
                                value: "Create a new connection",
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $7aAxC.default), {}),
                                    " Create a new connection"
                                ]
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                onSelect: ()=>handleNavigate(streamsPath),
                                value: "View streams",
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jVvcL))), {}),
                                    " View streams"
                                ]
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                value: "Create a new stream",
                                onSelect: ()=>handleNavigate(`${streamsPath}/create`),
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $7aAxC.default), {}),
                                    " Create a new stream"
                                ]
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                value: "View pipelines",
                                onSelect: ()=>handleNavigate(pipelinesPath),
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4aqud))), {}),
                                    " View pipelines"
                                ]
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                value: "Create a new pipeline",
                                onSelect: ()=>handleNavigate(`${pipelinesPath}/create`),
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $7aAxC.default), {}),
                                    " Create a new pipeline"
                                ]
                            }),
                            hasCustomPipelines ? /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                value: "Upload a new custom pipeline",
                                onSelect: ()=>{
                                    handleNavigate(`${pipelinesPath}/create?type=custom`);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $7aAxC.default), {}),
                                    " Upload a new custom pipeline"
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                value: "View secrets",
                                onSelect: ()=>handleNavigate(`${basePath}/secrets`),
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $fKNLT.default), {}),
                                    " View secrets"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $a2IZi.Command).Separator, {}),
                    /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Group, {
                        heading: "Manage Access Controls",
                        children: [
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                value: "Access Control Users",
                                onSelect: ()=>handleNavigate(usersPath),
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $goopS.default), {}),
                                    " Users"
                                ]
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                value: "Access Control Groups",
                                onSelect: ()=>handleNavigate(groupsPath),
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $ePYFP.GroupIcon), {}),
                                    " Groups"
                                ]
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                value: "Access Control Roles",
                                onSelect: ()=>handleNavigate(rolesPath),
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $676nd.RoleIcon), {}),
                                    " Roles"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $a2IZi.Command).Separator, {}),
                    /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Group, {
                        heading: "Manage Account",
                        children: [
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                value: "Invite users",
                                onSelect: ()=>handleNavigate(`${basePath}/account?tab=members`),
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5PdGJ.default), {}),
                                    " Invite users"
                                ]
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                value: "Switch accounts",
                                onSelect: ()=>handleNavigate(`/-/accounts`),
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $6fKva.default), {}),
                                    " Switch accounts"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $a2IZi.Command).Separator, {}),
                    /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Group, {
                        heading: "Get Help",
                        children: [
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                value: "Chat with the community",
                                onSelect: ()=>openTab($38420c53f1664521$var$communitySlackUrl),
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8EsI6.default), {}),
                                    " Chat with the community"
                                ]
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $a2IZi.Command).Item, {
                                value: "Read the documentation",
                                onSelect: ()=>openTab("https://docs.decodable.co/"),
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $cB0tV.default), {}),
                                    " Read the documentation"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $38420c53f1664521$export$b51c8c685b91ebad() {
    const { setOpen: setOpen } = $38420c53f1664521$export$6b58f9610017fbb7();
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $hvbBd.default), {
        arrow: true,
        title: `Open command palette
(\u{2318}K or Alt+K)`,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8p0qe.default), {
            "data-intercom-target": "LaunchCommandPalette",
            onClick: ()=>setOpen(true),
            sx: {
                minWidth: 0,
                height: "2.5rem",
                aspectRatio: "1/1"
            },
            children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $deADQ.default), {})
        })
    });
}

});
parcelRegister("a2IZi", function(module, exports) {

$parcel$export(module.exports, "Command", () => $c4cb31242de3c141$export$cc7e12c76513e857);

var $aTRWs = parcelRequire("aTRWs");

var $aOzEm = parcelRequire("aOzEm");

var $9H74C = parcelRequire("9H74C");
var $c4cb31242de3c141$var$ue = '[cmdk-list-sizer=""]', $c4cb31242de3c141$var$M = '[cmdk-group=""]', $c4cb31242de3c141$var$N = '[cmdk-group-items=""]', $c4cb31242de3c141$var$de = '[cmdk-group-heading=""]', $c4cb31242de3c141$var$ee = '[cmdk-item=""]', $c4cb31242de3c141$var$Z = `${$c4cb31242de3c141$var$ee}:not([aria-disabled="true"])`, $c4cb31242de3c141$var$z = "cmdk-item-select", $c4cb31242de3c141$var$S = "data-value", $c4cb31242de3c141$var$fe = (n, a)=>(0, (/*@__PURE__*/$parcel$interopDefault($9H74C)))(n, a), $c4cb31242de3c141$var$te = $aOzEm.createContext(void 0), $c4cb31242de3c141$var$k = ()=>$aOzEm.useContext($c4cb31242de3c141$var$te), $c4cb31242de3c141$var$re = $aOzEm.createContext(void 0), $c4cb31242de3c141$var$U = ()=>$aOzEm.useContext($c4cb31242de3c141$var$re), $c4cb31242de3c141$var$ne = $aOzEm.createContext(void 0), $c4cb31242de3c141$export$6def88b96ee4affb = $aOzEm.forwardRef((n, a)=>{
    let r = $aOzEm.useRef(null), o = $c4cb31242de3c141$var$x(()=>({
            search: "",
            value: "",
            filtered: {
                count: 0,
                items: new Map,
                groups: new Set
            }
        })), u = $c4cb31242de3c141$var$x(()=>new Set), l = $c4cb31242de3c141$var$x(()=>new Map), p = $c4cb31242de3c141$var$x(()=>new Map), f = $c4cb31242de3c141$var$x(()=>new Set), d = $c4cb31242de3c141$var$ae(n), { label: v, children: E, value: R, onValueChange: w, filter: O, shouldFilter: ie, ...D } = n, F = $aOzEm.useId(), g = $aOzEm.useId(), A = $aOzEm.useId(), y = $c4cb31242de3c141$var$ye();
    $c4cb31242de3c141$var$L(()=>{
        if (R !== void 0) {
            let e = R.trim().toLowerCase();
            o.current.value = e, y(6, W), h.emit();
        }
    }, [
        R
    ]);
    let h = $aOzEm.useMemo(()=>({
            subscribe: (e)=>(f.current.add(e), ()=>f.current.delete(e)),
            snapshot: ()=>o.current,
            setState: (e, c, i)=>{
                var s, m, b;
                if (!Object.is(o.current[e], c)) {
                    if (o.current[e] = c, e === "search") j(), G(), y(1, V);
                    else if (e === "value") {
                        if (((s = d.current) == null ? void 0 : s.value) !== void 0) {
                            (b = (m = d.current).onValueChange) == null || b.call(m, c);
                            return;
                        } else i || y(5, W);
                    }
                    h.emit();
                }
            },
            emit: ()=>{
                f.current.forEach((e)=>e());
            }
        }), []), K = $aOzEm.useMemo(()=>({
            value: (e, c)=>{
                c !== p.current.get(e) && (p.current.set(e, c), o.current.filtered.items.set(e, B(c)), y(2, ()=>{
                    G(), h.emit();
                }));
            },
            item: (e, c)=>(u.current.add(e), c && (l.current.has(c) ? l.current.get(c).add(e) : l.current.set(c, new Set([
                    e
                ]))), y(3, ()=>{
                    j(), G(), o.current.value || V(), h.emit();
                }), ()=>{
                    p.current.delete(e), u.current.delete(e), o.current.filtered.items.delete(e), y(4, ()=>{
                        j(), V(), h.emit();
                    });
                }),
            group: (e)=>(l.current.has(e) || l.current.set(e, new Set), ()=>{
                    p.current.delete(e), l.current.delete(e);
                }),
            filter: ()=>d.current.shouldFilter,
            label: v || n["aria-label"],
            listId: F,
            inputId: A,
            labelId: g
        }), []);
    function B(e) {
        var i;
        let c = ((i = d.current) == null ? void 0 : i.filter) ?? $c4cb31242de3c141$var$fe;
        return e ? c(e, o.current.search) : 0;
    }
    function G() {
        if (!r.current || !o.current.search || d.current.shouldFilter === !1) return;
        let e = o.current.filtered.items, c = [];
        o.current.filtered.groups.forEach((s)=>{
            let m = l.current.get(s), b = 0;
            m.forEach((P)=>{
                let ce = e.get(P);
                b = Math.max(ce, b);
            }), c.push([
                s,
                b
            ]);
        });
        let i = r.current.querySelector($c4cb31242de3c141$var$ue);
        I().sort((s, m)=>{
            let b = s.getAttribute($c4cb31242de3c141$var$S), P = m.getAttribute($c4cb31242de3c141$var$S);
            return (e.get(P) ?? 0) - (e.get(b) ?? 0);
        }).forEach((s)=>{
            let m = s.closest($c4cb31242de3c141$var$N);
            m ? m.appendChild(s.parentElement === m ? s : s.closest(`${$c4cb31242de3c141$var$N} > *`)) : i.appendChild(s.parentElement === i ? s : s.closest(`${$c4cb31242de3c141$var$N} > *`));
        }), c.sort((s, m)=>m[1] - s[1]).forEach((s)=>{
            let m = r.current.querySelector(`${$c4cb31242de3c141$var$M}[${$c4cb31242de3c141$var$S}="${s[0]}"]`);
            m == null || m.parentElement.appendChild(m);
        });
    }
    function V() {
        let e = I().find((i)=>!i.ariaDisabled), c = e == null ? void 0 : e.getAttribute($c4cb31242de3c141$var$S);
        h.setState("value", c || void 0);
    }
    function j() {
        if (!o.current.search || d.current.shouldFilter === !1) {
            o.current.filtered.count = u.current.size;
            return;
        }
        o.current.filtered.groups = new Set;
        let e = 0;
        for (let c of u.current){
            let i = p.current.get(c), s = B(i);
            o.current.filtered.items.set(c, s), s > 0 && e++;
        }
        for (let [c, i] of l.current)for (let s of i)if (o.current.filtered.items.get(s) > 0) {
            o.current.filtered.groups.add(c);
            break;
        }
        o.current.filtered.count = e;
    }
    function W() {
        var c, i, s;
        let e = _();
        e && (((c = e.parentElement) == null ? void 0 : c.firstChild) === e && ((s = (i = e.closest($c4cb31242de3c141$var$M)) == null ? void 0 : i.querySelector($c4cb31242de3c141$var$de)) == null || s.scrollIntoView({
            block: "nearest"
        })), e.scrollIntoView({
            block: "nearest"
        }));
    }
    function _() {
        return r.current.querySelector(`${$c4cb31242de3c141$var$ee}[aria-selected="true"]`);
    }
    function I() {
        return Array.from(r.current.querySelectorAll($c4cb31242de3c141$var$Z));
    }
    function q(e) {
        let i = I()[e];
        i && h.setState("value", i.getAttribute($c4cb31242de3c141$var$S));
    }
    function $(e) {
        var b;
        let c = _(), i = I(), s = i.findIndex((P)=>P === c), m = i[s + e];
        (b = d.current) != null && b.loop && (m = s + e < 0 ? i[i.length - 1] : s + e === i.length ? i[0] : i[s + e]), m && h.setState("value", m.getAttribute($c4cb31242de3c141$var$S));
    }
    function J(e) {
        let c = _(), i = c == null ? void 0 : c.closest($c4cb31242de3c141$var$M), s;
        for(; i && !s;)i = e > 0 ? $c4cb31242de3c141$var$Se(i, $c4cb31242de3c141$var$M) : $c4cb31242de3c141$var$Ce(i, $c4cb31242de3c141$var$M), s = i == null ? void 0 : i.querySelector($c4cb31242de3c141$var$Z);
        s ? h.setState("value", s.getAttribute($c4cb31242de3c141$var$S)) : $(e);
    }
    let Q = ()=>q(I().length - 1), X = (e)=>{
        e.preventDefault(), e.metaKey ? Q() : e.altKey ? J(1) : $(1);
    }, Y = (e)=>{
        e.preventDefault(), e.metaKey ? q(0) : e.altKey ? J(-1) : $(-1);
    };
    return $aOzEm.createElement("div", {
        ref: $c4cb31242de3c141$var$H([
            r,
            a
        ]),
        ...D,
        "cmdk-root": "",
        onKeyDown: (e)=>{
            var c;
            if ((c = D.onKeyDown) == null || c.call(D, e), !e.defaultPrevented) switch(e.key){
                case "n":
                case "j":
                    e.ctrlKey && X(e);
                    break;
                case "ArrowDown":
                    X(e);
                    break;
                case "p":
                case "k":
                    e.ctrlKey && Y(e);
                    break;
                case "ArrowUp":
                    Y(e);
                    break;
                case "Home":
                    e.preventDefault(), q(0);
                    break;
                case "End":
                    e.preventDefault(), Q();
                    break;
                case "Enter":
                    {
                        e.preventDefault();
                        let i = _();
                        if (i) {
                            let s = new Event($c4cb31242de3c141$var$z);
                            i.dispatchEvent(s);
                        }
                    }
            }
        }
    }, $aOzEm.createElement("label", {
        "cmdk-label": "",
        htmlFor: K.inputId,
        id: K.labelId,
        style: $c4cb31242de3c141$var$xe
    }, v), $aOzEm.createElement($c4cb31242de3c141$var$re.Provider, {
        value: h
    }, $aOzEm.createElement($c4cb31242de3c141$var$te.Provider, {
        value: K
    }, E)));
}), $c4cb31242de3c141$export$b9b346a733d36f61 = $aOzEm.forwardRef((n, a)=>{
    let r = $aOzEm.useId(), o = $aOzEm.useRef(null), u = $aOzEm.useContext($c4cb31242de3c141$var$ne), l = $c4cb31242de3c141$var$k(), p = $c4cb31242de3c141$var$ae(n);
    $c4cb31242de3c141$var$L(()=>l.item(r, u), []);
    let f = $c4cb31242de3c141$var$se(r, o, [
        n.value,
        n.children,
        o
    ]), d = $c4cb31242de3c141$var$U(), v = $c4cb31242de3c141$export$606184d999862dff((g)=>g.value && g.value === f.current), E = $c4cb31242de3c141$export$606184d999862dff((g)=>l.filter() === !1 ? !0 : g.search ? g.filtered.items.get(r) > 0 : !0);
    $aOzEm.useEffect(()=>{
        let g = o.current;
        if (!(!g || n.disabled)) return g.addEventListener($c4cb31242de3c141$var$z, R), ()=>g.removeEventListener($c4cb31242de3c141$var$z, R);
    }, [
        E,
        n.onSelect,
        n.disabled
    ]);
    function R() {
        var g, A;
        (A = (g = p.current).onSelect) == null || A.call(g, f.current);
    }
    function w() {
        d.setState("value", f.current, !0);
    }
    if (!E) return null;
    let { disabled: O, value: ie, onSelect: D, ...F } = n;
    return $aOzEm.createElement("div", {
        ref: $c4cb31242de3c141$var$H([
            o,
            a
        ]),
        ...F,
        "cmdk-item": "",
        role: "option",
        "aria-disabled": O || void 0,
        "aria-selected": v || void 0,
        "data-selected": v || void 0,
        onPointerMove: O ? void 0 : w,
        onClick: O ? void 0 : R
    }, n.children);
}), $c4cb31242de3c141$export$c157b9873a7a0fbd = $aOzEm.forwardRef((n, a)=>{
    let { heading: r, children: o, ...u } = n, l = $aOzEm.useId(), p = $aOzEm.useRef(null), f = $aOzEm.useRef(null), d = $aOzEm.useId(), v = $c4cb31242de3c141$var$k(), E = $c4cb31242de3c141$export$606184d999862dff((w)=>v.filter() === !1 ? !0 : w.search ? w.filtered.groups.has(l) : !0);
    $c4cb31242de3c141$var$L(()=>v.group(l), []), $c4cb31242de3c141$var$se(l, p, [
        n.value,
        n.heading,
        f
    ]);
    let R = $aOzEm.createElement($c4cb31242de3c141$var$ne.Provider, {
        value: l
    }, o);
    return $aOzEm.createElement("div", {
        ref: $c4cb31242de3c141$var$H([
            p,
            a
        ]),
        ...u,
        "cmdk-group": "",
        role: "presentation",
        hidden: E ? void 0 : !0
    }, r && $aOzEm.createElement("div", {
        ref: f,
        "cmdk-group-heading": "",
        "aria-hidden": !0,
        id: d
    }, r), $aOzEm.createElement("div", {
        "cmdk-group-items": "",
        role: "group",
        "aria-labelledby": r ? d : void 0
    }, R));
}), $c4cb31242de3c141$export$ace649eed6990b42 = $aOzEm.forwardRef((n, a)=>{
    let { alwaysRender: r, ...o } = n, u = $aOzEm.useRef(null), l = $c4cb31242de3c141$export$606184d999862dff((p)=>!p.search);
    return !r && !l ? null : $aOzEm.createElement("div", {
        ref: $c4cb31242de3c141$var$H([
            u,
            a
        ]),
        ...o,
        "cmdk-separator": "",
        role: "separator"
    });
}), $c4cb31242de3c141$export$ebdebb88e46df62a = $aOzEm.forwardRef((n, a)=>{
    let { onValueChange: r, ...o } = n, u = n.value != null, l = $c4cb31242de3c141$var$U(), p = $c4cb31242de3c141$export$606184d999862dff((d)=>d.search), f = $c4cb31242de3c141$var$k();
    return $aOzEm.useEffect(()=>{
        n.value != null && l.setState("search", n.value);
    }, [
        n.value
    ]), $aOzEm.createElement("input", {
        ref: a,
        ...o,
        "cmdk-input": "",
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: !1,
        "aria-autocomplete": "list",
        role: "combobox",
        "aria-expanded": !0,
        "aria-controls": f.listId,
        "aria-labelledby": f.labelId,
        id: f.inputId,
        type: "text",
        value: u ? n.value : p,
        onChange: (d)=>{
            u || l.setState("search", d.target.value), r == null || r(d.target.value);
        }
    });
}), $c4cb31242de3c141$export$9cffcb65e9381872 = $aOzEm.forwardRef((n, a)=>{
    let { children: r, ...o } = n, u = $aOzEm.useRef(null), l = $aOzEm.useRef(null), p = $c4cb31242de3c141$var$k();
    return $aOzEm.useEffect(()=>{
        if (l.current && u.current) {
            let f = l.current, d = u.current, v, E = new ResizeObserver(()=>{
                v = requestAnimationFrame(()=>{
                    let R = f.getBoundingClientRect().height;
                    d.style.setProperty("--cmdk-list-height", R.toFixed(1) + "px");
                });
            });
            return E.observe(f), ()=>{
                cancelAnimationFrame(v), E.unobserve(f);
            };
        }
    }, []), $aOzEm.createElement("div", {
        ref: $c4cb31242de3c141$var$H([
            u,
            a
        ]),
        ...o,
        "cmdk-list": "",
        role: "listbox",
        "aria-label": "Suggestions",
        id: p.listId,
        "aria-labelledby": p.inputId
    }, $aOzEm.createElement("div", {
        ref: l,
        "cmdk-list-sizer": ""
    }, r));
}), $c4cb31242de3c141$export$98f0540b5c04f3e8 = $aOzEm.forwardRef((n, a)=>{
    let { open: r, onOpenChange: o, container: u, ...l } = n;
    return $aOzEm.createElement($aTRWs.Root, {
        open: r,
        onOpenChange: o
    }, $aOzEm.createElement($aTRWs.Portal, {
        container: u
    }, $aOzEm.createElement($aTRWs.Overlay, {
        "cmdk-overlay": ""
    }), $aOzEm.createElement($aTRWs.Content, {
        "aria-label": n.label,
        "cmdk-dialog": ""
    }, $aOzEm.createElement($c4cb31242de3c141$export$6def88b96ee4affb, {
        ref: a,
        ...l
    }))));
}), $c4cb31242de3c141$export$f1753c65029fce09 = $aOzEm.forwardRef((n, a)=>{
    let r = $aOzEm.useRef(!0), o = $c4cb31242de3c141$export$606184d999862dff((u)=>u.filtered.count === 0);
    return $aOzEm.useEffect(()=>{
        r.current = !1;
    }, []), r.current || !o ? null : $aOzEm.createElement("div", {
        ref: a,
        ...n,
        "cmdk-empty": "",
        role: "presentation"
    });
}), $c4cb31242de3c141$export$8980984ffcab084a = $aOzEm.forwardRef((n, a)=>{
    let { progress: r, children: o, ...u } = n;
    return $aOzEm.createElement("div", {
        ref: a,
        ...u,
        "cmdk-loading": "",
        role: "progressbar",
        "aria-valuenow": r,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": "Loading..."
    }, $aOzEm.createElement("div", {
        "aria-hidden": !0
    }, o));
}), $c4cb31242de3c141$export$cc7e12c76513e857 = Object.assign($c4cb31242de3c141$export$6def88b96ee4affb, {
    List: $c4cb31242de3c141$export$9cffcb65e9381872,
    Item: $c4cb31242de3c141$export$b9b346a733d36f61,
    Input: $c4cb31242de3c141$export$ebdebb88e46df62a,
    Group: $c4cb31242de3c141$export$c157b9873a7a0fbd,
    Separator: $c4cb31242de3c141$export$ace649eed6990b42,
    Dialog: $c4cb31242de3c141$export$98f0540b5c04f3e8,
    Empty: $c4cb31242de3c141$export$f1753c65029fce09,
    Loading: $c4cb31242de3c141$export$8980984ffcab084a
});
function $c4cb31242de3c141$var$Se(n, a) {
    let r = n.nextElementSibling;
    for(; r;){
        if (r.matches(a)) return r;
        r = r.nextElementSibling;
    }
}
function $c4cb31242de3c141$var$Ce(n, a) {
    let r = n.previousElementSibling;
    for(; r;){
        if (r.matches(a)) return r;
        r = r.previousElementSibling;
    }
}
function $c4cb31242de3c141$var$ae(n) {
    let a = $aOzEm.useRef(n);
    return $c4cb31242de3c141$var$L(()=>{
        a.current = n;
    }), a;
}
var $c4cb31242de3c141$var$L = typeof window > "u" ? $aOzEm.useEffect : $aOzEm.useLayoutEffect;
function $c4cb31242de3c141$var$x(n) {
    let a = $aOzEm.useRef();
    return a.current === void 0 && (a.current = n()), a;
}
function $c4cb31242de3c141$var$H(n) {
    return (a)=>{
        n.forEach((r)=>{
            typeof r == "function" ? r(a) : r != null && (r.current = a);
        });
    };
}
function $c4cb31242de3c141$export$606184d999862dff(n) {
    let a = $c4cb31242de3c141$var$U(), r = ()=>n(a.snapshot());
    return $aOzEm.useSyncExternalStore(a.subscribe, r, r);
}
function $c4cb31242de3c141$var$se(n, a, r) {
    let o = $aOzEm.useRef(), u = $c4cb31242de3c141$var$k();
    return $c4cb31242de3c141$var$L(()=>{
        var p;
        let l = (()=>{
            var f;
            for (let d of r){
                if (typeof d == "string") return d.trim().toLowerCase();
                if (typeof d == "object" && "current" in d && d.current) return (f = d.current.textContent) == null ? void 0 : f.trim().toLowerCase();
            }
        })();
        u.value(n, l), (p = a.current) == null || p.setAttribute($c4cb31242de3c141$var$S, l), o.current = l;
    }), o;
}
var $c4cb31242de3c141$var$ye = ()=>{
    let [n, a] = $aOzEm.useState(), r = $c4cb31242de3c141$var$x(()=>new Map);
    return $c4cb31242de3c141$var$L(()=>{
        r.current.forEach((o)=>o()), r.current = new Map;
    }, [
        n
    ]), (o, u)=>{
        r.current.set(o, u), a({});
    };
}, $c4cb31242de3c141$var$xe = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: "0"
};

});
parcelRegister("aTRWs", function(module, exports) {

$parcel$export(module.exports, "Root", () => $7ef8e22db4e60da6$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Portal", () => $7ef8e22db4e60da6$export$602eac185826482c);
$parcel$export(module.exports, "Overlay", () => $7ef8e22db4e60da6$export$c6fdb837b070b4ff);
$parcel$export(module.exports, "Content", () => $7ef8e22db4e60da6$export$7c6e2c02157bb7d2);

var $H079p = parcelRequire("H079p");

var $aOzEm = parcelRequire("aOzEm");

var $jjwTY = parcelRequire("jjwTY");

var $kQ2YW = parcelRequire("kQ2YW");

var $aUf76 = parcelRequire("aUf76");

var $aD5ro = parcelRequire("aD5ro");

var $b9URh = parcelRequire("b9URh");

var $2JNLW = parcelRequire("2JNLW");

var $aVSdE = parcelRequire("aVSdE");

var $exHk7 = parcelRequire("exHk7");

var $jZEwW = parcelRequire("jZEwW");

var $wRVqr = parcelRequire("wRVqr");

var $ljSnT = parcelRequire("ljSnT");

var $bett1 = parcelRequire("bett1");

var $8WkFq = parcelRequire("8WkFq");

var $fFKx1 = parcelRequire("fFKx1");
/* -------------------------------------------------------------------------------------------------
 * Dialog
 * -----------------------------------------------------------------------------------------------*/ const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME = "Dialog";
const [$7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$createDialogContext, $7ef8e22db4e60da6$export$cc702773b8ea3e41] = (0, $aUf76.createContextScope)($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DialogProvider, $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useDialogContext] = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$createDialogContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $7ef8e22db4e60da6$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = (0, $aOzEm.useRef)(null);
    const contentRef = (0, $aOzEm.useRef)(null);
    const [open = false, setOpen] = (0, $b9URh.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $aOzEm.createElement)($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $aD5ro.useId)(),
        titleId: (0, $aD5ro.useId)(),
        descriptionId: (0, $aD5ro.useId)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $aOzEm.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal
    }, children);
};
/*#__PURE__*/ Object.assign($7ef8e22db4e60da6$export$3ddf2d174ce01153, {
    displayName: $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME = "DialogTrigger";
const $7ef8e22db4e60da6$export$2e1e1122cf0cba88 = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useDialogContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $kQ2YW.useComposedRefs)(forwardedRef, context.triggerRef);
    return /*#__PURE__*/ (0, $aOzEm.createElement)((0, $wRVqr.Primitive).button, (0, $H079p.default)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $jjwTY.composeEventHandlers)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($7ef8e22db4e60da6$export$2e1e1122cf0cba88, {
    displayName: $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME = "DialogPortal";
const [$7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$PortalProvider, $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$usePortalContext] = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$createDialogContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, {
    forceMount: undefined
});
const $7ef8e22db4e60da6$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useDialogContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $aOzEm.createElement)($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount
    }, (0, $aOzEm.Children).map(children, (child)=>/*#__PURE__*/ (0, $aOzEm.createElement)((0, $jZEwW.Presence), {
            present: forceMount || context.open
        }, /*#__PURE__*/ (0, $aOzEm.createElement)((0, $exHk7.Portal), {
            asChild: true,
            container: container
        }, child))));
};
/*#__PURE__*/ Object.assign($7ef8e22db4e60da6$export$dad7c95542bacce0, {
    displayName: $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME = "DialogOverlay";
const $7ef8e22db4e60da6$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const portalContext = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$usePortalContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useDialogContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /*#__PURE__*/ (0, $aOzEm.createElement)((0, $jZEwW.Presence), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $aOzEm.createElement)($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl, (0, $H079p.default)({}, overlayProps, {
        ref: forwardedRef
    }))) : null;
});
/*#__PURE__*/ Object.assign($7ef8e22db4e60da6$export$bd1d06c79be19e17, {
    displayName: $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME
});
const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useDialogContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
    return(/*#__PURE__*/ // ie. when `Overlay` and `Content` are siblings
    (0, $aOzEm.createElement)((0, $bett1.default), {
        as: (0, $fFKx1.Slot),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ]
    }, /*#__PURE__*/ (0, $aOzEm.createElement)((0, $wRVqr.Primitive).div, (0, $H079p.default)({
        "data-state": $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
        ref: forwardedRef // We re-enable pointer-events prevented by `Dialog.Content` to allow scrolling the overlay.
        ,
        style: {
            pointerEvents: "auto",
            ...overlayProps.style
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * DialogContent
 * -----------------------------------------------------------------------------------------------*/ const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME = "DialogContent";
const $7ef8e22db4e60da6$export$b6d9565de1e068cf = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const portalContext = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$usePortalContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useDialogContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    return /*#__PURE__*/ (0, $aOzEm.createElement)((0, $jZEwW.Presence), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $aOzEm.createElement)($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DialogContentModal, (0, $H079p.default)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $aOzEm.createElement)($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal, (0, $H079p.default)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($7ef8e22db4e60da6$export$b6d9565de1e068cf, {
    displayName: $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DialogContentModal = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const context = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useDialogContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = (0, $aOzEm.useRef)(null);
    const composedRefs = (0, $kQ2YW.useComposedRefs)(forwardedRef, context.contentRef, contentRef); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $aOzEm.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $8WkFq.hideOthers)(content);
    }, []);
    return /*#__PURE__*/ (0, $aOzEm.createElement)($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $H079p.default)({}, props, {
        ref: composedRefs // we make sure focus isn't trapped once `DialogContent` has been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $jjwTY.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $jjwTY.composeEventHandlers)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick; // If the event is a right-click, we shouldn't close because
            // it is effectively as if we right-clicked the `Overlay`.
            if (isRightClick) event.preventDefault();
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $jjwTY.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault())
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const context = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useDialogContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = (0, $aOzEm.useRef)(false);
    return /*#__PURE__*/ (0, $aOzEm.createElement)($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $H079p.default)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) hasInteractedOutsideRef.current = true; // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            //
            // We use `onInteractOutside` as some browsers also
            // focus on pointer down, creating the same issue.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DialogContentImpl = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useDialogContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = (0, $aOzEm.useRef)(null);
    const composedRefs = (0, $kQ2YW.useComposedRefs)(forwardedRef, contentRef); // Make sure the whole tree has focus guards as our `Dialog` will be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $ljSnT.useFocusGuards)();
    return /*#__PURE__*/ (0, $aOzEm.createElement)((0, $aOzEm.Fragment), null, /*#__PURE__*/ (0, $aOzEm.createElement)((0, $aVSdE.FocusScope), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $aOzEm.createElement)((0, $2JNLW.DismissableLayer), (0, $H079p.default)({
        role: "dialog",
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>context.onOpenChange(false)
    }))), false);
});
/* -------------------------------------------------------------------------------------------------
 * DialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$TITLE_NAME = "DialogTitle";
const $7ef8e22db4e60da6$export$16f7638e4a34b909 = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useDialogContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $aOzEm.createElement)((0, $wRVqr.Primitive).h2, (0, $H079p.default)({
        id: context.titleId
    }, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($7ef8e22db4e60da6$export$16f7638e4a34b909, {
    displayName: $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = "DialogDescription";
const $7ef8e22db4e60da6$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useDialogContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $aOzEm.createElement)((0, $wRVqr.Primitive).p, (0, $H079p.default)({
        id: context.descriptionId
    }, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($7ef8e22db4e60da6$export$94e94c2ec2c954d5, {
    displayName: $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogClose
 * -----------------------------------------------------------------------------------------------*/ const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME = "DialogClose";
const $7ef8e22db4e60da6$export$fba2fb7cd781b7ac = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useDialogContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $aOzEm.createElement)((0, $wRVqr.Primitive).button, (0, $H079p.default)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $jjwTY.composeEventHandlers)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($7ef8e22db4e60da6$export$fba2fb7cd781b7ac, {
    displayName: $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$getState(open) {
    return open ? "open" : "closed";
}
const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
const [$7ef8e22db4e60da6$export$69b62a49393917d6, $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useWarningContext] = (0, $aUf76.createContext)($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
    contentName: $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME,
    titleName: $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$TITLE_NAME,
    docsSlug: "dialog"
});
const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useWarningContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    (0, $aOzEm.useEffect)(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) throw new Error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
const $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$useWarningContext($7ef8e22db4e60da6$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    (0, $aOzEm.useEffect)(()=>{
        var _contentRef$current;
        const describedById = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute("aria-describedby"); // if we have an id and the user hasn't set aria-describedby={undefined}
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
const $7ef8e22db4e60da6$export$be92b6f5f03c0fe9 = $7ef8e22db4e60da6$export$3ddf2d174ce01153;
const $7ef8e22db4e60da6$export$41fb9f06171c75f4 = $7ef8e22db4e60da6$export$2e1e1122cf0cba88;
const $7ef8e22db4e60da6$export$602eac185826482c = $7ef8e22db4e60da6$export$dad7c95542bacce0;
const $7ef8e22db4e60da6$export$c6fdb837b070b4ff = $7ef8e22db4e60da6$export$bd1d06c79be19e17;
const $7ef8e22db4e60da6$export$7c6e2c02157bb7d2 = $7ef8e22db4e60da6$export$b6d9565de1e068cf;
const $7ef8e22db4e60da6$export$f99233281efd08a0 = $7ef8e22db4e60da6$export$16f7638e4a34b909;
const $7ef8e22db4e60da6$export$393edc798c47379d = $7ef8e22db4e60da6$export$94e94c2ec2c954d5;
const $7ef8e22db4e60da6$export$f39c2d165cd861fe = $7ef8e22db4e60da6$export$fba2fb7cd781b7ac;

});
parcelRegister("H079p", function(module, exports) {

$parcel$export(module.exports, "default", () => $08141af8c128aae6$export$2e2bcd8739ae039);
function $08141af8c128aae6$export$2e2bcd8739ae039() {
    return $08141af8c128aae6$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $08141af8c128aae6$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jjwTY", function(module, exports) {

$parcel$export(module.exports, "composeEventHandlers", () => $e0f950468f435d41$export$b9ecd428b558ff10);
function $e0f950468f435d41$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}

});

parcelRegister("kQ2YW", function(module, exports) {

$parcel$export(module.exports, "composeRefs", () => $f2bafa26066eea64$export$43e446d32b3d21af);
$parcel$export(module.exports, "useComposedRefs", () => $f2bafa26066eea64$export$c7b2cbe3552a0d05);

var $aOzEm = parcelRequire("aOzEm");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $f2bafa26066eea64$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $f2bafa26066eea64$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$f2bafa26066eea64$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $f2bafa26066eea64$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $aOzEm.useCallback)($f2bafa26066eea64$export$43e446d32b3d21af(...refs), refs);
}

});

parcelRegister("aUf76", function(module, exports) {

$parcel$export(module.exports, "createContext", () => $7f0adb92618a2445$export$fd42f52fd3ae1109);
$parcel$export(module.exports, "createContextScope", () => $7f0adb92618a2445$export$50c7b4e9d9f19c1);

var $aOzEm = parcelRequire("aOzEm");
function $7f0adb92618a2445$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $aOzEm.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $aOzEm.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $aOzEm.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $aOzEm.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $7f0adb92618a2445$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $aOzEm.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $aOzEm.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $aOzEm.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $aOzEm.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $aOzEm.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $aOzEm.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $7f0adb92618a2445$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $7f0adb92618a2445$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $aOzEm.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}

});

parcelRegister("aD5ro", function(module, exports) {

$parcel$export(module.exports, "useId", () => $7bd1c459ef281e82$export$f680877a34711e37);

var $aOzEm = parcelRequire("aOzEm");

var $9cIQx = parcelRequire("9cIQx");
const $7bd1c459ef281e82$var$$1746a345f3d73bb7$var$useReactId = $aOzEm["useId".toString()] || (()=>undefined);
let $7bd1c459ef281e82$var$$1746a345f3d73bb7$var$count = 0;
function $7bd1c459ef281e82$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $aOzEm.useState($7bd1c459ef281e82$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $9cIQx.useLayoutEffect)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($7bd1c459ef281e82$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}

});
parcelRegister("9cIQx", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $6b380597eb0cbe38$export$e5c5a5f917a5871c);

var $aOzEm = parcelRequire("aOzEm");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $6b380597eb0cbe38$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $aOzEm.useLayoutEffect) : ()=>{};

});


parcelRegister("b9URh", function(module, exports) {

$parcel$export(module.exports, "useControllableState", () => $81fca3db05b3641f$export$6f32135080cb4c3);

var $aOzEm = parcelRequire("aOzEm");

var $jyC7I = parcelRequire("jyC7I");
function $81fca3db05b3641f$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $81fca3db05b3641f$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $jyC7I.useCallbackRef)(onChange);
    const setValue = (0, $aOzEm.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $81fca3db05b3641f$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $aOzEm.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $aOzEm.useRef)(value);
    const handleChange = (0, $jyC7I.useCallbackRef)(onChange);
    (0, $aOzEm.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}

});
parcelRegister("jyC7I", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $e3cec3d4cf51ef1c$export$25bec8c6f54ee79a);

var $aOzEm = parcelRequire("aOzEm");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $e3cec3d4cf51ef1c$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $aOzEm.useRef)(callback);
    (0, $aOzEm.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $aOzEm.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}

});


parcelRegister("2JNLW", function(module, exports) {

$parcel$export(module.exports, "DismissableLayer", () => $1fe66479ac19d3c9$export$177fb62ff3ec1f22);

var $e8O24 = parcelRequire("e8O24");

var $aOzEm = parcelRequire("aOzEm");

var $jjwTY = parcelRequire("jjwTY");

var $wRVqr = parcelRequire("wRVqr");

var $kQ2YW = parcelRequire("kQ2YW");

var $jyC7I = parcelRequire("jyC7I");

var $6y2sP = parcelRequire("6y2sP");
/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $aOzEm.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $1fe66479ac19d3c9$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $aOzEm.useContext)($1fe66479ac19d3c9$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $aOzEm.useState)(null);
    const [, force] = (0, $aOzEm.useState)({});
    const composedRefs = (0, $kQ2YW.useComposedRefs)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    });
    const focusOutside = $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    });
    (0, $6y2sP.useEscapeKeydown)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    });
    (0, $aOzEm.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$originalBodyPointerEvents = document.body.style.pointerEvents;
                document.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) document.body.style.pointerEvents = $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $aOzEm.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $aOzEm.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($1fe66479ac19d3c9$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($1fe66479ac19d3c9$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $aOzEm.createElement)((0, $wRVqr.Primitive).div, (0, $e8O24.default)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $jjwTY.composeEventHandlers)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $jjwTY.composeEventHandlers)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $jjwTY.composeEventHandlers)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($1fe66479ac19d3c9$export$177fb62ff3ec1f22, {
    displayName: $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $1fe66479ac19d3c9$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const context = (0, $aOzEm.useContext)($1fe66479ac19d3c9$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $aOzEm.useRef)(null);
    const composedRefs = (0, $kQ2YW.useComposedRefs)(forwardedRef, ref);
    (0, $aOzEm.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $aOzEm.createElement)((0, $wRVqr.Primitive).div, (0, $e8O24.default)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($1fe66479ac19d3c9$export$4d5eb2109db14228, {
    displayName: $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside) {
    const handlePointerDownOutside = (0, $jyC7I.useCallbackRef)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $aOzEm.useRef)(false);
    const handleClickRef = (0, $aOzEm.useRef)(()=>{});
    (0, $aOzEm.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($1fe66479ac19d3c9$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    document.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    document.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            document.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            document.removeEventListener("pointerdown", handlePointerDown);
            document.removeEventListener("click", handleClickRef.current);
        };
    }, [
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside) {
    const handleFocusOutside = (0, $jyC7I.useCallbackRef)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $aOzEm.useRef)(false);
    (0, $aOzEm.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($1fe66479ac19d3c9$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        document.addEventListener("focusin", handleFocus);
        return ()=>document.removeEventListener("focusin", handleFocus);
    }, [
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($1fe66479ac19d3c9$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $1fe66479ac19d3c9$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $wRVqr.dispatchDiscreteCustomEvent)(target, event);
    else target.dispatchEvent(event);
}
const $1fe66479ac19d3c9$export$be92b6f5f03c0fe9 = $1fe66479ac19d3c9$export$177fb62ff3ec1f22;
const $1fe66479ac19d3c9$export$aecb2ddcb55c95be = $1fe66479ac19d3c9$export$4d5eb2109db14228;

});
parcelRegister("e8O24", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4b89f72e23bbe09$export$2e2bcd8739ae039);
function $a4b89f72e23bbe09$export$2e2bcd8739ae039() {
    return $a4b89f72e23bbe09$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a4b89f72e23bbe09$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("wRVqr", function(module, exports) {

$parcel$export(module.exports, "Primitive", () => $062cd1b2d644c801$export$250ffa63cdc0d034);
$parcel$export(module.exports, "dispatchDiscreteCustomEvent", () => $062cd1b2d644c801$export$6d1a0317bde7de7f);

var $e8O24 = parcelRequire("e8O24");

var $aOzEm = parcelRequire("aOzEm");

var $lOkAX = parcelRequire("lOkAX");

var $fFKx1 = parcelRequire("fFKx1");
const $062cd1b2d644c801$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "h2",
    "h3",
    "img",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $062cd1b2d644c801$export$250ffa63cdc0d034 = $062cd1b2d644c801$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $fFKx1.Slot) : node;
        (0, $aOzEm.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $aOzEm.createElement)(Comp, (0, $e8O24.default)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $062cd1b2d644c801$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $lOkAX.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $062cd1b2d644c801$export$be92b6f5f03c0fe9 = $062cd1b2d644c801$export$250ffa63cdc0d034;

});
parcelRegister("fFKx1", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $b68ec78ff0942bd2$export$8c6ed5c666ac1360);

var $e8O24 = parcelRequire("e8O24");

var $aOzEm = parcelRequire("aOzEm");

var $kQ2YW = parcelRequire("kQ2YW");
/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $b68ec78ff0942bd2$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $aOzEm.Children).toArray(children);
    const slottable = childrenArray.find($b68ec78ff0942bd2$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $aOzEm.Children).count(newElement) > 1) return (0, $aOzEm.Children).only(null);
                return /*#__PURE__*/ (0, $aOzEm.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $aOzEm.createElement)($b68ec78ff0942bd2$var$$5e63c961fc1ce211$var$SlotClone, (0, $e8O24.default)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $aOzEm.isValidElement)(newElement) ? /*#__PURE__*/ (0, $aOzEm.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $aOzEm.createElement)($b68ec78ff0942bd2$var$$5e63c961fc1ce211$var$SlotClone, (0, $e8O24.default)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$b68ec78ff0942bd2$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $b68ec78ff0942bd2$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $aOzEm.isValidElement)(children)) return /*#__PURE__*/ (0, $aOzEm.cloneElement)(children, {
        ...$b68ec78ff0942bd2$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: (0, $kQ2YW.composeRefs)(forwardedRef, children.ref)
    });
    return (0, $aOzEm.Children).count(children) > 1 ? (0, $aOzEm.Children).only(null) : null;
});
$b68ec78ff0942bd2$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $b68ec78ff0942bd2$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $aOzEm.createElement)((0, $aOzEm.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $b68ec78ff0942bd2$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $aOzEm.isValidElement)(child) && child.type === $b68ec78ff0942bd2$export$d9f1ccf0bdb05d45;
}
function $b68ec78ff0942bd2$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName); // if it's a handler, modify the override by composing the base handler
        if (isHandler) overrideProps[propName] = (...args)=>{
            childPropValue === null || childPropValue === void 0 || childPropValue(...args);
            slotPropValue === null || slotPropValue === void 0 || slotPropValue(...args);
        };
        else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $b68ec78ff0942bd2$export$be92b6f5f03c0fe9 = $b68ec78ff0942bd2$export$8c6ed5c666ac1360;

});


parcelRegister("6y2sP", function(module, exports) {

$parcel$export(module.exports, "useEscapeKeydown", () => $4c47d455b2c99517$export$3a72a57244d6e765);

var $aOzEm = parcelRequire("aOzEm");

var $jyC7I = parcelRequire("jyC7I");
/**
 * Listens for when the escape key is down
 */ function $4c47d455b2c99517$export$3a72a57244d6e765(onEscapeKeyDownProp) {
    const onEscapeKeyDown = (0, $jyC7I.useCallbackRef)(onEscapeKeyDownProp);
    (0, $aOzEm.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown
    ]);
}

});


parcelRegister("aVSdE", function(module, exports) {

$parcel$export(module.exports, "FocusScope", () => $7f594907ba31c806$export$20e40289641fbbb6);

var $e8O24 = parcelRequire("e8O24");

var $aOzEm = parcelRequire("aOzEm");

var $kQ2YW = parcelRequire("kQ2YW");

var $wRVqr = parcelRequire("wRVqr");

var $jyC7I = parcelRequire("jyC7I");
const $7f594907ba31c806$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $7f594907ba31c806$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $7f594907ba31c806$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $7f594907ba31c806$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $7f594907ba31c806$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container1, setContainer] = (0, $aOzEm.useState)(null);
    const onMountAutoFocus = (0, $jyC7I.useCallbackRef)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $jyC7I.useCallbackRef)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $aOzEm.useRef)(null);
    const composedRefs = (0, $kQ2YW.useComposedRefs)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $aOzEm.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $aOzEm.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $7f594907ba31c806$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                if (!container1.contains(event.relatedTarget)) $7f594907ba31c806$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $aOzEm.useEffect)(()=>{
        if (container1) {
            $7f594907ba31c806$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($7f594907ba31c806$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $7f594907ba31c806$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($7f594907ba31c806$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $7f594907ba31c806$var$$d3863c46a17e8a28$var$focusFirst($7f594907ba31c806$var$$d3863c46a17e8a28$var$removeLinks($7f594907ba31c806$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $7f594907ba31c806$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($7f594907ba31c806$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($7f594907ba31c806$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $7f594907ba31c806$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($7f594907ba31c806$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $7f594907ba31c806$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($7f594907ba31c806$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $7f594907ba31c806$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $aOzEm.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $7f594907ba31c806$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $7f594907ba31c806$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $7f594907ba31c806$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $aOzEm.createElement)((0, $wRVqr.Primitive).div, (0, $e8O24.default)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($7f594907ba31c806$export$20e40289641fbbb6, {
    displayName: $7f594907ba31c806$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $7f594907ba31c806$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $7f594907ba31c806$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $7f594907ba31c806$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $7f594907ba31c806$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $7f594907ba31c806$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $7f594907ba31c806$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $7f594907ba31c806$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $7f594907ba31c806$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$7f594907ba31c806$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $7f594907ba31c806$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $7f594907ba31c806$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $7f594907ba31c806$var$$d3863c46a17e8a28$var$focus(element, { select: select = false } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $7f594907ba31c806$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $7f594907ba31c806$var$$d3863c46a17e8a28$var$focusScopesStack = $7f594907ba31c806$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $7f594907ba31c806$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $7f594907ba31c806$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $7f594907ba31c806$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $7f594907ba31c806$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $7f594907ba31c806$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $7f594907ba31c806$export$be92b6f5f03c0fe9 = $7f594907ba31c806$export$20e40289641fbbb6;

});

parcelRegister("exHk7", function(module, exports) {

$parcel$export(module.exports, "Portal", () => $a965c0e9270e9f1a$export$602eac185826482c);

var $e8O24 = parcelRequire("e8O24");

var $aOzEm = parcelRequire("aOzEm");

var $lOkAX = parcelRequire("lOkAX");

var $wRVqr = parcelRequire("wRVqr");
/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $a965c0e9270e9f1a$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $a965c0e9270e9f1a$export$602eac185826482c = /*#__PURE__*/ (0, $aOzEm.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lOkAX))).createPortal(/*#__PURE__*/ (0, $aOzEm.createElement)((0, $wRVqr.Primitive).div, (0, $e8O24.default)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($a965c0e9270e9f1a$export$602eac185826482c, {
    displayName: $a965c0e9270e9f1a$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $a965c0e9270e9f1a$export$be92b6f5f03c0fe9 = $a965c0e9270e9f1a$export$602eac185826482c;

});

parcelRegister("jZEwW", function(module, exports) {

$parcel$export(module.exports, "Presence", () => $e8e32749e9fda18f$export$99c2b779aa4e8b8b);

var $aOzEm = parcelRequire("aOzEm");

var $lOkAX = parcelRequire("lOkAX");

var $kQ2YW = parcelRequire("kQ2YW");

var $9cIQx = parcelRequire("9cIQx");
function $e8e32749e9fda18f$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $aOzEm.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $e8e32749e9fda18f$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $e8e32749e9fda18f$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $aOzEm.Children).only(children);
    const ref = (0, $kQ2YW.useComposedRefs)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $aOzEm.cloneElement)(child, {
        ref: ref
    }) : null;
};
$e8e32749e9fda18f$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $e8e32749e9fda18f$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $aOzEm.useState)();
    const stylesRef = (0, $aOzEm.useRef)({});
    const prevPresentRef = (0, $aOzEm.useRef)(present);
    const prevAnimationNameRef = (0, $aOzEm.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $e8e32749e9fda18f$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $aOzEm.useEffect)(()=>{
        const currentAnimationName = $e8e32749e9fda18f$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $9cIQx.useLayoutEffect)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $e8e32749e9fda18f$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $9cIQx.useLayoutEffect)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $e8e32749e9fda18f$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $lOkAX.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $e8e32749e9fda18f$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $aOzEm.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $e8e32749e9fda18f$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}

});

parcelRegister("ljSnT", function(module, exports) {

$parcel$export(module.exports, "useFocusGuards", () => $f8558eede4090c8f$export$b7ece24a22aeda8c);

var $aOzEm = parcelRequire("aOzEm");
/** Number of components which have requested interest to have focus guards */ let $f8558eede4090c8f$var$$3db38b7d1fb3fe6a$var$count = 0;
function $f8558eede4090c8f$export$ac5b58043b79449b(props) {
    $f8558eede4090c8f$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $f8558eede4090c8f$export$b7ece24a22aeda8c() {
    (0, $aOzEm.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $f8558eede4090c8f$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $f8558eede4090c8f$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $f8558eede4090c8f$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($f8558eede4090c8f$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $f8558eede4090c8f$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $f8558eede4090c8f$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $f8558eede4090c8f$export$be92b6f5f03c0fe9 = $f8558eede4090c8f$export$ac5b58043b79449b;

});

parcelRegister("bett1", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d7dc0d3c317e70$export$2e2bcd8739ae039);

var $6JRCg = parcelRequire("6JRCg");

var $aOzEm = parcelRequire("aOzEm");

var $kqPr5 = parcelRequire("kqPr5");

var $9e36z = parcelRequire("9e36z");
var $82d7dc0d3c317e70$var$ReactRemoveScroll = $aOzEm.forwardRef(function(props, ref) {
    return $aOzEm.createElement((0, $kqPr5.RemoveScroll), (0, $6JRCg.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $9e36z.default)
    }));
});
$82d7dc0d3c317e70$var$ReactRemoveScroll.classNames = (0, $kqPr5.RemoveScroll).classNames;
var $82d7dc0d3c317e70$export$2e2bcd8739ae039 = $82d7dc0d3c317e70$var$ReactRemoveScroll;

});
parcelRegister("6JRCg", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $4e80891894e6c152$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $4e80891894e6c152$export$3c9a16f847548506);
$parcel$export(module.exports, "__spreadArray", () => $4e80891894e6c152$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $4e80891894e6c152$var$extendStatics = function(d, b) {
    $4e80891894e6c152$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4e80891894e6c152$var$extendStatics(d, b);
};
function $4e80891894e6c152$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4e80891894e6c152$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4e80891894e6c152$export$18ce0697a983be9b = function() {
    $4e80891894e6c152$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4e80891894e6c152$export$18ce0697a983be9b.apply(this, arguments);
};
function $4e80891894e6c152$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4e80891894e6c152$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4e80891894e6c152$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4e80891894e6c152$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $4e80891894e6c152$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $4e80891894e6c152$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $4e80891894e6c152$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $4e80891894e6c152$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4e80891894e6c152$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4e80891894e6c152$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4e80891894e6c152$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4e80891894e6c152$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4e80891894e6c152$export$45d3717a4c69092e(o, m, p);
}
function $4e80891894e6c152$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4e80891894e6c152$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4e80891894e6c152$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4e80891894e6c152$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4e80891894e6c152$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4e80891894e6c152$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4e80891894e6c152$export$10c90e4f7922046c(v) {
    return this instanceof $4e80891894e6c152$export$10c90e4f7922046c ? (this.v = v, this) : new $4e80891894e6c152$export$10c90e4f7922046c(v);
}
function $4e80891894e6c152$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4e80891894e6c152$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4e80891894e6c152$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4e80891894e6c152$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $4e80891894e6c152$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4e80891894e6c152$export$19a8beecd37a4c45 === "function" ? $4e80891894e6c152$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4e80891894e6c152$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4e80891894e6c152$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $4e80891894e6c152$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4e80891894e6c152$export$45d3717a4c69092e(result, mod, k);
    }
    $4e80891894e6c152$var$__setModuleDefault(result, mod);
    return result;
}
function $4e80891894e6c152$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4e80891894e6c152$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4e80891894e6c152$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4e80891894e6c152$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $4e80891894e6c152$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $4e80891894e6c152$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $4e80891894e6c152$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $4e80891894e6c152$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $4e80891894e6c152$export$2e2bcd8739ae039 = {
    __extends: $4e80891894e6c152$export$a8ba968b8961cb8a,
    __assign: $4e80891894e6c152$export$18ce0697a983be9b,
    __rest: $4e80891894e6c152$export$3c9a16f847548506,
    __decorate: $4e80891894e6c152$export$29e00dfd3077644b,
    __param: $4e80891894e6c152$export$d5ad3fd78186038f,
    __metadata: $4e80891894e6c152$export$f1db080c865becb9,
    __awaiter: $4e80891894e6c152$export$1050f835b63b671e,
    __generator: $4e80891894e6c152$export$67ebef60e6f28a6,
    __createBinding: $4e80891894e6c152$export$45d3717a4c69092e,
    __exportStar: $4e80891894e6c152$export$f33643c0debef087,
    __values: $4e80891894e6c152$export$19a8beecd37a4c45,
    __read: $4e80891894e6c152$export$8d051b38c9118094,
    __spread: $4e80891894e6c152$export$afc72e2116322959,
    __spreadArrays: $4e80891894e6c152$export$6388937ca91ccae8,
    __spreadArray: $4e80891894e6c152$export$1216008129fb82ed,
    __await: $4e80891894e6c152$export$10c90e4f7922046c,
    __asyncGenerator: $4e80891894e6c152$export$e427f37a30a4de9b,
    __asyncDelegator: $4e80891894e6c152$export$bbd80228419bb833,
    __asyncValues: $4e80891894e6c152$export$e3b29a3d6162315f,
    __makeTemplateObject: $4e80891894e6c152$export$4fb47efe1390b86f,
    __importStar: $4e80891894e6c152$export$c21735bcef00d192,
    __importDefault: $4e80891894e6c152$export$da59b14a69baef04,
    __classPrivateFieldGet: $4e80891894e6c152$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $4e80891894e6c152$export$d40a35129aaff81f,
    __classPrivateFieldIn: $4e80891894e6c152$export$81fdc39f203e4e04,
    __addDisposableResource: $4e80891894e6c152$export$88ac25d8e944e405,
    __disposeResources: $4e80891894e6c152$export$8f076105dc360e92
};

});

parcelRegister("kqPr5", function(module, exports) {

$parcel$export(module.exports, "RemoveScroll", () => $edfe2273e98a26e7$export$22940b497e769dee);

var $6JRCg = parcelRequire("6JRCg");

var $aOzEm = parcelRequire("aOzEm");

var $DE7wW = parcelRequire("DE7wW");

var $9iF0p = parcelRequire("9iF0p");

var $8WoCA = parcelRequire("8WoCA");
var $edfe2273e98a26e7$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $edfe2273e98a26e7$export$22940b497e769dee = $aOzEm.forwardRef(function(props, parentRef) {
    var ref = $aOzEm.useRef(null);
    var _a = $aOzEm.useState({
        onScrollCapture: $edfe2273e98a26e7$var$nothing,
        onWheelCapture: $edfe2273e98a26e7$var$nothing,
        onTouchMoveCapture: $edfe2273e98a26e7$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $6JRCg.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $9iF0p.useMergeRefs)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $6JRCg.__assign)((0, $6JRCg.__assign)({}, rest), callbacks);
    return $aOzEm.createElement($aOzEm.Fragment, null, enabled && $aOzEm.createElement(SideCar, {
        sideCar: (0, $8WoCA.effectCar),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $aOzEm.cloneElement($aOzEm.Children.only(children), (0, $6JRCg.__assign)((0, $6JRCg.__assign)({}, containerProps), {
        ref: containerRef
    })) : $aOzEm.createElement(Container, (0, $6JRCg.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$edfe2273e98a26e7$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$edfe2273e98a26e7$export$22940b497e769dee.classNames = {
    fullWidth: (0, $DE7wW.fullWidthClassName),
    zeroRight: (0, $DE7wW.zeroRightClassName)
};

});
parcelRegister("DE7wW", function(module, exports) {

$parcel$export(module.exports, "zeroRightClassName", () => $0772c3b851c25a19$export$1da7500147d4bc3);
$parcel$export(module.exports, "fullWidthClassName", () => $0772c3b851c25a19$export$898e37bbd2a0ae4e);
$parcel$export(module.exports, "noScrollbarsClassName", () => $0772c3b851c25a19$export$bb813dfbbc432abc);
$parcel$export(module.exports, "removedBarSizeVariable", () => $0772c3b851c25a19$export$63d0edf80fea83b1);
var $0772c3b851c25a19$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $0772c3b851c25a19$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $0772c3b851c25a19$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $0772c3b851c25a19$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";

});

parcelRegister("9iF0p", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $6c559a561de199aa$export$74665b213cb5c4cf);

var $6sKmh = parcelRequire("6sKmh");

var $b5W40 = parcelRequire("b5W40");
function $6c559a561de199aa$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $b5W40.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $6sKmh.assignRef)(ref, newValue);
        });
    });
}

});
parcelRegister("6sKmh", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $4b495167115adbde$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $4b495167115adbde$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("b5W40", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $813d3395719a50d2$export$25bec8c6f54ee79a);

var $aOzEm = parcelRequire("aOzEm");
function $813d3395719a50d2$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $aOzEm.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("8WoCA", function(module, exports) {

$parcel$export(module.exports, "effectCar", () => $6826d6d13f77eb5c$export$e27363444bedfeac);

var $iz3J1 = parcelRequire("iz3J1");
var $6826d6d13f77eb5c$export$e27363444bedfeac = (0, $iz3J1.createSidecarMedium)();

});
parcelRegister("iz3J1", function(module, exports) {

$parcel$export(module.exports, "createSidecarMedium", () => $d83e629bbc46a303$export$e13ec7dd7a14088d);

var $6JRCg = parcelRequire("6JRCg");
function $d83e629bbc46a303$var$ItoI(a) {
    return a;
}
function $d83e629bbc46a303$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $d83e629bbc46a303$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $d83e629bbc46a303$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $d83e629bbc46a303$var$ItoI;
    return $d83e629bbc46a303$var$innerCreateMedium(defaults, middleware);
}
function $d83e629bbc46a303$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $d83e629bbc46a303$var$innerCreateMedium(null);
    medium.options = (0, $6JRCg.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});



parcelRegister("9e36z", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b77d47133c000d8$export$2e2bcd8739ae039);

var $l3aWm = parcelRequire("l3aWm");

var $i4uKB = parcelRequire("i4uKB");

var $8WoCA = parcelRequire("8WoCA");
var $6b77d47133c000d8$export$2e2bcd8739ae039 = (0, $l3aWm.exportSidecar)((0, $8WoCA.effectCar), (0, $i4uKB.RemoveScrollSideCar));

});
parcelRegister("l3aWm", function(module, exports) {

$parcel$export(module.exports, "exportSidecar", () => $f5325d484fc21363$export$6cacc8fb0a9b94ce);

var $6JRCg = parcelRequire("6JRCg");

var $aOzEm = parcelRequire("aOzEm");
var $f5325d484fc21363$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $6JRCg.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $aOzEm.createElement(Target, (0, $6JRCg.__assign)({}, rest));
};
$f5325d484fc21363$var$SideCar.isSideCarExport = true;
function $f5325d484fc21363$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $f5325d484fc21363$var$SideCar;
}

});

parcelRegister("i4uKB", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollSideCar", () => $d2807422f45bdf10$export$a09dbff87b5da2d);

var $6JRCg = parcelRequire("6JRCg");

var $aOzEm = parcelRequire("aOzEm");
parcelRequire("iq61M");
var $0232z = parcelRequire("0232z");
parcelRequire("k0p9l");
var $gj1ak = parcelRequire("gj1ak");

var $hnaKq = parcelRequire("hnaKq");

var $gZiWz = parcelRequire("gZiWz");
var $d2807422f45bdf10$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $d2807422f45bdf10$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $d2807422f45bdf10$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $d2807422f45bdf10$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $d2807422f45bdf10$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $d2807422f45bdf10$var$idCounter = 0;
var $d2807422f45bdf10$var$lockStack = [];
function $d2807422f45bdf10$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $aOzEm.useRef([]);
    var touchStartRef = $aOzEm.useRef([
        0,
        0
    ]);
    var activeAxis = $aOzEm.useRef();
    var id = $aOzEm.useState($d2807422f45bdf10$var$idCounter++)[0];
    var Style = $aOzEm.useState(function() {
        return (0, $gj1ak.styleSingleton)();
    })[0];
    var lastProps = $aOzEm.useRef(props);
    $aOzEm.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $aOzEm.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $6JRCg.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($d2807422f45bdf10$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $aOzEm.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $d2807422f45bdf10$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $gZiWz.locationCouldBeScrolled)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $gZiWz.locationCouldBeScrolled)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $gZiWz.handleScroll)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $aOzEm.useCallback(function(_event) {
        var event = _event;
        if (!$d2807422f45bdf10$var$lockStack.length || $d2807422f45bdf10$var$lockStack[$d2807422f45bdf10$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $d2807422f45bdf10$export$39efaa2ca254a28d(event) : $d2807422f45bdf10$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $d2807422f45bdf10$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($d2807422f45bdf10$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) event.preventDefault();
        }
    }, []);
    var shouldCancel = $aOzEm.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $aOzEm.useCallback(function(event) {
        touchStartRef.current = $d2807422f45bdf10$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $aOzEm.useCallback(function(event) {
        shouldCancel(event.type, $d2807422f45bdf10$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $aOzEm.useCallback(function(event) {
        shouldCancel(event.type, $d2807422f45bdf10$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $aOzEm.useEffect(function() {
        $d2807422f45bdf10$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $hnaKq.nonPassive));
        document.addEventListener("touchmove", shouldPrevent, (0, $hnaKq.nonPassive));
        document.addEventListener("touchstart", scrollTouchStart, (0, $hnaKq.nonPassive));
        return function() {
            $d2807422f45bdf10$var$lockStack = $d2807422f45bdf10$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $hnaKq.nonPassive));
            document.removeEventListener("touchmove", shouldPrevent, (0, $hnaKq.nonPassive));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $hnaKq.nonPassive));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $aOzEm.createElement($aOzEm.Fragment, null, inert ? $aOzEm.createElement(Style, {
        styles: $d2807422f45bdf10$var$generateStyle(id)
    }) : null, removeScrollBar ? $aOzEm.createElement((0, $0232z.RemoveScrollBar), {
        gapMode: "margin"
    }) : null);
}

});
parcelRegister("iq61M", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", () => (parcelRequire("0232z")).RemoveScrollBar);

var $0232z = parcelRequire("0232z");

var $DE7wW = parcelRequire("DE7wW");

var $01XfQ = parcelRequire("01XfQ");

});
parcelRegister("0232z", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", () => $00628bc72db10c71$export$9aa43b459c5ae9b9);

var $aOzEm = parcelRequire("aOzEm");
parcelRequire("k0p9l");
var $gj1ak = parcelRequire("gj1ak");

var $DE7wW = parcelRequire("DE7wW");

var $01XfQ = parcelRequire("01XfQ");
var $00628bc72db10c71$var$Style = (0, $gj1ak.styleSingleton)();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $00628bc72db10c71$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $DE7wW.noScrollbarsClassName), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $DE7wW.zeroRightClassName), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $DE7wW.fullWidthClassName), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $DE7wW.zeroRightClassName), " .").concat((0, $DE7wW.zeroRightClassName), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $DE7wW.fullWidthClassName), " .").concat((0, $DE7wW.fullWidthClassName), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat((0, $DE7wW.removedBarSizeVariable), ": ").concat(gap, "px;\n  }\n");
};
var $00628bc72db10c71$export$9aa43b459c5ae9b9 = function(props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? "margin" : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $aOzEm.useMemo(function() {
        return (0, $01XfQ.getGapWidth)(gapMode);
    }, [
        gapMode
    ]);
    return $aOzEm.createElement($00628bc72db10c71$var$Style, {
        styles: $00628bc72db10c71$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};

});
parcelRegister("k0p9l", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", () => (parcelRequire("gj1ak")).styleSingleton);

var $gj1ak = parcelRequire("gj1ak");

var $6o9J7 = parcelRequire("6o9J7");

var $9K1pB = parcelRequire("9K1pB");

});
parcelRegister("gj1ak", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", () => $bdef53284f49bb88$export$c1248ee86ba532c8);

var $9K1pB = parcelRequire("9K1pB");
var $bdef53284f49bb88$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $9K1pB.styleHookSingleton)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

});
parcelRegister("9K1pB", function(module, exports) {

$parcel$export(module.exports, "styleHookSingleton", () => $717981566acdd3df$export$7d7b35c2d250e94c);

var $aOzEm = parcelRequire("aOzEm");

var $6o9J7 = parcelRequire("6o9J7");
var $717981566acdd3df$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $6o9J7.stylesheetSingleton)();
    return function(styles, isDynamic) {
        $aOzEm.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};

});
parcelRegister("6o9J7", function(module, exports) {

$parcel$export(module.exports, "stylesheetSingleton", () => $4a6c877902c4aeee$export$7c74eec858d5d226);

var $jTIGG = parcelRequire("jTIGG");
function $4a6c877902c4aeee$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $jTIGG.getNonce)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $4a6c877902c4aeee$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $4a6c877902c4aeee$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $4a6c877902c4aeee$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $4a6c877902c4aeee$var$makeStyleTag()) {
                    $4a6c877902c4aeee$var$injectStyles(stylesheet, style);
                    $4a6c877902c4aeee$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

});
parcelRegister("jTIGG", function(module, exports) {

$parcel$export(module.exports, "getNonce", () => $e7c5d15f760cd690$export$2b85b721e524d74b);
var $e7c5d15f760cd690$var$currentNonce;
var $e7c5d15f760cd690$export$c5f670b24c0ae95a = function(nonce) {
    $e7c5d15f760cd690$var$currentNonce = nonce;
};
var $e7c5d15f760cd690$export$2b85b721e524d74b = function() {
    if ($e7c5d15f760cd690$var$currentNonce) return $e7c5d15f760cd690$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};

});





parcelRegister("01XfQ", function(module, exports) {

$parcel$export(module.exports, "getGapWidth", () => $005e0edb3b57fb31$export$75f2ca8f029c77f4);
var $005e0edb3b57fb31$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $005e0edb3b57fb31$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $005e0edb3b57fb31$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $005e0edb3b57fb31$var$parse(left),
        $005e0edb3b57fb31$var$parse(top),
        $005e0edb3b57fb31$var$parse(right)
    ];
};
var $005e0edb3b57fb31$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $005e0edb3b57fb31$export$efed13b5d0ca3386;
    var offsets = $005e0edb3b57fb31$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};

});



parcelRegister("hnaKq", function(module, exports) {

$parcel$export(module.exports, "nonPassive", () => $ca5cebf4c375bfaf$export$10a6e88623fa9454);
var $ca5cebf4c375bfaf$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $ca5cebf4c375bfaf$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $ca5cebf4c375bfaf$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $ca5cebf4c375bfaf$var$options, $ca5cebf4c375bfaf$var$options);
    // @ts-ignore
    window.removeEventListener("test", $ca5cebf4c375bfaf$var$options, $ca5cebf4c375bfaf$var$options);
} catch (err) {
    $ca5cebf4c375bfaf$var$passiveSupported = false;
}
var $ca5cebf4c375bfaf$export$10a6e88623fa9454 = $ca5cebf4c375bfaf$var$passiveSupported ? {
    passive: false
} : false;

});

parcelRegister("gZiWz", function(module, exports) {

$parcel$export(module.exports, "locationCouldBeScrolled", () => $c5e109aa4308ef85$export$9ec64480cae49817);
$parcel$export(module.exports, "handleScroll", () => $c5e109aa4308ef85$export$dde0441bd4a6ded8);
var $c5e109aa4308ef85$var$elementCouldBeVScrolled = function(node) {
    var styles = window.getComputedStyle(node);
    return styles.overflowY !== "hidden" && // not-not-scrollable
    !(styles.overflowY === styles.overflowX && styles.overflowY === "visible" // scrollable
    );
};
var $c5e109aa4308ef85$var$elementCouldBeHScrolled = function(node) {
    var styles = window.getComputedStyle(node);
    return styles.overflowX !== "hidden" && // not-not-scrollable
    !(styles.overflowY === styles.overflowX && styles.overflowX === "visible" // scrollable
    );
};
var $c5e109aa4308ef85$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $c5e109aa4308ef85$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $c5e109aa4308ef85$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $c5e109aa4308ef85$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $c5e109aa4308ef85$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $c5e109aa4308ef85$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $c5e109aa4308ef85$var$elementCouldBeVScrolled(node) : $c5e109aa4308ef85$var$elementCouldBeHScrolled(node);
};
var $c5e109aa4308ef85$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $c5e109aa4308ef85$var$getVScrollVariables(node) : $c5e109aa4308ef85$var$getHScrollVariables(node);
};
var $c5e109aa4308ef85$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $c5e109aa4308ef85$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $c5e109aa4308ef85$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $c5e109aa4308ef85$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($c5e109aa4308ef85$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};

});




parcelRegister("8WkFq", function(module, exports) {

$parcel$export(module.exports, "hideOthers", () => $6823c590a7044b20$export$6e33d16126ed003c);
var $6823c590a7044b20$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $6823c590a7044b20$var$counterMap = new WeakMap();
var $6823c590a7044b20$var$uncontrolledNodes = new WeakMap();
var $6823c590a7044b20$var$markerMap = {};
var $6823c590a7044b20$var$lockCount = 0;
var $6823c590a7044b20$var$unwrapHost = function(node) {
    return node && (node.host || $6823c590a7044b20$var$unwrapHost(node.parentNode));
};
var $6823c590a7044b20$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $6823c590a7044b20$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $6823c590a7044b20$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $6823c590a7044b20$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$6823c590a7044b20$var$markerMap[markerName]) $6823c590a7044b20$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $6823c590a7044b20$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($6823c590a7044b20$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $6823c590a7044b20$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $6823c590a7044b20$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $6823c590a7044b20$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $6823c590a7044b20$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $6823c590a7044b20$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$6823c590a7044b20$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $6823c590a7044b20$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $6823c590a7044b20$var$lockCount--;
        if (!$6823c590a7044b20$var$lockCount) {
            // clear
            $6823c590a7044b20$var$counterMap = new WeakMap();
            $6823c590a7044b20$var$counterMap = new WeakMap();
            $6823c590a7044b20$var$uncontrolledNodes = new WeakMap();
            $6823c590a7044b20$var$markerMap = {};
        }
    };
};
var $6823c590a7044b20$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $6823c590a7044b20$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $6823c590a7044b20$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $6823c590a7044b20$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $6823c590a7044b20$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $6823c590a7044b20$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $6823c590a7044b20$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $6823c590a7044b20$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($6823c590a7044b20$export$cc95fea82d705fca() ? $6823c590a7044b20$export$59151cc8db999a24 : $6823c590a7044b20$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};

});


parcelRegister("9H74C", function(module, exports) {
// The scores are arranged so that a continuous match of characters will
// result in a total score of 1.
//
// The best case, this character is a match, and either this is the start
// of the string, or the previous character was also a match.
var $70ed9dd940e9df93$var$SCORE_CONTINUE_MATCH = 1, // A new match at the start of a word scores better than a new match
// elsewhere as it's more likely that the user will type the starts
// of fragments.
// (Our notion of word includes CamelCase and hypen-separated, etc.)
$70ed9dd940e9df93$var$SCORE_WORD_JUMP = 0.9, // Any other match isn't ideal, but we include it for completeness.
$70ed9dd940e9df93$var$SCORE_CHARACTER_JUMP = 0.3, // If the user transposed two letters, it should be signficantly penalized.
//
// i.e. "ouch" is more likely than "curtain" when "uc" is typed.
$70ed9dd940e9df93$var$SCORE_TRANSPOSITION = 0.1, // If the user jumped to half-way through a subsequent word, it should be
// very significantly penalized.
//
// i.e. "loes" is very unlikely to match "loch ness".
// NOTE: this is set to 0 for superhuman right now, but we may want to revisit.
$70ed9dd940e9df93$var$SCORE_LONG_JUMP = 0, // The goodness of a match should decay slightly with each missing
// character.
//
// i.e. "bad" is more likely than "bard" when "bd" is typed.
//
// This will not change the order of suggestions based on SCORE_* until
// 100 characters are inserted between matches.
$70ed9dd940e9df93$var$PENALTY_SKIPPED = 0.999, // The goodness of an exact-case match should be higher than a
// case-insensitive match by a small amount.
//
// i.e. "HTML" is more likely than "haml" when "HM" is typed.
//
// This will not change the order of suggestions based on SCORE_* until
// 1000 characters are inserted between matches.
$70ed9dd940e9df93$var$PENALTY_CASE_MISMATCH = 0.9999, // If the word has more characters than the user typed, it should
// be penalised slightly.
//
// i.e. "html" is more likely than "html5" if I type "html".
//
// However, it may well be the case that there's a sensible secondary
// ordering (like alphabetical) that it makes sense to rely on when
// there are many prefix matches, so we don't make the penalty increase
// with the number of tokens.
$70ed9dd940e9df93$var$PENALTY_NOT_COMPLETE = 0.99;
var $70ed9dd940e9df93$var$IS_GAP_REGEXP = /[\\\/\-_+.# \t"@\[\(\{&]/, $70ed9dd940e9df93$var$COUNT_GAPS_REGEXP = /[\\\/\-_+.# \t"@\[\(\{&]/g;
function $70ed9dd940e9df93$var$commandScoreInner(string, abbreviation, lowerString, lowerAbbreviation, stringIndex, abbreviationIndex) {
    if (abbreviationIndex === abbreviation.length) {
        if (stringIndex === string.length) return $70ed9dd940e9df93$var$SCORE_CONTINUE_MATCH;
        return $70ed9dd940e9df93$var$PENALTY_NOT_COMPLETE;
    }
    var abbreviationChar = lowerAbbreviation.charAt(abbreviationIndex);
    var index = lowerString.indexOf(abbreviationChar, stringIndex);
    var highScore = 0;
    var score, transposedScore, wordBreaks;
    while(index >= 0){
        score = $70ed9dd940e9df93$var$commandScoreInner(string, abbreviation, lowerString, lowerAbbreviation, index + 1, abbreviationIndex + 1);
        if (score > highScore) {
            if (index === stringIndex) score *= $70ed9dd940e9df93$var$SCORE_CONTINUE_MATCH;
            else if ($70ed9dd940e9df93$var$IS_GAP_REGEXP.test(string.charAt(index - 1))) {
                score *= $70ed9dd940e9df93$var$SCORE_WORD_JUMP;
                wordBreaks = string.slice(stringIndex, index - 1).match($70ed9dd940e9df93$var$COUNT_GAPS_REGEXP);
                if (wordBreaks && stringIndex > 0) score *= Math.pow($70ed9dd940e9df93$var$PENALTY_SKIPPED, wordBreaks.length);
            } else if ($70ed9dd940e9df93$var$IS_GAP_REGEXP.test(string.slice(stringIndex, index - 1))) {
                score *= $70ed9dd940e9df93$var$SCORE_LONG_JUMP;
                if (stringIndex > 0) score *= Math.pow($70ed9dd940e9df93$var$PENALTY_SKIPPED, index - stringIndex);
            } else {
                score *= $70ed9dd940e9df93$var$SCORE_CHARACTER_JUMP;
                if (stringIndex > 0) score *= Math.pow($70ed9dd940e9df93$var$PENALTY_SKIPPED, index - stringIndex);
            }
            if (string.charAt(index) !== abbreviation.charAt(abbreviationIndex)) score *= $70ed9dd940e9df93$var$PENALTY_CASE_MISMATCH;
        }
        if (score < $70ed9dd940e9df93$var$SCORE_TRANSPOSITION && lowerString.charAt(index - 1) === lowerAbbreviation.charAt(abbreviationIndex + 1) && lowerString.charAt(index - 1) !== lowerAbbreviation.charAt(abbreviationIndex)) {
            transposedScore = $70ed9dd940e9df93$var$commandScoreInner(string, abbreviation, lowerString, lowerAbbreviation, index + 1, abbreviationIndex + 2);
            if (transposedScore * $70ed9dd940e9df93$var$SCORE_TRANSPOSITION > score) score = transposedScore * $70ed9dd940e9df93$var$SCORE_TRANSPOSITION;
        }
        if (score > highScore) highScore = score;
        index = lowerString.indexOf(abbreviationChar, index + 1);
    }
    return highScore;
}
function $70ed9dd940e9df93$var$commandScore(string, abbreviation) {
    /* NOTE:
     * in the original, we used to do the lower-casing on each recursive call, but this meant that toLowerCase()
     * was the dominating cost in the algorithm, passing both is a little ugly, but considerably faster.
     */ return $70ed9dd940e9df93$var$commandScoreInner(string, abbreviation, string.toLowerCase(), abbreviation.toLowerCase(), 0, 0);
}
module.exports = $70ed9dd940e9df93$var$commandScore;

});


parcelRegister("4MSgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $37c5bca3f9eb6802$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $2Us5L = parcelRequire("2Us5L");

var $63Oo6 = parcelRequire("63Oo6");

var $k9mDT = parcelRequire("k9mDT");

var $3RfNY = parcelRequire("3RfNY");

var $h0mm1 = parcelRequire("h0mm1");

var $gEb5G = parcelRequire("gEb5G");

var $25zst = parcelRequire("25zst");

var $3O6jd = parcelRequire("3O6jd");

var $1nR8g = parcelRequire("1nR8g");

var $kLW6G = parcelRequire("kLW6G");

var $57YGU = parcelRequire("57YGU");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $37c5bca3f9eb6802$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $37c5bca3f9eb6802$var$DialogBackdrop = (0, $25zst.default)((0, $kLW6G.default), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $37c5bca3f9eb6802$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $63Oo6.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $63Oo6.default)(scroll)}`,
            `paperWidth${(0, $63Oo6.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $3O6jd.getDialogUtilityClass), classes);
};
const $37c5bca3f9eb6802$var$DialogRoot = (0, $25zst.default)((0, $k9mDT.default), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $37c5bca3f9eb6802$var$DialogContainer = (0, $25zst.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $63Oo6.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $g6Hsb.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&:after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $37c5bca3f9eb6802$var$DialogPaper = (0, $25zst.default)((0, $h0mm1.default), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $63Oo6.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $63Oo6.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $3O6jd.default).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $3O6jd.default).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $3O6jd.default).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $37c5bca3f9eb6802$var$Dialog = /*#__PURE__*/ $aOzEm.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $57YGU.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $h0mm1.default), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $3RfNY.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $cAqXo.default)(props, $37c5bca3f9eb6802$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $37c5bca3f9eb6802$var$useUtilityClasses(ownerState);
    const backdropClick = $aOzEm.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $2Us5L.default)(ariaLabelledbyProp);
    const dialogContextValue = $aOzEm.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($37c5bca3f9eb6802$var$DialogRoot, (0, $g6Hsb.default)({
        className: (0, $g45Wv.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $37c5bca3f9eb6802$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $g6Hsb.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $2T9xh.jsx)(TransitionComponent, (0, $g6Hsb.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $2T9xh.jsx)($37c5bca3f9eb6802$var$DialogContainer, {
                className: (0, $g45Wv.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $2T9xh.jsx)($37c5bca3f9eb6802$var$DialogPaper, (0, $g6Hsb.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $g45Wv.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $1nR8g.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $37c5bca3f9eb6802$export$2e2bcd8739ae039 = $37c5bca3f9eb6802$var$Dialog;

});
parcelRegister("3O6jd", function(module, exports) {

$parcel$export(module.exports, "getDialogUtilityClass", () => $2c5aef6ca41eb3ab$export$2177af0aa15c34c2);
$parcel$export(module.exports, "default", () => $2c5aef6ca41eb3ab$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $2c5aef6ca41eb3ab$export$2177af0aa15c34c2(slot) {
    return (0, $6vnyE.default)("MuiDialog", slot);
}
const $2c5aef6ca41eb3ab$var$dialogClasses = (0, $cyhE3.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $2c5aef6ca41eb3ab$export$2e2bcd8739ae039 = $2c5aef6ca41eb3ab$var$dialogClasses;

});

parcelRegister("1nR8g", function(module, exports) {

$parcel$export(module.exports, "default", () => $10212761f7ff478c$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");
const $10212761f7ff478c$var$DialogContext = /*#__PURE__*/ $aOzEm.createContext({});
var $10212761f7ff478c$export$2e2bcd8739ae039 = $10212761f7ff478c$var$DialogContext;

});


parcelRegister("3Nqau", function(module, exports) {

$parcel$export(module.exports, "decodable-cmd-palette", () => $2c3a3f2433b9c88d$export$6071538e042c1398, (v) => $2c3a3f2433b9c88d$export$6071538e042c1398 = v);
var $2c3a3f2433b9c88d$export$55ce6f3a06c59543;
var $2c3a3f2433b9c88d$export$6071538e042c1398;
$2c3a3f2433b9c88d$export$55ce6f3a06c59543 = `EYrGwG_dark`;
$2c3a3f2433b9c88d$export$6071538e042c1398 = `EYrGwG_decodable-cmd-palette`;

});

parcelRegister("hrwsS", function(module, exports) {
"use strict";
var $cb2e2416f963dc10$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ThrottledSearchBox = void 0;

var $2T9xh = parcelRequire("2T9xh");

var $8p0qe = parcelRequire("8p0qe");
var $2hYZ2 = parcelRequire("2hYZ2");
var $3kLlW = parcelRequire("3kLlW");

const $cb2e2416f963dc10$var$Search_1 = $cb2e2416f963dc10$var$__importDefault((parcelRequire("bT9P9")));

const $cb2e2416f963dc10$var$Cancel_1 = $cb2e2416f963dc10$var$__importDefault((parcelRequire("afh3O")));

var $aOzEm = parcelRequire("aOzEm");

var $09M6d = parcelRequire("09M6d");
function $cb2e2416f963dc10$var$SearchBox({ TextFieldProps: TextFieldProps, onCancel: onCancel }) {
    var _a;
    return (0, $2T9xh.jsx)($3kLlW.default, Object.assign({}, TextFieldProps, {
        InputProps: Object.assign(Object.assign({}, TextFieldProps === null || TextFieldProps === void 0 ? void 0 : TextFieldProps.InputProps), {
            startAdornment: ((_a = TextFieldProps === null || TextFieldProps === void 0 ? void 0 : TextFieldProps.InputProps) === null || _a === void 0 ? void 0 : _a.startAdornment) || (0, $2T9xh.jsx)($2hYZ2.default, Object.assign({
                position: "start"
            }, {
                children: (0, $2T9xh.jsx)($cb2e2416f963dc10$var$Search_1.default, {})
            })),
            endAdornment: (0, $2T9xh.jsx)($2hYZ2.default, Object.assign({
                position: "end"
            }, {
                children: onCancel ? (0, $2T9xh.jsx)($8p0qe.default, Object.assign({
                    onClick: onCancel
                }, {
                    children: (0, $2T9xh.jsx)($cb2e2416f963dc10$var$Cancel_1.default, {})
                })) : null
            }))
        })
    }));
}
module.exports.default = $cb2e2416f963dc10$var$SearchBox;
// An (uncontrolled) throttled version of the SearchBox.
// Helps reduce the number of state changes & re-renders in
// consuming components when the list of things to filter
// is large, and filtering is done client-side.
function $cb2e2416f963dc10$var$ThrottledSearchBox({ onFilterChanged: onFilterChanged, TextFieldProps: TextFieldProps, testId: testId, throttleDurationMs: throttleDurationMs = $09M6d.GLOBAL_THROTTLE_DELAY, cancellable: cancellable = true }) {
    const [gen, setGen] = (0, $aOzEm.useState)(0);
    const ref = (0, $aOzEm.useRef)({
        timeout: null,
        lastInput: ""
    });
    const updateFilter = (e)=>{
        ref.current.lastInput = e == "" ? "" : e.target.value;
        if (ref.current.timeout != null) clearTimeout(ref.current.timeout);
        ref.current.timeout = setTimeout(()=>{
            onFilterChanged(ref.current.lastInput);
        }, throttleDurationMs);
    };
    return (0, $2T9xh.jsx)($cb2e2416f963dc10$var$SearchBox, {
        "data-testid": testId,
        TextFieldProps: Object.assign(Object.assign({}, TextFieldProps), {
            onChange: (e)=>updateFilter(e)
        }),
        onCancel: cancellable ? ()=>{
            // Fast-path for clearing the filter with the button (not throttled like the updateFilter path)
            setGen((gen)=>gen + 1);
            ref.current.lastInput = "";
            if (ref.current.timeout) clearTimeout(ref.current.timeout);
            ref.current.timeout = null;
            onFilterChanged("");
        } : undefined
    }, gen);
}
module.exports.ThrottledSearchBox = $cb2e2416f963dc10$var$ThrottledSearchBox;

});
parcelRegister("2hYZ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1aac7955d5018ee7$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $63Oo6 = parcelRequire("63Oo6");

var $gdH9i = parcelRequire("gdH9i");

var $cUsUl = parcelRequire("cUsUl");

var $bNyOK = parcelRequire("bNyOK");

var $25zst = parcelRequire("25zst");

var $4V8E3 = parcelRequire("4V8E3");

var $gEb5G = parcelRequire("gEb5G");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $1aac7955d5018ee7$var$_span;
const $1aac7955d5018ee7$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $1aac7955d5018ee7$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $63Oo6.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $1aac7955d5018ee7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $63Oo6.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $63Oo6.default)(size)}`
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $4V8E3.getInputAdornmentUtilityClass), classes);
};
const $1aac7955d5018ee7$var$InputAdornmentRoot = (0, $25zst.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $1aac7955d5018ee7$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $4V8E3.default).positionStart}&:not(.${(0, $4V8E3.default).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $1aac7955d5018ee7$var$InputAdornment = /*#__PURE__*/ $aOzEm.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $cAqXo.default)(props, $1aac7955d5018ee7$var$_excluded);
    const muiFormControl = (0, $bNyOK.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $g6Hsb.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $1aac7955d5018ee7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $cUsUl.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)($1aac7955d5018ee7$var$InputAdornmentRoot, (0, $g6Hsb.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $g45Wv.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $2T9xh.jsx)((0, $gdH9i.default), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $2T9xh.jsxs)($aOzEm.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $1aac7955d5018ee7$var$_span || ($1aac7955d5018ee7$var$_span = /*#__PURE__*/ (0, $2T9xh.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $1aac7955d5018ee7$export$2e2bcd8739ae039 = $1aac7955d5018ee7$var$InputAdornment;

});
parcelRegister("cUsUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $966123764d886a4b$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");
/**
 * @ignore - internal component.
 */ const $966123764d886a4b$var$FormControlContext = /*#__PURE__*/ $aOzEm.createContext(undefined);
var $966123764d886a4b$export$2e2bcd8739ae039 = $966123764d886a4b$var$FormControlContext;

});

parcelRegister("bNyOK", function(module, exports) {

$parcel$export(module.exports, "default", () => $896f475789f8dc87$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");

var $cUsUl = parcelRequire("cUsUl");
"use client";
function $896f475789f8dc87$export$2e2bcd8739ae039() {
    return $aOzEm.useContext((0, $cUsUl.default));
}

});

parcelRegister("4V8E3", function(module, exports) {

$parcel$export(module.exports, "getInputAdornmentUtilityClass", () => $395331058882d615$export$4b135a4b3a6c4550);
$parcel$export(module.exports, "default", () => $395331058882d615$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $395331058882d615$export$4b135a4b3a6c4550(slot) {
    return (0, $6vnyE.default)("MuiInputAdornment", slot);
}
const $395331058882d615$var$inputAdornmentClasses = (0, $cyhE3.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $395331058882d615$export$2e2bcd8739ae039 = $395331058882d615$var$inputAdornmentClasses;

});


parcelRegister("3kLlW", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d7f8a239fdd167$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $2Us5L = parcelRequire("2Us5L");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $cIdIr = parcelRequire("cIdIr");

var $8w2Xp = parcelRequire("8w2Xp");

var $38dFO = parcelRequire("38dFO");

var $epKwu = parcelRequire("epKwu");

var $3lVSt = parcelRequire("3lVSt");

var $7VnTP = parcelRequire("7VnTP");

var $39CDh = parcelRequire("39CDh");

var $eXt0L = parcelRequire("eXt0L");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $26d7f8a239fdd167$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $26d7f8a239fdd167$var$variantComponent = {
    standard: (0, $cIdIr.default),
    filled: (0, $8w2Xp.default),
    outlined: (0, $38dFO.default)
};
const $26d7f8a239fdd167$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $eXt0L.getTextFieldUtilityClass), classes);
};
const $26d7f8a239fdd167$var$TextFieldRoot = (0, $25zst.default)((0, $3lVSt.default), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $26d7f8a239fdd167$var$TextField = /*#__PURE__*/ $aOzEm.forwardRef(function TextField(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $cAqXo.default)(props, $26d7f8a239fdd167$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $26d7f8a239fdd167$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $2Us5L.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $26d7f8a239fdd167$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $2T9xh.jsx)(InputComponent, (0, $g6Hsb.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($26d7f8a239fdd167$var$TextFieldRoot, (0, $g6Hsb.default)({
        className: (0, $g45Wv.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $2T9xh.jsx)((0, $epKwu.default), (0, $g6Hsb.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $2T9xh.jsx)((0, $39CDh.default), (0, $g6Hsb.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $2T9xh.jsx)((0, $7VnTP.default), (0, $g6Hsb.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $26d7f8a239fdd167$export$2e2bcd8739ae039 = $26d7f8a239fdd167$var$TextField;

});
parcelRegister("cIdIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $94143bc6318dca1b$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $b2r0b = parcelRequire("b2r0b");

var $hH5Br = parcelRequire("hH5Br");

var $52sGy = parcelRequire("52sGy");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $g5a08 = parcelRequire("g5a08");

var $52sGy = parcelRequire("52sGy");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $94143bc6318dca1b$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $94143bc6318dca1b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $b2r0b.default)(slots, (0, $g5a08.getInputUtilityClass), classes);
    return (0, $g6Hsb.default)({}, classes, composedClasses);
};
const $94143bc6318dca1b$var$InputRoot = (0, $25zst.default)((0, $52sGy.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $25zst.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $52sGy.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $g6Hsb.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $g5a08.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $g5a08.default).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $g5a08.default).disabled}, .${(0, $g5a08.default).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $g5a08.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $94143bc6318dca1b$var$InputInput = (0, $25zst.default)((0, $52sGy.InputBaseComponent), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $52sGy.inputOverridesResolver)
})({});
const $94143bc6318dca1b$var$Input = /*#__PURE__*/ $aOzEm.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $cAqXo.default)(props, $94143bc6318dca1b$var$_excluded);
    const classes = $94143bc6318dca1b$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $hH5Br.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $94143bc6318dca1b$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $94143bc6318dca1b$var$InputInput;
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $52sGy.default), (0, $g6Hsb.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$94143bc6318dca1b$var$Input.muiName = "Input";
var $94143bc6318dca1b$export$2e2bcd8739ae039 = $94143bc6318dca1b$var$Input;

});
parcelRegister("52sGy", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", () => $3ab363fa7b9c094d$export$965edad20a84fa75);
$parcel$export(module.exports, "inputOverridesResolver", () => $3ab363fa7b9c094d$export$cf507b112810e72d);
$parcel$export(module.exports, "InputBaseRoot", () => $3ab363fa7b9c094d$export$298a043133d72a38);
$parcel$export(module.exports, "InputBaseComponent", () => $3ab363fa7b9c094d$export$a1ad29c901026019);
$parcel$export(module.exports, "default", () => $3ab363fa7b9c094d$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $5IJqG = parcelRequire("5IJqG");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $cwzzR = parcelRequire("cwzzR");
var $2V0XV = parcelRequire("2V0XV");
var $b2r0b = parcelRequire("b2r0b");

var $g3m9r = parcelRequire("g3m9r");

var $cUsUl = parcelRequire("cUsUl");

var $bNyOK = parcelRequire("bNyOK");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $63Oo6 = parcelRequire("63Oo6");

var $eedeo = parcelRequire("eedeo");

var $ajCuK = parcelRequire("ajCuK");

var $103xJ = parcelRequire("103xJ");

var $cxEKe = parcelRequire("cxEKe");

var $iGKKN = parcelRequire("iGKKN");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $3ab363fa7b9c094d$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $3ab363fa7b9c094d$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $63Oo6.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $3ab363fa7b9c094d$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $3ab363fa7b9c094d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $63Oo6.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $63Oo6.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $iGKKN.getInputBaseUtilityClass), classes);
};
const $3ab363fa7b9c094d$export$298a043133d72a38 = (0, $25zst.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $3ab363fa7b9c094d$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $iGKKN.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $g6Hsb.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $3ab363fa7b9c094d$export$a1ad29c901026019 = (0, $25zst.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $3ab363fa7b9c094d$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $g6Hsb.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $g6Hsb.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $iGKKN.default).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $iGKKN.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $3ab363fa7b9c094d$var$inputGlobalStyles = /*#__PURE__*/ (0, $2T9xh.jsx)((0, $103xJ.default), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $3ab363fa7b9c094d$var$InputBase = /*#__PURE__*/ $aOzEm.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $cAqXo.default)(props, $3ab363fa7b9c094d$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $aOzEm.useRef(value != null);
    const inputRef = $aOzEm.useRef();
    const handleInputRefWarning = $aOzEm.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $eedeo.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $aOzEm.useState(false);
    const muiFormControl = (0, $bNyOK.default)();
    const fcs = (0, $g3m9r.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $aOzEm.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $aOzEm.useCallback((obj)=>{
        if ((0, $cxEKe.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $ajCuK.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $5IJqG.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $aOzEm.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $g6Hsb.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $g6Hsb.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $2V0XV.TextareaAutosize);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $aOzEm.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $3ab363fa7b9c094d$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $3ab363fa7b9c094d$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $3ab363fa7b9c094d$export$a1ad29c901026019;
    inputProps = (0, $g6Hsb.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($aOzEm.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $3ab363fa7b9c094d$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $2T9xh.jsxs)(Root, (0, $g6Hsb.default)({}, rootProps, !(0, $cwzzR.isHostComponent)(Root) && {
                ownerState: (0, $g6Hsb.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $g45Wv.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $cUsUl.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $2T9xh.jsx)(Input, (0, $g6Hsb.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $cwzzR.isHostComponent)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $g6Hsb.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $g45Wv.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $g6Hsb.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $3ab363fa7b9c094d$export$2e2bcd8739ae039 = $3ab363fa7b9c094d$var$InputBase;

});
parcelRegister("2V0XV", function(module, exports) {

$parcel$export(module.exports, "TextareaAutosize", () => $2201a75d1f282999$export$d1710922ecaf577a);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $aOzEm = parcelRequire("aOzEm");


var $lOkAX = parcelRequire("lOkAX");

var $kdu4X = parcelRequire("kdu4X");
var $kFAoC = parcelRequire("kFAoC");
var $3jQQ9 = parcelRequire("3jQQ9");
var $6KMJ0 = parcelRequire("6KMJ0");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $2201a75d1f282999$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $2201a75d1f282999$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $2201a75d1f282999$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $2201a75d1f282999$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $2201a75d1f282999$export$d1710922ecaf577a = /*#__PURE__*/ $aOzEm.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $cAqXo.default)(props, $2201a75d1f282999$var$_excluded);
    const { current: isControlled } = $aOzEm.useRef(value != null);
    const inputRef = $aOzEm.useRef(null);
    const handleRef = (0, $6KMJ0.default)(forwardedRef, inputRef);
    const shadowRef = $aOzEm.useRef(null);
    const renders = $aOzEm.useRef(0);
    const [state, setState] = $aOzEm.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = $aOzEm.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $kFAoC.default)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $2201a75d1f282999$var$getStyleValue(computedStyle.paddingBottom) + $2201a75d1f282999$var$getStyleValue(computedStyle.paddingTop);
        const border = $2201a75d1f282999$var$getStyleValue(computedStyle.borderBottomWidth) + $2201a75d1f282999$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle, overflow: overflow } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $aOzEm.useCallback(()=>{
        const newState = getUpdatedState();
        if ($2201a75d1f282999$var$isEmpty(newState)) return;
        setState((prevState)=>{
            return updateState(prevState, newState);
        });
    }, [
        getUpdatedState
    ]);
    const syncHeightWithFlushSync = ()=>{
        const newState = getUpdatedState();
        if ($2201a75d1f282999$var$isEmpty(newState)) return;
        // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
        // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
        // Related issue - https://github.com/facebook/react/issues/24331
        $lOkAX.flushSync(()=>{
            setState((prevState)=>{
                return updateState(prevState, newState);
            });
        });
    };
    $aOzEm.useEffect(()=>{
        const handleResize = ()=>{
            renders.current = 0;
            // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/32640
            if (inputRef.current) syncHeightWithFlushSync();
        };
        const handleResizeWindow = (0, $kdu4X.default)(()=>{
            renders.current = 0;
            // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/32640
            if (inputRef.current) syncHeightWithFlushSync();
        });
        let resizeObserver;
        const input = inputRef.current;
        const containerWindow = (0, $kFAoC.default)(input);
        containerWindow.addEventListener("resize", handleResizeWindow);
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            handleResizeWindow.clear();
            containerWindow.removeEventListener("resize", handleResizeWindow);
            if (resizeObserver) resizeObserver.disconnect();
        };
    });
    (0, $3jQQ9.default)(()=>{
        syncHeight();
    });
    $aOzEm.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($aOzEm.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)("textarea", (0, $g6Hsb.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $g6Hsb.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $2T9xh.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $g6Hsb.default)({}, $2201a75d1f282999$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});

});

parcelRegister("g3m9r", function(module, exports) {

$parcel$export(module.exports, "default", () => $bafe1bf490f10e41$export$2e2bcd8739ae039);
function $bafe1bf490f10e41$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("ajCuK", function(module, exports) {

$parcel$export(module.exports, "default", () => $782989ff9745364f$export$2e2bcd8739ae039);

var $3jQQ9 = parcelRequire("3jQQ9");
"use client";
var $782989ff9745364f$export$2e2bcd8739ae039 = (0, $3jQQ9.default);

});

parcelRegister("cxEKe", function(module, exports) {

$parcel$export(module.exports, "isFilled", () => $025b3a84d15e9a1c$export$d652b828d7fdeff8);
$parcel$export(module.exports, "isAdornedStart", () => $025b3a84d15e9a1c$export$1b68bdfa56faeb5d);
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $025b3a84d15e9a1c$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $025b3a84d15e9a1c$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($025b3a84d15e9a1c$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $025b3a84d15e9a1c$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $025b3a84d15e9a1c$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("iGKKN", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", () => $d9b06a8e07b239b2$export$ef57d5c8ca2278f6);
$parcel$export(module.exports, "default", () => $d9b06a8e07b239b2$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $d9b06a8e07b239b2$export$ef57d5c8ca2278f6(slot) {
    return (0, $6vnyE.default)("MuiInputBase", slot);
}
const $d9b06a8e07b239b2$var$inputBaseClasses = (0, $cyhE3.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $d9b06a8e07b239b2$export$2e2bcd8739ae039 = $d9b06a8e07b239b2$var$inputBaseClasses;

});


parcelRegister("g5a08", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", () => $bb54defc00d54e96$export$cdb270390122322b);
$parcel$export(module.exports, "default", () => $bb54defc00d54e96$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");

var $iGKKN = parcelRequire("iGKKN");
function $bb54defc00d54e96$export$cdb270390122322b(slot) {
    return (0, $6vnyE.default)("MuiInput", slot);
}
const $bb54defc00d54e96$var$inputClasses = (0, $g6Hsb.default)({}, (0, $iGKKN.default), (0, $cyhE3.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $bb54defc00d54e96$export$2e2bcd8739ae039 = $bb54defc00d54e96$var$inputClasses;

});


parcelRegister("8w2Xp", function(module, exports) {

$parcel$export(module.exports, "default", () => $63339b1cfadf7f40$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");

var $hH5Br = parcelRequire("hH5Br");


var $b2r0b = parcelRequire("b2r0b");

var $52sGy = parcelRequire("52sGy");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $grFPY = parcelRequire("grFPY");

var $52sGy = parcelRequire("52sGy");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $63339b1cfadf7f40$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $63339b1cfadf7f40$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $b2r0b.default)(slots, (0, $grFPY.getFilledInputUtilityClass), classes);
    return (0, $g6Hsb.default)({}, classes, composedClasses);
};
const $63339b1cfadf7f40$var$FilledInputRoot = (0, $25zst.default)((0, $52sGy.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $25zst.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $52sGy.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $g6Hsb.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $grFPY.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $grFPY.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $grFPY.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $grFPY.default).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $grFPY.default).disabled}, .${(0, $grFPY.default).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $grFPY.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $g6Hsb.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
const $63339b1cfadf7f40$var$FilledInputInput = (0, $25zst.default)((0, $52sGy.InputBaseComponent), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $52sGy.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
const $63339b1cfadf7f40$var$FilledInput = /*#__PURE__*/ $aOzEm.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $cAqXo.default)(props, $63339b1cfadf7f40$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $63339b1cfadf7f40$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $hH5Br.default)(slotProps != null ? slotProps : componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $63339b1cfadf7f40$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $63339b1cfadf7f40$var$FilledInputInput;
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $52sGy.default), (0, $g6Hsb.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$63339b1cfadf7f40$var$FilledInput.muiName = "Input";
var $63339b1cfadf7f40$export$2e2bcd8739ae039 = $63339b1cfadf7f40$var$FilledInput;

});
parcelRegister("grFPY", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", () => $bf8f9ef63aa38952$export$3331e419f1a48437);
$parcel$export(module.exports, "default", () => $bf8f9ef63aa38952$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");

var $iGKKN = parcelRequire("iGKKN");
function $bf8f9ef63aa38952$export$3331e419f1a48437(slot) {
    return (0, $6vnyE.default)("MuiFilledInput", slot);
}
const $bf8f9ef63aa38952$var$filledInputClasses = (0, $g6Hsb.default)({}, (0, $iGKKN.default), (0, $cyhE3.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $bf8f9ef63aa38952$export$2e2bcd8739ae039 = $bf8f9ef63aa38952$var$filledInputClasses;

});


parcelRegister("38dFO", function(module, exports) {

$parcel$export(module.exports, "default", () => $247cb9b85ec7c4fd$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");



var $b2r0b = parcelRequire("b2r0b");

var $dgwOW = parcelRequire("dgwOW");

var $bNyOK = parcelRequire("bNyOK");

var $g3m9r = parcelRequire("g3m9r");

var $25zst = parcelRequire("25zst");

var $5eXxG = parcelRequire("5eXxG");

var $52sGy = parcelRequire("52sGy");

var $gEb5G = parcelRequire("gEb5G");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $247cb9b85ec7c4fd$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $247cb9b85ec7c4fd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $b2r0b.default)(slots, (0, $5eXxG.getOutlinedInputUtilityClass), classes);
    return (0, $g6Hsb.default)({}, classes, composedClasses);
};
const $247cb9b85ec7c4fd$var$OutlinedInputRoot = (0, $25zst.default)((0, $52sGy.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $25zst.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $52sGy.rootOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $g6Hsb.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $5eXxG.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $5eXxG.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $5eXxG.default).focused} .${(0, $5eXxG.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $5eXxG.default).error} .${(0, $5eXxG.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $5eXxG.default).disabled} .${(0, $5eXxG.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $g6Hsb.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $247cb9b85ec7c4fd$var$NotchedOutlineRoot = (0, $25zst.default)((0, $dgwOW.default), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $247cb9b85ec7c4fd$var$OutlinedInputInput = (0, $25zst.default)((0, $52sGy.InputBaseComponent), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $52sGy.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $247cb9b85ec7c4fd$var$OutlinedInput = /*#__PURE__*/ $aOzEm.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $cAqXo.default)(props, $247cb9b85ec7c4fd$var$_excluded);
    const classes = $247cb9b85ec7c4fd$var$useUtilityClasses(props);
    const muiFormControl = (0, $bNyOK.default)();
    const fcs = (0, $g3m9r.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $g6Hsb.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $247cb9b85ec7c4fd$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $247cb9b85ec7c4fd$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $52sGy.default), (0, $g6Hsb.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $2T9xh.jsx)($247cb9b85ec7c4fd$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $2T9xh.jsxs)($aOzEm.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $g6Hsb.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$247cb9b85ec7c4fd$var$OutlinedInput.muiName = "Input";
var $247cb9b85ec7c4fd$export$2e2bcd8739ae039 = $247cb9b85ec7c4fd$var$OutlinedInput;

});
parcelRegister("dgwOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a863a78302742de$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");
parcelRequire("aOzEm");


var $25zst = parcelRequire("25zst");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $9a863a78302742de$var$_span;
const $9a863a78302742de$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $9a863a78302742de$var$NotchedOutlineRoot = (0, $25zst.default)("fieldset")({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $9a863a78302742de$var$NotchedOutlineLegend = (0, $25zst.default)("legend")(({ ownerState: ownerState, theme: theme })=>(0, $g6Hsb.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $g6Hsb.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $9a863a78302742de$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $cAqXo.default)(props, $9a863a78302742de$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $g6Hsb.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $2T9xh.jsx)($9a863a78302742de$var$NotchedOutlineRoot, (0, $g6Hsb.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $2T9xh.jsx)($9a863a78302742de$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $2T9xh.jsx)("span", {
                children: label
            }) : $9a863a78302742de$var$_span || ($9a863a78302742de$var$_span = /*#__PURE__*/ (0, $2T9xh.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}

});

parcelRegister("5eXxG", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", () => $3d0c726e572d3358$export$89922944c7227687);
$parcel$export(module.exports, "default", () => $3d0c726e572d3358$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");

var $iGKKN = parcelRequire("iGKKN");
function $3d0c726e572d3358$export$89922944c7227687(slot) {
    return (0, $6vnyE.default)("MuiOutlinedInput", slot);
}
const $3d0c726e572d3358$var$outlinedInputClasses = (0, $g6Hsb.default)({}, (0, $iGKKN.default), (0, $cyhE3.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $3d0c726e572d3358$export$2e2bcd8739ae039 = $3d0c726e572d3358$var$outlinedInputClasses;

});


parcelRegister("epKwu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7e77cf84adce886$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $b2r0b = parcelRequire("b2r0b");

var $g45Wv = parcelRequire("g45Wv");

var $g3m9r = parcelRequire("g3m9r");

var $bNyOK = parcelRequire("bNyOK");

var $ep1xL = parcelRequire("ep1xL");
var $g3TXx = parcelRequire("g3TXx");

var $gEb5G = parcelRequire("gEb5G");

var $63Oo6 = parcelRequire("63Oo6");

var $25zst = parcelRequire("25zst");

var $gLmKy = parcelRequire("gLmKy");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $a7e77cf84adce886$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $a7e77cf84adce886$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $63Oo6.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $b2r0b.default)(slots, (0, $gLmKy.getInputLabelUtilityClasses), classes);
    return (0, $g6Hsb.default)({}, classes, composedClasses);
};
const $a7e77cf84adce886$var$InputLabelRoot = (0, $25zst.default)((0, $ep1xL.default), {
    shouldForwardProp: (prop)=>(0, $25zst.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $g3TXx.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $g6Hsb.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $g6Hsb.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $g6Hsb.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $a7e77cf84adce886$var$InputLabel = /*#__PURE__*/ $aOzEm.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $gEb5G.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $cAqXo.default)(props, $a7e77cf84adce886$var$_excluded);
    const muiFormControl = (0, $bNyOK.default)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $g3m9r.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required"
        ]
    });
    const ownerState = (0, $g6Hsb.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required
    });
    const classes = $a7e77cf84adce886$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($a7e77cf84adce886$var$InputLabelRoot, (0, $g6Hsb.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $g45Wv.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $a7e77cf84adce886$export$2e2bcd8739ae039 = $a7e77cf84adce886$var$InputLabel;

});
parcelRegister("ep1xL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7c4990669a37bcf$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $g3m9r = parcelRequire("g3m9r");

var $bNyOK = parcelRequire("bNyOK");

var $63Oo6 = parcelRequire("63Oo6");

var $gEb5G = parcelRequire("gEb5G");

var $25zst = parcelRequire("25zst");

var $g3TXx = parcelRequire("g3TXx");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $a7c4990669a37bcf$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $a7c4990669a37bcf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $63Oo6.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $g3TXx.getFormLabelUtilityClasses), classes);
};
const $a7c4990669a37bcf$export$aa5bc7f8a4705b27 = (0, $25zst.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $g6Hsb.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $g3TXx.default).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $g3TXx.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $g3TXx.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $a7c4990669a37bcf$var$AsteriskComponent = (0, $25zst.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $g3TXx.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $a7c4990669a37bcf$var$FormLabel = /*#__PURE__*/ $aOzEm.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $cAqXo.default)(props, $a7c4990669a37bcf$var$_excluded);
    const muiFormControl = (0, $bNyOK.default)();
    const fcs = (0, $g3m9r.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $g6Hsb.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $a7c4990669a37bcf$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($a7c4990669a37bcf$export$aa5bc7f8a4705b27, (0, $g6Hsb.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $g45Wv.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $2T9xh.jsxs)($a7c4990669a37bcf$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $a7c4990669a37bcf$export$2e2bcd8739ae039 = $a7c4990669a37bcf$var$FormLabel;

});
parcelRegister("g3TXx", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", () => $bb1855826fc8efdb$export$f7d501e40371cd17);
$parcel$export(module.exports, "default", () => $bb1855826fc8efdb$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $bb1855826fc8efdb$export$f7d501e40371cd17(slot) {
    return (0, $6vnyE.default)("MuiFormLabel", slot);
}
const $bb1855826fc8efdb$var$formLabelClasses = (0, $cyhE3.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $bb1855826fc8efdb$export$2e2bcd8739ae039 = $bb1855826fc8efdb$var$formLabelClasses;

});


parcelRegister("gLmKy", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", () => $c342aec5df1c4cea$export$c1c4b4545ad2ea5f);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $c342aec5df1c4cea$export$c1c4b4545ad2ea5f(slot) {
    return (0, $6vnyE.default)("MuiInputLabel", slot);
}
const $c342aec5df1c4cea$var$inputLabelClasses = (0, $cyhE3.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $c342aec5df1c4cea$export$2e2bcd8739ae039 = $c342aec5df1c4cea$var$inputLabelClasses;

});


parcelRegister("3lVSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $27103a87fef5cf1c$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $gEb5G = parcelRequire("gEb5G");

var $25zst = parcelRequire("25zst");

var $cxEKe = parcelRequire("cxEKe");

var $63Oo6 = parcelRequire("63Oo6");

var $iXl4i = parcelRequire("iXl4i");

var $cUsUl = parcelRequire("cUsUl");

var $aOmPU = parcelRequire("aOmPU");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $27103a87fef5cf1c$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $27103a87fef5cf1c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $63Oo6.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $aOmPU.getFormControlUtilityClasses), classes);
};
const $27103a87fef5cf1c$var$FormControlRoot = (0, $25zst.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $g6Hsb.default)({}, styles.root, styles[`margin${(0, $63Oo6.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $g6Hsb.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $27103a87fef5cf1c$var$FormControl = /*#__PURE__*/ $aOzEm.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $cAqXo.default)(props, $27103a87fef5cf1c$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $27103a87fef5cf1c$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $aOzEm.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $aOzEm.Children.forEach(children, (child)=>{
            if (!(0, $iXl4i.default)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $iXl4i.default)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $cxEKe.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $aOzEm.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $aOzEm.Children.forEach(children, (child)=>{
            if (!(0, $iXl4i.default)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $cxEKe.isFilled)(child.props, true) || (0, $cxEKe.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $aOzEm.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $aOzEm.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $cUsUl.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)($27103a87fef5cf1c$var$FormControlRoot, (0, $g6Hsb.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $g45Wv.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $27103a87fef5cf1c$export$2e2bcd8739ae039 = $27103a87fef5cf1c$var$FormControl;

});
parcelRegister("iXl4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcce14669f296a8e$export$2e2bcd8739ae039);

var $bUObn = parcelRequire("bUObn");
var $dcce14669f296a8e$export$2e2bcd8739ae039 = (0, $bUObn.default);

});
parcelRegister("bUObn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8acbd9d9df43680e$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");
function $8acbd9d9df43680e$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $aOzEm.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

});


parcelRegister("aOmPU", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", () => $7df049b19f9c6287$export$149c8b8bab2289d1);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $7df049b19f9c6287$export$149c8b8bab2289d1(slot) {
    return (0, $6vnyE.default)("MuiFormControl", slot);
}
const $7df049b19f9c6287$var$formControlClasses = (0, $cyhE3.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $7df049b19f9c6287$export$2e2bcd8739ae039 = $7df049b19f9c6287$var$formControlClasses;

});


parcelRegister("7VnTP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c506530422e3774$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $g3m9r = parcelRequire("g3m9r");

var $bNyOK = parcelRequire("bNyOK");

var $25zst = parcelRequire("25zst");

var $63Oo6 = parcelRequire("63Oo6");

var $cxILR = parcelRequire("cxILR");

var $gEb5G = parcelRequire("gEb5G");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $5c506530422e3774$var$_span;
const $5c506530422e3774$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $5c506530422e3774$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $63Oo6.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $cxILR.getFormHelperTextUtilityClasses), classes);
};
const $5c506530422e3774$var$FormHelperTextRoot = (0, $25zst.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $63Oo6.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $cxILR.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $cxILR.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $5c506530422e3774$var$FormHelperText = /*#__PURE__*/ $aOzEm.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $cAqXo.default)(props, $5c506530422e3774$var$_excluded);
    const muiFormControl = (0, $bNyOK.default)();
    const fcs = (0, $g3m9r.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $g6Hsb.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $5c506530422e3774$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($5c506530422e3774$var$FormHelperTextRoot, (0, $g6Hsb.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $g45Wv.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $5c506530422e3774$var$_span || ($5c506530422e3774$var$_span = /*#__PURE__*/ (0, $2T9xh.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $5c506530422e3774$export$2e2bcd8739ae039 = $5c506530422e3774$var$FormHelperText;

});
parcelRegister("cxILR", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", () => $921b4bb3247d36c0$export$a394fa61b1d583a9);
$parcel$export(module.exports, "default", () => $921b4bb3247d36c0$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $921b4bb3247d36c0$export$a394fa61b1d583a9(slot) {
    return (0, $6vnyE.default)("MuiFormHelperText", slot);
}
const $921b4bb3247d36c0$var$formHelperTextClasses = (0, $cyhE3.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $921b4bb3247d36c0$export$2e2bcd8739ae039 = $921b4bb3247d36c0$var$formHelperTextClasses;

});


parcelRegister("39CDh", function(module, exports) {

$parcel$export(module.exports, "default", () => $24c02df55d533d2b$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $hH5Br = parcelRequire("hH5Br");

var $bYSbX = parcelRequire("bYSbX");

var $g3m9r = parcelRequire("g3m9r");

var $bNyOK = parcelRequire("bNyOK");

var $fvlLx = parcelRequire("fvlLx");

var $cIdIr = parcelRequire("cIdIr");

var $cr5FO = parcelRequire("cr5FO");

var $8w2Xp = parcelRequire("8w2Xp");

var $38dFO = parcelRequire("38dFO");

var $gEb5G = parcelRequire("gEb5G");

var $eedeo = parcelRequire("eedeo");

var $25zst = parcelRequire("25zst");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $24c02df55d533d2b$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $24c02df55d533d2b$var$_excluded2 = [
    "root"
];
const $24c02df55d533d2b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $24c02df55d533d2b$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $25zst.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $24c02df55d533d2b$var$StyledInput = (0, $25zst.default)((0, $cIdIr.default), $24c02df55d533d2b$var$styledRootConfig)("");
const $24c02df55d533d2b$var$StyledOutlinedInput = (0, $25zst.default)((0, $38dFO.default), $24c02df55d533d2b$var$styledRootConfig)("");
const $24c02df55d533d2b$var$StyledFilledInput = (0, $25zst.default)((0, $8w2Xp.default), $24c02df55d533d2b$var$styledRootConfig)("");
const $24c02df55d533d2b$var$Select = /*#__PURE__*/ $aOzEm.forwardRef(function Select(inProps, ref) {
    const props = (0, $gEb5G.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $fvlLx.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $cAqXo.default)(props, $24c02df55d533d2b$var$_excluded);
    const inputComponent = native ? (0, $cr5FO.default) : (0, $bYSbX.default);
    const muiFormControl = (0, $bNyOK.default)();
    const fcs = (0, $g3m9r.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $g6Hsb.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $24c02df55d533d2b$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $cAqXo.default)(classes, $24c02df55d533d2b$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $2T9xh.jsx)($24c02df55d533d2b$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $2T9xh.jsx)($24c02df55d533d2b$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $2T9xh.jsx)($24c02df55d533d2b$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $eedeo.default)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($aOzEm.Fragment, {
        children: /*#__PURE__*/ $aOzEm.cloneElement(InputComponent, (0, $g6Hsb.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $g6Hsb.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $g6Hsb.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $hH5Br.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, multiple && native && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $g45Wv.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$24c02df55d533d2b$var$Select.muiName = "Select";
var $24c02df55d533d2b$export$2e2bcd8739ae039 = $24c02df55d533d2b$var$Select;

});
parcelRegister("bYSbX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b8f55adf2224da1$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $5IJqG = parcelRequire("5IJqG");

var $aOzEm = parcelRequire("aOzEm");
parcelRequire("dln0Z");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $h2Mbk = parcelRequire("h2Mbk");

var $63Oo6 = parcelRequire("63Oo6");

var $bAQLH = parcelRequire("bAQLH");

var $cr5FO = parcelRequire("cr5FO");

var $cxEKe = parcelRequire("cxEKe");

var $25zst = parcelRequire("25zst");

var $eedeo = parcelRequire("eedeo");

var $duffS = parcelRequire("duffS");

var $fxtci = parcelRequire("fxtci");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $8b8f55adf2224da1$var$_span;
const $8b8f55adf2224da1$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $8b8f55adf2224da1$var$SelectSelect = (0, $25zst.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $fxtci.default).select}`]: styles.select
            },
            {
                [`&.${(0, $fxtci.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $fxtci.default).error}`]: styles.error
            },
            {
                [`&.${(0, $fxtci.default).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $cr5FO.nativeSelectSelectStyles), {
    // Win specificity over the input base
    [`&.${(0, $fxtci.default).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $8b8f55adf2224da1$var$SelectIcon = (0, $25zst.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $63Oo6.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $cr5FO.nativeSelectIconStyles));
const $8b8f55adf2224da1$var$SelectNativeInput = (0, $25zst.default)("input", {
    shouldForwardProp: (prop)=>(0, $25zst.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $8b8f55adf2224da1$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $8b8f55adf2224da1$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $8b8f55adf2224da1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $63Oo6.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $fxtci.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $8b8f55adf2224da1$var$SelectInput = /*#__PURE__*/ $aOzEm.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $cAqXo.default)(props, $8b8f55adf2224da1$var$_excluded);
    const [value, setValueState] = (0, $duffS.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $duffS.default)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $aOzEm.useRef(null);
    const displayRef = $aOzEm.useRef(null);
    const [displayNode, setDisplayNode] = $aOzEm.useState(null);
    const { current: isOpenControlled } = $aOzEm.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $aOzEm.useState();
    const handleRef = (0, $eedeo.default)(ref, inputRefProp);
    const handleDisplayRef = $aOzEm.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $aOzEm.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $aOzEm.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $aOzEm.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $aOzEm.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $h2Mbk.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $aOzEm.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $cxEKe.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $aOzEm.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $5IJqG.default)(2));
            selected = value.some((v)=>$8b8f55adf2224da1$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $8b8f55adf2224da1$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $aOzEm.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $8b8f55adf2224da1$var$useUtilityClasses(ownerState);
    const paperProps = (0, $g6Hsb.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($aOzEm.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)($8b8f55adf2224da1$var$SelectSelect, (0, $g6Hsb.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "button",
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $g45Wv.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $8b8f55adf2224da1$var$isEmpty(display) ? $8b8f55adf2224da1$var$_span || ($8b8f55adf2224da1$var$_span = /*#__PURE__*/ (0, $2T9xh.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $2T9xh.jsx)($8b8f55adf2224da1$var$SelectNativeInput, (0, $g6Hsb.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $2T9xh.jsx)($8b8f55adf2224da1$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $bAQLH.default), (0, $g6Hsb.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $g6Hsb.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    disableListWrap: true
                }, MenuProps.MenuListProps),
                slotProps: {
                    paper: (0, $g6Hsb.default)({}, paperProps, {
                        style: (0, $g6Hsb.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                },
                children: items
            }))
        ]
    });
});
var $8b8f55adf2224da1$export$2e2bcd8739ae039 = $8b8f55adf2224da1$var$SelectInput;

});
parcelRegister("dln0Z", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7z1yz"));

});
parcelRegister("7z1yz", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $581d0262e0d209c8$export$a7c73072b1a182ae, (v) => $581d0262e0d209c8$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $581d0262e0d209c8$export$9f27bc3417b4524d, (v) => $581d0262e0d209c8$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $581d0262e0d209c8$export$db77ccec0bb4ccac, (v) => $581d0262e0d209c8$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $581d0262e0d209c8$export$8392c0c9d3dcbd35, (v) => $581d0262e0d209c8$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $581d0262e0d209c8$export$ffb0004e005737fa, (v) => $581d0262e0d209c8$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $581d0262e0d209c8$export$b624eff549462981, (v) => $581d0262e0d209c8$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $581d0262e0d209c8$export$7897aa7841a5380c, (v) => $581d0262e0d209c8$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $581d0262e0d209c8$export$602eac185826482c, (v) => $581d0262e0d209c8$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $581d0262e0d209c8$export$e2c29f18771995cb, (v) => $581d0262e0d209c8$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $581d0262e0d209c8$export$5f8d39834fd61797, (v) => $581d0262e0d209c8$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $581d0262e0d209c8$export$74bf444e3cd11ea5, (v) => $581d0262e0d209c8$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $581d0262e0d209c8$export$998bcd577473dd93, (v) => $581d0262e0d209c8$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $581d0262e0d209c8$export$92387174baf9b227, (v) => $581d0262e0d209c8$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $581d0262e0d209c8$export$ec112efeb987d9c6, (v) => $581d0262e0d209c8$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $581d0262e0d209c8$export$b706b080d889d2c9, (v) => $581d0262e0d209c8$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $581d0262e0d209c8$export$5be5a87408f70ddc, (v) => $581d0262e0d209c8$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $581d0262e0d209c8$export$45a5e7f76e0caa8d, (v) => $581d0262e0d209c8$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $581d0262e0d209c8$export$455c2e768291efa6, (v) => $581d0262e0d209c8$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $581d0262e0d209c8$export$9522e17588c12572, (v) => $581d0262e0d209c8$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $581d0262e0d209c8$export$2110ac352bb060b9, (v) => $581d0262e0d209c8$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $581d0262e0d209c8$export$56885ab8b9c456ab, (v) => $581d0262e0d209c8$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $581d0262e0d209c8$export$d927fcb6adf8f9de, (v) => $581d0262e0d209c8$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $581d0262e0d209c8$export$b82d16f27459e05a, (v) => $581d0262e0d209c8$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $581d0262e0d209c8$export$522c17b4f5e123e8, (v) => $581d0262e0d209c8$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $581d0262e0d209c8$export$1aabd8a0274ecfd6, (v) => $581d0262e0d209c8$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $581d0262e0d209c8$export$3d6c20d97e46b957, (v) => $581d0262e0d209c8$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $581d0262e0d209c8$export$9b621391a187a31a, (v) => $581d0262e0d209c8$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $581d0262e0d209c8$export$f5bbd400c2f4426f, (v) => $581d0262e0d209c8$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $581d0262e0d209c8$export$a7c73072b1a182ae;
var $581d0262e0d209c8$export$9f27bc3417b4524d;
var $581d0262e0d209c8$export$db77ccec0bb4ccac;
var $581d0262e0d209c8$export$8392c0c9d3dcbd35;
var $581d0262e0d209c8$export$ffb0004e005737fa;
var $581d0262e0d209c8$export$b624eff549462981;
var $581d0262e0d209c8$export$7897aa7841a5380c;
var $581d0262e0d209c8$export$602eac185826482c;
var $581d0262e0d209c8$export$e2c29f18771995cb;
var $581d0262e0d209c8$export$5f8d39834fd61797;
var $581d0262e0d209c8$export$74bf444e3cd11ea5;
var $581d0262e0d209c8$export$998bcd577473dd93;
var $581d0262e0d209c8$export$92387174baf9b227;
var $581d0262e0d209c8$export$ec112efeb987d9c6;
var $581d0262e0d209c8$export$b706b080d889d2c9;
var $581d0262e0d209c8$export$5be5a87408f70ddc;
var $581d0262e0d209c8$export$45a5e7f76e0caa8d;
var $581d0262e0d209c8$export$455c2e768291efa6;
var $581d0262e0d209c8$export$9522e17588c12572;
var $581d0262e0d209c8$export$2110ac352bb060b9;
var $581d0262e0d209c8$export$56885ab8b9c456ab;
var $581d0262e0d209c8$export$d927fcb6adf8f9de;
var $581d0262e0d209c8$export$b82d16f27459e05a;
var $581d0262e0d209c8$export$522c17b4f5e123e8;
var $581d0262e0d209c8$export$1aabd8a0274ecfd6;
var $581d0262e0d209c8$export$3d6c20d97e46b957;
var $581d0262e0d209c8$export$9b621391a187a31a;
var $581d0262e0d209c8$export$f5bbd400c2f4426f;
"use strict";
var $581d0262e0d209c8$var$b = Symbol.for("react.element"), $581d0262e0d209c8$var$c = Symbol.for("react.portal"), $581d0262e0d209c8$var$d = Symbol.for("react.fragment"), $581d0262e0d209c8$var$e = Symbol.for("react.strict_mode"), $581d0262e0d209c8$var$f = Symbol.for("react.profiler"), $581d0262e0d209c8$var$g = Symbol.for("react.provider"), $581d0262e0d209c8$var$h = Symbol.for("react.context"), $581d0262e0d209c8$var$k = Symbol.for("react.server_context"), $581d0262e0d209c8$var$l = Symbol.for("react.forward_ref"), $581d0262e0d209c8$var$m = Symbol.for("react.suspense"), $581d0262e0d209c8$var$n = Symbol.for("react.suspense_list"), $581d0262e0d209c8$var$p = Symbol.for("react.memo"), $581d0262e0d209c8$var$q = Symbol.for("react.lazy"), $581d0262e0d209c8$var$t = Symbol.for("react.offscreen"), $581d0262e0d209c8$var$u;
$581d0262e0d209c8$var$u = Symbol.for("react.module.reference");
function $581d0262e0d209c8$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $581d0262e0d209c8$var$b:
                switch(a = a.type, a){
                    case $581d0262e0d209c8$var$d:
                    case $581d0262e0d209c8$var$f:
                    case $581d0262e0d209c8$var$e:
                    case $581d0262e0d209c8$var$m:
                    case $581d0262e0d209c8$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $581d0262e0d209c8$var$k:
                            case $581d0262e0d209c8$var$h:
                            case $581d0262e0d209c8$var$l:
                            case $581d0262e0d209c8$var$q:
                            case $581d0262e0d209c8$var$p:
                            case $581d0262e0d209c8$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $581d0262e0d209c8$var$c:
                return r;
        }
    }
}
$581d0262e0d209c8$export$a7c73072b1a182ae = $581d0262e0d209c8$var$h;
$581d0262e0d209c8$export$9f27bc3417b4524d = $581d0262e0d209c8$var$g;
$581d0262e0d209c8$export$db77ccec0bb4ccac = $581d0262e0d209c8$var$b;
$581d0262e0d209c8$export$8392c0c9d3dcbd35 = $581d0262e0d209c8$var$l;
$581d0262e0d209c8$export$ffb0004e005737fa = $581d0262e0d209c8$var$d;
$581d0262e0d209c8$export$b624eff549462981 = $581d0262e0d209c8$var$q;
$581d0262e0d209c8$export$7897aa7841a5380c = $581d0262e0d209c8$var$p;
$581d0262e0d209c8$export$602eac185826482c = $581d0262e0d209c8$var$c;
$581d0262e0d209c8$export$e2c29f18771995cb = $581d0262e0d209c8$var$f;
$581d0262e0d209c8$export$5f8d39834fd61797 = $581d0262e0d209c8$var$e;
$581d0262e0d209c8$export$74bf444e3cd11ea5 = $581d0262e0d209c8$var$m;
$581d0262e0d209c8$export$998bcd577473dd93 = $581d0262e0d209c8$var$n;
$581d0262e0d209c8$export$92387174baf9b227 = function() {
    return !1;
};
$581d0262e0d209c8$export$ec112efeb987d9c6 = function() {
    return !1;
};
$581d0262e0d209c8$export$b706b080d889d2c9 = function(a) {
    return $581d0262e0d209c8$var$v(a) === $581d0262e0d209c8$var$h;
};
$581d0262e0d209c8$export$5be5a87408f70ddc = function(a) {
    return $581d0262e0d209c8$var$v(a) === $581d0262e0d209c8$var$g;
};
$581d0262e0d209c8$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $581d0262e0d209c8$var$b;
};
$581d0262e0d209c8$export$455c2e768291efa6 = function(a) {
    return $581d0262e0d209c8$var$v(a) === $581d0262e0d209c8$var$l;
};
$581d0262e0d209c8$export$9522e17588c12572 = function(a) {
    return $581d0262e0d209c8$var$v(a) === $581d0262e0d209c8$var$d;
};
$581d0262e0d209c8$export$2110ac352bb060b9 = function(a) {
    return $581d0262e0d209c8$var$v(a) === $581d0262e0d209c8$var$q;
};
$581d0262e0d209c8$export$56885ab8b9c456ab = function(a) {
    return $581d0262e0d209c8$var$v(a) === $581d0262e0d209c8$var$p;
};
$581d0262e0d209c8$export$d927fcb6adf8f9de = function(a) {
    return $581d0262e0d209c8$var$v(a) === $581d0262e0d209c8$var$c;
};
$581d0262e0d209c8$export$b82d16f27459e05a = function(a) {
    return $581d0262e0d209c8$var$v(a) === $581d0262e0d209c8$var$f;
};
$581d0262e0d209c8$export$522c17b4f5e123e8 = function(a) {
    return $581d0262e0d209c8$var$v(a) === $581d0262e0d209c8$var$e;
};
$581d0262e0d209c8$export$1aabd8a0274ecfd6 = function(a) {
    return $581d0262e0d209c8$var$v(a) === $581d0262e0d209c8$var$m;
};
$581d0262e0d209c8$export$3d6c20d97e46b957 = function(a) {
    return $581d0262e0d209c8$var$v(a) === $581d0262e0d209c8$var$n;
};
$581d0262e0d209c8$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $581d0262e0d209c8$var$d || a === $581d0262e0d209c8$var$f || a === $581d0262e0d209c8$var$e || a === $581d0262e0d209c8$var$m || a === $581d0262e0d209c8$var$n || a === $581d0262e0d209c8$var$t || "object" === typeof a && null !== a && (a.$$typeof === $581d0262e0d209c8$var$q || a.$$typeof === $581d0262e0d209c8$var$p || a.$$typeof === $581d0262e0d209c8$var$g || a.$$typeof === $581d0262e0d209c8$var$h || a.$$typeof === $581d0262e0d209c8$var$l || a.$$typeof === $581d0262e0d209c8$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$581d0262e0d209c8$export$f5bbd400c2f4426f = $581d0262e0d209c8$var$v;

});


parcelRegister("bAQLH", function(module, exports) {

$parcel$export(module.exports, "default", () => $870bfd35a5465ba0$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $aOzEm = parcelRequire("aOzEm");
parcelRequire("dln0Z");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $74GFZ = parcelRequire("74GFZ");


var $79L8d = parcelRequire("79L8d");

var $9wBxU = parcelRequire("9wBxU");

var $25zst = parcelRequire("25zst");

var $57YGU = parcelRequire("57YGU");

var $gEb5G = parcelRequire("gEb5G");

var $adZRD = parcelRequire("adZRD");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $870bfd35a5465ba0$var$_excluded = [
    "onEntering"
], $870bfd35a5465ba0$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $870bfd35a5465ba0$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $870bfd35a5465ba0$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $870bfd35a5465ba0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $adZRD.getMenuUtilityClass), classes);
};
const $870bfd35a5465ba0$var$MenuRoot = (0, $25zst.default)((0, $9wBxU.default), {
    shouldForwardProp: (prop)=>(0, $25zst.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $870bfd35a5465ba0$export$4f7c51a5920c9f33 = (0, $25zst.default)((0, $9wBxU.PopoverPaper), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $870bfd35a5465ba0$var$MenuMenuList = (0, $25zst.default)((0, $79L8d.default), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $870bfd35a5465ba0$var$Menu = /*#__PURE__*/ $aOzEm.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $cAqXo.default)(props.TransitionProps, $870bfd35a5465ba0$var$_excluded), other = (0, $cAqXo.default)(props, $870bfd35a5465ba0$var$_excluded2);
    const theme = (0, $57YGU.default)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $g6Hsb.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $870bfd35a5465ba0$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $aOzEm.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $aOzEm.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $aOzEm.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $870bfd35a5465ba0$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $74GFZ.useSlotProps)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $74GFZ.useSlotProps)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $2T9xh.jsx)($870bfd35a5465ba0$var$MenuRoot, (0, $g6Hsb.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $870bfd35a5465ba0$var$RTL_ORIGIN : $870bfd35a5465ba0$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $g6Hsb.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)($870bfd35a5465ba0$var$MenuMenuList, (0, $g6Hsb.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $g45Wv.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $870bfd35a5465ba0$export$2e2bcd8739ae039 = $870bfd35a5465ba0$var$Menu;

});
parcelRegister("79L8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $535def00408919a9$export$2e2bcd8739ae039);

var $g6Hsb = parcelRequire("g6Hsb");

var $cAqXo = parcelRequire("cAqXo");

var $aOzEm = parcelRequire("aOzEm");
parcelRequire("dln0Z");


var $h2Mbk = parcelRequire("h2Mbk");

var $8pR5x = parcelRequire("8pR5x");

var $1FT07 = parcelRequire("1FT07");

var $eedeo = parcelRequire("eedeo");

var $ajCuK = parcelRequire("ajCuK");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $535def00408919a9$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $535def00408919a9$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $535def00408919a9$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $535def00408919a9$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $535def00408919a9$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$535def00408919a9$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $535def00408919a9$var$MenuList = /*#__PURE__*/ $aOzEm.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $cAqXo.default)(props, $535def00408919a9$var$_excluded);
    const listRef = $aOzEm.useRef(null);
    const textCriteriaRef = $aOzEm.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $ajCuK.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $aOzEm.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $1FT07.default)((0, $h2Mbk.default)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $h2Mbk.default)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $535def00408919a9$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $535def00408919a9$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $535def00408919a9$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $535def00408919a9$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $535def00408919a9$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $535def00408919a9$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $535def00408919a9$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $535def00408919a9$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $535def00408919a9$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $535def00408919a9$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $535def00408919a9$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $eedeo.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $aOzEm.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $aOzEm.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $aOzEm.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $aOzEm.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8pR5x.default), (0, $g6Hsb.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $535def00408919a9$export$2e2bcd8739ae039 = $535def00408919a9$var$MenuList;

});
parcelRegister("8pR5x", function(module, exports) {

$parcel$export(module.exports, "default", () => $6209d6c66e2f334a$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $1ZWU3 = parcelRequire("1ZWU3");

var $6K8hk = parcelRequire("6K8hk");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $6209d6c66e2f334a$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $6209d6c66e2f334a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $6K8hk.getListUtilityClass), classes);
};
const $6209d6c66e2f334a$var$ListRoot = (0, $25zst.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $g6Hsb.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $6209d6c66e2f334a$var$List = /*#__PURE__*/ $aOzEm.forwardRef(function List(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $cAqXo.default)(props, $6209d6c66e2f334a$var$_excluded);
    const context = $aOzEm.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $6209d6c66e2f334a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $1ZWU3.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $2T9xh.jsxs)($6209d6c66e2f334a$var$ListRoot, (0, $g6Hsb.default)({
            as: component,
            className: (0, $g45Wv.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $6209d6c66e2f334a$export$2e2bcd8739ae039 = $6209d6c66e2f334a$var$List;

});
parcelRegister("1ZWU3", function(module, exports) {

$parcel$export(module.exports, "default", () => $17492dde11f22640$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");
"use client";
/**
 * @ignore - internal component.
 */ const $17492dde11f22640$var$ListContext = /*#__PURE__*/ $aOzEm.createContext({});
var $17492dde11f22640$export$2e2bcd8739ae039 = $17492dde11f22640$var$ListContext;

});

parcelRegister("6K8hk", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", () => $4e8d75e296da9fba$export$c6bd6795ed6e3203);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $4e8d75e296da9fba$export$c6bd6795ed6e3203(slot) {
    return (0, $6vnyE.default)("MuiList", slot);
}
const $4e8d75e296da9fba$var$listClasses = (0, $cyhE3.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $4e8d75e296da9fba$export$2e2bcd8739ae039 = $4e8d75e296da9fba$var$listClasses;

});


parcelRegister("1FT07", function(module, exports) {

$parcel$export(module.exports, "default", () => $138448cb4585da74$export$2e2bcd8739ae039);

var $jMwIo = parcelRequire("jMwIo");
var $138448cb4585da74$export$2e2bcd8739ae039 = (0, $jMwIo.default);

});


parcelRegister("adZRD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getMenuUtilityClass", () => $771b1b32fa71b7a5$export$2cf86a63a84fe23d);
$parcel$export(module.exports, "default", () => $771b1b32fa71b7a5$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $771b1b32fa71b7a5$export$2cf86a63a84fe23d(slot) {
    return (0, $6vnyE.default)("MuiMenu", slot);
}
const $771b1b32fa71b7a5$var$menuClasses = (0, $cyhE3.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $771b1b32fa71b7a5$export$2e2bcd8739ae039 = $771b1b32fa71b7a5$var$menuClasses;

});


parcelRegister("cr5FO", function(module, exports) {

$parcel$export(module.exports, "nativeSelectSelectStyles", () => $90dc68422ac08762$export$c1eccd1617458c87);
$parcel$export(module.exports, "nativeSelectIconStyles", () => $90dc68422ac08762$export$e7a817afd12a40d0);
$parcel$export(module.exports, "default", () => $90dc68422ac08762$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");


var $b2r0b = parcelRequire("b2r0b");

var $63Oo6 = parcelRequire("63Oo6");

var $ceGgy = parcelRequire("ceGgy");

var $25zst = parcelRequire("25zst");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $90dc68422ac08762$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $90dc68422ac08762$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $63Oo6.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $ceGgy.getNativeSelectUtilityClasses), classes);
};
const $90dc68422ac08762$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $g6Hsb.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $g6Hsb.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $ceGgy.default).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $90dc68422ac08762$var$NativeSelectSelect = (0, $25zst.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $25zst.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $ceGgy.default).multiple}`]: styles.multiple
            }
        ];
    }
})($90dc68422ac08762$export$c1eccd1617458c87);
const $90dc68422ac08762$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $g6Hsb.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $ceGgy.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $90dc68422ac08762$var$NativeSelectIcon = (0, $25zst.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $63Oo6.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($90dc68422ac08762$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $90dc68422ac08762$var$NativeSelectInput = /*#__PURE__*/ $aOzEm.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $cAqXo.default)(props, $90dc68422ac08762$var$_excluded);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $90dc68422ac08762$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($aOzEm.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)($90dc68422ac08762$var$NativeSelectSelect, (0, $g6Hsb.default)({
                ownerState: ownerState,
                className: (0, $g45Wv.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $2T9xh.jsx)($90dc68422ac08762$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $90dc68422ac08762$export$2e2bcd8739ae039 = $90dc68422ac08762$var$NativeSelectInput;

});
parcelRegister("ceGgy", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", () => $8e8793fce3b30909$export$1ee13051fd9e2ab5);
$parcel$export(module.exports, "default", () => $8e8793fce3b30909$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $8e8793fce3b30909$export$1ee13051fd9e2ab5(slot) {
    return (0, $6vnyE.default)("MuiNativeSelect", slot);
}
const $8e8793fce3b30909$var$nativeSelectClasses = (0, $cyhE3.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $8e8793fce3b30909$export$2e2bcd8739ae039 = $8e8793fce3b30909$var$nativeSelectClasses;

});


parcelRegister("fxtci", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", () => $b500960f5493ae0b$export$2c0c1ee5a3392e);
$parcel$export(module.exports, "default", () => $b500960f5493ae0b$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $b500960f5493ae0b$export$2c0c1ee5a3392e(slot) {
    return (0, $6vnyE.default)("MuiSelect", slot);
}
const $b500960f5493ae0b$var$selectClasses = (0, $cyhE3.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $b500960f5493ae0b$export$2e2bcd8739ae039 = $b500960f5493ae0b$var$selectClasses;

});


parcelRegister("fvlLx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b49aa27a49d04742$export$2e2bcd8739ae039);
parcelRequire("aOzEm");

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $b49aa27a49d04742$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");

});


parcelRegister("eXt0L", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getTextFieldUtilityClass", () => $ae3d146df6e57b0f$export$c1bdcbaf0596aeda);
$parcel$export(module.exports, "default", () => $ae3d146df6e57b0f$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $ae3d146df6e57b0f$export$c1bdcbaf0596aeda(slot) {
    return (0, $6vnyE.default)("MuiTextField", slot);
}
const $ae3d146df6e57b0f$var$textFieldClasses = (0, $cyhE3.default)("MuiTextField", [
    "root"
]);
var $ae3d146df6e57b0f$export$2e2bcd8739ae039 = $ae3d146df6e57b0f$var$textFieldClasses;

});


parcelRegister("bT9P9", function(module, exports) {
"use strict";
"use client";

var $8uFn9 = parcelRequire("8uFn9");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a7c7398058ecea5$var$_createSvgIcon = $8uFn9((parcelRequire("5QdpD")));

var $2T9xh = parcelRequire("2T9xh");
var $8a7c7398058ecea5$var$_default = (0, $8a7c7398058ecea5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");
module.exports.default = $8a7c7398058ecea5$var$_default;

});

parcelRegister("afh3O", function(module, exports) {
"use strict";
"use client";

var $8uFn9 = parcelRequire("8uFn9");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $775889f7711c2780$var$_createSvgIcon = $8uFn9((parcelRequire("5QdpD")));

var $2T9xh = parcelRequire("2T9xh");
var $775889f7711c2780$var$_default = (0, $775889f7711c2780$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
module.exports.default = $775889f7711c2780$var$_default;

});

parcelRegister("09M6d", function(module, exports) {
"use strict";
var $00079545b4df77bb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $00079545b4df77bb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $00079545b4df77bb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$00079545b4df77bb$var$__exportStar((parcelRequire("8bQRU")), module.exports);

$00079545b4df77bb$var$__exportStar((parcelRequire("aePlD")), module.exports);

});
parcelRegister("8bQRU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.schemaOptions = void 0;
module.exports.schemaOptions = [
    {
        value: "char(length)",
        group: "String"
    },
    {
        value: "varchar(length)",
        group: "String"
    },
    {
        value: "string",
        group: "String"
    },
    {
        value: "binary(length)",
        group: "Binary"
    },
    {
        value: "varbinary(length)",
        group: "Binary"
    },
    {
        value: "bytes",
        group: "Binary"
    },
    {
        value: "decimal(precision,scale)",
        group: "Numeric"
    },
    {
        value: "dec(precision,scale)",
        group: "Numeric"
    },
    {
        value: "numeric(precision,scale)",
        group: "Numeric"
    },
    {
        value: "tinyint",
        group: "Numeric"
    },
    {
        value: "smallint",
        group: "Numeric"
    },
    {
        value: "integer",
        group: "Numeric"
    },
    {
        value: "bigint",
        group: "Numeric"
    },
    {
        value: "float",
        group: "Numeric"
    },
    {
        value: "double",
        group: "Numeric"
    },
    {
        value: "date",
        group: "Date and Time"
    },
    {
        value: "time(precision)",
        group: "Date and Time"
    },
    {
        value: "timestamp(precision)",
        group: "Date and Time"
    },
    {
        value: "timestamp_ltz(precision)",
        group: "Date and Time"
    },
    {
        value: "array<type>",
        group: "Compound"
    },
    {
        value: "map<key,value>",
        group: "Compound"
    },
    {
        value: "row<fields>",
        group: "Compound"
    },
    {
        value: "boolean",
        group: "Other"
    },
    {
        value: "interval",
        group: "Other"
    },
    {
        value: "multiset",
        group: "Other"
    }
];

});

parcelRegister("aePlD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GLOBAL_THROTTLE_DELAY = module.exports.NAV_RESPONSIVE_BREAKPOINT = void 0;
module.exports.NAV_RESPONSIVE_BREAKPOINT = "(min-width: 1060px)";
module.exports.GLOBAL_THROTTLE_DELAY = 250;

});



parcelRegister("33d8t", function(module, exports) {

$parcel$export(module.exports, "usePath", () => $ec3622315e1c0fc7$export$17886d48403e28f9);

var $aOzEm = parcelRequire("aOzEm");

var $5YTEB = parcelRequire("5YTEB");

var $2o5b6 = parcelRequire("2o5b6");
const $ec3622315e1c0fc7$var$resourceTypePaths = {
    account: [
        "account"
    ],
    pipeline: [
        "pipelines"
    ],
    connection: [
        "connections"
    ],
    stream: [
        "streams"
    ],
    user: [
        "access",
        "users"
    ],
    group: [
        "access",
        "groups"
    ],
    role: [
        "access",
        "roles"
    ],
    secret: [
        "secrets"
    ]
};
function $ec3622315e1c0fc7$export$17886d48403e28f9({ accountName: accountName, resourceType: resourceType, resourceId: resourceId } = {}) {
    const { accountName: accountNameFromPath } = (0, $5YTEB.useParams)();
    return (0, $aOzEm.useMemo)(()=>{
        if (!accountName) accountName = accountNameFromPath;
        if (!resourceType) return (0, $2o5b6.makePath)([
            accountName
        ]);
        if (!resourceId) return (0, $2o5b6.makePath)([
            accountName,
            ...$ec3622315e1c0fc7$var$resourceTypePaths[resourceType]
        ]);
        return (0, $2o5b6.makePath)([
            accountName,
            ...$ec3622315e1c0fc7$var$resourceTypePaths[resourceType],
            resourceId
        ]);
    }, [
        accountNameFromPath,
        accountName,
        resourceType,
        resourceId
    ]);
}

});
parcelRegister("2o5b6", function(module, exports) {

$parcel$export(module.exports, "makePath", () => $c161d0cba72c9e43$export$aa9bab72412f5613);
function $c161d0cba72c9e43$export$aa9bab72412f5613(parts) {
    return (parts[0] == "." || parts[0] == ".." ? "" : "/") + parts.map((part)=>encodeURIComponent(part)).join("/");
}

});


parcelRegister("7aAxC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5385cfe34d63e769$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $5385cfe34d63e769$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
}), "AddCircle");

});

parcelRegister("deADQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a290173a0f3e890$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $9a290173a0f3e890$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21z"
}), "Bolt");

});

parcelRegister("8EsI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $64c8546c9873710d$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $64c8546c9873710d$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
}), "ChatBubble");

});

parcelRegister("goopS", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef1d3d1a60d9d1a$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $bef1d3d1a60d9d1a$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");

});

parcelRegister("5PdGJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $43dc555bd6a5b258$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $43dc555bd6a5b258$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "PersonAdd");

});

parcelRegister("6fKva", function(module, exports) {

$parcel$export(module.exports, "default", () => $48d8370d642d7687$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $48d8370d642d7687$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 2c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H8v-1.5c0-1.99 4-3 6-3s6 1.01 6 3V16z"
}), "SwitchAccount");

});

parcelRegister("676nd", function(module, exports) {

$parcel$export(module.exports, "RoleIcon", () => $4bfacbcb5e7402f7$export$3e92acb23cdb6bf7);

var $iznXd = parcelRequire("iznXd");
const $4bfacbcb5e7402f7$export$3e92acb23cdb6bf7 = (0, $iznXd.default);

});
parcelRegister("iznXd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d84e13a43ec2d6f4$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $d84e13a43ec2d6f4$export$2e2bcd8739ae039 = (0, $9hLGI.default)([
    /*#__PURE__*/ (0, $2T9xh.jsx)("circle", {
        cx: "10",
        cy: "8",
        r: "4"
    }, "0"),
    /*#__PURE__*/ (0, $2T9xh.jsx)("path", {
        d: "M10.67 13.02c-.22-.01-.44-.02-.67-.02-2.42 0-4.68.67-6.61 1.82-.88.52-1.39 1.5-1.39 2.53V20h9.26c-.79-1.13-1.26-2.51-1.26-4 0-1.07.25-2.07.67-2.98zM20.75 16c0-.22-.03-.42-.06-.63l1.14-1.01-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L18 11h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01 1 1.73 1.45-.49c.32.27.68.48 1.08.63L16 21h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1.01c.03-.21.06-.41.06-.63zM17 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    }, "1")
], "ManageAccounts");

});



parcelRegister("i08ji", function(module, exports) {

$parcel$export(module.exports, "DataPlaneSetupAlert", () => $3a1d8711dda91b0f$export$e978bd60c613cc41);

var $2T9xh = parcelRequire("2T9xh");
parcelRequire("aOzEm");

var $bXjp5 = parcelRequire("bXjp5");

var $2Wdb2 = parcelRequire("2Wdb2");
function $3a1d8711dda91b0f$export$e978bd60c613cc41(props) {
    if (!props.activeAccountCtx.activeAccount || props.activeAccountCtx?.accountInfo?.deployment_type != "byoc" || props.activeAccountCtx?.accountInfo?.data_plane_hostname && props.activeAccountCtx?.accountInfo?.data_plane?.m_tlssigning_state == "AVAILABLE") // If the account info is still loading, the current account is not BYOC,
    // or the data plane URL and mTLS are already configured, render null.
    return null;
    // If mTLS isn't configured yet, pop up a banner for that
    if (props.activeAccountCtx?.accountInfo?.data_plane?.m_tlssigning_state != "AVAILABLE") return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bXjp5))), {
        severity: "info",
        sx: {
            margin: 0,
            padding: 0
        },
        children: [
            "Action required:",
            " ",
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Wdb2))), {
                sx: {
                    color: "white",
                    textDecoration: "underline",
                    display: "inline"
                },
                href: `/${props.activeAccountCtx.activeAccount.name}/account?tab=data-plane`,
                children: "Configure your mTLS credentials"
            }),
            " ",
            "to complete account setup."
        ]
    });
    // If mTLS is configured but the data plane host isn't, pop up a banner for thate
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bXjp5))), {
        severity: "info",
        sx: {
            margin: 0,
            padding: 0
        },
        children: [
            "Action required:",
            " ",
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Wdb2))), {
                sx: {
                    color: "white",
                    textDecoration: "underline",
                    display: "inline"
                },
                href: `/${props.activeAccountCtx.activeAccount.name}/account?tab=data-plane`,
                children: "Configure the data plane host"
            }),
            " ",
            "to complete account setup."
        ]
    });
}

});

parcelRegister("22SrL", function(module, exports) {

$parcel$export(module.exports, "default", () => $17d600b38d1b60de$export$2e2bcd8739ae039);


var $6XLpC = parcelRequire("6XLpC");
"use client";
/**
 *
 * Demos:
 *
 * - [Stack (Joy UI)](https://mui.com/joy-ui/react-stack/)
 * - [Stack (Material UI)](https://mui.com/material-ui/react-stack/)
 * - [Stack (MUI System)](https://mui.com/system/react-stack/)
 *
 * API:
 *
 * - [Stack API](https://mui.com/system/api/stack/)
 */ const $17d600b38d1b60de$var$Stack = (0, $6XLpC.default)();
var $17d600b38d1b60de$export$2e2bcd8739ae039 = $17d600b38d1b60de$var$Stack;

});

parcelRegister("29pjJ", function(module, exports) {

$parcel$export(module.exports, "AppEventsProvider", () => $9a7ec1a76a16cea8$export$aa4350006e53e5e4);
$parcel$export(module.exports, "useAppEventDispatch", () => $9a7ec1a76a16cea8$export$25291b9f475895fe);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");
class $9a7ec1a76a16cea8$export$bce77b2b1f2ef473 {
    constructor(){
        this.dispatch = (eventType, detail)=>{
            this.target.dispatchEvent(new CustomEvent(eventType, {
                detail: detail
            }));
        };
        this.target = new EventTarget();
    }
    on(eventType, handler) {
        this.target.addEventListener(eventType, handler);
    }
    off(eventType, handler) {
        this.target.removeEventListener(eventType, handler);
    }
}
const $9a7ec1a76a16cea8$export$b3c9eb233d55e5bb = /*#__PURE__*/ (0, $aOzEm.createContext)(new $9a7ec1a76a16cea8$export$bce77b2b1f2ef473());
function $9a7ec1a76a16cea8$export$aa4350006e53e5e4({ children: children }) {
    const [target] = (0, $aOzEm.useState)(()=>new $9a7ec1a76a16cea8$export$bce77b2b1f2ef473());
    return /*#__PURE__*/ (0, $2T9xh.jsx)($9a7ec1a76a16cea8$export$b3c9eb233d55e5bb.Provider, {
        value: target,
        children: children
    });
}
function $9a7ec1a76a16cea8$export$53b7a82d57692fbb() {
    return (0, $aOzEm.useContext)($9a7ec1a76a16cea8$export$b3c9eb233d55e5bb);
}
function $9a7ec1a76a16cea8$export$cf3f4d056220785c(event, handler) {
    const target = $9a7ec1a76a16cea8$export$53b7a82d57692fbb();
    (0, $aOzEm.useEffect)(()=>{
        target.on(event, handler);
        return ()=>target.off(event, handler);
    }, [
        target,
        event,
        handler
    ]);
}
function $9a7ec1a76a16cea8$export$25291b9f475895fe() {
    const target = $9a7ec1a76a16cea8$export$53b7a82d57692fbb();
    return target.dispatch;
}

});



parcelRegister("fmfg5", function(module, exports) {

$parcel$export(module.exports, "AccessApiProvider", () => $8f8387da47cf39e5$export$7d269dda5765bce4);
$parcel$export(module.exports, "useAccessApi", () => $8f8387da47cf39e5$export$ae6ae8a8b0a81b5e);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $hJHPU = parcelRequire("hJHPU");

var $ek6Yt = parcelRequire("ek6Yt");

var $3oogS = parcelRequire("3oogS");
const $8f8387da47cf39e5$export$55ea2303d9f57981 = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $8f8387da47cf39e5$export$7d269dda5765bce4({ children: children }) {
    const fetch = (0, $hJHPU.useAccountScopedFetch)();
    const service = (0, $aOzEm.useMemo)(()=>fetch && new (0, $ek6Yt.AccessService)(fetch), [
        fetch
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($8f8387da47cf39e5$export$55ea2303d9f57981.Provider, {
        value: service,
        children: children
    });
}
function $8f8387da47cf39e5$export$8c2276b160674c2e({ children: children }) {
    const db = (0, $aOzEm.useMemo)(()=>(0, $3oogS.newMockDatabase)(), []);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($8f8387da47cf39e5$export$55ea2303d9f57981.Provider, {
        value: new (0, $3oogS.MockAccessApi)({
            db: db
        }),
        children: children
    });
}
function $8f8387da47cf39e5$export$ae6ae8a8b0a81b5e() {
    return (0, $aOzEm.useContext)($8f8387da47cf39e5$export$55ea2303d9f57981);
}

});
parcelRegister("3oogS", function(module, exports) {

$parcel$export(module.exports, "MockAccessApi", () => $116ea4b5ba6bae93$export$bc75e0881acacf24);
$parcel$export(module.exports, "newMockDatabase", () => $116ea4b5ba6bae93$export$38d47f479d8dd542);
class $116ea4b5ba6bae93$export$bc75e0881acacf24 {
    constructor({ db: db } = {}){
        this.db = db || $116ea4b5ba6bae93$export$38d47f479d8dd542();
        window.accessData = this.db;
    }
    async listGroups() {
        return $116ea4b5ba6bae93$var$paginated([
            ...this.db.groups.values()
        ]);
    }
    async createGroup(params) {
        const now = new Date().toISOString();
        const group = {
            id: $116ea4b5ba6bae93$var$nextGroupId(),
            ...params.group,
            create_time: now,
            update_time: now
        };
        this.db.groups.set(group.id, group);
        return group;
    }
    async getGroup(params) {
        return $116ea4b5ba6bae93$var$find(()=>this.db.groups.get(params.id), `Group ${params.id}`);
    }
    async updateGroup(params) {
        const updated = {
            ...this.db.groups.get(params.group.id),
            ...params.group
        };
        this.db.groups.set(params.group.id, updated);
        return updated;
    }
    async deleteGroup(params) {
        this.db.groups.delete(params.id);
        this.db.group_roles = this.db.group_roles.filter((edge)=>edge.groupId != params.id);
        this.db.user_groups = this.db.user_groups.filter((edge)=>edge.groupId != params.id);
    }
    async listGroupUsers(params) {
        return $116ea4b5ba6bae93$var$paginated(this.db.user_groups.filter((edge)=>edge.groupId == params.id).map((edge)=>this.db.users.get(edge.userId)));
    }
    async addGroupUser(params) {
        this.db.user_groups.push(params);
        return this.db.groups.get(params.groupId);
    }
    async removeGroupUser(params) {
        this.db.user_groups = this.db.user_groups.filter((e)=>!(e.groupId == params.groupId && e.userId == params.userId));
        return this.db.groups.get(params.groupId);
    }
    async listGroupRoles(params) {
        return $116ea4b5ba6bae93$var$paginated(this.db.group_roles.filter((edge)=>edge.groupId == params.id).map((edge)=>this.db.roles.get(edge.roleId)));
    }
    async addGroupRole(params) {
        this.db.group_roles.push(params);
        return this.db.groups.get(params.groupId);
    }
    async removeGroupRole(params) {
        this.db.group_roles = this.db.group_roles.filter((e)=>!(e.groupId == params.groupId && e.roleId == params.roleId));
        return this.db.groups.get(params.groupId);
    }
    async listRoles() {
        return $116ea4b5ba6bae93$var$paginated([
            ...this.db.roles.values()
        ]);
    }
    async getRole(params) {
        return $116ea4b5ba6bae93$var$find(()=>this.db.roles.get(params.id), `Role ${params.id}`);
    }
    async createRole(params) {
        const now = new Date().toISOString();
        const role = {
            id: $116ea4b5ba6bae93$var$nextRoleId(),
            ...params.role,
            create_time: now,
            update_time: now
        };
        this.db.roles.set(role.id, role);
        this.db.role_permissions.set(role.id, []);
        return role;
    }
    async updateRole(params) {
        const updated = {
            ...this.db.roles.get(params.role.id),
            ...params.role
        };
        this.db.roles.set(params.role.id, updated);
        return updated;
    }
    async deleteRole(params) {
        this.db.roles.delete(params.id);
        this.db.group_roles = this.db.group_roles.filter((edge)=>edge.roleId != params.id);
    }
    async listRoleGroups(params) {
        return $116ea4b5ba6bae93$var$paginated(this.db.group_roles.filter((edge)=>edge.roleId == params.id).map((edge)=>this.db.groups.get(edge.groupId)));
    }
    async listRolePermissions(params) {
        return $116ea4b5ba6bae93$var$paginated(this.db.role_permissions.get(params.id));
    }
    async setRolePermissions(params) {
        this.db.role_permissions.set(params.id, params.permissions);
        return $116ea4b5ba6bae93$var$paginated(params.permissions);
    }
    async listUsers() {
        return $116ea4b5ba6bae93$var$paginated([
            ...this.db.users.values()
        ]);
    }
    async getUser(params) {
        return this.db.users.get(params.id);
    }
    async getUserGroups(params) {
        return $116ea4b5ba6bae93$var$paginated(this.db.user_groups.filter((edge)=>edge.userId == params.id).map((edge)=>this.db.groups.get(edge.groupId)));
    }
}
function $116ea4b5ba6bae93$var$find(finder, description) {
    const result = finder();
    if (!result) throw {
        status: 404,
        message: `Not found: ${description ?? "<no description>"}`
    };
    return result;
}
function $116ea4b5ba6bae93$var$paginated(items) {
    return {
        items: items,
        next_page_token: "unused"
    };
}
function $116ea4b5ba6bae93$var$idGenerator() {
    let next = 0;
    return function() {
        return (++next).toString();
    };
}
const $116ea4b5ba6bae93$var$nextGroupId = $116ea4b5ba6bae93$var$idGenerator();
const $116ea4b5ba6bae93$var$nextRoleId = $116ea4b5ba6bae93$var$idGenerator();
const $116ea4b5ba6bae93$var$nextUserId = $116ea4b5ba6bae93$var$idGenerator();
function $116ea4b5ba6bae93$export$38d47f479d8dd542() {
    var u, g, r;
    // https://parceljs.org/features/production/#development-branch-removal
    throw new Error("The mock access data is stripped in the production build");
}

});


parcelRegister("k3nD8", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("1WB2L"),
    $foscK("7iRlq")
]).then(()=>parcelRequire("2H4m6"));

});

parcelRegister("ZfB0f", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("8jIJA")
]).then(()=>parcelRequire("klhby"));

});

parcelRegister("eOFP5", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("fDgWP"),
    $foscK("jCVeS"),
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("bkWyz")
]).then(()=>parcelRequire("kPG0a"));

});

parcelRegister("9MUcM", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("kgRz6")
]).then(()=>parcelRequire("iCkdw"));

});

parcelRegister("dnhWp", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("fDgWP"),
    $foscK("jCVeS"),
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("hqkHt")
]).then(()=>parcelRequire("781KK"));

});

parcelRegister("87ZI0", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("e1bPM")
]).then(()=>parcelRequire("7CFp4"));

});

parcelRegister("4Jhys", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("fDgWP"),
    $foscK("jCVeS"),
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("6sWJb")
]).then(()=>parcelRequire("59oOK"));

});


parcelRegister("ekG0d", function(module, exports) {

$parcel$export(module.exports, "routes", () => $e74756888420cd89$export$66b32f6f30eb4b4);
$parcel$export(module.exports, "ConnectionsApiProvider", () => (parcelRequire("1Awk5")).ConnectionsApiProvider);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $5YTEB = parcelRequire("5YTEB");

var $1Awk5 = parcelRequire("1Awk5");

const $e74756888420cd89$var$LazyConnectionsListPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("bKxBT")));

const $e74756888420cd89$var$LazyConnectionDetailsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("5PcKC")));

const $e74756888420cd89$var$LazyConnectionCreatePage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("7y5tt")));
const $e74756888420cd89$export$66b32f6f30eb4b4 = /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $2T9xh.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
            index: true,
            element: /*#__PURE__*/ (0, $2T9xh.jsx)($e74756888420cd89$var$LazyConnectionsListPage, {})
        }),
        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
            path: ":connectionId",
            element: /*#__PURE__*/ (0, $2T9xh.jsx)($e74756888420cd89$var$LazyConnectionDetailsPage, {})
        }),
        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
            path: "create",
            element: /*#__PURE__*/ (0, $2T9xh.jsx)($e74756888420cd89$var$LazyConnectionCreatePage, {})
        })
    ]
});

});
parcelRegister("1Awk5", function(module, exports) {

$parcel$export(module.exports, "ConnectionsApiProvider", () => $33e84170c79a7599$export$95a6a4f0500f1a8e);
$parcel$export(module.exports, "useConnectionsApi", () => $33e84170c79a7599$export$636c0d94c75c01da);
$parcel$export(module.exports, "useConnectionsDataApi", () => $33e84170c79a7599$export$796df844838ed114);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $hJHPU = parcelRequire("hJHPU");

var $ek6Yt = parcelRequire("ek6Yt");

var $k5KQ6 = parcelRequire("k5KQ6");
const $33e84170c79a7599$export$9024f540d6757640 = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $33e84170c79a7599$export$95a6a4f0500f1a8e({ children: children = null }) {
    const fetch = (0, $hJHPU.useAccountScopedFetch)();
    const service = (0, $aOzEm.useMemo)(()=>fetch && new (0, $ek6Yt.ConnectionsService)(fetch), [
        fetch
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($33e84170c79a7599$export$9024f540d6757640.Provider, {
        value: service,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)($33e84170c79a7599$export$c8d6da0a6e91274a, {
            children: children
        })
    });
}
function $33e84170c79a7599$export$636c0d94c75c01da() {
    return (0, $aOzEm.useContext)($33e84170c79a7599$export$9024f540d6757640);
}
const $33e84170c79a7599$export$71909a7791105259 = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $33e84170c79a7599$export$c8d6da0a6e91274a({ children: children }) {
    const dataPlaneClient = (0, $k5KQ6.useDataPlaneClient)();
    const service = (0, $aOzEm.useMemo)(async ()=>new (0, $ek6Yt.ConnectionsDataService)({
            client: await dataPlaneClient
        }), [
        dataPlaneClient
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($33e84170c79a7599$export$71909a7791105259.Provider, {
        value: service,
        children: children
    });
}
function $33e84170c79a7599$export$796df844838ed114() {
    return (0, $aOzEm.useContext)($33e84170c79a7599$export$71909a7791105259);
}

});
parcelRegister("k5KQ6", function(module, exports) {

$parcel$export(module.exports, "useDataPlaneHost", () => $98a7f848c150782d$export$3fa2cb786a30a60a);
$parcel$export(module.exports, "useDataPlaneClient", () => $98a7f848c150782d$export$679aecc0f3476f83);

var $ek6Yt = parcelRequire("ek6Yt");

var $aOzEm = parcelRequire("aOzEm");

var $gga7I = parcelRequire("gga7I");
const $98a7f848c150782d$var$noHostErr = "Data plane hostname not configured";
function $98a7f848c150782d$export$3fa2cb786a30a60a() {
    const { accountInfoIsLoading: accountInfoIsLoading, accountInfoError: accountInfoError, accountInfo: accountInfo } = (0, $gga7I.useActiveAccount)();
    const error = (0, $aOzEm.useMemo)(()=>accountInfo && !accountInfo.data_plane_hostname ? new Error($98a7f848c150782d$var$noHostErr) : null, [
        accountInfo
    ]);
    return {
        isLoading: accountInfoIsLoading,
        host: accountInfo?.data_plane_hostname,
        error: error ?? accountInfoError
    };
}
function $98a7f848c150782d$export$679aecc0f3476f83() {
    const { host: host, isLoading: isLoading, error: error } = $98a7f848c150782d$export$3fa2cb786a30a60a();
    const ref = (0, $aOzEm.useRef)();
    // Initialize the promise on mount, or re-initialize when the host changes.
    if (!ref.current || ref.current.explodedPromise.isFinalized && (host ?? "") !== (ref.current.host ?? "")) ref.current = {
        host: null,
        explodedPromise: $98a7f848c150782d$var$explodedPromise()
    };
    if (!ref.current.explodedPromise.isFinalized) {
        if (host) {
            ref.current.host = host;
            ref.current.explodedPromise.resolve(new (0, $ek6Yt.DataPlaneClient)({
                host: host
            }));
        } else if (error) ref.current.explodedPromise.resolve($98a7f848c150782d$var$getUnusableDataPlaneClient(error));
        else if (!isLoading && !host) ref.current.explodedPromise.resolve($98a7f848c150782d$var$getUnusableDataPlaneClient(new Error($98a7f848c150782d$var$noHostErr)));
    }
    return ref.current.explodedPromise.promise;
}
// An unusable data plane client will throw for all method invocations.
// See comment on useDataPlaneClient for why we do this, rather than
// failing at initialization time.
function $98a7f848c150782d$var$getUnusableDataPlaneClient(error) {
    return new (0, $ek6Yt.DataPlaneClient)({
        host: "<undefined>",
        fetch (_) {
            throw error;
        }
    });
}
function $98a7f848c150782d$var$explodedPromise() {
    const exploded = {
        promise: null,
        resolve: null,
        reject: null,
        isFinalized: false
    };
    exploded.promise = new Promise((res, rej)=>{
        exploded.resolve = res;
        exploded.reject = rej;
    });
    exploded.promise.finally(()=>{
        exploded.isFinalized = true;
    });
    return exploded;
}

});


parcelRegister("bKxBT", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("6LPy3"),
    $foscK("gQdJ7"),
    $foscK("jU2Od"),
    $foscK("ddopL"),
    $foscK("7V5iC"),
    $foscK("jmeps"),
    $foscK("dx9bh"),
    $foscK("fDgWP"),
    $foscK("jCVeS"),
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("cKmUq")
]).then(()=>parcelRequire("fSGZe"));

});

parcelRegister("5PcKC", function(module, exports) {

var $foscK = parcelRequire("foscK");


module.exports = Promise.all([
    (parcelRequire("gVtzA"))((parcelRequire("3Dw4r")).resolve("k1DSm")),
    $foscK("fgx4Y"),
    $foscK("8cyRS"),
    $foscK("laLtR"),
    $foscK("cCFzf"),
    $foscK("6LPy3"),
    $foscK("jU2Od"),
    $foscK("ddopL"),
    $foscK("7V5iC"),
    $foscK("jmeps"),
    $foscK("dx9bh"),
    $foscK("fDgWP"),
    $foscK("jCVeS"),
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("iqPSQ")
]).then(()=>parcelRequire("7dcq9"));

});

parcelRegister("7y5tt", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("jU2Od"),
    $foscK("ddopL"),
    $foscK("7V5iC"),
    $foscK("jmeps"),
    $foscK("dx9bh"),
    $foscK("fDgWP"),
    $foscK("jCVeS"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("kMfS5"),
    $foscK("2SIdH")
]).then(()=>parcelRequire("8g450"));

});


parcelRegister("6KwHv", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a5aad2fe9ed40264$export$e324594224ef24da);
$parcel$export(module.exports, "AppQueryClientProvider", () => $a5aad2fe9ed40264$export$242d6945a7f8e51b);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");
parcelRequire("4UEYn");
var $l1slT = parcelRequire("l1slT");
var $k71hw = parcelRequire("k71hw");
var $dRtsf = parcelRequire("dRtsf");

var $4In7L = parcelRequire("4In7L");

var $5RcZa = parcelRequire("5RcZa");

var $29pjJ = parcelRequire("29pjJ");
function $a5aad2fe9ed40264$export$824f179edf406063(failureCount, error) {
    if (typeof error?.status === "number" && error.status >= 400 && error.status < 500 && error.status != 429) // No point in retrying request errors like 404, etc.
    // Fail fast instead.
    return false;
    // Default retry policy: 3 retries, 4 total attempts.
    // Same as the ReactQuery default.
    return failureCount < 3;
}
const $a5aad2fe9ed40264$export$a7a85ec87d2c479b = {
    defaultOptions: {
        queries: {
            // Don't refetch cached data if it's less than 2 seconds old.
            // By default React Query considers all cached data as stale,
            // and shows the stale data while refetching. This is a sane,
            // but somewhat aggressive default. We increase the timeout
            // to 2 seconds to play nice with pre-fetching on link hover,
            // and avoid the extra API call.
            staleTime: 2000,
            retry: $a5aad2fe9ed40264$export$824f179edf406063
        }
    }
};
const $a5aad2fe9ed40264$export$e324594224ef24da = {
    create: {
        infinitive: "create",
        continuousTense: "creating",
        pastTense: "created"
    },
    read: {
        infinitive: "read",
        continuousTense: "reading",
        pastTense: "read"
    },
    update: {
        infinitive: "update",
        continuousTense: "updating",
        pastTense: "updated"
    },
    delete: {
        infinitive: "delete",
        continuousTense: "deleting",
        pastTense: "deleted"
    },
    set: {
        infinitive: "set",
        continuousTense: "setting",
        pastTense: "set"
    },
    request: {
        infinitive: "request",
        continuousTense: "requesting",
        pastTense: "requested"
    }
};
function $a5aad2fe9ed40264$export$89c2cd53d8d67520({ notify: notify }) {
    return (_data, _variables, _context, mutation)=>{
        const action = mutation.meta?.action;
        const resourceType = mutation.meta?.resourceType;
        if (!action) // Do nothing if there is no action metadata.
        // This prevents showing duplicate notifications for
        // legacy queries that don't have meta defined, and
        // do their own notifications.
        return;
        if (action?.infinitive === "read") // Ignore read operations
        return;
        let title = "Success";
        if (action?.pastTense && resourceType) switch(action.infinitive){
            case "create":
                title = `New ${resourceType} ${action.pastTense}`;
                break;
            case "update":
            case "request":
            case "delete":
                title = `${action.pastTense} ${resourceType}`;
                break;
            case "set":
                title = `${resourceType} was ${action.pastTense} successfully`;
                break;
        }
        notify({
            title: (0, $5RcZa.sentenceCase)(title),
            message: undefined,
            severity: "success"
        });
    };
}
function $a5aad2fe9ed40264$export$951489f81f4d4cf9({ notify: notify }) {
    return (error, _variables, _context, mutation)=>{
        const action = mutation.meta?.action;
        const resourceType = mutation.meta?.resourceType;
        if (!action) // Do nothing if there is no action metadata.
        // This prevents showing duplicate notifications for
        // legacy queries that don't have meta defined, and
        // do their own notifications.
        return;
        let title = action?.continuousTense && resourceType ? `Error ${action.continuousTense} ${resourceType}` : "Error";
        notify({
            title: title,
            message: error?.message ?? undefined,
            severity: "error"
        });
    };
}
function $a5aad2fe9ed40264$export$2efb41c5e29c3fed() {
    const notify = (0, $4In7L.useSnackbar)();
    const dispatchEvent = (0, $29pjJ.useAppEventDispatch)();
    return (0, $aOzEm.useMemo)(()=>{
        const queryClient = new (0, $k71hw.QueryClient)({
            ...$a5aad2fe9ed40264$export$a7a85ec87d2c479b,
            mutationCache: new (0, $l1slT.MutationCache)({
                onSuccess: (data, variables, context, mutation)=>{
                    queryClient.invalidateQueries();
                    dispatchEvent("mutation:success", {
                        key: mutation.options.mutationKey,
                        data: data,
                        variables: variables,
                        context: context
                    });
                    $a5aad2fe9ed40264$export$89c2cd53d8d67520({
                        notify: notify
                    })(data, variables, context, mutation);
                },
                onError: (error, variables, context, mutation)=>{
                    dispatchEvent("mutation:error", {
                        key: mutation.options.mutationKey,
                        error: error,
                        variables: variables,
                        context: context
                    });
                    $a5aad2fe9ed40264$export$951489f81f4d4cf9({
                        notify: notify
                    })(error, variables, context, mutation);
                }
            })
        });
        return queryClient;
    }, []);
}
function $a5aad2fe9ed40264$export$242d6945a7f8e51b({ children: children }) {
    const client = $a5aad2fe9ed40264$export$2efb41c5e29c3fed();
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $dRtsf.QueryClientProvider), {
        client: client,
        children: children
    });
}

});
parcelRegister("5RcZa", function(module, exports) {

$parcel$export(module.exports, "titleCase", () => $672f521dcd55ced4$export$348afa8c9ff47183);
$parcel$export(module.exports, "sentenceCase", () => $672f521dcd55ced4$export$da1ec1d734312f9f);
$parcel$export(module.exports, "stripIndent", () => $672f521dcd55ced4$export$e0438862fe5d08f1);
function $672f521dcd55ced4$export$348afa8c9ff47183(str) {
    return str?.toLowerCase().replace(/\b(\w)/g, (s)=>s.toUpperCase());
}
function $672f521dcd55ced4$export$da1ec1d734312f9f(str) {
    return str.replace(/(^\s*\w|[.!?]\s*\w)/g, (c)=>c.toUpperCase());
}
function $672f521dcd55ced4$export$e0438862fe5d08f1(str) {
    const indent = $672f521dcd55ced4$export$740af0672d164065(str);
    if (indent === 0) return str;
    const regex = new RegExp(`^[ \\t]{${indent}}`, "gm");
    return str.replace(regex, "");
}
function $672f521dcd55ced4$export$740af0672d164065(str) {
    const match = str.match(/^[ \t]*(?=\S)/gm);
    if (!match) return 0;
    return match.reduce((r, a)=>Math.min(r, a.length), Infinity);
}

});


parcelRegister("8yT7q", function(module, exports) {

$parcel$export(module.exports, "routes", () => $12b24101c0f26c07$export$66b32f6f30eb4b4);
$parcel$export(module.exports, "flinkUiRoute", () => $12b24101c0f26c07$export$b1b92c5e9c0f3727);
$parcel$export(module.exports, "PipelinesApiProvider", () => (parcelRequire("eUGW8")).PipelinesApiProvider);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $5YTEB = parcelRequire("5YTEB");
var $57CDS = parcelRequire("57CDS");
parcelRequire("iT8Wb");
var $eUGW8 = parcelRequire("eUGW8");

const $12b24101c0f26c07$var$LazyPipelinesListPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("67tWN")));

const $12b24101c0f26c07$var$LazyPipelineDetailsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("cpk6f")));

const $12b24101c0f26c07$var$LazyPipelineCreatePage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("14VAx")));

const $12b24101c0f26c07$var$LazyPipelineUploadPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("26Ycs")));

const $12b24101c0f26c07$var$LazyFlinkController = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("fb8DO")));
const $12b24101c0f26c07$export$66b32f6f30eb4b4 = /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $2T9xh.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
            index: true,
            element: /*#__PURE__*/ (0, $2T9xh.jsx)($12b24101c0f26c07$var$LazyPipelinesListPage, {})
        }),
        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
            path: ":pipelineId",
            element: /*#__PURE__*/ (0, $2T9xh.jsx)($12b24101c0f26c07$var$LazyPipelineDetailsPage, {})
        }),
        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
            path: "create",
            element: /*#__PURE__*/ (0, $2T9xh.jsx)($12b24101c0f26c07$var$PipelineCreation, {})
        })
    ]
});
const $12b24101c0f26c07$export$b1b92c5e9c0f3727 = /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
    path: ":pipelineId/flink/ui",
    element: /*#__PURE__*/ (0, $2T9xh.jsx)($12b24101c0f26c07$var$LazyFlinkController, {})
});
// Pick pipeline creation flow based on type query param (defaults to SQL flow)
function $12b24101c0f26c07$var$PipelineCreation() {
    const [searchParams] = (0, $57CDS.useSearchParams)();
    const type = (0, $aOzEm.useMemo)(()=>searchParams.get("type"), []);
    if (type === "custom") return /*#__PURE__*/ (0, $2T9xh.jsx)($12b24101c0f26c07$var$LazyPipelineUploadPage, {});
    return /*#__PURE__*/ (0, $2T9xh.jsx)($12b24101c0f26c07$var$LazyPipelineCreatePage, {});
}

});
parcelRegister("iT8Wb", function(module, exports) {
$parcel$export(module.exports, "PipelinesApiProvider", () => (parcelRequire("eUGW8")).PipelinesApiProvider);
$parcel$export(module.exports, "usePipelinesApi", () => (parcelRequire("eUGW8")).usePipelinesApi);
$parcel$export(module.exports, "usePipelinesDataApi", () => (parcelRequire("eUGW8")).usePipelinesDataApi);
$parcel$export(module.exports, "FilesApiProvider", () => (parcelRequire("aJgK7")).FilesApiProvider);
parcelRequire("eUGW8");
parcelRequire("aJgK7");

});
parcelRegister("eUGW8", function(module, exports) {

$parcel$export(module.exports, "PipelinesApiProvider", () => $63c96d3036aa1f8b$export$970c1d6648279e8a);
$parcel$export(module.exports, "usePipelinesApi", () => $63c96d3036aa1f8b$export$c989620a5f9702bd);
$parcel$export(module.exports, "usePipelinesDataApi", () => $63c96d3036aa1f8b$export$b296e8ee37c6717c);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $hJHPU = parcelRequire("hJHPU");

var $ek6Yt = parcelRequire("ek6Yt");

var $k5KQ6 = parcelRequire("k5KQ6");

var $cXYct = parcelRequire("cXYct");
const $63c96d3036aa1f8b$export$be91bb2aa3e12393 = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $63c96d3036aa1f8b$export$970c1d6648279e8a({ children: children = null }) {
    const fetch = (0, $hJHPU.useAccountScopedFetch)();
    const service = (0, $aOzEm.useMemo)(()=>fetch && new (0, $ek6Yt.PipelinesService)(fetch), [
        fetch
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($63c96d3036aa1f8b$export$be91bb2aa3e12393.Provider, {
        value: service,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)($63c96d3036aa1f8b$export$9f775453dbf1e572, {
            children: children
        })
    });
}
function $63c96d3036aa1f8b$export$c989620a5f9702bd() {
    return (0, $aOzEm.useContext)($63c96d3036aa1f8b$export$be91bb2aa3e12393);
}
const $63c96d3036aa1f8b$export$1f796bca1057d1e = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $63c96d3036aa1f8b$export$9f775453dbf1e572({ children: children }) {
    const dataPlaneClient = (0, $k5KQ6.useDataPlaneClient)();
    const service = (0, $aOzEm.useMemo)(async ()=>new (0, (/*@__PURE__*/$parcel$interopDefault($cXYct)))({
            client: await dataPlaneClient
        }), [
        dataPlaneClient
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($63c96d3036aa1f8b$export$1f796bca1057d1e.Provider, {
        value: service,
        children: children
    });
}
function $63c96d3036aa1f8b$export$b296e8ee37c6717c() {
    return (0, $aOzEm.useContext)($63c96d3036aa1f8b$export$1f796bca1057d1e);
}

});

parcelRegister("aJgK7", function(module, exports) {

$parcel$export(module.exports, "FilesApiProvider", () => $5d20098ece393ed3$export$c085eef2e30349bd);
$parcel$export(module.exports, "useFileApi", () => $5d20098ece393ed3$export$925c76fde27f16eb);
$parcel$export(module.exports, "useFileDataApi", () => $5d20098ece393ed3$export$93b10c6ebbe3941f);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $ek6Yt = parcelRequire("ek6Yt");

var $hJHPU = parcelRequire("hJHPU");

var $k5KQ6 = parcelRequire("k5KQ6");
const $5d20098ece393ed3$export$c445e2c0f7527aef = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $5d20098ece393ed3$export$c085eef2e30349bd({ children: children = null }) {
    const fetch = (0, $hJHPU.useAccountScopedFetch)();
    const service = (0, $aOzEm.useMemo)(()=>fetch && new (0, $ek6Yt.FileService)(fetch), [
        fetch
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($5d20098ece393ed3$export$c445e2c0f7527aef.Provider, {
        value: service,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)($5d20098ece393ed3$export$d88cf685b6553565, {
            children: children
        })
    });
}
function $5d20098ece393ed3$export$925c76fde27f16eb() {
    return (0, $aOzEm.useContext)($5d20098ece393ed3$export$c445e2c0f7527aef);
}
const $5d20098ece393ed3$export$4d202b88a25fe109 = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $5d20098ece393ed3$export$d88cf685b6553565({ children: children }) {
    const dataPlaneClient = (0, $k5KQ6.useDataPlaneClient)();
    const service = (0, $aOzEm.useMemo)(async ()=>new (0, $ek6Yt.FileDataService)({
            client: await dataPlaneClient
        }), [
        dataPlaneClient
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($5d20098ece393ed3$export$4d202b88a25fe109.Provider, {
        value: service,
        children: children
    });
}
function $5d20098ece393ed3$export$93b10c6ebbe3941f() {
    return (0, $aOzEm.useContext)($5d20098ece393ed3$export$4d202b88a25fe109);
}

});


parcelRegister("67tWN", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("gQdJ7"),
    $foscK("jU2Od"),
    $foscK("ddopL"),
    $foscK("7V5iC"),
    $foscK("jmeps"),
    $foscK("dx9bh"),
    $foscK("fDgWP"),
    $foscK("jCVeS"),
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("fNb6i")
]).then(()=>parcelRequire("4i4ah"));

});

parcelRegister("cpk6f", function(module, exports) {

var $foscK = parcelRequire("foscK");


module.exports = Promise.all([
    (parcelRequire("gVtzA"))((parcelRequire("3Dw4r")).resolve("jQ4um")),
    $foscK("jVtCN"),
    $foscK("4hTiD"),
    $foscK("94zE7"),
    $foscK("fgx4Y"),
    $foscK("8cyRS"),
    $foscK("laLtR"),
    $foscK("cCFzf"),
    $foscK("gQdJ7"),
    $foscK("jU2Od"),
    $foscK("ddopL"),
    $foscK("7V5iC"),
    $foscK("jmeps"),
    $foscK("dx9bh"),
    $foscK("fDgWP"),
    $foscK("jCVeS"),
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("fNb6i"),
    $foscK("6Uvz0")
]).then(()=>parcelRequire("avWDg"));

});

parcelRegister("14VAx", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("4hTiD"),
    $foscK("94zE7"),
    $foscK("6LPy3"),
    $foscK("ddopL"),
    $foscK("jmeps"),
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("kMfS5"),
    $foscK("cKrup")
]).then(()=>parcelRequire("7A61A"));

});

parcelRegister("26Ycs", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("jVtCN"),
    $foscK("6LPy3"),
    $foscK("jU2Od"),
    $foscK("7V5iC"),
    $foscK("jmeps"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("kMfS5"),
    $foscK("bUwzS")
]).then(()=>parcelRequire("85Jwr"));

});

parcelRegister("fb8DO", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("6LPy3"),
    $foscK("jU2Od"),
    $foscK("b6yfN")
]).then(()=>parcelRequire("1eU0G"));

});


parcelRegister("PLN39", function(module, exports) {

$parcel$export(module.exports, "routes", () => $b822fa744237dd8c$export$66b32f6f30eb4b4);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $5YTEB = parcelRequire("5YTEB");

const $b822fa744237dd8c$var$LazySecretsListPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("8SbOR")));
const $b822fa744237dd8c$export$66b32f6f30eb4b4 = /*#__PURE__*/ (0, $2T9xh.jsx)((0, $2T9xh.Fragment), {
    children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
        index: true,
        element: /*#__PURE__*/ (0, $2T9xh.jsx)($b822fa744237dd8c$var$LazySecretsListPage, {})
    })
});

});
parcelRegister("8SbOR", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("gQdJ7"),
    $foscK("7V5iC"),
    $foscK("fDgWP"),
    $foscK("jCVeS"),
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("5zrDU")
]).then(()=>parcelRequire("9kg3A"));

});


parcelRegister("7SDUa", function(module, exports) {

$parcel$export(module.exports, "routes", () => $318b44f8a0599962$export$66b32f6f30eb4b4);
$parcel$export(module.exports, "StreamsApiProvider", () => (parcelRequire("fsqth")).StreamsApiProvider);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $5YTEB = parcelRequire("5YTEB");

var $fsqth = parcelRequire("fsqth");

const $318b44f8a0599962$var$LazyStreamsListPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("fAziY")));

const $318b44f8a0599962$var$LazyStreamDetailsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("lVCde")));

const $318b44f8a0599962$var$LazyStreamCreatePage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("fKNlk")));
const $318b44f8a0599962$export$66b32f6f30eb4b4 = /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $2T9xh.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
            index: true,
            element: /*#__PURE__*/ (0, $2T9xh.jsx)($318b44f8a0599962$var$LazyStreamsListPage, {})
        }),
        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
            path: "create",
            element: /*#__PURE__*/ (0, $2T9xh.jsx)($318b44f8a0599962$var$LazyStreamCreatePage, {})
        }),
        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
            path: ":streamId",
            element: /*#__PURE__*/ (0, $2T9xh.jsx)($318b44f8a0599962$var$LazyStreamDetailsPage, {})
        })
    ]
});

});
parcelRegister("fsqth", function(module, exports) {

$parcel$export(module.exports, "StreamsApiProvider", () => $72e6e8e78175270d$export$5a3981c437e158fd);
$parcel$export(module.exports, "useStreamsApi", () => $72e6e8e78175270d$export$fc1d8e81094dd9);
$parcel$export(module.exports, "useStreamsDataApi", () => $72e6e8e78175270d$export$9b194f6d431c15ec);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $hJHPU = parcelRequire("hJHPU");

var $ek6Yt = parcelRequire("ek6Yt");

var $k5KQ6 = parcelRequire("k5KQ6");
const $72e6e8e78175270d$export$e2a43ea8a5827e8c = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $72e6e8e78175270d$export$5a3981c437e158fd({ children: children = null }) {
    const fetch = (0, $hJHPU.useAccountScopedFetch)();
    const service = (0, $aOzEm.useMemo)(()=>fetch && new (0, $ek6Yt.StreamsService)(fetch), [
        fetch
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($72e6e8e78175270d$export$e2a43ea8a5827e8c.Provider, {
        value: service,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)($72e6e8e78175270d$export$4347900301b4d6c9, {
            children: children
        })
    });
}
function $72e6e8e78175270d$export$fc1d8e81094dd9() {
    return (0, $aOzEm.useContext)($72e6e8e78175270d$export$e2a43ea8a5827e8c);
}
const $72e6e8e78175270d$export$d9de599317e751c8 = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $72e6e8e78175270d$export$4347900301b4d6c9({ children: children }) {
    const dataPlaneClient = (0, $k5KQ6.useDataPlaneClient)();
    const service = (0, $aOzEm.useMemo)(async ()=>{
        return new (0, $ek6Yt.StreamsDataService)({
            client: await dataPlaneClient
        });
    }, [
        dataPlaneClient
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($72e6e8e78175270d$export$d9de599317e751c8.Provider, {
        value: service,
        children: children
    });
}
function $72e6e8e78175270d$export$9b194f6d431c15ec() {
    return (0, $aOzEm.useContext)($72e6e8e78175270d$export$d9de599317e751c8);
}

});

parcelRegister("fAziY", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("gQdJ7"),
    $foscK("fDgWP"),
    $foscK("jCVeS"),
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("dZozR")
]).then(()=>parcelRequire("kEyPK"));

});

parcelRegister("lVCde", function(module, exports) {

var $foscK = parcelRequire("foscK");


module.exports = Promise.all([
    (parcelRequire("gVtzA"))((parcelRequire("3Dw4r")).resolve("ayC1k")),
    $foscK("4hTiD"),
    $foscK("fgx4Y"),
    $foscK("laLtR"),
    $foscK("jU2Od"),
    $foscK("ddopL"),
    $foscK("7V5iC"),
    $foscK("jmeps"),
    $foscK("dx9bh"),
    $foscK("fDgWP"),
    $foscK("jCVeS"),
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("cjAq1")
]).then(()=>parcelRequire("7A1R0"));

});

parcelRegister("fKNlk", function(module, exports) {

var $foscK = parcelRequire("foscK");


module.exports = Promise.all([
    (parcelRequire("gVtzA"))((parcelRequire("3Dw4r")).resolve("ayC1k")),
    $foscK("4hTiD"),
    $foscK("fgx4Y"),
    $foscK("laLtR"),
    $foscK("jU2Od"),
    $foscK("ddopL"),
    $foscK("7V5iC"),
    $foscK("jmeps"),
    $foscK("dx9bh"),
    $foscK("fDgWP"),
    $foscK("jCVeS"),
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("cjAq1"),
    $foscK("7Zcl7")
]).then(()=>parcelRequire("fO33W"));

});


parcelRegister("4vrHF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef859133a3ef1b25$export$2e2bcd8739ae039);

var $2T9xh = parcelRequire("2T9xh");
parcelRequire("aOzEm");

var $8aalP = parcelRequire("8aalP");
var $h0mm1 = parcelRequire("h0mm1");
var $gvXbM = parcelRequire("gvXbM");

var $2Y85r = parcelRequire("2Y85r");
function $ef859133a3ef1b25$export$2e2bcd8739ae039({ title: title, message: message, actions: actions = null }) {
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8aalP.default), {
        sx: {
            display: "grid",
            placeItems: "center",
            padding: 6
        },
        children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Y85r))), {
            children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $h0mm1.default), {
                sx: {
                    width: "auto"
                },
                children: /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $gvXbM.default), {
                    alignItems: "center",
                    spacing: 3,
                    padding: 3,
                    children: [
                        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8aalP.default), {
                            component: "h1",
                            sx: {
                                fontSize: "2em",
                                fontWeight: "700",
                                margin: 0
                            },
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8aalP.default), {
                            component: "p",
                            sx: {
                                color: "text.secondary"
                            },
                            children: message
                        }),
                        actions && /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8aalP.default), {
                            children: actions
                        })
                    ]
                })
            })
        })
    });
}

});
parcelRegister("2Y85r", function(module, exports) {
"use strict";
var $2297753a6a72158c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Rectangle = module.exports.useTramlineContext = module.exports.TramlineSequence = module.exports.TramlineContext = void 0;

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

const $2297753a6a72158c$var$Box_1 = $2297753a6a72158c$var$__importDefault((parcelRequire("gBqWC")));
const $2297753a6a72158c$var$green = "#44E1BC";
const $2297753a6a72158c$var$blue = "#2F74F980";
const $2297753a6a72158c$var$colors = [
    $2297753a6a72158c$var$green,
    $2297753a6a72158c$var$blue
];
function $2297753a6a72158c$var$newLayout(params) {
    return {
        top: Object.assign({
            top: "-24px",
            height: "100px"
        }, params === null || params === void 0 ? void 0 : params.top),
        bottom: Object.assign({
            bottom: "-24px",
            height: "100px"
        }, params === null || params === void 0 ? void 0 : params.bottom)
    };
}
const $2297753a6a72158c$var$layouts = [
    // Vertical
    $2297753a6a72158c$var$newLayout({
        top: {
            width: "80%",
            left: "15%"
        },
        bottom: {
            width: "30%",
            left: "5%"
        }
    }),
    $2297753a6a72158c$var$newLayout({
        top: {
            width: "40%",
            left: "10%"
        },
        bottom: {
            width: "80%",
            left: "15%"
        }
    }),
    // Diagonal
    $2297753a6a72158c$var$newLayout({
        top: {
            width: "60%",
            height: "120px",
            left: "-24px"
        },
        bottom: {
            width: "50%",
            height: "160px",
            left: "calc(50% + 24px)"
        }
    }),
    $2297753a6a72158c$var$newLayout({
        top: {
            width: "40%",
            height: "100px",
            left: "calc(60% + 24px)"
        },
        bottom: {
            height: "200px",
            width: "50%",
            left: "-24px"
        }
    }),
    // Horizontal
    $2297753a6a72158c$var$newLayout({
        top: {
            top: "20%",
            height: "75%",
            left: "-24px",
            width: "48px"
        },
        bottom: {
            bottom: "30%",
            height: "60%",
            left: "calc(100% - 24px)",
            width: "48px"
        }
    }),
    $2297753a6a72158c$var$newLayout({
        top: {
            top: "20%",
            height: "60%",
            left: "-24px",
            width: "48px"
        },
        bottom: {
            bottom: "10%",
            height: "80%",
            left: "calc(100% - 120px + 24px)",
            width: "120px"
        }
    })
];
module.exports.TramlineContext = (0, $aOzEm.createContext)(null);
function $2297753a6a72158c$var$randomLayout() {
    let nextLayout;
    do nextLayout = $2297753a6a72158c$var$layouts[Math.floor(Math.random() * $2297753a6a72158c$var$layouts.length)];
    while (nextLayout == $2297753a6a72158c$var$randomLayout.last);
    $2297753a6a72158c$var$randomLayout.last = nextLayout;
    return $2297753a6a72158c$var$randomLayout.last;
}
$2297753a6a72158c$var$randomLayout.last = null;
function $2297753a6a72158c$var$randomColors() {
    return Math.random() >= 0.5 ? $2297753a6a72158c$var$colors : [
        $2297753a6a72158c$var$colors[1],
        $2297753a6a72158c$var$colors[0]
    ];
}
// Provides a stable selection of tramline layout & color selection for each "view".
// Intended for multi-step dialogs (e.g. the connection create flow), to maintain
// a stable appearance while the user is within the flow.
function $2297753a6a72158c$var$TramlineSequence({ view: view, children: children }) {
    const colors = (0, $aOzEm.useMemo)(()=>$2297753a6a72158c$var$randomColors(), []);
    const startLayout = (0, $aOzEm.useMemo)(()=>$2297753a6a72158c$var$randomLayout(), []);
    // Store generated layouts in a map, starting with the first step
    const sequenceRef = (0, $aOzEm.useRef)({
        [view]: {
            layout: startLayout,
            colors: colors
        }
    });
    // Generate a new layout if this is the first time we've seen this step
    if (!sequenceRef.current[view]) sequenceRef.current[view] = {
        layout: $2297753a6a72158c$var$randomLayout(),
        colors: $2297753a6a72158c$var$randomColors()
    };
    return (0, $2T9xh.jsx)(module.exports.TramlineContext.Provider, Object.assign({
        value: sequenceRef.current[view]
    }, {
        children: children
    }));
}
module.exports.TramlineSequence = $2297753a6a72158c$var$TramlineSequence;
function $2297753a6a72158c$var$useTramlineContext() {
    const ctx = (0, $aOzEm.useContext)(module.exports.TramlineContext);
    // If there is nothing provided by a parent,
    // we return a randomly selected - but stable -
    // layout and color palette.
    const defaultCtx = (0, $aOzEm.useMemo)(()=>({
            layout: $2297753a6a72158c$var$randomLayout(),
            colors: $2297753a6a72158c$var$randomColors()
        }), []);
    return ctx || defaultCtx;
}
module.exports.useTramlineContext = $2297753a6a72158c$var$useTramlineContext;
function $2297753a6a72158c$var$Rectangle(props) {
    const { borderWidth: borderWidth = "4px", borderColor: borderColor, style: style } = props;
    return (0, $2T9xh.jsx)("div", {
        style: Object.assign({
            width: `calc(100% - 2 * ${borderWidth})`,
            height: `calc(100% - 2 * ${borderWidth})`,
            borderColor: borderColor,
            borderStyle: "solid",
            borderWidth: 4,
            borderRadius: 10,
            opacity: 0.5
        }, style)
    });
}
module.exports.Rectangle = $2297753a6a72158c$var$Rectangle;
function $2297753a6a72158c$var$Tramlines({ children: children }) {
    const { layout: layout, colors: colors } = $2297753a6a72158c$var$useTramlineContext();
    return (0, $2T9xh.jsxs)($2297753a6a72158c$var$Box_1.default, Object.assign({
        sx: {
            position: "relative",
            marginY: "4ch"
        }
    }, {
        children: [
            (0, $2T9xh.jsx)($2297753a6a72158c$var$Rectangle, {
                style: {
                    position: "absolute",
                    height: layout.top.height,
                    width: layout.top.width,
                    left: layout.top.left,
                    top: layout.top.top
                },
                borderColor: colors[0]
            }),
            (0, $2T9xh.jsx)($2297753a6a72158c$var$Rectangle, {
                style: {
                    position: "absolute",
                    height: layout.bottom.height,
                    width: layout.bottom.width,
                    left: layout.bottom.left,
                    bottom: layout.bottom.bottom
                },
                borderColor: colors[1]
            }),
            (0, $2T9xh.jsx)($2297753a6a72158c$var$Box_1.default, Object.assign({
                sx: {
                    position: "relative"
                }
            }, {
                children: children
            }))
        ]
    }));
}
module.exports.default = $2297753a6a72158c$var$Tramlines;

});


parcelRegister("37RpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eed15fc05d0821$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useGtag", () => $96eed15fc05d0821$export$6df448fd86e7bbda);
$parcel$export(module.exports, "GTagUserTracker", () => $96eed15fc05d0821$export$ca1b29216524edcc);
$parcel$export(module.exports, "GTagAccountTracker", () => $96eed15fc05d0821$export$217c153a00c9ea8a);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $1M3WI = parcelRequire("1M3WI");

var $gga7I = parcelRequire("gga7I");
window.dataLayer = window.dataLayer || [];
function $96eed15fc05d0821$var$gtag(data) {
    window.dataLayer.push(data);
}
const $96eed15fc05d0821$var$GTagContext = /*#__PURE__*/ (0, $aOzEm.createContext)($96eed15fc05d0821$var$gtag);
function $96eed15fc05d0821$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2T9xh.jsx)($96eed15fc05d0821$var$GTagContext.Provider, {
        value: $96eed15fc05d0821$var$gtag,
        children: children
    });
}
function $96eed15fc05d0821$export$6df448fd86e7bbda() {
    return (0, $aOzEm.useContext)($96eed15fc05d0821$var$GTagContext);
}
// Note: Variables are persistent, and must be explicitly cleared when no longer valid.
// For this purpose, we issue reset messages to clear data on certain events.
const $96eed15fc05d0821$var$userContextReset = {
    user_id: undefined
};
const $96eed15fc05d0821$var$accountContextReset = {
    account_name: undefined,
    plan: undefined
};
function $96eed15fc05d0821$export$ca1b29216524edcc({}) {
    const gtag = $96eed15fc05d0821$export$6df448fd86e7bbda();
    const { jwt: jwt } = (0, $1M3WI.useAuth)();
    (0, $aOzEm.useEffect)(()=>{
        if (jwt) {
            if (jwt?.sub) gtag({
                user_id: jwt.sub
            });
            // NB: The concerns are somewhat mixed here.
            // The account context tracker must render under an account-scoped route
            // to retrieve the active account information. This means it won't be
            // around to track sign outs. Here, we detect when the JWT has no org_id,
            // and then clear the account context.
            if (!jwt?.org_id) gtag($96eed15fc05d0821$var$accountContextReset);
        } else // If the user is not logged in at all, clear all user & account info.
        gtag({
            ...$96eed15fc05d0821$var$userContextReset,
            ...$96eed15fc05d0821$var$accountContextReset
        });
    }, [
        jwt
    ]);
    return null;
}
function $96eed15fc05d0821$export$217c153a00c9ea8a({}) {
    const gtag = $96eed15fc05d0821$export$6df448fd86e7bbda();
    const { activeAccount: activeAccount, accountInfo: accountInfo } = (0, $gga7I.useActiveAccount)();
    (0, $aOzEm.useEffect)(()=>{
        if (activeAccount && accountInfo) {
            const context = {
                account_name: activeAccount.name,
                plan: accountInfo.subscription?.plan_id
            };
            gtag(context);
        }
    }, [
        activeAccount,
        accountInfo
    ]);
    return null;
}

});

parcelRegister("eYBPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9a3a8834d124b5f$export$2e2bcd8739ae039);

var $2T9xh = parcelRequire("2T9xh");
parcelRequire("aOzEm");

var $bfLP6 = parcelRequire("bfLP6");

var $79J0f = parcelRequire("79J0f");

var $bteot = parcelRequire("bteot");

var $gga7I = parcelRequire("gga7I");
function $e9a3a8834d124b5f$export$2e2bcd8739ae039({ text: text = "Go home" }) {
    const Link = (0, $bteot.useLink)();
    const { activeAccount: activeAccount } = (0, $gga7I.useActiveAccount)();
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $bfLP6.default), {
        component: Link,
        href: `/${activeAccount?.name ?? ""}`,
        variant: "contained",
        color: "primary",
        children: [
            text,
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $79J0f.default), {
                sx: {
                    marginLeft: 1,
                    fontSize: "1.5em"
                }
            })
        ]
    });
}

});
parcelRegister("79J0f", function(module, exports) {

$parcel$export(module.exports, "default", () => $535c4852c1c5cdc5$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $535c4852c1c5cdc5$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
}), "Link");

});


parcelRegister("eTQRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c335c2c385dd78b8$export$2e2bcd8739ae039);

var $2T9xh = parcelRequire("2T9xh");

var $8Rfza = parcelRequire("8Rfza");

var $5YTEB = parcelRequire("5YTEB");
var // This page is used as a target from the corp site, to allowing sending users
// to the app & initiating login immediately - if required. Once logged in,
// we simply redirect them to the root, replacing the login history entry.
$c335c2c385dd78b8$export$2e2bcd8739ae039 = (0, $8Rfza.withAuthenticationRequired)(()=>/*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Navigate), {
        to: "/",
        replace: true
    }));

});

parcelRegister("6xMPx", function(module, exports) {

$parcel$export(module.exports, "RouterLinkAdapter", () => $279e0f55033b638c$export$5d4020811d4db563);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $57CDS = parcelRequire("57CDS");

var $8aalP = parcelRequire("8aalP");
const $279e0f55033b638c$export$5d4020811d4db563 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).forwardRef(function RouterLinkAdapter({ href: href, ...rest }, ref) {
    if (!href) // React router's Link gets cranky without an href, and throws.
    // If there is no href to translate to the link, just use a div.
    // The navigation will of course not work - like any other link
    // without an href - but at least it will render correctly and not
    // break the page.
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8aalP.default), {
        component: "span",
        ref: ref,
        ...rest
    });
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $57CDS.Link), {
        ref: ref,
        to: href,
        ...rest
    });
});

});

parcelRegister("fzMi1", function(module, exports) {

$parcel$export(module.exports, "default", () => $760068936ef23a49$export$2e2bcd8739ae039);

var $2T9xh = parcelRequire("2T9xh");

var $8Rfza = parcelRequire("8Rfza");

var $4vrHF = parcelRequire("4vrHF");

var $8iH6y = parcelRequire("8iH6y");

var $bfLP6 = parcelRequire("bfLP6");

var $fJQtg = parcelRequire("fJQtg");
function $760068936ef23a49$export$2e2bcd8739ae039() {
    const { error: error, isLoading: isLoading, loginWithRedirect: loginWithRedirect } = (0, $8Rfza.useAuth0)();
    if (isLoading) return null;
    let title = "Something went wrong";
    let message = error.message;
    let prompt = "login";
    let cta = "Sign in";
    const messageKeys = Object.keys((0, $fJQtg.messages));
    for(let i = 0; i < messageKeys.length; i++){
        const strategy = (0, $fJQtg.messages)[messageKeys[i]](error);
        if (strategy.isError) {
            title = strategy.title;
            message = strategy.message;
            prompt = strategy.prompt;
            cta = strategy.cta;
            break;
        }
    }
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $2T9xh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8iH6y.default), {}),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $4vrHF.default), {
                title: title,
                message: /*#__PURE__*/ (0, $2T9xh.jsx)("span", {
                    children: message
                }),
                actions: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $bfLP6.default), {
                    color: "primary",
                    variant: "contained",
                    onClick: ()=>loginWithRedirect({
                            authorizationParams: {
                                prompt: prompt
                            }
                        }),
                    children: cta
                })
            })
        ]
    });
}

});
parcelRegister("fJQtg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c93710e0335c75e5$export$defe85febe8b728c);
const $c93710e0335c75e5$export$defe85febe8b728c = {
    verifyEmail: (error)=>({
            isError: error.message.toLocaleLowerCase().includes("verify your email"),
            title: "Email has been sent",
            message: "Check your email to verify your account before signing in.",
            cta: "Sign in",
            prompt: "login"
        }),
    passwordExpired: (error)=>({
            isError: error.message.toLocaleLowerCase().includes("password has expired"),
            title: "Your password has expired",
            message: "To reset your password proceed to the login screen, enter you email, click 'Continue', then click 'Forgot Password'.",
            cta: "Log in",
            prompt: "login"
        }),
    invalidState: (error)=>({
            isError: error.message.toLocaleLowerCase().includes("invalid state"),
            title: "Something went wrong",
            message: "Sign in again to access decodable",
            cta: "Sign in",
            prompt: "login"
        })
};

});


parcelRegister("yaNWN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "featureFlagDefaults", () => $8649a14295785543$export$251432ec023dcc78);
$parcel$export(module.exports, "standardCellOverrides", () => $8649a14295785543$export$c469aaddc40966ab);
$parcel$export(module.exports, "ExperimentsContext", () => $8649a14295785543$export$a03aa6b5108870a7);
$parcel$export(module.exports, "ExperimentsProvider", () => $8649a14295785543$export$f07850a925b63a2c);
$parcel$export(module.exports, "useFeatureFlags", () => $8649a14295785543$export$90335b3ff08f335);
$parcel$export(module.exports, "default", () => $8649a14295785543$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ExperimentsPage", () => $8649a14295785543$export$8cba47d010185de7);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $h0mm1 = parcelRequire("h0mm1");

var $4vFml = parcelRequire("4vFml");

var $5mWC6 = parcelRequire("5mWC6");

var $7OQOe = parcelRequire("7OQOe");

var $2oTOI = parcelRequire("2oTOI");


var $gga7I = parcelRequire("gga7I");
const $8649a14295785543$var$isLocal = window?.location?.origin.startsWith("http://localhost:");
const $8649a14295785543$export$251432ec023dcc78 = {
    sqlAutocomplete: false,
    dataPlaneAPIs: true,
    dataPlaneApiBaseUrl: "",
    intercom: true,
    msc: true,
    lineage: true
};
const $8649a14295785543$export$c469aaddc40966ab = {
    // cell=1 group=prod cloud=aws region=us-west-2
    1: {},
    // cell=2 group=prod cloud=aws region=us-east-1
    2: {},
    // cell=7 group=prod cloud=aws region=us-west-2
    7: {},
    // cell=12 group=prod cloud=aws region=us-east-1
    12: {},
    // cell=15 group=prod cloud=aws region=eu-central-1
    15: {},
    // cell=17 group=prod cloud=aws region=us-west-2
    17: {},
    // cell=19 group=prod cloud=aws region=ap-southeast-2
    19: {},
    // Dev Cells that have the edges view
    5: {},
    16: {},
    10: {},
    14: {}
};
function $8649a14295785543$var$useFlagsForCurrentCell({ cellOverrides: cellOverrides, globalDefaults: globalDefaults }) {
    const { activeAccount: activeAccount } = (0, $gga7I.useActiveAccount)();
    const cellDefaults = (0, $aOzEm.useMemo)(()=>{
        try {
            if (!activeAccount) return globalDefaults;
            return {
                ...globalDefaults,
                ...cellOverrides[parseInt(activeAccount.cell)]
            };
        } catch (ex) {
            console.error("Failed to load per-cell flag overrides. Using the defaults.", ex);
            return globalDefaults;
        }
    }, [
        activeAccount
    ]);
    return cellDefaults;
}
const $8649a14295785543$export$a03aa6b5108870a7 = /*#__PURE__*/ (0, $aOzEm.createContext)({
    flags: $8649a14295785543$export$251432ec023dcc78,
    setFlag: ()=>{}
});
function $8649a14295785543$export$f07850a925b63a2c({ globalDefaults: globalDefaults = $8649a14295785543$export$251432ec023dcc78, cellOverrides: cellOverrides = $8649a14295785543$export$c469aaddc40966ab, children: children }) {
    const cellFlags = $8649a14295785543$var$useFlagsForCurrentCell({
        cellOverrides: cellOverrides,
        globalDefaults: globalDefaults
    });
    const [sessionFlags, setSessionExperiments] = (0, $aOzEm.useState)(()=>sessionStorage.experiments ? JSON.parse(sessionStorage.experiments) : null);
    const effectiveFlags = sessionFlags ?? cellFlags ?? $8649a14295785543$export$251432ec023dcc78;
    const setFlag = (name, value)=>{
        const updated = {
            ...effectiveFlags,
            [name]: value
        };
        sessionStorage.experiments = JSON.stringify(updated);
        setSessionExperiments(updated);
    };
    return /*#__PURE__*/ (0, $2T9xh.jsx)($8649a14295785543$export$a03aa6b5108870a7.Provider, {
        value: {
            flags: effectiveFlags,
            setFlag: setFlag
        },
        children: children
    });
}
function $8649a14295785543$export$90335b3ff08f335() {
    const ctx = (0, $aOzEm.useContext)($8649a14295785543$export$a03aa6b5108870a7);
    if (ctx == null) return {
        flags: $8649a14295785543$export$251432ec023dcc78,
        setFlag: ()=>{
            throw new Error("cannot setFlag outside of an ExperimentsProvider!");
        }
    };
    return ctx;
}
var $8649a14295785543$export$2e2bcd8739ae039 = $8649a14295785543$export$8cba47d010185de7;
function $8649a14295785543$export$8cba47d010185de7() {
    const { flags: flags, setFlag: setFlag } = $8649a14295785543$export$90335b3ff08f335();
    const changeHandler = (flagName)=>(val)=>setFlag(flagName, val);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $2T9xh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7OQOe))), {
                anonymous: true
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2oTOI))), {
                children: /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $h0mm1.default), {
                    sx: {
                        padding: 3,
                        display: "flex",
                        flexDirection: "column"
                    },
                    children: [
                        /*#__PURE__*/ (0, $2T9xh.jsx)($8649a14295785543$var$Flag, {
                            label: "Enable Data Plane APIs",
                            value: !!flags?.dataPlaneAPIs,
                            onChange: changeHandler("dataPlaneAPIs")
                        }),
                        null,
                        /*#__PURE__*/ (0, $2T9xh.jsx)($8649a14295785543$var$Flag, {
                            label: "Enable SQL autocomplete",
                            value: !!flags?.sqlAutocomplete,
                            onChange: changeHandler("sqlAutocomplete")
                        }),
                        /*#__PURE__*/ (0, $2T9xh.jsx)($8649a14295785543$var$Flag, {
                            label: "Enable Intercom",
                            value: !!flags?.intercom,
                            onChange: changeHandler("intercom")
                        }),
                        /*#__PURE__*/ (0, $2T9xh.jsx)($8649a14295785543$var$Flag, {
                            label: "Enable MSC creation/update",
                            value: !!flags?.msc,
                            onChange: changeHandler("msc")
                        }),
                        /*#__PURE__*/ (0, $2T9xh.jsx)($8649a14295785543$var$Flag, {
                            label: "Enable lineage",
                            value: !!flags?.lineage,
                            onChange: changeHandler("lineage")
                        })
                    ]
                })
            })
        ]
    });
}
function $8649a14295785543$var$Flag({ label: label, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5mWC6.default), {
        control: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $4vFml.default), {
            checked: value,
            onChange: ()=>onChange(!value)
        }),
        label: label
    });
}

});
parcelRegister("4vFml", function(module, exports) {

$parcel$export(module.exports, "default", () => $348a23c9f66f2bb0$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");


var $b2r0b = parcelRequire("b2r0b");

var $fOENh = parcelRequire("fOENh");

var $1UXum = parcelRequire("1UXum");

var $74g3b = parcelRequire("74g3b");

var $fcvjR = parcelRequire("fcvjR");

var $bT7FR = parcelRequire("bT7FR");

var $63Oo6 = parcelRequire("63Oo6");

var $gEb5G = parcelRequire("gEb5G");

var $25zst = parcelRequire("25zst");

var $7hIGm = parcelRequire("7hIGm");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $348a23c9f66f2bb0$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $348a23c9f66f2bb0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $63Oo6.default)(color)}`,
            `size${(0, $63Oo6.default)(size)}`
        ]
    };
    const composedClasses = (0, $b2r0b.default)(slots, (0, $7hIGm.getCheckboxUtilityClass), classes);
    return (0, $g6Hsb.default)({}, classes, composedClasses);
};
const $348a23c9f66f2bb0$var$CheckboxRoot = (0, $25zst.default)((0, $1UXum.default), {
    shouldForwardProp: (prop)=>(0, $25zst.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            ownerState.color !== "default" && styles[`color${(0, $63Oo6.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fOENh.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $7hIGm.default).checked}, &.${(0, $7hIGm.default).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $7hIGm.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $348a23c9f66f2bb0$var$defaultCheckedIcon = /*#__PURE__*/ (0, $2T9xh.jsx)((0, $fcvjR.default), {});
const $348a23c9f66f2bb0$var$defaultIcon = /*#__PURE__*/ (0, $2T9xh.jsx)((0, $74g3b.default), {});
const $348a23c9f66f2bb0$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $2T9xh.jsx)((0, $bT7FR.default), {});
const $348a23c9f66f2bb0$var$Checkbox = /*#__PURE__*/ $aOzEm.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $348a23c9f66f2bb0$var$defaultCheckedIcon, color: color = "primary", icon: iconProp = $348a23c9f66f2bb0$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $348a23c9f66f2bb0$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = "medium", className: className } = props, other = (0, $cAqXo.default)(props, $348a23c9f66f2bb0$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $g6Hsb.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $348a23c9f66f2bb0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($348a23c9f66f2bb0$var$CheckboxRoot, (0, $g6Hsb.default)({
        type: "checkbox",
        inputProps: (0, $g6Hsb.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $aOzEm.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $aOzEm.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $g45Wv.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $348a23c9f66f2bb0$export$2e2bcd8739ae039 = $348a23c9f66f2bb0$var$Checkbox;

});
parcelRegister("1UXum", function(module, exports) {

$parcel$export(module.exports, "default", () => $16592a9d4d2eb62a$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");


var $b2r0b = parcelRequire("b2r0b");

var $63Oo6 = parcelRequire("63Oo6");

var $25zst = parcelRequire("25zst");

var $duffS = parcelRequire("duffS");

var $bNyOK = parcelRequire("bNyOK");

var $cdbdN = parcelRequire("cdbdN");

var $aPlrd = parcelRequire("aPlrd");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $16592a9d4d2eb62a$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $16592a9d4d2eb62a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $63Oo6.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $aPlrd.getSwitchBaseUtilityClass), classes);
};
const $16592a9d4d2eb62a$var$SwitchBaseRoot = (0, $25zst.default)((0, $cdbdN.default))(({ ownerState: ownerState })=>(0, $g6Hsb.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $16592a9d4d2eb62a$var$SwitchBaseInput = (0, $25zst.default)("input")({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $16592a9d4d2eb62a$var$SwitchBase = /*#__PURE__*/ $aOzEm.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $cAqXo.default)(props, $16592a9d4d2eb62a$var$_excluded);
    const [checked, setCheckedState] = (0, $duffS.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $bNyOK.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $g6Hsb.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $16592a9d4d2eb62a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($16592a9d4d2eb62a$var$SwitchBaseRoot, (0, $g6Hsb.default)({
        component: "span",
        className: (0, $g45Wv.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)($16592a9d4d2eb62a$var$SwitchBaseInput, (0, $g6Hsb.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $16592a9d4d2eb62a$export$2e2bcd8739ae039 = $16592a9d4d2eb62a$var$SwitchBase;

});
parcelRegister("aPlrd", function(module, exports) {

$parcel$export(module.exports, "getSwitchBaseUtilityClass", () => $7e1f4bf01c594879$export$baa0faa0c7ad8085);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $7e1f4bf01c594879$export$baa0faa0c7ad8085(slot) {
    return (0, $6vnyE.default)("PrivateSwitchBase", slot);
}
const $7e1f4bf01c594879$var$switchBaseClasses = (0, $cyhE3.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $7e1f4bf01c594879$export$2e2bcd8739ae039 = $7e1f4bf01c594879$var$switchBaseClasses;

});


parcelRegister("74g3b", function(module, exports) {

$parcel$export(module.exports, "default", () => $52555b68c157458f$export$2e2bcd8739ae039);
parcelRequire("aOzEm");

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $52555b68c157458f$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");

});

parcelRegister("fcvjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b110455ebecfe7f9$export$2e2bcd8739ae039);
parcelRequire("aOzEm");

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $b110455ebecfe7f9$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");

});

parcelRegister("bT7FR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a7ac8ae43b1b54d$export$2e2bcd8739ae039);
parcelRequire("aOzEm");

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $8a7ac8ae43b1b54d$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");

});

parcelRegister("7hIGm", function(module, exports) {

$parcel$export(module.exports, "getCheckboxUtilityClass", () => $54dcc7ebcee0f818$export$6c57c6e16b4063b);
$parcel$export(module.exports, "default", () => $54dcc7ebcee0f818$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $54dcc7ebcee0f818$export$6c57c6e16b4063b(slot) {
    return (0, $6vnyE.default)("MuiCheckbox", slot);
}
const $54dcc7ebcee0f818$var$checkboxClasses = (0, $cyhE3.default)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium"
]);
var $54dcc7ebcee0f818$export$2e2bcd8739ae039 = $54dcc7ebcee0f818$var$checkboxClasses;

});


parcelRegister("5mWC6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e8c7943f7eb68c7$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");


var $b2r0b = parcelRequire("b2r0b");

var $bNyOK = parcelRequire("bNyOK");

var $gvXbM = parcelRequire("gvXbM");

var $gdH9i = parcelRequire("gdH9i");

var $63Oo6 = parcelRequire("63Oo6");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $5c6uB = parcelRequire("5c6uB");

var $g3m9r = parcelRequire("g3m9r");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $3e8c7943f7eb68c7$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $3e8c7943f7eb68c7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $63Oo6.default)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $5c6uB.getFormControlLabelUtilityClasses), classes);
};
const $3e8c7943f7eb68c7$export$1b479270917a5676 = (0, $25zst.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $5c6uB.default).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $63Oo6.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $5c6uB.default).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $5c6uB.default).label}`]: {
            [`&.${(0, $5c6uB.default).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $3e8c7943f7eb68c7$var$AsteriskComponent = (0, $25zst.default)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $5c6uB.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $3e8c7943f7eb68c7$var$FormControlLabel = /*#__PURE__*/ $aOzEm.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end", required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $cAqXo.default)(props, $3e8c7943f7eb68c7$var$_excluded);
    const muiFormControl = (0, $bNyOK.default)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $g3m9r.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $g6Hsb.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $3e8c7943f7eb68c7$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $gdH9i.default) && !disableTypography) label = /*#__PURE__*/ (0, $2T9xh.jsx)((0, $gdH9i.default), (0, $g6Hsb.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $g45Wv.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($3e8c7943f7eb68c7$export$1b479270917a5676, (0, $g6Hsb.default)({
        className: (0, $g45Wv.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $aOzEm.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $gvXbM.default), {
                direction: "row",
                alignItems: "center",
                children: [
                    label,
                    /*#__PURE__*/ (0, $2T9xh.jsxs)($3e8c7943f7eb68c7$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            "*"
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $3e8c7943f7eb68c7$export$2e2bcd8739ae039 = $3e8c7943f7eb68c7$var$FormControlLabel;

});
parcelRegister("5c6uB", function(module, exports) {

$parcel$export(module.exports, "getFormControlLabelUtilityClasses", () => $3c831c0616dc1687$export$717666c39ec07e12);
$parcel$export(module.exports, "default", () => $3c831c0616dc1687$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $3c831c0616dc1687$export$717666c39ec07e12(slot) {
    return (0, $6vnyE.default)("MuiFormControlLabel", slot);
}
const $3c831c0616dc1687$var$formControlLabelClasses = (0, $cyhE3.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
var $3c831c0616dc1687$export$2e2bcd8739ae039 = $3c831c0616dc1687$var$formControlLabelClasses;

});


parcelRegister("2oTOI", function(module, exports) {
"use strict";
var $1bf91ebd9cbe0664$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2T9xh = parcelRequire("2T9xh");

const $1bf91ebd9cbe0664$var$Stack_1 = $1bf91ebd9cbe0664$var$__importDefault((parcelRequire("iZ9ll")));

const $1bf91ebd9cbe0664$var$ContentBox_1 = $1bf91ebd9cbe0664$var$__importDefault((parcelRequire("aSHbG")));
/**
 * @deprecated - Prefer the components from the PageTemplate.tsx file in the app instead.
 */ function $1bf91ebd9cbe0664$var$Content({ className: className, sx: sx, children: children }) {
    return (0, $2T9xh.jsx)($1bf91ebd9cbe0664$var$Stack_1.default, Object.assign({
        className: className,
        direction: "row",
        sx: Object.assign({
            padding: 2
        }, sx),
        alignItems: "flex-start",
        justifyContent: "center"
    }, {
        children: (0, $2T9xh.jsx)($1bf91ebd9cbe0664$var$ContentBox_1.default, {
            children: children
        })
    }));
}
module.exports.default = $1bf91ebd9cbe0664$var$Content;

});
parcelRegister("aSHbG", function(module, exports) {
"use strict";
var $7ec072a94f65fb19$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2T9xh = parcelRequire("2T9xh");

const $7ec072a94f65fb19$var$Stack_1 = $7ec072a94f65fb19$var$__importDefault((parcelRequire("iZ9ll")));
// ContentBox is a box the width of the standard content area (1024px currently)
function $7ec072a94f65fb19$var$ContentBox({ sx: sx, children: children }) {
    return (0, $2T9xh.jsx)($7ec072a94f65fb19$var$Stack_1.default, Object.assign({
        className: "ContentBox",
        sx: Object.assign({
            // todo: might want to have breakpoints for different widths depending on screen size.
            // minWidth: (theme: DecodableTheme) => theme.decodable.contentArea.minWidth,
            maxWidth: (theme)=>{
                var _a, _b;
                return `min(100%, ${(_b = (_a = theme.decodable) === null || _a === void 0 ? void 0 : _a.contentArea) === null || _b === void 0 ? void 0 : _b.maxWidth})`;
            },
            flexBasis: "900px",
            flexGrow: 1,
            flexShrink: 1
        }, sx || {})
    }, {
        children: children
    }));
}
module.exports.default = $7ec072a94f65fb19$var$ContentBox;

});



parcelRegister("29fm1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0883d0b6f2376e30$export$2e2bcd8739ae039);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $5YTEB = parcelRequire("5YTEB");

var $kICAk = parcelRequire("kICAk");

var $8Rfza = parcelRequire("8Rfza");

const $0883d0b6f2376e30$var$LazyAccountListPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>(parcelRequire("hJMLL")));
var $0883d0b6f2376e30$export$2e2bcd8739ae039 = (0, $8Rfza.withAuthenticationRequired)(function AccountsRoutes() {
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $5YTEB.Routes), {
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                index: true,
                element: /*#__PURE__*/ (0, $2T9xh.jsx)($0883d0b6f2376e30$var$LazyAccountListPage, {})
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $5YTEB.Route), {
                path: "/create",
                element: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $kICAk.AccountCreateContainer), {})
            })
        ]
    });
});

});
parcelRegister("kICAk", function(module, exports) {

$parcel$export(module.exports, "AccountCreateContainer", () => $d9afd20b76ac1975$export$e156b96044d5c180);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $5YTEB = parcelRequire("5YTEB");

var $ek6Yt = parcelRequire("ek6Yt");

var $4In7L = parcelRequire("4In7L");

var $yaNWN = parcelRequire("yaNWN");

var $cleXH = parcelRequire("cleXH");

var $kbGDn = parcelRequire("kbGDn");

var $hiyjS = parcelRequire("hiyjS");

var $agJmW = parcelRequire("agJmW");

var $gga7I = parcelRequire("gga7I");

var $guj2m = parcelRequire("guj2m");

var $a2Lgd = parcelRequire("a2Lgd");

var $bbs2R = parcelRequire("bbs2R");

var $29pjJ = parcelRequire("29pjJ");
function $d9afd20b76ac1975$export$e156b96044d5c180({ cellSampleFunc: cellSampleFunc = (0, $cleXH.sample) }) {
    const showSnackbar = (0, $4In7L.useSnackbar)();
    const dispatchAppEvent = (0, $29pjJ.useAppEventDispatch)();
    const navigate = (0, $5YTEB.useNavigate)();
    const { flags: flags } = (0, $yaNWN.useFeatureFlags)();
    const { plan: plan, selectPlan: selectPlan, formState: formState, dispatch: dispatch } = (0, $agJmW.useAccountCreatePageState)();
    const { data: cells, refetch: refetchCells } = (0, $hiyjS.useAvailableCells)({
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        onError (error) {
            dispatch({
                type: "updateRegions",
                error: error,
                loading: false
            });
        },
        onSuccess (cells) {
            dispatch({
                type: "updateRegions",
                error: null,
                regions: Object.keys(cells?.[0, $kbGDn.defaultCloud] ?? {}),
                loading: false
            });
            dispatch({
                type: "updateForm",
                formData: {
                    selectedRegion: (0, $guj2m.selectDefaultRegion)(cells)
                }
            });
        }
    });
    const onRefetchRegions = (0, $aOzEm.useCallback)(()=>{
        dispatch({
            type: "updateRegions",
            error: null,
            loading: true
        });
        return refetchCells();
    }, [
        refetchCells
    ]);
    const { refresh: refreshAccounts } = (0, $gga7I.useAccounts)();
    const { mutateAsync: mutateAsync, isLoading: isCreating } = (0, $hiyjS.useCreateAccount)();
    async function handleCreateAccount() {
        try {
            const cell = cellSampleFunc(cells[0, $kbGDn.defaultCloud][formState.selectedRegion]);
            await mutateAsync({
                cell: cell,
                plan: plan,
                name: formState.name,
                displayName: formState.displayName,
                invites: formState.invites
            });
            dispatchAppEvent("account:create", {
                cell: cell,
                plan_id: plan.id,
                name: formState.name
            });
        } catch (ex) {
            if (ex instanceof (0, $ek6Yt.DecodableApiError)) // status: conflict
            {
                if (ex.status === 409) {
                    dispatch({
                        type: "updateForm",
                        formData: {
                            isNameConflict: true
                        }
                    });
                    return;
                }
            }
            showSnackbar({
                severity: "error",
                title: "Error creating account",
                message: "Please try again"
            });
            return;
        }
        showSnackbar({
            severity: "success",
            title: "Account Created!",
            message: `Redirecting to new account: ${formState.name}`
        });
        try {
            await refreshAccounts();
            const destination = `/${formState.name}`;
            navigate(destination);
        } catch (ex) {
            // todo: Maybe just do this?
            document.location = `/${formState.name}`;
        }
    }
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $bbs2R.AccountCreatePage), {
        plan: plan,
        onSelectPlan: selectPlan,
        form: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $a2Lgd.AccountCreateForm), {
            onRefetchRegions: onRefetchRegions,
            plan: plan,
            formState: formState,
            dispatch: dispatch,
            isCreating: isCreating,
            onCreateAccount: handleCreateAccount
        })
    });
}

});
parcelRegister("kbGDn", function(module, exports) {

$parcel$export(module.exports, "defaultCloud", () => $11e01d16d5b1700a$export$f26c9b6a0f4576cf);
$parcel$export(module.exports, "termsOfServiceHref", () => $11e01d16d5b1700a$export$c5a56e259cbc37ff);
$parcel$export(module.exports, "searchParamNames", () => $11e01d16d5b1700a$export$1e9423d6616d30aa);
$parcel$export(module.exports, "selfServicePlans", () => $11e01d16d5b1700a$export$85bbb0f0e2bbcd4);
const $11e01d16d5b1700a$export$f26c9b6a0f4576cf = "aws";
const $11e01d16d5b1700a$export$c5a56e259cbc37ff = "https://www.decodable.co/legal/tos";
const $11e01d16d5b1700a$export$1e9423d6616d30aa = {
    selectedPlanId: "selected_plan_id"
};
const $11e01d16d5b1700a$export$c486f86aef8db22d = {
    small: {
        name: "Small",
        spec: {
            cpu: "0.25 cores",
            mem: "512 GB"
        }
    },
    medium: {
        name: "Medium",
        spec: {
            cpu: "0.5 cores",
            mem: "1024 GB"
        }
    },
    large: {
        name: "Large",
        spec: {
            cpu: "1 core",
            mem: "2048 GB"
        }
    }
};
const $11e01d16d5b1700a$export$9fa04d42e5fe01b1 = [
    {
        id: "free",
        name: "Developer",
        isSelfService: true,
        requiresPayment: false,
        taskPrices: [
            {
                taskSize: $11e01d16d5b1700a$export$c486f86aef8db22d.small,
                hourlyPrice: "Free"
            },
            {
                taskSize: $11e01d16d5b1700a$export$c486f86aef8db22d.medium,
                hourlyPrice: "Free"
            }
        ],
        description: [
            "4 tasks for pipelines and connections",
            "7 day per stream / 10GB total retention",
            "Community Slack support"
        ],
        cta: "Choose Plan",
        link: "./select?plan=free"
    },
    {
        id: "on_demand",
        name: "Team",
        isSelfService: true,
        requiresPayment: true,
        taskPrices: [
            {
                taskSize: $11e01d16d5b1700a$export$c486f86aef8db22d.small,
                hourlyPrice: "$0.10/hour"
            },
            {
                taskSize: $11e01d16d5b1700a$export$c486f86aef8db22d.medium,
                hourlyPrice: "$0.20/hour"
            },
            {
                taskSize: $11e01d16d5b1700a$export$c486f86aef8db22d.large,
                hourlyPrice: "$0.40/hour"
            }
        ],
        description: [
            "Unlimited tasks for pipelines and connections - pay only for what you use",
            "7 day per stream / 100GB total retention",
            "Slack and email support"
        ],
        cta: "Choose Plan",
        link: "./select?plan=on_demand"
    },
    {
        id: "enterprise",
        name: "Enterprise",
        isSelfService: false,
        requiresPayment: true,
        taskPrices: [
            {
                taskSize: $11e01d16d5b1700a$export$c486f86aef8db22d.small,
                hourlyPrice: "Custom"
            },
            {
                taskSize: $11e01d16d5b1700a$export$c486f86aef8db22d.medium,
                hourlyPrice: "Custom"
            },
            {
                taskSize: $11e01d16d5b1700a$export$c486f86aef8db22d.large,
                hourlyPrice: "Custom"
            }
        ],
        description: [
            "Unlimited tasks for pipelines and connections - reserved capacity",
            "Unlimited stream retention",
            "Enterprise identity provider support (ADFS, Okta, Ping Identity, and more)",
            "Dedicated support",
            "Optional isolated tenancy add-on"
        ],
        cta: "Contact Sales",
        link: "https://www.decodable.co/contact"
    }
];
const $11e01d16d5b1700a$export$85bbb0f0e2bbcd4 = $11e01d16d5b1700a$export$9fa04d42e5fe01b1.filter((p)=>p.isSelfService);

});

parcelRegister("hiyjS", function(module, exports) {

$parcel$export(module.exports, "useResolveHost", () => $4a504648cee77c0c$export$c31b0b38437cdb24);
$parcel$export(module.exports, "useUpdateAccount", () => $4a504648cee77c0c$export$d31ea9dfbc057989);
$parcel$export(module.exports, "useAvailableCells", () => $4a504648cee77c0c$export$3c10924bc485eb04);
$parcel$export(module.exports, "useCreateAccount", () => $4a504648cee77c0c$export$1c79e47509205715);
$parcel$export(module.exports, "useUploadCertificateSigningRequest", () => $4a504648cee77c0c$export$5b65958348b3db7);
$parcel$export(module.exports, "useDownloadSignedCertificate", () => $4a504648cee77c0c$export$5637b26c2d0511fb);
parcelRequire("4UEYn");
var $lKmTf = parcelRequire("lKmTf");
var $ipyAV = parcelRequire("ipyAV");
var $dRtsf = parcelRequire("dRtsf");

var $hJHPU = parcelRequire("hJHPU");

var $37RpH = parcelRequire("37RpH");

var $cleXH = parcelRequire("cleXH");

var $4TQfS = parcelRequire("4TQfS");

var $gga7I = parcelRequire("gga7I");
function $4a504648cee77c0c$export$c31b0b38437cdb24(opts = {}) {
    return (0, $lKmTf.useMutation)([
        "data-plane-host"
    ], async ({ host: host })=>{
        if (!host) return false;
        var protocol = host === "localhost" || host.startsWith("localhost:") ? "http" : "https";
        await fetch(`${protocol}://${host}`, {
            method: "HEAD",
            mode: "no-cors"
        });
        return true;
    }, {
        ...opts,
        retry: 3,
        retryDelay: 500
    });
}
function $4a504648cee77c0c$export$222f63d1381a37b6(params, options) {
    const accountsApi = (0, $4TQfS.useAccountsApi)();
    return (0, $ipyAV.useQuery)([
        "accounts"
    ], ()=>{
        return accountsApi.listUserAccounts(params);
    }, options);
}
function $4a504648cee77c0c$export$b07129094a7bdcfd() {
    const accountsApi = (0, $4TQfS.useAccountsApi)();
    return (0, $ipyAV.useQuery)([
        "accounts",
        "metadata"
    ], ()=>{
        return accountsApi.getAccountMetadata();
    });
}
function $4a504648cee77c0c$export$6377324201d3ac67(id) {
    const accountsApi = (0, $4TQfS.useAccountsApi)();
    return (0, $ipyAV.useQuery)([
        "accounts",
        "information"
    ], ()=>{
        return accountsApi.getAccountInformation({
            id: id
        });
    });
}
function $4a504648cee77c0c$export$d31ea9dfbc057989(id, options) {
    const accountsApi = (0, $4TQfS.useAccountsApi)();
    const queryClient = (0, $dRtsf.useQueryClient)();
    return (0, $lKmTf.useMutation)((accountUpdateParams)=>accountsApi.updateAccount({
            id: id,
            ...accountUpdateParams
        }), {
        ...options,
        onSuccess: (data, variables, context)=>{
            queryClient.invalidateQueries([
                "accounts"
            ]);
            options?.onSuccess?.(data, variables, context);
        }
    });
}
function $4a504648cee77c0c$export$3c10924bc485eb04(opts) {
    const decodableApiFetch = (0, $hJHPU.useDecodableApiFetch)();
    return (0, $ipyAV.useQuery)([
        "cells",
        "available"
    ], ()=>decodableApiFetch("/v1alpha2/cells/available"), opts);
}
function $4a504648cee77c0c$export$1c79e47509205715() {
    const gtag = (0, $37RpH.useGtag)();
    const decodableApiFetch = (0, $hJHPU.useDecodableApiFetch)();
    return (0, $lKmTf.useMutation)(async ({ cell: cell, plan: plan, name: name, displayName: displayName, invites: invites })=>{
        const body = {
            name: name,
            display_name: displayName,
            subscription: {
                plan_id: plan.id
            },
            invite_emails: undefined
        };
        if (invites) body.invite_emails = (0, $cleXH.splitEmailList)(invites);
        try {
            await decodableApiFetch("/v1alpha2/accounts", {
                body: JSON.stringify(body),
                headers: {
                    "Content-Type": "application/json"
                }
            }, {
                targetCell: cell
            });
        } catch (ex) {
            if (typeof jest === "undefined") console.error(ex);
            throw ex;
        }
        gtag({
            event: "account_created",
            account_name: name,
            plan: plan.id
        });
    });
}
const $4a504648cee77c0c$export$5b65958348b3db7 = (files, opts)=>{
    const { activeAccount: activeAccount } = (0, $gga7I.useActiveAccount)();
    const accountService = (0, $4TQfS.useAccountsApi)();
    const csr = Array.from(files.values()).pop();
    return (0, $ipyAV.useQuery)([
        "accounts",
        activeAccount.name,
        "certificate_signing_request"
    ], async ()=>accountService.uploadCertificateSigningRequest(activeAccount.name, {
            csr: csr
        }), opts);
};
const $4a504648cee77c0c$export$5637b26c2d0511fb = (opts)=>{
    const { activeAccount: activeAccount } = (0, $gga7I.useActiveAccount)();
    const accountService = (0, $4TQfS.useAccountsApi)();
    return (0, $lKmTf.useMutation)([
        "accounts",
        activeAccount.name,
        "certificate"
    ], async ()=>await accountService.getSignedCertificate(activeAccount.name), opts);
};

});
parcelRegister("4TQfS", function(module, exports) {

$parcel$export(module.exports, "AccountsApiProvider", () => $1bc8e286369cb21b$export$59c58b8b44c38a3d);
$parcel$export(module.exports, "useAccountsApi", () => $1bc8e286369cb21b$export$b48d77e1762c40ca);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $hJHPU = parcelRequire("hJHPU");

var $ek6Yt = parcelRequire("ek6Yt");
const $1bc8e286369cb21b$export$59de5d9ba1ade152 = /*#__PURE__*/ (0, $aOzEm.createContext)(null);
function $1bc8e286369cb21b$export$59c58b8b44c38a3d({ children: children = null }) {
    const fetch = (0, $hJHPU.useAccountScopedFetch)();
    const service = (0, $aOzEm.useMemo)(()=>fetch && new (0, $ek6Yt.AccountsService)(fetch), [
        fetch
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($1bc8e286369cb21b$export$59de5d9ba1ade152.Provider, {
        value: service,
        children: children
    });
}
function $1bc8e286369cb21b$export$b48d77e1762c40ca() {
    return (0, $aOzEm.useContext)($1bc8e286369cb21b$export$59de5d9ba1ade152);
}

});


parcelRegister("agJmW", function(module, exports) {

$parcel$export(module.exports, "useAccountCreatePageState", () => $2b1d3926dd60e4e5$export$2222f32f74f6c6b8);

var $aOzEm = parcelRequire("aOzEm");

var $57CDS = parcelRequire("57CDS");

var $cleXH = parcelRequire("cleXH");

var $kbGDn = parcelRequire("kbGDn");

var $guj2m = parcelRequire("guj2m");
function $2b1d3926dd60e4e5$export$1f874964016a5026() {
    const displayName = (0, $guj2m.generateDisplayName)();
    // There are currently 25,596 unique names that docker-names may produce.
    // We append a random number from 1-1000, yielding 25,596,000 unique account IDs
    // to further reduce the likelihood of any collisions.
    const name = (0, $guj2m.accountNameFromDisplayName)(displayName) + "-" + Math.floor(Math.random() * 1000);
    return {
        name: name,
        displayName: displayName
    };
}
function $2b1d3926dd60e4e5$export$6c48ceb03731fb94() {
    return {
        ...$2b1d3926dd60e4e5$export$1f874964016a5026(),
        nameErr: null,
        isNameDirty: false,
        isNameConflict: false,
        displayNameErr: null,
        regions: null,
        regionsAreLoading: true,
        regionsError: null,
        selectedRegion: "",
        invites: "",
        invitesErr: null,
        requiredInputErr: null,
        submitDisabledReason: "Account name is required"
    };
}
function $2b1d3926dd60e4e5$export$2222f32f74f6c6b8(initialState) {
    const [params, setParams] = (0, $57CDS.useSearchParams)();
    const plan = (0, $aOzEm.useMemo)(()=>(0, $kbGDn.selfServicePlans).find((p)=>p.id == params.get("selected_plan_id")) ?? (0, $kbGDn.selfServicePlans).find((p)=>p.id == "free"), [
        params
    ]);
    function selectPlan(planId) {
        params.set((0, $kbGDn.searchParamNames).selectedPlanId, planId);
        setParams(params, {
            replace: true
        });
    }
    const [formState, dispatch] = (0, $aOzEm.useReducer)((state, action)=>{
        let nextState = {
            ...state
        };
        switch(action.type){
            case "updateForm":
                Object.assign(nextState, action.formData);
                if (action.formData.name) nextState.isNameDirty = true;
                if (action.formData.displayName != null && !nextState.isNameDirty) nextState.name = (0, $guj2m.accountNameFromDisplayName)(nextState.displayName);
                break;
            case "regenerateName":
                Object.assign(nextState, $2b1d3926dd60e4e5$export$1f874964016a5026());
                nextState.isNameDirty = false;
                break;
            case "updateRegions":
                if (action.regions !== undefined) nextState.regions = action.regions;
                if (action.loading !== undefined) nextState.regionsAreLoading = action.loading;
                if (action.error !== undefined) nextState.regionsError = action.error;
                break;
            default:
                {
                    const unhandled = action;
                    throw new Error(`Unhandled action ${unhandled}`);
                }
        }
        // Unset any name conflict status when the user changes the name again
        if (nextState.name != state.name) nextState.isNameConflict = false;
        nextState.nameErr = $2b1d3926dd60e4e5$export$88b6c6a421641e83(nextState.name);
        nextState.displayNameErr = $2b1d3926dd60e4e5$export$4997a2b9d71b4bc3(nextState.displayName);
        nextState.invitesErr = $2b1d3926dd60e4e5$export$420627a6847873fe(nextState.invites);
        nextState.requiredInputErr = !nextState.name ? "Account name is required" : !nextState.displayName ? "Display name is required" : !nextState.selectedRegion ? "Region is required" : null;
        nextState.submitDisabledReason = nextState.nameErr ?? nextState.displayNameErr ?? nextState.invitesErr ?? nextState.requiredInputErr;
        return nextState;
    }, initialState ?? $2b1d3926dd60e4e5$export$6c48ceb03731fb94());
    return {
        plan: plan,
        selectPlan: selectPlan,
        formState: formState,
        dispatch: dispatch
    };
}
// Per: https://docs.google.com/document/d/1S8ETdc3-D8BX_ffgjPrcVlnJmp-sTHm7a3PIg9FK-Uo/edit#heading=h.fjadff6dwmyg
const $2b1d3926dd60e4e5$var$nameRegex = /^[a-z][a-z0-9]*(-[a-z0-9]+)*$/;
const $2b1d3926dd60e4e5$var$nameExplanation = "Account names must start with a letter (a-z) and may only contain letters, numbers (0-9), or hyphens ( - ). Special characters and spaces are not allowed.";
const $2b1d3926dd60e4e5$var$emailExplanation = "Invites must be valid email addresses separated by spaces or commas";
function $2b1d3926dd60e4e5$export$88b6c6a421641e83(name) {
    if (name.length == 0) return null;
    return (name.length >= 3 && name.length <= 50 ? false : "Account name must be between 3 and 50 characters") || (name.match($2b1d3926dd60e4e5$var$nameRegex) ? null : $2b1d3926dd60e4e5$var$nameExplanation) || null;
}
function $2b1d3926dd60e4e5$export$4997a2b9d71b4bc3(displayName) {
    if (displayName.length == 0) return null;
    return (displayName.length >= 3 && displayName.length <= 255 ? null : "Display name must be between 3 and 255 characters") || null;
}
function $2b1d3926dd60e4e5$export$420627a6847873fe(invites) {
    if (invites.length == 0) return null;
    return (0, $cleXH.splitEmailList)(invites).every((email)=>email.match((0, $cleXH.emailRegex))) ? null : $2b1d3926dd60e4e5$var$emailExplanation;
}

});
parcelRegister("guj2m", function(module, exports) {

$parcel$export(module.exports, "generateDisplayName", () => $293b25c970f13d1c$export$7aa0b9c40ab348a0);
$parcel$export(module.exports, "byocVersions", () => $293b25c970f13d1c$export$aed0d0c3a8907a0d);
$parcel$export(module.exports, "accountNameFromDisplayName", () => $293b25c970f13d1c$export$84e12a2e7b3d6e81);
$parcel$export(module.exports, "selectDefaultRegion", () => $293b25c970f13d1c$export$9663efd4eeb646e5);

var $8PhZ3 = parcelRequire("8PhZ3");

var $5RcZa = parcelRequire("5RcZa");

var $cleXH = parcelRequire("cleXH");

var $kbGDn = parcelRequire("kbGDn");
function $293b25c970f13d1c$export$7aa0b9c40ab348a0() {
    return $293b25c970f13d1c$export$ed9ca0ed97b33d39($8PhZ3.left, $8PhZ3.right);
}
function $293b25c970f13d1c$export$ed9ca0ed97b33d39(left, right) {
    return `${(0, $5RcZa.titleCase)((0, $cleXH.sample)(left))} ${(0, $5RcZa.titleCase)((0, $cleXH.sample)(right))}`;
}
const $293b25c970f13d1c$var$patterns = {
    invalidAccountNameChars: /[^\sa-z0-9-]+/g,
    spaces: /\s+/g
};
const $293b25c970f13d1c$export$aed0d0c3a8907a0d = {
    "v1.18.1": [
        {
            name: "Data Plane Helm Chart",
            file: "decodable-data-plane.tgz"
        },
        {
            name: "Flink Kubernetes Operator Helm Chart",
            file: "flink-kubernetes-operator.tgz"
        },
        {
            name: "Reference Terraform",
            file: "terraform.zip"
        }
    ],
    "v1.18.0": [
        {
            name: "Data Plane Helm Chart",
            file: "decodable-data-plane.tgz"
        },
        {
            name: "Flink Kubernetes Operator Helm Chart",
            file: "flink-kubernetes-operator.tgz"
        },
        {
            name: "Reference Terraform",
            file: "terraform.zip"
        }
    ],
    "v1.17.5": [
        {
            name: "Data Plane Helm Chart",
            file: "decodable-data-plane.tgz"
        },
        {
            name: "Flink Kubernetes Operator Helm Chart",
            file: "flink-kubernetes-operator.tgz"
        },
        {
            name: "Reference Terraform",
            file: "terraform.zip"
        }
    ],
    "v1.17.4": [
        {
            name: "Data Plane Helm Chart",
            file: "decodable-data-plane.tgz"
        },
        {
            name: "Flink Kubernetes Operator Helm Chart",
            file: "flink-kubernetes-operator.tgz"
        },
        {
            name: "Reference Terraform",
            file: "terraform.zip"
        }
    ],
    "v1.17.3": [
        {
            name: "Data Plane Helm Chart",
            file: "decodable-data-plane.tgz"
        },
        {
            name: "Flink Kubernetes Operator Helm Chart",
            file: "flink-kubernetes-operator.tgz"
        },
        {
            name: "Reference Terraform",
            file: "terraform.zip"
        }
    ],
    "v1.17.2": [
        {
            name: "Data Plane Helm Chart",
            file: "decodable-data-plane.tgz"
        },
        {
            name: "Flink Kubernetes Operator Helm Chart",
            file: "flink-kubernetes-operator.tgz"
        },
        {
            name: "Reference Terraform",
            file: "terraform.zip"
        }
    ],
    "v1.17.1": [
        {
            name: "Data Plane Helm Chart",
            file: "decodable-data-plane.tgz"
        },
        {
            name: "Flink Kubernetes Operator Helm Chart",
            file: "flink-kubernetes-operator.tgz"
        },
        {
            name: "Reference Terraform",
            file: "terraform.zip"
        }
    ],
    "v1.17.0": [
        {
            name: "Data Plane Helm Chart",
            file: "decodable-data-plane.tgz"
        },
        {
            name: "Flink Kubernetes Operator Helm Chart",
            file: "flink-kubernetes-operator.tgz"
        },
        {
            name: "Reference Terraform",
            file: "terraform.zip"
        }
    ],
    "v1.16.3": [
        {
            name: "Data Plane Helm Chart",
            file: "decodable-data-plane.tgz"
        },
        {
            name: "Flink Kubernetes Operator Helm Chart",
            file: "flink-kubernetes-operator.tgz"
        },
        {
            name: "Reference Terraform",
            file: "terraform.zip"
        }
    ],
    "v1.16.2": [
        {
            name: "Data Plane Helm Chart",
            file: "decodable-data-plane.tgz"
        },
        {
            name: "Flink Kubernetes Operator Helm Chart",
            file: "flink-kubernetes-operator.tgz"
        },
        {
            name: "Reference Terraform",
            file: "terraform.zip"
        }
    ],
    "v1.16.1": [
        {
            name: "Data Plane Helm Chart",
            file: "decodable-data-plane.tgz"
        },
        {
            name: "Flink Kubernetes Operator Helm Chart",
            file: "flink-kubernetes-operator.tgz"
        },
        {
            name: "Reference Terraform",
            file: "terraform.zip"
        }
    ],
    "v1.16.0": [
        {
            name: "Data Plane Helm Chart",
            file: "decodable-data-plane.tgz"
        },
        {
            name: "Flink Kubernetes Operator Helm Chart",
            file: "flink-kubernetes-operator.tgz"
        },
        {
            name: "Reference Terraform",
            file: "terraform.zip"
        }
    ],
    "v1.15.1": [
        {
            name: "Data Plane Helm Chart",
            file: "decodable-data-plane.tgz"
        },
        {
            name: "Flink Kubernetes Operator Helm Chart",
            file: "flink-kubernetes-operator.tgz"
        },
        {
            name: "Reference Terraform",
            file: "terraform.zip"
        }
    ],
    "v1.15.0": [
        {
            name: "Data Plane Helm Chart",
            file: "decodable-data-plane.tgz"
        },
        {
            name: "Flink Kubernetes Operator Helm Chart",
            file: "flink-kubernetes-operator.tgz"
        },
        {
            name: "Reference Terraform",
            file: "terraform.zip"
        }
    ]
};
function $293b25c970f13d1c$export$84e12a2e7b3d6e81(displayName) {
    return displayName.toLocaleLowerCase().replace($293b25c970f13d1c$var$patterns.invalidAccountNameChars, "").trim().replace($293b25c970f13d1c$var$patterns.spaces, "-").slice(0, 50);
}
function $293b25c970f13d1c$export$9663efd4eeb646e5(cells) {
    // Find the regions with a non-empty list of available cells.
    const awsRegions = Object.keys(cells?.[0, $kbGDn.defaultCloud] ?? {}).filter((r)=>cells[0, $kbGDn.defaultCloud][r].length > 0);
    let someUsWestRegion = null;
    let someUsEastRegion = null;
    let someUsRegion = null;
    // Default region preference is us-west-2 > any us-west > any us-east > any us > any region
    for (const region of awsRegions){
        if (region === "us-west-2") return region;
        if (!someUsWestRegion && region.startsWith("us-west")) someUsWestRegion = region;
        if (!someUsEastRegion && region.startsWith("us-east")) someUsEastRegion = region;
        if (!someUsRegion && region.startsWith("us-")) someUsRegion = region;
    }
    return someUsWestRegion ?? someUsEastRegion ?? someUsRegion ?? awsRegions[0];
}

});
parcelRegister("8PhZ3", function(module, exports) {
/**
 * @private
 * @summary "Randomly" picks an element from the left array and combines it with one form right.
 * @description
 *  This function is a copy paste implementation from docker_names in golang.
 *  Will never return "boring_wozniak".
 *  The left array should be an array of adjectives, where as the right array should be
 *  an individuals surname. This results in funny names like angry_bohr or prickly_murdock.
 * @param {Array} left - An array of strings to be used as the left  word in docker name.
 * @param {Array} right - An array of strings to be used as the right word in docker name.
 * @returns {string}
 */ function $66d1095aad178a22$var$generateName(left, right) {
    var first = left[Math.floor(Math.random() * left.length)];
    var second = right[Math.floor(Math.random() * right.length)];
    var result = first + "_" + second;
    /* Steve Wozniak is not boring. This is part of the docker names spec. */ if (result === "boring_wozniak") return $66d1095aad178a22$var$generateName(left, right);
    return result;
}
function $66d1095aad178a22$var$DockerNames() {
    this.left = [
        "admiring",
        "adoring",
        "affectionate",
        "agitated",
        "amazing",
        "angry",
        "awesome",
        "beautiful",
        "blissful",
        "bold",
        "boring",
        "brave",
        "busy",
        "charming",
        "clever",
        "cool",
        "compassionate",
        "competent",
        "condescending",
        "confident",
        "cranky",
        "crazy",
        "dazzling",
        "determined",
        "distracted",
        "dreamy",
        "eager",
        "ecstatic",
        "elastic",
        "elated",
        "elegant",
        "eloquent",
        "epic",
        "exciting",
        "fervent",
        "festive",
        "flamboyant",
        "focused",
        "friendly",
        "frosty",
        "funny",
        "gallant",
        "gifted",
        "goofy",
        "gracious",
        "great",
        "happy",
        "hardcore",
        "heuristic",
        "hopeful",
        "hungry",
        "infallible",
        "inspiring",
        "interesting",
        "intelligent",
        "jolly",
        "jovial",
        "keen",
        "kind",
        "laughing",
        "loving",
        "lucid",
        "magical",
        "mystifying",
        "modest",
        "musing",
        "naughty",
        "nervous",
        "nice",
        "nifty",
        "nostalgic",
        "objective",
        "optimistic",
        "peaceful",
        "pedantic",
        "pensive",
        "practical",
        "priceless",
        "quirky",
        "quizzical",
        "recursing",
        "relaxed",
        "reverent",
        "romantic",
        "sad",
        "serene",
        "sharp",
        "silly",
        "sleepy",
        "stoic",
        "strange",
        "stupefied",
        "suspicious",
        "sweet",
        "tender",
        "thirsty",
        "trusting",
        "unruffled",
        "upbeat",
        "vibrant",
        "vigilant",
        "vigorous",
        "wizardly",
        "wonderful",
        "xenodochial",
        "youthful",
        "zealous",
        "zen"
    ];
    this.right = [
        // Muhammad ibn Jābir al-Ḥarrānī al-Battānī was a founding father of astronomy. https://en.wikipedia.org/wiki/Mu%E1%B8%A5ammad_ibn_J%C4%81bir_al-%E1%B8%A4arr%C4%81n%C4%AB_al-Batt%C4%81n%C4%AB
        "albattani",
        // Frances E. Allen, became the first female IBM Fellow in 1989. In 2006, she became the first female recipient of the ACM's Turing Award. https://en.wikipedia.org/wiki/Frances_E._Allen
        "allen",
        // June Almeida - Scottish virologist who took the first pictures of the rubella virus - https://en.wikipedia.org/wiki/June_Almeida
        "almeida",
        // Kathleen Antonelli, American computer programmer and one of the six original programmers of the ENIAC - https://en.wikipedia.org/wiki/Kathleen_Antonelli
        "antonelli",
        // Maria Gaetana Agnesi - Italian mathematician, philosopher, theologian and humanitarian. She was the first woman to write a mathematics handbook and the first woman appointed as a Mathematics Professor at a University. https://en.wikipedia.org/wiki/Maria_Gaetana_Agnesi
        "agnesi",
        // Archimedes was a physicist, engineer and mathematician who invented too many things to list them here. https://en.wikipedia.org/wiki/Archimedes
        "archimedes",
        // Maria Ardinghelli - Italian translator, mathematician and physicist - https://en.wikipedia.org/wiki/Maria_Ardinghelli
        "ardinghelli",
        // Aryabhata - Ancient Indian mathematician-astronomer during 476-550 CE https://en.wikipedia.org/wiki/Aryabhata
        "aryabhata",
        // Wanda Austin - Wanda Austin is the President and CEO of The Aerospace Corporation, a leading architect for the US security space programs. https://en.wikipedia.org/wiki/Wanda_Austin
        "austin",
        // Charles Babbage invented the concept of a programmable computer. https://en.wikipedia.org/wiki/Charles_Babbage.
        "babbage",
        // Stefan Banach - Polish mathematician, was one of the founders of modern functional analysis. https://en.wikipedia.org/wiki/Stefan_Banach
        "banach",
        // Buckaroo Banzai and his mentor Dr. Hikita perfected the "oscillation overthruster", a device that allows one to pass through solid matter. - https://en.wikipedia.org/wiki/The_Adventures_of_Buckaroo_Banzai_Across_the_8th_Dimension
        "banzai",
        // John Bardeen co-invented the transistor - https://en.wikipedia.org/wiki/John_Bardeen
        "bardeen",
        // Jean Bartik, born Betty Jean Jennings, was one of the original programmers for the ENIAC computer. https://en.wikipedia.org/wiki/Jean_Bartik
        "bartik",
        // Laura Bassi, the world's first female professor https://en.wikipedia.org/wiki/Laura_Bassi
        "bassi",
        // Hugh Beaver, British engineer, founder of the Guinness Book of World Records https://en.wikipedia.org/wiki/Hugh_Beaver
        "beaver",
        // Alexander Graham Bell - an eminent Scottish-born scientist, inventor, engineer and innovator who is credited with inventing the first practical telephone - https://en.wikipedia.org/wiki/Alexander_Graham_Bell
        "bell",
        // Karl Friedrich Benz - a German automobile engineer. Inventor of the first practical motorcar. https://en.wikipedia.org/wiki/Karl_Benz
        "benz",
        // Homi J Bhabha - was an Indian nuclear physicist, founding director, and professor of physics at the Tata Institute of Fundamental Research. Colloquially known as "father of Indian nuclear programme"- https://en.wikipedia.org/wiki/Homi_J._Bhabha
        "bhabha",
        // Bhaskara II - Ancient Indian mathematician-astronomer whose work on calculus predates Newton and Leibniz by over half a millennium - https://en.wikipedia.org/wiki/Bh%C4%81skara_II#Calculus
        "bhaskara",
        // Sue Black - British computer scientist and campaigner. She has been instrumental in saving Bletchley Park, the site of World War II codebreaking - https://en.wikipedia.org/wiki/Sue_Black_(computer_scientist)
        "black",
        // Elizabeth Helen Blackburn - Australian-American Nobel laureate; best known for co-discovering telomerase. https://en.wikipedia.org/wiki/Elizabeth_Blackburn
        "blackburn",
        // Elizabeth Blackwell - American doctor and first American woman to receive a medical degree - https://en.wikipedia.org/wiki/Elizabeth_Blackwell
        "blackwell",
        // Niels Bohr is the father of quantum theory. https://en.wikipedia.org/wiki/Niels_Bohr.
        "bohr",
        // Kathleen Booth, she's credited with writing the first assembly language. https://en.wikipedia.org/wiki/Kathleen_Booth
        "booth",
        // Anita Borg - Anita Borg was the founding director of the Institute for Women and Technology (IWT). https://en.wikipedia.org/wiki/Anita_Borg
        "borg",
        // Satyendra Nath Bose - He provided the foundation for Bose–Einstein statistics and the theory of the Bose–Einstein condensate. - https://en.wikipedia.org/wiki/Satyendra_Nath_Bose
        "bose",
        // Katherine Louise Bouman is an imaging scientist and Assistant Professor of Computer Science at the California Institute of Technology. She researches computational methods for imaging, and developed an algorithm that made possible the picture first visualization of a black hole using the Event Horizon Telescope. - https://en.wikipedia.org/wiki/Katie_Bouman
        "bouman",
        // Evelyn Boyd Granville - She was one of the first African-American woman to receive a Ph.D. in mathematics; she earned it in 1949 from Yale University. https://en.wikipedia.org/wiki/Evelyn_Boyd_Granville
        "boyd",
        // Brahmagupta - Ancient Indian mathematician during 598-670 CE who gave rules to compute with zero - https://en.wikipedia.org/wiki/Brahmagupta#Zero
        "brahmagupta",
        // Walter Houser Brattain co-invented the transistor - https://en.wikipedia.org/wiki/Walter_Houser_Brattain
        "brattain",
        // Emmett Brown invented time travel. https://en.wikipedia.org/wiki/Emmett_Brown (thanks Brian Goff)
        "brown",
        // Linda Brown Buck - American biologist and Nobel laureate best known for her genetic and molecular analyses of the mechanisms of smell. https://en.wikipedia.org/wiki/Linda_B._Buck
        "buck",
        // Dame Susan Jocelyn Bell Burnell - Northern Irish astrophysicist who discovered radio pulsars and was the first to analyse them. https://en.wikipedia.org/wiki/Jocelyn_Bell_Burnell
        "burnell",
        // Annie Jump Cannon - pioneering female astronomer who classified hundreds of thousands of stars and created the system we use to understand stars today. https://en.wikipedia.org/wiki/Annie_Jump_Cannon
        "cannon",
        // Rachel Carson - American marine biologist and conservationist, her book Silent Spring and other writings are credited with advancing the global environmental movement. https://en.wikipedia.org/wiki/Rachel_Carson
        "carson",
        // Dame Mary Lucy Cartwright - British mathematician who was one of the first to study what is now known as chaos theory. Also known for Cartwright's theorem which finds applications in signal processing. https://en.wikipedia.org/wiki/Mary_Cartwright
        "cartwright",
        // George Washington Carver - American agricultural scientist and inventor. He was the most prominent black scientist of the early 20th century. https://en.wikipedia.org/wiki/George_Washington_Carver
        "carver",
        // Vinton Gray Cerf - American Internet pioneer, recognised as one of "the fathers of the Internet". With Robert Elliot Kahn, he designed TCP and IP, the primary data communication protocols of the Internet and other computer networks. https://en.wikipedia.org/wiki/Vint_Cerf
        "cerf",
        // Subrahmanyan Chandrasekhar - Astrophysicist known for his mathematical theory on different stages and evolution in structures of the stars. He has won nobel prize for physics - https://en.wikipedia.org/wiki/Subrahmanyan_Chandrasekhar
        "chandrasekhar",
        // Sergey Alexeyevich Chaplygin (Russian: Серге́й Алексе́евич Чаплы́гин; April 5, 1869 – October 8, 1942) was a Russian and Soviet physicist, mathematician, and mechanical engineer. He is known for mathematical formulas such as Chaplygin's equation and for a hypothetical substance in cosmology called Chaplygin gas, named after him. https://en.wikipedia.org/wiki/Sergey_Chaplygin
        "chaplygin",
        // Émilie du Châtelet - French natural philosopher, mathematician, physicist, and author during the early 1730s, known for her translation of and commentary on Isaac Newton's book Principia containing basic laws of physics. https://en.wikipedia.org/wiki/%C3%89milie_du_Ch%C3%A2telet
        "chatelet",
        // Asima Chatterjee was an Indian organic chemist noted for her research on vinca alkaloids, development of drugs for treatment of epilepsy and malaria - https://en.wikipedia.org/wiki/Asima_Chatterjee
        "chatterjee",
        // Pafnuty Chebyshev - Russian mathematician. He is known fo his works on probability, statistics, mechanics, analytical geometry and number theory https://en.wikipedia.org/wiki/Pafnuty_Chebyshev
        "chebyshev",
        // Bram Cohen - American computer programmer and author of the BitTorrent peer-to-peer protocol. https://en.wikipedia.org/wiki/Bram_Cohen
        "cohen",
        // David Lee Chaum - American computer scientist and cryptographer. Known for his seminal contributions in the field of anonymous communication. https://en.wikipedia.org/wiki/David_Chaum
        "chaum",
        // Joan Clarke - Bletchley Park code breaker during the Second World War who pioneered techniques that remained top secret for decades. Also an accomplished numismatist https://en.wikipedia.org/wiki/Joan_Clarke
        "clarke",
        // Jane Colden - American botanist widely considered the first female American botanist - https://en.wikipedia.org/wiki/Jane_Colden
        "colden",
        // Gerty Theresa Cori - American biochemist who became the third woman—and first American woman—to win a Nobel Prize in science, and the first woman to be awarded the Nobel Prize in Physiology or Medicine. Cori was born in Prague. https://en.wikipedia.org/wiki/Gerty_Cori
        "cori",
        // Seymour Roger Cray was an American electrical engineer and supercomputer architect who designed a series of computers that were the fastest in the world for decades. https://en.wikipedia.org/wiki/Seymour_Cray
        "cray",
        // This entry reflects a husband and wife team who worked together:
        // Joan Curran was a Welsh scientist who developed radar and invented chaff, a radar countermeasure. https://en.wikipedia.org/wiki/Joan_Curran
        // Samuel Curran was an Irish physicist who worked alongside his wife during WWII and invented the proximity fuse. https://en.wikipedia.org/wiki/Samuel_Curran
        "curran",
        // Marie Curie discovered radioactivity. https://en.wikipedia.org/wiki/Marie_Curie.
        "curie",
        // Charles Darwin established the principles of natural evolution. https://en.wikipedia.org/wiki/Charles_Darwin.
        "darwin",
        // Leonardo Da Vinci invented too many things to list here. https://en.wikipedia.org/wiki/Leonardo_da_Vinci.
        "davinci",
        // A. K. (Alexander Keewatin) Dewdney, Canadian mathematician, computer scientist, author and filmmaker. Contributor to Scientific American's "Computer Recreations" from 1984 to 1991. Author of Core War (program), The Planiverse, The Armchair Universe, The Magic Machine, The New Turing Omnibus, and more. https://en.wikipedia.org/wiki/Alexander_Dewdney
        "dewdney",
        // Satish Dhawan - Indian mathematician and aerospace engineer, known for leading the successful and indigenous development of the Indian space programme. https://en.wikipedia.org/wiki/Satish_Dhawan
        "dhawan",
        // Bailey Whitfield Diffie - American cryptographer and one of the pioneers of public-key cryptography. https://en.wikipedia.org/wiki/Whitfield_Diffie
        "diffie",
        // Edsger Wybe Dijkstra was a Dutch computer scientist and mathematical scientist. https://en.wikipedia.org/wiki/Edsger_W._Dijkstra.
        "dijkstra",
        // Paul Adrien Maurice Dirac - English theoretical physicist who made fundamental contributions to the early development of both quantum mechanics and quantum electrodynamics. https://en.wikipedia.org/wiki/Paul_Dirac
        "dirac",
        // Agnes Meyer Driscoll - American cryptanalyst during World Wars I and II who successfully cryptanalysed a number of Japanese ciphers. She was also the co-developer of one of the cipher machines of the US Navy, the CM. https://en.wikipedia.org/wiki/Agnes_Meyer_Driscoll
        "driscoll",
        // Donna Dubinsky - played an integral role in the development of personal digital assistants (PDAs) serving as CEO of Palm, Inc. and co-founding Handspring. https://en.wikipedia.org/wiki/Donna_Dubinsky
        "dubinsky",
        // Annie Easley - She was a leading member of the team which developed software for the Centaur rocket stage and one of the first African-Americans in her field. https://en.wikipedia.org/wiki/Annie_Easley
        "easley",
        // Thomas Alva Edison, prolific inventor https://en.wikipedia.org/wiki/Thomas_Edison
        "edison",
        // Albert Einstein invented the general theory of relativity. https://en.wikipedia.org/wiki/Albert_Einstein
        "einstein",
        // Alexandra Asanovna Elbakyan (Russian: Алекса́ндра Аса́новна Элбакя́н) is a Kazakhstani graduate student, computer programmer, internet pirate in hiding, and the creator of the site Sci-Hub. Nature has listed her in 2016 in the top ten people that mattered in science, and Ars Technica has compared her to Aaron Swartz. - https://en.wikipedia.org/wiki/Alexandra_Elbakyan
        "elbakyan",
        // Taher A. ElGamal - Egyptian cryptographer best known for the ElGamal discrete log cryptosystem and the ElGamal digital signature scheme. https://en.wikipedia.org/wiki/Taher_Elgamal
        "elgamal",
        // Gertrude Elion - American biochemist, pharmacologist and the 1988 recipient of the Nobel Prize in Medicine - https://en.wikipedia.org/wiki/Gertrude_Elion
        "elion",
        // James Henry Ellis - British engineer and cryptographer employed by the GCHQ. Best known for conceiving for the first time, the idea of public-key cryptography. https://en.wikipedia.org/wiki/James_H._Ellis
        "ellis",
        // Douglas Engelbart gave the mother of all demos: https://en.wikipedia.org/wiki/Douglas_Engelbart
        "engelbart",
        // Euclid invented geometry. https://en.wikipedia.org/wiki/Euclid
        "euclid",
        // Leonhard Euler invented large parts of modern mathematics. https://de.wikipedia.org/wiki/Leonhard_Euler
        "euler",
        // Michael Faraday - British scientist who contributed to the study of electromagnetism and electrochemistry. https://en.wikipedia.org/wiki/Michael_Faraday
        "faraday",
        // Horst Feistel - German-born American cryptographer who was one of the earliest non-government researchers to study the design and theory of block ciphers. Co-developer of DES and Lucifer. Feistel networks, a symmetric structure used in the construction of block ciphers are named after him. https://en.wikipedia.org/wiki/Horst_Feistel
        "feistel",
        // Pierre de Fermat pioneered several aspects of modern mathematics. https://en.wikipedia.org/wiki/Pierre_de_Fermat
        "fermat",
        // Enrico Fermi invented the first nuclear reactor. https://en.wikipedia.org/wiki/Enrico_Fermi.
        "fermi",
        // Richard Feynman was a key contributor to quantum mechanics and particle physics. https://en.wikipedia.org/wiki/Richard_Feynman
        "feynman",
        // Benjamin Franklin is famous for his experiments in electricity and the invention of the lightning rod.
        "franklin",
        // Yuri Alekseyevich Gagarin - Soviet pilot and cosmonaut, best known as the first human to journey into outer space. https://en.wikipedia.org/wiki/Yuri_Gagarin
        "gagarin",
        // Galileo was a founding father of modern astronomy, and faced politics and obscurantism to establish scientific truth.  https://en.wikipedia.org/wiki/Galileo_Galilei
        "galileo",
        // Évariste Galois - French mathematician whose work laid the foundations of Galois theory and group theory, two major branches of abstract algebra, and the subfield of Galois connections, all while still in his late teens. https://en.wikipedia.org/wiki/%C3%89variste_Galois
        "galois",
        // Kadambini Ganguly - Indian physician, known for being the first South Asian female physician, trained in western medicine, to graduate in South Asia. https://en.wikipedia.org/wiki/Kadambini_Ganguly
        "ganguly",
        // William Henry "Bill" Gates III is an American business magnate, philanthropist, investor, computer programmer, and inventor. https://en.wikipedia.org/wiki/Bill_Gates
        "gates",
        // Johann Carl Friedrich Gauss - German mathematician who made significant contributions to many fields, including number theory, algebra, statistics, analysis, differential geometry, geodesy, geophysics, mechanics, electrostatics, magnetic fields, astronomy, matrix theory, and optics. https://en.wikipedia.org/wiki/Carl_Friedrich_Gauss
        "gauss",
        // Marie-Sophie Germain - French mathematician, physicist and philosopher. Known for her work on elasticity theory, number theory and philosophy. https://en.wikipedia.org/wiki/Sophie_Germain
        "germain",
        // Adele Goldberg, was one of the designers and developers of the Smalltalk language. https://en.wikipedia.org/wiki/Adele_Goldberg_(computer_scientist)
        "goldberg",
        // Adele Goldstine, born Adele Katz, wrote the complete technical description for the first electronic digital computer, ENIAC. https://en.wikipedia.org/wiki/Adele_Goldstine
        "goldstine",
        // Shafi Goldwasser is a computer scientist known for creating theoretical foundations of modern cryptography. Winner of 2012 ACM Turing Award. https://en.wikipedia.org/wiki/Shafi_Goldwasser
        "goldwasser",
        // James Golick, all around gangster.
        "golick",
        // Jane Goodall - British primatologist, ethologist, and anthropologist who is considered to be the world's foremost expert on chimpanzees - https://en.wikipedia.org/wiki/Jane_Goodall
        "goodall",
        // Stephen Jay Gould was was an American paleontologist, evolutionary biologist, and historian of science. He is most famous for the theory of punctuated equilibrium - https://en.wikipedia.org/wiki/Stephen_Jay_Gould
        "gould",
        // Carolyn Widney Greider - American molecular biologist and joint winner of the 2009 Nobel Prize for Physiology or Medicine for the discovery of telomerase. https://en.wikipedia.org/wiki/Carol_W._Greider
        "greider",
        // Alexander Grothendieck - German-born French mathematician who became a leading figure in the creation of modern algebraic geometry. https://en.wikipedia.org/wiki/Alexander_Grothendieck
        "grothendieck",
        // Lois Haibt - American computer scientist, part of the team at IBM that developed FORTRAN - https://en.wikipedia.org/wiki/Lois_Haibt
        "haibt",
        // Margaret Hamilton - Director of the Software Engineering Division of the MIT Instrumentation Laboratory, which developed on-board flight software for the Apollo space program. https://en.wikipedia.org/wiki/Margaret_Hamilton_(scientist)
        "hamilton",
        // Caroline Harriet Haslett - English electrical engineer, electricity industry administrator and champion of women's rights. Co-author of British Standard 1363 that specifies AC power plugs and sockets used across the United Kingdom (which is widely considered as one of the safest designs). https://en.wikipedia.org/wiki/Caroline_Haslett
        "haslett",
        // Stephen Hawking pioneered the field of cosmology by combining general relativity and quantum mechanics. https://en.wikipedia.org/wiki/Stephen_Hawking
        "hawking",
        // Martin Edward Hellman - American cryptologist, best known for his invention of public-key cryptography in co-operation with Whitfield Diffie and Ralph Merkle. https://en.wikipedia.org/wiki/Martin_Hellman
        "hellman",
        // Werner Heisenberg was a founding father of quantum mechanics. https://en.wikipedia.org/wiki/Werner_Heisenberg
        "heisenberg",
        // Grete Hermann was a German philosopher noted for her philosophical work on the foundations of quantum mechanics. https://en.wikipedia.org/wiki/Grete_Hermann
        "hermann",
        // Caroline Lucretia Herschel - German astronomer and discoverer of several comets. https://en.wikipedia.org/wiki/Caroline_Herschel
        "herschel",
        // Heinrich Rudolf Hertz - German physicist who first conclusively proved the existence of the electromagnetic waves. https://en.wikipedia.org/wiki/Heinrich_Hertz
        "hertz",
        // Jaroslav Heyrovský was the inventor of the polarographic method, father of the electroanalytical method, and recipient of the Nobel Prize in 1959. His main field of work was polarography. https://en.wikipedia.org/wiki/Jaroslav_Heyrovsk%C3%BD
        "heyrovsky",
        // Dorothy Hodgkin was a British biochemist, credited with the development of protein crystallography. She was awarded the Nobel Prize in Chemistry in 1964. https://en.wikipedia.org/wiki/Dorothy_Hodgkin
        "hodgkin",
        // Douglas R. Hofstadter is an American professor of cognitive science and author of the Pulitzer Prize and American Book Award-winning work Goedel, Escher, Bach: An Eternal Golden Braid in 1979. A mind-bending work which coined Hofstadter's Law: "It always takes longer than you expect, even when you take into account Hofstadter's Law." https://en.wikipedia.org/wiki/Douglas_Hofstadter
        "hofstadter",
        // Erna Schneider Hoover revolutionized modern communication by inventing a computerized telephone switching method. https://en.wikipedia.org/wiki/Erna_Schneider_Hoover
        "hoover",
        // Grace Hopper developed the first compiler for a computer programming language and  is credited with popularizing the term "debugging" for fixing computer glitches. https://en.wikipedia.org/wiki/Grace_Hopper
        "hopper",
        // Frances Hugle, she was an American scientist, engineer, and inventor who contributed to the understanding of semiconductors, integrated circuitry, and the unique electrical principles of microscopic materials. https://en.wikipedia.org/wiki/Frances_Hugle
        "hugle",
        // Hypatia - Greek Alexandrine Neoplatonist philosopher in Egypt who was one of the earliest mothers of mathematics - https://en.wikipedia.org/wiki/Hypatia
        "hypatia",
        // Teruko Ishizaka - Japanese scientist and immunologist who co-discovered the antibody class Immunoglobulin E. https://en.wikipedia.org/wiki/Teruko_Ishizaka
        "ishizaka",
        // Mary Jackson, American mathematician and aerospace engineer who earned the highest title within NASA's engineering department - https://en.wikipedia.org/wiki/Mary_Jackson_(engineer)
        "jackson",
        // Yeong-Sil Jang was a Korean scientist and astronomer during the Joseon Dynasty; he invented the first metal printing press and water gauge. https://en.wikipedia.org/wiki/Jang_Yeong-sil
        "jang",
        // Mae Carol Jemison -  is an American engineer, physician, and former NASA astronaut. She became the first black woman to travel in space when she served as a mission specialist aboard the Space Shuttle Endeavour - https://en.wikipedia.org/wiki/Mae_Jemison
        "jemison",
        // Betty Jennings - one of the original programmers of the ENIAC. https://en.wikipedia.org/wiki/ENIAC - https://en.wikipedia.org/wiki/Jean_Bartik
        "jennings",
        // Mary Lou Jepsen, was the founder and chief technology officer of One Laptop Per Child (OLPC), and the founder of Pixel Qi. https://en.wikipedia.org/wiki/Mary_Lou_Jepsen
        "jepsen",
        // Katherine Coleman Goble Johnson - American physicist and mathematician contributed to the NASA. https://en.wikipedia.org/wiki/Katherine_Johnson
        "johnson",
        // Irène Joliot-Curie - French scientist who was awarded the Nobel Prize for Chemistry in 1935. Daughter of Marie and Pierre Curie. https://en.wikipedia.org/wiki/Ir%C3%A8ne_Joliot-Curie
        "joliot",
        // Karen Spärck Jones came up with the concept of inverse document frequency, which is used in most search engines today. https://en.wikipedia.org/wiki/Karen_Sp%C3%A4rck_Jones
        "jones",
        // A. P. J. Abdul Kalam - is an Indian scientist aka Missile Man of India for his work on the development of ballistic missile and launch vehicle technology - https://en.wikipedia.org/wiki/A._P._J._Abdul_Kalam
        "kalam",
        // Sergey Petrovich Kapitsa (Russian: Серге́й Петро́вич Капи́ца; 14 February 1928 – 14 August 2012) was a Russian physicist and demographer. He was best known as host of the popular and long-running Russian scientific TV show, Evident, but Incredible. His father was the Nobel laureate Soviet-era physicist Pyotr Kapitsa, and his brother was the geographer and Antarctic explorer Andrey Kapitsa. - https://en.wikipedia.org/wiki/Sergey_Kapitsa
        "kapitsa",
        // Susan Kare, created the icons and many of the interface elements for the original Apple Macintosh in the 1980s, and was an original employee of NeXT, working as the Creative Director. https://en.wikipedia.org/wiki/Susan_Kare
        "kare",
        // Mstislav Keldysh - a Soviet scientist in the field of mathematics and mechanics, academician of the USSR Academy of Sciences (1946), President of the USSR Academy of Sciences (1961–1975), three times Hero of Socialist Labor (1956, 1961, 1971), fellow of the Royal Society of Edinburgh (1968). https://en.wikipedia.org/wiki/Mstislav_Keldysh
        "keldysh",
        // Mary Kenneth Keller, Sister Mary Kenneth Keller became the first American woman to earn a PhD in Computer Science in 1965. https://en.wikipedia.org/wiki/Mary_Kenneth_Keller
        "keller",
        // Johannes Kepler, German astronomer known for his three laws of planetary motion - https://en.wikipedia.org/wiki/Johannes_Kepler
        "kepler",
        // Omar Khayyam - Persian mathematician, astronomer and poet. Known for his work on the classification and solution of cubic equations, for his contribution to the understanding of Euclid's fifth postulate and for computing the length of a year very accurately. https://en.wikipedia.org/wiki/Omar_Khayyam
        "khayyam",
        // Har Gobind Khorana - Indian-American biochemist who shared the 1968 Nobel Prize for Physiology - https://en.wikipedia.org/wiki/Har_Gobind_Khorana
        "khorana",
        // Jack Kilby invented silicon integrated circuits and gave Silicon Valley its name. - https://en.wikipedia.org/wiki/Jack_Kilby
        "kilby",
        // Maria Kirch - German astronomer and first woman to discover a comet - https://en.wikipedia.org/wiki/Maria_Margarethe_Kirch
        "kirch",
        // Donald Knuth - American computer scientist, author of "The Art of Computer Programming" and creator of the TeX typesetting system. https://en.wikipedia.org/wiki/Donald_Knuth
        "knuth",
        // Sophie Kowalevski - Russian mathematician responsible for important original contributions to analysis, differential equations and mechanics - https://en.wikipedia.org/wiki/Sofia_Kovalevskaya
        "kowalevski",
        // Marie-Jeanne de Lalande - French astronomer, mathematician and cataloguer of stars - https://en.wikipedia.org/wiki/Marie-Jeanne_de_Lalande
        "lalande",
        // Hedy Lamarr - Actress and inventor. The principles of her work are now incorporated into modern Wi-Fi, CDMA and Bluetooth technology. https://en.wikipedia.org/wiki/Hedy_Lamarr
        "lamarr",
        // Leslie B. Lamport - American computer scientist. Lamport is best known for his seminal work in distributed systems and was the winner of the 2013 Turing Award. https://en.wikipedia.org/wiki/Leslie_Lamport
        "lamport",
        // Mary Leakey - British paleoanthropologist who discovered the first fossilized Proconsul skull - https://en.wikipedia.org/wiki/Mary_Leakey
        "leakey",
        // Henrietta Swan Leavitt - she was an American astronomer who discovered the relation between the luminosity and the period of Cepheid variable stars. https://en.wikipedia.org/wiki/Henrietta_Swan_Leavitt
        "leavitt",
        // Esther Miriam Zimmer Lederberg - American microbiologist and a pioneer of bacterial genetics. https://en.wikipedia.org/wiki/Esther_Lederberg
        "lederberg",
        // Inge Lehmann - Danish seismologist and geophysicist. Known for discovering in 1936 that the Earth has a solid inner core inside a molten outer core. https://en.wikipedia.org/wiki/Inge_Lehmann
        "lehmann",
        // Daniel Lewin - Mathematician, Akamai co-founder, soldier, 9/11 victim-- Developed optimization techniques for routing traffic on the internet. Died attempting to stop the 9-11 hijackers. https://en.wikipedia.org/wiki/Daniel_Lewin
        "lewin",
        // Ruth Lichterman - one of the original programmers of the ENIAC. https://en.wikipedia.org/wiki/ENIAC - https://en.wikipedia.org/wiki/Ruth_Teitelbaum
        "lichterman",
        // Barbara Liskov - co-developed the Liskov substitution principle. Liskov was also the winner of the Turing Prize in 2008. - https://en.wikipedia.org/wiki/Barbara_Liskov
        "liskov",
        // Ada Lovelace invented the first algorithm. https://en.wikipedia.org/wiki/Ada_Lovelace (thanks James Turnbull)
        "lovelace",
        // Auguste and Louis Lumière - the first filmmakers in history - https://en.wikipedia.org/wiki/Auguste_and_Louis_Lumi%C3%A8re
        "lumiere",
        // Mahavira - Ancient Indian mathematician during 9th century AD who discovered basic algebraic identities - https://en.wikipedia.org/wiki/Mah%C4%81v%C4%ABra_(mathematician)
        "mahavira",
        // Lynn Margulis (b. Lynn Petra Alexander) - an American evolutionary theorist and biologist, science author, educator, and popularizer, and was the primary modern proponent for the significance of symbiosis in evolution. - https://en.wikipedia.org/wiki/Lynn_Margulis
        "margulis",
        // Yukihiro Matsumoto - Japanese computer scientist and software programmer best known as the chief designer of the Ruby programming language. https://en.wikipedia.org/wiki/Yukihiro_Matsumoto
        "matsumoto",
        // James Clerk Maxwell - Scottish physicist, best known for his formulation of electromagnetic theory. https://en.wikipedia.org/wiki/James_Clerk_Maxwell
        "maxwell",
        // Maria Mayer - American theoretical physicist and Nobel laureate in Physics for proposing the nuclear shell model of the atomic nucleus - https://en.wikipedia.org/wiki/Maria_Mayer
        "mayer",
        // John McCarthy invented LISP: https://en.wikipedia.org/wiki/John_McCarthy_(computer_scientist)
        "mccarthy",
        // Barbara McClintock - a distinguished American cytogeneticist, 1983 Nobel Laureate in Physiology or Medicine for discovering transposons. https://en.wikipedia.org/wiki/Barbara_McClintock
        "mcclintock",
        // Anne Laura Dorinthea McLaren - British developmental biologist whose work helped lead to human in-vitro fertilisation. https://en.wikipedia.org/wiki/Anne_McLaren
        "mclaren",
        // Malcolm McLean invented the modern shipping container: https://en.wikipedia.org/wiki/Malcom_McLean
        "mclean",
        // Kay McNulty - one of the original programmers of the ENIAC. https://en.wikipedia.org/wiki/ENIAC - https://en.wikipedia.org/wiki/Kathleen_Antonelli
        "mcnulty",
        // Gregor Johann Mendel - Czech scientist and founder of genetics. https://en.wikipedia.org/wiki/Gregor_Mendel
        "mendel",
        // Dmitri Mendeleev - a chemist and inventor. He formulated the Periodic Law, created a farsighted version of the periodic table of elements, and used it to correct the properties of some already discovered elements and also to predict the properties of eight elements yet to be discovered. https://en.wikipedia.org/wiki/Dmitri_Mendeleev
        "mendeleev",
        // Lise Meitner - Austrian/Swedish physicist who was involved in the discovery of nuclear fission. The element meitnerium is named after her - https://en.wikipedia.org/wiki/Lise_Meitner
        "meitner",
        // Carla Meninsky, was the game designer and programmer for Atari 2600 games Dodge 'Em and Warlords. https://en.wikipedia.org/wiki/Carla_Meninsky
        "meninsky",
        // Ralph C. Merkle - American computer scientist, known for devising Merkle's puzzles - one of the very first schemes for public-key cryptography. Also, inventor of Merkle trees and co-inventor of the Merkle-Damgård construction for building collision-resistant cryptographic hash functions and the Merkle-Hellman knapsack cryptosystem. https://en.wikipedia.org/wiki/Ralph_Merkle
        "merkle",
        // Johanna Mestorf - German prehistoric archaeologist and first female museum director in Germany - https://en.wikipedia.org/wiki/Johanna_Mestorf
        "mestorf",
        // Maryam Mirzakhani - an Iranian mathematician and the first woman to win the Fields Medal. https://en.wikipedia.org/wiki/Maryam_Mirzakhani
        "mirzakhani",
        // Rita Levi-Montalcini - Won Nobel Prize in Physiology or Medicine jointly with colleague Stanley Cohen for the discovery of nerve growth factor (https://en.wikipedia.org/wiki/Rita_Levi-Montalcini)
        "montalcini",
        // Gordon Earle Moore - American engineer, Silicon Valley founding father, author of Moore's law. https://en.wikipedia.org/wiki/Gordon_Moore
        "moore",
        // Samuel Morse - contributed to the invention of a single-wire telegraph system based on European telegraphs and was a co-developer of the Morse code - https://en.wikipedia.org/wiki/Samuel_Morse
        "morse",
        // Ian Murdock - founder of the Debian project - https://en.wikipedia.org/wiki/Ian_Murdock
        "murdock",
        // May-Britt Moser - Nobel prize winner neuroscientist who contributed to the discovery of grid cells in the brain. https://en.wikipedia.org/wiki/May-Britt_Moser
        "moser",
        // John Napier of Merchiston - Scottish landowner known as an astronomer, mathematician and physicist. Best known for his discovery of logarithms. https://en.wikipedia.org/wiki/John_Napier
        "napier",
        // John Forbes Nash, Jr. - American mathematician who made fundamental contributions to game theory, differential geometry, and the study of partial differential equations. https://en.wikipedia.org/wiki/John_Forbes_Nash_Jr.
        "nash",
        // John von Neumann - todays computer architectures are based on the von Neumann architecture. https://en.wikipedia.org/wiki/Von_Neumann_architecture
        "neumann",
        // Isaac Newton invented classic mechanics and modern optics. https://en.wikipedia.org/wiki/Isaac_Newton
        "newton",
        // Florence Nightingale, more prominently known as a nurse, was also the first female member of the Royal Statistical Society and a pioneer in statistical graphics https://en.wikipedia.org/wiki/Florence_Nightingale#Statistics_and_sanitary_reform
        "nightingale",
        // Alfred Nobel - a Swedish chemist, engineer, innovator, and armaments manufacturer (inventor of dynamite) - https://en.wikipedia.org/wiki/Alfred_Nobel
        "nobel",
        // Emmy Noether, German mathematician. Noether's Theorem is named after her. https://en.wikipedia.org/wiki/Emmy_Noether
        "noether",
        // Poppy Northcutt. Poppy Northcutt was the first woman to work as part of NASA’s Mission Control. http://www.businessinsider.com/poppy-northcutt-helped-apollo-astronauts-2014-12?op=1
        "northcutt",
        // Robert Noyce invented silicon integrated circuits and gave Silicon Valley its name. - https://en.wikipedia.org/wiki/Robert_Noyce
        "noyce",
        // Panini - Ancient Indian linguist and grammarian from 4th century CE who worked on the world's first formal system - https://en.wikipedia.org/wiki/P%C4%81%E1%B9%87ini#Comparison_with_modern_formal_systems
        "panini",
        // Ambroise Pare invented modern surgery. https://en.wikipedia.org/wiki/Ambroise_Par%C3%A9
        "pare",
        // Blaise Pascal, French mathematician, physicist, and inventor - https://en.wikipedia.org/wiki/Blaise_Pascal
        "pascal",
        // Louis Pasteur discovered vaccination, fermentation and pasteurization. https://en.wikipedia.org/wiki/Louis_Pasteur.
        "pasteur",
        // Cecilia Payne-Gaposchkin was an astronomer and astrophysicist who, in 1925, proposed in her Ph.D. thesis an explanation for the composition of stars in terms of the relative abundances of hydrogen and helium. https://en.wikipedia.org/wiki/Cecilia_Payne-Gaposchkin
        "payne",
        // Radia Perlman is a software designer and network engineer and most famous for her invention of the spanning-tree protocol (STP). https://en.wikipedia.org/wiki/Radia_Perlman
        "perlman",
        // Rob Pike was a key contributor to Unix, Plan 9, the X graphic system, utf-8, and the Go programming language. https://en.wikipedia.org/wiki/Rob_Pike
        "pike",
        // Henri Poincaré made fundamental contributions in several fields of mathematics. https://en.wikipedia.org/wiki/Henri_Poincar%C3%A9
        "poincare",
        // Laura Poitras is a director and producer whose work, made possible by open source crypto tools, advances the causes of truth and freedom of information by reporting disclosures by whistleblowers such as Edward Snowden. https://en.wikipedia.org/wiki/Laura_Poitras
        "poitras",
        // Tat’yana Avenirovna Proskuriakova (Russian: Татья́на Авени́ровна Проскуряко́ва) (January 23 [O.S. January 10] 1909 – August 30, 1985) was a Russian-American Mayanist scholar and archaeologist who contributed significantly to the deciphering of Maya hieroglyphs, the writing system of the pre-Columbian Maya civilization of Mesoamerica. https://en.wikipedia.org/wiki/Tatiana_Proskouriakoff
        "proskuriakova",
        // Claudius Ptolemy - a Greco-Egyptian writer of Alexandria, known as a mathematician, astronomer, geographer, astrologer, and poet of a single epigram in the Greek Anthology - https://en.wikipedia.org/wiki/Ptolemy
        "ptolemy",
        // C. V. Raman - Indian physicist who won the Nobel Prize in 1930 for proposing the Raman effect. - https://en.wikipedia.org/wiki/C._V._Raman
        "raman",
        // Srinivasa Ramanujan - Indian mathematician and autodidact who made extraordinary contributions to mathematical analysis, number theory, infinite series, and continued fractions. - https://en.wikipedia.org/wiki/Srinivasa_Ramanujan
        "ramanujan",
        // Sally Kristen Ride was an American physicist and astronaut. She was the first American woman in space, and the youngest American astronaut. https://en.wikipedia.org/wiki/Sally_Ride
        "ride",
        // Dennis Ritchie - co-creator of UNIX and the C programming language. - https://en.wikipedia.org/wiki/Dennis_Ritchie
        "ritchie",
        // Ida Rhodes - American pioneer in computer programming, designed the first computer used for Social Security. https://en.wikipedia.org/wiki/Ida_Rhodes
        "rhodes",
        // Julia Hall Bowman Robinson - American mathematician renowned for her contributions to the fields of computability theory and computational complexity theory. https://en.wikipedia.org/wiki/Julia_Robinson
        "robinson",
        // Wilhelm Conrad Röntgen - German physicist who was awarded the first Nobel Prize in Physics in 1901 for the discovery of X-rays (Röntgen rays). https://en.wikipedia.org/wiki/Wilhelm_R%C3%B6ntgen
        "roentgen",
        // Rosalind Franklin - British biophysicist and X-ray crystallographer whose research was critical to the understanding of DNA - https://en.wikipedia.org/wiki/Rosalind_Franklin
        "rosalind",
        // Vera Rubin - American astronomer who pioneered work on galaxy rotation rates. https://en.wikipedia.org/wiki/Vera_Rubin
        "rubin",
        // Meghnad Saha - Indian astrophysicist best known for his development of the Saha equation, used to describe chemical and physical conditions in stars - https://en.wikipedia.org/wiki/Meghnad_Saha
        "saha",
        // Jean E. Sammet developed FORMAC, the first widely used computer language for symbolic manipulation of mathematical formulas. https://en.wikipedia.org/wiki/Jean_E._Sammet
        "sammet",
        // Mildred Sanderson - American mathematician best known for Sanderson's theorem concerning modular invariants. https://en.wikipedia.org/wiki/Mildred_Sanderson
        "sanderson",
        // Satoshi Nakamoto is the name used by the unknown person or group of people who developed bitcoin, authored the bitcoin white paper, and created and deployed bitcoin's original reference implementation. https://en.wikipedia.org/wiki/Satoshi_Nakamoto
        "satoshi",
        // Adi Shamir - Israeli cryptographer whose numerous inventions and contributions to cryptography include the Ferge Fiat Shamir identification scheme, the Rivest Shamir Adleman (RSA) public-key cryptosystem, the Shamir's secret sharing scheme, the breaking of the Merkle-Hellman cryptosystem, the TWINKLE and TWIRL factoring devices and the discovery of differential cryptanalysis (with Eli Biham). https://en.wikipedia.org/wiki/Adi_Shamir
        "shamir",
        // Claude Shannon - The father of information theory and founder of digital circuit design theory. (https://en.wikipedia.org/wiki/Claude_Shannon)
        "shannon",
        // Carol Shaw - Originally an Atari employee, Carol Shaw is said to be the first female video game designer. https://en.wikipedia.org/wiki/Carol_Shaw_(video_game_designer)
        "shaw",
        // Dame Stephanie "Steve" Shirley - Founded a software company in 1962 employing women working from home. https://en.wikipedia.org/wiki/Steve_Shirley
        "shirley",
        // William Shockley co-invented the transistor - https://en.wikipedia.org/wiki/William_Shockley
        "shockley",
        // Lina Solomonovna Stern (or Shtern; Russian: Лина Соломоновна Штерн; 26 August 1878 – 7 March 1968) was a Soviet biochemist, physiologist and humanist whose medical discoveries saved thousands of lives at the fronts of World War II. She is best known for her pioneering work on blood–brain barrier, which she described as hemato-encephalic barrier in 1921. https://en.wikipedia.org/wiki/Lina_Stern
        "shtern",
        // Françoise Barré-Sinoussi - French virologist and Nobel Prize Laureate in Physiology or Medicine; her work was fundamental in identifying HIV as the cause of AIDS. https://en.wikipedia.org/wiki/Fran%C3%A7oise_Barr%C3%A9-Sinoussi
        "sinoussi",
        // Betty Snyder - one of the original programmers of the ENIAC. https://en.wikipedia.org/wiki/ENIAC - https://en.wikipedia.org/wiki/Betty_Holberton
        "snyder",
        // Cynthia Solomon - Pioneer in the fields of artificial intelligence, computer science and educational computing. Known for creation of Logo, an educational programming language.  https://en.wikipedia.org/wiki/Cynthia_Solomon
        "solomon",
        // Frances Spence - one of the original programmers of the ENIAC. https://en.wikipedia.org/wiki/ENIAC - https://en.wikipedia.org/wiki/Frances_Spence
        "spence",
        // Michael Stonebraker is a database research pioneer and architect of Ingres, Postgres, VoltDB and SciDB. Winner of 2014 ACM Turing Award. https://en.wikipedia.org/wiki/Michael_Stonebraker
        "stonebraker",
        // Ivan Edward Sutherland - American computer scientist and Internet pioneer, widely regarded as the father of computer graphics. https://en.wikipedia.org/wiki/Ivan_Sutherland
        "sutherland",
        // Janese Swanson (with others) developed the first of the Carmen Sandiego games. She went on to found Girl Tech. https://en.wikipedia.org/wiki/Janese_Swanson
        "swanson",
        // Aaron Swartz was influential in creating RSS, Markdown, Creative Commons, Reddit, and much of the internet as we know it today. He was devoted to freedom of information on the web. https://en.wikiquote.org/wiki/Aaron_Swartz
        "swartz",
        // Bertha Swirles was a theoretical physicist who made a number of contributions to early quantum theory. https://en.wikipedia.org/wiki/Bertha_Swirles
        "swirles",
        // Helen Brooke Taussig - American cardiologist and founder of the field of paediatric cardiology. https://en.wikipedia.org/wiki/Helen_B._Taussig
        "taussig",
        // Valentina Tereshkova is a Russian engineer, cosmonaut and politician. She was the first woman to fly to space in 1963. In 2013, at the age of 76, she offered to go on a one-way mission to Mars. https://en.wikipedia.org/wiki/Valentina_Tereshkova
        "tereshkova",
        // Nikola Tesla invented the AC electric system and every gadget ever used by a James Bond villain. https://en.wikipedia.org/wiki/Nikola_Tesla
        "tesla",
        // Marie Tharp - American geologist and oceanic cartographer who co-created the first scientific map of the Atlantic Ocean floor. Her work led to the acceptance of the theories of plate tectonics and continental drift. https://en.wikipedia.org/wiki/Marie_Tharp
        "tharp",
        // Ken Thompson - co-creator of UNIX and the C programming language - https://en.wikipedia.org/wiki/Ken_Thompson
        "thompson",
        // Linus Torvalds invented Linux and Git. https://en.wikipedia.org/wiki/Linus_Torvalds
        "torvalds",
        // Youyou Tu - Chinese pharmaceutical chemist and educator known for discovering artemisinin and dihydroartemisinin, used to treat malaria, which has saved millions of lives. Joint winner of the 2015 Nobel Prize in Physiology or Medicine. https://en.wikipedia.org/wiki/Tu_Youyou
        "tu",
        // Alan Turing was a founding father of computer science. https://en.wikipedia.org/wiki/Alan_Turing.
        "turing",
        // Varahamihira - Ancient Indian mathematician who discovered trigonometric formulae during 505-587 CE - https://en.wikipedia.org/wiki/Var%C4%81hamihira#Contributions
        "varahamihira",
        // Dorothy Vaughan was a NASA mathematician and computer programmer on the SCOUT launch vehicle program that put America's first satellites into space - https://en.wikipedia.org/wiki/Dorothy_Vaughan
        "vaughan",
        // Sir Mokshagundam Visvesvaraya - is a notable Indian engineer.  He is a recipient of the Indian Republic's highest honour, the Bharat Ratna, in 1955. On his birthday, 15 September is celebrated as Engineer's Day in India in his memory - https://en.wikipedia.org/wiki/Visvesvaraya
        "visvesvaraya",
        // Christiane Nüsslein-Volhard - German biologist, won Nobel Prize in Physiology or Medicine in 1995 for research on the genetic control of embryonic development. https://en.wikipedia.org/wiki/Christiane_N%C3%BCsslein-Volhard
        "volhard",
        // Cédric Villani - French mathematician, won Fields Medal, Fermat Prize and Poincaré Price for his work in differential geometry and statistical mechanics. https://en.wikipedia.org/wiki/C%C3%A9dric_Villani
        "villani",
        // Marlyn Wescoff - one of the original programmers of the ENIAC. https://en.wikipedia.org/wiki/ENIAC - https://en.wikipedia.org/wiki/Marlyn_Meltzer
        "wescoff",
        // Sylvia B. Wilbur - British computer scientist who helped develop the ARPANET, was one of the first to exchange email in the UK and a leading researcher in computer-supported collaborative work. https://en.wikipedia.org/wiki/Sylvia_Wilbur
        "wilbur",
        // Andrew Wiles - Notable British mathematician who proved the enigmatic Fermat's Last Theorem - https://en.wikipedia.org/wiki/Andrew_Wiles
        "wiles",
        // Roberta Williams, did pioneering work in graphical adventure games for personal computers, particularly the King's Quest series. https://en.wikipedia.org/wiki/Roberta_Williams
        "williams",
        // Malcolm John Williamson - British mathematician and cryptographer employed by the GCHQ. Developed in 1974 what is now known as Diffie-Hellman key exchange (Diffie and Hellman first published the scheme in 1976). https://en.wikipedia.org/wiki/Malcolm_J._Williamson
        "williamson",
        // Sophie Wilson designed the first Acorn Micro-Computer and the instruction set for ARM processors. https://en.wikipedia.org/wiki/Sophie_Wilson
        "wilson",
        // Jeannette Wing - co-developed the Liskov substitution principle. - https://en.wikipedia.org/wiki/Jeannette_Wing
        "wing",
        // Steve Wozniak invented the Apple I and Apple II. https://en.wikipedia.org/wiki/Steve_Wozniak
        "wozniak",
        // The Wright brothers, Orville and Wilbur - credited with inventing and building the world's first successful airplane and making the first controlled, powered and sustained heavier-than-air human flight - https://en.wikipedia.org/wiki/Wright_brothers
        "wright",
        // Chien-Shiung Wu - Chinese-American experimental physicist who made significant contributions to nuclear physics. https://en.wikipedia.org/wiki/Chien-Shiung_Wu
        "wu",
        // Rosalyn Sussman Yalow - Rosalyn Sussman Yalow was an American medical physicist, and a co-winner of the 1977 Nobel Prize in Physiology or Medicine for development of the radioimmunoassay technique. https://en.wikipedia.org/wiki/Rosalyn_Sussman_Yalow
        "yalow",
        // Ada Yonath - an Israeli crystallographer, the first woman from the Middle East to win a Nobel prize in the sciences. https://en.wikipedia.org/wiki/Ada_Yonath
        "yonath",
        // Nikolay Yegorovich Zhukovsky (Russian: Никола́й Его́рович Жуко́вский, January 17 1847 – March 17, 1921) was a Russian scientist, mathematician and engineer, and a founding father of modern aero- and hydrodynamics. Whereas contemporary scientists scoffed at the idea of human flight, Zhukovsky was the first to undertake the study of airflow. He is often called the Father of Russian Aviation. https://en.wikipedia.org/wiki/Nikolay_Yegorovich_Zhukovsky
        "zhukovsky"
    ];
    this.adjectives = this.left;
    this.surnames = this.right;
}
/**
 * @summary Generates a random docker style name.
 *
 * @param {boolean|number} [appendNumber] - Adds a random number to the resulting docker name.
 * @returns {string}
 */ $66d1095aad178a22$var$DockerNames.prototype.getRandomName = function(appendNumber) {
    var rand = appendNumber === true || appendNumber > 0 ? String(Math.floor(Math.random() * 9 + 1)) : "";
    return $66d1095aad178a22$var$generateName(this.left, this.right) + rand;
};
module.exports = new $66d1095aad178a22$var$DockerNames();

});



parcelRegister("a2Lgd", function(module, exports) {

$parcel$export(module.exports, "AccountCreateForm", () => $65cfbca23ae69a6a$export$ec181475f08c7954);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $jyGS9 = parcelRequire("jyGS9");

var $bfLP6 = parcelRequire("bfLP6");
var $8ImVZ = parcelRequire("8ImVZ");
var $7VnTP = parcelRequire("7VnTP");
var $7Wk6y = parcelRequire("7Wk6y");
var $5q2UM = parcelRequire("5q2UM");
var $h0mm1 = parcelRequire("h0mm1");
var $3kLlW = parcelRequire("3kLlW");
var $hvbBd = parcelRequire("hvbBd");

var $eJ54v = parcelRequire("eJ54v");

var $7BxHq = parcelRequire("7BxHq");

var $d9FmX = parcelRequire("d9FmX");

var $kbGDn = parcelRequire("kbGDn");

var $2j3zZ = parcelRequire("2j3zZ");
function $65cfbca23ae69a6a$export$ec181475f08c7954({ sx: sx, onRefetchRegions: onRefetchRegions, plan: plan, formState: formState, dispatch: dispatch, isCreating: isCreating, onCreateAccount: onCreateAccount }) {
    const title = (0, $aOzEm.useMemo)(()=>/*#__PURE__*/ (0, $2T9xh.jsxs)((0, $2T9xh.Fragment), {
            children: [
                "Create your ",
                plan.name,
                " account"
            ]
        }), [
        plan
    ]);
    // We delay the loading message for regions for 1 second to avoid jank
    // in the case that they resolve quickly, but still provide feedback in
    // case the response is slow.
    const { delayPassed: loadingDelayPassed } = (0, (/*@__PURE__*/$parcel$interopDefault($d9FmX)))(1000);
    const regionSelectorIsReady = !formState.regionsAreLoading && !Boolean(formState.regionsError);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $h0mm1.default), {
        component: "form",
        autoComplete: "off",
        sx: {
            ...sx,
            display: "grid",
            "&>*": {
                padding: "2rem"
            }
        },
        elevation: 10,
        onSubmit: (e)=>{
            e.preventDefault();
            onCreateAccount();
        },
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                sx: {
                    fontWeight: "600",
                    fontSize: "2rem",
                    margin: 0,
                    borderBottom: "solid 1px rgb(90% 90% 90%)"
                },
                children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $2j3zZ.FadeTransition), {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
                sx: {
                    display: "grid",
                    gap: "2.5rem",
                    paddingBottom: "0.8rem"
                },
                children: [
                    /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $8ImVZ.default), {
                        row: true,
                        sx: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
                                sx: {
                                    display: "flex",
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $3kLlW.default), {
                                        inputProps: {
                                            "data-hj-allow": true
                                        },
                                        autoFocus: true,
                                        label: "Display Name",
                                        placeholder: "Account Name",
                                        value: formState.displayName,
                                        error: !!formState.displayNameErr,
                                        onChange: (e)=>dispatch({
                                                type: "updateForm",
                                                formData: {
                                                    displayName: e.target.value
                                                }
                                            }),
                                        required: true,
                                        sx: {
                                            flexGrow: 1,
                                            boxSizing: "border-box",
                                            "& .MuiInputBase-root *": {
                                                borderRadius: "4px 0 0 4px"
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $hvbBd.default), {
                                        title: "Generate a new name",
                                        children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $bfLP6.default), {
                                            variant: "contained",
                                            color: "secondary",
                                            sx: {
                                                boxSizing: "border-box",
                                                border: "solid 1px rgb(80% 80% 80%)",
                                                borderLeft: "none",
                                                borderRadius: "0 4px 4px 0"
                                            },
                                            onClick: ()=>dispatch({
                                                    type: "regenerateName"
                                                }),
                                            disableElevation: true,
                                            children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $7BxHq.default), {})
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $7VnTP.default), {
                                sx: {
                                    // magic number to match the margin that TextField uses. Not sure why this isn't the default
                                    marginLeft: "14px"
                                },
                                children: formState.displayNameErr ?? "We\u2019ll use this to refer to your account throughout this dashboard."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $3kLlW.default), {
                        inputProps: {
                            "data-hj-allow": true
                        },
                        label: "Account Name",
                        helperText: formState.nameErr ?? (formState.isNameConflict ? "Sorry, a Decodable Account already exists for this name." : "A unique name to identify your account when using the Decodable APIs or CLIs."),
                        placeholder: "account-name",
                        value: formState.name,
                        error: formState.isNameConflict || !!formState.nameErr,
                        onChange: (e)=>dispatch({
                                type: "updateForm",
                                formData: {
                                    name: e.target.value
                                }
                            }),
                        required: true
                    }),
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $3kLlW.default), {
                        label: "Region",
                        select: regionSelectorIsReady ? true : false,
                        value: formState.selectedRegion,
                        error: Boolean(formState.regionsError),
                        disabled: !regionSelectorIsReady,
                        placeholder: !loadingDelayPassed ? "" : formState.regionsAreLoading ? "Loading available regions..." : "No regions available",
                        helperText: formState.regionsError ? /*#__PURE__*/ (0, $2T9xh.jsxs)("span", {
                            children: [
                                "Error loading available regions.",
                                " ",
                                /*#__PURE__*/ (0, $2T9xh.jsx)((0, $bfLP6.default), {
                                    sx: {
                                        width: "min-content",
                                        minWidth: "min-content",
                                        margin: 0,
                                        padding: "2px",
                                        color: "inherit",
                                        fontSize: "inherit",
                                        textDecoration: "underline",
                                        "&:hover": {
                                            bgcolor: "inherit",
                                            textDecoration: "underline"
                                        }
                                    },
                                    onClick: onRefetchRegions,
                                    children: "Retry."
                                })
                            ]
                        }) : "Select a region that's as close to your data sources and destinations as possible to reduce network costs from other service providers.",
                        required: true,
                        onChange: (e)=>dispatch({
                                type: "updateForm",
                                formData: {
                                    selectedRegion: e.target.value
                                }
                            }),
                        children: (formState.regions ?? []).map((region)=>/*#__PURE__*/ (0, $2T9xh.jsx)((0, $5q2UM.default), {
                                value: region,
                                children: region
                            }, region))
                    }),
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $hvbBd.default), {
                        title: formState.submitDisabledReason ?? "",
                        children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                            children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $eJ54v.default), {
                                type: "submit",
                                loading: isCreating,
                                fullWidth: true,
                                color: "primary",
                                variant: "contained",
                                sx: {
                                    // todo: I really need to stop inlining this.
                                    bgcolor: "var(--de-color-blue)",
                                    "&:hover": {
                                        bgcolor: "var(--de-color-blue)"
                                    }
                                },
                                disabled: !!formState.submitDisabledReason,
                                children: "Create Account"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
                sx: {
                    padding: "0 2rem 2rem 2rem",
                    fontSize: "0.8rem",
                    margin: 0,
                    color: "text.secondary",
                    textAlign: "center"
                },
                children: [
                    "By creating an account, you agree to Decodable's",
                    " ",
                    /*#__PURE__*/ (0, $2T9xh.jsx)((0, $7Wk6y.default), {
                        href: (0, $kbGDn.termsOfServiceHref),
                        children: "Terms of Service"
                    }),
                    "."
                ]
            })
        ]
    });
}

});
parcelRegister("8ImVZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6584390d71066af5$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $kY5NG = parcelRequire("kY5NG");

var $bNyOK = parcelRequire("bNyOK");

var $g3m9r = parcelRequire("g3m9r");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $6584390d71066af5$var$_excluded = [
    "className",
    "row"
];
const $6584390d71066af5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $b2r0b.default)(slots, (0, $kY5NG.getFormGroupUtilityClass), classes);
};
const $6584390d71066af5$var$FormGroupRoot = (0, $25zst.default)("div", {
    name: "MuiFormGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $g6Hsb.default)({
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    }, ownerState.row && {
        flexDirection: "row"
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $6584390d71066af5$var$FormGroup = /*#__PURE__*/ $aOzEm.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiFormGroup"
    });
    const { className: className, row: row = false } = props, other = (0, $cAqXo.default)(props, $6584390d71066af5$var$_excluded);
    const muiFormControl = (0, $bNyOK.default)();
    const fcs = (0, $g3m9r.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $g6Hsb.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $6584390d71066af5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2T9xh.jsx)($6584390d71066af5$var$FormGroupRoot, (0, $g6Hsb.default)({
        className: (0, $g45Wv.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $6584390d71066af5$export$2e2bcd8739ae039 = $6584390d71066af5$var$FormGroup;

});
parcelRegister("kY5NG", function(module, exports) {

$parcel$export(module.exports, "getFormGroupUtilityClass", () => $f43de90c9ce74923$export$d72d4cbdc30b331f);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $f43de90c9ce74923$export$d72d4cbdc30b331f(slot) {
    return (0, $6vnyE.default)("MuiFormGroup", slot);
}
const $f43de90c9ce74923$var$formGroupClasses = (0, $cyhE3.default)("MuiFormGroup", [
    "root",
    "row",
    "error"
]);
var $f43de90c9ce74923$export$2e2bcd8739ae039 = $f43de90c9ce74923$var$formGroupClasses;

});


parcelRegister("5q2UM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0104abf08886160c$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");


var $g45Wv = parcelRequire("g45Wv");

var $b2r0b = parcelRequire("b2r0b");

var $fOENh = parcelRequire("fOENh");

var $25zst = parcelRequire("25zst");

var $gEb5G = parcelRequire("gEb5G");

var $1ZWU3 = parcelRequire("1ZWU3");

var $cdbdN = parcelRequire("cdbdN");

var $ajCuK = parcelRequire("ajCuK");

var $eedeo = parcelRequire("eedeo");

var $fBz0E = parcelRequire("fBz0E");

var $9PibM = parcelRequire("9PibM");

var $5aT9v = parcelRequire("5aT9v");

var $3JvRr = parcelRequire("3JvRr");

var $2T9xh = parcelRequire("2T9xh");
"use client";
const $0104abf08886160c$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $0104abf08886160c$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $0104abf08886160c$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $b2r0b.default)(slots, (0, $3JvRr.getMenuItemUtilityClass), classes);
    return (0, $g6Hsb.default)({}, classes, composedClasses);
};
const $0104abf08886160c$var$MenuItemRoot = (0, $25zst.default)((0, $cdbdN.default), {
    shouldForwardProp: (prop)=>(0, $25zst.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $0104abf08886160c$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $3JvRr.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $fOENh.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $3JvRr.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $fOENh.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $3JvRr.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $fOENh.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $fOENh.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $3JvRr.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $3JvRr.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $fBz0E.default).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $fBz0E.default).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $5aT9v.default).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $5aT9v.default).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $9PibM.default).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $g6Hsb.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $9PibM.default).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $0104abf08886160c$var$MenuItem = /*#__PURE__*/ $aOzEm.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $cAqXo.default)(props, $0104abf08886160c$var$_excluded);
    const context = $aOzEm.useContext((0, $1ZWU3.default));
    const childContext = $aOzEm.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $aOzEm.useRef(null);
    (0, $ajCuK.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $g6Hsb.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $0104abf08886160c$var$useUtilityClasses(props);
    const handleRef = (0, $eedeo.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $1ZWU3.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)($0104abf08886160c$var$MenuItemRoot, (0, $g6Hsb.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $g45Wv.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $g45Wv.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $0104abf08886160c$export$2e2bcd8739ae039 = $0104abf08886160c$var$MenuItem;

});
parcelRegister("9PibM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getListItemIconUtilityClass", () => $7276fc75941feff4$export$81478e24460c57f2);
$parcel$export(module.exports, "default", () => $7276fc75941feff4$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $7276fc75941feff4$export$81478e24460c57f2(slot) {
    return (0, $6vnyE.default)("MuiListItemIcon", slot);
}
const $7276fc75941feff4$var$listItemIconClasses = (0, $cyhE3.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $7276fc75941feff4$export$2e2bcd8739ae039 = $7276fc75941feff4$var$listItemIconClasses;

});

parcelRegister("5aT9v", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getListItemTextUtilityClass", () => $3c48ab0568a2890a$export$1061006a0db3aeb5);
$parcel$export(module.exports, "default", () => $3c48ab0568a2890a$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $3c48ab0568a2890a$export$1061006a0db3aeb5(slot) {
    return (0, $6vnyE.default)("MuiListItemText", slot);
}
const $3c48ab0568a2890a$var$listItemTextClasses = (0, $cyhE3.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $3c48ab0568a2890a$export$2e2bcd8739ae039 = $3c48ab0568a2890a$var$listItemTextClasses;

});

parcelRegister("3JvRr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getMenuItemUtilityClass", () => $2b7e4a018de64c90$export$515f8c67b5305377);
$parcel$export(module.exports, "default", () => $2b7e4a018de64c90$export$2e2bcd8739ae039);

var $cyhE3 = parcelRequire("cyhE3");

var $6vnyE = parcelRequire("6vnyE");
function $2b7e4a018de64c90$export$515f8c67b5305377(slot) {
    return (0, $6vnyE.default)("MuiMenuItem", slot);
}
const $2b7e4a018de64c90$var$menuItemClasses = (0, $cyhE3.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $2b7e4a018de64c90$export$2e2bcd8739ae039 = $2b7e4a018de64c90$var$menuItemClasses;

});


parcelRegister("eJ54v", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8933cb28fa1543$export$2e2bcd8739ae039);

var $cAqXo = parcelRequire("cAqXo");

var $g6Hsb = parcelRequire("g6Hsb");

var $aOzEm = parcelRequire("aOzEm");



var $63Oo6 = parcelRequire("63Oo6");
var $cqmYq = parcelRequire("cqmYq");

var $b2r0b = parcelRequire("b2r0b");

var $25zst = parcelRequire("25zst");
var $gEb5G = parcelRequire("gEb5G");

var $bfLP6 = parcelRequire("bfLP6");

var $3Mgo0 = parcelRequire("3Mgo0");

var $exQkc = parcelRequire("exQkc");

var $2T9xh = parcelRequire("2T9xh");
const $ab8933cb28fa1543$var$_excluded = [
    "children",
    "disabled",
    "id",
    "loading",
    "loadingIndicator",
    "loadingPosition",
    "variant"
];
const $ab8933cb28fa1543$var$useUtilityClasses = (ownerState)=>{
    const { loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            loading && "loading"
        ],
        startIcon: [
            loading && `startIconLoading${(0, $63Oo6.default)(loadingPosition)}`
        ],
        endIcon: [
            loading && `endIconLoading${(0, $63Oo6.default)(loadingPosition)}`
        ],
        loadingIndicator: [
            "loadingIndicator",
            loading && `loadingIndicator${(0, $63Oo6.default)(loadingPosition)}`
        ]
    };
    const composedClasses = (0, $b2r0b.default)(slots, (0, $exQkc.getLoadingButtonUtilityClass), classes);
    return (0, $g6Hsb.default)({}, classes, composedClasses);
};
// TODO use `import { rootShouldForwardProp } from '../styles/styled';` once move to core
const $ab8933cb28fa1543$var$rootShouldForwardProp = (prop)=>prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as" && prop !== "classes";
const $ab8933cb28fa1543$var$LoadingButtonRoot = (0, $25zst.default)((0, $bfLP6.default), {
    shouldForwardProp: (prop)=>$ab8933cb28fa1543$var$rootShouldForwardProp(prop) || prop === "classes",
    name: "MuiLoadingButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        return [
            styles.root,
            styles.startIconLoadingStart && {
                [`& .${(0, $exQkc.default).startIconLoadingStart}`]: styles.startIconLoadingStart
            },
            styles.endIconLoadingEnd && {
                [`& .${(0, $exQkc.default).endIconLoadingEnd}`]: styles.endIconLoadingEnd
            }
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $g6Hsb.default)({
        [`& .${(0, $exQkc.default).startIconLoadingStart}, & .${(0, $exQkc.default).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0
        }
    }, ownerState.loadingPosition === "center" && {
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        [`&.${(0, $exQkc.default).loading}`]: {
            color: "transparent"
        }
    }, ownerState.loadingPosition === "start" && ownerState.fullWidth && {
        [`& .${(0, $exQkc.default).startIconLoadingStart}, & .${(0, $exQkc.default).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            marginRight: -8
        }
    }, ownerState.loadingPosition === "end" && ownerState.fullWidth && {
        [`& .${(0, $exQkc.default).startIconLoadingStart}, & .${(0, $exQkc.default).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            marginLeft: -8
        }
    }));
const $ab8933cb28fa1543$var$LoadingButtonLoadingIndicator = (0, $25zst.default)("span", {
    name: "MuiLoadingButton",
    slot: "LoadingIndicator",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.loadingIndicator,
            styles[`loadingIndicator${(0, $63Oo6.default)(ownerState.loadingPosition)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $g6Hsb.default)({
        position: "absolute",
        visibility: "visible",
        display: "flex"
    }, ownerState.loadingPosition === "start" && (ownerState.variant === "outlined" || ownerState.variant === "contained") && {
        left: ownerState.size === "small" ? 10 : 14
    }, ownerState.loadingPosition === "start" && ownerState.variant === "text" && {
        left: 6
    }, ownerState.loadingPosition === "center" && {
        left: "50%",
        transform: "translate(-50%)",
        color: (theme.vars || theme).palette.action.disabled
    }, ownerState.loadingPosition === "end" && (ownerState.variant === "outlined" || ownerState.variant === "contained") && {
        right: ownerState.size === "small" ? 10 : 14
    }, ownerState.loadingPosition === "end" && ownerState.variant === "text" && {
        right: 6
    }, ownerState.loadingPosition === "start" && ownerState.fullWidth && {
        position: "relative",
        left: -10
    }, ownerState.loadingPosition === "end" && ownerState.fullWidth && {
        position: "relative",
        right: -10
    }));
const $ab8933cb28fa1543$var$LoadingButton = /*#__PURE__*/ $aOzEm.forwardRef(function LoadingButton(inProps, ref) {
    const props = (0, $gEb5G.default)({
        props: inProps,
        name: "MuiLoadingButton"
    });
    const { children: children, disabled: disabled = false, id: idProp, loading: loading = false, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = "center", variant: variant = "text" } = props, other = (0, $cAqXo.default)(props, $ab8933cb28fa1543$var$_excluded);
    const id = (0, $cqmYq.default)(idProp);
    const loadingIndicator = loadingIndicatorProp != null ? loadingIndicatorProp : /*#__PURE__*/ (0, $2T9xh.jsx)((0, $3Mgo0.default), {
        "aria-labelledby": id,
        color: "inherit",
        size: 16
    });
    const ownerState = (0, $g6Hsb.default)({}, props, {
        disabled: disabled,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        variant: variant
    });
    const classes = $ab8933cb28fa1543$var$useUtilityClasses(ownerState);
    const loadingButtonLoadingIndicator = loading ? /*#__PURE__*/ (0, $2T9xh.jsx)($ab8933cb28fa1543$var$LoadingButtonLoadingIndicator, {
        className: classes.loadingIndicator,
        ownerState: ownerState,
        children: loadingIndicator
    }) : null;
    return /*#__PURE__*/ (0, $2T9xh.jsxs)($ab8933cb28fa1543$var$LoadingButtonRoot, (0, $g6Hsb.default)({
        disabled: disabled || loading,
        id: id,
        ref: ref
    }, other, {
        variant: variant,
        classes: classes,
        ownerState: ownerState,
        children: [
            ownerState.loadingPosition === "end" ? children : loadingButtonLoadingIndicator,
            ownerState.loadingPosition === "end" ? loadingButtonLoadingIndicator : children
        ]
    }));
});
var $ab8933cb28fa1543$export$2e2bcd8739ae039 = $ab8933cb28fa1543$var$LoadingButton;

});
parcelRegister("exQkc", function(module, exports) {

$parcel$export(module.exports, "getLoadingButtonUtilityClass", () => $a96cbc58b917a1b0$export$24fdd7c0683a4fed);
$parcel$export(module.exports, "default", () => $a96cbc58b917a1b0$export$2e2bcd8739ae039);

var $6vnyE = parcelRequire("6vnyE");

var $cyhE3 = parcelRequire("cyhE3");
function $a96cbc58b917a1b0$export$24fdd7c0683a4fed(slot) {
    return (0, $6vnyE.default)("MuiLoadingButton", slot);
}
const $a96cbc58b917a1b0$var$loadingButtonClasses = (0, $cyhE3.default)("MuiLoadingButton", [
    "root",
    "loading",
    "loadingIndicator",
    "loadingIndicatorCenter",
    "loadingIndicatorStart",
    "loadingIndicatorEnd",
    "endIconLoadingEnd",
    "startIconLoadingStart"
]);
var $a96cbc58b917a1b0$export$2e2bcd8739ae039 = $a96cbc58b917a1b0$var$loadingButtonClasses;

});


parcelRegister("7BxHq", function(module, exports) {

$parcel$export(module.exports, "default", () => $589621208b66d20d$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $589621208b66d20d$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), "Loop");

});

parcelRegister("2j3zZ", function(module, exports) {

$parcel$export(module.exports, "FadeTransition", () => $97117f62442d32b1$export$b4cd2c531e831209);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $jyGS9 = parcelRequire("jyGS9");
function $97117f62442d32b1$export$b4cd2c531e831209({ children: children, duration: duration = 300 }) {
    const [childState, setChildState] = (0, $aOzEm.useState)(children);
    const ref = (0, $aOzEm.useRef)(null);
    (0, $aOzEm.useEffect)(()=>{
        if (ref.current && children && !Object.is(childState, children)) {
            const animation = ref.current.animate([
                {
                    opacity: "0",
                    visibility: "hidden"
                }
            ], {
                duration: duration / 2,
                iterations: 1,
                fill: "forwards"
            });
            animation.onfinish = ()=>{
                setChildState(children);
                ref.current.animate([
                    {
                        opacity: "100%",
                        visibility: "visible"
                    }
                ], {
                    duration: duration / 2,
                    iterations: 1,
                    fill: "forwards"
                });
            };
        }
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
        ref: ref,
        children: childState
    });
}

});


parcelRegister("bbs2R", function(module, exports) {

$parcel$export(module.exports, "AccountCreatePage", () => $99ef763cac02c6e1$export$1632352c0c1e9d9d);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $jyGS9 = parcelRequire("jyGS9");

var $ihgkR = parcelRequire("ihgkR");

var $ygnqW = parcelRequire("ygnqW");

var $2Wdb2 = parcelRequire("2Wdb2");

var $8pwQi = parcelRequire("8pwQi");

var $2j3zZ = parcelRequire("2j3zZ");

var $jalfE = parcelRequire("jalfE");

var $6VdRj = parcelRequire("6VdRj");

var $kbGDn = parcelRequire("kbGDn");

var $57CDS = parcelRequire("57CDS");
function $99ef763cac02c6e1$var$useLayout() {
    const isNarrowScreen = (0, $ygnqW.default)("(max-width:800px)");
    const isWideScreen = (0, $ygnqW.default)("(min-width:162ch)");
    return {
        grid: {
            sx: {
                minWidth: "60ch",
                maxWidth: "100vw",
                overflow: "hidden",
                display: "grid",
                // Left and right columns are just spacers. The inner 2 contain the description and form
                gridTemplateColumns: `1fr minmax(auto, 1200px) ${isWideScreen ? "auto" : ""} 1fr`,
                gridTemplateRows: "auto auto auto 1fr auto",
                minHeight: "100vh",
                gridTemplateAreas: isWideScreen ? `
        'lpad title title rpad'
        'lpad desc  form  rpad'
        'lpad deet  form  rpad'
        'lpad bpad  bpad  rpad'
        'foot foot  foot  foot'
      ` : `
        'lpad title rpad'
        'lpad desc  rpad'
        'lpad form  rpad'
        'lpad deet  rpad'
        'lpad bpad  rpad'
        'foot foot  foot'
      `,
                "& h1": isWideScreen ? {
                    fontSize: "4rem",
                    margin: 0
                } : {
                    fontSize: "2.5rem",
                    margin: 0
                },
                "& h2": isWideScreen ? {
                    fontSize: "2rem",
                    margin: 0,
                    marginBottom: "1rem"
                } : {
                    fontSize: "2rem",
                    margin: 0,
                    marginBottom: "1rem"
                },
                "& h3": {
                    fontSize: isNarrowScreen ? "1.2rem" : "1.4rem"
                }
            }
        },
        areas: {
            heroBackdrop: {
                sx: {
                    gridArea: "title-start / lpad-start / desc-end / rpad-end",
                    bgcolor: "var(--de-color-corp-dark-blue)",
                    backgroundImage: `
          radial-gradient(circle at top 20ch left 50ch, rgb(100%, 100%, 100%, 2%) 40%, transparent),
          radial-gradient(circle at top 0 right 0, transparent 298px, var(--de-color-plum) 300px, var(--de-color-plum) 310px, transparent 312px)
        `
                }
            },
            heroTitle: {
                sx: {
                    gridArea: "title",
                    color: "white"
                }
            },
            heroDescription: {
                sx: {
                    gridArea: "desc",
                    color: "white",
                    padding: isWideScreen ? "0 4rem 1rem" : "0 4rem 6rem",
                    "& p": {
                        fontSize: "1.25rem"
                    },
                    minHeight: "14em"
                }
            },
            form: {
                sx: {
                    width: isWideScreen ? "60ch" : "min(80ch, 80%)",
                    gridArea: "form",
                    placeSelf: "start center",
                    margin: `${isWideScreen ? "2rem" : "-4rem"} 6ch 2rem`
                }
            },
            details: {
                sx: {
                    gridArea: "deet",
                    placeSelf: "start stretch",
                    justifyContent: "center",
                    width: "100%",
                    maxWidth: "110ch",
                    marginTop: "1rem",
                    marginX: "auto",
                    "& h2": {
                        margin: 0,
                        textAlign: "center",
                        padding: "2ch 2ch 0"
                    }
                }
            },
            detailCards: {
                sx: {
                    display: "grid",
                    margin: "2rem",
                    gap: "2ch",
                    gridTemplateColumns: "repeat(auto-fill, 30ch)",
                    gridAutoFlow: "row",
                    justifyContent: "center",
                    placeItems: "stretch",
                    "& .detail-card": {},
                    "& .detail-card-title": {
                        fontSize: "1rem",
                        fontWeight: "600"
                    },
                    "& .detail-card-description": {
                        fontSize: "0.9rem",
                        color: "text.secondary"
                    }
                }
            },
            bottomSpacer: {
                sx: {
                    gridArea: "bpad"
                }
            },
            footer: {
                sx: {
                    gridArea: "foot"
                }
            }
        }
    };
}
function $99ef763cac02c6e1$export$1632352c0c1e9d9d({ plan: plan, onSelectPlan: onSelectPlan, form: form }) {
    const layout = $99ef763cac02c6e1$var$useLayout();
    // Memoized to ensure the transition effect only triggers when this actually changes.
    const description = (0, $aOzEm.useMemo)(()=>/*#__PURE__*/ (0, $2T9xh.jsxs)((0, $2T9xh.Fragment), {
            children: [
                " ",
                $99ef763cac02c6e1$var$planInfo[plan.id].description,
                $99ef763cac02c6e1$var$planInfo[plan.id].switchPlanCTA
            ]
        }), [
        plan
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
        sx: layout.grid.sx,
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                sx: layout.areas.heroBackdrop.sx
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)($99ef763cac02c6e1$var$HeroSection, {
                sx: layout.areas.heroTitle.sx,
                plan: plan
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                sx: {
                    ...layout.areas.heroDescription.sx
                },
                children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $2j3zZ.FadeTransition), {
                    children: description
                })
            }),
            /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
                sx: layout.areas.details.sx,
                children: [
                    /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
                        component: "h3",
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            gap: "2ch",
                            alignItems: "center",
                            margin: "1ch"
                        },
                        children: [
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                                children: "Pick the plan that's right for you"
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $6VdRj.PlanSelector), {
                                selectedPlan: plan,
                                onSelectPlan: onSelectPlan
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
                        sx: layout.areas.detailCards.sx,
                        children: [
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jalfE.DetailCard), {
                                isFree: true,
                                selectedPlan: plan,
                                title: "Pre-Built Connector Library",
                                description: "Use pre-built connectors to get data from databases and event streaming platforms in real-time. Send that data to the destination where it has the most value."
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jalfE.DetailCard), {
                                isFree: true,
                                selectedPlan: plan,
                                title: "Change Data Capture with Debezium",
                                description: "Replicate tables from OLTP database systems using connectors with Debezium-powered Change Data Capture (CDC) support."
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jalfE.DetailCard), {
                                isFree: true,
                                selectedPlan: plan,
                                title: "Custom role-based access control",
                                description: "Manage who has access to your Decodable resources and what they can do with them."
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jalfE.DetailCard), {
                                isFree: true,
                                selectedPlan: plan,
                                title: "Basic or intermediate transformations",
                                description: "Filter, route, extract, aggregate, and enrich data using the SQL that you already know."
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jalfE.DetailCard), {
                                isFree: false,
                                selectedPlan: plan,
                                title: "Advanced transformations",
                                description: "Perform stream-stream joins to combine two or more streams into one enriched stream. Or, write code in a JVM-based language to do even more advanced processing."
                            }),
                            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jalfE.DetailCard), {
                                isFree: false,
                                selectedPlan: plan,
                                title: "Enhanced support",
                                description: "Get direct help via Slack or Email with a Decodable professional."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                sx: {
                    ...layout.areas.bottomSpacer.sx,
                    bgcolor: "background.default"
                }
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                sx: layout.areas.form.sx,
                children: form
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $8pwQi.Footer), {
                sx: layout.areas.footer.sx
            })
        ]
    });
}
function $99ef763cac02c6e1$var$PlanLink({ planId: planId, children: children }) {
    const [params, setParams] = (0, $57CDS.useSearchParams)();
    function handleClick(e) {
        e.preventDefault();
        params.set((0, $kbGDn.searchParamNames).selectedPlanId, planId);
        setParams(params, {
            replace: true
        });
    }
    return /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Wdb2))), {
        sx: {
            fontWeight: "700"
        },
        href: `?selected_plan_id=${planId}`,
        onClick: handleClick,
        children: children
    });
}
const $99ef763cac02c6e1$var$planInfo = {
    free: {
        h2: "No credit card required. Start free.",
        description: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $2T9xh.Fragment), {
            children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                component: "p",
                children: "Developer accounts can use 4 free tasks for running connections and pipelines."
            })
        }),
        switchPlanCTA: /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
            component: "p",
            children: [
                "Ready for more? Start with a",
                " ",
                /*#__PURE__*/ (0, $2T9xh.jsx)($99ef763cac02c6e1$var$PlanLink, {
                    planId: "on_demand",
                    children: "Team account"
                }),
                " instead, or upgrade any time."
            ]
        })
    },
    on_demand: {
        h2: "Use as much as you'd like. Pay only for what you use.",
        description: /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $2T9xh.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                    component: "p",
                    children: "Team accounts have unlimited tasks for running connections and pipelines."
                }),
                /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                    component: "p",
                    children: "Pay-as-you-go, so you can scale your data processing workloads while only paying for what you actually use."
                })
            ]
        }),
        switchPlanCTA: /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
            component: "p",
            children: [
                "Want to try it out first or process low amounts of data? Start with a free ",
                /*#__PURE__*/ (0, $2T9xh.jsx)($99ef763cac02c6e1$var$PlanLink, {
                    planId: "free",
                    children: "Developer account"
                }),
                ". You can upgrade any time."
            ]
        })
    }
};
function $99ef763cac02c6e1$var$HeroSection({ sx: sx, plan: plan }) {
    const cta = (0, $aOzEm.useMemo)(()=>/*#__PURE__*/ (0, $2T9xh.jsxs)((0, $2T9xh.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
                    component: "h1",
                    children: [
                        "Get started with the ",
                        /*#__PURE__*/ (0, $2T9xh.jsx)("u", {
                            children: plan.name
                        }),
                        " plan"
                    ]
                }),
                /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                    component: "h2",
                    children: $99ef763cac02c6e1$var$planInfo[plan.id].h2
                })
            ]
        }), [
        plan
    ]);
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
        className: "hero",
        sx: {
            ...sx,
            padding: "4rem 4rem 0"
        },
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($ihgkR))),
                width: "200",
                height: "30",
                style: {
                    marginBottom: "2ch"
                }
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $2j3zZ.FadeTransition), {
                children: cta
            })
        ]
    });
}

});
parcelRegister("ihgkR", function(module, exports) {
module.exports = new URL("decodable_logo_white.b6ed06d8.svg", import.meta.url).toString();

});

parcelRegister("ygnqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $066fe136a63ddef6$export$2e2bcd8739ae039);

var $aOzEm = parcelRequire("aOzEm");

var $l1T3r = parcelRequire("l1T3r");
var $8BSy0 = parcelRequire("8BSy0");

var $ajCuK = parcelRequire("ajCuK");
"use client";
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $066fe136a63ddef6$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $aOzEm.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $ajCuK.default)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $066fe136a63ddef6$var$maybeReactUseSyncExternalStore = $aOzEm.useSyncExternalStore;
function $066fe136a63ddef6$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $aOzEm.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $aOzEm.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $aOzEm.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $066fe136a63ddef6$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $066fe136a63ddef6$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $8BSy0.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $l1T3r.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $066fe136a63ddef6$var$maybeReactUseSyncExternalStore !== undefined ? $066fe136a63ddef6$var$useMediaQueryNew : $066fe136a63ddef6$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}

});

parcelRegister("8pwQi", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $b7b1f6fbeb960a74$export$a06f1c675e846f6f);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $jyGS9 = parcelRequire("jyGS9");

var $7Wk6y = parcelRequire("7Wk6y");

var $kbGDn = parcelRequire("kbGDn");
function $b7b1f6fbeb960a74$export$a06f1c675e846f6f({ sx: sx, target: // Avoids navigating away from account creation by default.
// Another default may be more suited to other pages.
target = "_blank" }) {
    return (0, $aOzEm.useMemo)(()=>/*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
            sx: {
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, clamp(20ch, 0.20 * 100vw, min(40ch, 0.5*100vw)))",
                justifyContent: "center",
                placeItems: "start center",
                gap: "4ch",
                bgcolor: "var(--de-color-corp-dark-blue)",
                color: "white",
                padding: "4ch",
                ...sx
            },
            children: $b7b1f6fbeb960a74$var$footerData.map((section)=>/*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
                    sx: {
                        display: "grid",
                        gap: "1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                            sx: {
                                fontWeight: "600"
                            },
                            children: section.name
                        }),
                        section.links.map((link)=>/*#__PURE__*/ (0, $2T9xh.jsx)((0, $7Wk6y.default), {
                                href: link.href,
                                target: target,
                                children: link.label
                            }, link.href))
                    ]
                }, section.name))
        }), [
        sx,
        target
    ]);
}
const $b7b1f6fbeb960a74$var$footerData = [
    {
        name: "Resources",
        links: [
            {
                label: "Product Overview",
                href: "https://decodable.co/product"
            },
            {
                label: "Solutions",
                href: "https://www.decodable.co/solutions"
            },
            {
                label: "Documentation",
                href: "https://docs.decodable.co"
            },
            {
                label: "Pricing",
                href: "https://decodable.co/pricing"
            }
        ]
    },
    {
        name: "Policies",
        links: [
            {
                label: "Terms of Service",
                href: (0, $kbGDn.termsOfServiceHref)
            },
            {
                label: "Privacy Policy",
                href: "https://www.decodable.co/legal/privacy-policy"
            },
            {
                label: "Security",
                href: "https://www.decodable.co/security"
            }
        ]
    },
    {
        name: "Company",
        links: [
            {
                label: "About Decodable",
                href: "https://www.decodable.co/about"
            },
            {
                label: "Careers",
                href: "https://www.decodable.co/careers"
            }
        ]
    },
    {
        name: "Contact",
        links: [
            {
                label: "Email support",
                href: "https://www.decodable.co/contact"
            },
            {
                label: "Community Slack",
                href: "https://decodablecommunity.slack.com/join/shared_invite/zt-uvow71bk-Uf914umgpoyIbOQSxriJkA#/shared-invite/email"
            }
        ]
    }
];

});

parcelRegister("jalfE", function(module, exports) {

$parcel$export(module.exports, "DetailCard", () => $b7c4ef5126847a8b$export$63aaec23c0ca5ec3);

var $2T9xh = parcelRequire("2T9xh");
parcelRequire("aOzEm");

var $jyGS9 = parcelRequire("jyGS9");

var $h0mm1 = parcelRequire("h0mm1");

var $iDocK = parcelRequire("iDocK");
function $b7c4ef5126847a8b$export$63aaec23c0ca5ec3({ title: title, description: description, isFree: isFree, selectedPlan: selectedPlan }) {
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $h0mm1.default), {
        className: "detail-card",
        sx: {
            position: "relative",
            display: "grid",
            gridTemplateRows: "auto auto 1fr",
            textJustify: "inter-word",
            padding: "3ch 3ch 1ch",
            border: "1px solid rgb(90% 90% 90%)"
        },
        elevation: 0,
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                className: "detail-card-title",
                sx: {
                    marginBottom: "1ch"
                },
                children: title
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                className: "detail-card-description",
                sx: {
                    marginBottom: "1rem"
                },
                children: description
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                sx: {
                    placeSelf: "end stretch",
                    display: "grid",
                    fontSize: "0.8rem"
                },
                children: /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
                    sx: {
                        placeSelf: "end stretch",
                        gridRow: "1 / 1",
                        gridColumn: "1 / 1",
                        display: "flex",
                        justifyContent: "start",
                        color: "rgb(50% 50% 50%)",
                        fontSize: "0.8rem",
                        marginBottom: "0.5em"
                    },
                    children: [
                        isFree ? /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                paddingRight: "1ch",
                                marginRight: "1ch"
                            },
                            children: [
                                "Developer",
                                " ",
                                /*#__PURE__*/ (0, $2T9xh.jsx)((0, $iDocK.default), {
                                    sx: {
                                        color: selectedPlan.id == "free" ? "brand.green.main" : "text.secondary",
                                        fontSize: "1em"
                                    }
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
                            sx: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                "Team",
                                " ",
                                /*#__PURE__*/ (0, $2T9xh.jsx)((0, $iDocK.default), {
                                    sx: {
                                        color: selectedPlan.id == "on_demand" ? "brand.green.main" : "text.secondary",
                                        fontSize: "1em"
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

});
parcelRegister("iDocK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d90ea509f12702df$export$2e2bcd8739ae039);

var $9hLGI = parcelRequire("9hLGI");

var $2T9xh = parcelRequire("2T9xh");
"use client";
var $d90ea509f12702df$export$2e2bcd8739ae039 = (0, $9hLGI.default)(/*#__PURE__*/ (0, $2T9xh.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");

});


parcelRegister("6VdRj", function(module, exports) {

$parcel$export(module.exports, "PlanSelector", () => $717524fbb08a56ab$export$da87035e91ce94ac);

var $2T9xh = parcelRequire("2T9xh");
parcelRequire("aOzEm");

var $jyGS9 = parcelRequire("jyGS9");

var $bfLP6 = parcelRequire("bfLP6");
function $717524fbb08a56ab$export$da87035e91ce94ac({ selectedPlan: selectedPlan, onSelectPlan: onSelectPlan }) {
    return /*#__PURE__*/ (0, $2T9xh.jsxs)((0, $jyGS9.default), {
        sx: {
            position: "relative",
            display: "grid",
            gridTemplateColumns: "100px 100px",
            gridTemplateRows: "2.5rem",
            gridTemplateAreas: '"left right"',
            placeItems: "stretch",
            padding: "4px",
            border: "solid 1px rgb(90% 90% 90%)",
            bgcolor: "background.paper",
            borderRadius: "4px"
        },
        children: [
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $jyGS9.default), {
                sx: {
                    gridArea: "left",
                    bgcolor: "brand.blue.main",
                    borderRadius: "4px",
                    position: "relative",
                    transition: "left 0.2s ease-in-out",
                    left: selectedPlan.id == "free" ? "0%" : "100%"
                }
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $bfLP6.default), {
                sx: {
                    gridArea: "left",
                    fontWeight: "500",
                    textAlign: "center",
                    verticalAlign: "center",
                    "&:hover": {
                        bgcolor: "transparent"
                    },
                    transition: "color 0.2s linear",
                    color: selectedPlan.id == "free" ? "white" : "text.secondary"
                },
                onClick: ()=>onSelectPlan("free"),
                children: "Developer"
            }),
            /*#__PURE__*/ (0, $2T9xh.jsx)((0, $bfLP6.default), {
                sx: {
                    gridArea: "right",
                    transition: "color 0.2s linear",
                    color: selectedPlan.id == "on_demand" ? "white" : "text.secondary",
                    "&:hover": {
                        bgcolor: "transparent"
                    }
                },
                onClick: ()=>onSelectPlan("on_demand"),
                children: "Team"
            })
        ]
    });
}

});



parcelRegister("hJMLL", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("fDgWP"),
    $foscK("jCVeS"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("jV2L9")
]).then(()=>parcelRequire("dV3YL"));

});


parcelRegister("i4RsZ", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("6LPy3"),
    $foscK("jU2Od"),
    $foscK("ddopL"),
    $foscK("7V5iC"),
    $foscK("jmeps"),
    $foscK("dx9bh"),
    $foscK("fDgWP"),
    $foscK("jCVeS"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("kMfS5"),
    $foscK("amtFu")
]).then(()=>parcelRequire("gKnGS"));

});

parcelRegister("hDwdE", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = $foscK("9DcyL").then(()=>parcelRequire("dy9TF"));

});

parcelRegister("gBucm", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = $foscK("cGwgD").then(()=>parcelRequire("j2gjM"));

});

parcelRegister("8dshk", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("jVtCN"),
    $foscK("laLtR"),
    $foscK("cCFzf"),
    $foscK("fDgWP"),
    $foscK("gK9Ud"),
    $foscK("imqQA"),
    $foscK("ajNnj"),
    $foscK("hMoMy"),
    $foscK("1SCIX"),
    $foscK("kMfS5"),
    $foscK("1WB2L"),
    $foscK("enIgz")
]).then(()=>parcelRequire("e7eTZ"));

});

parcelRegister("43HUV", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("6LPy3"),
    $foscK("dAmWd")
]).then(()=>parcelRequire("fdDio"));

});



//# sourceMappingURL=App.bc97a473.js.map
